webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(327);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(496);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _routing3 = __webpack_require__(512);
	
	var _routing4 = _interopRequireDefault(_routing3);
	
	var _routing5 = __webpack_require__(520);
	
	var _routing6 = _interopRequireDefault(_routing5);
	
	var _routing7 = __webpack_require__(528);
	
	var _routing8 = _interopRequireDefault(_routing7);
	
	var _routing9 = __webpack_require__(643);
	
	var _routing10 = _interopRequireDefault(_routing9);
	
	var _routing11 = __webpack_require__(649);
	
	var _routing12 = _interopRequireDefault(_routing11);
	
	var _fakeScroll = __webpack_require__(691);
	
	var _fakeScroll2 = _interopRequireDefault(_fakeScroll);
	
	var _routing13 = __webpack_require__(692);
	
	var _routing14 = _interopRequireDefault(_routing13);
	
	var _routing15 = __webpack_require__(717);
	
	var _routing16 = _interopRequireDefault(_routing15);
	
	var _routing17 = __webpack_require__(721);
	
	var _routing18 = _interopRequireDefault(_routing17);
	
	var _breadcrumbs = __webpack_require__(725);
	
	var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);
	
	var _routing19 = __webpack_require__(726);
	
	var _routing20 = _interopRequireDefault(_routing19);
	
	var _init = __webpack_require__(825);
	
	var _init2 = _interopRequireDefault(_init);
	
	var _routing21 = __webpack_require__(826);
	
	var _routing22 = _interopRequireDefault(_routing21);
	
	__webpack_require__(827);
	
	__webpack_require__(839);
	
	__webpack_require__(849);
	
	__webpack_require__(861);
	
	__webpack_require__(863);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var App = (_dec = (0, _decorators.Boot)({ element: document, strictDi: true }), _dec2 = (0, _decorators.Module)({
	    name: 'app',
	    modules: [_routing2.default, _routing4.default, _routing6.default, _routing8.default, _routing10.default, _routing12.default, _routing14.default, _routing20.default, _fakeScroll2.default, _init2.default, _routing16.default, _routing18.default, _routing22.default, 'tc.chartjs']
	}), _dec3 = (0, _decorators.Config)(["$compileProvider", function ($compileProvider) {
	    "ngInject";
	
	    $compileProvider.debugInfoEnabled(false);
	}]), _dec4 = (0, _decorators.Config)(["uiGmapGoogleMapApiProvider", "growlProvider", "$urlRouterProvider", function (uiGmapGoogleMapApiProvider, growlProvider, $urlRouterProvider) {
	    "ngInject";
	
	    uiGmapGoogleMapApiProvider.configure({
	        key: 'AIzaSyA8bR5Wbf6Kvk0ZOWN5J_dVgdQiG_Ol-hY',
	        v: '3.23', //defaults to latest 3.X anyhow
	        libraries: 'weather,geometry,visualization'
	    });
	    growlProvider.globalTimeToLive(4 * 1000);
	    growlProvider.globalDisableCountDown(true);
	    growlProvider.globalDisableIcons(true);
	    growlProvider.globalPosition('bottom-right');
	    $urlRouterProvider.deferIntercept();
	}]), _dec5 = (0, _decorators.Config)(["$breadcrumbProvider", function ($breadcrumbProvider) {
	    "ngInject";
	
	    $breadcrumbProvider.setOptions({
	        template: _breadcrumbs2.default,
	        includeAbstract: true
	    });
	}]), _dec6 = (0, _decorators.Run)(["$q", "$rootScope", "$urlRouter", "InitService", function ($q, $rootScope, $urlRouter, InitService) {
	    "ngInject";
	
	    $rootScope.image = function (name) {
	        return '/images/' + name;
	    };
	    InitService().then(function () {
	        $urlRouter.sync();
	        $urlRouter.listen();
	    });
	}]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = function App() {
	    _classCallCheck(this, App);
	}) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = App;

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.Module = Module;
	exports.Inject = Inject;
	exports.State = State;
	exports.Component = Component;
	exports.Directive = Directive;
	exports.Directive2 = Directive2;
	exports.Service = Service;
	exports.Factory = Factory;
	exports.Config = Config;
	exports.Run = Run;
	exports.Boot = Boot;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(332);
	
	var _angularCookies = __webpack_require__(334);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	__webpack_require__(336);
	
	__webpack_require__(339);
	
	__webpack_require__(341);
	
	__webpack_require__(342);
	
	__webpack_require__(343);
	
	__webpack_require__(346);
	
	__webpack_require__(347);
	
	__webpack_require__(348);
	
	__webpack_require__(349);
	
	__webpack_require__(356);
	
	__webpack_require__(357);
	
	var _angularPermission = __webpack_require__(358);
	
	var _ngInfiniteScroll = __webpack_require__(362);
	
	var _ngInfiniteScroll2 = _interopRequireDefault(_ngInfiniteScroll);
	
	__webpack_require__(363);
	
	__webpack_require__(365);
	
	__webpack_require__(494);
	
	__webpack_require__(495);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function Module(_ref) {
	    var name = _ref.name,
	        inject = _ref.inject,
	        _ref$modules = _ref.modules,
	        modules = _ref$modules === undefined ? [] : _ref$modules,
	        _ref$setdefault = _ref.setdefault,
	        setdefault = _ref$setdefault === undefined ? false : _ref$setdefault;
	
	    return function (Target) {
	
	        if (_angular2.default.isDefined(name) && _angular2.default.isDefined(inject)) throw new TypeError("Name and Inject can't be define in the same @Module");
	
	        modules.push.apply(modules, [_angularCookies2.default, 'ui.router', 'ui.router.default', 'ui.bootstrap', 'ui.select', 'ngTable', 'ngStorage', 'angular-ladda', 'ncy-angular-breadcrumb', 'uiGmapgoogle-maps', 'restangular', 'ngAnimate', 'ngCookies', 'cfp.hotkeys', _angularPermission.permission, _angularPermission.uiPermission, _ngInfiniteScroll2.default, 'dndLists', 'app.growl', 'app.filters.datetime', 'app.filters.title', 'app.directives.autofocus', 'app.directives.loading', 'app.directives.nodata', 'app.directives.ncyBreadcrumbTitle', 'app.directives.appLoading', 'app.directives.check.browser', 'app.directives.selectOnClick', 'app.directives.uiSelectHelpers', 'app.directives.read_only_icon', 'app.helpers', 'app.services.models.registry']);
	        Target.$angularModule = _angular2.default.isUndefined(inject) ? _angular2.default.module(name, modules.map(extractAngularModuleName)) : extractAngularModule(inject);
	
	        if (Target.component) Target.$angularModule.component(Target.$componentName, Target.component);
	        if (Target.directive) Target.$angularModule.directive(Target.$directiveName, Target.directive);
	        if (Target.$serviceName) Target.$angularModule.service(Target.$serviceName, Target);
	
	        if (Target.$factories) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Target.$factories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _Target$$angularModul;
	
	                    var factory = _step.value;
	
	                    (_Target$$angularModul = Target.$angularModule).factory.apply(_Target$$angularModul, _toConsumableArray(factory));
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	
	        if (Target.$directives) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Target.$directives[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _Target$$angularModul2;
	
	                    var d = _step2.value;
	
	                    (_Target$$angularModul2 = Target.$angularModule).directive.apply(_Target$$angularModul2, _toConsumableArray(d));
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	
	        if (Target.stateConfigs) {
	            Target.$angularModule.config(["$stateProvider", function ($stateProvider) {
	                "ngInject";
	
	                var _iteratorNormalCompletion3 = true;
	                var _didIteratorError3 = false;
	                var _iteratorError3 = undefined;
	
	                try {
	                    for (var _iterator3 = Target.stateConfigs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                        var stateConfig = _step3.value;
	
	                        $stateProvider.state.apply($stateProvider, _toConsumableArray(stateConfig));
	                    }
	                } catch (err) {
	                    _didIteratorError3 = true;
	                    _iteratorError3 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                            _iterator3.return();
	                        }
	                    } finally {
	                        if (_didIteratorError3) {
	                            throw _iteratorError3;
	                        }
	                    }
	                }
	            }]);
	        }
	
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = (Target.$config || [])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var config = _step4.value;
	
	                Target.$angularModule.config(config);
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	            for (var _iterator5 = (Target.$run || [])[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                var run = _step5.value;
	
	                Target.$angularModule.run(run);
	            }
	        } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                    _iterator5.return();
	                }
	            } finally {
	                if (_didIteratorError5) {
	                    throw _iteratorError5;
	                }
	            }
	        }
	    };
	}
	
	function Inject() {
	    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
	        params[_key] = arguments[_key];
	    }
	
	    return function (Target) {
	        if (!Target.$inject) Target.$inject = [];
	        Target.$inject = [].concat(params, _toConsumableArray(Target.$inject));
	    };
	}
	
	function State(_ref2) {
	    var name = _ref2.name,
	        _ref2$as = _ref2.as,
	        as = _ref2$as === undefined ? 'vm' : _ref2$as,
	        _ref2$auth = _ref2.auth,
	        auth = _ref2$auth === undefined ? true : _ref2$auth,
	        params = _objectWithoutProperties(_ref2, ['name', 'as', 'auth']);
	
	    return function (Target) {
	        if (!Target.stateConfigs) Target.stateConfigs = [];
	        var defaults = {
	            auth: auth,
	            controllerAs: as
	        };
	
	        var state = _angular2.default.extend({}, params, defaults);
	
	        if (state.views) {
	            var _iteratorNormalCompletion6 = true;
	            var _didIteratorError6 = false;
	            var _iteratorError6 = undefined;
	
	            try {
	                for (var _iterator6 = Object.keys(state.views)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                    var key = _step6.value;
	
	                    var value = state.views[key];
	                    value.controllerAs = value.as || 'vm';
	                }
	            } catch (err) {
	                _didIteratorError6 = true;
	                _iteratorError6 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                        _iterator6.return();
	                    }
	                } finally {
	                    if (_didIteratorError6) {
	                        throw _iteratorError6;
	                    }
	                }
	            }
	        }
	        Target.stateConfigs.push([name, state]);
	    };
	}
	
	function Component(_ref3) {
	    var _ref3$as = _ref3.as,
	        as = _ref3$as === undefined ? '$ctrl' : _ref3$as,
	        _ref3$bindings = _ref3.bindings,
	        bindings = _ref3$bindings === undefined ? {} : _ref3$bindings,
	        selector = _ref3.selector,
	        _ref3$template = _ref3.template,
	        template = _ref3$template === undefined ? '' : _ref3$template,
	        params = _objectWithoutProperties(_ref3, ['as', 'bindings', 'selector', 'template']);
	
	    return function (Target) {
	        if (!selector) throw new TypeError("A selector should be defined in the current annotation @Component");
	
	        Target.$componentName = snakeCaseToCamelCase(selector);
	        Target.component = _extends({
	            template: template,
	            controller: Target,
	            controllerAs: as,
	            bindings: bindings
	        }, params);
	    };
	}
	
	function Directive(name, method) {
	    return function (Target) {
	        if (!Target.$directives) Target.$directives = [];
	        Target.$directives.push([snakeCaseToCamelCase(name), method]);
	    };
	}
	function Directive2(_ref4) {
	    var _ref4$scope = _ref4.scope,
	        scope = _ref4$scope === undefined ? true : _ref4$scope,
	        _ref4$as = _ref4.as,
	        as = _ref4$as === undefined ? 'vm' : _ref4$as,
	        _ref4$bindToControlle = _ref4.bindToController,
	        bindToController = _ref4$bindToControlle === undefined ? true : _ref4$bindToControlle,
	        selector = _ref4.selector,
	        _ref4$require = _ref4.require,
	        require = _ref4$require === undefined ? '' : _ref4$require,
	        params = _objectWithoutProperties(_ref4, ['scope', 'as', 'bindToController', 'selector', 'require']);
	
	    return function (Target) {
	        if (!selector) throw new TypeError("A selector should be defined in the current annotation @Component");
	
	        Target.$directiveName = snakeCaseToCamelCase(selector);
	        Target.directive = function () {
	            var ddo = {
	                restrict: 'A',
	                require: require,
	                scope: scope,
	                controller: Target,
	                controllerAs: as,
	                bindToController: bindToController
	            };
	            _angular2.default.extend(ddo, params);
	
	            Target.link && (ddo.link = Target.link);
	            return ddo;
	        };
	    };
	}
	
	function Service(name) {
	    return function (Target) {
	        Target.$serviceName = name;
	    };
	}
	
	function Factory(name, method) {
	    return function (Target) {
	        if (!Target.$factories) Target.$factories = [];
	        Target.$factories.push([name, method]);
	    };
	}
	
	function Config(configFunction) {
	    return function (Target) {
	        if (!Target.$config) Target.$config = [];
	        Target.$config.push(configFunction);
	    };
	}
	
	function Run(runFunction) {
	    return function (Target, name, descriptor) {
	        if (!Target.$run) Target.$run = [];
	        Target.$run.push(runFunction || descriptor.value);
	    };
	}
	
	function Boot(_ref5) {
	    var _ref5$element = _ref5.element,
	        element = _ref5$element === undefined ? document : _ref5$element,
	        _ref5$strictDi = _ref5.strictDi,
	        strictDi = _ref5$strictDi === undefined ? false : _ref5$strictDi;
	
	    return function (Target) {
	        if (!_angular2.default.isDefined(Target.$angularModule)) throw new TypeError("@Boot should be used only on a @Module Class");
	
	        _angular2.default.element(document).ready(function () {
	            return _angular2.default.bootstrap(element, [Target.$angularModule.name], { strictDi: strictDi });
	        });
	    };
	}
	
	function snakeCaseToCamelCase(string) {
	    return string.replace(/-([a-z])/ig, function (_, letter) {
	        return letter.toUpperCase();
	    });
	}
	
	function extractAngularModuleName(clazz) {
	    if (clazz.default) clazz = clazz.default;
	
	    if (clazz.$angularModule) return clazz.$angularModule.name;
	
	    return clazz.name ? clazz.name : clazz;
	}
	
	function extractAngularModule(clazz) {
	    return clazz.$angularModule ? clazz.$angularModule : clazz;
	}

/***/ }),
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(364);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Growl = function () {
	    Growl.$inject = ["growl"];
	    function Growl(growl) {
	        "ngInject";
	
	        _classCallCheck(this, Growl);
	
	        this.growl = growl;
	    }
	
	    _createClass(Growl, [{
	        key: 'deleted',
	        value: function deleted() {
	            this.growl.success('Deleted sucessfuly !');
	        }
	    }, {
	        key: 'updated',
	        value: function updated() {
	            this.growl.success('Updated sucessfuly !');
	        }
	    }, {
	        key: 'added',
	        value: function added() {
	            this.growl.success('Added sucessfuly !');
	        }
	    }, {
	        key: 'copied',
	        value: function copied() {
	            this.growl.success('Copied successfully !');
	        }
	    }, {
	        key: 'success',
	        value: function success(message) {
	            this.growl.success(message);
	        }
	    }, {
	        key: 'error',
	        value: function error(message) {
	            this.growl.error(message);
	        }
	    }]);
	
	    return Growl;
	}();
	
	exports.default = Growl;
	
	
	_angular2.default.module('app.growl', ['angular-growl']).service('$growl', Growl);

/***/ }),
/* 364 */,
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(366);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app.filters.datetime', []).filter('blndDt', function () {
	    return function (item) {
	        if (!item) {
	            return 'N/A';
	        }
	        var parsedDt = _moment2.default.utc(item, "YYYY-MM-DDTHH:mm:ss.SSSSZ", true);
	        return parsedDt.isValid() ? parsedDt.tz('US/Eastern').format('L LT') : item;
	    };
	}).filter('blndTimeAgo', function () {
	    return function (item) {
	        if (!item) {
	            return 'N/A';
	        }
	        return _moment2.default.utc(item).tz('US/Eastern').fromNow();
	    };
	}).filter('blndDate', function () {
	    return function (item) {
	        if (!item) {
	            return 'N/A';
	        }
	        return _moment2.default.utc(item).tz('US/Eastern').format('L');
	    };
	});

/***/ }),
/* 366 */,
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 368,
		"./af.js": 368,
		"./ar": 369,
		"./ar-dz": 370,
		"./ar-dz.js": 370,
		"./ar-kw": 371,
		"./ar-kw.js": 371,
		"./ar-ly": 372,
		"./ar-ly.js": 372,
		"./ar-ma": 373,
		"./ar-ma.js": 373,
		"./ar-sa": 374,
		"./ar-sa.js": 374,
		"./ar-tn": 375,
		"./ar-tn.js": 375,
		"./ar.js": 369,
		"./az": 376,
		"./az.js": 376,
		"./be": 377,
		"./be.js": 377,
		"./bg": 378,
		"./bg.js": 378,
		"./bm": 379,
		"./bm.js": 379,
		"./bn": 380,
		"./bn.js": 380,
		"./bo": 381,
		"./bo.js": 381,
		"./br": 382,
		"./br.js": 382,
		"./bs": 383,
		"./bs.js": 383,
		"./ca": 384,
		"./ca.js": 384,
		"./cs": 385,
		"./cs.js": 385,
		"./cv": 386,
		"./cv.js": 386,
		"./cy": 387,
		"./cy.js": 387,
		"./da": 388,
		"./da.js": 388,
		"./de": 389,
		"./de-at": 390,
		"./de-at.js": 390,
		"./de-ch": 391,
		"./de-ch.js": 391,
		"./de.js": 389,
		"./dv": 392,
		"./dv.js": 392,
		"./el": 393,
		"./el.js": 393,
		"./en-au": 394,
		"./en-au.js": 394,
		"./en-ca": 395,
		"./en-ca.js": 395,
		"./en-gb": 396,
		"./en-gb.js": 396,
		"./en-ie": 397,
		"./en-ie.js": 397,
		"./en-il": 398,
		"./en-il.js": 398,
		"./en-nz": 399,
		"./en-nz.js": 399,
		"./eo": 400,
		"./eo.js": 400,
		"./es": 401,
		"./es-do": 402,
		"./es-do.js": 402,
		"./es-us": 403,
		"./es-us.js": 403,
		"./es.js": 401,
		"./et": 404,
		"./et.js": 404,
		"./eu": 405,
		"./eu.js": 405,
		"./fa": 406,
		"./fa.js": 406,
		"./fi": 407,
		"./fi.js": 407,
		"./fo": 408,
		"./fo.js": 408,
		"./fr": 409,
		"./fr-ca": 410,
		"./fr-ca.js": 410,
		"./fr-ch": 411,
		"./fr-ch.js": 411,
		"./fr.js": 409,
		"./fy": 412,
		"./fy.js": 412,
		"./gd": 413,
		"./gd.js": 413,
		"./gl": 414,
		"./gl.js": 414,
		"./gom-latn": 415,
		"./gom-latn.js": 415,
		"./gu": 416,
		"./gu.js": 416,
		"./he": 417,
		"./he.js": 417,
		"./hi": 418,
		"./hi.js": 418,
		"./hr": 419,
		"./hr.js": 419,
		"./hu": 420,
		"./hu.js": 420,
		"./hy-am": 421,
		"./hy-am.js": 421,
		"./id": 422,
		"./id.js": 422,
		"./is": 423,
		"./is.js": 423,
		"./it": 424,
		"./it.js": 424,
		"./ja": 425,
		"./ja.js": 425,
		"./jv": 426,
		"./jv.js": 426,
		"./ka": 427,
		"./ka.js": 427,
		"./kk": 428,
		"./kk.js": 428,
		"./km": 429,
		"./km.js": 429,
		"./kn": 430,
		"./kn.js": 430,
		"./ko": 431,
		"./ko.js": 431,
		"./ky": 432,
		"./ky.js": 432,
		"./lb": 433,
		"./lb.js": 433,
		"./lo": 434,
		"./lo.js": 434,
		"./lt": 435,
		"./lt.js": 435,
		"./lv": 436,
		"./lv.js": 436,
		"./me": 437,
		"./me.js": 437,
		"./mi": 438,
		"./mi.js": 438,
		"./mk": 439,
		"./mk.js": 439,
		"./ml": 440,
		"./ml.js": 440,
		"./mn": 441,
		"./mn.js": 441,
		"./mr": 442,
		"./mr.js": 442,
		"./ms": 443,
		"./ms-my": 444,
		"./ms-my.js": 444,
		"./ms.js": 443,
		"./mt": 445,
		"./mt.js": 445,
		"./my": 446,
		"./my.js": 446,
		"./nb": 447,
		"./nb.js": 447,
		"./ne": 448,
		"./ne.js": 448,
		"./nl": 449,
		"./nl-be": 450,
		"./nl-be.js": 450,
		"./nl.js": 449,
		"./nn": 451,
		"./nn.js": 451,
		"./pa-in": 452,
		"./pa-in.js": 452,
		"./pl": 453,
		"./pl.js": 453,
		"./pt": 454,
		"./pt-br": 455,
		"./pt-br.js": 455,
		"./pt.js": 454,
		"./ro": 456,
		"./ro.js": 456,
		"./ru": 457,
		"./ru.js": 457,
		"./sd": 458,
		"./sd.js": 458,
		"./se": 459,
		"./se.js": 459,
		"./si": 460,
		"./si.js": 460,
		"./sk": 461,
		"./sk.js": 461,
		"./sl": 462,
		"./sl.js": 462,
		"./sq": 463,
		"./sq.js": 463,
		"./sr": 464,
		"./sr-cyrl": 465,
		"./sr-cyrl.js": 465,
		"./sr.js": 464,
		"./ss": 466,
		"./ss.js": 466,
		"./sv": 467,
		"./sv.js": 467,
		"./sw": 468,
		"./sw.js": 468,
		"./ta": 469,
		"./ta.js": 469,
		"./te": 470,
		"./te.js": 470,
		"./tet": 471,
		"./tet.js": 471,
		"./tg": 472,
		"./tg.js": 472,
		"./th": 473,
		"./th.js": 473,
		"./tl-ph": 474,
		"./tl-ph.js": 474,
		"./tlh": 475,
		"./tlh.js": 475,
		"./tr": 476,
		"./tr.js": 476,
		"./tzl": 477,
		"./tzl.js": 477,
		"./tzm": 478,
		"./tzm-latn": 479,
		"./tzm-latn.js": 479,
		"./tzm.js": 478,
		"./ug-cn": 480,
		"./ug-cn.js": 480,
		"./uk": 481,
		"./uk.js": 481,
		"./ur": 482,
		"./ur.js": 482,
		"./uz": 483,
		"./uz-latn": 484,
		"./uz-latn.js": 484,
		"./uz.js": 483,
		"./vi": 485,
		"./vi.js": 485,
		"./x-pseudo": 486,
		"./x-pseudo.js": 486,
		"./yo": 487,
		"./yo.js": 487,
		"./zh-cn": 488,
		"./zh-cn.js": 488,
		"./zh-hk": 489,
		"./zh-hk.js": 489,
		"./zh-tw": 490,
		"./zh-tw.js": 490
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 367;


/***/ }),
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app.filters.title', []).filter('titlecase', function () {
	    return function (input) {
	        var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	        input = input.toLowerCase();
	        return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	            if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	                return match.toLowerCase();
	            }
	
	            if (match.substr(1).search(/[A-Z]|\../) > -1) {
	                return match;
	            }
	
	            return match.charAt(0).toUpperCase() + match.substr(1);
	        });
	    };
	});

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.ncyBreadcrumbTitle"
	}), _dec2 = (0, _decorators.Directive)('ncy-breadcrumb-title', ["$interpolate", "$breadcrumb", "$rootScope", function ($interpolate, $breadcrumb, $rootScope) {
	    "ngInject";
	
	    return {
	        restrict: 'A',
	        scope: {},
	        template: '{{ncyTitle}}',
	        compile: function compile() {
	            var separator = ' · ';
	            var siteTitle = 'Blend 2';
	
	            return {
	                post: function postLink(scope, element) {
	                    var labelWatchers = [];
	
	                    // ncyBreadcrumb core functions
	                    var getExpression = function getExpression(interpolationFunction) {
	                        if (interpolationFunction.expressions) {
	                            return interpolationFunction.expressions;
	                        } else {
	                            var expressions = [];
	                            _angular2.default.forEach(interpolationFunction.parts, function (part) {
	                                if (_angular2.default.isFunction(part)) {
	                                    expressions.push(part.exp);
	                                }
	                            });
	                            return expressions;
	                        }
	                    };
	                    var registerWatchersText = function registerWatchersText(labelWatcherArray, interpolationFunction, viewScope) {
	                        _angular2.default.forEach(getExpression(interpolationFunction), function (expression) {
	                            var watcher = viewScope.$watch(expression, function (newValue, oldValue) {
	                                if (newValue !== oldValue) {
	                                    renderLabel();
	                                }
	                            });
	                            labelWatcherArray.push(watcher);
	                        });
	                    };
	                    var deregisterWatchers = function deregisterWatchers(labelWatcherArray) {
	                        _angular2.default.forEach(labelWatcherArray, function (deregisterWatch) {
	                            deregisterWatch();
	                        });
	                        labelWatcherArray = [];
	                    };
	                    // -----------
	
	                    var renderLabel = function renderLabel() {
	                        deregisterWatchers(labelWatchers);
	                        var viewScope = $breadcrumb.$getLastViewScope();
	                        var steps = $breadcrumb.getStatesChain();
	                        var combinedLabels = [];
	                        var ncyTitle = siteTitle;
	                        _lodash2.default.each(steps, function (step) {
	                            if (step.ncyBreadcrumb && step.ncyBreadcrumb.skipStateForTitle) {
	                                return;
	                            }
	                            if (step.ncyBreadcrumb && step.ncyBreadcrumb.label) {
	                                var label = step.ncyBreadcrumb.label;
	                                if (step.ncyBreadcrumb && step.ncyBreadcrumb.siteTitle) {
	                                    label = step.ncyBreadcrumb.siteTitle;
	                                }
	
	                                var parseLabel = $interpolate(label);
	                                combinedLabels.push({
	                                    name: step.name,
	                                    label: parseLabel(viewScope)
	                                });
	                                // Watcher for further viewScope updates
	                                registerWatchersText(labelWatchers, parseLabel, viewScope);
	                            } else {
	                                combinedLabels.push({
	                                    name: step.name,
	                                    label: step.name
	                                });
	                            }
	                        });
	                        combinedLabels = _lodash2.default.reverse(combinedLabels);
	                        if (combinedLabels.length > 0) {
	                            var title = _lodash2.default.map(combinedLabels, function (obj) {
	                                return obj.label;
	                            }).join(separator);
	                            ncyTitle = title + ' - ' + ncyTitle;
	                        }
	
	                        scope.ncyTitle = ncyTitle;
	                    };
	
	                    $rootScope.$on('$viewContentLoaded', function () {
	                        renderLabel();
	                    });
	
	                    // View(s) may be already loaded while the directive's linking
	                    renderLabel();
	
	                    scope.$on('$onDestroy', function () {
	                        element.remove();
	                    });
	                }
	            };
	        }
	    };
	}]), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _homepage = __webpack_require__(497);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _main = __webpack_require__(511);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Ctrl = function Ctrl($stats) {
	    "ngInject";
	
	    _classCallCheck(this, Ctrl);
	
	    this.stats = $stats;
	};
	Ctrl.$inject = ["$stats"];
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.home',
	    modules: [_routing2.default, _homepage2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.home',
	    url: '/',
	    controller: Ctrl,
	    template: _main2.default,
	    ncyBreadcrumb: {
	        skip: true
	    },
	    resolve: {
	        $stats: function $stats(HomepageStore) {
	            return HomepageStore.get();
	        }
	    }
	}), _dec(_class = _dec2(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class);
	exports.default = States;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.homepage',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('HomepageStore'), _dec(_class = _dec2(_class = function () {
	    Store.$inject = ["R"];
	    function Store(R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        this.R = R;
	        this.endpoint = this.R.one('homepage');
	    }
	
	    _createClass(Store, [{
	        key: 'get',
	        value: function get() {
	            return this.endpoint.get();
	        }
	    }]);
	
	    return Store;
	}()) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _token = __webpack_require__(499);
	
	var _token2 = _interopRequireDefault(_token);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Resource = (_dec = (0, _decorators.Module)({
	    name: 'app.resource',
	    modules: [_token2.default]
	}), _dec2 = (0, _decorators.Factory)('R', ["$state", "Restangular", "TokenService", function ($state, Restangular, TokenService) {
	    "ngInject";
	
	    return Restangular.withConfig(function (RestangularConfigurer) {
	        RestangularConfigurer.setBaseUrl(baseConfig.backendUrl + '/api/v1');
	        RestangularConfigurer.addFullRequestInterceptor(function () {
	            var headers = arguments.length <= 4 ? undefined : arguments[4];
	            var token = TokenService.get();
	            if (token) {
	                headers['Authorization'] = 'Token ' + token;
	            }
	        });
	        RestangularConfigurer.addResponseInterceptor(function (data, operation, what, url, response) {
	            var extractedData;
	            if (operation === 'getList' && response.data.results) {
	                extractedData = response.data.results;
	                extractedData.count = response.data.count;
	                extractedData.next = response.data.next;
	                extractedData.previous = response.data.previous;
	            } else {
	                extractedData = response.data;
	            }
	            return extractedData;
	        });
	        RestangularConfigurer.setErrorInterceptor(function (response) {
	            if (response.status === 401) {
	                TokenService.clear();
	                $state.go('r.login', { force: true });
	            }
	            return true;
	        });
	    });
	}]), _dec(_class = _dec2(_class = function Resource() {
	    _classCallCheck(this, Resource);
	}) || _class) || _class);
	exports.default = Resource;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = (_dec = (0, _decorators.Module)({
	    name: 'app.services.token'
	}), _dec2 = (0, _decorators.Service)('TokenService'), _dec(_class = _dec2(_class = function () {
	    AuthService.$inject = ["$localStorage", "$cookies"];
	    function AuthService($localStorage, $cookies) {
	        "ngInject";
	
	        _classCallCheck(this, AuthService);
	
	        this.$cookies = $cookies;
	        this.$storage = $localStorage.$default({
	            tokens: {}
	        });
	        if (!$cookies.get('key')) {
	            $cookies.put('key', Math.random().toString(36).slice(2));
	        }
	    }
	
	    _createClass(AuthService, [{
	        key: 'set',
	        value: function set(token) {
	            if (this.get() && this.get() !== token) {
	                this.clearApiCaches();
	            }
	            this.$storage.tokens[this.$cookies.get('key')] = token;
	            this.$storage.$apply();
	        }
	    }, {
	        key: 'get',
	        value: function get() {
	            return this.$storage.tokens[this.$cookies.get('key')];
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            var self = this;
	            this.clearApiCaches();
	            _lodash2.default.each(self.$cookies.getAll(), function (v, k) {
	                self.$cookies.remove(k);
	            });
	            this.$storage.tokens = {};
	        }
	    }, {
	        key: 'clearApiCaches',
	        value: function clearApiCaches() {
	            if (window.ReactBridge && window.ReactBridge.clearOfflineData) {
	                window.ReactBridge.clearOfflineData();
	            }
	            if (!('serviceWorker' in navigator)) {
	                return;
	            }
	            navigator.serviceWorker.getRegistration().then(function (registration) {
	                var worker = registration && (registration.active || registration.waiting);
	                if (worker) {
	                    worker.postMessage({ type: 'CLEAR_API_CACHES' });
	                }
	            }).catch(_lodash2.default.noop);
	        }
	    }]);
	
	    return AuthService;
	}()) || _class) || _class);
	exports.default = AuthService;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseStore = function () {
	    BaseStore.$inject = ["$q", "R"];
	    function BaseStore($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, BaseStore);
	
	        this.$q = $q;
	        this.R = R;
	        this.loading = false;
	        this.list = [];
	        this.count = 0;
	        this.endpoint = R.all('dummy');
	        this.params = {};
	        this.isEmpty = false;
	        this.defer = $q.defer();
	        this.$promise = this.defer.promise;
	    }
	
	    _createClass(BaseStore, [{
	        key: 'resetParams',
	        value: function resetParams() {
	            this.params = {};
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            this.resetParams();
	            this.list = [];
	            this.isEmpty = false;
	        }
	    }, {
	        key: 'get',
	        value: function get(id, params) {
	            params = params || {};
	            id = _lodash2.default.toString(id);
	            return this.endpoint.get(id, params);
	        }
	    }, {
	        key: 'create',
	        value: function create(data) {
	            return this.endpoint.post(data);
	        }
	    }, {
	        key: 'remove',
	        value: function remove(id) {
	            var self = this;
	            var index = self.list.findIndex(function (field) {
	                return field.id === id;
	            });
	            if (index > -1) {
	                var field = self.list[index];
	                return field.remove(this.params, { 'Content-Type': 'application/json' }).then(function (resp) {
	                    self.list.splice(index, 1);
	                    return resp;
	                });
	            }
	            return self.$q.resolve();
	        }
	    }, {
	        key: 'restangularize',
	        value: function restangularize(obj) {
	            return this.R.restangularizeElement(null, obj, this.endpoint.route);
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            var self = this;
	            return self._refresh().then(function (data) {
	                self.list = data;
	                return self;
	            });
	        }
	    }, {
	        key: 'loadMore',
	        value: function loadMore() {
	            var self = this;
	            self.params.page = (self.params.page || 0) + 1;
	            return self._refresh().then(function (data) {
	                var _self$list;
	
	                (_self$list = self.list).push.apply(_self$list, _toConsumableArray(data));
	                return self;
	            });
	        }
	    }, {
	        key: '_refresh',
	        value: function _refresh() {
	            var self = this;
	            self.loading = true;
	            return self.endpoint.getList(self.params).then(function (data) {
	                self.count = data.count;
	                self.isEmpty = !data.next;
	                self.defer.resolve(data);
	                return data;
	            }, function (data) {
	                self.defer.reject(data);
	            }).finally(function () {
	                self.loading = false;
	            });
	        }
	    }]);
	
	    return BaseStore;
	}();
	
	exports.default = BaseStore;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _auth = __webpack_require__(502);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _user = __webpack_require__(503);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _config = __webpack_require__(504);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _bb = __webpack_require__(505);
	
	var _bb2 = _interopRequireDefault(_bb);
	
	var _ctrls = __webpack_require__(506);
	
	var _topbar = __webpack_require__(507);
	
	var _topbar2 = _interopRequireDefault(_topbar);
	
	var _page_header = __webpack_require__(508);
	
	var _page_header2 = _interopRequireDefault(_page_header);
	
	var _ = __webpack_require__(509);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(510);
	
	var _4 = _interopRequireDefault(_3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.routing',
	    modules: [_auth2.default, _user2.default, _config2.default, _bb2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r',
	    url: '',
	    template: '<div ui-view></div><div growl limit-messages="5"></div>',
	    resolve: {},
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in',
	    url: '',
	    template: '<div ui-view="topbar"></div><div ui-view></div>',
	    ncyBreadcrumb: {
	        skip: true
	    },
	    abstract: '.top'
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top',
	    url: '',
	    views: {
	        topbar: {
	            template: _topbar2.default,
	            controller: _ctrls.TopBarCtrl
	        },
	        '': {
	            template: _page_header2.default
	        }
	    },
	    ncyBreadcrumb: {
	        skipStateForTitle: true,
	        label: 'Home'
	    },
	    abstract: '.home'
	}), _dec5 = (0, _decorators.State)({
	    name: 'error',
	    template: '<div ui-view="topbar"></div><div ui-view></div>',
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec6 = (0, _decorators.State)({
	    name: 'error.404',
	    views: {
	        topbar: {
	            template: _topbar2.default,
	            controller: _ctrls.TopBarCtrl
	        },
	        '': {
	            template: _2.default
	        }
	    },
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec7 = (0, _decorators.State)({
	    name: '500',
	    template: _4.default
	}), _dec8 = (0, _decorators.State)({
	    name: '404',
	    abstract: 'error.404'
	}), _dec9 = (0, _decorators.Config)(["$locationProvider", "$urlRouterProvider", function ($locationProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $locationProvider.html5Mode(true);
	    $urlRouterProvider.otherwise(function ($injector) {
	        var $state = $injector.get('$state');
	        $state.go('404');
	    });
	}]), _dec10 = (0, _decorators.Run)(["$location", "$rootScope", "$state", "AuthService", function ($location, $rootScope, $state, AuthService) {
	    "ngInject";
	
	    $rootScope.$state = $state;
	    $rootScope.$on('$stateChangeStart', function (event, to, params, from, options) {
	        if (to.auth && !AuthService.isLoggedIn) {
	            $state.go('r.login', { next: $location.url() });
	            event.preventDefault();
	        }
	    });
	}]), _dec11 = (0, _decorators.Run)(["$templateCache", function ($templateCache) {
	    "ngInject";
	
	    $templateCache.put('headerCheckBox', '<input type="checkbox" />');
	}]), _dec12 = (0, _decorators.Run)(["$log", "$rootScope", function ($log, $rootScope) {
	    "ngInject";
	
	    $rootScope.$on('$stateChangeStart', function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        $log.log(['start'].concat(args));
	    });
	    $rootScope.$on('$stateChangeError', function () {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        $log.log(['error'].concat(args));
	    });
	    $rootScope.$on('$stateChangeSuccess', function () {
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	        }
	
	        $log.log(['success'].concat(args));
	    });
	}]), _dec13 = (0, _decorators.Run)(["$rootScope", "$state", "$uibModalStack", function ($rootScope, $state, $uibModalStack) {
	    "ngInject";
	    // Close all modals if user clicked back button
	
	    $rootScope.$state = $state;
	    $rootScope.$on('$stateChangeStart', function () {
	        $uibModalStack.dismissAll();
	    });
	}]), _dec14 = (0, _decorators.Run)(["$rootScope", "$state", function ($rootScope, $state) {
	    "ngInject";
	
	    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
	        event.preventDefault();
	
	        if (!error || !error.status) {
	            return;
	        }
	        if ([403, 404].indexOf(error.status) !== -1) {
	            $state.go('404');
	        } else if (error.status >= 500) {
	            $state.go('500');
	        }
	    });
	}]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = _dec8(_class = _dec9(_class = _dec10(_class = _dec11(_class = _dec12(_class = _dec13(_class = _dec14(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _token = __webpack_require__(499);
	
	var _token2 = _interopRequireDefault(_token);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = (_dec = (0, _decorators.Module)({
	    name: "app.services.auth",
	    modules: [_resource2.default, _token2.default]
	}), _dec2 = (0, _decorators.Service)("AuthService"), _dec(_class = _dec2(_class = function () {
	    AuthService.$inject = ["R", "TokenService"];
	    function AuthService(R, TokenService) {
	        "ngInject";
	
	        _classCallCheck(this, AuthService);
	
	        this.R = R;
	        this.TokenService = TokenService;
	    }
	
	    _createClass(AuthService, [{
	        key: 'login',
	        value: function login(email, password) {
	            var self = this;
	            var data = { username: email, password: password };
	            return this.R.all('token').customPOST(data).then(function (data) {
	                self.TokenService.set(data.token);
	                return true;
	            }, function () {
	                self.TokenService.clear();
	                return false;
	            });
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            var self = this;
	            self.TokenService.clear();
	        }
	    }, {
	        key: 'resetPassword',
	        value: function resetPassword(email) {
	            var self = this;
	            var $promise = this.R.one('users', 'password').post('reset', {
	                email: email
	            });
	
	            // In case if user somehow has token
	            $promise.then(function () {
	                self.TokenService.clear();
	            });
	
	            return $promise;
	        }
	    }, {
	        key: 'changePassword',
	        value: function changePassword(data) {
	            return this.R.one('users', 'me').one('password').post('change', data);
	        }
	    }, {
	        key: 'confirmReset',
	        value: function confirmReset(data) {
	            var $promise = this.R.one('users', 'password').one('reset').post('confirm', data);
	            return $promise;
	        }
	    }, {
	        key: 'isLoggedIn',
	        get: function get() {
	            var self = this;
	            return !!self.TokenService.get();
	        }
	    }]);
	
	    return AuthService;
	}()) || _class) || _class);
	exports.default = AuthService;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserService = (_dec = (0, _decorators.Module)({
	    name: 'app.services.user',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('UserService'), _dec(_class = _dec2(_class = function () {
	    UserService.$inject = ["$q", "R"];
	    function UserService($q, R) {
	        'ngInject';
	
	        _classCallCheck(this, UserService);
	
	        this.R = R;
	        this.endpoint = R.one('users', 'me');
	        this.deferred = $q.defer();
	        this.promise = this.deferred.promise;
	        this.reset();
	    }
	
	    _createClass(UserService, [{
	        key: 'reset',
	        value: function reset() {
	            this.$user = {};
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            var self = this;
	            var request = window.ReactBridge && window.ReactBridge.getCurrentUser ? window.ReactBridge.getCurrentUser().then(function (response) {
	                return self.R.restangularizeElement(null, response, 'users', true);
	            }) : self.endpoint.get();
	            request.then(function (response) {
	                _angular2.default.extend(self.$user, response);
	                self.deferred.resolve(self);
	            });
	            return self.promise;
	        }
	    }]);
	
	    return UserService;
	}()) || _class) || _class);
	exports.default = UserService;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Config = (_dec = (0, _decorators.Module)({
	    name: 'app.services.config',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('Config'), _dec(_class = _dec2(_class = function () {
	    Config.$inject = ["$q", "R"];
	    function Config($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Config);
	
	        this.endpoint = R.one('config');
	        this.deferred = $q.defer();
	        this.promise = this.deferred.promise;
	        this.reset();
	    }
	
	    _createClass(Config, [{
	        key: 'reset',
	        value: function reset() {
	            this.$config = {
	                dateFormat: 'YYYY-MM-DD'
	            };
	        }
	    }, {
	        key: 'isFeatureFlagActive',
	        value: function isFeatureFlagActive(name) {
	            var defaultActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            var featureFlags = this.$config.feature_flags || {};
	            var switches = featureFlags.switches || [];
	            var featureFlag = switches.find(function (item) {
	                return item.name === name;
	            });
	            return featureFlag ? featureFlag.active : defaultActive;
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            var self = this;
	            this.endpoint.get().then(function (response) {
	                _angular2.default.extend(self.$config, response.plain());
	                self.deferred.resolve(self);
	            });
	            return self.promise;
	        }
	    }]);
	
	    return Config;
	}()) || _class) || _class);
	exports.default = Config;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var STATUS = {
	    CONNECTING: 'connecting',
	    BUSY: 'controller_busy',
	    CONNECTED: 'connected',
	    NOT_CONNECTED_WITH_CTRL: 'no_connection_with_ctrl',
	    NOT_CONNECTED_WITH_BB: 'no_connection_with_bb'
	
	};
	
	var ACTIONS = {
	    RESET_REGISTERS: 'reset_registers'
	};
	
	var BB = (_dec = (0, _decorators.Module)({
	    name: 'app.services.bb'
	}), _dec2 = (0, _decorators.Service)('BB'), _dec(_class = _dec2(_class = function () {
	    BB.$inject = ["$http", "$q", "Config"];
	    function BB($http, $q, Config) {
	        "ngInject";
	
	        _classCallCheck(this, BB);
	
	        this.$q = $q;
	        this.$http = $http;
	        this.baseUrl = Config.$config.config_params.BB_URL;
	        this.ctrl = {
	            state: STATUS.CONNECTING,
	            action: ''
	        };
	    }
	
	    _createClass(BB, [{
	        key: 'dataEntry',
	        value: function dataEntry(tag, code, value) {
	            var entry = {
	                tag_type: tag.startsWith('D') ? 196 : 195, // 196 is DINT and 195 is REAL
	                elements: 1,
	                method: 'read',
	                path: [{
	                    symbolic: tag
	                }, {
	                    element: code
	                }]
	            };
	
	            if (value) {
	                entry.data = _lodash2.default.isArray(value) ? value : [value];
	                entry.elements = entry.data.length;
	                entry.method = 'write';
	            }
	            return entry;
	        }
	    }, {
	        key: 'sendPresets',
	        value: function sendPresets(tags, data) {
	            var self = this;
	            data = data.map(function (l) {
	                return self.dataEntry(l.write_tag, l.preset_code, l.preset);
	            });
	
	            _lodash2.default.each(tags, function (key) {
	                data.push(self.dataEntry(key, 0, 9999));
	            });
	
	            return self.status(tags).then(function () {
	                if (self.ctrl.state !== STATUS.CONNECTED) {
	                    return self.$q.reject();
	                }
	
	                return self.resetRegisters(tags).then(function () {
	                    return self.$http.post(self.baseUrl + '/api/controller/tags', data).then(function (resp) {
	                        return resp.data;
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'status',
	        value: function status(tags) {
	            var self = this;
	            var data = _lodash2.default.map(tags, function (tag) {
	                return self.dataEntry(tag, 0);
	            });
	
	            self.checking = true;
	            return this.$http.post(self.baseUrl + '/api/controller/tags', data).then(function (resp) {
	                self.ctrl.state = _lodash2.default.every(_lodash2.default.map(_lodash2.default.flatten(resp.data.result), function (o) {
	                    return o != 0;
	                })) ? STATUS.BUSY : STATUS.CONNECTED;
	                return resp;
	            }, function (resp) {
	                self.ctrl.state = resp.status === 503 ? STATUS.NOT_CONNECTED_WITH_CTRL : STATUS.NOT_CONNECTED_WITH_BB;
	                return resp;
	            }).finally(function () {
	                return self.checking = false;
	            });
	        }
	    }, {
	        key: 'resetRegisters',
	        value: function resetRegisters(tags) {
	            var self = this;
	            var zeroes = _lodash2.default.times(101, _lodash2.default.constant(0));
	            var data = _lodash2.default.map(tags, function (tag) {
	                return self.dataEntry(tag, 0, zeroes);
	            });
	
	            self.ctrl.action = ACTIONS.RESET_REGISTERS;
	            return this.$http.post(self.baseUrl + '/api/controller/tags', data).then(function (resp) {
	                return resp.data;
	            }).finally(function () {
	                return self.ctrl.action = '';
	            });
	        }
	    }]);
	
	    return BB;
	}()) || _class) || _class);
	exports.default = BB;

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainCtrl = exports.MainCtrl = function MainCtrl() {
	    _classCallCheck(this, MainCtrl);
	};
	
	var TopBarCtrl = exports.TopBarCtrl = function () {
	    TopBarCtrl.$inject = ["$state", "$window", "AuthService", "ReactBridge"];
	    function TopBarCtrl($state, $window, AuthService, ReactBridge) {
	        "ngInject";
	
	        _classCallCheck(this, TopBarCtrl);
	
	        this.AuthService = AuthService;
	        this.ReactBridge = ReactBridge;
	        this.$state = $state;
	        this.$window = $window;
	    }
	
	    _createClass(TopBarCtrl, [{
	        key: "logout",
	        value: function logout() {
	            this.AuthService.logout();
	            if (window.ReactBridge) {
	                window.ReactBridge.store.getState().setCurrentUser(null);
	            }
	            this.$window.location = '/';
	        }
	    }, {
	        key: "$user",
	        get: function get() {
	            return this.ReactBridge().store.getState().currentUser || {};
	        }
	    }]);
	
	    return TopBarCtrl;
	}();

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = "<nav fake-scroll class=\"navbar navbar-default navbar-fixed-top\">\n    <div ng-if=\"$state.test\" class=\"test-bar bg-danger\">\n        <p class=\"testenv\">Testing environment</p>\n    </div>\n    <div ng-if=\"$state.staging\" class=\"test-bar bg-danger\">\n        <p class=\"testenv\">Staging environment</p>\n    </div>\n    <div class=\"container\">\n        <div class=\"navbar-header\">\n            <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\">\n                <span class=\"sr-only\">Toggle navigation</span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n                <span class=\"icon-bar\"></span>\n            </button>\n            <a class=\"navbar-brand\" ui-sref=\"r.in.top.home\">Blend 2</a>\n        </div>\n        <div class=\"navbar-collapse collapse\">\n            <ul class=\"nav navbar-nav\">\n                <li ui-sref-active=\"active\"><a ui-sref=\"r.in.top.home\" ui-sref-opts=\"{reload:true}\">Home</a></li>\n                <li ui-sref-active=\"active\"><a ui-sref=\"r.in.top.orders\" ui-sref-opts=\"{reload:true}\">Orders</a></li>\n                <li ui-sref-active=\"active\" permission permission-sref=\"'r.in.top.dispatch'\"><a ui-sref=\"r.in.top.dispatch.applicator\" ui-sref-opts=\"{reload:true}\">Dispatch</a></li>\n                <li ui-sref-active=\"active\"><a ui-sref=\"r.in.top.tickets\" ui-sref-opts=\"{reload:true}\">Tickets</a></li>\n                <li ui-sref-active=\"active\" permission permission-sref=\"'r.in.top.customers'\" ><a ui-sref=\"r.in.top.customers\" ui-sref-opts=\"{reload:true}\">Customers</a></li>\n                <li ui-sref-active=\"active\"><a ui-sref=\"r.in.top.inventoryDashboard\" permission permission-sref=\"'r.in.top.inventoryDashboard'\" ui-sref-opts=\"{reload:true}\">Inventory</a></li>\n                <li ui-sref-active=\"active\"><a ui-sref=\"r.in.top.tonsDashboard\" ui-sref-opts=\"{reload:true}\">Tonnage</a></li>\n                <li ui-sref-active=\"active\" permission permission-sref=\"'r.in.top.admin'\"><a ui-sref=\"r.in.top.admin\" ui-sref-opts=\"{reload:true}\">Admin</a></li>\n            </ul>\n            <ul class=\"nav navbar-nav navbar-right\">\n                <li class=\"dropdown\" uib-dropdown>\n                    <a href=\"#\" class=\"dropdown-toggle\" uib-dropdown-toggle>\n                        {{vm.$user.username}} <span class=\"caret\"></span>\n                    </a>\n                    <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n                        <li role=\"menuitem\"><a ui-sref=\"r.in.top.account\">Account</a></li>\n                        <li class=\"divider\"></li>\n                        <li role=\"menuitem\"><a href=\"\" ng-click=\"vm.logout()\">Logout</a></li>\n                    </ul>\n                </li>\n            </ul>\n        </div>\n        <div class=\"blnd-page-header\">\n            <div class=\"pull-left\" ncy-breadcrumb></div>\n            <div class=\"pull-right actions\" ui-view=\"actions\"></div>\n        </div>\n    </div>\n</nav>\n"

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container container-fluid-blnd\">\n    <div ui-view></div>\n</div>\n"

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"content-error-page\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-lg-8 col-lg-offset-2\">\n                <div class=\"logo\"></div>\n                <h1>Page not found</h1>\n                <p>Apologies, but the page you requested could not be found.</p>\n                <a ui-sref=\"r.in.top.home\" class=\"btn btn-link\">Okay, take me Home</a>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"content-error-page\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-lg-8 col-lg-offset-2\">\n                <div class=\"logo\"></div>\n                <h1>Server Error</h1>\n                <p>There was a problem serving the requested page. We've been notified of the problem and will do our best to make sure it doesn't happen again.</p>\n                <a ui-sref=\"r.in.top.home\" class=\"btn btn-link\">Okay, take me Home</a>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"home-page landing-page\">\n    <div class=\"row\">\n        <div class=\"col-md-4\" permission permission-only=\"'main.view_customer'\">\n            <div class=\"card-box\">\n                <p class=\"box-num\" ng-bind=\"vm.stats.counters.customers\"></p>\n                <a ui-sref=\"r.in.top.customers\" class=\"box-title\">My Customers</a>\n            </div>\n\n        </div>\n        <div class=\"col-md-4\" permission permission-only=\"'main.view_order'\">\n            <div class=\"card-box\">\n                <p class=\"box-num\" ng-bind=\"vm.stats.counters.orders\"></p>\n                <a ui-sref=\"r.in.top.orders\" class=\"box-title\">My Orders</a>\n            </div>\n        </div>\n        <div class=\"col-md-4\" permission permission-only=\"'main.view_ticket'\">\n            <div class=\"card-box\">\n                <p class=\"box-num\" ng-bind=\"vm.stats.counters.tickets\"></p>\n                <a ui-sref=\"r.in.top.tickets\" class=\"box-title\">My Tickets</a>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _class;
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _decorators = __webpack_require__(331);
	
	var _error = __webpack_require__(513);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _auth = __webpack_require__(502);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _loginForm = __webpack_require__(516);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	var _resetPasswordForm = __webpack_require__(517);
	
	var _resetPasswordForm2 = _interopRequireDefault(_resetPasswordForm);
	
	var _resetPasswordConfirm = __webpack_require__(518);
	
	var _resetPasswordConfirm2 = _interopRequireDefault(_resetPasswordConfirm);
	
	var _ctrls = __webpack_require__(519);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.login',
	    modules: [_routing2.default, _auth2.default, _error2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.login',
	    url: '/login?next',
	    controller: _ctrls.LoginCtrl,
	    className: 'auth-page',
	    template: _loginForm2.default,
	    auth: false,
	    ncyBreadcrumb: {
	        label: 'Login'
	    },
	    resolve: {
	        isLogged: ["$q", "$state", "AuthService", function isLogged($q, $state, AuthService) {
	            "ngInject";
	
	            if (AuthService.isLoggedIn) {
	                $state.go('r.in', { force: true });
	                return $q.reject();
	            }
	        }]
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.password',
	    url: '/password',
	    template: '<div ui-view></div>',
	    auth: false,
	    resolve: {},
	    abstract: '.reset',
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.password.reset',
	    url: '/reset',
	    controller: _ctrls.PasswordResetCtrl,
	    template: _resetPasswordForm2.default,
	    className: 'auth-page',
	    auth: false,
	    ncyBreadcrumb: {
	        label: 'Reset Password'
	    },
	    resolve: {}
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.password.confirm',
	    url: '/confirm/:uid/:token',
	    controller: _ctrls.PasswordConfirmCtrl,
	    template: _resetPasswordConfirm2.default,
	    className: 'auth-page',
	    auth: false,
	    ncyBreadcrumb: {
	        label: 'Confirm'
	    },
	    resolve: {}
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _company = __webpack_require__(514);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _errorMessages = __webpack_require__(515);
	
	var _errorMessages2 = _interopRequireDefault(_errorMessages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.error.messages"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-errors',
	    bindings: {
	        ngModel: '='
	    },
	    template: _errorMessages2.default
	}), _dec(_class = _dec2(_class = function C() {
	    _classCallCheck(this, C);
	}) || _class) || _class);
	exports.default = C;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.company',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('CompanyStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('companies');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.ngModel.non_field_errors\" class=\"alert alert-danger\">\n    <ul class=\"list-unstyled\">\n        <li ng-repeat=\"message in $ctrl.ngModel.non_field_errors\" ng-bind=\"message\"></li>\n    </ul>\n</div>\n"

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container full-content-center\">\n    <div class=\"box\">\n        <div class=\"header\">\n            <div class=\"logo\"></div>\n            <h2 class=\"form-signin-heading\">Please login</h2>\n        </div>\n        <form class=\"form-signin\" ng-submit=\"vm.submit()\" novalidate>\n            <input type=\"text\" class=\"form-control\" name=\"username\" placeholder=\"Username or Email\" required=\"\" autofocus=\"\" ng-model=\"vm.email\"/>\n            <input type=\"password\" class=\"form-control\" name=\"password\" placeholder=\"Password\" required=\"\" ng-model=\"vm.password\"/>\n            <div class=\"form-group row login-tools\">\n                <div class=\"col-xs-6 pull-right login-forgot-password\">\n                    <a ui-sref=\"r.password\">Forgot Password?</a>\n                </div>\n            </div>\n            <button class=\"btn btn-lg btn-success btn-block\" type=\"submit\" ladda=\"vm.loading\">Login</button>\n        </form>\n    </div>\n</div>\n"

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"full-content-center\">\n    <div class=\"box\">\n        <div class=\"header\">\n            <img ng-src=\"{{$root.image('logo.png')}}\">\n            <h2 class=\"form-signin-heading\">Reset Password</h2>\n        </div>\n        <form ng-submit=\"vm.submit()\" ng-if=\"vm.complete === false\" novalidate>\n            <div class=\"form-group\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       name=\"username\"\n                       placeholder=\"Email\"\n                       required=\"\"\n                       autofocus=\"\"\n                       ng-model=\"vm.data.email\"\n                       form-error>\n            </div>\n            <button class=\"btn btn-success btn-block\"\n                    type=\"submit\"\n                    ladda=\"vm.loading\"\n                    ng-click=\"vm.submit()\">Continue</button>\n        </form>\n        <div ng-if=\"vm.complete === true\">\n            <div class=\"alert alert-success\">\n                <p>We've sent an email. Click the link in the email to reset your password.</p>\n                <p>If you don't see the email, check other places it might be, like your junk, spam, social, or other folders.</p>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"full-content-center\">\n    <div class=\"box\">\n        <div class=\"header\">\n            <img ng-src=\"{{$root.image('logo.png')}}\">\n            <h2 class=\"form-signin-heading\">Reset Password</h2>\n        </div>\n        <form role=\"form\" name=\"confirmResetForm\" ng-submit=\"vm.submit()\" novalidate>\n            <blnd-errors ng-model=\"vm.errors\"></blnd-errors>\n            <div class=\"list-group\">\n                <div class=\"form-group\">\n                    <input name=\"password1\"\n                           type=\"password\"\n                           ng-model=\"vm.data.new_password\"\n                           placeholder=\"New Password\"\n                           class=\"form-control\"\n                           form-error\n                           required>\n                </div>\n                <div class=\"form-group\">\n                    <input name=\"password2\"\n                           type=\"password\"\n                           ng-model=\"vm.data.re_new_password\"\n                           placeholder=\"Repeat Password\"\n                           class=\"form-control\"\n                           form-error\n                           required>\n                </div>\n            </div>\n            <button type=\"submit\" class=\"btn btn-success btn-block\" ng-click=\"vm.submit()\">Reset Password</button>\n        </form>\n    </div>\n</div>\n"

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginCtrl = exports.LoginCtrl = function () {
	    LoginCtrl.$inject = ["$location", "$state", "$stateParams", "AuthService", "InitService"];
	    function LoginCtrl($location, $state, $stateParams, AuthService, InitService) {
	        "ngInject";
	
	        _classCallCheck(this, LoginCtrl);
	
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$location = $location;
	        this.AuthService = AuthService;
	        this.InitService = InitService;
	        this.email = '';
	        this.password = '';
	        this.loading = false;
	    }
	
	    _createClass(LoginCtrl, [{
	        key: 'submit',
	        value: function submit() {
	            var q = this.AuthService.login(this.email, this.password);
	            var self = this;
	            self.loading = true;
	            q.then(function (success) {
	                if (success) {
	                    self.InitService().then(function () {
	                        var path = self.$stateParams.next || self.$state.href('r.in.top.home');
	                        self.$location.url(path);
	                    });
	                } else {
	                    self.loading = false;
	                    self.password = '';
	                }
	            });
	        }
	    }]);
	
	    return LoginCtrl;
	}();
	
	var PasswordResetCtrl = exports.PasswordResetCtrl = function () {
	    PasswordResetCtrl.$inject = ["AuthService"];
	    function PasswordResetCtrl(AuthService) {
	        "ngInject";
	
	        _classCallCheck(this, PasswordResetCtrl);
	
	        this.AuthService = AuthService;
	        this.complete = false;
	        this.data = {
	            email: ''
	        };
	    }
	
	    _createClass(PasswordResetCtrl, [{
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            this.loading = true;
	            this.AuthService.resetPassword(this.data.email).then(function () {
	                self.complete = true;
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }]);
	
	    return PasswordResetCtrl;
	}();
	
	var PasswordConfirmCtrl = exports.PasswordConfirmCtrl = function () {
	    PasswordConfirmCtrl.$inject = ["AuthService", "$state", "$growl", "$stateParams"];
	    function PasswordConfirmCtrl(AuthService, $state, $growl, $stateParams) {
	        "ngInject";
	
	        _classCallCheck(this, PasswordConfirmCtrl);
	
	        this.AuthService = AuthService;
	        this.$state = $state;
	        this.$growl = $growl;
	        this.data = {
	            uid: $stateParams.uid,
	            token: $stateParams.token,
	            new_password: '',
	            re_new_password: ''
	        };
	    }
	
	    _createClass(PasswordConfirmCtrl, [{
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            this.loading = true;
	            this.AuthService.confirmReset(this.data).then(function () {
	                self.$growl.success('Password changed!');
	                self.$state.go('r.login');
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }]);
	
	    return PasswordConfirmCtrl;
	}();

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _ctrls = __webpack_require__(521);
	
	var _main = __webpack_require__(523);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _profile = __webpack_require__(524);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _notifications = __webpack_require__(525);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _profilePassword = __webpack_require__(526);
	
	var _profilePassword2 = _interopRequireDefault(_profilePassword);
	
	var _profileSignature = __webpack_require__(527);
	
	var _profileSignature2 = _interopRequireDefault(_profileSignature);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.account',
	    modules: [_routing2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.account',
	    url: '/account',
	    controller: _ctrls.ProfileCtrl,
	    template: _main2.default,
	    ncyBreadcrumb: {
	        label: 'Account'
	    },
	    abstract: '.profile'
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.account.profile',
	    url: '',
	    template: _profile2.default,
	    ncyBreadcrumb: {
	        label: 'Profile'
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.account.password',
	    url: '/password',
	    controller: _ctrls.ChangePasswordCtrl,
	    template: _profilePassword2.default,
	    ncyBreadcrumb: {
	        label: 'Change Password'
	    }
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.account.notifications',
	    url: '/notifications',
	    controller: _ctrls.UserNotificationsCtrl,
	    template: _notifications2.default,
	    ncyBreadcrumb: {
	        label: 'Notifications'
	    }
	}), _dec6 = (0, _decorators.State)({
	    name: 'r.in.top.account.signature',
	    url: '/signature',
	    controller: _ctrls.UploadSignatureCtrl,
	    template: _profileSignature2.default,
	    ncyBreadcrumb: {
	        label: 'Upload Signature'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UploadSignatureCtrl = exports.UserNotificationsCtrl = exports.ChangePasswordCtrl = exports.ProfileCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _files = __webpack_require__(522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserFileUpload = function (_BaseFileUpload) {
	    _inherits(UserFileUpload, _BaseFileUpload);
	
	    function UserFileUpload($cookies, TokenService, Upload, UserService) {
	        _classCallCheck(this, UserFileUpload);
	
	        var _this = _possibleConstructorReturn(this, (UserFileUpload.__proto__ || Object.getPrototypeOf(UserFileUpload)).call(this, $cookies, TokenService, Upload));
	
	        _this.user = UserService.$user;
	        _this.endpoint = UserService.endpoint.getRequestedUrl() + '/update';
	        return _this;
	    }
	
	    _createClass(UserFileUpload, [{
	        key: 'uploadFile',
	        value: function uploadFile(file) {
	            if (!file) {
	                return;
	            }
	            var data = {
	                signature: file
	            };
	            return _get(UserFileUpload.prototype.__proto__ || Object.getPrototypeOf(UserFileUpload.prototype), 'uploadFile', this).call(this, this.endpoint, data, file.type, 'post');
	        }
	    }]);
	
	    return UserFileUpload;
	}(_files.BaseFileUpload);
	
	var ProfileCtrl = exports.ProfileCtrl = function () {
	    ProfileCtrl.$inject = ["UserService", "$growl"];
	    function ProfileCtrl(UserService, $growl) {
	        "ngInject";
	
	        _classCallCheck(this, ProfileCtrl);
	
	        this.$user = UserService.$user;
	        this.$growl = $growl;
	        this.endpoint = UserService.endpoint;
	        this.data = { phone_number: this.$user.phone_number };
	    }
	
	    _createClass(ProfileCtrl, [{
	        key: 'submitChange',
	        value: function submitChange() {
	            var self = this;
	
	            self.loading = true;
	            this.endpoint.post('update', self.data).then(function () {
	                self.$growl.success('Phone Number changed!');
	                self.errors = {};
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'clean',
	        value: function clean() {
	            this.data = { phone_number: this.$user.phone_number };
	        }
	    }]);
	
	    return ProfileCtrl;
	}();
	
	var ChangePasswordCtrl = exports.ChangePasswordCtrl = function () {
	    ChangePasswordCtrl.$inject = ["UserService", "AuthService", "$growl"];
	    function ChangePasswordCtrl(UserService, AuthService, $growl) {
	        "ngInject";
	
	        _classCallCheck(this, ChangePasswordCtrl);
	
	        this.$user = UserService.$user;
	        this.AuthService = AuthService;
	        this.$growl = $growl;
	        this.loading = false;
	        this.data = {
	            current_password: '',
	            new_password: '',
	            re_new_password: ''
	        };
	    }
	
	    _createClass(ChangePasswordCtrl, [{
	        key: 'resetInputs',
	        value: function resetInputs() {
	            this.data = {
	                current_password: '',
	                new_password: '',
	                re_new_password: ''
	            };
	        }
	    }, {
	        key: 'submitPasswordChange',
	        value: function submitPasswordChange() {
	            var self = this;
	
	            self.loading = true;
	            this.AuthService.changePassword(self.data).then(function () {
	                self.$growl.success('Password changed!');
	                self.resetInputs();
	                self.errors = {};
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }]);
	
	    return ChangePasswordCtrl;
	}();
	
	var UserNotificationsCtrl = exports.UserNotificationsCtrl = function () {
	    UserNotificationsCtrl.$inject = ["UserService", "$growl"];
	    function UserNotificationsCtrl(UserService, $growl) {
	        "ngInject";
	
	        _classCallCheck(this, UserNotificationsCtrl);
	
	        this.$user = UserService.$user;
	        this.endpoint = UserService.endpoint;
	        this.$growl = $growl;
	        var userNotifications = this.$user.notifications_settings;
	        this.notifications = {
	            ticket_was_mixed_email: userNotifications ? userNotifications.ticket_was_mixed_email : false,
	            ticket_was_mixed_sms: userNotifications ? userNotifications.ticket_was_mixed_sms : false,
	            ticket_start_delivery_email: userNotifications ? userNotifications.ticket_start_delivery_email : false,
	            ticket_start_delivery_sms: userNotifications ? userNotifications.ticket_start_delivery_sms : false,
	            ticket_finish_delivery_email: userNotifications ? userNotifications.ticket_finish_delivery_email : false,
	            ticket_finish_delivery_sms: userNotifications ? userNotifications.ticket_finish_delivery_sms : false,
	            ticket_start_application_email: userNotifications ? userNotifications.ticket_start_application_email : false,
	            ticket_start_application_sms: userNotifications ? userNotifications.ticket_start_application_sms : false,
	            ticket_stop_application_email: userNotifications ? userNotifications.ticket_stop_application_email : false,
	            ticket_stop_application_sms: userNotifications ? userNotifications.ticket_stop_application_sms : false,
	            ticket_ready_to_bill_email: userNotifications ? userNotifications.ticket_ready_to_bill_email : false,
	            ticket_ready_to_bill_sms: userNotifications ? userNotifications.ticket_ready_to_bill_sms : false
	        };
	    }
	
	    _createClass(UserNotificationsCtrl, [{
	        key: 'submitChange',
	        value: function submitChange() {
	            var self = this;
	            this.endpoint.post('notifications', self.notifications).then(function () {
	                self.$growl.success('Notifications settings updated!');
	                self.errors = {};
	                self.$user.notifications_settings = self.notifications;
	            }, function (response) {
	                self.$growl.error('Something went wrong', response.data);
	            });
	        }
	    }]);
	
	    return UserNotificationsCtrl;
	}();
	
	var UploadSignatureCtrl = exports.UploadSignatureCtrl = function () {
	    UploadSignatureCtrl.$inject = ["UserService", "$cookies", "TokenService", "$growl", "Upload"];
	    function UploadSignatureCtrl(UserService, $cookies, TokenService, $growl, Upload) {
	        "ngInject";
	
	        _classCallCheck(this, UploadSignatureCtrl);
	
	        this.$user = UserService.$user;
	        this.$growl = $growl;
	        this.endpoint = UserService.endpoint;
	        this.fileUpload = new UserFileUpload($cookies, TokenService, Upload, UserService);
	    }
	
	    _createClass(UploadSignatureCtrl, [{
	        key: 'upload',
	        value: function upload(file) {
	            var self = this;
	            this.fileUpload.uploadFile(file).then(function (response) {
	                _angular2.default.extend(self.$user, response.data);
	            });
	        }
	    }]);
	
	    return UploadSignatureCtrl;
	}();

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FileUpload = exports.BaseFileUpload = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseFileUpload = exports.BaseFileUpload = function () {
	    function BaseFileUpload($cookies, TokenService, Upload) {
	        _classCallCheck(this, BaseFileUpload);
	
	        this.Upload = Upload;
	        this.$cookies = $cookies;
	        this.TokenService = TokenService;
	    }
	
	    _createClass(BaseFileUpload, [{
	        key: 'uploadFile',
	        value: function uploadFile(url, data, contentType, method) {
	            method = method || 'post';
	            return this.Upload.upload({
	                url: url,
	                headers: {
	                    'Content-Type': contentType,
	                    'Authorization': 'Token ' + this.token,
	                    'X-CSRFToken': this.csrfToken
	                },
	                data: data,
	                method: method
	            });
	        }
	    }, {
	        key: 'csrfToken',
	        get: function get() {
	            return this.$cookies.get('csrftoken');
	        }
	    }, {
	        key: 'token',
	        get: function get() {
	            return this.TokenService.get();
	        }
	    }]);
	
	    return BaseFileUpload;
	}();
	
	var FileUpload = exports.FileUpload = function (_BaseFileUpload) {
	    _inherits(FileUpload, _BaseFileUpload);
	
	    function FileUpload($cookies, TokenService, FileStore, Upload) {
	        _classCallCheck(this, FileUpload);
	
	        var _this = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this, $cookies, TokenService, Upload));
	
	        _this.FileStore = FileStore;
	        _this.index = 0;
	        return _this;
	    }
	
	    _createClass(FileUpload, [{
	        key: 'uploadFiles',
	        value: function uploadFiles(files) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var file = _step.value;
	
	                    this.uploadFile(file);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'uploadFile',
	        value: function uploadFile(file) {
	            var data = _lodash2.default.extend({ file: file }, this.FileStore.params);
	            _get(FileUpload.prototype.__proto__ || Object.getPrototypeOf(FileUpload.prototype), 'uploadFile', this).call(this, baseConfig.backendUrl + '/api/v1/files', data, file.type).then(_lodash2.default.bind(this.successHandler, this), _lodash2.default.bind(this.errorHandler, this), _lodash2.default.bind(this.progressHandler, this));
	        }
	    }, {
	        key: 'successHandler',
	        value: function successHandler(response) {
	            var queueIndex = response.config.data.index;
	            var indexInArray = Math.abs(this.index - queueIndex - 1);
	            this.FileStore.list[indexInArray] = this.FileStore.restangularize(response.data);
	        }
	    }, {
	        key: 'errorHandler',
	        value: function errorHandler(response) {}
	    }, {
	        key: 'progressHandler',
	        value: function progressHandler(event) {
	            if (!event.config.data.$uploading) {
	                this.FileStore.list.unshift({
	                    name: event.config.data.file.name,
	                    $uploading: true
	                });
	                _lodash2.default.extend(event.config.data, { $uploading: true, index: this.index });
	                this.index = this.index + 1;
	            }
	        }
	    }]);
	
	    return FileUpload;
	}(BaseFileUpload);

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"profile-container\">\n    <ul class=\"nav nav-tabs\">\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.account.profile\">Profile</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.account.password\">Change Password</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.account.notifications\">Notifications</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.account.signature\">Signature</a></li>\n    </ul>\n    <div class=\"blnd-tab-content\" ui-view></div>\n</div>\n"

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"jumbotron\">\n    <h2>Account {{ vm.$user.username}}</h2>\n    <form ng-submit=\"vm.submitChange\" novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-4\">\n                <label class=\"control-label\">Phone number</label>\n                <div class=\"form-group\">\n                    <input type=\"tel\" class=\"form-control\" name=\"phone_number\" ng-model=\"vm.data.phone_number\"\n                           form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row modal-footer\">\n            <button class=\"btn btn-submit pull-left\" type=\"button\" ng-click=\"vm.submitChange()\">Save</button>\n            <button class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.clean()\">Cancel</button>\n        </div>\n    </form>\n</div>\n"

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"jumbotron\">\n    <form ng-submit=\"vm.submitChange\" novalidate ng-if=\"vm.$user.role.name != 'Salesperson'\">\n        <table class=\"notifications_table\">\n            <thead>\n                <tr>\n                    <th>Notification</th>\n                    <th>Email</th>\n                    <th>SMS</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>Ticket was mixed</td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_was_mixed_email\">\n                    </td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_was_mixed_sms\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Ticket is in delivery</td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_delivery_email\">\n                    </td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_delivery_sms\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Ticket was delivered</td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_finish_delivery_email\">\n                    </td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_finish_delivery_sms\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Application has started</td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_application_email\">\n                    </td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_application_sms\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Ticket ready to bill</td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_ready_to_bill_email\">\n                    </td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_ready_to_bill_sms\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Application is completed</td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_stop_application_email\">\n                    </td>\n                    <td>\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_stop_application_sms\">\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n\n        <div class=\"row modal-footer\">\n            <button class=\"btn btn-submit pull-right\" type=\"button\" ng-click=\"vm.submitChange()\">Save</button>\n        </div>\n    </form>\n    <div ng-if=\"vm.$user.role.name == 'Salesperson'\">\n        <p>Salesperson notifications settings are set per client. Check the Customers notifications page.</p>\n    </div>\n</div>\n"

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"col-sm-4\" role=\"form\" ng-submit=\"vm.submitPasswordChange\" novalidate>\n    <blnd-errors ng-model=\"errors\"></blnd-errors>\n    <div class=\"form-group\">\n        <label class=\"control-label\" for=\"id_old_password\">\n            Old password\n        </label>\n        <input class=\"form-control\"\n               id=\"id_old_password\"\n               name=\"old_password\"\n               type=\"password\"\n               ng-model=\"vm.data.current_password\"\n               form-error >\n    </div>\n    <div class=\"form-group\">\n        <label class=\"control-label\" for=\"id_new_password1\">\n            New password\n        </label>\n        <input class=\"form-control\"\n               id=\"id_new_password1\"\n               name=\"new_password1\"\n               type=\"password\"\n               ng-model=\"vm.data.new_password\"\n               form-error >\n    </div>\n    <div class=\"form-group\">\n        <label class=\"control-label\" for=\"id_new_password2\">\n            New password confirmation\n        </label>\n        <input class=\"form-control\"\n               id=\"id_new_password2\"\n               name=\"new_password2\"\n               type=\"password\"\n               ng-model=\"vm.data.re_new_password\"\n               form-error >\n    </div>\n    <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.submitPasswordChange()\" ladda=\"vm.loading\">Change</button>\n</form>\n"

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"col-sm-4\" role=\"form\" novalidate>\n    <blnd-errors ng-model=\"errors\"></blnd-errors>\n    <div class=\"form-group signature\">\n        <div>\n            <img ng-show=\"vm.$user.signature\" ng-src=\"{{ vm.$user.signature }}\" alt=\"Plant Operator Signature\">\n            <input type=\"file\" ngf-select=\"vm.upload($file)\" ng-model=\"vm.$user.signature\" name=\"file\" ngf-accept=\"'image/*'\">\n            <p class=\"help-block\">Uploading a new signature overwrite old one!</p>\n        </div>\n    </div>\n</form>\n"

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class;
	
	// Templates
	
	
	__webpack_require__(529);
	
	__webpack_require__(530);
	
	var _decorators = __webpack_require__(331);
	
	var _modals = __webpack_require__(532);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _config = __webpack_require__(504);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _ctrls = __webpack_require__(534);
	
	var _billing = __webpack_require__(549);
	
	var _billing2 = _interopRequireDefault(_billing);
	
	var _order = __webpack_require__(550);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _customer = __webpack_require__(551);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _applicator = __webpack_require__(553);
	
	var _applicator2 = _interopRequireDefault(_applicator);
	
	var _company = __webpack_require__(554);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _nutrient = __webpack_require__(555);
	
	var _nutrient2 = _interopRequireDefault(_nutrient);
	
	var _file = __webpack_require__(556);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _printer = __webpack_require__(557);
	
	var _printer2 = _interopRequireDefault(_printer);
	
	var _fade = __webpack_require__(558);
	
	var _fade2 = _interopRequireDefault(_fade);
	
	var _blnd = __webpack_require__(559);
	
	var _blnd2 = _interopRequireDefault(_blnd);
	
	var _blnd3 = __webpack_require__(561);
	
	var _blnd4 = _interopRequireDefault(_blnd3);
	
	var _customer3 = __webpack_require__(566);
	
	var _customer4 = _interopRequireDefault(_customer3);
	
	var _applicator3 = __webpack_require__(570);
	
	var _applicator4 = _interopRequireDefault(_applicator3);
	
	var _shipTo = __webpack_require__(574);
	
	var _shipTo2 = _interopRequireDefault(_shipTo);
	
	var _crop = __webpack_require__(581);
	
	var _crop2 = _interopRequireDefault(_crop);
	
	var _company3 = __webpack_require__(583);
	
	var _company4 = _interopRequireDefault(_company3);
	
	var _nutrients = __webpack_require__(585);
	
	var _nutrients2 = _interopRequireDefault(_nutrients);
	
	var _products = __webpack_require__(587);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _order3 = __webpack_require__(590);
	
	var _order4 = _interopRequireDefault(_order3);
	
	var _list = __webpack_require__(592);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _main = __webpack_require__(600);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _component = __webpack_require__(602);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _delivery = __webpack_require__(609);
	
	var _delivery2 = _interopRequireDefault(_delivery);
	
	var _price = __webpack_require__(611);
	
	var _price2 = _interopRequireDefault(_price);
	
	var _upload = __webpack_require__(613);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	var _activity = __webpack_require__(618);
	
	var _activity2 = _interopRequireDefault(_activity);
	
	var _component3 = __webpack_require__(621);
	
	var _component4 = _interopRequireDefault(_component3);
	
	var _component5 = __webpack_require__(624);
	
	var _component6 = _interopRequireDefault(_component5);
	
	var _component7 = __webpack_require__(626);
	
	var _component8 = _interopRequireDefault(_component7);
	
	var _chemicalProgram = __webpack_require__(628);
	
	var _chemicalProgram2 = _interopRequireDefault(_chemicalProgram);
	
	var _acresCalc = __webpack_require__(631);
	
	var _acresCalc2 = _interopRequireDefault(_acresCalc);
	
	var _secure = __webpack_require__(633);
	
	var _secure2 = _interopRequireDefault(_secure);
	
	var _list3 = __webpack_require__(635);
	
	var _list4 = _interopRequireDefault(_list3);
	
	var _detail = __webpack_require__(636);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _detailOrder = __webpack_require__(637);
	
	var _detailOrder2 = _interopRequireDefault(_detailOrder);
	
	var _detailFiles = __webpack_require__(638);
	
	var _detailFiles2 = _interopRequireDefault(_detailFiles);
	
	var _detailNotes = __webpack_require__(639);
	
	var _detailNotes2 = _interopRequireDefault(_detailNotes);
	
	var _detailLog = __webpack_require__(640);
	
	var _detailLog2 = _interopRequireDefault(_detailLog);
	
	var _detailBilling = __webpack_require__(641);
	
	var _detailBilling2 = _interopRequireDefault(_detailBilling);
	
	var _actions = __webpack_require__(642);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.orders',
	    modules: [_routing2.default, _modals2.default, _config2.default, _order2.default, _customer2.default, _file2.default, _applicator2.default, _company2.default, _nutrient2.default, _nutrients2.default, _products2.default, _price2.default, _upload2.default, _crop2.default, _shipTo2.default, _blnd2.default, _blnd4.default, _customer4.default, _delivery2.default, _applicator4.default, _company4.default, _order4.default, _list2.default, _component2.default, _acresCalc2.default, _main2.default, 'ngFileUpload', _secure2.default, 'selector', _activity2.default, _component4.default, _component6.default, _component8.default, _printer2.default, _chemicalProgram2.default, _fade2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.orders',
	    url: '/orders',
	    abstract: '.list',
	    views: {
	        '': {
	            template: '<ui-view></ui-view>'
	        },
	        'actions': {
	            template: _actions2.default
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Orders'
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.orders.list',
	    abstract: '.main',
	    controller: _ctrls.ListCtrl,
	    template: _list4.default,
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.orders.list.priority',
	    url: '/sorted',
	    template: '<order-priority-list></order-priority-list>',
	    data: {
	        permissions: {
	            only: ['main.can_schedule_orders']
	        }
	    },
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.orders.list.main',
	    url: '?company&search&created_at__range&status&page&ordering&contains_product',
	    // The React page owns these query params (it writes them directly and
	    // refetches itself); the legacy fallback also drives them via UI + an
	    // explicit `$state.go('.', ..., {notify: false})`. Neither relies on the
	    // state reloading when they change, so disable it - otherwise Angular
	    // remounts the React island (and reconciles a stale `$location`) on every
	    // paginate/filter, causing flicker and the "click navbar twice" bug.
	    reloadOnSearch: false,
	    // Feature flag managed by the backend controls the React list rollout.
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_ORDERS_LIST');
	        return useReact ? '<div react-view="orders-list"></div>' : '<order-list extra-fields="[\'customer\']"></order-list>';
	    }],
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec6 = (0, _decorators.State)({
	    name: 'r.in.top.orders.detail',
	    url: '/{orderId:int}',
	    controller: _ctrls.DetailsCtrl,
	    template: _detail2.default,
	    as: 'vmo',
	    resolve: {
	        $order: function $order($stateParams, OrderStore) {
	            return OrderStore.get($stateParams.orderId);
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Order #{{ vmo.order.order_id }}',
	        parent: 'r.in.top.orders'
	    },
	    abstract: '.order'
	}), _dec7 = (0, _decorators.State)({
	    name: 'r.in.top.orders.detail.order',
	    url: '',
	    controller: _ctrls.OrderDetailsCtrl,
	    template: _detailOrder2.default,
	    ncyBreadcrumb: {
	        label: 'Details'
	    },
	    params: {
	        created: null
	    }
	}), _dec8 = (0, _decorators.State)({
	    name: 'r.in.top.orders.detail.files',
	    url: '/files',
	    controller: _ctrls.FilesCtrl,
	    template: _detailFiles2.default,
	    ncyBreadcrumb: {
	        label: 'Files'
	    }
	}), _dec9 = (0, _decorators.State)({
	    name: 'r.in.top.orders.detail.notes',
	    url: '/notes',
	    controller: _ctrls.NotesCtrl,
	    template: _detailNotes2.default,
	    ncyBreadcrumb: {
	        label: 'Notes'
	    }
	}), _dec10 = (0, _decorators.State)({
	    name: 'r.in.top.orders.detail.log',
	    url: '/log',
	    controller: _ctrls.LogCtrl,
	    template: _detailLog2.default,
	    ncyBreadcrumb: {
	        label: 'Log'
	    }
	}), _dec11 = (0, _decorators.State)({
	    name: 'r.in.top.orders.detail.billing',
	    url: '/billing',
	    controller: _billing2.default,
	    template: _detailBilling2.default,
	    ncyBreadcrumb: {
	        label: 'Billing'
	    },
	    resolve: {}
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = _dec8(_class = _dec9(_class = _dec10(_class = _dec11(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _decorators = __webpack_require__(331);
	
	var _confirmModal = __webpack_require__(533);
	
	var _confirmModal2 = _interopRequireDefault(_confirmModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfirmModalCtrl = function () {
	    ConfirmModalCtrl.$inject = ["$sce", "$uibModalInstance", "context", "wait"];
	    function ConfirmModalCtrl($sce, $uibModalInstance, context, wait) {
	        "ngInject";
	
	        _classCallCheck(this, ConfirmModalCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.wait = wait;
	
	        this.confirmName = 'Submit';
	        this.confirmClass = 'btn-submit';
	
	        this.cancelName = 'Cancel';
	        this.cancelClass = 'btn-default';
	
	        this.title = 'Confirm';
	        this.text = "Are you sure ?";
	
	        _angular2.default.extend(this, context);
	
	        this.title = $sce.trustAsHtml(this.title);
	        this.text = $sce.trustAsHtml(this.text);
	
	        this.loading = false;
	    }
	
	    _createClass(ConfirmModalCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.loading = true;
	            self.wait.resolve({
	                choice: true,
	                close: function close() {
	                    self.loading = false;
	                    self.$modal.close();
	                }
	            });
	        }
	    }]);
	
	    return ConfirmModalCtrl;
	}();
	
	var Modal = (_dec = (0, _decorators.Module)({
	    name: 'app.services.modals'
	}), _dec2 = (0, _decorators.Service)('Modal'), _dec(_class = _dec2(_class = function () {
	    Modal.$inject = ["$q", "$uibModal"];
	    function Modal($q, $uibModal) {
	        "ngInject";
	
	        _classCallCheck(this, Modal);
	
	        this.$q = $q;
	        this.$uibModal = $uibModal;
	    }
	
	    _createClass(Modal, [{
	        key: 'open',
	        value: function open(_ref) {
	            var _ref$as = _ref.as,
	                as = _ref$as === undefined ? 'vm' : _ref$as,
	                _ref$backdrop = _ref.backdrop,
	                backdrop = _ref$backdrop === undefined ? 'static' : _ref$backdrop,
	                params = _objectWithoutProperties(_ref, ['as', 'backdrop']);
	
	            params['controllerAs'] = as;
	            params['backdrop'] = backdrop;
	            return this.$uibModal.open(params);
	        }
	    }, {
	        key: 'openConfirm',
	        value: function openConfirm(_context) {
	            _context = _context || {};
	            var deffered = this.$q.defer();
	            var $modal = this.open({
	                template: _confirmModal2.default,
	                controller: ConfirmModalCtrl,
	                size: 'medium',
	                resolve: {
	                    context: function context() {
	                        return _context;
	                    },
	                    wait: function wait() {
	                        return deffered;
	                    }
	                }
	            });
	            $modal.wait = deffered.promise;
	            return $modal;
	        }
	    }, {
	        key: 'openConfirmDelete',
	        value: function openConfirmDelete(context) {
	            context = context || {};
	            var ctx = {
	                confirmName: 'Delete',
	                confirmClass: 'btn-delete'
	            };
	            _angular2.default.extend(ctx, context);
	            return this.openConfirm(ctx);
	        }
	    }]);
	
	    return Modal;
	}()) || _class) || _class);
	exports.default = Modal;

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">{{ vm.title }}</h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-sm-12\" ng-bind-html=\"vm.text\">\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn\" ng-class=\"vm.confirmClass\" type=\"submit\" ladda=\"vm.loading\">{{ vm.confirmName }}</button>\n        <button class=\"btn\" ng-class=\"vm.cancelClass\" type=\"button\" ng-click=\"vm.close()\">{{ vm.cancelName }}</button>\n    </div>\n</form>\n"

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LogCtrl = exports.NotesCtrl = exports.FilesCtrl = exports.EditOrderDetailsCtrl = exports.SendAndPrintFormCtrl = exports.SendFormPDFCtrl = exports.SendEstimatePDFCtrl = exports.OrderDetailsCtrl = exports.DetailsCtrl = exports.ListCtrl = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _create = __webpack_require__(535);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _calculation = __webpack_require__(536);
	
	var _notes = __webpack_require__(537);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	var _constants = __webpack_require__(538);
	
	var _createModalTpl = __webpack_require__(539);
	
	var _createModalTpl2 = _interopRequireDefault(_createModalTpl);
	
	var _editModal = __webpack_require__(540);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	var _cloneOrder = __webpack_require__(541);
	
	var _cloneOrder2 = _interopRequireDefault(_cloneOrder);
	
	var _createTicket = __webpack_require__(542);
	
	var _createTicket2 = _interopRequireDefault(_createTicket);
	
	var _sendEstimationForm = __webpack_require__(543);
	
	var _sendEstimationForm2 = _interopRequireDefault(_sendEstimationForm);
	
	var _ctrls = __webpack_require__(544);
	
	var _modalList = __webpack_require__(545);
	
	var _modalList2 = _interopRequireDefault(_modalList);
	
	var _constants2 = __webpack_require__(546);
	
	var _helpers = __webpack_require__(547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddOrderCtrl = function (_BaseAddModal) {
	  AddOrderCtrl.$inject = ["$uibModalInstance", "store", "UserService"];
	  _inherits(AddOrderCtrl, _BaseAddModal);
	
	  function AddOrderCtrl($uibModalInstance, store, UserService) {
	    "ngInject";
	
	    _classCallCheck(this, AddOrderCtrl);
	
	    return _possibleConstructorReturn(this, (AddOrderCtrl.__proto__ || Object.getPrototypeOf(AddOrderCtrl)).call(this, $uibModalInstance, store, UserService));
	  }
	
	  _createClass(AddOrderCtrl, [{
	    key: "title",
	    get: function get() {
	      return "Add Order";
	    }
	  }]);
	
	  return AddOrderCtrl;
	}(_create2.default);
	
	var CloneOrderCtrl = function () {
	  CloneOrderCtrl.$inject = ["$state", "$uibModalInstance", "order"];
	  function CloneOrderCtrl($state, $uibModalInstance, order) {
	    "ngInject";
	
	    _classCallCheck(this, CloneOrderCtrl);
	
	    this.data = {
	      customer: order.customer,
	      company: order.company
	    };
	    this.order = order;
	    this.$modal = $uibModalInstance;
	    this.$state = $state;
	  }
	
	  _createClass(CloneOrderCtrl, [{
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var self = this;
	      self.loading = true;
	      var copyNotes = false;
	      var copyNotesCheck = document.getElementById("copy-notes");
	      if (copyNotesCheck) {
	        copyNotes = copyNotesCheck.checked;
	      }
	
	      self.order.one("clone").customPOST({
	        customer: self.data.customer,
	        company: self.data.company,
	        copy_notes: copyNotes
	      }).then(function (data) {
	        self.$modal.close(data);
	      }, function (resp) {
	        self.errors = resp.data;
	      }).finally(function () {
	        return self.loading = false;
	      });
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Copy order";
	    }
	  }]);
	
	  return CloneOrderCtrl;
	}();
	
	var OrderRecalc = function (_BaseReCalc) {
	  _inherits(OrderRecalc, _BaseReCalc);
	
	  function OrderRecalc(order, nutrientsReCalc) {
	    _classCallCheck(this, OrderRecalc);
	
	    var _this2 = _possibleConstructorReturn(this, (OrderRecalc.__proto__ || Object.getPrototypeOf(OrderRecalc)).call(this, order));
	
	    _this2.nutrientsReCalc = nutrientsReCalc;
	    return _this2;
	  }
	
	  _createClass(OrderRecalc, [{
	    key: "_nutrients",
	    value: function _nutrients() {
	      this.nutrientsReCalc.calcLbs();
	    }
	  }, {
	    key: "rate",
	    value: function rate() {
	      if (!this.canUpdateRate) {
	        return;
	      }
	      this.object.acres = _lodash2.default.round(this.object.acres, 3);
	
	      var quantity = this.object.acres * this.object.rate;
	
	      if (!this.object.water_gallons) {
	        quantity = quantity / 2000;
	      }
	      this.object.quantity = _lodash2.default.round(quantity, 3);
	      this._nutrients();
	    }
	  }]);
	
	  return OrderRecalc;
	}(_calculation.BaseReCalc);
	
	var NutrientReCalc = function () {
	  function NutrientReCalc(order) {
	    _classCallCheck(this, NutrientReCalc);
	
	    this.object = order;
	    this.init();
	  }
	
	  _createClass(NutrientReCalc, [{
	    key: "init",
	    value: function init() {
	      this.nutrients = _lodash2.default.filter(this.object.nutrients, function (obj, key) {
	        return ["urea_dry", "an", "crn", "potcarb", "p2", "p3", "s2"].indexOf(key) === -1;
	      });
	      this.nutrients = _lodash2.default.orderBy(_lodash2.default.values(this.nutrients), "ui_place");
	      this.nutrients = _lodash2.default.map(this.nutrients, function (obj) {
	        obj.label = _lodash2.default.toLower(obj.short_name);
	        return obj;
	      });
	    }
	  }, {
	    key: "calcLbs",
	    value: function calcLbs() {
	      var self = this;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = self.nutrients[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var obj = _step.value;
	
	          self.onPercentChanged(obj);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: "onPercentChanged",
	    value: function onPercentChanged(obj) {
	      if (!obj.percent) {
	        obj.percent = 0;
	      }
	      obj.percent = parseFloat(obj.percent);
	      if (obj.percent < 0 || obj.percent > 100) {
	        obj.percent = 0;
	      }
	      obj.percent = _lodash2.default.round(obj.percent, 3);
	      obj.lbs = this.object.rate * (obj.percent / 100);
	      obj.lbs = _lodash2.default.round(obj.lbs, 3);
	    }
	  }, {
	    key: "onLbsChanged",
	    value: function onLbsChanged(obj) {
	      if (!obj.lbs) {
	        obj.lbs = 0;
	      }
	      obj.lbs = parseFloat(obj.lbs);
	      if (obj.lbs < 0) {
	        obj.lbs = 0;
	      }
	      obj.percent = obj.lbs / this.object.rate * 100;
	      obj.percent = _lodash2.default.round(obj.percent, 3);
	    }
	  }]);
	
	  return NutrientReCalc;
	}();
	
	var CreateTicket = function () {
	  CreateTicket.$inject = ["$state", "$uibModalInstance", "order"];
	  function CreateTicket($state, $uibModalInstance, order) {
	    "ngInject";
	
	    _classCallCheck(this, CreateTicket);
	
	    this.data = {
	      tonnage: 0,
	      acres: 0,
	      fields: _angular2.default.copy(order.fields),
	      applicators: Array(),
	      haulers: Array()
	    };
	    this.order = order;
	    this.$modal = $uibModalInstance;
	    this.$state = $state;
	    this.ticketsCreated = [];
	    this.data.tonnage = this.tonnage_left;
	    this.data.acres = this.acres_left;
	  }
	
	  _createClass(CreateTicket, [{
	    key: "reCalculateAcres",
	    value: function reCalculateAcres() {
	      if (this.touched) {
	        return;
	      }
	      this.data.acres = _lodash2.default.sum(_lodash2.default.map(this.data.fields, "field.acres"));
	      this.calculateTonnage();
	    }
	  }, {
	    key: "calculateAcres",
	    value: function calculateAcres() {
	      this.data.acres = _lodash2.default.round(this.data.tonnage * 2000 / this.order.rate, 3);
	    }
	  }, {
	    key: "calculateTonnage",
	    value: function calculateTonnage() {
	      this.data.tonnage = _lodash2.default.round(this.data.acres * this.order.rate / 2000, 3);
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "checkApplicators",
	    value: function checkApplicators() {
	      var self = this;
	      if (self.data.applicators == null) {
	        self.data.applicators = [];
	      } else if (!Array.isArray(self.data.applicators)) {
	        self.data.applicators = Array(self.data.applicators);
	      }
	      if (self.data.haulers == null) {
	        self.data.haulers = [];
	      } else if (!Array.isArray(self.data.haulers)) {
	        self.data.haulers = Array(self.data.haulers);
	      }
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var _this3 = this;
	
	      var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var self = this;
	      self.loading = true;
	      self.checkApplicators();
	      var p = self.order.one("ticket").customPOST(self.data);
	      p.then(function (data) {
	        if (redirect) {
	          self.$modal.close(data);
	        } else {
	          var p2 = self.order.customGET("").then(function (data) {
	            return _lodash2.default.extend(self.order, data);
	          });
	          p2 = p2.then(function () {
	            return self.ticketsCreated.push(data);
	          });
	          p2.then(function () {
	            return self.loading = false;
	          });
	          _this3.data.tonnage = _lodash2.default.max([_lodash2.default.round(_this3.tonnage_left - _this3.data.tonnage, 3), 0]);
	          _this3.data.acres = _lodash2.default.max([_lodash2.default.round(_this3.acres_left - _this3.data.acres, 3), 0]);
	        }
	      }, function (resp) {
	        self.errors = resp.data;
	        self.loading = false;
	      });
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Create Ticket";
	    }
	  }, {
	    key: "tonnage_left",
	    get: function get() {
	      return _lodash2.default.max([_lodash2.default.round(this.order.tonnage - this.order.tickets_tonnage, 3), 0]);
	    }
	  }, {
	    key: "acres_left",
	    get: function get() {
	      return _lodash2.default.max([_lodash2.default.round(this.order.acres - this.order.tickets_acres, 3), 0]);
	    }
	  }]);
	
	  return CreateTicket;
	}();
	
	var ListCtrl = exports.ListCtrl = function () {
	  ListCtrl.$inject = ["$growl", "$state", "Modal", "OrderStore"];
	  function ListCtrl($growl, $state, Modal, OrderStore) {
	    "ngInject";
	
	    _classCallCheck(this, ListCtrl);
	
	    this.$growl = $growl;
	    this.$state = $state;
	    this.Modal = Modal;
	    this.store = OrderStore;
	  }
	
	  _createClass(ListCtrl, [{
	    key: "openAddModal",
	    value: function openAddModal() {
	      var _this4 = this;
	
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _createModalTpl2.default,
	        controller: AddOrderCtrl,
	        size: "small",
	        resolve: {
	          store: function store() {
	            return _this4.store;
	          }
	        }
	      });
	
	      $modal.result.then(function (data) {
	        self.$growl.added();
	        self.$state.go("r.in.top.orders.detail", { orderId: data.id, created: true }, { absolute: true, reload: true });
	      });
	    }
	  }]);
	
	  return ListCtrl;
	}();
	
	var DetailsCtrl = exports.DetailsCtrl = function () {
	  DetailsCtrl.$inject = ["$scope", "$window", "$state", "$order", "$growl", "$httpParamSerializer", "Modal", "SecureUrlService", "UserService"];
	  function DetailsCtrl($scope, $window, $state, $order, $growl, $httpParamSerializer, Modal, SecureUrlService, UserService) {
	    "ngInject";
	
	    _classCallCheck(this, DetailsCtrl);
	
	    this.order = $order;
	    this.$state = $state;
	    this.$growl = $growl;
	    this.$window = $window;
	    this.user = UserService.$user;
	    this.$httpParamSerializer = $httpParamSerializer;
	    this.Modal = Modal;
	    this.secureUrlService = SecureUrlService;
	    this.loading = {};
	
	    // Assign to the scope and pass value to child views
	    $scope.canViewEditButton = this.canViewEditButton;
	  }
	
	  _createClass(DetailsCtrl, [{
	    key: "createTicket",
	    value: function createTicket() {
	      var _this5 = this;
	
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _createTicket2.default,
	        controller: CreateTicket,
	        size: "small",
	        resolve: {
	          order: function order() {
	            return _this5.order;
	          }
	        }
	      });
	
	      $modal.result.then(function (data) {
	        self.$state.go("r.in.top.tickets.detail", {
	          ticketId: data.id,
	          created: true
	        });
	        self.$growl.added();
	      });
	    }
	  }, {
	    key: "cloneOrder",
	    value: function cloneOrder() {
	      var _this6 = this;
	
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _cloneOrder2.default,
	        controller: CloneOrderCtrl,
	        size: "small",
	        resolve: {
	          order: function order() {
	            return _this6.order;
	          }
	        }
	      });
	
	      $modal.result.then(function (data) {
	        self.$state.go("r.in.top.orders.detail", { orderId: data.id });
	        self.$growl.success("Copied successfully !");
	      });
	    }
	  }, {
	    key: "openSendEmail",
	    value: function openSendEmail(type) {
	      var controller = SendEstimatePDFCtrl;
	      if (type === "form") {
	        controller = SendFormPDFCtrl;
	      } else if (type == "send_and_print") {
	        controller = SendAndPrintFormCtrl;
	      }
	
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _sendEstimationForm2.default,
	        controller: controller,
	        size: "large",
	        resolve: {
	          order: function order() {
	            return self.order;
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        self.$growl.success("E-mail has been sent");
	      });
	    }
	  }, {
	    key: "print",
	    value: function print(type) {
	      var endpoint = type === "estimate" ? this.order.all("estimate").all("print") : this.order.all("form").all("print");
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _modalList2.default,
	        controller: _ctrls.PrinterListModalCtrl,
	        size: "large",
	        resolve: {
	          company: function company() {
	            return self.order.company.id;
	          },
	          request: function request() {
	            return {
	              endpoint: endpoint,
	              multiple: false
	            };
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        self.$growl.success("Added file to queue");
	      });
	    }
	  }, {
	    key: "orderFormUrl",
	    value: function orderFormUrl() {
	      this.secureUrlService.openInNewWindow(this.order.one("form"));
	    }
	  }, {
	    key: "orderEstimateUrl",
	    value: function orderEstimateUrl() {
	      this.secureUrlService.openInNewWindow(this.order.one("estimate"));
	    }
	  }, {
	    key: "sendAndPrint",
	    value: function sendAndPrint() {
	      var self = this;
	      self.loading["sendAndPrint"] = true;
	      this.order.all("print-and-send").post().then(function () {
	        self.$growl.success("Sent email and added file to print queue");
	      }).finally(function () {
	        self.loading["sendAndPrint"] = false;
	      });
	    }
	  }, {
	    key: "canViewEditButton",
	    get: function get() {
	      // Edit button should be always visible, but it should not be visible
	      // in few cases like:
	      if (this.user.role && this.user.role.id === _constants.roles.SALESPERSON) {
	        // if ticket is created from the order, salesperson cannot edit
	        return this.order.tickets.length === 0;
	      }
	      if (this.user.role && this.user.role.id === _constants.roles.DISPATCHER) {
	        // disable for dispatcher
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: "canSeePrice",
	    get: function get() {
	      if (this.user.role && [_constants.roles.PLANT_MANAGER, _constants.roles.DISPATCHER].includes(this.user.role.id)) {
	        // hide for plant_manager & dispatcher
	        return false;
	      }
	
	      return true;
	    }
	  }]);
	
	  return DetailsCtrl;
	}();
	
	var OrderDetailsCtrl = exports.OrderDetailsCtrl = function (_DetailViewMap) {
	  OrderDetailsCtrl.$inject = ["$order", "$growl", "$stateParams", "UserService", "ApplicatorConfigStore", "CompanyFreightStore", "NutrientPricesStore", "Modal", "FieldStore", "hotkeys", "modalRegistry"];
	  _inherits(OrderDetailsCtrl, _DetailViewMap);
	
	  function OrderDetailsCtrl($order, $growl, $stateParams, UserService, ApplicatorConfigStore, CompanyFreightStore, NutrientPricesStore, Modal, FieldStore, hotkeys, modalRegistry) {
	    "ngInject";
	
	    _classCallCheck(this, OrderDetailsCtrl);
	
	    //maps
	    var _this7 = _possibleConstructorReturn(this, (OrderDetailsCtrl.__proto__ || Object.getPrototypeOf(OrderDetailsCtrl)).call(this, $order));
	
	    _this7.$growl = $growl;
	    _this7.$stateParams = $stateParams;
	    _this7.order = $order;
	    _this7.Modal = Modal;
	    _this7.user = UserService.$user;
	    _this7.hotkeys = hotkeys;
	    _this7.modalRegistry = modalRegistry;
	    _this7.applicatorsConfig = ApplicatorConfigStore;
	    _this7.companyFreightStore = CompanyFreightStore;
	    _this7.nutrientPricesStore = NutrientPricesStore;
	    _this7.nutrientReCalc = new NutrientReCalc(_this7.order);
	    _this7.priceCalc = new PriceCalculation(_this7.order, _this7.applicatorsConfig, _this7.companyFreightStore, _this7.nutrientPricesStore);
	    _this7.fieldStore = FieldStore;
	    _this7.i = 0;
	
	    _this7.setHotKeys();
	    _this7.customEvents();
	    return _this7;
	  }
	
	  _createClass(OrderDetailsCtrl, [{
	    key: "customEvents",
	    value: function customEvents() {
	      if (this.$stateParams.created) {
	        this.editModal();
	      }
	    }
	  }, {
	    key: "setHotKeys",
	    value: function setHotKeys() {
	      var self = this;
	      if (this.user.role.name != "Dispatcher") {
	        self.hotkeys.add({
	          combo: "e",
	          description: "Edit Modal",
	          callback: function callback(event, hotkey) {
	            if (self.modalRegistry.isOpen("order-edit")) {
	              return;
	            }
	            self.modalRegistry.push("order-edit");
	            self.editModal();
	          }
	        });
	      }
	    }
	  }, {
	    key: "onProductsChange",
	    value: function onProductsChange() {
	      this.priceCalc.preview();
	    }
	  }, {
	    key: "editModal",
	    value: function editModal() {
	      var _this8 = this;
	
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _editModal2.default,
	        controller: EditOrderDetailsCtrl,
	        size: "ticket-edit",
	        resolve: {
	          order: function order() {
	            return _this8.order;
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        if (self.$stateParams.created) {
	          // reload page if crated
	          window.location.reload();
	        } else {
	          // Update components
	          self.nutrientReCalc = new NutrientReCalc(self.order);
	          self.priceCalc.preview();
	          self.$growl.updated();
	          self.getStaticLocations();
	          self.updateMarkers();
	        }
	      }).finally(function () {
	        self.modalRegistry.pop("order-edit");
	      });
	    }
	  }]);
	
	  return OrderDetailsCtrl;
	}(_helpers.DetailViewMap);
	
	var BaseSendPDFFrom = function () {
	  BaseSendPDFFrom.$inject = ["$uibModalInstance", "UserService", "order", "R"];
	  function BaseSendPDFFrom($uibModalInstance, UserService, order, R) {
	    "ngInject";
	
	    _classCallCheck(this, BaseSendPDFFrom);
	
	    this.$modal = $uibModalInstance;
	    this.user = UserService.$user;
	    this.multipleOrders = false;
	    this.R = R;
	    if (Array.isArray(order)) {
	      if (order.length > 1) {
	        this.multipleOrders = true;
	        this.orders = order;
	      } else {
	        this.order = order[0];
	      }
	    } else {
	      this.order = order;
	    }
	    this.data = this.buildContext();
	  }
	
	  _createClass(BaseSendPDFFrom, [{
	    key: "buildContext",
	    value: function buildContext() {
	      throw "buildContext() not implemented";
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      throw "title() not implemented";
	    }
	  }]);
	
	  return BaseSendPDFFrom;
	}();
	
	var SendEstimatePDFCtrl = exports.SendEstimatePDFCtrl = function (_BaseSendPDFFrom) {
	  SendEstimatePDFCtrl.$inject = ["$uibModalInstance", "UserService", "order", "R"];
	  _inherits(SendEstimatePDFCtrl, _BaseSendPDFFrom);
	
	  function SendEstimatePDFCtrl($uibModalInstance, UserService, order, R) {
	    "ngInject";
	
	    _classCallCheck(this, SendEstimatePDFCtrl);
	
	    return _possibleConstructorReturn(this, (SendEstimatePDFCtrl.__proto__ || Object.getPrototypeOf(SendEstimatePDFCtrl)).call(this, $uibModalInstance, UserService, order, R));
	  }
	
	  _createClass(SendEstimatePDFCtrl, [{
	    key: "buildContext",
	    value: function buildContext() {
	      if (this.multipleOrders) {
	        var customers = new Array();
	        var emails = new Set(_lodash2.default.map(this.user.email_to, "email"));
	        this.orders.forEach(function (value) {
	          customers.push(value.id + " of customer " + value.customer.title);
	          emails.add(value.company.email);
	        });
	        return {
	          subject: "Willard Agri Service Estimate for multiple orders.",
	          message: "Hello, \nAttached is an estimate of orders: \n" + _lodash2.default.join(customers, ", \n") + ".",
	          email_to: _lodash2.default.join(Array.from(emails), ",") || "",
	          bcc_salesperson: true
	        };
	      } else {
	        var emailTo = _lodash2.default.map(this.user.email_to, "email");
	        if (emailTo.indexOf(this.order.company.email) === -1) {
	          emailTo.push(this.order.company.email);
	        }
	        return {
	          subject: "Willard Agri Service Estimate for " + this.order.customer.title,
	          message: "Hello, \nAttached is an estimate of your order.",
	          email_to: _lodash2.default.join(emailTo, ",") || "",
	          bcc_salesperson: true
	        };
	      }
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var self = this;
	      self.loading = true;
	      if (this.multipleOrders) {
	        self.data["orders"] = self.orders.map(function (value) {
	          return value.id;
	        });
	        self.R.all(["orders", "estimate", "send"].join("/")).post(self.data).then(function () {
	          self.$modal.close(true);
	        }, function (resp) {
	          self.errors = resp.data;
	        }).finally(function () {
	          self.loading = false;
	        });
	      } else {
	        self.order.one("estimate").post("send", self.data).then(function () {
	          self.$modal.close(true);
	        }, function (resp) {
	          self.errors = resp.data;
	        }).finally(function () {
	          self.loading = false;
	        });
	      }
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Estimate Email";
	    }
	  }]);
	
	  return SendEstimatePDFCtrl;
	}(BaseSendPDFFrom);
	
	var SendFormPDFCtrl = exports.SendFormPDFCtrl = function (_BaseSendPDFFrom2) {
	  SendFormPDFCtrl.$inject = ["$uibModalInstance", "UserService", "order", "R"];
	  _inherits(SendFormPDFCtrl, _BaseSendPDFFrom2);
	
	  function SendFormPDFCtrl($uibModalInstance, UserService, order, R) {
	    "ngInject";
	
	    _classCallCheck(this, SendFormPDFCtrl);
	
	    return _possibleConstructorReturn(this, (SendFormPDFCtrl.__proto__ || Object.getPrototypeOf(SendFormPDFCtrl)).call(this, $uibModalInstance, UserService, order, R));
	  }
	
	  _createClass(SendFormPDFCtrl, [{
	    key: "buildContext",
	    value: function buildContext() {
	      if (this.multipleOrders) {
	        var customers = new Array();
	        var emails = new Set(_lodash2.default.map(this.user.email_to, "email"));
	        this.orders.forEach(function (value) {
	          customers.push(value.id + " of customer " + value.customer.title);
	          emails.add(value.company.email);
	        });
	        return {
	          subject: "Order Form for multiple orders",
	          message: "Hello, \nAttached is the Order Form for orders: \n" + _lodash2.default.join(Array.from(customers), ", \n") + ".",
	          email_to: _lodash2.default.join(Array.from(emails), ",") || "",
	          bcc_salesperson: true
	        };
	      } else {
	        var emailTo = _lodash2.default.map(this.user.email_to, "email");
	        if (emailTo.indexOf(this.order.company.email) === -1) {
	          emailTo.push(this.order.company.email);
	        }
	        return {
	          subject: "Order Form for " + this.order.customer.title,
	          message: "Hello, \nAttached is the Order Form.",
	          email_to: _lodash2.default.join(emailTo, ",") || "",
	          bcc_salesperson: true
	        };
	      }
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var self = this;
	      self.loading = true;
	      if (this.multipleOrders) {
	        self.data["orders"] = self.orders.map(function (value) {
	          return value.id;
	        });
	        self.R.all(["orders", "form", "send"].join("/")).post(self.data).then(function () {
	          self.$modal.close(true);
	        }, function (resp) {
	          self.errors = resp.data;
	        }).finally(function () {
	          self.loading = false;
	        });
	      } else {
	        self.order.one("form").post("send", self.data).then(function () {
	          self.$modal.close(true);
	        }, function (resp) {
	          self.errors = resp.data;
	        }).finally(function () {
	          self.loading = false;
	        });
	      }
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Form Email";
	    }
	  }]);
	
	  return SendFormPDFCtrl;
	}(BaseSendPDFFrom);
	
	var SendAndPrintFormCtrl = exports.SendAndPrintFormCtrl = function (_SendFormPDFCtrl) {
	  SendAndPrintFormCtrl.$inject = ["$uibModalInstance", "UserService", "order", "$growl", "R"];
	  _inherits(SendAndPrintFormCtrl, _SendFormPDFCtrl);
	
	  function SendAndPrintFormCtrl($uibModalInstance, UserService, order, $growl, R) {
	    "ngInject";
	
	    _classCallCheck(this, SendAndPrintFormCtrl);
	
	    var _this11 = _possibleConstructorReturn(this, (SendAndPrintFormCtrl.__proto__ || Object.getPrototypeOf(SendAndPrintFormCtrl)).call(this, $uibModalInstance, UserService, order, R));
	
	    _this11.$growl = $growl;
	    _this11.btnLabel = "Send and Print";
	    return _this11;
	  }
	
	  _createClass(SendAndPrintFormCtrl, [{
	    key: "submit",
	    value: function submit() {
	      var self = this;
	      self.loading = true;
	      if (this.multipleOrders) {
	        self.data["orders"] = self.orders.map(function (value) {
	          return value.id;
	        });
	        self.R.all(["orders", "print-and-send"].join("/")).post(self.data).then(function () {
	          self.$modal.close(true);
	        }, function (resp) {
	          self.errors = resp.data;
	        }).finally(function () {
	          self.loading = false;
	        });
	      } else {
	        self.order.post("print-and-send", self.data).then(function () {
	          self.$modal.close(true);
	        }, function (resp) {
	          self.errors = resp.data;
	          if (resp.data.non_field_errors) {
	            self.$growl.error(resp.data.non_field_errors[0]);
	          }
	        }).finally(function () {
	          self.loading = false;
	        });
	      }
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Send and Print Form";
	    }
	  }]);
	
	  return SendAndPrintFormCtrl;
	}(SendFormPDFCtrl);
	
	var EditOrderDetailsCtrl = exports.EditOrderDetailsCtrl = function (_EditViewMap) {
	  EditOrderDetailsCtrl.$inject = ["ApplicatorStore", "$growl", "ApplicatorConfigStore", "Config", "CompanyFreightStore", "NutrientPricesStore", "CustomerStore", "R", "Modal", "$uibModalInstance", "order", "ProductStore"];
	  _inherits(EditOrderDetailsCtrl, _EditViewMap);
	
	  function EditOrderDetailsCtrl(ApplicatorStore, $growl, ApplicatorConfigStore, Config, CompanyFreightStore, NutrientPricesStore, CustomerStore, R, Modal, $uibModalInstance, order, ProductStore) {
	    "ngInject";
	
	    _classCallCheck(this, EditOrderDetailsCtrl);
	
	    // maps
	    var _this12 = _possibleConstructorReturn(this, (EditOrderDetailsCtrl.__proto__ || Object.getPrototypeOf(EditOrderDetailsCtrl)).call(this, order));
	
	    _this12.R = R;
	    _this12.$growl = $growl;
	    _this12.customers = CustomerStore;
	    _this12.applicators = ApplicatorStore;
	    _this12.applicatorsConfig = ApplicatorConfigStore;
	    _this12.companyFreightStore = CompanyFreightStore;
	    _this12.nutrientPricesStore = NutrientPricesStore;
	    _this12.productStore = ProductStore;
	    _this12.config = Config;
	    _this12.order = order;
	    _this12.data = _this12.R.copy(_this12.order);
	    _this12.nutrientReCalc = new NutrientReCalc(_this12.data);
	    _this12.tRecalc = new OrderRecalc(_this12.data, _this12.nutrientReCalc);
	    _this12.priceCalc = new PriceCalculation(_this12.data, _this12.applicatorsConfig, _this12.companyFreightStore, _this12.nutrientPricesStore);
	    _this12.priceCalc.calc();
	
	    _this12.showPrices = false;
	    _this12.saveDisabled = false;
	    _this12.convertToPints = _this12.data.quantity_units === "GALS";
	
	    _this12.$modal = $uibModalInstance;
	    _this12.Modal = Modal;
	    _this12.units = [{
	      id: "TONS",
	      name: "T"
	    }, {
	      id: "GALS",
	      name: "G"
	    }];
	    _this12.acresStatus = "";
	    return _this12;
	  }
	
	  _createClass(EditOrderDetailsCtrl, [{
	    key: "acresStatusCallback",
	    value: function acresStatusCallback() {
	      this.acresStatus = "";
	    }
	  }, {
	    key: "onProductUpdate",
	    value: function onProductUpdate(recalcOnlyChemicals) {
	      var shouldDisable = false;
	
	      if (this.data.products.length >= 1) {
	        _lodash2.default.forEach(this.data.products, function (obj) {
	          if (_lodash2.default.inRange(obj.product && obj.product.id, _constants2.DISABLED_DELIVERY_RANGE[0], _constants2.DISABLED_DELIVERY_RANGE[1])) {
	            shouldDisable = true;
	            return;
	          }
	        });
	
	        if (shouldDisable) {
	          this.priceCalc.disableCalcForDelivery();
	        } else {
	          this.priceCalc.enableCalcForDelivery();
	        }
	      } else {
	        this.priceCalc.enableCalcForDelivery();
	      }
	      this.priceCalc.calc(recalcOnlyChemicals);
	    }
	  }, {
	    key: "recalculatePrice",
	    value: function recalculatePrice(recalcOnlyChemicals) {
	      this.priceCalc.calc(recalcOnlyChemicals);
	    }
	  }, {
	    key: "onAcresModelChange",
	    value: function onAcresModelChange() {
	      this.tRecalc.acres();
	      this.priceCalc.calc();
	      this.data.is_acres_touched = true;
	    }
	  }, {
	    key: "onQuantityChange",
	    value: function onQuantityChange() {
	      this.tRecalc.quantity();
	      this.priceCalc.calc();
	      this.data.is_acres_touched = true;
	    }
	  }, {
	    key: "reCalculateAcres",
	    value: function reCalculateAcres(canReCalc) {
	      if (canReCalc) {
	        return;
	      }
	
	      // If empty do nothing
	      if (!_lodash2.default.isArray(this.data.fields)) {
	        return;
	      }
	
	      this.data.acres = _lodash2.default.round(_lodash2.default.sum(_lodash2.default.map(this.data.fields, "field.acres")), 3);
	      this.tRecalc.acres();
	    }
	  }, {
	    key: "onAcresTouchChange",
	    value: function onAcresTouchChange(isChanged) {
	      this.reCalculateAcres(isChanged);
	    }
	  }, {
	    key: "onAcresChange",
	    value: function onAcresChange() {
	      if (this.data.is_acres_touched) {
	        this.acresStatus = "not-updated";
	      } else {
	        this.acresStatus = "updated";
	      }
	      this.getDynamicLocations(this.data.fields);
	      this.updateMarkers();
	      this.reCalculateAcres(this.data.is_acres_touched);
	    }
	  }, {
	    key: "onWaterChange",
	    value: function onWaterChange() {
	      var quantity = parseFloat(this.data.quantity) || 0;
	      this.data.quantity = _lodash2.default.round(this.data.water_gallons ? quantity * 2000 : quantity / 2000, 2);
	      this.data.quantity_units = this.data.water_gallons ? "GALS" : "TONS";
	    }
	  }, {
	    key: "onDeliveryChange",
	    value: function onDeliveryChange() {
	      this.priceCalc.calc();
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var self = this;
	      if (self._submitting) {
	        return;
	      }
	      self._submitting = true;
	      var data = self.R.copy(self.data);
	      data.products = _lodash2.default.filter(data.products, function (o) {
	        return o.product;
	      }); // to avoid glitches
	      data.custom_fields_destinations = self.order.custom_fields_destinations;
	
	      data.put().then(function (response) {
	        _angular2.default.extend(self.order, response);
	        self.$modal.close(response);
	      }, function (resp) {
	        if (resp.status === 403) {
	          self.$growl.error(resp.data.detail);
	        } else {
	          Object.entries(resp.data).forEach(function (entry) {
	            var _entry = _slicedToArray(entry, 2),
	                field = _entry[0],
	                error = _entry[1];
	
	            error.forEach(function (err_msg) {
	              if ((typeof err_msg === "undefined" ? "undefined" : _typeof(err_msg)) === "object" && err_msg !== null) {
	                Object.entries(err_msg).forEach(function (list_entry) {
	                  self.$growl.error(field + ": " + list_entry);
	                });
	              } else {
	                self.$growl.error(field + ": " + err_msg);
	              }
	            });
	          });
	        }
	        self.errors = resp.data;
	      }).finally(function () {
	        self.loading = false;
	        self._submitting = false;
	      });
	    }
	  }, {
	    key: "isZoneEditable",
	    get: function get() {
	      return this.order.company.id === _constants.MARION_ID;
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Order #" + this.data.id + " - " + this.data.customer.title;
	    }
	  }]);
	
	  return EditOrderDetailsCtrl;
	}(_helpers.EditViewMap);
	
	var FilesCtrl = exports.FilesCtrl = ["$order", function FilesCtrl($order) {
	  "ngInject";
	
	  _classCallCheck(this, FilesCtrl);
	
	  this.order = $order;
	}];
	
	var NotesCtrl = exports.NotesCtrl = function (_BaseNotesCtrl) {
	  NotesCtrl.$inject = ["R", "$order", "$growl"];
	  _inherits(NotesCtrl, _BaseNotesCtrl);
	
	  function NotesCtrl(R, $order, $growl) {
	    "ngInject";
	
	    _classCallCheck(this, NotesCtrl);
	
	    return _possibleConstructorReturn(this, (NotesCtrl.__proto__ || Object.getPrototypeOf(NotesCtrl)).call(this, R, $growl, $order));
	  }
	
	  return NotesCtrl;
	}(_notes2.default);
	
	var LogCtrl = exports.LogCtrl = function LogCtrl() {
	  _classCallCheck(this, LogCtrl);
	};
	
	var PriceCalculation = function () {
	  function PriceCalculation(data, applicatorsConfig, companyFreightStore, nutrientPricesStore) {
	    _classCallCheck(this, PriceCalculation);
	
	    this.data = data;
	    this.haulerCost = 0.0;
	    this.fertTotalCost = 0.0;
	    this.totalProductsCost = 0.0;
	    this.enabledCalcForDelivery = true;
	
	    this.isCalculating = false;
	
	    this.applicatorsConfig = applicatorsConfig;
	    this.companyFreightStore = companyFreightStore;
	    this.nutrientPricesStore = nutrientPricesStore;
	
	    this.nutrientKeys = ["n", "k", "b", "z", "cu", "mn", "fe"];
	
	    this.nutrientsForSpecialPricing = _lodash2.default.clone(this.nutrientKeys);
	    this.nutrientsForSpecialPricing.push("p");
	    this.nutrientsForSpecialPricing.push("sulfur_dry");
	    this.initialize();
	  }
	
	  _createClass(PriceCalculation, [{
	    key: "initialize",
	    value: function initialize() {
	      this.applicatorsConfig.init();
	      this.companyFreightStore.init();
	      this.nutrientPricesStore.init();
	
	      this.applicatorsConfig.params.company = this.data.company.id;
	      this.companyFreightStore.params.company = this.data.company.id;
	      this.nutrientPricesStore.params = {
	        company: this.data.company.id,
	        price_level: this.data.customer.price_level,
	        ns_price_level: this.data.customer.non_standard_price_level,
	        customer: this.data.customer.id
	      };
	
	      var self = this;
	      this.applicatorsConfig.refresh().then(function () {
	        self.calcApplicatorCost();
	      });
	      this.companyFreightStore.refresh().then(function () {
	        self.calcApplicatorCost();
	      });
	    }
	  }, {
	    key: "calc",
	    value: function calc(calcOnlyChemicals) {
	      if (calcOnlyChemicals) {
	        this.calcProductsTotalCost();
	      }
	      this.calcApplicatorCost();
	      this.calcTotalCost();
	    }
	  }, {
	    key: "preview",
	    value: function preview() {
	      var self = this;
	      var nutrientsTotalCost = 0;
	
	      if (this.data.fertilizer_special_price) {
	        nutrientsTotalCost = self.data.fertilizer_special_price * self.data.quantity;
	      } else {
	        nutrientsTotalCost = _lodash2.default.sum(_lodash2.default.map(self.nutrientKeys, function (key) {
	          return self.nutrient_total_price(self.data.nutrients[key].price, self.data.nutrients[key].lbs);
	        }));
	      }
	
	      self.fertTotalCost = self.calcFertTotalCost(nutrientsTotalCost, self.data.applicator_price);
	
	      self.calcProductsTotalCost();
	    }
	  }, {
	    key: "price_per_lbs",
	    value: function price_per_lbs(price) {
	      return price / 20;
	    }
	  }, {
	    key: "nutrient_total_price",
	    value: function nutrient_total_price(nutrientPrice, nutrientLbs) {
	      return _lodash2.default.round(this.price_per_lbs(nutrientPrice) * nutrientLbs * this.data.acres, 2);
	    }
	  }, {
	    key: "calcPFactor",
	    value: function calcPFactor(lbs, price) {
	      var p_percentage_points = 100 - (this.data.base + this.data.nutrients.p3.percent);
	      return this.calcPXFactor(lbs, price, p_percentage_points);
	    }
	  }, {
	    key: "calcPXFactor",
	    value: function calcPXFactor(lbs, price, percentage_points) {
	      return _lodash2.default.round(lbs * this.price_per_lbs(price) * this.data.acres * percentage_points / 100, 2);
	    }
	  }, {
	    key: "calcSFactor",
	    value: function calcSFactor(lbs, price) {
	      var p_percentage_points = 100 - this.data.nutrients.s2.percent;
	      return this.calcPXFactor(lbs, price, p_percentage_points);
	    }
	  }, {
	    key: "calcSXFactor",
	    value: function calcSXFactor(lbs, price, percentage_points) {
	      return _lodash2.default.round(lbs * this.price_per_lbs(price) * this.data.acres * percentage_points / 100, 2);
	    }
	  }, {
	    key: "disableCalcForDelivery",
	    value: function disableCalcForDelivery() {
	      this.enabledCalcForDelivery = false;
	    }
	  }, {
	    key: "enableCalcForDelivery",
	    value: function enableCalcForDelivery() {
	      this.enabledCalcForDelivery = true;
	    }
	  }, {
	    key: "calcApplicatorCostDefault",
	    value: function calcApplicatorCostDefault() {
	      var self = this;
	      var freightZone = parseInt(self.data.freight_zone);
	      var freightZoneObj = _lodash2.default.find(this.companyFreightStore.list, function (obj) {
	        return obj.zone === freightZone;
	      });
	      var applicationObj = _lodash2.default.find(this.applicatorsConfig.list, function (obj) {
	        return obj.zone === 1 && obj.range === 1;
	      });
	
	      var freightZoneRate = freightZoneObj && freightZoneObj.rate || 0.0;
	      var applicationRate = applicationObj && applicationObj.rate || 0.0;
	
	      var freightCost = freightZoneRate; // Rate per ton
	      var applicationCost = self.data.acres * applicationRate / self.data.quantity; // Appl rate per ton
	
	      this.setApplicatorCost(freightCost, applicationCost);
	    }
	  }, {
	    key: "calcApplicatorCost",
	    value: function calcApplicatorCost() {
	      if (!this.enabledCalcForDelivery) {
	        this.setApplicatorCost(0, 0);
	        return;
	      }
	      this.calcApplicatorCostDefault();
	    }
	  }, {
	    key: "setApplicatorCost",
	    value: function setApplicatorCost(freightZoneRate, applicationRate) {
	      switch (this.data.delivery) {
	        case "apply_haul":
	          this.haulerCost = _lodash2.default.round(freightZoneRate + applicationRate, 3);
	          break;
	        case "haul":
	          this.haulerCost = _lodash2.default.round(freightZoneRate, 3);
	          break;
	        default:
	          this.haulerCost = 0;
	          break;
	      }
	    }
	  }, {
	    key: "calcFertTotalCost",
	    value: function calcFertTotalCost(nutrientsTotalCost, applHaulCost) {
	      var pCost = this.calcPFactor(this.data.nutrients.p.lbs, this.data.nutrients.p.price);
	      var p2Cost = this.calcPXFactor(this.data.nutrients.p.lbs, this.data.nutrients.p2.price, this.data.base);
	      var p3Cost = this.calcPXFactor(this.data.nutrients.p.lbs, this.data.nutrients.p3.price, this.data.nutrients.p3.percent);
	
	      var sCost = this.calcSFactor(this.data.nutrients.sulfur_dry.lbs, this.data.nutrients.sulfur_dry.price);
	      var s2Cost = this.calcSXFactor(this.data.nutrients.sulfur_dry.lbs, this.data.nutrients.s2.price, this.data.nutrients.s2.percent);
	
	      var totalCost = 0;
	      if (this.data.rate !== 0) {
	        var acresRate = this.data.acres / (2000 / this.data.rate);
	        totalCost = nutrientsTotalCost + pCost + p2Cost + p3Cost + sCost + s2Cost + acresRate * applHaulCost;
	      }
	
	      // Store information about p and p2 cost
	      if (this.data.nutrients) {
	        this.data.nutrients["p"]["total_price"] = pCost || 0;
	        this.data.nutrients["p2"]["total_price"] = p2Cost || 0;
	        this.data.nutrients["p3"]["total_price"] = p3Cost || 0;
	
	        this.data.nutrients["sulfur_dry"]["total_price"] = sCost || 0;
	        this.data.nutrients["s2"]["total_price"] = s2Cost || 0;
	      }
	
	      if (_lodash2.default.isNaN(totalCost)) {
	        return 0;
	      }
	      return totalCost;
	    }
	  }, {
	    key: "setZeroPriceForAllNutrients",
	    value: function setZeroPriceForAllNutrients() {
	      var self = this;
	      _lodash2.default.each(self.nutrientKeys, function (key) {
	        self.data.nutrients[key]["price"] = 0;
	      });
	      self.data.nutrients["p"]["price"] = 0;
	      self.data.nutrients["p2"]["price"] = 0;
	      self.data.nutrients["p3"]["price"] = 0;
	
	      this.data.nutrients["sulfur_dry"]["total_price"] = 0;
	      this.data.nutrients["s2"]["total_price"] = 0;
	    }
	  }, {
	    key: "getCurrentNutrientsValue",
	    value: function getCurrentNutrientsValue() {
	      var self = this;
	      return _lodash2.default.fromPairs(_lodash2.default.map(self.nutrientsForSpecialPricing, function (key) {
	        return [key, self.data.nutrients[key].percent];
	      }));
	    }
	  }, {
	    key: "calcTotalCost",
	    value: function calcTotalCost() {
	      var self = this;
	
	      this.isCalculating = true;
	
	      if (this.data.crop && this.data.crop.id) {
	        this.nutrientPricesStore.params.crop = this.data.crop.id;
	      }
	
	      // Gen current nutrients values
	      var nutrientValues = self.getCurrentNutrientsValue();
	      _lodash2.default.extend(this.nutrientPricesStore.params, nutrientValues);
	
	      this.nutrientPricesStore.refresh().then(function (obj) {
	        var nutrientsTotalCost = 0;
	        var nutrientPrices = obj.list;
	
	        if (_lodash2.default.has(nutrientPrices, "special_total_price")) {
	          nutrientsTotalCost = nutrientPrices.special_total_price * self.data.quantity;
	          self.data.fertilizer_special_price = nutrientPrices.special_total_price;
	          self.setZeroPriceForAllNutrients();
	        } else {
	          nutrientPrices = obj.list.nutrients;
	          self.data.price_level = _lodash2.default.toString(obj.list.price_level);
	          self.data.fertilizer_special_price = null;
	          nutrientsTotalCost = _lodash2.default.sum(_lodash2.default.map(self.nutrientKeys, function (key) {
	            var totalPrice = self.nutrient_total_price(nutrientPrices[key], self.data.nutrients[key].lbs);
	            self.data.nutrients[key]["price"] = nutrientPrices[key] || 0;
	            self.data.nutrients[key]["total_price"] = totalPrice;
	            return totalPrice;
	          }));
	
	          // Saving to database
	          self.data.nutrients["p"]["price"] = nutrientPrices.p || 0;
	          self.data.nutrients["p2"]["price"] = nutrientPrices.p2 || 0;
	          self.data.nutrients["p3"]["price"] = nutrientPrices.p3 || 0;
	
	          self.data.nutrients["sulfur_dry"]["price"] = nutrientPrices.sulfur_dry || 0;
	          self.data.nutrients["s2"]["price"] = nutrientPrices.s2 || 0;
	        }
	
	        self.data.applicator_price = self.haulerCost;
	        self.fertTotalCost = self.calcFertTotalCost(nutrientsTotalCost, self.haulerCost);
	      }).finally(function () {
	        self.isCalculating = false;
	        self.calcProductsTotalCost();
	      });
	    }
	  }, {
	    key: "calcProductsTotalCost",
	    value: function calcProductsTotalCost() {
	      this.totalProductsCost = _lodash2.default.sum(_lodash2.default.map(this.data.products, function (obj) {
	        return obj.total_price || 0.0;
	      }));
	    }
	  }]);
	
	  return PriceCalculation;
	}();

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseAddModal = function () {
	    BaseAddModal.$inject = ["$uibModalInstance", "store", "UserService"];
	    function BaseAddModal($uibModalInstance, store, UserService) {
	        "ngInject";
	
	        _classCallCheck(this, BaseAddModal);
	
	        this.data = {};
	        this.store = store;
	        this.$modal = $uibModalInstance;
	
	        if (UserService.$user.companies.length > 0) {
	            this.data.company = _lodash2.default.first(UserService.$user.companies);
	            if (UserService.$user.default_company) {
	                this.data.company = UserService.$user.companies.find(function (x) {
	                    return x.id === UserService.$user.default_company;
	                });
	            }
	        }
	    }
	
	    _createClass(BaseAddModal, [{
	        key: "close",
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: "submit",
	        value: function submit() {
	            var _this = this;
	
	            var self = this;
	            this.store.create(this.data).then(function (data) {
	                return _this.$modal.close(data);
	            }, function (response) {
	                self.errors = response.data;
	            });
	        }
	    }]);
	
	    return BaseAddModal;
	}();
	
	exports.default = BaseAddModal;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BaseReCalc = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseReCalc = exports.BaseReCalc = function () {
	    function BaseReCalc(object) {
	        _classCallCheck(this, BaseReCalc);
	
	        this.acresChanged = false;
	        this.object = object;
	    }
	
	    _createClass(BaseReCalc, [{
	        key: 'rate',
	        value: function rate() {
	            if (!this.canUpdateRate) {
	                return;
	            }
	            this.object.quantity = _lodash2.default.round(this.object.acres * this.object.rate / 2000, 3);
	            this._nutrients();
	        }
	    }, {
	        key: 'acres',
	        value: function acres() {
	            this.object.acres = _lodash2.default.round(this.object.acres, 3);
	            this.rate();
	            this.acresChanged = !this.acresChanged;
	        }
	    }, {
	        key: 'quantity',
	        value: function quantity() {
	            this.object.quantity = _lodash2.default.round(this.object.quantity, 3);
	            this.object.acres = _lodash2.default.round(this.object.quantity * 2000 / this.object.rate, 3);
	            if (_lodash2.default.isNaN(this.object.acres)) {
	                this.object.acres = 0;
	            }
	            this.acresChanged = !this.acresChanged;
	        }
	    }, {
	        key: '_nutrients',
	        value: function _nutrients() {}
	    }, {
	        key: 'canUpdateRate',
	        get: function get() {
	            return this.object.acres >= 0 && this.object.rate > 0;
	        }
	    }]);
	
	    return BaseReCalc;
	}();

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NotesCtrl = function () {
	    NotesCtrl.$inject = ["R", "$growl", "$object"];
	    function NotesCtrl(R, $growl, $object) {
	        "ngInject";
	
	        _classCallCheck(this, NotesCtrl);
	
	        this.$growl = $growl;
	
	        this.$object = $object;
	        this.data = R.copy(this.$object);
	    }
	
	    _createClass(NotesCtrl, [{
	        key: "submit",
	        value: function submit() {
	            var self = this;
	            this.data.patch({ notes: this.data.notes }).then(function (response) {
	                self.$object.notes = response.notes;
	                self.$growl.success('Notes saved!');
	            });
	        }
	    }]);
	
	    return NotesCtrl;
	}();
	
	exports.default = NotesCtrl;

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FREDERICK_ID = exports.FREDERICK_ID = 1;
	var MT_AIRY = exports.MT_AIRY = 2;
	var LYNCH = exports.LYNCH = 6;
	var MARION_ID = exports.MARION_ID = 8;
	var GREENWOOD = exports.GREENWOOD = 9;
	var GOOGLE_API_KEY = exports.GOOGLE_API_KEY = "AIzaSyDg8QgP1N5JQHdB7-fIriQN3qx_E8BBG7g";
	
	var roles = exports.roles = {
	  ADMIN: 1,
	  PLANT_MANAGER: 2,
	  SALESPERSON: 3,
	  APPLICATOR: 4,
	  SALES_MANAGEMENT: 5,
	  DISPATCHER: 6
	};

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label>Company</label>\n                    <blnd-company-picker ng-model=\"vm.data.company\" mode=\"edit\"\n                                         test-id=\"add-company-picker\" form-error></blnd-company-picker>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label>Customer</label>\n                    <blnd-customer-picker clear-on-change=\"true\" ng-model=\"vm.data.customer\" company=\"vm.data.company.id\" form-error></blnd-customer-picker>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-5\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Ship to</label>\n                    <div class=\"ship-to\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.ship_to_text\" data-testid=\"ship-to-edit\" form-error select-on-click/>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-5\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Ship to fields</label>\n                    <span class=\"text-primary\" fade-in=\"vm.acresStatus === 'updated'\" callback=\"vm.acresStatusCallback()\">Acres updated!</span>\n                    <span class=\"text-danger\" fade-in=\"vm.acresStatus === 'not-updated'\" callback=\"vm.acresStatusCallback()\">Acres not updated!</span>\n                    <div class=\"ship-to\">\n                        <blnd-ship-to ng-model=\"vm.data.fields\" customer=\"vm.data.customer\" data-testid=\"ship-to-fields-edit\" ng-change=\"vm.onAcresChange()\" mode=\"edit\"></blnd-ship-to>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-sm-2\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Ready</label>\n                    <blnd-datepicker ng-model=\"vm.data.ready\" data-testid=\"ready-edit\" mode=\"edit\"></blnd-datepicker>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-8\">\n                <div class=\"order-fields-page\">\n                    <div class=\"row\">\n                        <div class=\"col-sm-6\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Salesperson</label>\n                                <blnd-salesperson-picker ng-model=\"vm.data.sales_person\" data-testid=\"sales-person-edit\"></blnd-salesperson-picker>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-6\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Delivery</label>\n                                <blnd-delivery-picker data-testid=\"delivery-edit\"\n                                                      ng-change=\"vm.onDeliveryChange()\"\n                                                      data=\"vm.data\"\n                                                      ng-model=\"vm.data.delivery\"\n                                                      mode=\"edit\">\n                                </blnd-delivery-picker>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-6\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Applicators</label>\n                                <blnd-applicator-picker ng-model=\"vm.data.applicators\" company=\"vm.data.company\" data-testid=\"applicators-edit\" fieldname=\"applicator\" mode=\"edit\"></blnd-applicator-picker>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-6\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Haulers</label>\n                                <blnd-applicator-picker ng-model=\"vm.data.haulers\" company=\"vm.data.company\" data-testid=\"haulers-edit\" fieldname=\"hauler\" mode=\"edit\"></blnd-applicator-picker>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-1half\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">\n                                    Acres\n                                    <blnd-acres-control ng-model=\"vm.data.is_acres_touched\" ng-change=\"vm.onAcresTouchChange(isChanged)\"></blnd-acres-control>\n                                </label>\n                                <div class=\"input-group transparent\">\n                                    <input type=\"number\"\n                                           min=\"0\"\n                                           step=\"0.001\"\n                                           ng-model=\"vm.data.acres\"\n                                           data-testid=\"acres-edit\"\n                                           class=\"form-control\"\n                                           ng-change=\"vm.onAcresModelChange()\"\n                                           form-error blink select-on-click\n                                    >\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-1half\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Rate</label>\n                                <input type=\"number\"\n                                       min=\"0\"\n                                       ng-model=\"vm.data.rate\"\n                                       data-testid=\"rate-edit\"\n                                       form-error name=\"rate\"\n                                       class=\"form-control\"\n                                       ng-blur=\"vm.tRecalc.rate(); vm.recalculatePrice()\" blink select-on-click>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-3\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Quantity</label>\n                                <div class=\"form-group form-group-sm\">\n                                    <div class=\"input-group blnd-order-group\">\n                                        <input type=\"number\"\n                                               min=\"0\"\n                                               step=\"0.001\"\n                                               ng-model=\"vm.data.quantity\"\n                                               data-testid=\"quantity-edit\"\n                                               form-error class=\"form-control\"\n                                               ng-change=\"vm.onQuantityChange()\"\n                                               blink select-on-click >\n                                        <select class=\"form-control\"\n                                                ng-disabled=\"true\"\n                                                ng-model=\"vm.data.quantity_units\">\n                                            <option ng-value=\"'TONS'\">TONS</option>\n                                            <option ng-value=\"'GALS'\">GALS</option>\n                                        </select>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                     <div class=\"col-sm-2\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Base P2</label>\n                                <div class=\"form-group form-group-sm\">\n                                    <input type=\"number\"\n                                           min=\"0\"\n                                           max=\"100\"\n                                           step=\"0.01\"\n                                           ng-model=\"vm.data.base\"\n                                           data-testid=\"base-p2-edit\"\n                                           ng-blur=\"vm.recalculatePrice()\"\n                                           form-error select-on-click\n                                           class=\"form-control \" />\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-2\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">TFP P3</label>\n                                <div class=\"form-group form-group-sm\">\n                                    <input type=\"number\"\n                                           min=\"0\"\n                                           max=\"100\"\n                                           step=\"0.01\"\n                                           ng-model=\"vm.data.nutrients.p3.percent\"\n                                           data-testid=\"tfp-p3-edit\"\n                                           ng-blur=\"vm.recalculatePrice()\"\n                                           form-error select-on-click\n                                           class=\"form-control \" />\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-2\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">ATS S2</label>\n                                <div class=\"form-group form-group-sm\">\n                                    <input type=\"number\"\n                                           min=\"0\"\n                                           max=\"100\"\n                                           step=\"0.01\"\n                                           ng-model=\"vm.data.nutrients.s2.percent\"\n                                           data-testid=\"ats-s2-edit\"\n                                           ng-blur=\"vm.recalculatePrice()\"\n                                           form-error select-on-click\n                                           class=\"form-control \" />\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-1half\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Urea</label>\n                                <input type=\"number\"\n                                       min=\"0\"\n                                       max=\"100\"\n                                       step=\"0.01\"\n                                       ng-model=\"vm.data.nutrients.urea_dry.percent\"\n                                       data-testid=\"urea-edit\"\n                                       form-error select-on-click\n                                       class=\"form-control \" />\n                            </div>\n                        </div>\n                        <div class=\"col-sm-1half\" ng-if=\"vm.order.nutrients.potcarb\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Potcarb</label>\n                                <input type=\"number\"\n                                       min=\"0\"\n                                       max=\"100\"\n                                       step=\"0.01\"\n                                       ng-model=\"vm.data.nutrients.potcarb.percent\"\n                                       data-testid=\"potcarb-edit\"\n                                       form-error select-on-click\n                                       class=\"form-control \" />\n                            </div>\n                        </div>\n                        <div class=\"col-sm-1half\" ng-if=\"vm.order.nutrients.crn\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">CRN</label>\n                                <input type=\"number\"\n                                       min=\"0\"\n                                       max=\"100\"\n                                       step=\"0.01\"\n                                       ng-model=\"vm.data.nutrients.crn.percent\"\n                                       data-testid=\"crn-edit\"\n                                       form-error select-on-click\n                                       class=\"form-control \" />\n                            </div>\n                        </div>\n                        <div class=\"col-sm-1half\">\n                            <div class=\"form-group form-group-sm\">\n                                <label>Water</label>\n                                <div>\n                                    <input type=\"checkbox\" ng-model=\"vm.data.water_gallons\" data-testid=\"water-edit\" ng-change=\"vm.onWaterChange()\" form-error>\n                                </div>\n                            </div>\n                        </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <blnd-nutrients\n                                nutrient-re-calc=\"vm.nutrientReCalc\"\n                                ng-model=\"vm.data.nutrients\"\n                                show-prices=\"vm.showPrices\"\n                                errors=\"vm.errors.nutrients\"\n                                ng-change=\"vm.recalculatePrice()\"\n                                edit-mode=\"true\">\n                        </blnd-nutrients>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-sm-12\">\n                        <div>\n                            <blnd-products\n                                    ng-model=\"vm.data.products\"\n                                    acres=\"vm.data.acres\"\n                                    company=\"vm.data.company\"\n                                    customer=\"vm.data.customer\"\n                                    crop=\"vm.data.crop\"\n                                    acres-changed=\"vm.tRecalc.acresChanged\"\n                                    ng-change=\"vm.onProductUpdate(true)\"\n                                    errors=\"vm.errors.products\"\n                                    mode=\"edit\"\n                                    show-prices=\"true\"\n                                    has-errors=\"vm.saveDisabled\"\n                                    convert-to-pints=\"true\">\n                            </blnd-products>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-4\">\n                <div class=\"row\">\n                    <div class=\"col-sm-6\">\n                        <div class=\"form-group form-group-sm\">\n                            <label class=\"control-label\">Crop</label>\n                            <blnd-crop-picker ng-change=\"vm.recalculatePrice()\" ng-model=\"vm.data.crop\" data-testid=\"crop-edit\" form-error></blnd-crop-picker>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-6\">\n                        <div class=\"form-group form-group-sm\">\n                            <label class=\"control-label\">Yield Goal</label>\n                            <input type=\"text\" ng-model=\"vm.data.yield_goal\" class=\"form-control\" form-error select-on-click>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-sm-4\">\n                        <div class=\"form-group form-group-sm\">\n                            <label class=\"control-label\">Zone</label>\n                            <div>\n                                <input type=\"number\"\n                                       ng-model=\"vm.data.freight_zone\"\n                                       data-testid=\"zone-edit\"\n                                       class=\"form-control\"\n                                       ng-show=\"{disabled: !vm.isZoneEditable}\"\n                                       ng-disabled=\"!vm.isZoneEditable\"\n                                       form-error select-on-click>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-2\">\n                        <div class=\"form-group price-level form-group-sm\">\n                            <label class=\"control-label\">PL</label>\n                            <div class=\"form-control-static\">\n                                <span class=\"label label-default\" ng-bind=\"vm.data.price_level\"></span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-sm-2\">\n                        <div class=\"form-group form-group-sm\">\n                            <label class=\"control-label\">Company</label>\n                            <div>\n                                <blnd-company-picker ng-model=\"vm.data.company\" test-id=\"company-edit\"></blnd-company-picker>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <strong>Show on Estimate</strong>\n                        <div class=\"form-horizontal\">\n                            <div class=\"row col-md-6\">\n                            <div class=\"checkbox\">\n                                <label>\n                                    <input type=\"checkbox\" ng-model=\"vm.data.willard_reward\" form-error> Willard Rewards\n                                </label>\n                            </div>\n                            <div class=\"checkbox\">\n                                <label>\n                                    <input type=\"checkbox\" ng-model=\"vm.data.total_price\" form-error> Total Price\n                                </label>\n                            </div>\n                            </div>\n                            <div class=\"row col-md-6\">\n                            <div class=\"checkbox\">\n                                <label>\n                                   <input type=\"checkbox\" ng-model=\"vm.data.chemical_price\" form-error> Chemical Price\n                                </label>\n                            </div>\n                            <div class=\"checkbox\">\n                                <label>\n                                   <input type=\"checkbox\" ng-model=\"vm.data.per_ton_price\" form-error> Per Ton Pricing\n                                </label>\n                            </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row top-space\" ng-if=\"vm.showPrices\">\n                    <div class=\"col-md-12\">\n                        <strong>Costs</strong>\n                        <table class=\"table price-table\">\n                            <tbody>\n                                <tr>\n                                    <td class=\"title\">Apply & Haul:</td>\n                                    <td class=\"value\">${{ vm.priceCalc.haulerCost | number: 2 }}</td>\n                                </tr>\n                                <tr>\n                                    <td class=\"title\">P2:</td>\n                                    <td class=\"value\">${{ vm.data.nutrients.p2.price | number: 2 }}</td>\n                                </tr>\n                                <tr>\n                                    <td class=\"title\">P3:</td>\n                                    <td class=\"value\">${{ vm.data.nutrients.p3.price | number: 2 }}</td>\n                                </tr>\n                                <tr>\n                                    <td class=\"title\">S2:</td>\n                                    <td class=\"value\">${{ vm.data.nutrients.s2.price | number: 2 }}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n\n                <div class=\"row\" ng-class=\"{'top-space': !vm.showPrices}\">\n                    <div class=\"col-md-12\">\n                        <strong>Fertilizer Price</strong>\n                        <blnd-price-table\n                                fert-total-cost=\"vm.priceCalc.fertTotalCost\"\n                                is-calculating=\"vm.priceCalc.isCalculating\"\n                                data=\"vm.data\">\n                        </blnd-price-table>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <strong>Total Price</strong>\n                        <blnd-price-table\n                                fert-total-cost=\"vm.priceCalc.fertTotalCost\"\n                                product-total-cost=\"vm.priceCalc.totalProductsCost\"\n                                is-calculating=\"vm.priceCalc.isCalculating\"\n                                data=\"vm.data\">\n                        </blnd-price-table>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <section>\n            <h4 >Location </h4>\n            <!-- Google Maps -->\n            <div id=\"map\" style=\"height: 400px;\" class=\"w-100\"></div>\n        </section>\n    </div>\n    <div class=\"modal-footer\">\n        <div class=\"pull-left col-md-5\">\n            <blnd-chemical-program-picker ng-model=\"vm.data.chemical_program\"\n                                          acres=\"vm.data.acres\"\n                                          company=\"vm.data.company\"\n                                          customer=\"vm.data.customer\"\n                                          products=\"vm.data.products\">\n            </blnd-chemical-program-picker>\n        </div>\n        <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.showPrices = !vm.showPrices\">{{ vm.showPrices && 'Hide prices' || 'Show prices' }}</button>\n        <button class=\"btn btn-submit\" type=\"submit\" ng-disabled=\"vm.saveDisabled\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <label class=\"control-label\">Company</label>\n                <div>\n                    <blnd-company-picker ng-model=\"vm.data.company\" mode=\"edit\"\n                                         test-id=\"order-add-company-picker\" form-error></blnd-company-picker>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <label class=\"control-label\">Customer</label>\n                <div>\n                    <blnd-customer-picker clear-on-change=\"true\" ng-model=\"vm.data.customer\"\n                        company=\"vm.data.company.id\" form-error></blnd-customer-picker>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <br />\n                <label ng-if=\"vm.order.notes\" class=\"control-label\"><input id=\"copy-notes\" type=\"checkbox\" checked />\n                    Copy notes</label>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\" ng-disabled=\"vm.loading\">\n            Copy\n        </button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">\n            Cancel\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"form-horizontal create-ticket-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"col-md-12\">\n                    <h4>Left on Order</h4>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6\">Rate</label>\n                        <div class=\"col-sm-3\">\n                            <div class=\"form-control-static\"><span ng-bind=\"vm.order.rate\"></span></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6\">Quantity</label>\n                        <div class=\"col-sm-3\">\n                            <div class=\"form-control-static\"><span ng-bind=\"vm.tonnage_left\"></span>T</div>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6\">Acres</label>\n                        <div class=\"col-sm-3\">\n                            <div class=\"form-control-static\"><span ng-bind=\"vm.acres_left\"></span></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <h4>New Ticket</h4>\n                        <div class=\"form-group form-static\">\n                            <label class=\"control-label col-sm-6\">Rate</label>\n                            <div class=\"col-sm-3\">\n                                <div class=\"form-control-static\"><span ng-bind=\"vm.order.rate\"></span></div>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-sm-6\">Quantity</label>\n                            <div class=\"col-sm-4\">\n                                <input class=\"form-control\"\n                                       type=\"number\"\n                                       step=\"0.01\"\n                                       name=\"amount\"\n                                       ng-model=\"vm.data.tonnage\"\n                                       ng-blur=\"vm.touched=true;vm.calculateAcres()\"\n                                       form-error blink>\n                            </div>\n                        </div>\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-sm-6\">Acres</label>\n                            <div class=\"col-sm-4\">\n                                <input class=\"form-control\"\n                                       type=\"number\"\n                                       step=\"0.01\"\n                                       name=\"amount\"\n                                       ng-model=\"vm.data.acres\"\n                                       ng-blur=\"vm.touched=true;vm.calculateTonnage()\"\n                                       form-error blink/>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group ship-to-container\">\n                    <label class=\"control-label\">Ship To</label>\n                    <div class=\"ship-to\">\n                        <blnd-ship-to ng-model=\"vm.data.fields\" customer=\"vm.order.customer\" ng-change=\"vm.reCalculateAcres()\" mode=\"edit\"></blnd-ship-to>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group ship-to-container\">\n                    <label class=\"control-label\">Applicators</label>\n                    <div class=\"ship-to\">\n                        <blnd-applicator-picker ng-model=\"vm.data.applicators\" company=\"vm.order.company\" fieldname=\"applicator\" mode=\"edit\" type=\"one\"></blnd-applicator-picker>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group ship-to-container\">\n                    <label class=\"control-label\">Haulers</label>\n                    <div class=\"ship-to\">\n                        <blnd-applicator-picker ng-model=\"vm.data.haulers\" company=\"vm.order.company\" fieldname=\"hauler\" mode=\"edit\" type=\"one\"></blnd-applicator-picker>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row tickets-created\" ng-show=\"vm.ticketsCreated.length > 0\">\n            <div class=\"col-md-6\">\n                <h4>Tickets created:</h4>\n                <ul>\n                    <li ng-repeat=\"ticket in vm.ticketsCreated\">\n                         {{ ticket.title }} (<a ui-sref=\"r.in.top.tickets.detail({ticketId: ticket.id})\">open</a>)\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\" ladda=\"vm.loading\">Create and add another</button>\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit(true)\" ladda=\"vm.loading\">Create</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\">\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Email To</label>\n                    <input type=\"text\" class=\"form-control\" form-error ng-model=\"vm.data.email_to\" placeholder=\"plant_address_here@someplace.com\">\n                </div>\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Copy Salesperson</label>\n                    <input type=\"checkbox\" ng-model=\"vm.data.bcc_salesperson\">\n                </div>\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Subject</label>\n                    <input type=\"text\" class=\"form-control\" form-error ng-model=\"vm.data.subject\">\n                </div>\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Message</label>\n                    <textarea class=\"form-control\" form-error ng-model=\"vm.data.message\"></textarea>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\" ladda=\"vm.loading\" ng-bind=\"vm.btnLabel || 'Send'\"></button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PrinterListModalCtrl = exports.PrinterListModalCtrl = function () {
	    PrinterListModalCtrl.$inject = ["$uibModalInstance", "R", "company", "request", "PrinterStore"];
	    function PrinterListModalCtrl($uibModalInstance, R, company, request, PrinterStore) {
	        "ngInject";
	
	        _classCallCheck(this, PrinterListModalCtrl);
	
	        var self = this;
	
	        self.store = PrinterStore;
	        self.$modal = $uibModalInstance;
	        self.R = R;
	        self.loading = true;
	        self.sendingRequest = false;
	        self.selectedPrinter = null;
	        self.hasErrors = false;
	        self.errorMessage = '';
	        self.store.init();
	        self.store.params.company = company;
	        self.store.params.status = 'online';
	
	        self.store.refresh();
	        self.store.$promise.then(function () {
	            self.hasErrors = false;
	            self.errorMessage = '';
	        }, function (response) {
	            if (response.status === 403) {
	                self.hasErrors = true;
	                self.errorMessage = 'You are not connected to PrintNode, please connect first';
	            }
	        }).finally(function () {
	            return self.loading = false;
	        });
	
	        self.request = request;
	    }
	
	    _createClass(PrinterListModalCtrl, [{
	        key: 'resetErrors',
	        value: function resetErrors() {
	            this.hasErrors = false;
	            this.errorMessage = '';
	        }
	    }, {
	        key: 'selectPrinter',
	        value: function selectPrinter(id) {
	            if (this.selectedPrinter === id) {
	                // Unselect
	                this.selectedPrinter = null;
	                return;
	            }
	            this.selectedPrinter = id;
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'getEndpoint',
	        value: function getEndpoint(type, order) {
	            if (type === 'estimate') {
	                return order.all('estimate').all('print');
	            } else {
	                return order.all('form').all('print');
	            }
	        }
	    }, {
	        key: 'getPromise',
	        value: function getPromise(order) {
	            var self = this;
	
	            var endpoint = this.getEndpoint(self.request.type, order);
	            return endpoint.post(_.extend({
	                printer: self.selectedPrinter
	            }), self.request.params || {});
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	
	            if (self.request.multiple) {
	                this.submitMultiple();
	            } else {
	                this.submitOne();
	            }
	        }
	    }, {
	        key: 'submitOne',
	        value: function submitOne() {
	            var self = this;
	
	            self.resetErrors();
	            self.sendingRequest = true;
	            self.request.endpoint.post(_.extend({
	                printer: self.selectedPrinter
	            }), self.request.params || {}).then(function () {
	                self.$modal.close(true);
	            }, function (response) {
	                if (response.status === 403) {
	                    self.hasErrors = true;
	                    self.errorMessage = 'Looks like you are not connected to PrintNode. Please contact administrator';
	                }
	            }).finally(function () {
	                return self.sendingRequest = false;
	            });
	        }
	    }, {
	        key: 'getInitialButtonState',
	        value: function getInitialButtonState(orderId) {
	            return {
	                id: orderId,
	                status: 'sending',
	                class: { 'btn-primary': true, 'btn-success': false, 'btn-danger': false },
	                msg: 'Order ' + orderId + ': Sending',
	                loading: true
	            };
	        }
	    }, {
	        key: 'getSuccessButtonState',
	        value: function getSuccessButtonState(orderId) {
	            return {
	                id: orderId,
	                status: 'success',
	                class: { 'btn-primary': false, 'btn-success': true, 'btn-danger': false },
	                msg: 'Order ' + orderId + ': Success!'
	            };
	        }
	    }, {
	        key: 'getErrorButtonState',
	        value: function getErrorButtonState(orderId) {
	            return {
	                id: orderId,
	                status: 'error',
	                class: { 'btn-primary': false, 'btn-success': false, 'btn-danger': true },
	                msg: 'Order ' + orderId + ': Error occured!'
	            };
	        }
	    }, {
	        key: 'canModalBeClosed',
	        value: function canModalBeClosed() {
	            var self = this;
	
	            var statusArr = Object.values(self.sendStatus).map(function (item) {
	                return item.status;
	            });
	            return statusArr.every(function (item) {
	                return item === 'success';
	            });
	        }
	    }, {
	        key: 'submitMultiple',
	        value: function submitMultiple() {
	            var self = this;
	
	            self.resetErrors();
	            self.sendingRequest = true;
	            if (self.request.orders && self.request.type) {
	                self.sendStatus = {};
	                angular.forEach(self.request.orders, function (order) {
	                    self.sendStatus[order.id] = self.getInitialButtonState(order.id);
	                    self.oneOrder = Object.keys(self.sendStatus).length === 1;
	                    self.getPromise(order).then(function () {
	                        self.sendStatus[order.id] = self.getSuccessButtonState(order.id);
	                    }, function (response) {
	                        self.sendStatus[order.id] = self.getErrorButtonState(order.id);
	                        if (response.status === 403) {
	                            // Google Cloud Print message
	                        }
	                    }).finally(function () {
	                        self.sendingRequest = false;
	                        self.sendStatus[order.id].loading = false;
	                        if (self.canModalBeClosed()) {
	                            self.$modal.close(Object.keys(self.sendStatus).length);
	                        }
	                    });
	                });
	            }
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Select Printer';
	        }
	    }]);
	
	    return PrinterListModalCtrl;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)))

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <button\n        type=\"button\"\n        class=\"close\"\n        data-dismiss=\"modal\"\n        aria-label=\"Close\"\n        ng-click=\"vm.close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n</div>\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <div class=\"col-md-12\" ng-if=\"vm.loading\">\n            <div class=\"text-center\">\n                <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\n                <span class=\"sr-only\">Loading...</span>\n            </div>\n        </div>\n\n        <div class=\"col-md-12\" ng-if=\"!vm.loading\">\n            <ul class=\"list-unstyled printers\" ng-if=\"vm.store.list.length > 0\">\n                <li ng-repeat=\"printer in vm.store.list\"\n                    ng-class=\"{'selected': vm.selectedPrinter === printer.id}\"\n                    ng-click=\"vm.selectPrinter(printer.id)\">\n                    <div class=\"icon-container\">\n                        <i class=\"fa fa-print\" aria-hidden=\"true\"></i>\n                    </div>\n                    <div class=\"printer-container\">\n                        <div class=\"printer-info\">{{ printer.display_name || printer.name }}</div>\n                    </div>\n                </li>\n            </ul>\n            <p ng-if=\"vm.store.list.length === 0\">No printer available</p>\n            <div ng-if=\"vm.hasErrors\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <div class=\"alert alert-warning\">\n                            {{ vm.errorMessage }}\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div>\n                <div class=\"order-button-container\">\n                    <div ng-repeat=\"(key, value) in vm.sendStatus\" class=\"order-button\" ng-class=\"{'w-100': vm.oneOrder, 'w-50': !vm.oneOrder}\">\n                        <button\n                            class=\"btn\"\n                            ng-class=\"value.class\"\n                            ladda=\"value.loading\"\n                            type=\"button\"\n                            data-style=\"{{ $index % 2 === 0 ? 'expand-left' : 'expand-right'}}\">{{ value.msg }}\n                                <i ng-if=\"value.status === 'success'\" class=\"fa fa-check\" aria-hidden=\"true\"></i>\n                                <i ng-if=\"value.status === 'error'\" class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-submit\"\n            ng-disabled=\"vm.selectedPrinter === null\"\n            type=\"button\"\n            ladda=\"vm.sendingRequest\"\n            ng-click=\"vm.submit()\">Print</button>\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n</div>\n"

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var stateFilters = exports.stateFilters = {
	    all: 'Select Status',
	    open: 'Open',
	    closed: 'Closed',
	    ready: 'Ready',
	    trashed: 'Trashed'
	};
	
	var DISABLED_DELIVERY_RANGE = exports.DISABLED_DELIVERY_RANGE = [3400, 3450];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EditViewMap = exports.DetailViewMap = exports.MapClass = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _jsApiLoader = __webpack_require__(548);
	
	var _constants = __webpack_require__(538);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var F = (_dec = (0, _decorators.Module)({
	    name: 'app.helpers',
	    modules: []
	}), _dec2 = (0, _decorators.Factory)('BlndHelpers', ["$q", function ($q) {
	    "ngInject";
	
	    return {
	        all: function all(promises) {
	            var deferred = $q.defer();
	            var results = _.fromPairs(_.map(promises, function (v, k) {
	                return [k, null];
	            }));
	            var callback = function callback(name) {
	                return function (resp) {
	                    var nulls;
	                    results[name] = resp;
	                    nulls = _.filter(results, function (v) {
	                        return v === null;
	                    });
	                    if (nulls.length === 0) {
	                        deferred.resolve(results);
	                    }
	                };
	            };
	            _.each(promises, function (v, k) {
	                v.then(callback(k), callback(k));
	            });
	            return deferred.promise;
	        }
	    };
	}]), _dec(_class = _dec2(_class = function F() {
	    _classCallCheck(this, F);
	}) || _class) || _class);
	
	// Google Maps Api
	
	exports.default = F;
	
	var MapClass = exports.MapClass = function () {
	    function MapClass(object) {
	        _classCallCheck(this, MapClass);
	
	        this.object = object;
	        this.markers = [];
	        this.map = null;
	        this.getStaticLocations();
	        this.prepareMap();
	    }
	
	    _createClass(MapClass, [{
	        key: 'getDynamicLocations',
	        value: function getDynamicLocations(fields) {
	            /*
	            Returns chosen fields locations in editModal.
	            */
	            this.getLocations(fields);
	        }
	    }, {
	        key: 'getStaticLocations',
	        value: function getStaticLocations() {
	            /*
	            Returns object locations saved in db.
	            */
	            this.getLocations(this.object.fields);
	        }
	    }, {
	        key: 'getLocations',
	        value: function getLocations(fields) {
	            /*
	            Creates locations list of dicts with parameters to compose map,
	            markers and template for google maps.
	             *loc - object's custom fields destinations if set, else location of
	                fields destination
	             If fields are not set or doesn't have location
	            function returns geoLocation of Willardag Freederick
	            */
	            var self = this;
	            var locations = [];
	            self.noMarkers = false;
	            fields.forEach(function (field, index) {
	                var geo = field.field.geo;
	                if (geo.latitude && geo.longitude && field.field.location) {
	                    // if object has custom geoLocations returns it instead of original
	                    var field_full_name = field.field.farm_name + ': ' + field.field.field_name + ' - ' + field.field.acres;
	                    if (field.field.id in self.object.custom_fields_destinations) {
	                        var custom_loc = self.object.custom_fields_destinations[field.field.id];
	                        locations.push({
	                            loc: custom_loc,
	                            field_id: field.field.id,
	                            full_string: index + 1 + '. (' + custom_loc.lat + ', ' + custom_loc.lng + ') [' + field_full_name + ']'
	                        });
	                    } else {
	                        locations.push({
	                            loc: { lat: geo.latitude, lng: geo.longitude },
	                            field_id: field.field.id,
	                            full_string: index + 1 + '. ' + field.field.location + ' [' + field_full_name + ']'
	                        });
	                    }
	                }
	            });
	            if (!locations.length) {
	                self.noMarkers = true;
	                locations = [{
	                    loc: { lat: 39.411136, lng: -77.402671 },
	                    field_id: null,
	                    full_string: ""
	                }];
	            }
	            self.varLocations = locations;
	        }
	    }, {
	        key: 'prepareMap',
	        value: function prepareMap() {
	            var self = this;
	            self.loader = new _jsApiLoader.Loader({
	                apiKey: _constants.GOOGLE_API_KEY,
	                libraries: ["places"],
	                version: "weekly"
	            });
	            self.loader.load().then(function () {
	                self.map = new google.maps.Map(document.getElementById("map"), {
	                    zoom: 9,
	                    center: self.varLocations[0].loc
	                });
	            });
	        }
	    }]);
	
	    return MapClass;
	}();
	
	var DetailViewMap = exports.DetailViewMap = function (_MapClass) {
	    _inherits(DetailViewMap, _MapClass);
	
	    function DetailViewMap(object) {
	        _classCallCheck(this, DetailViewMap);
	
	        var _this = _possibleConstructorReturn(this, (DetailViewMap.__proto__ || Object.getPrototypeOf(DetailViewMap)).call(this, object));
	
	        _this.updateMarkers();
	        return _this;
	    }
	
	    _createClass(DetailViewMap, [{
	        key: 'updateMarkers',
	        value: function updateMarkers() {
	            var self = this;
	            self.loader.load().then(function () {
	                self.markers.forEach(function (marker) {
	                    marker.setMap(null);
	                });
	                self.map.setCenter(self.varLocations[0].loc);
	                if (!self.noMarkers) {
	                    self.varLocations.forEach(function (location) {
	                        var marker = new google.maps.Marker({
	                            position: location.loc,
	                            map: self.map,
	                            label: { text: location.full_string, color: "white", className: "custom-marker" }
	                        });
	                        self.markers.push(marker);
	                    });
	                }
	            });
	        }
	    }]);
	
	    return DetailViewMap;
	}(MapClass);
	
	var EditViewMap = exports.EditViewMap = function (_MapClass2) {
	    _inherits(EditViewMap, _MapClass2);
	
	    function EditViewMap(object) {
	        _classCallCheck(this, EditViewMap);
	
	        var _this2 = _possibleConstructorReturn(this, (EditViewMap.__proto__ || Object.getPrototypeOf(EditViewMap)).call(this, object));
	
	        _this2.updateMarkers();
	        return _this2;
	    }
	
	    _createClass(EditViewMap, [{
	        key: 'updateMarkers',
	        value: function updateMarkers() {
	            var self = this;
	            self.loader.load().then(function () {
	                self.markers.forEach(function (marker) {
	                    marker.setMap(null);
	                });
	                self.map.setCenter(self.varLocations[0].loc);
	                if (!self.noMarkers) {
	                    self.varLocations.forEach(function (location) {
	                        var marker = new google.maps.Marker({
	                            position: location.loc,
	                            map: self.map,
	                            draggable: true,
	                            label: { text: location.full_string, color: "white", className: "custom-marker" }
	                        });
	                        marker.addListener("dragend", function () {
	                            var latValue = marker.getPosition().lat().toFixed(6);
	                            var lngValue = marker.getPosition().lng().toFixed(6);
	                            self.object.custom_fields_destinations[location.field_id] = {
	                                lat: parseFloat(latValue),
	                                lng: parseFloat(lngValue)
	                            };
	                        });
	                        self.markers.push(marker);
	                    });
	                }
	            });
	        }
	    }]);
	
	    return EditViewMap;
	}(MapClass);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)))

/***/ }),
/* 548 */,
/* 549 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BillingCtrl = function BillingCtrl($order) {
	    "ngInject";
	
	    _classCallCheck(this, BillingCtrl);
	
	    this.order = $order;
	};
	BillingCtrl.$inject = ["$order"];
	
	exports.default = BillingCtrl;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.order',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('OrderStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('orders');
	        _this.resetParams();
	        return _this;
	    }
	
	    _createClass(Store, [{
	        key: 'resetParams',
	        value: function resetParams() {
	            this.params = _angular2.default.copy(this.defaultParams || {});
	        }
	    }]);
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _react = __webpack_require__(552);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * `CustomerStore` now delegates to the shared REST resource store from
	 * `frontend/react` (see `resourceStore.ts`) instead of Restangular, so the
	 * exact same `customers` collection/list state (list/count/loading/params) is
	 * readable and writable from BOTH AngularJS and React.
	 *
	 * One behavioural difference: `get`/`create`/`update` now return plain data
	 * objects instead of "live" Restangular elements, so they no longer have
	 * `.put()`/`.remove()` methods on them directly - use `CustomerStore.update(id, data)`
	 * / `CustomerStore.remove(id)` instead (see `customers/ctrls.js` EditInfoCtrl).
	 */
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.customer',
	    modules: [_resource2.default, _react2.default]
	}), _dec2 = (0, _decorators.Service)('CustomerStore'), _dec(_class = _dec2(_class = function () {
	    Store.$inject = ["$q", "R", "ReactBridge"];
	    function Store($q, R, ReactBridge) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        this.$q = $q;
	        this.R = R;
	        this.resourceStore = ReactBridge().getResourceStore('customers');
	    }
	
	    // Re-wraps a plain data object (as returned by the shared Zustand
	    // resourceStore) into a Restangular element, so legacy consumers that
	    // expect `.all()`/`.one()`/`.put()`/`.remove()` (e.g. `blnd-activity`
	    // via `ActivityStore.getNew(object)`, which calls `object.all('activity')`)
	    // keep working exactly as before.
	
	
	    _createClass(Store, [{
	        key: 'restangularize',
	        value: function restangularize(obj) {
	            return this.R.restangularizeElement(null, obj, 'customers');
	        }
	
	        // Live getters/setters backed directly by the shared Zustand store state
	        // (rather than a mirrored copy) so external direct assignment - e.g.
	        // `BlndTable` does `self.store.params = requestParams;` - stays in sync
	        // with what `refresh()`/`loadMore()` actually read.
	
	    }, {
	        key: 'resetParams',
	        value: function resetParams() {
	            this.resourceStore.getState().resetParams();
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            this.resourceStore.getState().init();
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            var _this = this;
	
	            return this.$q.when(this.resourceStore.getState().refresh()).then(function () {
	                return _this;
	            });
	        }
	    }, {
	        key: 'loadMore',
	        value: function loadMore() {
	            var _this2 = this;
	
	            return this.$q.when(this.resourceStore.getState().loadMore()).then(function () {
	                return _this2;
	            });
	        }
	    }, {
	        key: 'get',
	        value: function get(id, params) {
	            var _this3 = this;
	
	            return this.$q.when(this.resourceStore.getState().get(_lodash2.default.toString(id), params)).then(function (data) {
	                return _this3.restangularize(data);
	            });
	        }
	    }, {
	        key: 'create',
	        value: function create(data) {
	            return this.$q.when(this.resourceStore.getState().create(data));
	        }
	    }, {
	        key: 'update',
	        value: function update(id, data) {
	            return this.$q.when(this.resourceStore.getState().update(_lodash2.default.toString(id), data));
	        }
	    }, {
	        key: 'remove',
	        value: function remove(id) {
	            return this.$q.when(this.resourceStore.getState().remove(_lodash2.default.toString(id)));
	        }
	    }, {
	        key: 'list',
	        get: function get() {
	            return this.resourceStore.getState().list;
	        }
	    }, {
	        key: 'count',
	        get: function get() {
	            return this.resourceStore.getState().count;
	        }
	    }, {
	        key: 'loading',
	        get: function get() {
	            return this.resourceStore.getState().loading;
	        }
	    }, {
	        key: 'isEmpty',
	        get: function get() {
	            return this.resourceStore.getState().isEmpty;
	        }
	    }, {
	        key: 'params',
	        get: function get() {
	            return this.resourceStore.getState().params;
	        },
	        set: function set(value) {
	            this.resourceStore.setState({ params: value });
	        }
	    }]);
	
	    return Store;
	}()) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _token = __webpack_require__(499);
	
	var _token2 = _interopRequireDefault(_token);
	
	var _config = __webpack_require__(504);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AngularJS <-> React integration layer.
	 *
	 * The modern React code is built separately (see `frontend/react`) into a
	 * global `window.ReactBridge`. This module lets the legacy AngularJS shell:
	 *
	 *   1. Mount a React view into any element:
	 *        <div react-view="hello" props="vm.someData"></div>
	 *      and cleanly unmount it when the Angular scope is destroyed.
	 *
	 *   2. Keep AngularJS in sync with the shared vanilla Zustand store, so state
	 *      changes made in React trigger an Angular digest.
	 *
	 *   3. Give the shared REST resource stores (`ReactBridge().getResourceStore`)
	 *      access to the auth token + 401 handling, so they can talk to the API
	 *      exactly like the legacy Restangular-based stores did.
	 */
	
	var MODULE = 'app.react';
	
	_angular2.default.module(MODULE, [_token2.default.$angularModule.name, _config2.default.$angularModule.name]).config(["$provide", function ($provide) {
	  'ngInject';
	
	  $provide.decorator('$exceptionHandler', ["$delegate", function ($delegate) {
	    'ngInject';
	
	    return function (exception, cause) {
	      if (window.ReactBridge) {
	        window.ReactBridge.captureException(exception);
	      }
	      $delegate(exception, cause);
	    };
	  }]);
	}])
	
	// Thin accessor so the rest of the Angular app can inject the bridge/store
	// instead of reaching for the window global directly.
	.factory('ReactBridge', function () {
	  'ngInject';
	
	  return function getBridge() {
	    if (!window.ReactBridge) {
	      throw new Error('[app.react] window.ReactBridge is not loaded. ' + 'Ensure /react-bridge/bridge.js is included in index.html and built ' + '(cd frontend/react && yarn build).');
	    }
	    return window.ReactBridge;
	  };
	})
	
	/**
	 * Wrapper directive that mounts a React route into its host element.
	 *
	 * Usage:
	 *   <div react-view="hello"></div>
	 *   <div react-view="hello" props="vm.data"></div>
	 */
	.directive('reactView', ["ReactBridge", function (ReactBridge) {
	  'ngInject';
	
	  return {
	    restrict: 'A',
	    scope: {
	      route: '@reactView',
	      props: '<?'
	    },
	    link: function link(scope, element) {
	      var host = element[0];
	
	      function render() {
	        ReactBridge().mount(host, scope.route, scope.props || {});
	      }
	
	      render();
	
	      // Re-render React when the passed-in props change.
	      scope.$watch('props', render, true);
	
	      // React 18 needs an explicit unmount to avoid leaking the tree.
	      scope.$on('$destroy', function () {
	        if (window.ReactBridge) {
	          window.ReactBridge.unmount(host);
	        }
	      });
	    }
	  };
	}])
	
	/**
	 * Connector: when the shared store changes (e.g. from a React component),
	 * schedule an Angular digest so any Angular bindings reflecting that state
	 * update. `$applyAsync` coalesces bursts of updates into a single digest.
	 */
	.run(["$rootScope", function ($rootScope) {
	  'ngInject';
	
	  if (window.ReactBridge && window.ReactBridge.store) {
	    window.ReactBridge.store.subscribe(function () {
	      $rootScope.$applyAsync();
	    });
	  }
	}])
	
	/**
	 * Give the shared REST resource stores (`ReactBridge().getResourceStore`)
	 * the same auth token + 401 handling the legacy Restangular `R` factory
	 * uses (see `app/resource.js`), so they can talk to the API identically.
	 */
	.run(["$state", "TokenService", "Config", function ($state, TokenService, Config) {
	  'ngInject';
	
	  if (window.ReactBridge) {
	    window.ReactBridge.configureResourceAuth({
	      getToken: function getToken() {
	        return TokenService.get();
	      },
	      isApiV2Enabled: function isApiV2Enabled() {
	        return Config.isFeatureFlagActive('ENABLE_API_V2', false);
	      },
	      onUnauthorized: function onUnauthorized() {
	        TokenService.clear();
	        $state.go('r.login', { force: true });
	      }
	    });
	  }
	}])
	
	/**
	 * Seamless SPA navigation handler for React components.
	 * When React calls `window.ReactBridge.navigate(url)`, update Angular's
	 * $location and trigger a digest so UI-Router transitions cleanly without page reload.
	 */
	.run(["$location", "$rootScope", "$state", function ($location, $rootScope, $state) {
	  'ngInject';
	
	  if (window.ReactBridge) {
	    window.ReactBridge.replaceUrl = function (url) {
	      $rootScope.$evalAsync(function () {
	        var params = _angular2.default.copy($state.params);
	        Object.keys($location.search()).forEach(function (key) {
	          delete params[key];
	        });
	        $location.url(url);
	        _angular2.default.extend(params, $location.search());
	        $state.go($state.current.name, params, {
	          notify: false,
	          location: 'replace',
	          inherit: false
	        });
	      });
	    };
	    window.ReactBridge.navigate = function (url) {
	      $rootScope.$applyAsync(function () {
	        $location.url(url);
	      });
	    };
	  }
	}]);
	
	exports.default = MODULE;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.applicatorConfig',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('ApplicatorConfigStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('applicators-config');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.companyFreight',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('CompanyFreightStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('company-freights');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NutrientStore = (_dec = (0, _decorators.Module)({
	    name: 'app.store.nutrientPrices',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('NutrientPricesStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    NutrientStore.$inject = ["$q", "R"];
	    _inherits(NutrientStore, _BaseStore);
	
	    function NutrientStore($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, NutrientStore);
	
	        var _this = _possibleConstructorReturn(this, (NutrientStore.__proto__ || Object.getPrototypeOf(NutrientStore)).call(this, $q, R));
	
	        _this.endpoint = _this.R.one('nutrients-price');
	        return _this;
	    }
	
	    _createClass(NutrientStore, [{
	        key: 'refresh',
	        value: function refresh() {
	            var self = this;
	            this.loading = true;
	
	            return this.endpoint.get(this.params).then(function (data) {
	                self.list = data;
	                return self;
	            }).finally(function () {
	                self.loading = false;
	            });
	        }
	    }]);
	
	    return NutrientStore;
	}(_base2.default)) || _class) || _class);
	exports.default = NutrientStore;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.file',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('FileStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('files');
	        return _this;
	    }
	
	    _createClass(Store, [{
	        key: 'refresh',
	        value: function refresh() {
	            var self = this;
	            return self._refresh().then(function (data) {
	                var _self$list;
	
	                (_self$list = self.list).push.apply(_self$list, _toConsumableArray(data));
	                return self;
	            });
	        }
	    }]);
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.printer',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('PrinterStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('printers');
	        return _this;
	    }
	
	    _createClass(Store, [{
	        key: 'remove',
	        value: function remove() {
	            return this.endpoint.remove();
	        }
	    }]);
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.fadeout"
	}), _dec2 = (0, _decorators.Directive)('fadeIn', ["$timeout", "$animate", function ($timeout, $animate) {
	    "ngInject";
	
	    return {
	        restrict: 'A',
	        scope: {
	            fadeIn: '=',
	            callback: '&'
	        },
	        link: function linkingFunction(scope, element) {
	            var classes = 'fadein-start animated fade-in';
	            var watcher = scope.$watch('fadeIn', function watchFunction(value) {
	                if (value) {
	                    var $promise = $animate.addClass(element, classes);
	                    if (scope.callback) {
	                        $promise.then(scope.callback);
	                    }
	                } else {
	                    $animate.removeClass(element, 'fade-in');
	                }
	            });
	
	            scope.$on('$destroy', function () {
	                watcher();
	            });
	        }
	    };
	}]), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(366);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _decorators = __webpack_require__(331);
	
	var _blndDatepickerTpl = __webpack_require__(560);
	
	var _blndDatepickerTpl2 = _interopRequireDefault(_blndDatepickerTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.datepicker"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-datepicker',
	    bindings: {
	        ngModel: '=',
	        mode: '@?'
	    },
	    template: _blndDatepickerTpl2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$element"];
	    function C($element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$element = $element;
	        this.opened = false;
	        this.mode = this.mode || 'view';
	        this.options = _angular2.default.extend({
	            startingDay: 1
	        }, {});
	
	        if (this.ngModel !== null && _angular2.default.isDefined(this.ngModel) && !_angular2.default.isDate(this.ngModel)) {
	            this.ngModel = new Date(this.ngModel);
	        }
	    }
	
	    _createClass(C, [{
	        key: 'open',
	        value: function open() {
	            this.opened = true;
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.$element.remove();
	            this.$element = null;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"blnd-datepicker\" ng-if=\"$ctrl.mode == 'view'\">\n    {{ $ctrl.ngModel | blndDate }}\n</div>\n<div class=\"blnd-datepicker\" ng-if=\"$ctrl.mode == 'edit'\">\n    <div class=\"input-group\">\n        <input type=\"text\"\n              class=\"form-control\"\n              uib-datepicker-popup=\"MM/dd/yy\"\n              ng-model=\"$ctrl.ngModel\"\n              is-open=\"$ctrl.opened\"\n              datepicker-options=\"config\"\n              close-text=\"Close\" />\n        <span class=\"input-group-btn\">\n           <button type=\"button\"\n                   class=\"btn btn-default\"\n                   ng-click=\"$ctrl.open()\">\n             <i class=\"glyphicon glyphicon-calendar\"></i>\n           </button>\n        </span>\n    </div>\n</div>\n"

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class; // WARNING: Order of imports is important!
	
	
	__webpack_require__(330);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(366);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(562);
	
	__webpack_require__(563);
	
	var _decorators = __webpack_require__(331);
	
	var _utils = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function isMomentEqual(date1, date2) {
	    if (_moment2.default.isMoment(date1) && _moment2.default.isMoment(date2)) {
	        return date1.isSame(date2, 'day');
	    } else {
	        return date1 === date2;
	    }
	}
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.daterangepicker",
	    modules: ['daterangepicker']
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-date-range-picker',
	    bindings: {
	        ngModel: '=',
	        ngChange: '&?',
	        format: '@?'
	    },
	    template: '<input\n            placeholder="No Dates Selected"\n            class="form-control date-picker"\n            type="text"\n            ng-change="$ctrl.onChange"\n            date-range-picker options="$ctrl.options" ng-model="$ctrl.date"/>',
	    link: function link(scope, element, attrs) {
	        scope.$on('$destroy', function () {
	            element.remove();
	        });
	    }
	}), _dec(_class = _dec2(_class = function () {
	    D.$inject = ["$scope", "$timeout"];
	    function D($scope, $timeout) {
	        "ngInject";
	
	        _classCallCheck(this, D);
	
	        var self = this;
	        self.$timeout = $timeout;
	        self.format = self.format || 'object'; // can be 'string'
	
	        self.options = {
	            opens: "left",
	            ranges: {
	                'This Week': [(0, _moment2.default)().startOf('week'), (0, _moment2.default)().endOf('week')],
	                'This Month': [(0, _moment2.default)().startOf('month'), (0, _moment2.default)().endOf('month')],
	                'This Year': [(0, _moment2.default)().startOf('year'), (0, _moment2.default)().endOf('year')]
	            },
	            locale: {
	                format: 'MM/DD/YYYY'
	            }
	        };
	        var watcher = $scope.$watch('$ctrl.date', function (newV, oldV) {
	            oldV = oldV || { startDate: null, endDate: null };
	            newV = newV || { startDate: null, endDate: null };
	            if (!(isMomentEqual(newV.startDate, oldV.startDate) && isMomentEqual(newV.endDate, oldV.endDate))) {
	                var newNgModel = self.fromPickerFormat(newV);
	
	                if (self.ngModel != newNgModel) {
	                    self.ngModel = self.fromPickerFormat(newV);
	                    self.$timeout(function () {
	                        self.ngChange && self.ngChange(newV, oldV);
	                    });
	                }
	            }
	        });
	
	        $scope.$watch('$ctrl.ngModel', function (newV, oldV) {
	            self.date = self.toPickerFormat(newV);
	        });
	
	        $scope.$on('$destroy', function () {
	            watcher();
	            watcher = null;
	        });
	    }
	
	    _createClass(D, [{
	        key: 'fromPickerFormat',
	        value: function fromPickerFormat(dates) {
	            if (!dates || !dates.startDate || !dates.endDate) {
	                return '';
	            }
	            if (this.format === 'string') {
	                dates = (0, _utils.toDR)(dates);
	            }
	            return dates;
	        }
	    }, {
	        key: 'toPickerFormat',
	        value: function toPickerFormat(dates) {
	            if (!dates) {
	                return {
	                    startDate: null,
	                    endDate: null
	                };
	            }
	
	            if (this.format === 'string') {
	                dates = (0, _utils.fromDR)(dates);
	            }
	
	            return dates;
	        }
	    }]);
	
	    return D;
	}()) || _class) || _class);
	exports.default = D;

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fromDR = fromDR;
	exports.toDR = toDR;
	
	var _moment = __webpack_require__(366);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fromDR(dr) {
	    var dates = dr.split(',');
	    return {
	        startDate: (0, _moment2.default)(dates[0]),
	        endDate: (0, _moment2.default)(dates[1])
	    };
	}
	
	function toDR(dates) {
	    var startDate = dates.startDate;
	    var endDate = dates.endDate;
	    if (startDate && endDate) {
	        startDate = (0, _moment2.default)(dates.startDate).format('YYYY-MM-DD');
	        endDate = (0, _moment2.default)(dates.endDate).format('YYYY-MM-DD');
	        return startDate + ',' + endDate;
	    }
	}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _hiddenCustomers = __webpack_require__(567);
	
	var _hiddenCustomers2 = _interopRequireDefault(_hiddenCustomers);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _customerPicker = __webpack_require__(569);
	
	var _customerPicker2 = _interopRequireDefault(_customerPicker);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.customer.picker",
	    modules: [_hiddenCustomers2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-customer-picker',
	    bindings: {
	        ngModel: '=',
	        ngDisabled: '=',
	        ngChange: '&',
	        company: '<', // one-way binding
	        mode: '=',
	        clearOnChange: '=?'
	    },
	    template: _customerPicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["$scope", "HiddenCustomersStore", "$element"];
	    _inherits(C, _BasePicker);
	
	    function C($scope, HiddenCustomersStore, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.scope = $scope;
	        _this.store = HiddenCustomersStore;
	        _this.store.init();
	        _this.store.params.is_active = 'True';
	
	        _this.clearOnChange = _this.clearOnChange || false;
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var self = this;
	            if (!self.ngChange) {
	                return;
	            }
	
	            this.watcher = this.scope.$watch(function () {
	                return self.ngModel;
	            }, function (newValue, oldValue) {
	                if (newValue === oldValue) {
	                    return;
	                }
	                if (!self.ngChange) {
	                    return;
	                }
	
	                self.ngChange();
	            }, true);
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changesObj) {
	            if (!this.company) {
	                return;
	            }
	            var currentCompanyId = this.getCompanyId(changesObj.company.currentValue);
	
	            if (!_lodash2.default.isUndefined(currentCompanyId)) {
	                this.store.params.companies = currentCompanyId;
	
	                if (this.clearOnChange && !(changesObj.company.isFirstChange && changesObj.company.isFirstChange())) {
	                    // Do not reset value on first change
	                    this.ngModel = '';
	                    this.store.refresh();
	                }
	            }
	        }
	    }, {
	        key: 'getCompanyId',
	        value: function getCompanyId(obj) {
	            if (_lodash2.default.isObject(obj) && obj.id) {
	                return obj.id;
	            }
	
	            return _lodash2.default.isNumber(obj) ? obj : undefined;
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.HiddenCustomers',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('HiddenCustomersStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('hidden-customers');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BasePicker = function () {
	    function BasePicker($element) {
	        _classCallCheck(this, BasePicker);
	
	        this.enabled = false;
	        this.placeholder = this.placeholder || 'Type to search ...';
	        this.watcher = null;
	        this.$element = $element || null;
	    }
	
	    _createClass(BasePicker, [{
	        key: 'refresh',
	        value: function refresh(search) {
	            var self = this;
	            this.store.params.search = search;
	            if (!search && !this.enabled) {
	                return;
	            }
	
	            this.store.refresh().then(function () {
	                if (search === '') {
	                    self._push(self.ngModel);
	                }
	            });
	        }
	    }, {
	        key: '_push',
	        value: function _push(obj) {
	            if (_angular2.default.isUndefined(obj) || obj === null) {
	                return;
	            }
	            var self = this;
	            var i = self.store.list.findIndex(function (p) {
	                return p.id === obj.id;
	            });
	            if (i >= 0) {
	                self.store.list.splice(i, 1);
	            }
	            self.store.list.unshift(obj);
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick() {
	            if (this.enabled) {
	                return;
	            }
	            this.enabled = true;
	            this.refresh('');
	        }
	    }, {
	        key: 'onSelect',
	        value: function onSelect($item, $model) {
	            var self = this;
	            self._push($model);
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            if (this.watcher) {
	                this.watcher();
	                this.watcher = null;
	            }
	            if (this.store && this.store.list) {
	                self.store = null;
	            }
	
	            if (this.$element) {
	                this.$element.remove();
	                this.$element = null;
	            }
	        }
	    }]);
	
	    return BasePicker;
	}();
	
	exports.default = BasePicker;

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\">\n    <span class=\"form-control\" ng-if=\"$ctrl.mode === 'read'\">{{ $ctrl.ngModel.title }}</span>\n\n    <ui-select ng-model=\"$ctrl.ngModel\" prevent-animations allow-remove ng-disabled=\"$ctrl.ngDisabled\" ng-click=\"$ctrl.onClick()\" on-select=\"$ctrl.onSelect($item, $model)\" theme=\"bootstrap\" ng-if=\"!$ctrl.mode || $ctrl.mode !== 'read'\">\n        <ui-select-match prevent-animations placeholder=\"{{$ctrl.placeholder}}\">{{ $select.selected.title || $select.selected }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"customer in $ctrl.store.list | filter: $select.search\"\n                refresh=\"$ctrl.refresh($select.search, $select)\"\n                refresh-delay=\"100\"\n                prevent-animations>\n            <div ng-bind=\"customer.title\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n"

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(571);
	
	var _decorators = __webpack_require__(331);
	
	var _applicator = __webpack_require__(572);
	
	var _applicator2 = _interopRequireDefault(_applicator);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _applicatorPicker = __webpack_require__(573);
	
	var _applicatorPicker2 = _interopRequireDefault(_applicatorPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.applicator.picker",
	    modules: [_applicator2.default, 'app.filters.properties']
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-applicator-picker',
	    bindings: {
	        ngModel: '=',
	        company: '<', // one-way binding
	        fieldname: '@',
	        mode: '@',
	        type: '@'
	    },
	    template: _applicatorPicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["$scope", "$element", "ApplicatorStore"];
	    _inherits(C, _BasePicker);
	
	    function C($scope, $element, ApplicatorStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.fetched = false;
	        _this.$scope = $scope;
	        _this.store = ApplicatorStore;
	        _this.store.init();
	
	        // Creates separate list of objects for each component.
	        // Do not use ApplicatorStore.list here! As this is singleton and it is shared
	        // between components
	        _this.list = [];
	
	        if (_this.company) {
	            _this.store.params.company = _this.company.id;
	        }
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var self = this;
	            self.currentCompany = {};
	
	            self.watcher = self.$scope.$watch(function () {
	                return self.company;
	            }, function (newValue, oldValue) {
	                if (newValue === oldValue) {
	                    return;
	                }
	                self.store.params.company = self.company.id;
	                self.enabled = true;
	                self.ngModel = null;
	                self.fetched = false;
	                self.refresh();
	            }, true);
	        }
	    }, {
	        key: '$postLink',
	        value: function $postLink() {
	            this.refresh();
	        }
	    }, {
	        key: 'onSelect',
	        value: function onSelect($item, $model) {}
	    }, {
	        key: '_push',
	        value: function _push(obj) {
	            if (angular.isUndefined(obj) || obj === null) {
	                return;
	            }
	            var self = this;
	            var i = self.list.findIndex(function (p) {
	                return p.id === obj.id;
	            });
	            if (i >= 0) {
	                self.list.splice(i, 1);
	            }
	            self.list.unshift(obj);
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh(search, $select) {
	            var self = this;
	            if (self.fetched) {
	                return;
	            }
	
	            var refreshPromise = this.store.refresh().then(function (response) {
	                self.fetched = true;
	                if (self.fieldname) {
	                    var applicatorsHaulers = response.list.plain();
	                    self.list = applicatorsHaulers.map(function (o) {
	                        var _ref;
	
	                        return _ref = {}, _defineProperty(_ref, self.fieldname, o), _defineProperty(_ref, "title", o.title), _ref;
	                    });
	                } else {
	                    self.list = response.list;
	                }
	
	                if (search === '') {
	                    self._push(self.ngModel);
	                }
	            });
	
	            return refreshPromise;
	        }
	    }, {
	        key: 'applicators',
	        get: function get() {
	            if (this.ngModel.length === 0) {
	                return '-';
	            }
	            var applicatorsHaulers = _lodash2.default.groupBy(this.ngModel, this.fieldname + '.title');
	            return _lodash2.default.map(applicatorsHaulers, function (value, key) {
	                return key;
	            }).join(', ');
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app.filters.properties', []).filter('propsFilter', function () {
	    "ngInject";
	
	    return function (items, props) {
	        var out = [];
	
	        if (_angular2.default.isArray(items)) {
	
	            items.forEach(function (item) {
	                var itemMatches = false;
	                var keys = Object.keys(props);
	                var optionValue = '';
	                for (var i = 0; i < keys.length; i++) {
	                    optionValue = item[keys[i]] ? optionValue + item[keys[i]].toString().toLowerCase().replace(/ /g, '') : '';
	                }
	                for (var j = 0; j < keys.length; j++) {
	                    var text = props[keys[j]];
	                    if (text) {
	                        text = text.toLowerCase().replace(/ /g, '');
	                    }
	                    if (optionValue.indexOf(text) !== -1) {
	                        itemMatches = true;
	                        break;
	                    }
	                }
	                if (itemMatches) {
	                    out.push(item);
	                }
	            });
	        } else {
	            // Let the output be the input untouched
	            out = items;
	        }
	
	        return out;
	    };
	});

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.applicator',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('ApplicatorStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('applicators');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode === 'edit'\">\n    <ui-select ng-model=\"$ctrl.ngModel\" ng-if=\"$ctrl.type === 'one'\" allow-remove>\n        <ui-select-match prevent-animations placeholder=\"{{ $ctrl.placeholder }}\">{{ $select.selected[0].applicator.title || $select.selected[0].hauler.title || $select.selected.title}}</ui-select-match>\n        <ui-select-choices\n            prevent-animations\n            repeat=\"applicator as applicator in $ctrl.list | filter: {title: $select.search}\">\n            <div ng-bind=\"applicator.applicator.title || applicator.hauler.title\"></div>\n        </ui-select-choices>\n    </ui-select>\n\n    <ui-select multiple ng-model=\"$ctrl.ngModel\" ng-if=\"$ctrl.type != 'one'\">\n        <ui-select-match prevent-animations placeholder=\"{{ $ctrl.placeholder }}\">{{ $item.applicator.title || $item.hauler.title }}</ui-select-match>\n        <ui-select-choices\n            prevent-animations\n            repeat=\"applicator as applicator in $ctrl.list | filter: {title: $select.search}\">\n            <div ng-bind=\"applicator.applicator.title || applicator.hauler.title\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n<span ng-if=\"$ctrl.mode === 'view'\" ng-bind=\"$ctrl.applicators || '-'\"></span>\n"

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(575);
	
	var _shipToPicker = __webpack_require__(580);
	
	var _shipToPicker2 = _interopRequireDefault(_shipToPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.orders.compontents.shipTo",
	    modules: ['selector']
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-ship-to',
	    template: _shipToPicker2.default,
	    bindings: {
	        ngModel: '=',
	        customer: '=',
	        mode: '@',
	        ngChange: '&?'
	    }
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope", "$element", "FieldStore"];
	    function C($scope, $element, FieldStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.store = FieldStore;
	        this.scope = $scope;
	        this.$element = $element;
	        this.creating = false;
	        this.watcher = null;
	    }
	
	    _createClass(C, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            var self = this;
	            this.watcher = this.scope.$watch(function () {
	                return _this.ngModel.length;
	            }, function (newValue, oldValue) {
	                if (newValue === oldValue) {
	                    return;
	                }
	                self.triggerChange();
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.watcher();
	            this.$element.remove();
	            this.store = [];
	            this.watcher = null;
	            this.$element = null;
	        }
	    }, {
	        key: 'customOptionComparator',
	        value: function customOptionComparator(option, value) {
	            // It's faster then comparing whole object
	            return option.field.id == value.field.id;
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh(search) {
	            this.store.init();
	            this.store.params.customer = this.customer.id;
	            this.store.params.name = search;
	            return this.store.refresh().then(function (resp) {
	                var fields = resp.list.plain();
	                return fields.map(function (o) {
	                    return { field: o };
	                });
	            });
	        }
	    }, {
	        key: 'create',
	        value: function create(input) {
	            var self = this;
	            if (this.creating) {
	                return;
	            }
	
	            this.creating = true;
	            var data = _lodash2.default.extend({
	                customer: this.customer.id,
	                geo: {
	                    latitude: 0.0,
	                    longitude: 0.0
	                }
	            }, input);
	            return this.store.create(data).then(function (resp) {
	                resp = resp.plain();
	                return {
	                    field: resp
	                };
	            }).finally(function () {
	                self.creating = false;
	            });
	        }
	    }, {
	        key: 'triggerChange',
	        value: function triggerChange() {
	            if (this.ngChange) {
	                this.ngChange();
	            }
	        }
	    }, {
	        key: 'shipTo',
	        get: function get() {
	            if (this.ngModel.length === 0) {
	                return '-';
	            }
	            var fields = _lodash2.default.groupBy(this.ngModel, 'field.farm_name');
	            return _lodash2.default.map(fields, function (value, key) {
	                var fields = _lodash2.default.map(value, function (obj) {
	                    return obj.field.field_name + '-' + obj.field.acres;
	                }).join(', ');
	                if (fields) {
	                    return key + ': ' + fields;
	                }
	                return key;
	            }).join(', ');
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _selector = __webpack_require__(576);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _itemCreate = __webpack_require__(577);
	
	var _itemCreate2 = _interopRequireDefault(_itemCreate);
	
	var _itemDefault = __webpack_require__(578);
	
	var _itemDefault2 = _interopRequireDefault(_itemDefault);
	
	var _groupDefault = __webpack_require__(579);
	
	var _groupDefault2 = _interopRequireDefault(_groupDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Key codes
	var KEYS = { up: 38, down: 40, left: 37, right: 39, escape: 27, enter: 13, backspace: 8, delete: 46, shift: 16, leftCmd: 91, rightCmd: 93, ctrl: 17, alt: 18, tab: 9 };
	
	var $filter, $timeout, $window, $http, $q, $document;
	
	var Selector = function () {
	
	    function getStyles(element) {
	        return !(element instanceof HTMLElement) ? {} : element.ownerDocument && element.ownerDocument.defaultView.opener ? element.ownerDocument.defaultView.getComputedStyle(element) : window.getComputedStyle(element);
	    }
	
	    // Selector directive
	    function Selector(filter, timeout, window, http, q, document) {
	        this.restrict = 'EAC';
	        this.replace = true;
	        this.transclude = true;
	        this.scope = {
	            name: '@?',
	            value: '=model',
	            disabled: '=?disable',
	            disableSearch: '=?',
	            required: '=?require',
	            multiple: '=?multi',
	            placeholder: '@?',
	            valueAttr: '@',
	            labelAttr: '@?',
	            groupAttr: '@?',
	            options: '=?',
	            debounce: '=?',
	            create: '&?',
	            limit: '=?',
	            rtl: '=?',
	            api: '=?',
	            change: '&?',
	            remote: '&?',
	            remoteParam: '@?',
	            remoteValidation: '&?',
	            remoteValidationParam: '@?',
	            removeButton: '=?',
	            softDelete: '=?',
	            closeAfterSelection: '=?',
	            viewItemTemplate: '=?',
	            dropdownItemTemplate: '=?',
	            dropdownCreateTemplate: '=?',
	            dropdownGroupTemplate: '=?',
	            comparator: '&?optionComparator'
	        };
	        this.templateUrl = 'selector/selector.html';
	        $filter = filter;
	        $timeout = timeout;
	        $window = window;
	        $http = http;
	        $q = q;
	        $document = document;
	    }
	    Selector.prototype.$inject = ['$filter', '$timeout', '$window', '$http', '$q'];
	    Selector.prototype.link = function (scope, element, attrs, controller, transclude) {
	        transclude(scope, function (clone, scope) {
	            var filter = $filter('filter'),
	                input = _angular2.default.element(element[0].querySelector('.selector-input .search-input')),
	                dropdown = _angular2.default.element(element[0].querySelector('.selector-dropdown')),
	                inputCtrl = input.controller('ngModel'),
	                selectCtrl = element.find('select').controller('ngModel'),
	                initDeferred = $q.defer(),
	                defaults = {
	                api: {},
	                search: '',
	                disableSearch: false,
	                selectedValues: [],
	                highlighted: 0,
	                valueAttr: null,
	                labelAttr: 'label',
	                groupAttr: 'group',
	                options: [],
	                debounce: 0,
	                limit: Infinity,
	                remoteParam: 'q',
	                remoteValidationParam: 'value',
	                removeButton: true,
	                viewItemTemplate: 'selector/item-default.html',
	                dropdownItemTemplate: 'selector/item-default.html',
	                dropdownCreateTemplate: 'selector/item-create.html',
	                dropdownGroupTemplate: 'selector/group-default.html'
	            };
	            var watchers = [];
	            // Default data for form
	            scope.formData = {
	                farm_name: '',
	                field_name: '',
	                acres: 0
	            };
	
	            scope.triggeredByEnter = false;
	            scope.options = [];
	
	            // Default attributes
	            if (!_angular2.default.isDefined(scope.value) && scope.multiple) scope.value = [];
	            _angular2.default.forEach(defaults, function (value, key) {
	                if (!_angular2.default.isDefined(scope[key])) scope[key] = value;
	            });
	            _angular2.default.forEach(['name', 'valueAttr', 'labelAttr'], function (attr) {
	                if (!attrs[attr]) attrs[attr] = scope[attr];
	            });
	
	            // Options' utilities
	            scope.getObjValue = function (obj, path) {
	                var key;
	                if (!_angular2.default.isDefined(obj) || !_angular2.default.isDefined(path)) return obj;
	                path = _angular2.default.isArray(path) ? path : path.split('.');
	                key = path.shift();
	
	                if (key.indexOf('[') > 0) {
	                    var match = key.match(/(\w+)\[(\d+)\]/);
	                    if (match !== null) {
	                        obj = obj[match[1]];
	                        key = match[2];
	                    }
	                }
	                return path.length === 0 ? obj[key] : scope.getObjValue(obj[key], path);
	            };
	            scope.setObjValue = function (obj, path, value) {
	                var key;
	                if (!_angular2.default.isDefined(obj)) obj = {};
	                path = _angular2.default.isArray(path) ? path : path.split('.');
	                key = path.shift();
	
	                if (key.indexOf('[') > 0) {
	                    var match = key.match(/(\w+)\[(\d+)\]/);
	                    if (match !== null) {
	                        obj = obj[match[1]];
	                        key = match[2];
	                    }
	                }
	                obj[key] = path.length === 0 ? value : scope.setObjValue(obj[key], path, value);
	                return obj;
	            };
	            scope.optionValue = function (option) {
	                return scope.valueAttr == null ? option : scope.getObjValue(option, scope.valueAttr);
	            };
	            scope.optionEquals = function (option, value) {
	                return _angular2.default.equals(scope.optionValue(option), _angular2.default.isDefined(value) ? value : scope.value);
	            };
	
	            // Value utilities
	            scope.setValue = function (value) {
	                if (!scope.multiple) scope.value = scope.valueAttr == null ? value : scope.getObjValue(value || {}, scope.valueAttr);else scope.value = scope.valueAttr == null ? value || [] : (value || []).map(function (option) {
	                    return scope.getObjValue(option, scope.valueAttr);
	                });
	            };
	            scope.hasValue = function () {
	                return scope.multiple ? (scope.value || []).length > 0 : !!scope.value;
	            };
	
	            // Remote fetching
	            scope.request = function (paramName, paramValue, remote, remoteParam) {
	                var promise,
	                    remoteOptions = {};
	                if (scope.disabled) return $q.reject();
	                if (!_angular2.default.isDefined(remote)) throw 'Remote attribute is not defined';
	
	                scope.loading = true;
	
	                remoteOptions[paramName] = paramValue;
	                promise = remote(remoteOptions);
	                if (typeof promise.then !== 'function') {
	                    var settings = { method: 'GET', cache: true, params: {} };
	                    _angular2.default.extend(settings, promise);
	                    _angular2.default.extend(settings.params, promise.params);
	                    settings.params[remoteParam] = paramValue;
	                    promise = $http(settings);
	                }
	                promise.then(function (data) {
	                    scope.options = data.data || data;
	                    scope.filterOptions();
	                    initDeferred.resolve();
	                }, function (error) {
	                    initDeferred.reject();
	                    throw 'Error while fetching data: ' + (error.message || error);
	                }).finally(function () {
	                    scope.loading = false;
	                });
	                return promise;
	            };
	            scope.fetch = function () {
	                return scope.request('search', scope.search || '', scope.remote, scope.remoteParam);
	            };
	            scope.fetchValidation = function (value) {
	                return scope.request('value', value, scope.remoteValidation, scope.remoteValidationParam);
	            };
	            if (!_angular2.default.isDefined(scope.remote)) {
	                scope.remote = false;
	                scope.remoteValidation = false;
	                initDeferred.resolve();
	            } else if (!_angular2.default.isDefined(scope.remoteValidation)) scope.remoteValidation = false;
	            if (scope.remote) $timeout(function () {
	                $q.when(!scope.hasValue() || !scope.remoteValidation ? _angular2.default.noop : scope.fetchValidation(scope.value)).then(function () {
	                    var searchWatch = scope.$watch('search', function () {
	                        if (scope.isOpen && scope.triggeredByEnter) {
	                            return;
	                        } else {
	                            $timeout(function () {
	                                scope.fetch().finally(function () {
	                                    scope.triggeredByEnter = false;
	                                });
	                            });
	                        }
	                    });
	                    watchers.push(searchWatch);
	                });
	            });
	
	            // Fill with options in the select
	            scope.optionToObject = function (option, group) {
	                var object = {},
	                    element = _angular2.default.element(option);
	
	                _angular2.default.forEach(option.dataset, function (value, key) {
	                    if (!key.match(/^\$/)) object[key] = value;
	                });
	                if (option.value) scope.setObjValue(object, scope.valueAttr || 'value', option.value);
	                if (element.text()) scope.setObjValue(object, scope.labelAttr, element.text().trim());
	                if (_angular2.default.isDefined(group)) scope.setObjValue(object, scope.groupAttr, group);
	                scope.options.push(object);
	                if (element.attr('selected') && (scope.multiple || !scope.hasValue())) if (!scope.multiple) {
	                    if (!scope.value) scope.value = scope.optionValue(object);
	                } else {
	                    if (!scope.value) scope.value = [];
	                    scope.value.push(scope.optionValue(object));
	                }
	            };
	            scope.fillWithHtml = function () {
	                scope.options = [];
	                _angular2.default.forEach(clone, function (element) {
	                    var tagName = (element.tagName || '').toLowerCase();
	
	                    if (tagName == 'option') scope.optionToObject(element);
	                    if (tagName == 'optgroup') {
	                        _angular2.default.forEach(element.querySelectorAll('option'), function (option) {
	                            scope.optionToObject(option, (element.attributes.label || {}).value);
	                        });
	                    }
	                });
	                scope.updateSelected();
	            };
	
	            // Initialization
	            scope.initialize = function () {
	                if (!scope.remote && (!_angular2.default.isArray(scope.options) || !scope.options.length)) scope.fillWithHtml();
	                if (scope.hasValue()) {
	                    if (!scope.multiple) {
	                        if (_angular2.default.isArray(scope.value)) scope.value = scope.value[0];
	                    } else {
	                        if (!_angular2.default.isArray(scope.value)) scope.value = [scope.value];
	                    }
	                    scope.updateSelected();
	                    scope.filterOptions();
	                    scope.updateValue();
	                }
	            };
	            var multipleWatcher = scope.$watch('multiple', function () {
	                $timeout(scope.setInputWidth);
	                initDeferred.promise.then(scope.initialize, scope.initialize);
	            });
	            watchers.push(multipleWatcher);
	
	            // Dropdown utilities
	            scope.dropdownPosition = function () {
	                var label = input.parent()[0],
	                    styles = getStyles(label),
	                    marginTop = parseFloat(styles.marginTop || 0),
	                    marginLeft = parseFloat(styles.marginLeft || 0);
	
	                dropdown.css({
	                    top: label.offsetTop + label.offsetHeight + marginTop + 'px',
	                    left: label.offsetLeft + marginLeft + 'px',
	                    width: label.offsetWidth + 'px'
	                });
	            };
	            scope.open = function () {
	                if (scope.multiple && (scope.selectedValues || []).length >= scope.limit) return;
	                scope.isOpen = true;
	                scope.dropdownPosition();
	                $timeout(scope.scrollToHighlighted);
	            };
	            scope.close = function () {
	                scope.isOpen = false;
	                scope.resetInput();
	                if (scope.remote) $timeout(scope.fetch);
	            };
	            scope.decrementHighlighted = function () {
	                scope.highlight(scope.highlighted - 1);
	                scope.scrollToHighlighted();
	            };
	            scope.incrementHighlighted = function () {
	                scope.highlight(scope.highlighted + 1);
	                scope.scrollToHighlighted();
	            };
	            scope.highlight = function (index) {
	                if (attrs.create && scope.search && index == -1) scope.highlighted = -1;else if (scope.filteredOptions.length) scope.highlighted = (scope.filteredOptions.length + index) % scope.filteredOptions.length;
	            };
	            scope.scrollToHighlighted = function () {
	                var dd = dropdown[0],
	                    option = dd.querySelectorAll('li.selector-option')[scope.highlighted],
	                    styles = getStyles(option),
	                    marginTop = parseFloat(styles.marginTop || 0),
	                    marginBottom = parseFloat(styles.marginBottom || 0);
	
	                if (!scope.filteredOptions.length) return;
	
	                if (option.offsetTop + option.offsetHeight + marginBottom > dd.scrollTop + dd.offsetHeight) $timeout(function () {
	                    dd.scrollTop = option.offsetTop + option.offsetHeight + marginBottom - dd.offsetHeight;
	                });
	
	                if (option.offsetTop - marginTop < dd.scrollTop) $timeout(function () {
	                    dd.scrollTop = option.offsetTop - marginTop;
	                });
	            };
	            scope.createOption = function (value) {
	                $q.when(function () {
	                    var option = {};
	                    if (_angular2.default.isFunction(scope.create)) {
	                        option = scope.create({ input: value });
	                    } else {
	                        scope.setObjValue(option, scope.labelAttr, value);
	                        scope.setObjValue(option, scope.valueAttr || 'value', value);
	                    }
	                    return option;
	                }()).then(function (option) {
	                    if (!option) {
	                        scope.resetInput();
	                        selectCtrl.$setDirty();
	                        return;
	                    }
	                    scope.options.push(option);
	                    scope.set(option);
	
	                    if (scope.filteredOptions.length === 0) {
	                        // After creating option, set focus on search input
	                        scope.triggeredByEnter = false;
	                        scope.api.focus();
	                    }
	                });
	            };
	            scope.set = function (option) {
	                if (scope.multiple && (scope.selectedValues || []).length >= scope.limit) return;
	
	                if (!_angular2.default.isDefined(option)) option = scope.filteredOptions[scope.highlighted];
	
	                if (!scope.multiple) scope.selectedValues = [option];else {
	                    if (!scope.selectedValues) scope.selectedValues = [];
	                    if (scope.selectedValues.indexOf(option) < 0) scope.selectedValues.push(option);
	                }
	                if (!scope.multiple || scope.closeAfterSelection || (scope.selectedValues || []).length >= scope.limit) scope.close();
	                scope.resetInput();
	                selectCtrl.$setDirty();
	            };
	            scope.unset = function (index) {
	                if (!scope.multiple) scope.selectedValues = [];else scope.selectedValues.splice(_angular2.default.isDefined(index) ? index : scope.selectedValues.length - 1, 1);
	                scope.resetInput();
	                selectCtrl.$setDirty();
	            };
	            scope.keydown = function (e) {
	                switch (e.keyCode) {
	                    case KEYS.up:
	                        if (!scope.isOpen) break;
	                        scope.decrementHighlighted();
	                        e.preventDefault();
	                        break;
	                    case KEYS.down:
	                        if (!scope.isOpen) scope.open();else scope.incrementHighlighted();
	                        e.preventDefault();
	                        break;
	                    case KEYS.escape:
	                        scope.highlight(0);
	                        scope.close();
	                        break;
	                    case KEYS.tab:
	                        if (scope.isOpen) {
	                            if (!scope.search) {
	                                scope.close();
	                                break;
	                            }
	                            if (attrs.create && scope.search && scope.filteredOptions.length === 0) {
	                                copyValueFromSearch();
	                            }
	                            e.preventDefault();
	                        }
	                        break;
	                    case KEYS.enter:
	                        if (scope.isOpen) {
	                            if (attrs.create && scope.search && scope.filteredOptions.length === 0) {
	                                copyValueFromSearch();
	                            } else if (scope.filteredOptions.length) {
	                                scope.set();
	                            }
	                            e.preventDefault();
	                        }
	                        break;
	                    case KEYS.backspace:
	                        if (!input.val()) {
	                            var search = scope.getObjValue(scope.selectedValues.slice(-1)[0] || {}, scope.labelAttr || '');
	                            scope.unset();
	                            scope.open();
	                            if (scope.softDelete && !scope.disableSearch) $timeout(function () {
	                                scope.search = search;
	                            });
	                            e.preventDefault();
	                        }
	                        break;
	                    case KEYS.left:
	                    case KEYS.right:
	                    case KEYS.shift:
	                    case KEYS.ctrl:
	                    case KEYS.alt:
	                    case KEYS.leftCmd:
	                    case KEYS.rightCmd:
	                        break;
	                    default:
	                        if (!scope.multiple && scope.hasValue()) {
	                            e.preventDefault();
	                        } else {
	                            scope.open();
	                            scope.highlight(0);
	                        }
	                        break;
	                }
	            };
	
	            function copyValueFromSearch() {
	                $timeout(function () {
	                    scope.formData.farm_name = scope.search;
	                    scope.triggeredByEnter = true;
	                    scope.search = '';
	                    scope.api.focusFormInput();
	                });
	            }
	
	            // Filtered options
	            scope.inOptions = function (options, value) {
	                // if options are fetched from a remote source, it's not possibile to use
	                // the simplest check with native `indexOf` function, beacause every object
	                // in the results array has it own new address
	                if (scope.remote) return options.filter(function (option) {
	                    return _angular2.default.equals(value, option);
	                }).length > 0;else return options.indexOf(value) >= 0;
	            };
	            scope.filterOptions = function () {
	                if (scope.triggeredByEnter) {
	                    return;
	                }
	                scope.filteredOptions = filter(scope.options || [], scope.search);
	                if (!_angular2.default.isArray(scope.selectedValues)) scope.selectedValues = [];
	                if (scope.multiple) scope.filteredOptions = scope.filteredOptions.filter(function (option) {
	                    return !scope.inOptions(scope.selectedValues, option);
	                });else {
	                    var index = scope.filteredOptions.indexOf(scope.selectedValues[0]);
	                    if (index >= 0) scope.highlight(index);
	                }
	            };
	
	            // Input width utilities
	            scope.measureWidth = function () {
	                var width,
	                    styles = getStyles(input[0]),
	                    shadow = _angular2.default.element('<span class="selector-shadow"></span>');
	                shadow.text(input.val() || (!scope.hasValue() ? scope.placeholder : '') || '');
	                _angular2.default.element(document.body).append(shadow);
	                _angular2.default.forEach(['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'letterSpacing', 'textTransform', 'wordSpacing', 'textIndent'], function (style) {
	                    shadow.css(style, styles[style]);
	                });
	                width = shadow[0].offsetWidth;
	                shadow.remove();
	                return width;
	            };
	            scope.setInputWidth = function () {
	                var width = scope.measureWidth() + 1;
	                input.css('width', width + 'px');
	            };
	            scope.resetInput = function () {
	
	                input.val('');
	                scope.setInputWidth();
	                $timeout(function () {
	                    scope.search = '';
	                    scope.formData = {
	                        farm_name: '',
	                        field_name: '',
	                        acres: 0
	                    };
	                });
	            };
	
	            var valuesWatcher = scope.$watch('[search, options, value]', function () {
	                // hide selected items
	                scope.filterOptions();
	                $timeout(function () {
	                    // set input width
	                    scope.setInputWidth();
	                    // repositionate dropdown
	                    if (scope.isOpen) scope.dropdownPosition();
	                });
	            }, true);
	            watchers.push(valuesWatcher);
	
	            // Update value
	            scope.updateValue = function (origin) {
	                if (!_angular2.default.isDefined(origin)) origin = scope.selectedValues || [];
	                scope.setValue(!scope.multiple ? origin[0] : origin);
	            };
	            var selectedWatcher = scope.$watch('selectedValues', function (newValue, oldValue) {
	                if (_angular2.default.equals(newValue, oldValue)) return;
	                scope.updateValue();
	                if (_angular2.default.isFunction(scope.change)) scope.change(scope.multiple ? { newValue: newValue, oldValue: oldValue } : { newValue: (newValue || [])[0], oldValue: (oldValue || [])[0] });
	            }, true);
	            watchers.push(selectedWatcher);
	
	            var optionsWatcher = scope.$watchCollection('options', function (newValue, oldValue) {
	                if (_angular2.default.equals(newValue, oldValue) || scope.remote) return;
	                scope.updateSelected();
	            });
	            watchers.push(optionsWatcher);
	
	            function getComparator() {
	                if (scope.comparator) {
	                    return scope.comparator();
	                }
	                return scope.optionEquals;
	            }
	
	            // Update selected values
	            scope.updateSelected = function () {
	                var comparator = getComparator();
	                if (!scope.multiple) scope.selectedValues = (scope.options || []).filter(function (option) {
	                    return scope.optionEquals(option);
	                }).slice(0, 1);else scope.selectedValues = (scope.value || []).map(function (value) {
	                    return filter(scope.options, function (option) {
	                        return comparator(option, value);
	                    })[0];
	                }).filter(function (value) {
	                    return _angular2.default.isDefined(value);
	                }).slice(0, scope.limit);
	            };
	
	            var valueWatcher = scope.$watch('value', function (newValue, oldValue) {
	                if (_angular2.default.equals(newValue, oldValue)) return;
	                $q.when(!scope.remote || !scope.remoteValidation || !scope.hasValue() ? _angular2.default.noop : scope.fetchValidation(newValue)).then(function () {
	                    scope.updateSelected();
	                    scope.filterOptions();
	                    scope.updateValue();
	                });
	            }, true);
	            watchers.push(valueWatcher);
	
	            // DOM event listeners
	            input = _angular2.default.element(element[0].querySelector('.selector-input .search-input'));
	            input.on('focus', function () {
	                $timeout(function () {
	                    scope.triggeredByEnter = false;
	                    scope.$apply(scope.open);
	                });
	            }).on('keydown', function (e) {
	                scope.$apply(function () {
	                    scope.keydown(e);
	                });
	            }).on('input', function () {
	                scope.setInputWidth();
	            });
	            dropdown.on('keydown', function (e) {
	                scope.$apply(function () {
	                    switch (e.keyCode) {
	                        case KEYS.enter:
	                            if (scope.isOpen) {
	                                if (attrs.create && scope.filteredOptions.length === 0) {
	                                    scope.createOption(scope.formData);
	                                }
	                                e.preventDefault();
	                            }
	                            break;
	                    }
	                });
	            });
	
	            _angular2.default.element($window).on('resize', function () {
	                scope.dropdownPosition();
	            });
	
	            scope.onKeyPress = function (e) {
	                $timeout(function () {
	                    switch (e.keyCode) {
	                        case KEYS.tab:
	                            scope.close();
	                            break;
	                    }
	                });
	            };
	
	            // Update select controller
	            var pristineWatcher = scope.$watch(function () {
	                return inputCtrl.$pristine;
	            }, function ($pristine) {
	                selectCtrl[$pristine ? '$setPristine' : '$setDirty']();
	            });
	            watchers.push(pristineWatcher);
	            var touchedWatcher = scope.$watch(function () {
	                return inputCtrl.$touched;
	            }, function ($touched) {
	                selectCtrl[$touched ? '$setTouched' : '$setUntouched']();
	            });
	            watchers.push(touchedWatcher);
	
	            function onDocumentClick(e) {
	                var contains = false;
	                if (!scope.isOpen) {
	                    return;
	                }
	
	                if (__webpack_provided_window_dot_jQuery) {
	                    // Firefox 3.6 does not support element.contains()
	                    // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	                    contains = __webpack_provided_window_dot_jQuery.contains(element[0], e.target);
	                } else {
	                    contains = element[0].contains(e.target);
	                }
	
	                if (!contains) {
	                    scope.close();
	                    scope.$digest();
	                }
	            }
	            $document.on('click', onDocumentClick);
	
	            // Expose APIs
	            _angular2.default.forEach(['open', 'close', 'fetch'], function (api) {
	                scope.api[api] = scope[api];
	            });
	            scope.api.focus = function () {
	                if (!input) {
	                    return;
	                }
	                input[0].focus();
	            };
	            scope.api.focusFormInput = function () {
	                var firstFormInput = _angular2.default.element(element[0].querySelector('.selector-dropdown input'));
	                if (!firstFormInput) {
	                    return;
	                }
	                firstFormInput[0].focus();
	            };
	            scope.api.set = function (value) {
	                return scope.value = value;
	            };
	            scope.api.unset = function (value) {
	                var comparator = getComparator();
	                var values = !value ? scope.selectedValues : (scope.selectedValues || []).filter(function (option) {
	                    return comparator(option, value);
	                }),
	                    indexes = scope.selectedValues.map(function (option, index) {
	                    return scope.inOptions(values, option) ? index : -1;
	                }).filter(function (index) {
	                    return index >= 0;
	                });
	
	                _angular2.default.forEach(indexes, function (index, i) {
	                    scope.unset(index - i);
	                });
	            };
	            scope.$on('$destroy', function () {
	                // Clean up events
	                input.off('focus keydown input');
	                dropdown.off('keydown');
	                $document.off('click', onDocumentClick);
	                // Remove watchers
	                _lodash2.default.each(watchers, function (watcher) {
	                    watcher();
	                });
	
	                _angular2.default.element($window).off('resize');
	                scope.options = [];
	                watchers = [];
	                element.remove();
	                input = null;
	                scope.$destroy();
	            });
	        });
	    };
	
	    return Selector;
	}();
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "selector"
	}), _dec2 = (0, _decorators.Run)(["$templateCache", function ($templateCache) {
	    "ngInject";
	
	    $templateCache.put('selector/selector.html', _selector2.default);
	    $templateCache.put('selector/item-create.html', _itemCreate2.default);
	    $templateCache.put('selector/item-default.html', _itemDefault2.default);
	    $templateCache.put('selector/group-default.html', _groupDefault2.default);
	}]), _dec3 = (0, _decorators.Directive)('selector', ["$filter", "$timeout", "$document", "$window", "$http", "$q", function ($filter, $timeout, $document, $window, $http, $q) {
	    "ngInject";
	
	    return new Selector($filter, $timeout, $window, $http, $q, $document);
	}]), _dec(_class = _dec2(_class = _dec3(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class) || _class);
	exports.default = D;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(330)))

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"selector-container\" ng-attr-dir=\"{{rtl ? 'rtl' : 'ltr'}}\"\n     ng-class=\"{open: isOpen, empty: !filteredOptions.length && (!create || !search), multiple: multiple, 'has-value': hasValue(), rtl: rtl,\nloading: loading, 'remove-button': removeButton, disabled: disabled}\">\n    <select name=\"{{name}}\" ng-hide=\"true\" ng-required=\"required && !hasValue()\"\n            ng-model=\"selectedValues\" multiple\n            ng-options=\"option as getObjValue(option, labelAttr) for option in selectedValues\">\n    </select>\n    <label class=\"selector-input\">\n        <ul class=\"selector-values\">\n            <li ng-repeat=\"(index, option) in selectedValues track by index\">\n                <div ng-include=\"viewItemTemplate\"></div>\n                <div ng-if=\"multiple\" class=\"selector-helper\"\n                     ng-click=\"!disabled && unset(index)\">\n                    <span class=\"selector-icon\"></span>\n                </div>\n            </li>\n        </ul>\n        <input ng-model=\"search\"\n               class=\"search-input\"\n               placeholder=\"{{!hasValue() ? placeholder : ''}}\"\n               ng-model-options=\"{debounce: debounce}\"\n               ng-disabled=\"disabled\"\n               ng-readonly=\"disableSearch\"\n               ng-required=\"required && !hasValue()\"\n               autocomplete=\"off\">\n        <div ng-if=\"!multiple || loading\"\n             class=\"selector-helper selector-global-helper\"\n             ng-click=\"!disabled && removeButton && unset()\">\n            <span class=\"selector-icon\"></span>\n        </div>\n    </label>\n    <ul class=\"selector-dropdown\">\n        <li class=\"create\"\n            ng-class=\"{active: highlighted == -1}\"\n            ng-if=\"!loading && options.length === 0 || filteredOptions.length === 0\"\n            ng-include=\"dropdownCreateTemplate\">\n        </li>\n        <li ng-repeat-start=\"(index, option) in filteredOptions track by index\"\n            class=\"option selector-optgroup\"\n            ng-include=\"dropdownGroupTemplate\"\n            ng-show=\"groupAttr && (getObjValue(option, groupAttr) && index == 0 || getObjValue(filteredOptions[index - 1], groupAttr) != getObjValue(option, groupAttr))\">\n        </li>\n        <li ng-repeat-end\n            ng-class=\"{active: highlighted == index, grouped: groupAttr && getObjValue(option, groupAttr)}\"\n            class=\"option selector-option\"\n            ng-include=\"dropdownItemTemplate\"\n            ng-mouseover=\"highlight(index)\"\n            ng-click=\"set()\">\n        </li>\n    </ul>\n</div>\n"

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"form-inline\">\n    <div class=\"form-group form-group-sm\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"formData.farm_name\" placeholder=\"Farm name\" required>\n    </div>\n    <div class=\"form-group form-group-sm\">\n        <input type=\"text\" class=\"form-control\" ng-model=\"formData.field_name\" placeholder=\"Field name\" required>\n    </div>\n    <div class=\"form-group form-group-sm\">\n        <input type=\"number\" class=\"form-control\" ng-model=\"formData.acres\" placeholder=\"Acres\" required>\n    </div>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"createOption(formData)\" ng-keydown=\"onKeyPress($event)\">Add Field</button>\n</div>\n"

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = "<span> {{ option.field.farm_name }} {{ option.field.field_name }} - {{ option.field.acres }}</span>\n"

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = "<span ng-bind=\"getObjValue(option, groupAttr)\"></span>\n"

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode === 'edit'\">\n    <selector\n        model=\"$ctrl.ngModel\"\n        multi=\"true\"\n        remote=\"$ctrl.refresh(search)\"\n        create=\"$ctrl.create(input)\"\n        option-comparator=\"$ctrl.customOptionComparator\"\n        placeholder=\"Type to search...\">\n    </selector>\n</div>\n<span ng-if=\"$ctrl.mode === 'view'\" ng-bind=\"$ctrl.shipTo || '-'\"></span>\n"

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _cropPickerTpl = __webpack_require__(582);
	
	var _cropPickerTpl2 = _interopRequireDefault(_cropPickerTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.orders.compontents.crop",
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-crop-picker',
	    template: _cropPickerTpl2.default,
	    bindings: {
	        ngModel: '=',
	        ngChange: '&?'
	    }
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["$scope", "$element", "R"];
	    _inherits(C, _BasePicker);
	
	    function C($scope, $element, R) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.scope = $scope;
	        _this.R = R;
	        _this.list = [];
	        _this.endpoint = R.one('crops');
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: 'refresh',
	        value: function refresh() {
	            if (!this.enabled) {
	                return;
	            }
	
	            var self = this;
	            return this.endpoint.getList().then(function (response) {
	                self.list = response.plain();
	                return self;
	            });
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;
	
	            var self = this;
	            this.watcher = this.scope.$watch(function () {
	                return _this2.ngModel;
	            }, function () {
	                self.onChange();
	            });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            if (this.ngChange) {
	                this.ngChange();
	            }
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            delete this.list;
	            _get(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), '$onDestroy', this).call(this);
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\">\n    <ui-select ng-model=\"$ctrl.ngModel\" prevent-animations allow-remove theme=\"bootstrap\" class=\"input-sm\" ng-click=\"$ctrl.onClick()\">\n        <ui-select-match prevent-animations placeholder=\"{{$ctrl.placeholder}}\">{{ $select.selected.title || $select.selected }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"crop in $ctrl.list | filter: $select.search\"\n                refresh=\"$ctrl.refresh($select.search, $select)\"\n                refresh-delay=\"100\"\n                prevent-animations>\n            <div ng-bind=\"crop.title\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n"

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _company = __webpack_require__(514);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _companyPicker = __webpack_require__(584);
	
	var _companyPicker2 = _interopRequireDefault(_companyPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//http://tools.medialab.sciences-po.fr/iwanthue/
	var colors = ["#deb1e0", "#85e4d4", "#f1a7a2", "#5dcce3", "#d7c695", "#a4bfeb", "#d1ecba", "#e4b5ac", "#9ac899", "#9cd9d4"];
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.company.picker",
	    modules: [_company2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-company-picker',
	    bindings: {
	        ngModel: '=',
	        ngDisabled: '=',
	        ngChange: '&',
	        mode: '@?',
	        customer: '<?',
	        allowEmpty: '<',
	        testId: '@?'
	    },
	    template: _companyPicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["$scope", "$element", "$timeout", "CompanyStore", "UserService"];
	    _inherits(C, _BasePicker);
	
	    function C($scope, $element, $timeout, CompanyStore, UserService) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.allowEmpty = _.isUndefined(_this.allowEmpty) ? false : _this.allowEmpty;
	        _this.$timeout = $timeout;
	        _this.mode = _this.mode || 'view';
	        _this.$user = UserService.$user;
	
	        _this.ngModelId = _this.ngModel && _this.ngModel.id;
	        _this.oldNgModel = _this.ngModel;
	
	        _this.scope = $scope;
	        _this.colorStyle = { 'background-color': '#999' };
	
	        if (_this.mode === 'edit') {
	            _this.store = CompanyStore;
	            _this.store.init();
	            if (_this.customer) {
	                _this.store.params.customers = _this.customer.id; // Get customer companies
	            }
	            _this.store.refresh();
	        }
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: '_ngChange',
	        value: function _ngChange(newV, oldV) {
	            var _this2 = this;
	
	            this.ngModel = this.list.find(function (c) {
	                return c.id === _this2.ngModelId;
	            });
	            this.$timeout(function () {
	                _this2.ngChange(newV, oldV);
	            });
	        }
	    }, {
	        key: 'list',
	        get: function get() {
	            if (this.oldNgModel && !this.store.list.map(function (c) {
	                return c.id;
	            }).includes(this.oldNgModel.id)) {
	                return [this.oldNgModel].concat(_toConsumableArray(this.store.list));
	            } else {
	                return this.store.list;
	            }
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)))

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = "<select class=\"form-control\"\n        ng-if=\"$ctrl.mode === 'edit'\"\n    ng-attr-data-testid=\"{{$ctrl.testId}}\"\n        ng-model=\"$ctrl.ngModelId\"\n        ng-disabled=\"$ctrl.ngDisabled\"\n        ng-change=\"$ctrl._ngChange()\"\n        ng-options=\"item.id as item.name for item in $ctrl.list\">\n    <option ng-if=\"$ctrl.allowEmpty\" value=\"\">Select Company</option>\n</select>\n<span ng-if=\"$ctrl.mode === 'view'\" class=\"label label-default\" ng-bind=\"$ctrl.ngModel.name\" ng-style=\"$ctrl.colorStyle\"></span>\n"

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _nutrientsTpl = __webpack_require__(586);
	
	var _nutrientsTpl2 = _interopRequireDefault(_nutrientsTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NutrientsComponent = (_dec = (0, _decorators.Module)({
	    name: "app.orders.compontents.nutrients"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-nutrients',
	    template: _nutrientsTpl2.default,
	    bindings: {
	        ngModel: '=',
	        editMode: '=',
	        errors: '=?',
	        nutrientReCalc: '=?',
	        showPrices: '=?',
	        ngChange: '&?'
	    }
	}), _dec(_class = _dec2(_class = function () {
	    NutrientsComponent.$inject = ["$element"];
	    function NutrientsComponent($element) {
	        "ngInject";
	
	        _classCallCheck(this, NutrientsComponent);
	
	        this.$element = $element;
	        this.showPrices = this.showPrices || false;
	    }
	
	    _createClass(NutrientsComponent, [{
	        key: 'onChange',
	        value: function onChange() {
	            if (this.ngChange) {
	                this.ngChange();
	            }
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.$element.remove();
	            this.$element = null;
	        }
	    }]);
	
	    return NutrientsComponent;
	}()) || _class) || _class);
	exports.default = NutrientsComponent;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ngModels\" ng-switch=\"$ctrl.editMode\">\n    <!-- Read-only Mode -->\n    <table class=\"table table-ngModels-view borderless\" ng-switch-default>\n        <thead>\n            <tr>\n                <th ng-repeat=\"nutrient in $ctrl.nutrientReCalc.nutrients\" ng-bind=\"nutrient.short_name\"></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr>\n                <td ng-repeat=\"nutrient in $ctrl.nutrientReCalc.nutrients\">{{ nutrient.percent }}</td>\n            </tr>\n        </tbody>\n    </table>\n    <!-- End: Ready-only Mode -->\n    <!-- Edit Mode -->\n    <table class=\"table table-elements-edit borderless\" ng-switch-when=\"true\">\n        <thead>\n            <tr>\n                <th ng-repeat=\"nutrient in $ctrl.nutrientReCalc.nutrients\" ng-bind=\"nutrient.short_name\"></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr ng-if=\"$ctrl.showPrices\">\n                <td class=\"col-md-1 prices form-group form-group-sm\"\n                    ng-repeat=\"nutrient in $ctrl.nutrientReCalc.nutrients\">\n                    <span>${{ nutrient.price }}</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"col-md-1 form-group form-group-sm\"\n                    ng-repeat=\"nutrient in $ctrl.nutrientReCalc.nutrients\">\n                    <input class=\"form-control\"\n                           type=\"text\"\n                           name=\"{{ nutrient.label }}_rate\"\n                           ng-model=\"nutrient.percent\"\n                           ng-blur=\"$ctrl.nutrientReCalc.onPercentChanged(nutrient); $ctrl.onChange();\"\n                           form-error=\"$ctrl.errors['{{nutrient.label}}'].rate\"\n                           blink\n                           select-on-click>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"col-md-1 form-group form-group-sm\"\n                    ng-repeat=\"nutrient in $ctrl.nutrientReCalc.nutrients\">\n                    <input class=\"form-control\"\n                           type=\"text\"\n                           ng-model=\"nutrient.lbs\"\n                           name=\"{{ nutrient.label }}_lbs\"\n                           ng-blur=\"$ctrl.nutrientReCalc.onLbsChanged(nutrient); $ctrl.onChange();\"\n                           form-error=\"$ctrl.errors['{{nutrient.label}}'].lbs\"\n                           blink\n                           select-on-click>\n                </td>\n            </tr>\n        </tbody>\n\n    </table>\n    <!-- End: Edit Mode -->\n</div>\n"

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _product = __webpack_require__(588);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productsComponent = __webpack_require__(589);
	
	var _productsComponent2 = _interopRequireDefault(_productsComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var pintsUnits = ['GAL', 'GALS'];
	var convertionGallonsToPints = 8;
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.products.component",
	    modules: [_product2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-products',
	    bindings: {
	        ngModel: '=',
	        mode: '@',
	        company: '<',
	        customer: '<',
	        acres: '<',
	        crop: '<',
	        acresChanged: '<',
	        ngChange: '&?',
	        errors: '=?',
	        showPrices: '<?',
	        hasErrors: '=?',
	        convertToPints: '<?'
	    },
	    template: _productsComponent2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope", "$element", "ProductRateStore"];
	    function C($scope, $element, ProductRateStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var self = this;
	        this.scope = $scope;
	        this.$element = $element;
	        this.productRateStore = ProductRateStore;
	        self.showPrices = self.showPrices || false;
	        self.convertToPints = self.convertToPints || false;
	        self.isDisabled = false;
	        // Per-product debounced rate checkers, to avoid flooding /products-rate with a request on every keystroke/rate change.
	        this._verifyRateDebounced = {};
	    }
	
	    _createClass(C, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var self = this;
	            self.watcher = self.scope.$watch(function () {
	                return self.ngModel;
	            }, function () {
	                if (self.showPrices) {
	                    self.ngModel.forEach(function (p) {
	                        return self.calcTotalPrice(p);
	                    });
	                }
	
	                self.ngModel.forEach(function (p) {
	                    // Set quantityDisplay
	                    if (!p.quantityDisplay) {
	                        p.quantityDisplay = self.getQuantity(p);
	                    }
	                });
	
	                if (self.onChange) {
	                    self.onChange();
	                }
	            }, true);
	        }
	    }, {
	        key: '$doCheck',
	        value: function $doCheck() {
	            if (this.ngModel.length >= 10) {
	                this.isDisabled = true;
	            }
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            _lodash2.default.forEach(this._verifyRateDebounced, function (fn) {
	                return fn.cancel();
	            });
	            this._verifyRateDebounced = {};
	            if (this.watcher) {
	                this.watcher();
	                this.watcher = null;
	            }
	            this.$element.remove();
	            this.$element = null;
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            if (this.mode === 'view') {
	                return;
	            }
	            var self = this;
	            if (changes.acres) {
	                var acresCurrent = changes.acres.currentValue;
	                var isFirst = changes.acres.isFirstChange();
	
	                if (isFirst && acresCurrent === 0) {
	                    return;
	                }
	                if ((changes.acresChanged || changes.convertToPints) && changes.acres.previousValue.constructor.name !== 'UNINITIALIZED_VALUE') {
	                    self.ngModel.forEach(function (p) {
	                        return self.onRateChange(p);
	                    });
	                }
	            }
	
	            if (changes.crop && changes.crop.currentValue) {
	                self.verifyProductRate();
	            }
	        }
	    }, {
	        key: 'hasFieldErrors',
	        value: function hasFieldErrors(index) {
	            var err = this.errors && this.errors[index];
	            if (!err) return false;
	            return !!(err.restricted || err.quantity || err.rate_acre || err.product);
	        }
	    }, {
	        key: 'checkErrors',
	        value: function checkErrors() {
	            if (!_lodash2.default.isUndefined(this.hasErrors)) {
	                var hasErrors = _lodash2.default.filter(this.ngModel, function (obj) {
	                    return obj.errorMessage !== null && parseFloat(obj.rate_acre) !== 0;
	                });
	                this.hasErrors = hasErrors.length > 0;
	            }
	        }
	    }, {
	        key: 'addProduct',
	        value: function addProduct() {
	            if (this.ngModel.length >= 10) {
	                this.isDisabled = true;
	                return;
	            }
	
	            // Add default values
	            this.ngModel.push({
	                rate_acre: 0,
	                quantity: 0,
	                quantityDisplay: 0
	            });
	
	            this.triggerFocus = true;
	        }
	    }, {
	        key: 'removeProduct',
	        value: function removeProduct(product) {
	            var index = this.ngModel.indexOf(product);
	            this.ngModel.splice(index, 1);
	            this.isDisabled = false;
	
	            try {
	                // Remove error if exists
	                if (this.errors[index]) {
	                    delete this.errors[index];
	                }
	            } catch (error) {
	                // Catch TypeError exception
	            }
	        }
	    }, {
	        key: 'onPress',
	        value: function onPress(e, isLast) {
	            if (e.which === 9 && isLast) {
	                this.addProduct();
	            }
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            if (this.ngChange) {
	                this.ngChange();
	            }
	        }
	    }, {
	        key: 'verifyProductRate',
	        value: function verifyProductRate() {
	            var _this = this;
	
	            var self = this;
	            var payload = _lodash2.default.map(this.ngModel, function (obj) {
	                return {
	                    product: obj.product.id,
	                    crop: _this.crop.id,
	                    rate: obj.rate_acre
	                };
	            });
	
	            this.productRateStore.checkProducts(payload).then(function () {
	                _lodash2.default.map(self.ngModel, function (obj) {
	                    obj.errorMessage = null;
	                });
	                self.checkErrors();
	            }, function (response) {
	                _lodash2.default.map(response.data, function (data, idx) {
	                    if (data) {
	                        self.ngModel[idx].errorMessage = _lodash2.default.first(data.rate) || null;
	                    }
	                });
	                self.checkErrors();
	            });
	        }
	    }, {
	        key: 'verifyRate',
	        value: function verifyRate(product) {
	            var _this2 = this;
	
	            // Debounce per product: rapid rate changes should collapse into a single `/products-rate` request instead of one per keystroke.
	            var key = product.product && product.product.id || 'unknown';
	            if (!this._verifyRateDebounced[key]) {
	                this._verifyRateDebounced[key] = _lodash2.default.debounce(function (p) {
	                    return _this2._verifyRate(p);
	                }, 400);
	            }
	            this._verifyRateDebounced[key](product);
	        }
	    }, {
	        key: '_verifyRate',
	        value: function _verifyRate(product) {
	            var self = this;
	
	            if (this.crop) {
	                this.productRateStore.checkProducts({
	                    product: product.product.id,
	                    crop: this.crop.id,
	                    rate: product.rate_acre
	                }).then(function () {
	                    product.errorMessage = null;
	                    self.checkErrors();
	                }, function (response) {
	                    product.errorMessage = _lodash2.default.first(_lodash2.default.first(response.data).rate);
	                    self.checkErrors();
	                });
	            }
	        }
	    }, {
	        key: 'calcTotalPrice',
	        value: function calcTotalPrice(obj, itemChanged) {
	            if (!this.showPrices || !_lodash2.default.has(obj, 'product')) {
	                return;
	            }
	            var div = pintsUnits.indexOf(obj.product.units.id) >= 0 ? convertionGallonsToPints : 1;
	
	            var priceLevels = _lodash2.default.fromPairs(_lodash2.default.map(obj.product.prices, function (obj) {
	                return [obj.price_level, obj.price];
	            }));
	
	            if (itemChanged) {
	                obj.unit_price = 0;
	                obj.total_price = 0;
	            }
	
	            // Only recalculate unit_price if it doesn't exist or if item changed (new product)
	            // This prevents overwriting existing prices when editing orders
	            // Use _.isUndefined() to distinguish between unit_price=0 and unit_price not set
	            if (_lodash2.default.isUndefined(obj.unit_price) || itemChanged) {
	                // Get unit price from response
	                if (_lodash2.default.has(priceLevels, 'special')) {
	                    obj.isSpecial = true;
	                    obj.unit_price = priceLevels.special;
	                } else {
	                    obj.isSpecial = false;
	                    obj.unit_price = obj.product.prices && obj.product.prices.length > 0 ? priceLevels[this.customer.price_level] : obj.unit_price;
	                }
	            }
	
	            // Display value
	            obj.unitPrice = _lodash2.default.round((obj.unit_price || 0.00) / div, 3);
	
	            // Total price for product - recalculate based on current quantity and EXISTING unit_price
	            obj.total_price = obj.quantityDisplay ? _lodash2.default.round(obj.quantityDisplay * obj.unit_price / div, 2) : _lodash2.default.round(obj.quantity * obj.unit_price, 2);
	            obj.total_price = obj.total_price || 0;
	        }
	    }, {
	        key: 'onProductChange',
	        value: function onProductChange(product) {
	            if (!this.showPrices) {
	                return;
	            }
	            this.calcTotalPrice(product, true);
	        }
	    }, {
	        key: 'canConvertToPints',
	        value: function canConvertToPints(product) {
	            return this.convertToPints && product.product && product.product.units && pintsUnits.indexOf(product.product.units.name) >= 0;
	        }
	    }, {
	        key: 'getUnit',
	        value: function getUnit(product) {
	            if (this.canConvertToPints(product)) {
	                return 'PINTS';
	            }
	
	            try {
	                return product.product.units.name;
	            } catch (err) {
	                return '';
	            }
	        }
	    }, {
	        key: 'getQuantity',
	        value: function getQuantity(product) {
	            if (this.canConvertToPints(product)) {
	                return _lodash2.default.round(product.quantity * convertionGallonsToPints, 2);
	            }
	            return product.quantity;
	        }
	    }, {
	        key: 'hasWarnings',
	        value: function hasWarnings(product) {
	            if (!product.product) return false;
	            return !product.product.is_active || this.showPrices && this.getUnitPrice(product) === 0;
	        }
	    }, {
	        key: 'getUnitPrice',
	        value: function getUnitPrice(product) {
	            return product.unitPrice;
	        }
	    }, {
	        key: 'getMaxQuantity',
	        value: function getMaxQuantity(product) {
	            if (!product.product || !product.product.units) {
	                return undefined;
	            }
	            var units = product.product.units.id || product.product.units.name;
	            if (units === 'GAL' || units === 'GALS') {
	                return this.canConvertToPints(product) ? 1200 * convertionGallonsToPints : 1200;
	            }
	            if (units === 'GLS') {
	                return 9999;
	            }
	            return undefined;
	        }
	    }, {
	        key: 'checkMaxQuantity',
	        value: function checkMaxQuantity(product) {
	            var maxQty = this.getMaxQuantity(product);
	            if (maxQty !== undefined && parseFloat(product.quantityDisplay) > maxQty) {
	                product.errorMessage = 'Quantity cannot exceed ' + maxQty;
	                this.checkErrors();
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'onRateChange',
	        value: function onRateChange(product) {
	            var self = this;
	            if (!product.product) {
	                return;
	            }
	            if (_lodash2.default.isUndefined(this.acres)) {
	                return;
	            }
	            var div = pintsUnits.indexOf(product.product.units.id) >= 0 ? convertionGallonsToPints : 1;
	
	            if (parseFloat(this.acres) !== 0) {
	                // value which will be send to server
	                product.quantity = _lodash2.default.round(this.acres * product.rate_acre / div, 3) || 0;
	                // value which is visible on UI
	                product.quantityDisplay = self.canConvertToPints(product) ? _lodash2.default.round(this.acres * product.rate_acre, 2) : product.quantity;
	            }
	
	            if (this.showPrices) {
	                this.calcTotalPrice(product);
	            }
	
	            if (this.checkMaxQuantity(product)) {
	                return;
	            }
	
	            // Check product rate
	            // Do not check rate in $watch it makes a lot of requests to backend!
	            this.verifyRate(product);
	        }
	    }, {
	        key: 'onQuantityChange',
	        value: function onQuantityChange(product) {
	            if (!product.product) {
	                return;
	            }
	            if (_lodash2.default.isUndefined(this.acres)) {
	                return;
	            }
	            var div = 1;
	            if (!this.canConvertToPints(product)) {
	                div = pintsUnits.indexOf(product.product.units.name) >= 0 ? convertionGallonsToPints : 1;
	            }
	            product.rate_acre = _lodash2.default.round(product.quantityDisplay / this.acres * div, 2) || 0;
	            product.quantity = this.canConvertToPints(product) ? _lodash2.default.round(product.quantityDisplay / convertionGallonsToPints, 3) : product.quantityDisplay;
	
	            if (this.showPrices) {
	                this.calcTotalPrice(product);
	            }
	
	            if (this.checkMaxQuantity(product)) {
	                return;
	            }
	
	            // Check product rate
	            // Do not check rate in $watch it makes a lot of requests to backend!
	            this.verifyRate(product);
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.product.rate',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('ProductRateStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('products-rate');
	        return _this;
	    }
	
	    _createClass(Store, [{
	        key: 'checkProducts',
	        value: function checkProducts(data) {
	            var self = this;
	            var $promise = null;
	
	            this.loading = true;
	            $promise = this.endpoint.post(data);
	            $promise.finally(function () {
	                self.loading = false;
	            });
	            return $promise;
	        }
	    }]);
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"blnd-products-warning-popover.html\">\n    <div ng-if=\"product.product && !product.product.is_active\">Product is no longer active</div>\n    <hr ng-if=\"product.product && !product.product.is_active && $ctrl.showPrices && product.product && $ctrl.getUnitPrice(product) === 0\" style=\"margin: 6px 0\">\n    <div ng-if=\"$ctrl.showPrices && product.product && $ctrl.getUnitPrice(product) === 0\">Unit price is zero — price level may not be configured for this product, customer, and company</div>\n</script>\n<table class=\"table products-edit-table\" ng-if=\"$ctrl.mode == 'edit'\">\n    <thead>\n        <tr>\n            <th></th>\n            <th>Product</th>\n            <th>Rate</th>\n            <th>Quantity</th>\n            <th>Units</th>\n            <th ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\">Unit Price</th>\n            <th ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\">Total Price</th>\n            <th></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-class=\"{\n                'alert-danger': product.errorMessage || $ctrl.hasFieldErrors($index),\n                'alert-warning': !product.errorMessage && !$ctrl.hasFieldErrors($index) && (product.isSpecial || $ctrl.hasWarnings(product))\n            }\"\n            ng-repeat=\"product in $ctrl.ngModel track by $index\">\n            <td>\n                <i class=\"fa fa-times clickable\" ng-click=\"$ctrl.removeProduct(product)\"></i>\n            </td>\n            <td class=\"col-grow\">\n                <blnd-product-picker\n                        mode=\"edit\"\n                        extra-fields=\"['prices']\"\n                        ng-model=\"product.product\"\n                        company=\"$ctrl.company\"\n                        customer=\"$ctrl.customer\"\n                        crop=\"$ctrl.crop\"\n                        on-change=\"$ctrl.onProductChange(product)\"\n                        form-error=\"$ctrl.errors[{{$index}}].product\"\n                        focus=\"$last && $ctrl.triggerFocus\"\n                        force-update=\"$ctrl.showPrices\">\n                </blnd-product-picker>\n            </td>\n            <td>\n                <input ng-model=\"product.rate_acre\"\n                       type=\"number\"\n                       step=\"0.01\"\n                       blink\n                       class=\"form-control input-sm rate-acre-input\"\n                       form-error=\"$ctrl.errors[{{$index}}].rate_acre\"\n                       ng-model-options=\"{debounce: 400}\"\n                       ng-change=\"$ctrl.onRateChange(product)\"\n                       select-on-click>\n            </td>\n            <td>\n                <input ng-model=\"product.quantityDisplay\"\n                       type=\"number\"\n                       step=\"0.01\"\n                       min=\"0\"\n                       blink\n                       class=\"form-control input-sm quantity-input\"\n                       form-error=\"$ctrl.errors[{{$index}}].quantity\"\n                       ng-model-options=\"{debounce: 400}\"\n                       ng-keypress=\"$ctrl.onPress($event, $last)\"\n                       ng-keydown=\"$ctrl.onPress($event, $last)\"\n                       ng-change=\"$ctrl.onQuantityChange(product)\"\n                       select-on-click>\n            </td>\n            <td class=\"col-sm-1 units\" ng-bind=\"$ctrl.getUnit(product)\"></td>\n            <td class=\"price\" ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\">${{ $ctrl.getUnitPrice(product) || 0 | number: 2 }}</td>\n            <td class=\"price\" ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\">${{ product.total_price || 0 | number: 2 }}</td>\n            <td class=\"warning-icon\">\n                <i ng-if=\"product.isSpecial\"\n                   class=\"fa fa-info-circle\"\n                   uib-popover=\"Special price used\"\n                   popover-append-to-body=\"true\"\n                   popover-trigger=\"'mouseenter'\"\n                   popover-placement=\"auto\"\n                   aria-hidden=\"true\"></i>\n                <i ng-if=\"product.errorMessage || $ctrl.hasFieldErrors($index)\"\n                   class=\"fa fa-exclamation-circle\"\n                   uib-popover=\"{{ product.errorMessage || $ctrl.errors[$index].restricted || $ctrl.errors[$index].quantity || $ctrl.errors[$index].rate_acre || $ctrl.errors[$index].product }}\"\n                   popover-append-to-body=\"true\"\n                   popover-trigger=\"'mouseenter'\"\n                   popover-placement=\"auto\"\n                   aria-hidden=\"true\"></i>\n                <i ng-if=\"!product.errorMessage && !$ctrl.hasFieldErrors($index) && $ctrl.hasWarnings(product)\"\n                   class=\"fa fa-exclamation-triangle text-warning\"\n                   uib-popover-template=\"'blnd-products-warning-popover.html'\"\n                   popover-append-to-body=\"true\"\n                   popover-trigger=\"'mouseenter'\"\n                   popover-placement=\"auto\"\n                   aria-hidden=\"true\"></i>\n            </td>\n        </tr>\n        <tr>\n            <td><i class=\"fa fa-plus clickable\" ng-if=\"!$ctrl.isDisabled\" ng-click=\"$ctrl.addProduct()\"></i></td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td></td>\n            <td class=\"price\" ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\"></td>\n            <td class=\"price\" ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\"></td>\n            <td></td>\n        </tr>\n    </tbody>\n</table>\n<table class=\"table table-fixed table-striped\" ng-if=\"$ctrl.mode === 'view'\">\n    <thead>\n        <tr>\n            <th class=\"\">ID</th>\n            <th class=\"col-grow\">Product</th>\n            <th class=\"\">Rate</th>\n            <th class=\"\">Qty</th>\n            <th class=\"\">Units</th>\n            <th ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\">Unit Price</th>\n            <th ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\">Total Price</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-if=\"$ctrl.ngModel.length === 0\">\n            <td colspan=\"5\" class=\"no-items\">No product selected</td>\n        </tr>\n        <tr ng-if=\"$ctrl.ngModel.length > 0\" ng-repeat=\"product in $ctrl.ngModel\">\n            <td ng-bind=\"product.product.id\"></td>\n            <td class=\"col-grow\" ng-bind=\"product.product.description || product.product.dot\"></td>\n            <td ng-bind=\"product.rate_acre\"></td>\n            <td ng-bind=\"$ctrl.getQuantity(product)\"></td>\n            <td class=\"units\" ng-bind=\"$ctrl.getUnit(product)\"></td>\n            <td class=\"price\" ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\">${{ $ctrl.getUnitPrice(product) | number: 2 }}</td>\n            <td class=\"price\" ng-if=\"$ctrl.showPrices\" permission permission-only=\"'main.change_order'\">${{ product.total_price | number: 2 }}</td>\n        </tr>\n    </tbody>\n</table>\n"

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _orderStatus = __webpack_require__(591);
	
	var _orderStatus2 = _interopRequireDefault(_orderStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.orders.compontents.order.status"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-order-status',
	    template: _orderStatus2.default,
	    bindings: {
	        ngModel: '=',
	        mode: '@',
	        inputClass: '@'
	    }
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["Config", "$element"];
	    function C(Config, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var self = this;
	        self.$element = $element;
	        self.statuses = Config.$config.order.statuses;
	        self.statusMap = _lodash2.default.fromPairs(self.statuses);
	    }
	
	    _createClass(C, [{
	        key: 'getName',
	        value: function getName() {
	            var self = this;
	            return self.statusMap[self.ngModel];
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            delete this.statuses;
	            delete this.statusMap;
	            this.$element.remove();
	            this.$element = null;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports = "<span ng-bind=\"$ctrl.getName()\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control\" ng-class=\"$ctrl.inputClass\" ng-model=\"$ctrl.ngModel\" ng-options=\"opt[0] as opt[1] for opt in $ctrl.statuses\" ng-if=\"$ctrl.mode === 'edit'\"></select>\n"

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _constants = __webpack_require__(546);
	
	var _companyId = __webpack_require__(594);
	
	var _companyId2 = _interopRequireDefault(_companyId);
	
	var _product = __webpack_require__(596);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _ctrls = __webpack_require__(534);
	
	var _list = __webpack_require__(599);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _sendEstimationForm = __webpack_require__(543);
	
	var _sendEstimationForm2 = _interopRequireDefault(_sendEstimationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.orders.components.list",
	    modules: [_companyId2.default, _product2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'order-list',
	    bindings: {
	        customer: '=?',
	        extraFields: '<'
	    },
	    template: _list2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$state", "$scope", "$element", "$stateParams", "$timeout", "NgTableParams", "OrderStore", "SecureUrlService", "UserService", "R", "Modal"];
	    function C($state, $scope, $element, $stateParams, $timeout, NgTableParams, OrderStore, SecureUrlService, UserService, R, Modal) {
	        "ngInject";
	
	        var _this = this;
	
	        _classCallCheck(this, C);
	
	        this.stateFilters = _constants.stateFilters;
	        this.$stateParams = $stateParams;
	        this.secureUrlService = SecureUrlService;
	        this.$user = UserService.$user;
	        this.R = R;
	        this.$element = $element;
	        this.$state = $state;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.Modal = Modal;
	        var defaultFields = ['id', 'order_id', 'customer', 'company', 'crop', 'acres', 'analysis', 'created_at', 'status', 'applicators'];
	
	        this.defaultParams = {
	            search: '',
	            created_at__range: '',
	            status: 'open',
	            ordering: ['-created_at'],
	            page_size: 20,
	            field: _lodash2.default.concat(defaultFields, this.extraFields),
	            contains_product: null
	        };
	
	        if (this.customer) {
	            this.defaultParams.customer = this.customer.id;
	        }
	
	        this.resetParams();
	        this.selectedContainsProduct = null;
	        this.searchMode = 'order';
	        this.searchModeLabel = 'Order';
	        this.applyQSParams();
	
	        this.table = new _table2.default(NgTableParams, OrderStore, {
	            defaultParams: this.defaultParams,
	            params: this.params,
	            onChange: function onChange(params) {
	                return _this.onChange(params);
	            }
	        });
	
	        this.selectedObjects = [];
	        this.watcher = null;
	    }
	
	    _createClass(C, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var self = this;
	            self.canExport = true;
	            self.watcher = self.$scope.$watch(function () {
	                return self.table.checked;
	            }, function () {
	                var orders = self.table.store.list;
	                var checked = self.table.checked;
	
	                self.companies = {};
	                self.selectedObjects = self.table.getSelectedObjects();
	                _lodash2.default.each(_lodash2.default.range(0, _lodash2.default.keys(checked).length), function (index) {
	                    var order = orders[index];
	                    if (order && checked[order.id]) {
	                        self.companies[order.company.id] = true;
	                    }
	                });
	                self.canExport = _lodash2.default.keys(self.companies).length <= 1;
	                self.companyIDs = [];
	                angular.forEach(self.table.checked, function (value, key) {
	                    if (value) {
	                        var order = orders.filter(function (obj) {
	                            return obj.id == key;
	                        });
	                        angular.forEach(order, function (item) {
	                            self.companyIDs.push(item.company.id);
	                        });
	                    }
	                });
	                self.canPrint = _lodash2.default.uniq(self.companyIDs).length <= 1;
	                self.canSend = _lodash2.default.uniq(self.companyIDs).length <= 1;
	                self.table.updateAllChecked();
	            }, true);
	        }
	    }, {
	        key: 'export',
	        value: function _export(type) {
	            var self = this;
	            var selectedTicket = self.table.getSelected();
	
	            self.secureUrlService.openInNewWindow(self.R.one('export', type), { id: selectedTicket });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            if (this.watcher) {
	                this.watcher();
	                this.watcher = null;
	            }
	            this.table.onDestroy();
	            delete this.table;
	            this.$element.remove();
	            this.$element = null;
	        }
	    }, {
	        key: 'applyQSParams',
	        value: function applyQSParams() {
	            var params = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Object.keys(this.$stateParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var k = _step.value;
	
	                    var v = this.$stateParams[k];
	                    if (!_lodash2.default.isUndefined(v)) {
	                        params[k] = v;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            params.company = parseInt(params.company) || undefined;
	            params.page = parseInt(params.page) || undefined;
	            params.contains_product = parseInt(params.contains_product) || null;
	
	            delete params.customerId;
	            _lodash2.default.extend(this.params, params);
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(params_) {
	            // clear current params:
	            var params = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.entries(this.$state.$current.params)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _step2$value = _slicedToArray(_step2.value, 2),
	                        k = _step2$value[0],
	                        v = _step2$value[1];
	
	                    if (v.location === 'search') {
	                        params[k] = undefined;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            params = _lodash2.default.extend(params, params_);
	            this.$state.go('.', params, { notify: false });
	        }
	    }, {
	        key: 'resetParams',
	        value: function resetParams() {
	            this.params = _lodash2.default.clone(this.defaultParams);
	            this.selectedContainsProduct = null;
	            this.searchMode = 'order';
	            this.searchModeLabel = 'Order';
	        }
	    }, {
	        key: 'setSearchMode',
	        value: function setSearchMode(mode) {
	            var _this2 = this;
	
	            var labels = { order: 'Order', product: 'Product' };
	            this.searchMode = mode;
	            this.searchModeLabel = labels[mode];
	            if (mode === 'order') {
	                this.selectedContainsProduct = null;
	                this.params.contains_product = null;
	                this.$timeout(function () {
	                    var input = _this2.$element[0].querySelector('.order-search-input-wrapper input[type="text"]');
	                    if (input) input.focus();
	                });
	            } else {
	                this.params.search = '';
	                this.$timeout(function () {
	                    var toggle = _this2.$element[0].querySelector('.order-list-page-product-picker .ui-select-toggle');
	                    if (toggle) toggle.click();
	                });
	            }
	            this.refresh();
	        }
	    }, {
	        key: 'onContainsProductChange',
	        value: function onContainsProductChange() {
	            this.params.contains_product = this.selectedContainsProduct ? this.selectedContainsProduct.id : null;
	            this.refresh();
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }, {
	        key: 'openSendEmail',
	        value: function openSendEmail(type) {
	            var controller = _ctrls.SendEstimatePDFCtrl;
	            if (type === 'form') {
	                controller = _ctrls.SendFormPDFCtrl;
	            } else if (type == 'send_and_print') {
	                controller = _ctrls.SendAndPrintFormCtrl;
	            }
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _sendEstimationForm2.default,
	                controller: controller,
	                size: 'large',
	                resolve: {
	                    order: function order() {
	                        return self.selectedObjects;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.success('E-mail has been sent');
	            });
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DAY = 1000 * 60 * 60 * 24; // 24 hours
	
	function toStoreSorting(sorting) {
	    var ordering = [];
	    // params.sorting() give you field -> order obj
	    // we need to transform it to django filters (field or -field)
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = _lodash2.default.toPairs(sorting)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _step$value = _slicedToArray(_step.value, 2),
	                field = _step$value[0],
	                order = _step$value[1];
	
	            ordering.push('' + (order === 'asc' ? '' : '-') + field);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return ordering;
	}
	
	function toNgTableSorting(ordering) {
	    ordering = ordering || [];
	    return _lodash2.default.fromPairs(ordering.map(function (v) {
	        var order = 'asc';
	        if (v.startsWith('-')) {
	            v = v.substring(1);
	            order = 'desc';
	        }
	        return [v, order];
	    }));
	}
	
	function toArray(value) {
	    if (value && !_lodash2.default.isArray(value)) {
	        return [value];
	    }
	    return value;
	}
	
	var TableList = function () {
	    function TableList(NgTableParams, Store, _ref) {
	        var _ref$defaultParams = _ref.defaultParams,
	            defaultParams = _ref$defaultParams === undefined ? {} : _ref$defaultParams,
	            _ref$params = _ref.params,
	            params = _ref$params === undefined ? {} : _ref$params,
	            _ref$onChange = _ref.onChange,
	            onChange = _ref$onChange === undefined ? function () {} : _ref$onChange;
	
	        _classCallCheck(this, TableList);
	
	        defaultParams = _lodash2.default.clone(defaultParams);
	        params = _lodash2.default.clone(params);
	        defaultParams.page = defaultParams.page || 1;
	
	        var self = this;
	        self._onChange = onChange || function () {};
	        self.defaultParams = defaultParams;
	        self.isPaginationEnabled = !!this.defaultParams.page_size;
	
	        var requestParams = _lodash2.default.extend(_lodash2.default.clone(defaultParams), params);
	        var ordering = toArray(requestParams.ordering || this.defaultParams.ordering);
	
	        var ngParams = {
	            count: this.defaultParams.page_size || 100000000,
	            sorting: toNgTableSorting(ordering)
	        };
	
	        self.store = Store;
	        self.store.init();
	        self.store.params = requestParams;
	        self.initialized = false;
	
	        this.params = new NgTableParams(ngParams, {
	            counts: [],
	            paginationMinBlocks: 2,
	            paginationMaxBlocks: 10,
	            getData: function getData(params) {
	                if (!self.store) {
	                    // Destroy data from ngTable.
	                    // I did not find any different way to cleanup data
	                    return [];
	                }
	                if (!self.initialized) {
	                    params.page(self.store.params.page);
	                }
	                self.store.params.ordering = toStoreSorting(params.sorting());
	
	                if (self.isPaginationEnabled) {
	                    self.store.params.page = params.page();
	                }
	                if (self.initialized) {
	                    self.onChange();
	                } else {
	                    self.initialized = true;
	                }
	
	                return self.store.refresh().then(function (store) {
	                    // recal. page nav controls
	                    params.total(store.count);
	                    // return data
	                    return store.list;
	                });
	            }
	        });
	
	        this.allChecked = false;
	        this.checked = {};
	    }
	
	    _createClass(TableList, [{
	        key: 'getSelected',
	        value: function getSelected() {
	            var checked = this.checked;
	            return _lodash2.default.map(_lodash2.default.filter(_lodash2.default.keys(checked), function (key) {
	                return checked[key];
	            }), function (key) {
	                return key;
	            });
	        }
	    }, {
	        key: 'getSelectedObjects',
	        value: function getSelectedObjects() {
	            var checked = this.checked;
	            var objects = {};
	
	            _lodash2.default.each(this.store.list, function (obj) {
	                objects[obj.id] = obj;
	            });
	
	            return _lodash2.default.map(_lodash2.default.filter(_lodash2.default.keys(checked), function (id) {
	                return checked[id];
	            }), function (id) {
	                return objects[id];
	            });
	        }
	    }, {
	        key: 'updateAllChecked',
	        value: function updateAllChecked() {
	            var self = this;
	
	            if (_lodash2.default.isEmpty(self.checked)) {
	                self.allChecked = false;
	                return;
	            }
	            self.allChecked = _lodash2.default.every(self.store.list, function (o) {
	                return self.checked[o.id];
	            });
	        }
	    }, {
	        key: 'allCheckedToggle',
	        value: function allCheckedToggle() {
	            var self = this;
	            var value = !self.allChecked;
	            self.allChecked = value;
	
	            _lodash2.default.map(self.store.list, function (obj) {
	                self.checked[obj.id] = value;
	            });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            var params = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.keys(this.store.params)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var k = _step2.value;
	
	                    var v = this.store.params[k];
	                    if (!_lodash2.default.isEqual(v, this.defaultParams[k])) {
	                        params[k] = v;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            this._onChange(params);
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh(params) {
	            params = params || {};
	            this.params.page(1);
	            this.params.sorting(toNgTableSorting(toArray(params.ordering)));
	            this.store.params = _lodash2.default.clone(params);
	            this.params.reload();
	        }
	    }, {
	        key: 'onDestroy',
	        value: function onDestroy() {
	            delete this.store;
	            this.params.settings().dataset = [];
	            this.params.reload();
	        }
	    }, {
	        key: 'inProgressTime',
	        value: function inProgressTime(ticketId) {
	            var ticket = this.params.data.find(function (t) {
	                return t.id === ticketId;
	            });
	            if (!ticket) return 0;
	
	            var time = 0;
	            if (ticket.delivery_start && !ticket.delivery_stop) {
	                time = new Date() - Date.parse(ticket.delivery_start);
	            }
	            if (!time && ticket.application_start && !ticket.application_stop) {
	                time = new Date() - Date.parse(ticket.application_start);
	            }
	
	            return time;
	        }
	    }, {
	        key: 'isInProgressCorrect',
	        value: function isInProgressCorrect(ticketId) {
	            var time = this.inProgressTime(ticketId);
	            if (time === 0) return false;
	            return time < DAY;
	        }
	    }, {
	        key: 'isInProgressTooLong',
	        value: function isInProgressTooLong(ticketId) {
	            var time = this.inProgressTime(ticketId);
	            return time >= DAY;
	        }
	    }]);
	
	    return TableList;
	}();
	
	exports.default = TableList;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _user = __webpack_require__(503);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _companyIdPicker = __webpack_require__(595);
	
	var _companyIdPicker2 = _interopRequireDefault(_companyIdPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.companyid",
	    modules: [_user2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-company-id-picker',
	    bindings: {
	        ngModel: '=',
	        ngChange: '&',
	        testId: '@?'
	    },
	    template: _companyIdPicker2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$timeout", "UserService"];
	    function C($timeout, UserService) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$timeout = $timeout;
	        this.$user = UserService.$user;
	    }
	
	    _createClass(C, [{
	        key: '_ngChange',
	        value: function _ngChange(newV, oldV) {
	            var _this = this;
	
	            this.$timeout(function () {
	                _this.ngChange(newV, oldV);
	            });
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	module.exports = "<select class=\"form-control\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-change=\"$ctrl._ngChange()\"\n        ng-attr-data-testid=\"{{$ctrl.testId}}\"\n        ng-options=\"item.id as item.name for item in $ctrl.$user.companies\">\n    <option value=\"\">Select Company</option>\n</select>\n"

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _product = __webpack_require__(597);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _productPicker = __webpack_require__(598);
	
	var _productPicker2 = _interopRequireDefault(_productPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.productpicker",
	    modules: [_product2.default]
	
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-product-picker',
	    bindings: {
	        ngModel: '=',
	        onChange: '&',
	        mode: '@?',
	        placeholder: '@?',
	        extendedClassStyleName: '@?',
	        extraFields: '<',
	        crop: '<?',
	        company: '<?',
	        customer: '<?',
	        focus: '=?',
	        forceUpdate: '<?',
	        isActive: '@?'
	    },
	    template: _productPicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["$scope", "$element", "$timeout", "ProductStore"];
	    _inherits(C, _BasePicker);
	
	    function C($scope, $element, $timeout, ProductStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        var defaultFields = ['id', 'title', 'units', 'is_active'];
	
	        _this.scope = $scope;
	        _this.store = ProductStore;
	        _this.$timeout = $timeout;
	        _this.store.init();
	        if (_.isUndefined(_this.isActive)) {
	            _this.store.params.is_active = "True";
	        } else if (_this.isActive !== '') {
	            _this.store.params.is_active = { "": undefined, true: "True", false: "False" }[_this.isActive];
	        }
	
	        var extraFields = _.isUndefined(_this.extraFields) ? [] : _this.extraFields;
	        _this.store.params.field = _.concat(defaultFields, extraFields);
	        _this.store.params.extra_field = extraFields;
	        if (!_.isUndefined(_this.company)) {
	            _this.store.params.company = _this.company.id;
	        }
	
	        if (!_.isUndefined(_this.customer)) {
	            _this.store.params.customer = _this.customer.id;
	            _this.store.params.price_level = _this.customer.price_level;
	        }
	
	        if (!_.isUndefined(_this.crop) && _.has(_this.crop, 'id')) {
	            _this.store.params.crop = _this.crop.id;
	        }
	
	        _this.mode = _this.mode || 'view';
	        _this.forceUpdate = _this.forceUpdate || false;
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: 'hasValue',
	        value: function hasValue(obj, name) {
	            if (obj[name] && obj[name].isFirstChange && obj[name].isFirstChange()) {
	                return false;
	            }
	            return obj[name] && obj[name].currentValue && obj[name].currentValue.id;
	        }
	    }, {
	        key: '$postLink',
	        value: function $postLink() {
	            var self = this;
	            if (!this.forceUpdate) {
	                return;
	            }
	
	            if (self.ngModel && self.ngModel.id) {
	                self.store.get(self.ngModel.id, self.store.params).then(function (response) {
	                    self.ngModel = response;
	                    self.forceUpdate = false;
	                });
	            }
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changesObj) {
	            if (this.hasValue(changesObj, 'company')) {
	                this.store.params.company = changesObj.company.currentValue.id;
	            }
	            if (this.hasValue(changesObj, 'crop')) {
	                this.store.params.crop = changesObj.crop.currentValue.id;
	                this.store.refresh();
	            }
	            if (this.hasValue(changesObj, 'customer')) {
	                this.store.params.customer = changesObj.customer.currentValue.id;
	            }
	        }
	    }, {
	        key: 'onSelect',
	        value: function onSelect($item, $model) {
	            if (this.onChange) {
	                this.onChange();
	            }
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.product',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('ProductStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('products');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper {{$ctrl.extendedClassStyleName}}\" ng-if=\"$ctrl.mode === 'edit'\">\n    <ui-select\n            set-focus=\"$ctrl.focus\"\n            ng-model=\"$ctrl.ngModel\"\n            theme=\"bootstrap\"\n            class=\"input-sm\"\n            ng-click=\"$ctrl.onClick()\"\n            on-select=\"$ctrl.onSelect($item, $model)\"\n            prevent-animations>\n        <ui-select-match prevent-animations placeholder=\"{{$ctrl.placeholder}}\">{{ $select.selected.title }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"product in $ctrl.store.list | filter: $select.search track by product.id\"\n                refresh=\"$ctrl.refresh($select.search, $select)\"\n                refresh-delay=\"400\"\n                prevent-animations>\n            <div>\n                <span ng-if=\"::!product.is_active\" class=\"product-inactive-indicator pull-right\">inactive</span><span ng-bind=\"::product.title\"></span>\n            </div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n\n<span ng-if=\"$ctrl.mode === 'view'\" ng-bind=\"$ctrl.ngModel.title\"></span>\n"

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default\">\n    <script type=\"text/ng-template\" id=\"headerCheckbox.html\">\n        <input type=\"checkbox\"\n               ng-checked=\"$ctrl.table.allChecked\"\n               ng-click=\"$ctrl.table.allCheckedToggle()\"\n               uib-tooltip=\"{{ $ctrl.table.allChecked ? 'Unselect' : 'Select' }} all rows\">\n    </script>\n    <div class=\"panel-heading\">\n        <div class=\"search-query\">\n            <div class=\"table-list-filters\" ng-show=\"$ctrl.table.getSelected().length === 0\">\n                <form novalidate>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\">\n                            <div class=\"input-group\">\n                                <div class=\"order-search-input-wrapper\">\n                                    <input type=\"text\"\n                                           ng-show=\"$ctrl.searchMode === 'order'\"\n                                           class=\"form-control\"\n                                           placeholder=\"Search Orders\"\n                                           ng-model=\"$ctrl.params.search\"\n                                           ng-keyup=\"$event.keyCode == 13 && $ctrl.refresh()\"\n                                           autofocus />\n                                    <blnd-product-picker\n                                        ng-show=\"$ctrl.searchMode === 'product'\"\n                                        mode=\"edit\"\n                                        ng-model=\"$ctrl.selectedContainsProduct\"\n                                        placeholder=\"Search by product\"\n                                        on-change=\"$ctrl.onContainsProductChange()\"\n                                        extended-class-style-name=\"order-list-page-product-picker\"\n                                        is-active=\"\"\n                                    ></blnd-product-picker>\n                                </div>\n                                <div class=\"input-group-btn\" uib-dropdown>\n                                    <button type=\"button\" class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle>\n                                        <span ng-bind=\"$ctrl.searchModeLabel\"></span> <span class=\"caret\"></span>\n                                    </button>\n                                    <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\n                                        <li ng-class=\"{active: $ctrl.searchMode === 'order'}\">\n                                            <a href ng-click=\"$ctrl.setSearchMode('order')\">Order</a>\n                                        </li>\n                                        <li ng-class=\"{active: $ctrl.searchMode === 'product'}\">\n                                            <a href ng-click=\"$ctrl.setSearchMode('product')\">Product</a>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-2 filter-by-company\">\n                            <blnd-company-id-picker\n                                    ng-model=\"$ctrl.params.company\"\n                                    test-id=\"order-filter-company-picker\"\n                                    ng-change=\"$ctrl.refresh()\">\n                            </blnd-company-id-picker>\n                        </div>\n                        <div class=\"col-md-3 filter-by-date\">\n                            <blnd-date-range-picker\n                                   ng-model=\"$ctrl.params.created_at__range\"\n                                   ng-change=\"$ctrl.refresh()\"\n                                   format=\"string\">\n                            </blnd-date-range-picker>\n                        </div>\n                        <div class=\"col-md-2 filter-by-status\">\n                            <select class=\"form-control\"\n                                    ng-options=\"key as value for (key, value) in $ctrl.stateFilters\"\n                                    ng-model=\"$ctrl.params.status\"\n                                    ng-change=\"$ctrl.refresh()\">\n                            </select>\n                        </div>\n                        <div class=\"col-sm-1\">\n                            <button type=\"button\" class=\"btn btn-default pull-right\"\n                                    ng-click=\"$ctrl.resetParams(); $ctrl.refresh()\">\n                                Clear\n                            </button>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"table-list-actions\" ng-if=\"$ctrl.$user.role.name != 'Dispatcher'\" ng-show=\"$ctrl.selectedObjects.length !== 0\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <div class=\"action pull-right\">\n                            <div class=\"action pull-right\">\n                                <div class=\"btn-group\" uib-dropdown>\n                                    <button class=\"btn btn-default\"\n                                            type=\"button\"\n                                            uib-dropdown-toggle\n                                            ng-disabled=\"!$ctrl.canExport\">\n                                        Export <span class=\"caret\"></span>\n                                    </button>\n                                    <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n                                        <li role=\"menuitem\"><a href=\"#\" ng-click=\"$ctrl.export('xlsx')\">XLSX</a></li>\n                                    </ul>\n                                </div>\n                                <span class=\"text-danger\" ng-if=\"!$ctrl.canExport\">\n                                    <i class=\"fa fa-exclamation-triangle print-error\"\n                                       tooltip-placement=\"auto\"\n                                       uib-tooltip=\"Please select tickets for one company\"\n                                       aria-hidden=\"true\"></i>\n                                </span>\n                            </div>\n                            <div class=\"action pull-right\">\n                                    <div class=\"btn-group\" uib-dropdown>\n                                            <button class=\"btn btn-default\"\n                                            type=\"button\"\n                                            uib-dropdown-toggle\n                                            ng-disabled=\"!$ctrl.canSend\">\n                                        Send <span class=\"caret\"></span>\n                                    </button>\n                                    <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n                                        <li role=\"menuitem\"><a href=\"#\" ng-click=\"$ctrl.openSendEmail('estimate')\">Estimate</a></li>\n                                        <li role=\"menuitem\"><a href=\"#\" ng-click=\"$ctrl.openSendEmail('form')\">Form</a></li>\n                                        <li role=\"menuitem\"><a href=\"#\" ng-click=\"$ctrl.openSendEmail('send_and_print')\">Send and Print Form</a></li>\n                                    </ul>\n                                    </div>\n                            </div>\n                            <div class=\"action pull-right\">\n                                <blnd-print-button ng-disabled=\"!$ctrl.canPrint\"\n                                                   ng-model=\"$ctrl.selectedObjects\"\n                                                   type=\"order\"\n                                                   multiple=\"true\"\n                                                   table=\"$ctrl.table\">\n                                </blnd-print-button>\n                            </div>\n                            <div class=\"action pull-right\">\n                                <blnd-status-button ng-model=\"$ctrl.selectedObjects\"\n                                                    type=\"order\"\n                                                    multiple=\"true\"\n                                                    table=\"$ctrl.table\">\n                                </blnd-status-button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div loading-container=\"$ctrl.table.params.settings().$loading\">\n        <table ng-table=\"$ctrl.table.params\" class=\"table table-fixed table-sortable table-striped orders-table\">\n            <tr ng-repeat=\"order in $data\">\n                <td header=\"'headerCheckbox.html'\" class=\"col-checkbox\">\n                    <input type=\"checkbox\"\n                           ng-model=\"$ctrl.table.checked[order.id]\"\n                           ng-click=\"$ctrl.table.updateAllChecked()\">\n                </td>\n                <td class=\"col-id\" data-title=\"'ID'\" sortable=\"'order_id'\" >\n                    <a ui-sref=\"r.in.top.orders.detail({orderId: order.id})\" ng-bind=\"order.order_id\"></a>\n                </td>\n                <td data-title=\"'Customer'\" sortable=\"'customer__name'\" ng-if=\"$ctrl.extraFields.includes('customer')\">\n                    <span ng-bind=\"order.customer.title\"></span>\n                </td>\n                <td data-title=\"'Ship To'\" ng-if=\"$ctrl.extraFields.includes('fields')\">\n                    <blnd-ship-to ng-model=\"order.fields\" mode=\"view\" customer=\"order.customer\"></blnd-ship-to>\n                </td>\n                <td class=\"col-company\" data-title=\"'Company'\" sortable=\"'company'\">\n                    <blnd-company-picker ng-model=\"order.company\"></blnd-company-picker>\n                </td>\n                <td class=\"col-crop\" data-title=\"'Crop'\" sortable=\"'crop'\" ng-bind=\"order.crop.name || '-'\"></td>\n                <td class=\"\" data-title=\"'Acres'\"  sortable=\"'acres'\" ng-bind=\"order.acres\"></td>\n                <td class=\"col-analysis\" data-title=\"'Analysis'\" sortable=\"'analysis'\" ng-bind=\"order.analysis\"></td>\n                <td class=\"col-date\" data-title=\"'Created'\" sortable=\"'created_at'\" ng-bind=\"order.created_at | blndDate\"></td>\n                <td class=\"\"\n                    ng-bind=\"order.applicators.length > 1 ? order.applicators[0].applicator.name+' ...' : order.applicators[0].applicator.name\"\n                    sortable=\"'applicator'\"\n                    data-title=\"'Applicators'\">\n                </td>\n                <td class=\"col-status\" data-title=\"'Status'\" sortable=\"'status'\">\n                    <blnd-order-status ng-model=\"order.status\" mode=\"view\"></blnd-order-status>\n                </td>\n            </tr>\n        </table>\n        <no-data params=\"$ctrl.table.params\">No orders</no-data>\n    </div>\n</div>\n"

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _list = __webpack_require__(601);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _order = __webpack_require__(550);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _order3 = __webpack_require__(590);
	
	var _order4 = _interopRequireDefault(_order3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.orders.components.priority-list",
	    modules: [_order2.default, _order4.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'order-priority-list',
	    template: _list2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["OrderStore", "$element"];
	    function C(OrderStore, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$element = $element;
	        this.store = OrderStore;
	        this.store.init();
	        this.store.params.ordering = 'sort_order';
	        this.store.params.view = 'schedule_orders';
	        this.store.params.status = 'schedule';
	        this.store.params.field = ['id', 'order_id', 'customer', 'status', 'fields', 'crop', 'created_at', 'applicators', 'haulers', 'analysis'];
	        this.store.params.page = 1;
	        var self = this;
	        this.store.refresh().then(function () {
	            self.prepareLinkedOrders();
	        });
	        this.saving = false;
	    }
	
	    _createClass(C, [{
	        key: 'prepareLinkedOrders',
	        value: function prepareLinkedOrders() {
	            var self = this;
	            var linkedOrders = [];
	            self.store.list.map(function (o) {
	                return o.linked = false;
	            });
	            self.store.list.forEach(function (order) {
	                if (!linkedOrders.some(function (l) {
	                    return l.id == order.id;
	                })) {
	                    linkedOrders.push(JSON.parse(JSON.stringify(order)));
	                    order.haulers.forEach(function (haul) {
	                        var order_linked = haul.linked_with.linked.filter(function (l) {
	                            return l.split("/")[0] != order.id;
	                        }).map(function (l) {
	                            return l.split("/")[0];
	                        });
	                        var linked_with = haul.linked_with.linked.map(function (l) {
	                            return l.split("/")[0];
	                        });
	                        order_linked.forEach(function (order_id) {
	                            if (haul.linked_with.linked.length > 1) {
	                                var linkedIndex = self.store.list.findIndex(function (order) {
	                                    return order.id == order_id;
	                                });
	                                if (linkedIndex) {
	                                    var linkedItem = self.store.list[linkedIndex];
	                                    linkedItem.linked_class = true;
	                                    linkedItem.linked_with = linked_with;
	                                    linkedOrders[linkedOrders.length - 1].linked = true;
	                                    linkedOrders[linkedOrders.length - 1].linked_class = true;
	                                    linkedOrders[linkedOrders.length - 1].linked_with = linked_with;
	                                    linkedOrders.push(JSON.parse(JSON.stringify(linkedItem)));
	                                }
	                            }
	                        });
	                    });
	                }
	            });
	            self.store.list = linkedOrders;
	        }
	    }, {
	        key: 'onMoved',
	        value: function onMoved($index) {
	            var self = this;
	            self.store.list.splice($index, 1);
	        }
	    }, {
	        key: 'updateLinkedOnDrop',
	        value: function updateLinkedOnDrop(item, itemIndex) {
	            var self = this;
	            item.linked_with.filter(function (l) {
	                return l != item.id;
	            }).forEach(function (l, index) {
	                var lIndex = self.store.list.findIndex(function (o) {
	                    return o.id == l;
	                });
	                var linkedElement = self.store.list.splice(lIndex, 1)[0];
	                self.store.list.splice(itemIndex + index + 1, 0, linkedElement);
	            });
	        }
	    }, {
	        key: 'onDrop',
	        value: function onDrop(event, index, item, external, type) {
	            var self = this;
	            item = self.store.restangularize(item);
	            var data = {
	                after: this.store.list[index - 1],
	                before: this.store.list[index]
	            };
	            self.saving = true;
	            item.customPUT(data, 'sort_order').then(function (i) {
	                // item.sort_order = i.sort_order
	                if (item.linked_with) self.updateLinkedOnDrop(item, index);
	                self.prepareLinkedOrders();
	            }).finally(function () {
	                self.saving = false;
	            });
	            return item;
	        }
	    }, {
	        key: 'loadMore',
	        value: function loadMore() {
	            var self = this;
	            this.store.loadMore().then(function () {
	                self.prepareLinkedOrders();
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.store = null;
	            this.$element.remove();
	            this.$element = null;
	        }
	        //ng-bind="order.applicators.length > 1 ? order.applicators[0].applicator.name+'...' : ''"></td>
	
	    }, {
	        key: 'orderApplicators',
	        value: function orderApplicators(order) {
	            console.log('order', order.applicators.length);
	            return order.applicators[0].title;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default order-sorted-list\">\n    <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Schedule Orders</h3>\n    </div>\n    <div loading-container=\"$ctrl.store.loading\">\n        <table class=\"table table-fixed table-sortable orders-table\">\n            <thead>\n            <tr>\n                <th></th>\n                <th>ID</th>\n                <th>Customer</th>\n                <th>Ship To</th>\n                <th>Crop</th>\n                <th>Analysis</th>\n                <th>Created</th>\n                <th>Applicators</th>\n                <th>Status</th>\n            </tr>\n            </thead>\n            <tbody dnd-list=\"$ctrl.store.list\"\n                   dnd-drop=\"$ctrl.onDrop(event, index, item, external, type)\"\n                   infinite-scroll=\"$ctrl.loadMore()\"\n                   infinite-scroll-disabled=\"$ctrl.store.loading || $ctrl.store.isEmpty\"\n                   infinite-scroll-immediate-check=\"true\"\n                   loading-container=\"$ctrl.store.loading\"\n            >\n                <tr ng-repeat=\"order in $ctrl.store.list\"\n                    dnd-draggable=\"order\"\n                    dnd-moved=\"$ctrl.onMoved($index)\"\n                    dnd-effect-allowed=\"move\"\n                    ng-class=\"{'linked-cell': order.linked_class}\"\n                >\n                    <td class=\"col-checkbox\" dnd-handle>:::</td>\n                    <td dnd-nodrag\n                        class=\"col-id\"\n                        data-title=\"'ID'\"\n                        sortable=\"'order_id'\"\n                        ng-class=\"{'linked-td': order.linked}\"\n                    >\n                        <a ui-sref=\"r.in.top.orders.detail({orderId: order.id})\" ng-bind=\"order.order_id\"></a>\n                        <span ng-if=\"order.linked\" class=\"fa fa-link lined_order_span\" ng-attr-title=\"{{'linked with: ' + order.linked_with}}\"></span>\n                    </td>\n                    <td dnd-nodrag>\n                        <span ng-bind=\"order.customer.title\"></span>\n                    </td>\n                    <td dnd-nodrag=\"\">\n                        <blnd-ship-to ng-model=\"order.fields\" mode=\"view\" customer=\"order.customer\"></blnd-ship-to>\n                    </td>\n                    <td dnd-nodrag\n                        class=\"col-crop\"\n                        ng-bind=\"order.crop.name || '-'\"></td>\n                    <td dnd-nodrag\n                        ng-bind=\"order.analysis || '-'\"></td>\n                    <td dnd-nodrag\n                        class=\"col-date\"\n                        ng-bind=\"order.created_at | blndDate\"></td>\n                    <td dnd-nodrag\n                        ng-bind=\"order.applicators.length > 1 ? order.applicators[0].applicator.name+' ...' : order.applicators[0].applicator.name\"></td>\n                    <td dnd-nodrag><blnd-order-status ng-model=\"order.status\" mode=\"view\"></blnd-order-status></td>\n                    <!-- dnd-nodrag has to be applied on all td elements :/ -->\n                </tr>\n                <tr class=\"dndPlaceholder\">\n                    <td colspan=\"7\">Drop here ...</td>\n                </tr>\n            </tbody>\n        </table>\n        <no-data =\"$ctrl.store.list.length === 0 && $ctrl.store.isEmpty\">No ready orders</no-data>\n    </div>\n</div>\n<div style=\"text-align: center; padding-bottom: 20px\" ng-show=\"$ctrl.store.loading\">\n    <span class=\"text-muted\">Loading... <i class=\"fa fa-spin fa-spinner\"></i></span>\n</div>\n"

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _decorators = __webpack_require__(331);
	
	var _customer = __webpack_require__(566);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _customers = __webpack_require__(603);
	
	var _customers2 = _interopRequireDefault(_customers);
	
	var _customerCard = __webpack_require__(605);
	
	var _customerCard2 = _interopRequireDefault(_customerCard);
	
	var _editModal = __webpack_require__(607);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	var _billing = __webpack_require__(608);
	
	var _billing2 = _interopRequireDefault(_billing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SplitBillingCtrl = function () {
	    SplitBillingCtrl.$inject = ["$uibModalInstance", "R", "object", "customers"];
	    function SplitBillingCtrl($uibModalInstance, R, object, customers) {
	        "ngInject";
	
	        _classCallCheck(this, SplitBillingCtrl);
	
	        this.R = R;
	        this.$modal = $uibModalInstance;
	        this.object = object;
	        this.customers = customers;
	        this.data = this.R.copy(this.customers);
	    }
	
	    _createClass(SplitBillingCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            this.object.one('billing').customPUT(this.data).then(function (data) {
	                self.$modal.close(data);
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Order #' + this.object.id + ' - ' + this.object.customer.title + ' #' + this.object.customer.id;
	        }
	    }]);
	
	    return SplitBillingCtrl;
	}();
	
	var BillingComponent = (_dec = (0, _decorators.Module)({
	    name: "app.directives.billing",
	    modules: [_customer2.default, _customers2.default, _customerCard2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-billing-component',
	    bindings: {
	        ngModel: '=',
	        editPerm: '<'
	    },
	    template: _billing2.default
	}), _dec(_class = _dec2(_class = function () {
	    BillingComponent.$inject = ["Modal", "$growl"];
	    function BillingComponent(Modal, $growl) {
	        "ngInject";
	
	        _classCallCheck(this, BillingComponent);
	
	        var self = this;
	        this.Modal = Modal;
	        this.$growl = $growl;
	        this.customers = [];
	
	        this.ngModel.all('billing').getList().then(function (data) {
	            self.customers = data;
	        });
	    }
	
	    _createClass(BillingComponent, [{
	        key: 'openSplitModal',
	        value: function openSplitModal() {
	            var _this = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: SplitBillingCtrl,
	                size: 'lg',
	                resolve: {
	                    object: function object() {
	                        return _this.ngModel;
	                    },
	                    customers: function customers() {
	                        return _this.customers;
	                    }
	                }
	            });
	
	            $modal.result.then(function (order) {
	                self.customers = order;
	                self.$growl.updated();
	            });
	        }
	    }]);
	
	    return BillingComponent;
	}()) || _class) || _class);
	exports.default = BillingComponent;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _customersCompontent = __webpack_require__(604);
	
	var _customersCompontent2 = _interopRequireDefault(_customersCompontent);
	
	var _customerCard = __webpack_require__(605);
	
	var _customerCard2 = _interopRequireDefault(_customerCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CustomersSplitList = (_dec = (0, _decorators.Module)({
	    name: "app.orders.compontents.customersSplitList",
	    modules: [_resource2.default, _customerCard2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-customer-split-list',
	    template: _customersCompontent2.default,
	    bindings: {
	        ngModel: '=',
	        mode: '@',
	        number: '@'
	    }
	}), _dec(_class = _dec2(_class = function () {
	    function CustomersSplitList() {
	        _classCallCheck(this, CustomersSplitList);
	    }
	
	    _createClass(CustomersSplitList, [{
	        key: 'addCustomer',
	        value: function addCustomer() {
	            if (!this.canAdd) {
	                return;
	            }
	
	            this.ngModel.push({
	                percentage: 50
	            });
	        }
	    }, {
	        key: 'removeCustomer',
	        value: function removeCustomer(customer) {
	            var index = this.ngModel.indexOf(customer);
	            this.ngModel.splice(index, 1);
	        }
	    }, {
	        key: 'canAdd',
	        get: function get() {
	            return this.ngModel.length < 1;
	        }
	    }]);
	
	    return CustomersSplitList;
	}()) || _class) || _class);
	exports.default = CustomersSplitList;

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"customer-split-billing\">\n    <div class=\"customer row\" ng-repeat=\"customer in $ctrl.ngModel\">\n        <div class=\"col-md-12\">\n            <div class=\"col-md-1\">\n               <div class=\"form-group-static\">\n                   <i class=\"fa fa-times clickable\" ng-click=\"$ctrl.removeCustomer(customer.customer)\"></i>\n               </div>\n            </div>\n            <div class=\"col-md-9\">\n                <div class=\"form-group form-group-sm\">\n                    <blnd-customer-picker ng-model=\"customer.customer\" mode=\"$ctrl.mode\"></blnd-customer-picker>\n                </div>\n            </div>\n            <div class=\"col-md-2\">\n                <div class=\"form-group form-group-sm\">\n                    <div class=\"input-group\">\n                        <input type=\"number\" step=\"0.01\" ng-model=\"customer.percentage\" class=\"form-control\" ng-disabled=\"1\" />\n                        <span class=\"input-group-addon\" id=\"basic-addon2\">%</span>\n                    </div>\n                </div>\n            </div>\n       </div>\n    </div>\n    <div class=\"row actions\">\n        <div class=\"col-md-12\">\n            <button class=\"btn btn-add\" ng-click=\"$ctrl.addCustomer()\" ng-show=\"$ctrl.canAdd\">Add</button>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _customerCardComponent = __webpack_require__(606);
	
	var _customerCardComponent2 = _interopRequireDefault(_customerCardComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CustomerCardComponent = (_dec = (0, _decorators.Module)({
	    name: "app.orders.compontents.customerCard",
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-customer-card',
	    template: _customerCardComponent2.default,
	    bindings: {
	        ngModel: '=',
	        primary: '=',
	        index: '=',
	        type: '@'
	    }
	}), _dec(_class = _dec2(_class = function CustomerCardComponent() {
	    _classCallCheck(this, CustomerCardComponent);
	}) || _class) || _class);
	exports.default = CustomerCardComponent;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"customer-card\" ng-if=\"$ctrl.type !== 'inline'\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div class=\"blnd-data-field\">\n                <div ng-if=\"$ctrl.primary\">Primary</div>\n                <div ng-if=\"!$ctrl.primary && $ctrl.index\">Split #{{ $ctrl.index }}</div>\n                <div>\n                    <a ui-sref=\"r.in.top.customers.detail({customerId: $ctrl.ngModel.customer.id})\" ng-bind=\"$ctrl.ngModel.customer.title\"></a>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-6\" ng-if=\"!$ctrl.primary\">\n            <div class=\"blnd-data-field\">\n                <div>Percentage</div>\n                <div ng-bind=\"$ctrl.ngModel.percentage\"></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"blnd-data-field\">\n                <div>Address</div>\n                <div>\n                    <span ng-bind=\"$ctrl.ngModel.customer.address.line1\"></span>\n                    <span ng-bind=\"$ctrl.ngModel.customer.address.line2\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-3\">\n            <div class=\"blnd-data-field\">\n                <div>City</div>\n                <div>\n                    <span ng-bind=\"$ctrl.ngModel.customer.address.city\"></span>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-3\">\n            <div class=\"blnd-data-field\">\n                <div>State</div>\n                <div>\n                    <span ng-bind=\"$ctrl.ngModel.customer.address.state\"></span>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-3\">\n            <div class=\"blnd-data-field\">\n                <div>Zip</div>\n                <div>\n                    <span ng-bind=\"$ctrl.ngModel.customer.address.zipcode\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"customer-card-inline\" ng-if=\"$ctrl.type === 'inline'\">\n    <div class=\"input-group\">\n        <span class=\"input-group-addon customer-id\" ng-bind=\"$ctrl.ngModel.customer.id\"></span>\n        <span class=\"form-control\">{{ $ctrl.ngModel.customer.title }}</span>\n    </div>\n</div>\n"

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <button\n        type=\"button\"\n        class=\"close\"\n        data-dismiss=\"modal\"\n        aria-label=\"Close\"\n        ng-click=\"vm.close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n</div>\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <div class=\"col-md-3\">\n            <div class=\"form-group form-group-sm\">\n                <label>Price Level</label>\n                <select class=\"form-control\" disabled>\n                    <option ng-bind=\"vm.object.price_level\"></option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"\">\n                <h4>Primary</h4>\n                <blnd-customer-card ng-model=\"vm.object\" primary=\"true\" type=\"inline\"></blnd-customer-card>\n            </div>\n            <div class=\"\">\n                <h4>Splits</h4>\n                <blnd-customer-split-list ng-model=\"vm.data\"></blnd-customer-split-list>\n            </div>\n        </div>\n    </div>\n\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n</div>\n"

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default blnd-panel\">\n    <div class=\"panel-body\">\n        <div class=\"top-right-corner\">\n            <button type=\"button\" class=\"btn btn-submit\" ng-click=\"$ctrl.openSplitModal()\" permission permission-only=\"$ctrl.editPerm\">Edit</button>\n        </div>\n\n        <!-- Primary Client -->\n        <blnd-customer-card ng-model=\"$ctrl.ngModel\" primary=\"true\"></blnd-customer-card>\n\n        <!-- Rest Clients -->\n        <blnd-customer-card ng-repeat=\"customer in $ctrl.customers\" ng-model=\"customer\" index=\"$index + 1\"></blnd-customer-card>\n\n    </div>\n</div>\n"

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _product = __webpack_require__(597);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _deliveryPicker = __webpack_require__(610);
	
	var _deliveryPicker2 = _interopRequireDefault(_deliveryPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var pl5_customer = ['apply_haul_itemized', 'haul_itemized'];
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.delivery.picker",
	    modules: [_product2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-delivery-picker',
	    bindings: {
	        ngModel: '=',
	        ngDisabled: '=',
	        mode: '@?',
	        ngChange: '&?',
	        data: '=?'
	    },
	    template: _deliveryPicker2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope", "$element", "Config", "ProductStore"];
	    function C($scope, $element, Config, ProductStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.scope = $scope;
	        this.$element = $element;
	        this.mode = this.mode || 'view';
	
	        this.productStore = ProductStore;
	        this.config = Config;
	
	        this.watcher = null;
	
	        if (_lodash2.default.isUndefined(this.data)) {
	            this.delivery = this.config.$config.delivery;
	        } else {
	            var is5PL = this.data.customer && this.data.customer.price_level === 5;
	            this.delivery = _lodash2.default.filter(this.config.$config.delivery, function (obj) {
	                var exists = pl5_customer.indexOf(obj[0]);
	                return obj[0] == 'pickup' || is5PL && exists >= 0 || !is5PL && exists === -1;
	            });
	        }
	
	        this.deliveryMap = _lodash2.default.fromPairs(this.delivery);
	    }
	
	    _createClass(C, [{
	        key: 'getName',
	        value: function getName() {
	            var self = this;
	            return self.deliveryMap[self.ngModel];
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var self = this;
	            this.watcher = this.scope.$watch(function () {
	                return self.ngModel;
	            }, function (newValue, oldValue) {
	                if (newValue === oldValue) {
	                    return;
	                }
	                if (!_lodash2.default.isUndefined(self.data)) {
	                    self.onDeliveryChange();
	                }
	
	                self.onChange();
	            }, true);
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            if (this.watcher) {
	                this.watcher();
	                this.watcher = null;
	            }
	            this.productStore = null;
	            this.$element.remove();
	            this.$element = null;
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            if (this.ngChange) {
	                this.ngChange();
	            }
	        }
	    }, {
	        key: 'onDeliveryChange',
	        value: function onDeliveryChange() {
	            var self = this;
	            var isExists = self.isAlreadyAdded();
	            var isDeliveryItemized = self.ngModel === 'apply_haul_itemized' || self.ngModel === 'haul_itemized';
	            var shouldAddProduct = self.data.customer.price_level === 5 && isDeliveryItemized && !isExists;
	
	            if (shouldAddProduct) {
	                var params = {
	                    extra_field: 'prices',
	                    company: self.data.company.id,
	                    price_level: self.data.customer.price_level,
	                    customer: self.data.customer.id
	                };
	                self.productStore.get(self.config.$config.application_product_id, params).then(function (response) {
	                    self.data.products.push({
	                        product: response,
	                        rate_acre: 1,
	                        quantity: self.data.acres
	                    });
	                });
	            } else if (isExists && !isDeliveryItemized) {
	                var idx = _lodash2.default.findIndex(self.data.products, function (o) {
	                    return o.product && o.product.id === self.config.$config.application_product_id;
	                });
	                self.data.products.splice(idx, 1);
	            }
	        }
	    }, {
	        key: 'isAlreadyAdded',
	        value: function isAlreadyAdded() {
	            return this.applicationProduct.length > 0;
	        }
	    }, {
	        key: 'applicationProduct',
	        get: function get() {
	            var self = this;
	            return _lodash2.default.filter(self.data.products, function (o) {
	                return o.product && o.product.id === self.config.$config.application_product_id;
	            });
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	module.exports = "<span ng-bind=\"$ctrl.getName()\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control\"\n        ng-class=\"$ctrl.inputClass\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-options=\"opt[0] as opt[1] for opt in $ctrl.delivery\"\n        ng-if=\"$ctrl.mode === 'edit'\">\n   <option value=\"\">Choose delivery ...</option>\n</select>\n"

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _priceSection = __webpack_require__(612);
	
	var _priceSection2 = _interopRequireDefault(_priceSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.compontents.price.table"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-price-table',
	    template: _priceSection2.default,
	    bindings: {
	        fertTotalCost: '<',
	        productTotalCost: '<',
	        isCalculating: '<',
	        data: '='
	    }
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope", "$element"];
	    function C($scope, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.scope = $scope;
	        this.$element = $element;
	        this.costPerAcre = 0;
	        this.costPerTon = 0;
	        this.totalCost = 0;
	        this.fertTotalCost = 0;
	        this.productTotalCost = 0;
	        this.watcher = null;
	    }
	
	    _createClass(C, [{
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            this.productTotalCost = this.productTotalCost || 0;
	            this.fertTotalCost = this.fertTotalCost || 0;
	            if (!this.isCalculating) {
	                this.calc();
	            }
	        }
	    }, {
	        key: 'calc',
	        value: function calc() {
	            var acres = this.data.acres || 0;
	            var totalCost = this.fertTotalCost + this.productTotalCost;
	
	            this.costPerAcre = acres === 0 ? 0 : totalCost / acres;
	
	            var quantity = this.data.quantity || 0;
	            if (this.data.water_gallons) {
	                quantity = quantity / 2000;
	            }
	
	            if (this.productTotalCost) {
	                this.totalCost = totalCost;
	                this.costPerTon = quantity === 0 ? 0 : this.productTotalCost / quantity + this.fertTotalCost / quantity;
	            } else {
	                this.totalCost = this.fertTotalCost;
	                this.costPerTon = quantity === 0 ? 0 : this.fertTotalCost / quantity;
	            }
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var self = this;
	            this.watcher = this.scope.$watch(function () {
	                return self.data.water_gallons;
	            }, function () {
	                self.calc();
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            if (this.watcher) {
	                this.watcher();
	                this.watcher = null;
	            }
	            this.$element.remove();
	            this.$element = null;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table price-table\">\n    <tbody>\n        <tr>\n            <td class=\"title\">Per Acre:</td>\n            <td class=\"value\">${{ $ctrl.costPerAcre | number: 2 }}</td>\n        </tr>\n        <tr>\n            <td class=\"title\">Per Ton:</td>\n            <td class=\"value\">${{ $ctrl.costPerTon | number: 2 }}</td>\n        </tr>\n        <tr>\n            <td class=\"title\">Total:</td>\n            <td class=\"value\">${{ $ctrl.totalCost | number: 2 }}</td>\n        </tr>\n    </tbody>\n</table>\n"

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	__webpack_require__(614);
	
	var _decorators = __webpack_require__(331);
	
	var _files = __webpack_require__(522);
	
	var _modals = __webpack_require__(532);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _token = __webpack_require__(499);
	
	var _token2 = _interopRequireDefault(_token);
	
	var _file = __webpack_require__(556);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _mimetype = __webpack_require__(616);
	
	var _mimetype2 = _interopRequireDefault(_mimetype);
	
	var _uploadSection = __webpack_require__(617);
	
	var _uploadSection2 = _interopRequireDefault(_uploadSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.upload",
	    modules: [_token2.default, _file2.default, _modals2.default, 'ngFileUpload', _mimetype2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-upload-section',
	    bindings: {
	        ngModel: '=',
	        type: '@'
	    },
	    template: _uploadSection2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$growl", "$cookies", "TokenService", "Modal", "Upload", "FileStore"];
	    function C($growl, $cookies, TokenService, Modal, Upload, FileStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$growl = $growl;
	        this.Modal = Modal;
	        this.store = FileStore;
	        this.store.init();
	        this.store.params.type = this.type;
	        this.store.params.object_id = this.ngModel.id;
	        this.store.refresh();
	        this.fileUpload = new _files.FileUpload($cookies, TokenService, FileStore, Upload);
	    }
	
	    _createClass(C, [{
	        key: 'deleteFile',
	        value: function deleteFile(name, id) {
	            var self = this;
	            var $modal = self.Modal.openConfirmDelete({
	                text: 'Are you sure to delete file ' + name + ' ?'
	            });
	            $modal.wait.then(function (result) {
	                self.store.remove(id).then(function () {
	                    result.close();
	                    self.$growl.deleted();
	                });
	            });
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 614 */,
/* 615 */,
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.orders.compontents.mimetype.icon"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-mimetype-icon',
	    template: '<i class="fa {{ $ctrl.icon }}" aria-hidden="true"></i>',
	    bindings: {
	        ngModel: '='
	    }
	}), _dec(_class = _dec2(_class = function () {
	    function C() {
	        _classCallCheck(this, C);
	
	        this.IconMapping = {
	            // Images
	            'image': 'fa-file-image-o',
	            // Audio
	            'audio': 'fa-file-audio-o',
	            // Video
	            'video': 'fa-file-video-o',
	            // Documents
	            'application/pdf': 'fa-file-pdf-o',
	            'text/plain': 'fa-file-text-o',
	            'text/html': 'fa-file-code-o',
	            'application/json': 'fa-file-code-o',
	            // Archives
	            'application/gzip': 'fa-file-archive-o',
	            'application/zip': 'fa-file-archive-o',
	            // Misc
	            'application/octet-stream': 'fa-file-o'
	        };
	
	        this.icon = this.getIcon(this.ngModel);
	    }
	
	    _createClass(C, [{
	        key: 'getIcon',
	        value: function getIcon(mimetype) {
	            if (this.IconMapping[mimetype]) {
	                return this.IconMapping[mimetype];
	            }
	
	            var _mimetype$split = mimetype.split('/'),
	                _mimetype$split2 = _toArray(_mimetype$split),
	                group = _mimetype$split2[0],
	                rest = _mimetype$split2.slice(1);
	
	            if (this.IconMapping[group]) {
	                return this.IconMapping[group];
	            }
	
	            return 'fa-file-o';
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"upload-component\">\n    <div class=\"drag-and-drop\"\n         ngf-drop=\"$ctrl.fileUpload.uploadFiles($files)\"\n         ngf-drag-over-class=\"'dragover'\"\n         ngf-multiple=\"true\">\n        <p>\n            <button class=\"btn btn-primary\"\n                    ngf-multiple=\"true\"\n                    ngf-select=\"$ctrl.fileUpload.uploadFiles($files)\">Choose files</button>\n            <span>or</span>\n            drag and drop files here\n        </p>\n    </div>\n    <div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div>\n\n    <div class=\"browse-files-container\">\n        <ul class=\"list-unstyled browse-files\">\n            <li class=\"\" tabindex=\"-1\" ng-repeat=\"f in $ctrl.store.list\">\n                <div class=\"browse-file-row\" ng-if=\"!f.$uploading\">\n                    <div class=\"file-actions\">\n                        <a ng-click=\"$ctrl.deleteFile(f.name, f.id)\" href=\"\" class=\"delete\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a>\n                    </div>\n                    <div class=\"file-icon\"><blnd-mimetype-icon ng-model=\"f.mime_type\"></blnd-mimetype-icon></div>\n                    <div class=\"file-name\">\n                        <a class=\"file-link\" ng-href=\"{{ f.file }}\"><span>{{ f.name }}</span></a> ({{ f.size_display }})\n                    </div>\n                </div>\n                <div class=\"browse-file-row\" ng-if=\"f.$uploading\">\n                    <div class=\"file-icon\"><i class=\"fa fa-refresh fa-spin fa-fw\"></i></div>\n                    <div class=\"file-name\" ng-if=\"f.$uploading\">{{ f.name }}</div>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _moment = __webpack_require__(366);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _decorators = __webpack_require__(331);
	
	var _activity = __webpack_require__(619);
	
	var _activity2 = _interopRequireDefault(_activity);
	
	var _activity3 = __webpack_require__(620);
	
	var _activity4 = _interopRequireDefault(_activity3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.activity",
	    modules: [_activity2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-activity',
	    bindings: {
	        object: '<'
	    },
	    template: _activity4.default
	}), _dec(_class = _dec2(_class = ["ActivityStore", function C(ActivityStore) {
	    "ngInject";
	
	    _classCallCheck(this, C);
	
	    this.store = ActivityStore.getNew(this.object);
	}]) || _class) || _class);
	exports.default = C;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.activity',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('ActivityStore'), _dec(_class = _dec2(_class = function () {
	    Store.$inject = ["$q", "R"];
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        this.$q = $q;
	        this.R = R;
	    }
	
	    _createClass(Store, [{
	        key: 'getNew',
	        value: function getNew(object) {
	            var store = new _base2.default(this.$q, this.R);
	            store.endpoint = object.all('activity');
	            return store;
	        }
	    }]);
	
	    return Store;
	}()) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row activity-list\">\n    <div class=\"col-md-12\">\n        <ul class=\"list-group\"\n            loading-container=\"$ctrl.store.loading\"\n            infinite-scroll=\"$ctrl.store.loadMore()\"\n            infinite-scroll-disabled=\"$ctrl.store.loading || $ctrl.store.isEmpty\"\n        >\n            <li class=\"list-group-item activity-item-container\" ng-repeat=\"activity in $ctrl.store.list\">\n                <div class=\"activity-item\">\n                    <div class=\"top\">\n                        <div class=\"message\">\n                            <span ng-bind=\"activity.user.title\"></span>\n                            <span ng-bind=\"activity.message\"></span>\n                        </div>\n                        <div class=\"timeago\">\n                            <span ng-bind=\"activity.created_at | blndDt\"></span>\n                        </div>\n                    </div>\n                    <div class=\"updates row\" ng-if=\"activity.field_changes.length > 0\">\n                        <div class=\"col-md-12\">\n                            <table class=\"table\">\n                                <thead>\n                                <tr>\n                                    <th>Field</th>\n                                    <th>Original Value</th>\n                                    <th>New Value</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr ng-repeat=\"change in activity.field_changes\">\n                                    <td ng-bind=\"change.field\"></td>\n                                    <td class=\"field_value\" ng-bind=\"change.old_value\"></td>\n                                    <td class=\"field_value\" ng-bind=\"change.new_value | blndDt\"></td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <div class=\"updates row\" ng-if=\"activity.presets.length > 0\">\n                        <div class=\"col-md-12\">\n                            <table class=\"table\">\n                                <thead>\n                                    <tr>\n                                        <th>Preset Name</th>\n                                        <th>Write Tag</th>\n                                        <th>Preset Code</th>\n                                        <th>Preset</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr ng-repeat=\"p in activity.presets\">\n                                        <td ng-bind=\"p.preset_name || '-'\"></td>\n                                        <td ng-bind=\"p.write_tag\"></td>\n                                        <td ng-bind=\"p.preset_code\"></td>\n                                        <td ng-bind=\"p.preset_value\"></td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _confirmModal = __webpack_require__(622);
	
	var _confirmModal2 = _interopRequireDefault(_confirmModal);
	
	var _statusButton = __webpack_require__(623);
	
	var _statusButton2 = _interopRequireDefault(_statusButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfirmationModalCtrl = function () {
	    ConfirmationModalCtrl.$inject = ["$q", "$growl", "$uibModalInstance", "status", "objects", "tableCtrl"];
	    function ConfirmationModalCtrl($q, $growl, $uibModalInstance, status, objects, tableCtrl) {
	        "ngInject";
	
	        _classCallCheck(this, ConfirmationModalCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.$q = $q;
	        this.$growl = $growl;
	
	        this.status = status;
	        this.objects = objects;
	        this.tableCtrl = tableCtrl;
	        this.loading = false;
	    }
	
	    _createClass(ConfirmationModalCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.loading = true;
	            self.errors = [];
	
	            var promises = _lodash2.default.map(self.objects, function (obj, idx) {
	                var $promise = obj.patch({ status: self.status.value });
	
	                return $promise.then(function (response) {
	                    // successful
	                    _angular2.default.extend(obj, response);
	                    if (self.tableCtrl) {
	                        delete self.tableCtrl.checked[obj.id];
	                    }
	                }, function (response) {
	                    // error
	                    var errMessage = void 0;
	                    if (response.status === 400) {
	                        errMessage = Object.keys(response.data).reduce(function (result, key, idx) {
	                            return idx === 0 ? response.data[key].join(", ") : result + response.data[key].join(", ");
	                        }, "");
	                    }
	                    if (response.status === 500) {
	                        errMessage = response.data.detail;
	                    }
	                    var err = { object: obj, message: errMessage };
	                    self.errors.push(err);
	                });
	            });
	
	            self.$q.all(promises).then(function () {
	                if (self.errors.length > 0) {
	                    // After click take only with errors
	                    self.objects = _lodash2.default.map(self.errors, function (o) {
	                        return o.object;
	                    });
	                    return;
	                }
	                self.$modal.close(true);
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Confirm';
	        }
	    }]);
	
	    return ConfirmationModalCtrl;
	}();
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.status.button.component"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-status-button',
	    template: _statusButton2.default,
	    bindings: {
	        ngModel: '=',
	        ngDisabled: '=?',
	        type: "@",
	        multiple: "=?",
	        table: '<'
	    }
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$growl", "$element", "R", "Modal", "Config", "PermPermissionStore"];
	    function C($growl, $element, R, Modal, Config, PermPermissionStore) {
	        "ngInject";
	
	        var _this = this;
	
	        _classCallCheck(this, C);
	
	        this.$growl = $growl;
	        this.$element = $element;
	
	        if (_lodash2.default.indexOf(['order', 'ticket'], this.type) === -1) {
	            throw 'Invalid type for statuses';
	        }
	
	        this.R = R;
	        this.Modal = Modal;
	
	        this.multiple = this.multiple || false;
	        this.allStatuses = Config.$config[this.type].statuses;
	        this.statuses = this.allStatuses.filter(function (element) {
	            return element[0] === _this.$element.status;
	        });
	
	        this.limitStatusChoices = function () {
	            if (_this.type == "order") {
	                _this.statuses = _this.allStatuses;
	                _this.statusMap = _lodash2.default.fromPairs(_this.statuses);
	                return;
	            }
	
	            _this.statuses = _this.allStatuses.filter(function (element) {
	                return element[0] === _this.ngModel.status;
	            });
	            if (_this.ngModel.status === "pending" && PermPermissionStore.hasPermissionDefinition("main.can_ticket_status_only_pending_to_ready_to_bill")) {
	                var _statuses;
	
	                (_statuses = _this.statuses).push.apply(_statuses, _toConsumableArray(_this.allStatuses.filter(function (element) {
	                    return element[0] === "ready_to_bill";
	                })));
	            }
	            if (_this.ngModel.status === "mixed" && PermPermissionStore.hasPermissionDefinition("main.can_ticket_status_only_mixed_to_ready_to_bill")) {
	                var _statuses2;
	
	                (_statuses2 = _this.statuses).push.apply(_statuses2, _toConsumableArray(_this.allStatuses.filter(function (element) {
	                    return element[0] === "ready_to_bill";
	                })));
	            }
	
	            if (PermPermissionStore.hasPermissionDefinition("main.can_change_ticket_status_freely")) {
	                _this.statuses = _this.allStatuses;
	            } else {
	                var currentStatusPair = _this.allStatuses.find(function (status) {
	                    return status === _this.ngModel.status;
	                });
	                var currentStatusIndex = _this.allStatuses.indexOf(currentStatusPair);
	                _this.statuses = _this.statuses.filter(function (_, index) {
	                    return index >= currentStatusIndex;
	                });
	            }
	            _this.statusMap = _lodash2.default.fromPairs(_this.statuses);
	        };
	
	        this.limitStatusChoices();
	        this.ngDisabled = this.ngDisabled || false;
	        this.loading = false;
	    }
	
	    _createClass(C, [{
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.$element.remove();
	            this.$element = null;
	        }
	    }, {
	        key: 'changeStatus',
	        value: function changeStatus(newStatus) {
	            if (this.multiple) {
	                this.changeMultipleObjects(newStatus);
	                return;
	            }
	            this.changeSingleObject(newStatus);
	        }
	    }, {
	        key: 'changeSingleObject',
	        value: function changeSingleObject(newStatus) {
	            var self = this;
	            self.loading = true;
	
	            var $modal = self.Modal.open({
	                template: _confirmModal2.default,
	                controller: ConfirmationModalCtrl,
	                resolve: {
	                    status: function status() {
	                        return {
	                            value: newStatus,
	                            label: self.getLabel(newStatus)
	                        };
	                    },
	                    objects: function objects() {
	                        return [self.ngModel];
	                    },
	                    tableCtrl: function tableCtrl() {
	                        return undefined;
	                    }
	                }
	            });
	
	            $modal.result.then(function (result) {
	                if (result) {
	                    self.limitStatusChoices();
	                    self.$growl.success('Status Changed!');
	                }
	            });
	            self.loading = false;
	        }
	    }, {
	        key: 'changeMultipleObjects',
	        value: function changeMultipleObjects(newStatus) {
	            var self = this;
	            var $modal = self.Modal.open({
	                template: _confirmModal2.default,
	                controller: ConfirmationModalCtrl,
	                resolve: {
	                    status: function status() {
	                        return {
	                            value: newStatus,
	                            label: self.getLabel(newStatus)
	                        };
	                    },
	                    objects: function objects() {
	                        return self.ngModel;
	                    },
	                    tableCtrl: function tableCtrl() {
	                        return self.table;
	                    }
	                }
	            });
	
	            $modal.result.then(function (result) {
	                if (result) {
	                    self.$growl.success('Statuses updated!');
	                }
	            });
	        }
	    }, {
	        key: 'getLabel',
	        value: function getLabel(status) {
	            return this.statusMap[status];
	        }
	    }, {
	        key: 'label',
	        get: function get() {
	            return this.getLabel(this.ngModel.status);
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\">\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                Do you want to change ticket status to <strong ng-bind=\"vm.status.label\"></strong> ?\n            </div>\n        </div>\n        <div class=\"row top-space\" ng-if=\"vm.errors.length > 0\">\n            <div class=\"col-md-12\">\n                <h5>Could not update status for:</h5>\n                <ul>\n                    <li ng-repeat=\"(key, value) in vm.errors\">\n                        <span>#{{ value.object.ticketnumber || value.object.id }}</span>\n                        <span class=\"text-danger\" ng-if=\"value.message\" ng-bind=\"value.message\"></span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ladda=\"vm.loading\" data-testid=\"ticket-status-change-button\" ng-click=\"vm.submit()\">{{ vm.errors.length > 0 && 'Try Again' || 'Change' }}</button>\n        <button class=\"btn btn-default\" type=\"button\" data-testid=\"ticket-status-cancel-button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"btn-group\" uib-dropdown>\n    <button type=\"button\" class=\"btn\" data-testid=\"status-button\" ng-disabled=\"$ctrl.statuses.length == 1 || $ctrl.ngDisabled\"\n        ng-class=\"{'btn-primary': !$ctrl.multiple, 'btn-default': $ctrl.multiple}\" ladda=\"$ctrl.loading\"\n        uib-dropdown-toggle>\n        <span ng-if=\"!$ctrl.multiple\">{{ $ctrl.label }} &nbsp; <span ng-if=\"$ctrl.statuses.length != 1\"\n                class=\"caret\"></span></span>\n        <span ng-if=\"$ctrl.multiple\">Choose status &nbsp; <span class=\"caret\"></span></span>\n    </button>\n    <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\n        <li ng-repeat=\"(key, label) in $ctrl.statusMap\">\n            <a ng-if=\"$ctrl.multiple || key !== $ctrl.ngModel.status\" href=\"#\" ng-click=\"$ctrl.changeStatus(key)\"\n                ng-bind=\"label\"></a>\n        </li>\n    </ul>\n</div>\n"

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _hitPercentageButton = __webpack_require__(625);
	
	var _hitPercentageButton2 = _interopRequireDefault(_hitPercentageButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	  name: "app.directives.hit-percentage.button.component"
	}), _dec2 = (0, _decorators.Component)({
	  selector: "blnd-hit-percentage-button",
	  template: _hitPercentageButton2.default,
	  bindings: {
	    ngModel: "=",
	    ngDisabled: "=?",
	    type: "@",
	    multiple: "=?",
	    table: "<"
	  }
	}), _dec(_class = _dec2(_class = function () {
	  C.$inject = ["$growl", "$element", "R", "Modal", "Config"];
	  function C($growl, $element, R, Modal, Config) {
	    "ngInject";
	
	    _classCallCheck(this, C);
	
	    this.$growl = $growl;
	    this.$element = $element;
	
	    if (_lodash2.default.indexOf(["order", "ticket"], this.type) === -1) {
	      throw "Invalid type for Hit Percentages";
	    }
	    this.R = R;
	    this.Modal = Modal;
	    this.multiple = this.multiple || false;
	    this.hitPercentages = Config.$config[this.type].hit_percentages;
	    this.hitPercentageMap = _lodash2.default.fromPairs(this.hitPercentages);
	    this.ngDisabled = this.ngDisabled || false;
	    this.loading = false;
	  }
	
	  _createClass(C, [{
	    key: "$onDestroy",
	    value: function $onDestroy() {
	      this.$element.remove();
	      this.$element = null;
	    }
	  }, {
	    key: "changeHitPercentage",
	    value: function changeHitPercentage(newHitPercentage) {
	      var _this = this;
	
	      this.loading = true;
	      this.ngModel.patch({ hit_percentage: newHitPercentage }).then(function (response) {
	        _angular2.default.extend(_this.ngModel, response);
	        _this.$growl.success("Status Changed!");
	      }, function (response) {
	        if (response.status === 500) {
	          _this.$growl.error(response.data.detail);
	        }
	      }).finally(function () {
	        return _this.loading = false;
	      });
	    }
	  }]);
	
	  return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"btn-group\" uib-dropdown>\n    <button type=\"button\" class=\"btn\" ng-disabled=\"$ctrl.ngDisabled\"\n        ng-class=\"{'btn-primary': !$ctrl.multiple, 'btn-default': $ctrl.multiple}\" ladda=\"$ctrl.loading\"\n        uib-dropdown-toggle>\n        <span ng-if=\"$ctrl.ngModel.hit_percentage>0\">Hit percentage: {{ $ctrl.ngModel.hit_percentage }}% &nbsp; <span\n                class=\"caret\"></span></span>\n        <span ng-if=\"$ctrl.ngModel.hit_percentage==null\">Don't use for forecasting &nbsp; <span\n                class=\"caret\"></span></span>\n        <span ng-if=\"$ctrl.multiple\">Choose hit percentage &nbsp; <span class=\"caret\"></span></span>\n    </button>\n    <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\n        <li ng-repeat=\"(key, label) in $ctrl.hitPercentageMap\">\n            <a ng-if=\"key !== $ctrl.ngModel.hit_percentage\" href=\"#\" ng-click=\"$ctrl.changeHitPercentage(key)\"\n                ng-bind=\"label\"></a>\n        </li>\n    </ul>\n</div>\n"

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _printButton = __webpack_require__(627);
	
	var _printButton2 = _interopRequireDefault(_printButton);
	
	var _ctrls = __webpack_require__(544);
	
	var _modalList = __webpack_require__(545);
	
	var _modalList2 = _interopRequireDefault(_modalList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.print.button.component"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-print-button',
	    template: _printButton2.default,
	    bindings: {
	        ngModel: '=',
	        ngDisabled: '=?',
	        type: "@",
	        multiple: "=?",
	        table: '<'
	    }
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$growl", "Modal"];
	    function C($growl, Modal) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$growl = $growl;
	        this.Modal = Modal;
	    }
	
	    _createClass(C, [{
	        key: 'print',
	        value: function print(type) {
	            var self = this;
	
	            var $modal = this.Modal.open({
	                template: _modalList2.default,
	                controller: _ctrls.PrinterListModalCtrl,
	                size: 'large',
	                resolve: {
	                    company: function company() {
	                        return _lodash2.default.first(self.ngModel).company.id;
	                    },
	                    request: function request() {
	                        return {
	                            endpoint: undefined,
	                            type: type,
	                            orders: self.ngModel,
	                            multiple: true
	                        };
	                    }
	                }
	            });
	
	            $modal.result.then(function (data) {
	                var msg = data === 1 ? '1 file' : data + ' files';
	                self.$growl.success('Added ' + msg + ' to queue');
	            });
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"btn-group\" uib-dropdown>\n    <button type=\"button\"\n            class=\"btn\"\n            ng-disabled=\"$ctrl.ngDisabled\"\n            ng-class=\"{'btn-primary': !$ctrl.multiple, 'btn-default': $ctrl.multiple}\"\n            ladda=\"$ctrl.loading\"\n            uib-dropdown-toggle>\n        Print <span class=\"caret\"></span>\n    </button>\n    <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" >\n        <li role=\"menuitem\">\n            <a href=\"#\" ng-click=\"$ctrl.print('estimate')\">Estimate</a>\n        </li>\n        <li role=\"menuitem\">\n            <a href=\"#\" ng-click=\"$ctrl.print('form')\">Form</a>\n        </li>\n    </ul>\n</div>\n"

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _chemical = __webpack_require__(629);
	
	var _chemical2 = _interopRequireDefault(_chemical);
	
	var _chemicalProgramPicker = __webpack_require__(630);
	
	var _chemicalProgramPicker2 = _interopRequireDefault(_chemicalProgramPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pintsUnits = ['GAL', 'GALS'];
	var convertionGallonsToPints = 8;
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.chemical.program",
	    modules: [_chemical2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-chemical-program-picker',
	    bindings: {
	        ngModel: '=',
	        company: '<',
	        customer: '<',
	        products: '=',
	        acres: '<?',
	        ngChanged: '&?'
	    },
	    template: _chemicalProgramPicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["$timeout", "Config", "$element", "ChemicalProgramStore", "Modal"];
	    _inherits(C, _BasePicker);
	
	    function C($timeout, Config, $element, ChemicalProgramStore, Modal) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.internalModel = _this.ngModel ? _this.ngModel : '';
	        _this.Modal = Modal;
	        _this.placeholder = 'Choose Chemical Program';
	        _this.acres = _this.acres || 0;
	        _this.$timeout = $timeout;
	        _this.config = Config;
	
	        _this.store = ChemicalProgramStore;
	        _this.store.init();
	
	        _this.store.params = {
	            company: _this.company.id,
	            is_active: true
	        };
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: 'addProducts',
	        value: function addProducts() {
	            var self = this;
	            var params = {
	                company: this.company.id,
	                extra_field: ['prices']
	            };
	
	            if (this.customer) {
	                params.customer = this.customer.id;
	                params.price_level = this.customer.price_level;
	            }
	
	            this.store.get(this.internalModel.id, params).then(function (response) {
	                self.$timeout(function () {
	                    var applicationRowProduct = _lodash2.default.find(self.products, function (obj) {
	                        return obj.product.id == self.config.$config.application_product_id;
	                    });
	                    var products = _lodash2.default.map(response.products, function (obj) {
	                        var div = pintsUnits.indexOf(obj.product.units.id) >= 0 ? 8 : 1;
	                        var quantity = _lodash2.default.round(self.acres * obj.rate / div, 2);
	                        return {
	                            product: obj.product,
	                            rate_acre: obj.rate,
	                            quantity: _lodash2.default.isNaN(quantity) ? 0 : quantity
	                        };
	                    });
	
	                    if (applicationRowProduct) {
	                        products.push(applicationRowProduct);
	                    }
	
	                    self.products = products;
	                });
	            });
	        }
	    }, {
	        key: 'onRemove',
	        value: function onRemove() {
	            this.ngModel = angular.copy(this.internalModel);
	        }
	    }, {
	        key: 'confirmModal',
	        value: function confirmModal() {
	            this.ngModel = angular.copy(this.internalModel);
	            this.addProducts();
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.chemical.program',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('ChemicalProgramStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('chemical-programs');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\">\n    <div class=\"row\">\n        <div class=\"col-md-8\">\n            <ui-select ng-model=\"$ctrl.internalModel\"\n                       theme=\"bootstrap\"\n                       class=\"input-sm\"\n                       ng-click=\"$ctrl.onClick()\"\n                       allow-remove\n                       on-remove=\"$ctrl.onRemove($item, $model)\"\n                       on-select=\"$ctrl.onSelect($item, $model)\"\n                       prevent-animations>\n                <ui-select-match prevent-animations placeholder=\"{{ $ctrl.placeholder }}\">{{  $select.selected.title }}</ui-select-match>\n                <ui-select-choices\n                        repeat=\"object in $ctrl.store.list | filter: $select.search\"\n                        refresh=\"$ctrl.refresh($select.search, $select)\"\n                        refresh-delay=\"100\"\n                        prevent-animations>\n                    <div ng-bind=\"object.title\"></div>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n        <div class=\"col-md-4\">\n            <button class=\"btn btn-add btn-sm btn-block\" type=\"button\" ng-click=\"$ctrl.confirmModal()\">Select Program</button>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _acresCalcControl = __webpack_require__(632);
	
	var _acresCalcControl2 = _interopRequireDefault(_acresCalcControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.acres.calc.control",
	    modules: []
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-acres-control',
	    bindings: {
	        ngModel: '=',
	        ngChange: '&'
	    },
	    template: _acresCalcControl2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$timeout"];
	    function C($timeout) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$timeout = $timeout;
	    }
	
	    _createClass(C, [{
	        key: 'toggle',
	        value: function toggle() {
	            this.ngModel = !this.ngModel;
	            this.ngChange({ isChanged: this.ngModel });
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	module.exports = "<i class=\"fa fa-chain-broken clickable text-danger\"\n   aria-hidden=\"true\"\n   title=\"Automatic calculation is off.\"\n   ng-show=\"$ctrl.ngModel\"\n   ng-click=\"$ctrl.toggle()\">\n</i>\n<i class=\"fa fa-link clickable text-primary\"\n   aria-hidden=\"true\"\n   title=\"Automatic calculation in on.\"\n   ng-show=\"!$ctrl.ngModel\"\n   ng-click=\"$ctrl.toggle()\">\n</i>\n"

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _signature2 = __webpack_require__(634);
	
	var _signature3 = _interopRequireDefault(_signature2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SecureUrlService = (_dec = (0, _decorators.Module)({
	  name: "app.services.secure.url.generator",
	  modules: [_signature3.default]
	}), _dec2 = (0, _decorators.Service)("SecureUrlService"), _dec(_class = _dec2(_class = function () {
	  SecureUrlService.$inject = ["$q", "$window", "$httpParamSerializer", "SignatureService", "$http"];
	  function SecureUrlService($q, $window, $httpParamSerializer, SignatureService, $http) {
	    "ngInject";
	
	    _classCallCheck(this, SecureUrlService);
	
	    this.signatureService = SignatureService;
	    this.$q = $q;
	    this.$httpParamSerializer = $httpParamSerializer;
	    this.$window = $window;
	    this.$http = $http;
	  }
	
	  _createClass(SecureUrlService, [{
	    key: "generateUrl",
	    value: function generateUrl(object, qs) {
	      var self = this;
	      var urlPromise = self.$q.defer();
	
	      self.signatureService.get().then(function (signature) {
	        var url = object.getRequestedUrl();
	        var params = qs || {};
	        params = _lodash2.default.extend(params, { signature: signature });
	        var query = self.$httpParamSerializer(params);
	
	        urlPromise.resolve(url + "?" + query);
	      });
	
	      return urlPromise.promise;
	    }
	  }, {
	    key: "generateMixCalculatorPdf",
	    value: function generateMixCalculatorPdf(object, qs) {
	      var _this = this;
	
	      var self = this;
	
	      var response = self.signatureService.get().then(function (signature) {
	        var url = object.getRequestedUrl();
	        var params = qs || {};
	        params = _lodash2.default.extend(params, { signature: signature });
	
	        // replace ';' for ',' because the semicolon is not supported in the paramSerializer
	        params.products.forEach(function (product) {
	          if (product.product.dot) {
	            product.product.dot = product.product.dot.replaceAll(';', ',');
	          }
	        });
	
	        var query = self.$httpParamSerializer(params);
	        var _signature = self.$httpParamSerializer({ signature: signature });
	
	        var promise = _this.$http({
	          method: "POST",
	          url: url + "?" + _signature,
	          data: query,
	          headers: { "Content-Type": "application/x-www-form-urlencoded" },
	          responseType: "arraybuffer"
	        }).then(function (_response) {
	          return _response;
	        });
	        return promise;
	      });
	      return response;
	    }
	  }, {
	    key: "openInNewWindow",
	    value: function openInNewWindow(object, qs) {
	      var self = this;
	
	      if (typeof qs === 'undefined' || !qs.acres) {
	        self.generateUrl(object, qs).then(function (url) {
	          self.$window.open(url, "_blank");
	        });
	      } else {
	        self.generateMixCalculatorPdf(object, qs).then(function (url) {
	          var file = new Blob([url.data], { type: "application/pdf" });
	          var fileURL = URL.createObjectURL(file);
	          self.$window.open(fileURL, "_blank");
	        });
	      }
	    }
	  }, {
	    key: "redirect",
	    value: function redirect(object, qs) {
	      var self = this;
	      self.generateUrl(object, qs).then(function (url) {
	        self.$window.location = url;
	      });
	    }
	  }]);
	
	  return SecureUrlService;
	}()) || _class) || _class);
	exports.default = SecureUrlService;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignatureService = (_dec = (0, _decorators.Module)({
	    name: 'app.services.signature',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('SignatureService'), _dec(_class = _dec2(_class = function () {
	    SignatureService.$inject = ["R"];
	    function SignatureService(R) {
	        "ngInject";
	
	        _classCallCheck(this, SignatureService);
	
	        this.R = R;
	        this.endpoint = this.R.all('signature');
	    }
	
	    _createClass(SignatureService, [{
	        key: 'get',
	        value: function get() {
	            return this.endpoint.post().then(function (resp) {
	                return resp.signature;
	            });
	        }
	    }]);
	
	    return SignatureService;
	}()) || _class) || _class);
	exports.default = SignatureService;

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"order-list-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"flip-container\">\n                <div class=\"page flip\" ui-view></div>\n            </div>\n        </div>\n    </div>\n        <div id=\"create-button\"\n            data-testid=\"order-create-button\"\n            class=\"bottom-right-icon-button\"\n            permission permission-only=\"'main.add_order'\">\n        <div class=\"btn btn-primary btn-fab\"\n             role=\"button\"\n             title=\"Create new order\"\n             aria-label=\"Create new order\"\n             ng-click=\"vm.openAddModal()\">\n            <i class=\"btn-icon fa fa-plus\" aria-hidden=\"true\"></i>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"order-details\">\n    <ul class=\"nav nav-tabs\">\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.orders.detail.order\">Order</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.orders.detail.billing\">Billing</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.orders.detail.files\">Files</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.orders.detail.notes\">Notes</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.orders.detail.log\">Log</a></li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.add_order'\">\n            <button type=\"button\" class=\"btn btn-primary\" data-testid=\"order-copy-button\" ng-click=\"vmo.cloneOrder()\">\n                Copy\n            </button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.add_order'\">\n            <div class=\"btn-group\" uib-dropdown>\n            <button type=\"button\" class=\"btn btn-primary\" data-testid=\"order-preview-button\" uib-dropdown-toggle>\n                Preview <span class=\"caret\"></span>\n            </button>\n            <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" >\n                <li role=\"menuitem\">\n                    <a href=\"#\" ng-click=\"vmo.orderEstimateUrl()\">Estimate</a>\n                </li>\n                <li role=\"menuitem\">\n                    <a href=\"#\" ng-click=\"vmo.orderFormUrl()\">Form</a>\n                </li>\n            </ul>\n            </div>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\">\n            <div class=\"btn-group\" uib-dropdown>\n            <button type=\"button\" class=\"btn btn-primary\" data-testid=\"order-print-button\" uib-dropdown-toggle>\n                Print <span class=\"caret\"></span>\n            </button>\n            <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" >\n                <li role=\"menuitem\">\n                    <a href=\"#\" ng-click=\"vmo.print('estimate')\">Estimate</a>\n                </li>\n                <li role=\"menuitem\">\n                    <a href=\"#\" ng-click=\"vmo.print('form')\">Form</a>\n                </li>\n            </ul>\n            </div>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.add_order'\">\n            <div class=\"btn-group\" uib-dropdown>\n            <button type=\"button\" class=\"btn btn-primary\" data-testid=\"order-send-button\" uib-dropdown-toggle>\n                Send <span class=\"caret\"></span>\n            </button>\n            <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" >\n                <li role=\"menuitem\">\n                    <a href=\"#\" ng-click=\"vmo.openSendEmail('estimate')\">Estimate</a>\n                </li>\n                <li role=\"menuitem\">\n                    <a href=\"#\" ng-click=\"vmo.openSendEmail('form')\">Form</a>\n                </li>\n                <li role=\"menuitem\">\n                    <a href=\"#\" ng-click=\"vmo.openSendEmail('send_and_print')\" ladda=\"vmo.loading.sendAndPrint\">Send and Print Form</a>\n                </li>\n            </ul>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.view_ticket'\">\n            <div class=\"btn-group\" uib-dropdown>\n            <button type=\"button\" class=\"btn btn-primary\" data-testid=\"order-tickets-button\" uib-dropdown-toggle>\n                Tickets ( {{vmo.order.tickets.length}} )&nbsp; <span class=\"caret\"></span>\n            </button>\n            <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\n                <li role=\"menuitem\"><a href=\"#\" ng-click=\"vmo.createTicket()\" permission permission-only=\"'main.add_ticket'\">Create</a></li>\n                <li role=\"separator\" class=\"divider\" ng-show=\"vmo.order.tickets.length > 0\" permission permission-only=\"'main.add_ticket'\"></li>\n                <li role=\"menuitem\" ng-repeat=\"ticket in vmo.order.tickets\">\n                    <a ui-sref=\"r.in.top.tickets.detail({ticketId: ticket.id})\" ng-bind=\"ticket.title\"></a>\n                </li>\n            </ul>\n            </div>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.change_order'\">\n            <blnd-status-button ng-model=\"vmo.order\" ng-disabled=\"!canViewEditButton\" type=\"order\"></blnd-status-button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.change_order'\">\n            <!-- Feature hit-percentage hidden, uncomment to enable -->\n            <!-- <blnd-hit-percentage-button ng-model=\"vmo.order\" ng-disabled=\"!canViewEditButton\" type=\"order\"></blnd-hit-percentage-button> -->\n        </li>\n    </ul>\n    <div class=\"blnd-tab-content\" ui-view>\n    </div>\n</div>\n"

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"order-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"top-right-corner\">\n                        <button class=\"btn btn btn-edit\" data-testid=\"order-edit-button\"\n                                ng-disabled=\"!canViewEditButton\"\n                                ng-click=\"vm.editModal()\"\n                                permission permission-only=\"'main.change_order'\">Edit\n                        </button>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>Order #</div>\n                                <div ng-bind=\"vm.order.order_id\" data-testid=\"order-number-read\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-6\">\n                            <div class=\"blnd-data-field\">\n                                <div>Customer</div>\n                                <div><a ui-sref=\"r.in.top.customers.detail({customerId: vm.order.customer.id})\" ng-bind=\"vm.order.customer.title\" data-testid=\"customer-read\"></a></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>Status</div>\n                                <div><blnd-order-status ng-model=\"vm.order.status\" mode=\"view\" data-testid=\"order-status-read\"></blnd-order-status></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Ship To</div>\n                                <div ng-bind=\"vm.order.ship_to_text || '-'\" data-testid=\"ship-to-read\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Ship to fields</div>\n                                <div><blnd-ship-to ng-model=\"vm.order.fields\" customer=\"vm.order.customer\" mode=\"view\" data-testid=\"ship-to-fields-read\"></blnd-ship-to></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>Created</div>\n                                <div>\n                                    <span ng-bind=\"vm.order.created_at | blndDate\" data-testid=\"created-read\"></span>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>Ready</div>\n                                <blnd-datepicker ng-model=\"vm.order.ready\" data-testid=\"ready-read\"></blnd-datepicker>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-8\">\n                            <div class=\"row\">\n                                <div class=\"col-sm-6\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Sales Person</div>\n                                        <div data-testid=\"sales-person-read\">{{ vm.order.sales_person.title }}</div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-6\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Delivery</div>\n                                        <blnd-delivery-picker ng-model=\"vm.order.delivery\" data-testid=\"delivery-read\"></blnd-delivery-picker>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-sm-6\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Applicators</div>\n                                        <blnd-applicator-picker ng-model=\"vm.order.applicators\" company=\"vm.data.company\" fieldname=\"applicator\" mode=\"view\" data-testid=\"applicators-read\"></blnd-applicator-picker>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-6\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Haulers</div>\n                                        <blnd-applicator-picker ng-model=\"vm.order.haulers\" company=\"vm.data.company\" fieldname=\"hauler\" mode=\"view\" data-testid=\"haulers-read\"></blnd-applicator-picker>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"col-sm-2\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Acres</div>\n                                        <div ng-bind=\"vm.order.acres\" data-testid=\"acres-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-2\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Rate</div>\n                                        <div ng-bind=\"vm.order.rate\" data-testid=\"rate-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-3\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Quantity</div>\n                                        <div data-testid=\"quantity-read\">{{ vm.order.quantity }} {{ vm.order.quantity_units }}</div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"col-sm-2\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Base P2</div>\n                                        <div ng-bind=\"vm.order.base\" data-testid=\"base-p2-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-2\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>TFP P3</div>\n                                        <div ng-bind=\"vm.order.nutrients.p3.percent\" data-testid=\"tfp-p3-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-2\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>ATS S2</div>\n                                        <div ng-bind=\"vm.order.nutrients.s2.percent\" data-testid=\"ats-s2-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-1\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Urea</div>\n                                        <div ng-bind=\"vm.order.nutrients.urea_dry.percent\" data-testid=\"urea-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-1\" ng-if=\"vm.order.nutrients.potcarb\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>PotCarb</div>\n                                        <div ng-bind=\"vm.order.nutrients.potcarb.percent\" data-testid=\"potcarb-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-1\" ng-if=\"vm.order.nutrients.crn\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>CRN</div>\n                                        <div ng-bind=\"vm.order.nutrients.crn.percent\" data-testid=\"crn-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-2\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Water</div>\n                                        <div>\n                                            <input type=\"checkbox\" ng-model=\"vm.order.water_gallons\" data-testid=\"water-read\" disabled />\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"rounded-table\">\n                                    <blnd-nutrients nutrient-re-calc=\"vm.nutrientReCalc\"  ng-model=\"vm.order.nutrients\"></blnd-nutrients>\n                                </div>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"rounded-table\">\n                                    <div>\n                                        <blnd-products ng-change=\"vm.onProductsChange()\"\n                                                       ng-model=\"vm.order.products\"\n                                                       mode=\"view\"\n                                                       show-prices=\"true\"\n                                                       convert-to-pints=\"true\">\n                                        </blnd-products>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-4\">\n                            <div class=\"row\">\n                                <div class=\"col-sm-6\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Crop</div>\n                                        <div ng-bind=\"vm.order.crop.title || '-'\" data-testid=\"crop-read\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-6\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Yield Goal</div>\n                                        <div ng-bind=\"vm.order.yield_goal || '-'\"></div>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                            <div class=\"row\">\n                                <div class=\"col-sm-3\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Zone</div>\n                                        <div ng-bind=\"vm.order.freight_zone\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-3\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>PL</div>\n                                        <span class=\"label label-default\" ng-bind=\"vm.order.customer.price_level\"></span>\n                                    </div>\n                                </div>\n\n                                <div class=\"col-sm-6\">\n                                    <div class=\"blnd-data-field\">\n                                        <div>Company</div>\n                                        <div>\n                                            <blnd-company-picker ng-model=\"vm.order.company\"></blnd-company-picker>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"rounded\">\n                                    <strong>Show on Estimate</strong>\n                                    <div class=\"checkbox\">\n                                        <label>\n                                          <input type=\"checkbox\" ng-model=\"vm.order.willard_reward\" disabled /> Willard Rewards\n                                        </label>\n                                    </div>\n                                    <div class=\"checkbox\">\n                                        <label>\n                                          <input type=\"checkbox\" ng-model=\"vm.order.total_price\"  disabled /> Total Price\n                                        </label>\n                                    </div>\n                                    <div class=\"checkbox\">\n                                        <label>\n                                          <input type=\"checkbox\" ng-model=\"vm.order.chemical_price\" disabled /> Chemical Prices\n                                        </label>\n                                    </div>\n                                    <div class=\"checkbox\">\n                                        <label>\n                                          <input type=\"checkbox\" ng-model=\"vm.order.per_ton_price\" disabled /> Per Ton Pricing\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\" ng-if=\"vmo.canSeePrice\" permission permission-only=\"'main.change_order'\">\n                                <div class=\"rounded\">\n                                    <strong>Fertilizer Price</strong>\n                                    <blnd-price-table\n                                            fert-total-cost=\"vm.priceCalc.fertTotalCost\"\n                                            data=\"vm.order\">\n                                    </blnd-price-table>\n                                </div>\n                            </div>\n                            <div class=\"row\" ng-if=\"vmo.canSeePrice\" permission permission-only=\"'main.change_order'\">\n                                <div class=\"rounded\">\n                                    <strong>Total Price</strong>\n                                    <blnd-price-table\n                                            fert-total-cost=\"vm.priceCalc.fertTotalCost\"\n                                            product-total-cost=\"vm.priceCalc.totalProductsCost\"\n                                            data=\"vm.order\">\n                                    </blnd-price-table>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <section>\n                        <h4 >Location </h4>\n                        <h5 ng-repeat=\"location in vm.varLocations\">{{ location.full_string }}</h5>\n                        <!-- Google Maps -->\n                        <div id=\"map\" style=\"height: 400px;\" class=\"w-100\"></div>\n                    </section>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"order-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-upload-section ng-model=\"vm.order\" type=\"order\"></blnd-upload-section>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <div class=\"panel panel-default blnd-panel\">\n            <div class=\"panel-body\">\n                <form>\n                    <div class=\"form-group\">\n                        <textarea class=\"form-control notes\" ng-blur=\"vm.submit()\" ng-model=\"vm.data.notes\"></textarea>\n                    </div>\n                    <button class=\"btn btn-submit pull-right\" ng-click=\"vm.submit()\">Save</button>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	module.exports = "<blnd-activity object=\"vmo.order\"></blnd-activity>\n"

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"order-billing-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <blnd-billing-component ng-model=\"vm.order\" edit-perm=\"'main.change_order'\"></blnd-billing-component>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"actions\">\n    <a class=\"btn btn-default\"\n       ng-if=\"$state.includes('r.in.top.orders.list.priority')\"\n       ui-sref=\"r.in.top.orders.list.main\">Open Orders</a>\n    <a class=\"btn btn-default\"\n       ng-if=\"$state.includes('r.in.top.orders.list.main')\"\n       ui-sref=\"r.in.top.orders.list.priority\"\n       permission permission-sref=\"'r.in.top.orders.list.priority'\">Schedule Orders</a></li>\n</div>\n"

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _class;
	
	// Controllers
	
	
	// Templates
	
	
	var _decorators = __webpack_require__(331);
	
	var _order = __webpack_require__(550);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _dispatch = __webpack_require__(644);
	
	var _dispatch2 = _interopRequireDefault(_dispatch);
	
	var _ctrls = __webpack_require__(645);
	
	var _dispatch3 = __webpack_require__(646);
	
	var _dispatch4 = _interopRequireDefault(_dispatch3);
	
	var _applicator = __webpack_require__(647);
	
	var _applicator2 = _interopRequireDefault(_applicator);
	
	var _hauler = __webpack_require__(648);
	
	var _hauler2 = _interopRequireDefault(_hauler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.dispatch',
	    modules: [_order2.default, _dispatch2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.dispatch',
	    url: '/dispatch',
	    template: _dispatch4.default,
	    abstract: '.applicator',
	    data: {
	        permissions: {
	            only: ['main.can_dispatch_order']
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Dispatch'
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.dispatch.applicator',
	    url: '/applicator',
	    controller: _ctrls.ApplicatorCtrl,
	    template: _applicator2.default,
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.dispatch.hauler',
	    url: '/hauler',
	    controller: _ctrls.HaulerCtrl,
	    template: _hauler2.default,
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.dispatch.mixer',
	    url: '/mixer',
	    template: '<order-priority-list></order-priority-list>',
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.dispatch',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('DispatchStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('dispatch');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HaulerCtrl = exports.ApplicatorCtrl = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DispatchCtrl = function () {
	    function DispatchCtrl() {
	        _classCallCheck(this, DispatchCtrl);
	
	        this.checkedOrders = {};
	        this.duplicatedInfo = "Duplicates are only temporary. They will automatically disappear if you didn't assign any Hauler or Applicator and left the page.";
	    }
	
	    _createClass(DispatchCtrl, [{
	        key: "isOpen",
	        value: function isOpen(ticket) {
	            return ["mixed", "ready_to_bill", "pending"].includes(ticket.status);
	        }
	    }, {
	        key: "validateCheckedOrders",
	        value: function validateCheckedOrders() {
	            var unlink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            var self = this;
	            var valid = true;
	            var applicator = Object.keys(self.checkedOrders)[0].split("/")[1];
	            if (!applicator) {
	                self.$growl.error("Cannot link not assigned orders!");
	                return false;
	            }
	            if (Object.keys(self.checkedOrders).length < 2 && !unlink) {
	                self.$growl.error("You have to choose at least 2 orders!");
	                return false;
	            }
	            Object.keys(self.checkedOrders).forEach(function (checkedOrderName) {
	                if (checkedOrderName.split("/")[1] != applicator) {
	                    self.$growl.error("Cannot link orders from different Applicators/Haulers!");
	                    valid = false;
	                }
	            });
	            return valid;
	        }
	    }, {
	        key: "getCheckedObjectsAndLinked",
	        value: function getCheckedObjectsAndLinked(checkedOrders) {
	            var self = this;
	            var checkedObjectsLinked = [];
	
	            // TODO: optimize if possible
	            Object.keys(checkedOrders).forEach(function (checkedOrderName) {
	                var _checkedOrderName$spl = checkedOrderName.split("/"),
	                    _checkedOrderName$spl2 = _slicedToArray(_checkedOrderName$spl, 2),
	                    checkedOrderId = _checkedOrderName$spl2[0],
	                    applicatorId = _checkedOrderName$spl2[1];
	
	                if (applicatorId) {
	                    var orderObject = self.orderFromApplicatorHauler(checkedOrderId, applicatorId);
	                    checkedObjectsLinked = checkedObjectsLinked.concat(orderObject.linked_with["linked"], checkedOrderName);
	                }
	            });
	
	            var linkedWithoutDuplicates = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(checkedObjectsLinked)))));
	            return linkedWithoutDuplicates;
	        }
	    }, {
	        key: "updateOrderLinked",
	        value: function updateOrderLinked(order_id, applicator_id, checkedOrdersObjectsLinked) {
	            var unlink = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	            var self = this;
	            self.orderStore.get(order_id).then(function (order) {
	                switch (self.target) {
	                    case "Applicator":
	                        var orderApplicatorIndex = order.applicators.findIndex(function (a) {
	                            return a.applicator.id == applicator_id;
	                        });
	                        order.applicators[orderApplicatorIndex].linked_with["linked"] = checkedOrdersObjectsLinked;
	                        break;
	                    case "Hauler":
	                        var orderHaulerIndex = order.haulers.findIndex(function (a) {
	                            return a.hauler.id == applicator_id;
	                        });
	                        order.haulers[orderHaulerIndex].linked_with["linked"] = checkedOrdersObjectsLinked;
	                        break;
	                }
	                order.put().then(function () {
	                    if (!unlink) {
	                        self.$growl.success(checkedOrdersObjectsLinked.map(function (l) {
	                            return l.split("/")[0];
	                        }) + " linked together");
	                    }
	                });
	            });
	        }
	    }, {
	        key: "unlinkSingleOrder",
	        value: function unlinkSingleOrder(checkedOrderId, applicator_id) {
	            var self = this;
	            self.orderStore.get(checkedOrderId).then(function (order) {
	                switch (self.target) {
	                    case "Applicator":
	                        var orderApplicatorIndex = order.applicators.findIndex(function (a) {
	                            return a.applicator.id == applicator_id;
	                        });
	                        order.applicators[orderApplicatorIndex].linked_with["linked"] = [];
	                        break;
	                    case "Hauler":
	                        var orderHaulerIndex = order.haulers.findIndex(function (a) {
	                            return a.hauler.id == applicator_id;
	                        });
	                        order.haulers[orderHaulerIndex].linked_with["linked"] = [];
	                        break;
	                }
	                order.put();
	            });
	        }
	    }, {
	        key: "linkOrders",
	        value: function linkOrders() {
	            var self = this;
	            var valid = self.validateCheckedOrders();
	            if (valid) {
	                var checkedOrdersObjectsLinked = self.getCheckedObjectsAndLinked(self.checkedOrders);
	                checkedOrdersObjectsLinked.forEach(function (checkedLinkedName) {
	                    var _checkedLinkedName$sp = checkedLinkedName.split("/"),
	                        _checkedLinkedName$sp2 = _slicedToArray(_checkedLinkedName$sp, 2),
	                        checkedOrderId = _checkedLinkedName$sp2[0],
	                        applicatorId = _checkedLinkedName$sp2[1];
	
	                    var orderObject = self.orderFromApplicatorHauler(checkedOrderId, applicatorId);
	                    orderObject.linked_with["linked"] = checkedOrdersObjectsLinked;
	                    self.checkedOrders[checkedLinkedName] = false;
	                });
	                if (checkedOrdersObjectsLinked.length > 1) {
	                    var _checkedOrdersObjects = checkedOrdersObjectsLinked[0].split("/"),
	                        _checkedOrdersObjects2 = _slicedToArray(_checkedOrdersObjects, 2),
	                        order_id = _checkedOrdersObjects2[0],
	                        applicator_id = _checkedOrdersObjects2[1];
	
	                    self.updateOrderLinked(order_id, applicator_id, checkedOrdersObjectsLinked);
	                }
	                self.prepareLinkedOrders();
	            }
	        }
	    }, {
	        key: "unlinkSelectedOrders",
	        value: function unlinkSelectedOrders(checkedOrders) {
	            var self = this;
	            var checkedOrdersObjectsLinked = self.getCheckedObjectsAndLinked(checkedOrders);
	            var unlinkedOrders = checkedOrdersObjectsLinked.filter(function (l) {
	                return !Object.keys(checkedOrders).includes(l);
	            });
	
	            checkedOrdersObjectsLinked.forEach(function (checkedLinkedName) {
	                var _checkedLinkedName$sp3 = checkedLinkedName.split("/"),
	                    _checkedLinkedName$sp4 = _slicedToArray(_checkedLinkedName$sp3, 2),
	                    checkedOrderId = _checkedLinkedName$sp4[0],
	                    applicatorId = _checkedLinkedName$sp4[1];
	
	                if (applicatorId) {
	                    var orderObject = self.orderFromApplicatorHauler(checkedOrderId, applicatorId);
	                    if (unlinkedOrders.includes(checkedLinkedName)) {
	                        orderObject.linked_with["linked"] = unlinkedOrders;
	                    } else if (Object.keys(checkedOrders).includes(checkedLinkedName)) {
	                        orderObject.linked_with["linked"] = [];
	                        checkedOrders[checkedLinkedName] = false;
	                        self.unlinkSingleOrder(checkedOrderId, applicatorId);
	                    }
	                }
	            });
	
	            if (unlinkedOrders.length > 0) {
	                var _unlinkedOrders$0$spl = unlinkedOrders[0].split("/"),
	                    _unlinkedOrders$0$spl2 = _slicedToArray(_unlinkedOrders$0$spl, 2),
	                    order_id = _unlinkedOrders$0$spl2[0],
	                    applicator_id = _unlinkedOrders$0$spl2[1];
	
	                self.updateOrderLinked(order_id, applicator_id, unlinkedOrders, true);
	            }
	            // show unlink message
	            if (unlinkedOrders.length > 0 || Object.keys(checkedOrders).length > 1) {
	                self.$growl.success(Object.keys(checkedOrders).map(function (l) {
	                    return l.split("/")[0];
	                }) + " unlinked");
	            }
	        }
	    }, {
	        key: "unlinkOrders",
	        value: function unlinkOrders() {
	            var self = this;
	            var valid = self.validateCheckedOrders(true);
	            if (valid) {
	                self.unlinkSelectedOrders(self.checkedOrders);
	                self.prepareLinkedOrders();
	            }
	        }
	    }, {
	        key: "orderHasApplicator",
	        value: function orderHasApplicator(order) {
	            if (order.applicators && order.applicators.length > 0) return true;
	            return false;
	        }
	    }, {
	        key: "orderHasHauler",
	        value: function orderHasHauler(order) {
	            if (order.haulers && order.haulers.length > 0) return true;
	            return false;
	        }
	    }, {
	        key: "duplicateOrders",
	        value: function duplicateOrders() {
	            var self = this;
	            Object.keys(self.checkedOrders).forEach(function (checkedOrderName) {
	                // try from orderStore
	                var _checkedOrderName$spl3 = checkedOrderName.split("/"),
	                    _checkedOrderName$spl4 = _slicedToArray(_checkedOrderName$spl3, 2),
	                    checkedOrderId = _checkedOrderName$spl4[0],
	                    applicatorId = _checkedOrderName$spl4[1];
	
	                var orderIndex = self.orderStore.list.findIndex(function (o) {
	                    return o.id == checkedOrderId;
	                });
	                var checkedOrder = self.orderStore.list[orderIndex];
	                if (!checkedOrder) {
	                    // if not search in applicator_orders
	                    checkedOrder = self.orderFromApplicatorHauler(checkedOrderId, applicatorId);
	                    self.orderStore.get(checkedOrder.order.id).then(function (checkedOrder) {
	                        self.checkedOrders[checkedOrderName] = false;
	                        checkedOrder.duplicate = true;
	                        self.orderStore.list.unshift(checkedOrder);
	                        self.$growl.success(checkedOrder.order_id + " - duplicate created.");
	                    });
	                } else {
	                    checkedOrder = JSON.parse(JSON.stringify(self.orderStore.list[orderIndex]));
	                    self.checkedOrders[checkedOrderName] = false;
	                    checkedOrder.duplicate = true;
	                    self.orderStore.list.unshift(checkedOrder);
	                    self.$growl.success(checkedOrder.order_id + " - duplicate created.");
	                }
	            });
	        }
	    }, {
	        key: "orderFromApplicatorHauler",
	        value: function orderFromApplicatorHauler(checkedOrderId, applicatorId) {
	            var self = this;
	            var checkedOrder = null;
	            var applicatorIndex = self.haulerApplicatorStore.list.findIndex(function (a) {
	                return a.id == applicatorId;
	            });
	            var appHaul = self.haulerApplicatorStore.list[applicatorIndex];
	            switch (this.target) {
	                case "Applicator":
	                    appHaul.applicator_orders.forEach(function (o) {
	                        if (o.order.id == checkedOrderId) checkedOrder = o;
	                    });
	                    break;
	                case "Hauler":
	                    appHaul.hauler_orders.forEach(function (o) {
	                        if (o.order.id == checkedOrderId) checkedOrder = o;
	                    });
	                    break;
	            }
	            return checkedOrder;
	        }
	    }, {
	        key: "updateCheckedOrders",
	        value: function updateCheckedOrders() {
	            var self = this;
	            var filteredOrders = Object.keys(self.checkedOrders).reduce(function (filtered, order) {
	                if (self.checkedOrders[order]) filtered[order] = self.checkedOrders[order];
	                return filtered;
	            }, {});
	            self.checkedOrders = filteredOrders;
	            self.showButtonsIfIsAnyChecked();
	        }
	    }, {
	        key: "showButtonsIfIsAnyChecked",
	        value: function showButtonsIfIsAnyChecked() {
	            var buttonsDiv = _angular2.default.element(document.getElementById("selected-orders-action"));
	            if (Object.keys(this.checkedOrders).length > 0) {
	                buttonsDiv.show();
	            } else {
	                buttonsDiv.hide();
	            }
	        }
	    }, {
	        key: "onMoved",
	        value: function onMoved(index) {
	            this.orderStore.list.splice(index, 1);
	        }
	    }, {
	        key: "onDrop",
	        value: function onDrop(event, index, item) {
	            var _this = this;
	
	            var self = this;
	            var selectedHaulerApplicator = self.haulerApplicatorStore.list[index];
	            selectedHaulerApplicator.noEvents = true;
	
	            var orderIndex = self.orderStore.list.findIndex(function (o) {
	                return o.order_id == item.order_id;
	            });
	            var grabbedOrder = self.orderStore.restangularize(self.orderStore.list[orderIndex]);
	            grabbedOrder.noEvents = true;
	
	            self.orderStore.get(grabbedOrder.id).then(function (updatedOrder) {
	                switch (_this.target) {
	                    case "Applicator":
	                        updatedOrder.applicators.push({
	                            "applicator": selectedHaulerApplicator
	                        });
	                        break;
	                    case "Hauler":
	                        updatedOrder.haulers.push({
	                            "hauler": selectedHaulerApplicator
	                        });
	                        break;
	                }
	                return updatedOrder;
	            }).then(function (updatedOrder) {
	                updatedOrder.put().then(function () {
	                    // update orders list
	                    self.orderStore.list.splice(orderIndex, 1);
	
	                    // avoid Converting circular structure
	                    updatedOrder.applicators = updatedOrder.applicators.map(function (a) {
	                        return a.applicator.id;
	                    });
	                    updatedOrder.haulers = updatedOrder.haulers.map(function (h) {
	                        return h.hauler.id;
	                    });
	
	                    switch (self.target) {
	                        case "Applicator":
	                            updatedOrder.tickets = self.filterApplicatorOrdersTickets(updatedOrder.tickets, selectedHaulerApplicator.id);
	                            selectedHaulerApplicator.applicator_orders.push({ "order": updatedOrder, "linked_with": { "linked": [] } });
	                            break;
	                        case "Hauler":
	                            updatedOrder.tickets = self.filterHaulerOrdersTickets(updatedOrder.tickets, selectedHaulerApplicator.id);
	                            selectedHaulerApplicator.hauler_orders.push({ "order": updatedOrder, "linked_with": { "linked": [] } });
	                            break;
	                    }
	                    self.$growl.success(item.order_id + " assigned to " + selectedHaulerApplicator.name);
	                    grabbedOrder.noEvents = false;
	                    selectedHaulerApplicator.noEvents = false;
	                }, function (resp) {
	                    // Order error handling
	                    Object.entries(resp.data).forEach(function (entry) {
	                        var _entry = _slicedToArray(entry, 2),
	                            field = _entry[0],
	                            error = _entry[1];
	
	                        error.forEach(function (err_msg) {
	                            if ((typeof err_msg === "undefined" ? "undefined" : _typeof(err_msg)) === 'object' && err_msg !== null) {
	                                Object.entries(err_msg).forEach(function (list_entry) {
	                                    self.$growl.error(field + ": " + list_entry);
	                                });
	                            } else {
	                                self.$growl.error(field + ": " + err_msg);
	                            }
	                        });
	                    });
	                    self.unassignHaulerApplicator(updatedOrder);
	                    grabbedOrder.noEvents = false;
	                    selectedHaulerApplicator.noEvents = false;
	                });
	            });
	        }
	    }, {
	        key: "unassignHaulerApplicator",
	        value: function unassignHaulerApplicator(order, haulerApplicatorId) {
	            switch (this.target) {
	                case "Applicator":
	                    var appIndex = order.applicators.findIndex(function (a) {
	                        return a.applicator.id == haulerApplicatorId;
	                    });
	                    order.applicators.splice(appIndex, 1);
	                    break;
	                case "Hauler":
	                    var haulIndex = order.haulers.findIndex(function (a) {
	                        return a.hauler.id == haulerApplicatorId;
	                    });
	                    order.haulers.splice(haulIndex, 1);
	                    break;
	            }
	        }
	    }, {
	        key: "removeOrderFromHaulerApplicator",
	        value: function removeOrderFromHaulerApplicator(haulerApplicator, orderIndex) {
	            switch (this.target) {
	                case "Applicator":
	                    haulerApplicator.applicator_orders.splice(orderIndex, 1);
	                    break;
	                case "Hauler":
	                    haulerApplicator.hauler_orders.splice(orderIndex, 1);
	                    break;
	            }
	        }
	    }, {
	        key: "unassignOrder",
	        value: function unassignOrder(order, haulerApplicatorIndex, orderIndex) {
	            var self = this;
	            var haulerApplicator = self.haulerApplicatorStore.list[haulerApplicatorIndex];
	            haulerApplicator.noEvents = true;
	
	            // unlink orders and then unassign
	            var checkedOrders = {};
	            checkedOrders[order.id + "/" + haulerApplicator.id] = true;
	            self.unlinkSelectedOrders(checkedOrders);
	
	            self.orderStore.get(order.id).then(function (cancelledOrder) {
	                self.unassignHaulerApplicator(cancelledOrder, haulerApplicator.id);
	                cancelledOrder.put().then(function () {
	                    cancelledOrder.tickets = cancelledOrder.tickets.filter(self.isOpen);
	                    if (Object.keys(self.checkedOrders).includes(cancelledOrder.order_id)) {
	                        cancelledOrder.duplicate = true;
	                    }
	                    self.orderStore.list.unshift(cancelledOrder);
	                    self.removeOrderFromHaulerApplicator(haulerApplicator, orderIndex);
	                    self.$growl.success(order.id + " unassigned.");
	                    haulerApplicator.noEvents = false;
	                    self.prepareLinkedOrders();
	                }, function (resp) {
	                    console.log(resp);
	                    haulerApplicator.noEvents = false;
	                });
	            });
	        }
	    }]);
	
	    return DispatchCtrl;
	}();
	
	var ApplicatorCtrl = exports.ApplicatorCtrl = function (_DispatchCtrl) {
	    ApplicatorCtrl.$inject = ["$growl", "DispatchStore", "OrderStore"];
	    _inherits(ApplicatorCtrl, _DispatchCtrl);
	
	    function ApplicatorCtrl($growl, DispatchStore, OrderStore) {
	        "ngInject";
	
	        _classCallCheck(this, ApplicatorCtrl);
	
	        var _this2 = _possibleConstructorReturn(this, (ApplicatorCtrl.__proto__ || Object.getPrototypeOf(ApplicatorCtrl)).call(this));
	
	        _this2.$growl = $growl;
	        _this2.haulerApplicatorStore = DispatchStore;
	        _this2.orderStore = OrderStore;
	        _this2.target = "Applicator";
	
	        _this2.haulerApplicatorStore.params = {
	            page: 1,
	            page_size: 15
	        };
	        var self = _this2;
	        _this2.haulerApplicatorStore.refresh().then(function () {
	            self.prepareApplicatorTickets();
	            self.prepareLinkedOrders();
	        });
	        _this2.orderStore.params = {
	            page: 1,
	            status: "dispatcher_filters",
	            applicators: "None",
	            delivery: ["apply_haul"],
	            ticket_status: "open"
	        };
	        _this2.orderStore.refresh();
	        return _this2;
	    }
	
	    _createClass(ApplicatorCtrl, [{
	        key: "searchApplicator",
	        value: function searchApplicator() {
	            var self = this;
	            this.haulerApplicatorStore.params.page = null;
	            this.haulerApplicatorStore.refresh().then(function () {
	                self.prepareApplicatorTickets();
	                self.prepareLinkedOrders();
	            });
	            this.haulerApplicatorStore.params.page = 1;
	        }
	    }, {
	        key: "prepareApplicatorTickets",
	        value: function prepareApplicatorTickets() {
	            // Return only applicator_order tickets assign to picked Applicator.
	            var self = this;
	            self.haulerApplicatorStore.list.forEach(function (applicator) {
	                applicator.applicator_orders.forEach(function (order) {
	                    order.order.tickets = self.filterApplicatorOrdersTickets(order.order.tickets, applicator.id);
	                });
	            });
	        }
	    }, {
	        key: "filterApplicatorOrdersTickets",
	        value: function filterApplicatorOrdersTickets(tickets, applicator_id) {
	            var filteredTickets = [];
	            tickets.forEach(function (ticket) {
	                if (["mixed", "ready_to_bill", "pending"].includes(ticket.status)) {
	                    if (ticket.applicators.some(function (v) {
	                        return v.applicator == applicator_id;
	                    })) {
	                        filteredTickets.push(ticket);
	                    }
	                }
	            });
	            return filteredTickets;
	        }
	    }, {
	        key: "loadMoreApplicators",
	        value: function loadMoreApplicators() {
	            var self = this;
	            self.haulerApplicatorStore.loadMore().then(function () {
	                self.prepareApplicatorTickets();
	                self.prepareLinkedOrders();
	            });
	        }
	    }, {
	        key: "prepareLinkedOrders",
	        value: function prepareLinkedOrders() {
	            // display linked items under oder without duplicates
	            var self = this;
	            self.haulerApplicatorStore.list.forEach(function (app) {
	                var linkedOrders = [];
	                app.applicator_orders.map(function (order) {
	                    return order.linked = false;
	                });
	                app.applicator_orders.forEach(function (order) {
	                    if (!linkedOrders.some(function (l) {
	                        return l.order.id == order.order.id;
	                    })) {
	                        linkedOrders.push(JSON.parse(JSON.stringify(order)));
	                        // iterate through this applicator linked orders
	                        var applicator_linked = order.linked_with.linked.filter(function (l) {
	                            return l.split("/")[0] != order.order.id && l.split("/")[1] == app.id;
	                        });
	                        applicator_linked.forEach(function (linked_name) {
	                            var order_id = linked_name.split("/")[0];
	                            var linkedIndex = app.applicator_orders.findIndex(function (o) {
	                                return o.order.id == order_id;
	                            });
	                            var linkedItem = app.applicator_orders[linkedIndex];
	
	                            linkedOrders[linkedOrders.length - 1].linked = true;
	                            linkedOrders.push(JSON.parse(JSON.stringify(linkedItem)));
	                        });
	                    }
	                });
	                app.applicator_orders = linkedOrders;
	            });
	        }
	    }]);
	
	    return ApplicatorCtrl;
	}(DispatchCtrl);
	
	var HaulerCtrl = exports.HaulerCtrl = function (_DispatchCtrl2) {
	    HaulerCtrl.$inject = ["$growl", "OrderStore", "DispatchStore"];
	    _inherits(HaulerCtrl, _DispatchCtrl2);
	
	    function HaulerCtrl($growl, OrderStore, DispatchStore) {
	        "ngInject";
	
	        _classCallCheck(this, HaulerCtrl);
	
	        var _this3 = _possibleConstructorReturn(this, (HaulerCtrl.__proto__ || Object.getPrototypeOf(HaulerCtrl)).call(this));
	
	        _this3.target = "Hauler";
	        _this3.$growl = $growl;
	        _this3.haulerApplicatorStore = DispatchStore;
	        _this3.orderStore = OrderStore;
	        _this3.haulerApplicatorStore.params = {
	            page: 1,
	            page_size: 15
	        };
	        var self = _this3;
	        _this3.haulerApplicatorStore.refresh().then(function () {
	            self.prepereHaulerTickets(); // TOOD: possible fututre remove when optimize queryset on backend
	            self.prepareLinkedOrders();
	        });
	
	        _this3.orderStore.params = {
	            page: 1,
	            status: "dispatcher_filters",
	            haulers: "None",
	            delivery: ["apply_haul", "haul"],
	            ticket_status: "open"
	        };
	        _this3.orderStore.refresh();
	        return _this3;
	    }
	
	    _createClass(HaulerCtrl, [{
	        key: "searchHauler",
	        value: function searchHauler() {
	            var self = this;
	            this.haulerApplicatorStore.params.page = null;
	            this.haulerApplicatorStore.refresh().then(function () {
	                self.prepereHaulerTickets(); // TOOD: possible fututre remove when optimize queryset on backend
	                self.prepareLinkedOrders();
	            });
	            this.haulerApplicatorStore.params.page = 1;
	        }
	    }, {
	        key: "prepereHaulerTickets",
	        value: function prepereHaulerTickets() {
	            // Return only hauler_order tickets assign to picked Hauler.
	            var self = this;
	            self.haulerApplicatorStore.list.forEach(function (hauler) {
	                hauler.hauler_orders.forEach(function (order) {
	                    order.order.tickets = self.filterHaulerOrdersTickets(order.order.tickets, hauler.id);
	                });
	            });
	        }
	    }, {
	        key: "filterHaulerOrdersTickets",
	        value: function filterHaulerOrdersTickets(tickets, hauler_id) {
	            var filteredTickets = [];
	            tickets.forEach(function (ticket) {
	                if (["mixed", "ready_to_bill", "pending"].includes(ticket.status)) {
	                    if (ticket.haulers.some(function (v) {
	                        return v.hauler == hauler_id;
	                    })) {
	                        filteredTickets.push(ticket);
	                    }
	                }
	            });
	            return filteredTickets;
	        }
	    }, {
	        key: "loadMoreHaulers",
	        value: function loadMoreHaulers() {
	            var self = this;
	            self.haulerApplicatorStore.loadMore().then(function () {
	                self.prepereHaulerTickets();
	                self.prepareLinkedOrders();
	            });
	        }
	    }, {
	        key: "prepareLinkedOrders",
	        value: function prepareLinkedOrders() {
	            // display linked items under oder without duplicates
	            var self = this;
	            self.haulerApplicatorStore.list.forEach(function (haul) {
	                var linkedOrders = [];
	                haul.hauler_orders.map(function (order) {
	                    return order.linked = false;
	                });
	                haul.hauler_orders.forEach(function (order) {
	                    if (!linkedOrders.some(function (l) {
	                        return l.order.id == order.order.id;
	                    })) {
	                        linkedOrders.push(JSON.parse(JSON.stringify(order)));
	                        // iterate through this hauler linked orders
	                        var hauler_linked = order.linked_with.linked.filter(function (l) {
	                            return l.split("/")[0] != order.order.id && l.split("/")[1] == haul.id;
	                        });
	                        hauler_linked.forEach(function (linked_name) {
	                            var order_id = linked_name.split("/")[0];
	                            var linkedIndex = haul.hauler_orders.findIndex(function (o) {
	                                return o.order.id == order_id;
	                            });
	                            var linkedItem = haul.hauler_orders[linkedIndex];
	
	                            linkedOrders[linkedOrders.length - 1].linked = true;
	                            linkedOrders.push(JSON.parse(JSON.stringify(linkedItem)));
	                        });
	                    }
	                });
	                haul.hauler_orders = linkedOrders;
	            });
	        }
	    }]);
	
	    return HaulerCtrl;
	}(DispatchCtrl);

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dispatch-details\">\n   <ul class=\"nav nav-tabs\">\n       <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.dispatch.applicator\">Applicator</a></li>\n       <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.dispatch.hauler\">Hauler</a></li>\n       <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.dispatch.mixer\">Mixer</a></li>\n   </ul>\n   <div class=\"blnd-tab-content\" ui-view></div>\n</div>\n"

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dispatch-applicator-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"row\">\n                        <!-- Ready Orders -->\n                        <div id=\"read-orders-scroll\" class=\"col-sm-3 ready-orders-col\">\n                            <div infinite-scroll=\"vm.orderStore.loadMore()\"\n                                 infinite-scroll-disabled=\"vm.orderStore.loading || vm.orderStore.isEmpty\"\n                                 infinite-scroll-immediate-check=\"true\"\n                                 infinite-scroll-container='\"#read-orders-scroll\"'\n                                 loading-container=\"vm.orderStore.loading\"\n                                 dnd-list=\"vm.orderStore.list\"\n                            >\n                                <div ng-repeat=\"order in vm.orderStore.list track by $index\"\n                                     dnd-handle\n                                     dnd-draggable=\"order\"\n                                     dnd-effect-allowed=\"move\"\n                                     dnd-moved=\"vm.onMoved($index)\"\n                                     ng-class=\"{'order-card-no-events':order.noEvents}\"\n                                     class=\"order-div\"\n                                >\n                                    <input type=\"checkbox\" class=\"bigger-checkbox\"\n                                        ng-model=\"vm.checkedOrders[order.id]\"\n                                        ng-click=\"vm.updateCheckedOrders()\"\n                                    >\n                                    <div class=\"card order-card\">\n                                        <div class=\"card-body\">\n                                            <div ng-if=\"order.duplicate\" class=\"row\" title=\"{{vm.duplicatedInfo}}\">\n                                                <span class=\"label label-warning\">Duplicate</span>\n                                            </div>\n                                            <div class=\"row text-justify\">\n                                                <a ui-sref=\"r.in.top.orders.detail({orderId: order.id})\"><p style=\"float: left;\" ng-bind=\"order.order_id\"></p></a>\n                                                <p style=\"float: right;\" ng-bind=\"order.crop.name\"></p>\n                                            </div>\n                                            <div class=\"row\">\n                                                <p ng-bind=\"order.customer.title\"></p>\n                                            </div>\n                                            <div class=\"row\">\n                                                <p style=\"float: left;\" ng-bind=\"order.tonnage + ' Tons'\"></p>\n                                                <p style=\"float: right;\" ng-bind=\"order.acres + ' Acres'\"></p>\n                                            </div>\n                                            <div class=\"row\">\n                                                <p ng-if=\"vm.orderHasApplicator(order)\" class=\"left-correct\">\n                                                    Applicator &#10004;\n                                                </p>\n                                                <p ng-if=\"!vm.orderHasApplicator(order)\" class=\"left-error\">\n                                                    Applicator &#10006;\n                                                </p>\n                                                <p ng-if=\"vm.orderHasHauler(order)\" class=\"right-correct\">\n                                                    Hauler &#10004;\n                                                </p>\n                                                <p ng-if=\"!vm.orderHasHauler(order)\" class=\"right-error\">\n                                                    Hauler &#10006;\n                                                </p>\n                                            </div>\n                                        </div>\n                                        <li ng-repeat=\"ticket in order.tickets\"\n                                            class=\"list-group-item applicator-ticket\"\n                                        >\n                                            <a ui-sref=\"r.in.top.tickets.detail({ticketId: ticket.id})\"><span ng-bind=\"'#' + ticket.slug\"></span></a>\n                                            <span ng-bind=\"ticket.status\" style=\"text-transform: capitalize;\"></span>\n                                        </li>\n                                    </div>\n                                </div>\n                            </div>\n                            <no-data =\"vm.orderStore.list.length === 0 && vm.orderStore.isEmpty\">No ready orders</no-data>\n                        </div>\n                        <!-- Available Applicators -->\n                        <div class=\"col-sm-9 available-applicators-col\">\n                            <div class=\"row search-buttons-div\">\n                                <div class=\"search-window\">\n                                    <input type=\"text\"\n                                            class=\"form-control\"\n                                            placeholder=\"Search Applicators\"\n                                            ng-model=\"vm.haulerApplicatorStore.params.search\"\n                                            ng-keyup=\"$event.keyCode == 13 && vm.searchApplicator()\"\n                                            autofocus />\n                                </div>\n                                <div id=\"selected-orders-action\">\n                                    <button class=\"btn btn-default dispatch-button\" type=\"button\" style=\"display: none;\" ng-click=\"vm.linkOrders()\">\n                                        Link\n                                        <span class=\"fa fa-link\"></span>\n                                    </button>\n                                    <button class=\"btn btn-default dispatch-button\" type=\"button\" style=\"display: none;\" ng-click=\"vm.unlinkOrders()\">\n                                        Unlink\n                                        <span class=\"fa fa-unlink\"></span>\n                                    </button>\n                                    <button class=\"btn btn-default dispatch-button\" type=\"button\" ng-click=\"vm.duplicateOrders()\">\n                                        Duplicate\n                                        <span class=\"glyphicon glyphicon-duplicate\"></span>\n                                    </button>\n                                </div>\n                            </div>\n                            <div id=\"available-applicators-scroll\">\n                                <div infinite-scroll=\"vm.loadMoreApplicators()\"\n                                    infinite-scroll-disabled=\"vm.haulerApplicatorStore.loading || vm.haulerApplicatorStore.isEmpty\"\n                                    infinite-scroll-immediate-check=\"true\"\n                                    infinite-scroll-container='\"#available-applicators-scroll\"'\n                                    loading-container=\"vm.haulerApplicatorStore.loading\"\n                                    class=\"infinite-scroll-orders\"\n                                    dnd-list=\"vm.haulerApplicatorStore.list\"\n                                    dnd-drop=\"vm.onDrop(event, index, item)\"\n                                >\n                                    <div ng-repeat=\"applicator in vm.haulerApplicatorStore.list\"\n                                        class=\"card applicator-card\"\n                                        ng-class=\"{'order-card-no-events':applicator.noEvents}\"\n                                    >\n                                        <div class=\"applicator-header\">\n                                            <h5 class=\"card-title text-center\">\n                                                <span style=\"vertical-align: middle;\" ng-bind=\"applicator.title\"></span>\n                                            </h5>\n                                        </div>\n                                        <ul class=\"list-group applicator-order-list\">\n                                            <!-- Applicator Orders -->\n                                            <div ng-repeat=\"order in applicator.applicator_orders\"\n                                                 class=\"order-div\"\n                                            >\n                                                <div class=\"checkbox-div\">\n                                                    <input type=\"checkbox\" class=\"bigger-checkbox\"\n                                                        ng-model=\"vm.checkedOrders[order.order.id + '/' + applicator.id]\"\n                                                        ng-click=\"vm.updateCheckedOrders()\"\n                                                    >\n                                                </div>\n                                                <div class=\"card applicator-order-card\">\n                                                    <span ng-click=\"vm.unassignOrder(order.order, $parent.$index, $index)\"\n                                                          class=\"close\">&#10005;\n                                                    </span>\n                                                    <div class=\"card-body\">\n                                                        <div class=\"row text-justify\">\n                                                            <a ui-sref=\"r.in.top.orders.detail({orderId: order.order.id})\"><p style=\"float: left;\" ng-bind=\"order.order.order_id\"></p></a>\n                                                            <p style=\"float: right;\" ng-bind=\"order.order.crop.name\"></p>\n                                                        </div>\n                                                        <div class=\"row\">\n                                                            <p ng-bind=\"order.order.customer.title\"></p>\n                                                        </div>\n                                                        <div class=\"row\">\n                                                            <p style=\"float: left;\" ng-bind=\"order.order.tonnage + ' Tons'\"></p>\n                                                            <p style=\"float: right;\" ng-bind=\"order.order.acres + ' Acres'\"></p>\n                                                        </div>\n                                                        <div class=\"row\">\n                                                            <p ng-if=\"vm.orderHasApplicator(order.order)\" class=\"left-correct\">\n                                                                Applicator &#10004;\n                                                            </p>\n                                                            <p ng-if=\"!vm.orderHasApplicator(order.order)\" class=\"left-error\">\n                                                                Applicator &#10006;\n                                                            </p>\n                                                            <p ng-if=\"vm.orderHasHauler(order.order)\" class=\"right-correct\">\n                                                                Hauler &#10004;\n                                                            </p>\n                                                            <p ng-if=\"!vm.orderHasHauler(order.order)\" class=\"right-error\">\n                                                                Hauler &#10006;\n                                                            </p>\n                                                        </div>\n                                                    </div>\n                                                    <!-- Applicator Order Tickets -->\n                                                    <li ng-repeat=\"ticket in order.order.tickets\"\n                                                        class=\"list-group-item applicator-ticket\"\n                                                    >\n                                                        <a ui-sref=\"r.in.top.tickets.detail({ticketId: ticket.id})\"><span ng-bind=\"'#' + ticket.slug\"></span></a>\n                                                        <span ng-bind=\"ticket.status\" style=\"text-transform: capitalize;\"></span>\n                                                    </li>\n                                                    <span ng-if=\"order.linked\" class=\"fa fa-link linked-order\"></span>\n                                                </div>\n                                            </div>\n                                        </ul>\n                                    </div>\n                                </div>\n                                <no-data =\"vm.haulerApplicatorStore.list.length === 0 && vm.haulerApplicatorStore.isEmpty\">No available Applicators</no-data>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dispatch-applicator-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"row\">\n                        <!-- Ready Orders -->\n                        <div id=\"read-orders-scroll\" class=\"col-sm-3 ready-orders-col\">\n                            <div infinite-scroll=\"vm.orderStore.loadMore()\"\n                                 infinite-scroll-disabled=\"vm.orderStore.loading || vm.orderStore.isEmpty\"\n                                 infinite-scroll-immediate-check=\"true\"\n                                 infinite-scroll-container='\"#read-orders-scroll\"'\n                                 loading-container=\"vm.orderStore.loading\"\n                                 dnd-list=\"vm.orderStore.list\"\n                            >\n                                <div ng-repeat=\"order in vm.orderStore.list track by $index\"\n                                     dnd-handle\n                                     dnd-draggable=\"order\"\n                                     dnd-effect-allowed=\"move\"\n                                     dnd-moved=\"vm.onMoved($index)\"\n                                     ng-class=\"{'order-card-no-events':order.noEvents}\"\n                                     class=\"order-div\"\n                                >\n                                    <input type=\"checkbox\" class=\"bigger-checkbox\"\n                                          ng-model=\"vm.checkedOrders[order.id]\"\n                                          ng-click=\"vm.updateCheckedOrders()\"\n                                    >\n                                    <div class=\"card order-card\">\n                                        <div class=\"card-body\">\n                                            <div ng-if=\"order.duplicate\" class=\"row\" title=\"{{vm.duplicatedInfo}}\">\n                                                <span class=\"label label-warning\">Duplicate</span>\n                                            </div>\n                                            <div class=\"row text-justify\">\n                                                <a ui-sref=\"r.in.top.orders.detail({orderId: order.id})\"><p style=\"float: left;\" ng-bind=\"order.order_id\"></p></a>\n                                                <p style=\"float: right;\" ng-bind=\"order.crop.name\"></p>\n                                            </div>\n                                            <div class=\"row\">\n                                                <p ng-bind=\"order.customer.title\"></p>\n                                            </div>\n                                            <div class=\"row\">\n                                                <p style=\"float: left;\" ng-bind=\"order.tonnage + ' Tons'\"></p>\n                                                <p style=\"float: right;\" ng-bind=\"order.acres + ' Acres'\"></p>\n                                            </div>\n                                            <div class=\"row\">\n                                                <p ng-if=\"vm.orderHasApplicator(order)\" class=\"left-correct\">\n                                                    Applicator &#10004;\n                                                </p>\n                                                <p ng-if=\"!vm.orderHasApplicator(order)\" class=\"left-error\">\n                                                    Applicator &#10006;\n                                                </p>\n                                                <p ng-if=\"vm.orderHasHauler(order)\" class=\"right-correct\">\n                                                    Hauler &#10004;\n                                                </p>\n                                                <p ng-if=\"!vm.orderHasHauler(order)\" class=\"right-error\">\n                                                    Hauler &#10006;\n                                                </p>\n                                            </div>\n                                        </div>\n                                        <li ng-repeat=\"ticket in order.tickets\"\n                                            class=\"list-group-item applicator-ticket\"\n                                        >\n                                            <a ui-sref=\"r.in.top.tickets.detail({ticketId: ticket.id})\"><span ng-bind=\"'#' + ticket.slug\"></span></a>\n                                            <span ng-bind=\"ticket.status\" style=\"text-transform: capitalize;\"></span>\n                                        </li>\n\n                                    </div>\n                                </div>\n                            </div>\n                            <no-data =\"vm.orderStore.list.length === 0 && vm.orderStore.isEmpty\">No ready orders</no-data>\n                        </div>\n                        <!-- Available Haulers -->\n                        <div class=\"col-sm-9 available-applicators-col\">\n                            <div class=\"row\">\n                                <div class=\"row search-buttons-div\">\n                                    <div class=\"search-window\">\n                                        <input type=\"text\"\n                                                class=\"form-control\"\n                                                placeholder=\"Search Haulers\"\n                                                ng-model=\"vm.haulerApplicatorStore.params.search\"\n                                                ng-keyup=\"$event.keyCode == 13 && vm.searchHauler()\"\n                                                autofocus />\n                                    </div>\n                                    <div id=\"selected-orders-action\">\n                                        <button class=\"btn btn-default dispatch-button\" type=\"button\" ng-click=\"vm.linkOrders()\">\n                                            Link\n                                            <span class=\"fa fa-link\"></span>\n                                        </button>\n                                        <button class=\"btn btn-default dispatch-button\" type=\"button\" ng-click=\"vm.unlinkOrders()\">\n                                            Unlink\n                                            <span class=\"fa fa-unlink\"></span>\n                                        </button>\n                                        <button class=\"btn btn-default dispatch-button\" type=\"button\" ng-click=\"vm.duplicateOrders()\">\n                                            Duplicate\n                                            <span class=\"glyphicon glyphicon-duplicate\"></span>\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                            <div id=\"available-applicators-scroll\">\n                                <div infinite-scroll=\"vm.loadMoreHaulers()\"\n                                    infinite-scroll-disabled=\"vm.haulerApplicatorStore.loading || vm.haulerApplicatorStore.isEmpty\"\n                                    infinite-scroll-immediate-check=\"true\"\n                                    infinite-scroll-container='\"#available-applicators-scroll\"'\n                                    loading-container=\"vm.haulerApplicatorStore.loading\"\n                                    class=\"infinite-scroll-orders\"\n                                    dnd-list=\"vm.haulerApplicatorStore.list\"\n                                    dnd-drop=\"vm.onDrop(event, index, item)\"\n                                >\n                                    <div ng-repeat=\"hauler in vm.haulerApplicatorStore.list\"\n                                        class=\"card applicator-card\"\n                                        ng-class=\"{'order-card-no-events':hauler.noEvents}\"\n                                    >\n                                        <div class=\"applicator-header\">\n                                            <h5 class=\"card-title text-center\">\n                                                <span style=\"vertical-align: middle;\" ng-bind=\"hauler.title\"></span>\n                                            </h5>\n                                        </div>\n                                        <ul class=\"list-group applicator-order-list\">\n                                            <!-- Hauler Orders -->\n                                            <div  ng-repeat=\"order in hauler.hauler_orders\"\n                                                 class=\"order-div\"\n                                            >\n                                                <div class=\"checkbox-div\">\n                                                    <input type=\"checkbox\" class=\"bigger-checkbox\"\n                                                        ng-model=\"vm.checkedOrders[order.order.id + '/' + hauler.id]\"\n                                                        ng-click=\"vm.updateCheckedOrders()\"\n                                                    >\n                                                </div>\n                                                <div class=\"card applicator-order-card\">\n                                                    <span ng-click=\"vm.unassignOrder(order.order, $parent.$index, $index)\"\n                                                          class=\"close\">&#10005;\n                                                    </span>\n                                                    <div class=\"card-body\">\n                                                        <div class=\"row text-justify\">\n                                                            <a ui-sref=\"r.in.top.orders.detail({orderId: order.order.id})\"><p style=\"float: left;\" ng-bind=\"order.order.order_id\"></p></a>\n                                                            <p style=\"float: right;\" ng-bind=\"order.order.crop.name\"></p>\n                                                        </div>\n                                                        <div class=\"row\">\n                                                            <p ng-bind=\"order.order.customer.title\"></p>\n                                                        </div>\n                                                        <div class=\"row\">\n                                                            <p style=\"float: left;\" ng-bind=\"order.order.tonnage + ' Tons'\"></p>\n                                                            <p style=\"float: right;\" ng-bind=\"order.order.acres + ' Acres'\"></p>\n                                                        </div>\n                                                        <div class=\"row\">\n                                                            <p ng-if=\"vm.orderHasApplicator(order.order)\" class=\"left-correct\">\n                                                                Applicator &#10004;\n                                                            </p>\n                                                            <p ng-if=\"!vm.orderHasApplicator(order.order)\" class=\"left-error\">\n                                                                Applicator &#10006;\n                                                            </p>\n                                                            <p ng-if=\"vm.orderHasHauler(order.order)\" class=\"right-correct\">\n                                                                Hauler &#10004;\n                                                            </p>\n                                                            <p ng-if=\"!vm.orderHasHauler(order.order)\" class=\"right-error\">\n                                                                Hauler &#10006;\n                                                            </p>\n                                                        </div>\n                                                    </div>\n                                                    <!-- Hauler Order Tickets -->\n                                                    <li ng-repeat=\"ticket in order.order.tickets\"\n                                                        class=\"list-group-item applicator-ticket\"\n                                                    >\n                                                        <a ui-sref=\"r.in.top.tickets.detail({ticketId: ticket.id})\"><span ng-bind=\"'#' + ticket.slug\"></span></a>\n                                                        <span ng-bind=\"ticket.status\" style=\"text-transform: capitalize;\"></span>\n                                                    </li>\n                                                    <span ng-if=\"order.linked\" class=\"fa fa-link linked-order\"></span>\n                                                </div>\n                                            </div>\n                                        </ul>\n                                    </div>\n                                </div>\n                                <no-data =\"vm.haulerApplicatorStore.list.length === 0 && vm.haulerApplicatorStore.isEmpty\">No available Haulers</no-data>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _class;
	
	//components
	
	
	// Templates
	
	
	var _decorators = __webpack_require__(331);
	
	var _activity = __webpack_require__(618);
	
	var _activity2 = _interopRequireDefault(_activity);
	
	var _modals = __webpack_require__(532);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _config = __webpack_require__(504);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _file = __webpack_require__(556);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _ticket = __webpack_require__(650);
	
	var _ticket2 = _interopRequireDefault(_ticket);
	
	var _product = __webpack_require__(651);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _is = __webpack_require__(652);
	
	var _is2 = _interopRequireDefault(_is);
	
	var _ctrls = __webpack_require__(653);
	
	var _formula = __webpack_require__(663);
	
	var _formula2 = _interopRequireDefault(_formula);
	
	var _presets = __webpack_require__(665);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _product3 = __webpack_require__(596);
	
	var _product4 = _interopRequireDefault(_product3);
	
	var _products = __webpack_require__(587);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _ticket3 = __webpack_require__(667);
	
	var _ticket4 = _interopRequireDefault(_ticket3);
	
	var _blink = __webpack_require__(669);
	
	var _blink2 = _interopRequireDefault(_blink);
	
	var _company = __webpack_require__(583);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _component = __webpack_require__(602);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _list = __webpack_require__(670);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _tank = __webpack_require__(672);
	
	var _tank2 = _interopRequireDefault(_tank);
	
	var _component3 = __webpack_require__(621);
	
	var _component4 = _interopRequireDefault(_component3);
	
	var _component5 = __webpack_require__(626);
	
	var _component6 = _interopRequireDefault(_component5);
	
	var _main = __webpack_require__(674);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _chemicalProgram = __webpack_require__(628);
	
	var _chemicalProgram2 = _interopRequireDefault(_chemicalProgram);
	
	var _salesCode = __webpack_require__(676);
	
	var _salesCode2 = _interopRequireDefault(_salesCode);
	
	var _analysis_warning = __webpack_require__(678);
	
	var _analysis_warning2 = _interopRequireDefault(_analysis_warning);
	
	var _acresCalc = __webpack_require__(631);
	
	var _acresCalc2 = _interopRequireDefault(_acresCalc);
	
	var _product_code = __webpack_require__(681);
	
	var _product_code2 = _interopRequireDefault(_product_code);
	
	var _fade = __webpack_require__(558);
	
	var _fade2 = _interopRequireDefault(_fade);
	
	var _list3 = __webpack_require__(683);
	
	var _list4 = _interopRequireDefault(_list3);
	
	var _detail = __webpack_require__(684);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _detailTicket = __webpack_require__(685);
	
	var _detailTicket2 = _interopRequireDefault(_detailTicket);
	
	var _detailLog = __webpack_require__(686);
	
	var _detailLog2 = _interopRequireDefault(_detailLog);
	
	var _actions = __webpack_require__(687);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _detailFiles = __webpack_require__(688);
	
	var _detailFiles2 = _interopRequireDefault(_detailFiles);
	
	var _detailShipping = __webpack_require__(689);
	
	var _detailShipping2 = _interopRequireDefault(_detailShipping);
	
	var _detailNotes = __webpack_require__(690);
	
	var _detailNotes2 = _interopRequireDefault(_detailNotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.tickets',
	    modules: [_routing2.default, _modals2.default, _config2.default, _ticket2.default, _product2.default, _product4.default, _products2.default, _ticket4.default, _main2.default, _chemicalProgram2.default, _blink2.default, _fade2.default, _formula2.default, _presets2.default, _company2.default, _list2.default, _component2.default, _tank2.default, _activity2.default, _component4.default, _component6.default, _is2.default, _salesCode2.default, _analysis_warning2.default, _acresCalc2.default, _product_code2.default, _file2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.tickets',
	    url: '/tickets',
	    views: {
	        '': {
	            template: '<ui-view></ui-view>'
	        },
	        actions: {
	            template: _actions2.default
	        }
	    },
	    abstract: '.list',
	    ncyBreadcrumb: {
	        label: 'Tickets'
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.list',
	    abstract: '.main',
	    controller: _ctrls.ListCtrl,
	    template: _list4.default,
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.list.main',
	    url: '?company&search&created_at__range&status&page&ordering&contains_product',
	    // The React page owns these query params (it writes them directly and
	    // refetches itself); the legacy fallback also drives them via UI + an
	    // explicit `$state.go('.', ..., {notify: false})`. Neither relies on the
	    // state reloading when they change, so disable it - otherwise Angular
	    // remounts the React island (and reconciles a stale `$location`) on every
	    // paginate/filter, causing flicker and the "click navbar twice" bug.
	    reloadOnSearch: false,
	    // Feature flag managed by the backend controls the React list rollout.
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKETS_LIST');
	        return useReact ? '<div react-view="tickets-list"></div>' : '<ticket-list extra-fields="[\'customer\']"></ticket-list>';
	    }],
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.list.priority',
	    url: '/sorted',
	    template: '<ticket-priority-list></ticket-priority-list>',
	    data: {
	        permissions: {
	            only: ['main.can_schedule_tickets']
	        }
	    },
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec6 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.map',
	    url: '/map?status&company&delivery&crop&locations&contains_product&applicator',
	    // The React page owns these query params, see `r.in.top.tickets.list.main`.
	    reloadOnSearch: false,
	    template: '<div react-view="tickets-map"></div>',
	    ncyBreadcrumb: {
	        label: 'Ticket Map'
	    }
	}), _dec7 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.detail',
	    url: '/{ticketId:[0-9-]+}',
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? ["$stateParams", "$ticket", function ($stateParams, $ticket) {
	            "ngInject";
	
	            this.ticket = $ticket;
	            this.autoEdit = !!$stateParams.created;
	        }] : _ctrls.DetailsCtrl;
	    }],
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? '<div react-view="ticket-detail" props="{ticket: vmo.ticket, autoEdit: vmo.autoEdit}"></div><div ui-view style="display:none"></div>' : _detail2.default;
	    }],
	    as: 'vmo',
	    resolve: {
	        $ticket: function $ticket($stateParams, TicketStore, Config, ReactBridge, $q) {
	            if (Config.isFeatureFlagActive('REACT_TICKET_DETAIL')) {
	                return $q.when(ReactBridge().getResourceStore('tickets').getState().get($stateParams.ticketId));
	            }
	            return TicketStore.get($stateParams.ticketId);
	        },
	        $prodConf: function $prodConf(ProductConfStore, $ticket, Config) {
	            if (Config.isFeatureFlagActive('REACT_TICKET_DETAIL')) {
	                return null;
	            }
	            ProductConfStore.params.company = $ticket.company.id;
	            return ProductConfStore.refresh();
	        },
	        $company: function $company(CompanyStore, $ticket, Config) {
	            if (Config.isFeatureFlagActive('REACT_TICKET_DETAIL')) {
	                return null;
	            }
	            return CompanyStore.get($ticket.company.id);
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Ticket #{{ vmo.ticket.ticketnumber }}',
	        parent: 'r.in.top.tickets.list'
	    },
	    params: {
	        created: null
	    },
	    abstract: '.ticket'
	}), _dec8 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.detail.ticket',
	    url: '',
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? function () {
	            "ngInject";
	        } : _ctrls.TicketDetailsCtrl;
	    }],
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? '<div style="display:none"></div>' : _detailTicket2.default;
	    }],
	    ncyBreadcrumb: {
	        label: 'Details'
	    }
	}), _dec9 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.detail.files',
	    url: '/files',
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? function () {
	            "ngInject";
	        } : _ctrls.FilesCtrl;
	    }],
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? '<div style="display:none"></div>' : _detailFiles2.default;
	    }],
	    ncyBreadcrumb: {
	        label: 'Files'
	    }
	}), _dec10 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.detail.shipping',
	    url: '/shipping',
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? function () {
	            "ngInject";
	        } : _ctrls.TicketShippingCtrl;
	    }],
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? '<div style="display:none"></div>' : _detailShipping2.default;
	    }],
	    ncyBreadcrumb: {
	        label: 'Shipping'
	    }
	}), _dec11 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.detail.notes',
	    url: '/notes',
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? function () {
	            "ngInject";
	        } : _ctrls.TicketNotesCtrl;
	    }],
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? '<div style="display:none"></div>' : _detailNotes2.default;
	    }],
	    ncyBreadcrumb: {
	        label: 'Notes'
	    }
	}), _dec12 = (0, _decorators.State)({
	    name: 'r.in.top.tickets.detail.log',
	    url: '/log',
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? function () {
	            "ngInject";
	        } : _ctrls.TicketLogCtrl;
	    }],
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_TICKET_DETAIL');
	        return useReact ? '<div style="display:none"></div>' : _detailLog2.default;
	    }],
	    ncyBreadcrumb: {
	        label: 'Log'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = _dec8(_class = _dec9(_class = _dec10(_class = _dec11(_class = _dec12(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.ticket',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('TicketStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.defaultParams = {
	            date: {
	                startDate: null,
	                endDate: null
	            }
	        };
	
	        _this.endpoint = _this.R.all('tickets');
	        _this.params = _angular2.default.copy(_this.defaultParams);
	        return _this;
	    }
	
	    _createClass(Store, [{
	        key: 'resetParams',
	        value: function resetParams() {
	            this.params = _angular2.default.copy(this.defaultParams);
	        }
	    }]);
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.productConf',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('ProductConfStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('product_configurations');
	        return _this;
	    }
	
	    _createClass(Store, [{
	        key: 'uilist',
	        get: function get() {
	            return this.list.filter(function (pc) {
	                return pc.ui_location;
	            });
	        }
	    }]);
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: 'app.directives.is.active'
	}), _dec2 = (0, _decorators.Directive)('is-active', ["$location", function ($location) {
	    "ngInject";
	
	    return {
	        restrict: "A",
	        link: function link(scope, element, attrs) {
	            scope.$watch(function () {
	                return $location.hash();
	            }, function (newHash) {
	                if (newHash === attrs.isActive) {
	                    element.addClass('active');
	                } else {
	                    element.removeClass('active');
	                }
	            });
	        }
	    };
	}]), _dec3 = (0, _decorators.Directive)('default', ["$location", function ($location) {
	    "ngInject";
	
	    return {
	        restrict: "A",
	        link: function link(scope, element, attrs) {
	            scope.$watch(function () {
	                return $location.hash();
	            }, function (newHash) {
	                if (_lodash2.default.isUndefined(newHash) || !newHash) {
	                    element.addClass('active');
	                }
	            });
	        }
	    };
	}]), _dec(_class = _dec2(_class = _dec3(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class) || _class);
	exports.default = D;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TicketNotesCtrl = exports.TicketShippingCtrl = exports.FilesCtrl = exports.TicketLogCtrl = exports.TicketEditModalCtrl = exports.TicketDetailsCtrl = exports.ConfirmSendModalCtrl = exports.ConfirmEditModalCtrl = exports.ConfirmDeliveryModalCtrl = exports.DetailsCtrl = exports.ListCtrl = exports.TicketRecalc = exports.FieldConf = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _jsApiLoader = __webpack_require__(548);
	
	var _create = __webpack_require__(535);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _calculation = __webpack_require__(536);
	
	var _ctrls = __webpack_require__(544);
	
	var _modalList = __webpack_require__(545);
	
	var _modalList2 = _interopRequireDefault(_modalList);
	
	var _createModalTpl = __webpack_require__(539);
	
	var _createModalTpl2 = _interopRequireDefault(_createModalTpl);
	
	var _cloneTicket = __webpack_require__(654);
	
	var _cloneTicket2 = _interopRequireDefault(_cloneTicket);
	
	var _sendbbModal = __webpack_require__(655);
	
	var _sendbbModal2 = _interopRequireDefault(_sendbbModal);
	
	var _copyMix = __webpack_require__(656);
	
	var _copyMix2 = _interopRequireDefault(_copyMix);
	
	var _editModal = __webpack_require__(657);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	var _confirmEditModal = __webpack_require__(658);
	
	var _confirmEditModal2 = _interopRequireDefault(_confirmEditModal);
	
	var _confirmSendModal = __webpack_require__(659);
	
	var _confirmSendModal2 = _interopRequireDefault(_confirmSendModal);
	
	var _confirmStopDeliveryModal = __webpack_require__(660);
	
	var _confirmStopDeliveryModal2 = _interopRequireDefault(_confirmStopDeliveryModal);
	
	var _confirmStopApplicationModal = __webpack_require__(661);
	
	var _confirmStopApplicationModal2 = _interopRequireDefault(_confirmStopApplicationModal);
	
	var _helpers = __webpack_require__(547);
	
	var _constants = __webpack_require__(662);
	
	var _constants2 = __webpack_require__(538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FieldConf = exports.FieldConf = function () {
	    function FieldConf(ticket, prodConf) {
	        _classCallCheck(this, FieldConf);
	
	        this.ticket = ticket;
	        delete this.ticket.delivery_start;
	        delete this.ticket.delivery_stop;
	        delete this.ticket.application_start;
	        delete this.ticket.application_stop;
	        this.prodConf = prodConf;
	
	        this.fields = null;
	        this.ui = null;
	        this.values = null;
	        this.products = null;
	        this.fields = {
	            top: _lodash2.default.range(8),
	            bottom: _lodash2.default.range(10)
	        };
	        this.init();
	    }
	
	    _createClass(FieldConf, [{
	        key: 'hasUiPlace',
	        value: function hasUiPlace(config) {
	            return !_lodash2.default.isUndefined(config.ui_row) && !_lodash2.default.isUndefined(config.ui_place);
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            var self = this;
	            this.ui = {
	                top: _lodash2.default.chain(this.fields.top).map(function (x) {
	                    return [x, []];
	                }).fromPairs().value(),
	                bottom: _lodash2.default.chain(this.fields.bottom).map(function (x) {
	                    return [x, []];
	                }).fromPairs().value()
	            };
	
	            this.values = {
	                top: _lodash2.default.chain(this.fields.top).map(function (x) {
	                    return [x, {}];
	                }).fromPairs().value(),
	                bottom: _lodash2.default.chain(this.fields.bottom).map(function (x) {
	                    return [x, {}];
	                }).fromPairs().value()
	            };
	
	            // preparing UI:
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.prodConf.uilist[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var pc = _step.value;
	
	                    if (!this.hasUiPlace(pc)) {
	                        continue;
	                    }
	
	                    var place = this.ui[pc.ui_row][pc.ui_place];
	                    place.push(pc);
	                    place.sort(function (pc) {
	                        return !pc.default;
	                    }); // default first
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                var _loop = function _loop() {
	                    var n = _step2.value;
	
	                    if (!_this.hasUiPlace(n.config)) {
	                        return 'continue';
	                    }
	
	                    var place = _this.ui[n.config.ui_row][n.config.ui_place];
	                    var config = place.find(function (c) {
	                        return c.id === n.config.id;
	                    });
	                    if (!config) {
	                        place.unshift(n.config);
	                    }
	                };
	
	                for (var _iterator2 = this.ticket.nutrients[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _ret = _loop();
	
	                    if (_ret === 'continue') continue;
	                }
	
	                // default values:
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = this.prodConf.uilist[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var _pc = _step3.value;
	
	                    if (!this.hasUiPlace(_pc)) {
	                        continue;
	                    }
	
	                    var _place = this.values[_pc.ui_row][_pc.ui_place];
	                    _place.percent = 0;
	                    _place.lbs = 0;
	                    _place.pc = this.ui[_pc.ui_row][_pc.ui_place][0];
	                }
	
	                // fill with real value
	
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                        _iterator3.return();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                var _loop2 = function _loop2() {
	                    var n = _step4.value;
	
	                    if (!_this.hasUiPlace(n.config)) {
	                        return 'continue';
	                    }
	
	                    var place = _this.values[n.config.ui_row][n.config.ui_place];
	                    place.percent = n.percent;
	                    place.pc = _this.ui[n.config.ui_row][n.config.ui_place].find(function (c) {
	                        return c.id === n.config.id;
	                    });
	                };
	
	                for (var _iterator4 = this.ticket.nutrients[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var _ret2 = _loop2();
	
	                    if (_ret2 === 'continue') continue;
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	
	            this.calcLbs();
	
	            /*
	            ui = {
	                top : {
	                   8: [pc1, pc2, pc3]
	                }
	            }
	            values = {
	                top: {
	                  8: {
	                    'pc': pc1,
	                    'percent': x
	                  }
	                }
	            }
	             */
	        }
	    }, {
	        key: 'setClay',
	        value: function setClay(pct) {
	            var self = this;
	            var nutrients = [].concat(_toConsumableArray(_lodash2.default.values(self.values.top)), _toConsumableArray(_lodash2.default.values(self.values.bottom)));
	            var clay = nutrients.find(function (x) {
	                return x.pc && x.pc.source_of.id == 'clay';
	            });
	            if (clay) {
	                clay.percent = pct;
	            }
	        }
	    }, {
	        key: 'calcLbs',
	        value: function calcLbs() {
	            var self = this;
	            var _iteratorNormalCompletion5 = true;
	            var _didIteratorError5 = false;
	            var _iteratorError5 = undefined;
	
	            try {
	                for (var _iterator5 = self.ticket.nutrients[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                    var _n = _step5.value;
	
	                    if (!this.hasUiPlace(_n.config)) {
	                        continue;
	                    }
	
	                    var place = self.values[_n.config.ui_row][_n.config.ui_place];
	                    self.onPercentChanged(place);
	                }
	            } catch (err) {
	                _didIteratorError5 = true;
	                _iteratorError5 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                        _iterator5.return();
	                    }
	                } finally {
	                    if (_didIteratorError5) {
	                        throw _iteratorError5;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'syncNutrientsToTicket',
	        value: function syncNutrientsToTicket() {
	            var self = this;
	            var topNutrients = _lodash2.default.values(self.values.top).filter(function (x) {
	                return x.pc;
	            });
	            var bottomNutrients = _lodash2.default.values(self.values.bottom).filter(function (x) {
	                return x.pc;
	            });
	            var nutrients = [].concat(_toConsumableArray(topNutrients), _toConsumableArray(bottomNutrients));
	            self.errorMapping = _lodash2.default.extend({}, _lodash2.default.fromPairs(topNutrients.map(function (_, i) {
	                return [i, 'top_' + i];
	            })), _lodash2.default.fromPairs(bottomNutrients.map(function (_, i) {
	                return [topNutrients.length + i, 'bottom_' + i];
	            })));
	            self.ticket.nutrients = nutrients.map(function (n) {
	                return {
	                    percent: n.percent || 0,
	                    config: {
	                        id: n.pc.id
	                    }
	                };
	            });
	        }
	    }, {
	        key: 'handleErrors',
	        value: function handleErrors(errors) {
	            var _this2 = this;
	
	            errors = _lodash2.default.clone(errors);
	            // take errors and their position in array:
	            var nerrors = (errors.nutrients || []).map(function (err, i) {
	                return [i, err];
	            });
	            // filter out the empty ones
	            nerrors = nerrors.filter(function (x) {
	                return !_lodash2.default.isEmpty(x[1]);
	            });
	            // take possition from errorMapping:
	            nerrors = nerrors.map(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    i = _ref2[0],
	                    err = _ref2[1];
	
	                return [_this2.errorMapping[i], _lodash2.default.values(err)[0]];
	            });
	            errors.nutrients = _lodash2.default.fromPairs(nerrors);
	            return errors;
	        }
	    }, {
	        key: 'onPercentChanged',
	        value: function onPercentChanged(obj) {
	            if (!obj.percent) {
	                obj.percent = 0;
	            }
	            obj.percent = parseFloat(obj.percent);
	            if (obj.percent < 0 || obj.percent > 100) {
	                obj.percent = 0;
	            }
	            obj.percent = _lodash2.default.round(obj.percent, 3);
	            obj.lbs = this.ticket.rate * (obj.percent / 100);
	            obj.lbs = _lodash2.default.round(obj.lbs, 3);
	        }
	    }, {
	        key: 'onLbsChanged',
	        value: function onLbsChanged(obj) {
	            if (!obj.lbs) {
	                obj.lbs = 0;
	            }
	            obj.lbs = parseFloat(obj.lbs);
	            if (obj.lbs < 0) {
	                obj.lbs = 0;
	            }
	            obj.lbs = _lodash2.default.round(obj.lbs, 3);
	            obj.percent = obj.lbs / this.ticket.rate * 100;
	            obj.percent = _lodash2.default.round(obj.percent, 3);
	        }
	    }]);
	
	    return FieldConf;
	}();
	
	var TicketRecalc = exports.TicketRecalc = function (_BaseReCalc) {
	    _inherits(TicketRecalc, _BaseReCalc);
	
	    function TicketRecalc(ticket, fieldConf) {
	        _classCallCheck(this, TicketRecalc);
	
	        var _this3 = _possibleConstructorReturn(this, (TicketRecalc.__proto__ || Object.getPrototypeOf(TicketRecalc)).call(this, ticket));
	
	        _this3.fieldConf = fieldConf;
	        return _this3;
	    }
	
	    _createClass(TicketRecalc, [{
	        key: '_nutrients',
	        value: function _nutrients() {
	            this.fieldConf.calcLbs();
	        }
	    }]);
	
	    return TicketRecalc;
	}(_calculation.BaseReCalc);
	
	var ListCtrl = exports.ListCtrl = function () {
	    ListCtrl.$inject = ["$growl", "$state", "Modal", "TicketStore", "Config"];
	    function ListCtrl($growl, $state, Modal, TicketStore, Config) {
	        "ngInject";
	
	        _classCallCheck(this, ListCtrl);
	
	        this.$growl = $growl;
	        this.$state = $state;
	        this.Modal = Modal;
	        this.store = TicketStore;
	        this.Config = Config;
	    }
	
	    _createClass(ListCtrl, [{
	        key: 'openAddModal',
	        value: function openAddModal() {
	            var _this4 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _createModalTpl2.default,
	                controller: AddTicketCtrl,
	                size: 'small',
	                resolve: {
	                    store: function store() {
	                        return _this4.store;
	                    }
	                }
	            });
	
	            $modal.result.then(function (data) {
	                self.$growl.added();
	                self.$state.go('r.in.top.tickets.detail', { ticketId: data.id, created: true }, { absolute: true, reload: true });
	            });
	        }
	    }, {
	        key: 'showAngularCreateButton',
	        get: function get() {
	            return !(this.Config.isFeatureFlagActive('REACT_TICKETS_LIST') && this.$state.current.name === 'r.in.top.tickets.list.main');
	        }
	    }]);
	
	    return ListCtrl;
	}();
	
	var CloneMixCtrl = function () {
	    CloneMixCtrl.$inject = ["$uibModalInstance", "ticket"];
	    function CloneMixCtrl($uibModalInstance, ticket) {
	        "ngInject";
	
	        _classCallCheck(this, CloneMixCtrl);
	
	        var self = this;
	
	        self.$modal = $uibModalInstance;
	        self.ticket = ticket;
	        self.ticketList = [];
	        self.endpoint = self.ticket.one('copy_mix');
	        self.endpoint.getList().then(function (response) {
	            self.ticketList = response;
	        });
	    }
	
	    _createClass(CloneMixCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.loading = true;
	            self.endpoint.post().then(function () {
	                self.$modal.close({});
	            }).finally(function () {
	                self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Clone Mix';
	        }
	    }]);
	
	    return CloneMixCtrl;
	}();
	
	var DetailsCtrl = exports.DetailsCtrl = function () {
	    DetailsCtrl.$inject = ["BB", "SecureUrlService", "$state", "$growl", "$company", "$ticket", "Modal", "$interval", "UserService"];
	    function DetailsCtrl(BB, SecureUrlService, $state, $growl, $company, $ticket, Modal, $interval, UserService) {
	        "ngInject";
	
	        _classCallCheck(this, DetailsCtrl);
	
	        this.BB = BB;
	        this.ticket = $ticket;
	        this.delivery_start = this.ticket.delivery_start;
	        this.delivery_stop = this.ticket.delivery_stop;
	        this.application_start = this.ticket.application_start;
	        this.application_stop = this.ticket.application_stop;
	        delete this.ticket.delivery_start;
	        delete this.ticket.delivery_stop;
	        delete this.ticket.application_start;
	        delete this.ticket.application_stop;
	        this.company = $company;
	        this.$growl = $growl;
	        this.$state = $state;
	        this.Modal = Modal;
	        this.secureUrlService = SecureUrlService;
	        this.stopInterval = null;
	        this.$interval = $interval;
	        this.initDeliveryTimer();
	        this.initApplicationTimer();
	        this.user = UserService.$user;
	    }
	
	    _createClass(DetailsCtrl, [{
	        key: 'onDestroy',
	        value: function onDestroy() {
	            if (this.stopInterval) {
	                clearInterval(this.stopInterval);
	            }
	        }
	    }, {
	        key: 'sendToBB',
	        value: function sendToBB() {
	            var _this5 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _sendbbModal2.default,
	                controller: SendPresetsCtrl,
	                resolve: {
	                    company: function company() {
	                        return _this5.company;
	                    },
	                    ticket: function ticket() {
	                        return _this5.ticket;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$state.go(self.$state.current, { created: false }, { reload: true });
	            });
	        }
	    }, {
	        key: 'shippingTicketUrl',
	        value: function shippingTicketUrl() {
	            var self = this;
	            this.secureUrlService.openInNewWindow(self.ticket.one('shipping_ticket'));
	        }
	    }, {
	        key: 'copyMix',
	        value: function copyMix() {
	            var _this6 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _copyMix2.default,
	                controller: CloneMixCtrl,
	                resolve: {
	                    ticket: function ticket() {
	                        return _this6.ticket;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.success('Copied sucesfully');
	            });
	        }
	    }, {
	        key: 'cloneTicket',
	        value: function cloneTicket() {
	            var _this7 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _cloneTicket2.default,
	                controller: CloneTicketCtrl,
	                size: 'small',
	                resolve: {
	                    ticket: function ticket() {
	                        return _this7.ticket;
	                    }
	                }
	            });
	
	            $modal.result.then(function (data) {
	                self.$state.go('r.in.top.tickets.detail', { ticketId: data.id, created: true });
	                self.$growl.copied();
	            });
	        }
	    }, {
	        key: 'print',
	        value: function print() {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _modalList2.default,
	                controller: _ctrls.PrinterListModalCtrl,
	                size: 'large',
	                resolve: {
	                    company: function company() {
	                        return self.ticket.company.id;
	                    },
	                    request: function request() {
	                        return {
	                            endpoint: self.ticket.all('shipping-ticket').all('print'),
	                            multiple: false
	                        };
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$state.go(self.$state.current, { created: false }, { reload: true });
	                self.$growl.success('Added file to queue');
	            });
	        }
	    }, {
	        key: 'getTimerModal',
	        value: function getTimerModal(modalTpl) {
	            return this.Modal.open({
	                template: modalTpl,
	                controller: ConfirmEditModalCtrl
	            });
	        }
	    }, {
	        key: 'confirmStopDeliveryModal',
	        value: function confirmStopDeliveryModal() {
	            var _this8 = this;
	
	            var modal = this.getTimerModal(_confirmStopDeliveryModal2.default);
	            modal.result.then(function () {
	                _this8.delivery_stop = _this8.saveTime(_constants.timerFields.deliveryStop, 'Delivery stopped!');
	                _this8.stopTimer();
	            });
	        }
	    }, {
	        key: 'confirmStopApplicationModal',
	        value: function confirmStopApplicationModal() {
	            var _this9 = this;
	
	            var modal = this.getTimerModal(_confirmStopApplicationModal2.default);
	            modal.result.then(function () {
	                _this9.application_stop = _this9.saveTime(_constants.timerFields.applicationStop, 'Application stopped!');
	                _this9.stopTimer();
	            });
	        }
	    }, {
	        key: 'initDeliveryTimer',
	        value: function initDeliveryTimer() {
	            if (this.delivery_start && !this.delivery_stop && !this.ticket.break_in_progress) {
	                this.displayDeliveryTime = this.calcDatetimeDiff(new Date(), Date.parse(this.delivery_start), this.ticket.break_time);
	                this.stopInterval = this.startTimer(_constants.timerType.delivery);
	            } else if (this.delivery_start && !this.delivery_stop && this.ticket.break_in_progress) {
	                this.displayDeliveryTime = this.calcDatetimeDiff(new Date(), Date.parse(this.delivery_start), this.ticket.break_time);
	            }
	        }
	    }, {
	        key: 'initApplicationTimer',
	        value: function initApplicationTimer() {
	            if (this.application_start && !this.application_stop && !this.ticket.break_in_progress) {
	                this.displayApplicationTime = this.calcDatetimeDiff(new Date(), Date.parse(this.application_start), this.ticket.break_time);
	                this.stopInterval = this.startTimer(_constants.timerType.application);
	            } else if (this.application_start && !this.application_stop && this.ticket.break_in_progress) {
	                this.displayApplicationTime = this.calcDatetimeDiff(new Date(), Date.parse(this.application_start), this.ticket.break_time);
	            }
	        }
	    }, {
	        key: 'startTimer',
	        value: function startTimer(type) {
	            var _this10 = this;
	
	            if (type === _constants.timerType.delivery) {
	                return this.$interval(function () {
	                    _this10.displayDeliveryTime = _this10.calcDatetimeDiff(new Date(), Date.parse(_this10.delivery_start), _this10.ticket.break_time);
	                }, 1000);
	            } else if (type === _constants.timerType.application) {
	                return this.$interval(function () {
	                    _this10.displayApplicationTime = _this10.calcDatetimeDiff(new Date(), Date.parse(_this10.application_start), _this10.ticket.break_time);
	                }, 1000);
	            }
	        }
	    }, {
	        key: 'stopTimer',
	        value: function stopTimer() {
	            this.$interval.cancel(this.stopInterval);
	        }
	    }, {
	        key: 'calcDatetimeDiff',
	        value: function calcDatetimeDiff(toTime, fromTime) {
	            var break_time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	            var newDateDiff = (toTime - fromTime) / 1000 - break_time;
	            return this.transform(newDateDiff);
	        }
	    }, {
	        key: 'transform',
	        value: function transform(value) {
	            var sec_num = Math.floor(value);
	            var hours = Math.floor(sec_num / 3600);
	            var minutes = Math.floor((sec_num - hours * 3600) / 60);
	            var seconds = sec_num - hours * 3600 - minutes * 60;
	            return hours + 'h : ' + minutes + 'm : ' + seconds + 's';
	        }
	    }, {
	        key: 'saveTime',
	        value: function saveTime(field, message) {
	            var _this11 = this;
	
	            var new_datetime = new Date();
	            this.ticket.patch(_defineProperty({}, field, new_datetime)).then(function (response) {
	                _angular2.default.extend(_this11.ticket, response);
	                _this11.$growl.success(message);
	            }, function (response) {
	                if (response.status === 500) {
	                    _this11.$growl.error(response.data.detail);
	                }
	            });
	            return new_datetime;
	        }
	    }, {
	        key: 'showInDelivery',
	        value: function showInDelivery() {
	            return this.delivery_start && !this.delivery_stop;
	        }
	    }, {
	        key: 'showInApplication',
	        value: function showInApplication() {
	            return this.application_start && !this.application_stop;
	        }
	    }, {
	        key: 'showStopDelivery',
	        value: function showStopDelivery() {
	            return this.delivery_start && !this.delivery_stop && (this.user.role.name === 'Admin' || this.user.role.name === 'Dispatcher');
	        }
	    }, {
	        key: 'showStopApplication',
	        value: function showStopApplication() {
	            return this.application_start && !this.application_stop && (this.user.role.name === 'Admin' || this.user.role.name === 'Dispatcher');
	        }
	    }, {
	        key: 'canCopyMix',
	        get: function get() {
	            return this.ticket.order;
	        }
	    }]);
	
	    return DetailsCtrl;
	}();
	
	var ConfirmDeliveryModalCtrl = exports.ConfirmDeliveryModalCtrl = function () {
	    ConfirmDeliveryModalCtrl.$inject = ["$uibModalInstance"];
	    function ConfirmDeliveryModalCtrl($uibModalInstance) {
	        "ngInject";
	
	        _classCallCheck(this, ConfirmDeliveryModalCtrl);
	
	        this.$modal = $uibModalInstance;
	    }
	
	    _createClass(ConfirmDeliveryModalCtrl, [{
	        key: 'confirmChange',
	        value: function confirmChange() {
	            this.$modal.close();
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$modal.dismiss();
	        }
	    }]);
	
	    return ConfirmDeliveryModalCtrl;
	}();
	
	var CloneTicketCtrl = function () {
	    CloneTicketCtrl.$inject = ["$state", "$uibModalInstance", "R", "ticket"];
	    function CloneTicketCtrl($state, $uibModalInstance, R, ticket) {
	        "ngInject";
	
	        _classCallCheck(this, CloneTicketCtrl);
	
	        this.ticket = ticket;
	        delete this.ticket.delivery_start;
	        delete this.ticket.delivery_stop;
	        delete this.ticket.application_start;
	        delete this.ticket.application_stop;
	        this.$modal = $uibModalInstance;
	        this.$state = $state;
	        this.data = R.copy(this.ticket);
	    }
	
	    _createClass(CloneTicketCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            var copyNotes = false;
	            self.loading = true;
	            var copyNotesCheck = document.getElementById("copy-notes");
	            if (copyNotesCheck) {
	                copyNotes = copyNotesCheck.checked;
	            }
	
	            self.ticket.one("clone").customPOST({ customer: self.data.customer, copy_notes: copyNotes }).then(function (response) {
	                self.$modal.close(response);
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Copy ticket';
	        }
	    }]);
	
	    return CloneTicketCtrl;
	}();
	
	var ConfirmEditModalCtrl = exports.ConfirmEditModalCtrl = function () {
	    ConfirmEditModalCtrl.$inject = ["$uibModalInstance"];
	    function ConfirmEditModalCtrl($uibModalInstance) {
	        "ngInject";
	
	        _classCallCheck(this, ConfirmEditModalCtrl);
	
	        this.$modal = $uibModalInstance;
	    }
	
	    _createClass(ConfirmEditModalCtrl, [{
	        key: 'edit',
	        value: function edit() {
	            this.$modal.close();
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$modal.dismiss();
	        }
	    }]);
	
	    return ConfirmEditModalCtrl;
	}();
	
	var ConfirmSendModalCtrl = exports.ConfirmSendModalCtrl = function () {
	    ConfirmSendModalCtrl.$inject = ["$uibModalInstance"];
	    function ConfirmSendModalCtrl($uibModalInstance) {
	        "ngInject";
	
	        _classCallCheck(this, ConfirmSendModalCtrl);
	
	        this.$modal = $uibModalInstance;
	    }
	
	    _createClass(ConfirmSendModalCtrl, [{
	        key: 'send',
	        value: function send() {
	            this.$modal.close();
	        }
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.$modal.dismiss();
	        }
	    }]);
	
	    return ConfirmSendModalCtrl;
	}();
	
	var TicketDetailsCtrl = exports.TicketDetailsCtrl = function (_DetailViewMap) {
	    TicketDetailsCtrl.$inject = ["$ticket", "$company", "$growl", "$stateParams", "$prodConf", "$state", "hotkeys", "modalRegistry", "Modal"];
	    _inherits(TicketDetailsCtrl, _DetailViewMap);
	
	    function TicketDetailsCtrl($ticket, $company, $growl, $stateParams, $prodConf, $state, hotkeys, modalRegistry, Modal) {
	        "ngInject";
	
	        _classCallCheck(this, TicketDetailsCtrl);
	
	        // maps
	        var _this12 = _possibleConstructorReturn(this, (TicketDetailsCtrl.__proto__ || Object.getPrototypeOf(TicketDetailsCtrl)).call(this, $ticket));
	
	        _this12.$state = $state;
	        _this12.$growl = $growl;
	        _this12.$stateParams = $stateParams;
	        _this12.ticket = $ticket;
	        delete _this12.ticket.delivery_start;
	        delete _this12.ticket.delivery_stop;
	        delete _this12.ticket.application_start;
	        delete _this12.ticket.application_stop;
	        _this12.hotkeys = hotkeys;
	        _this12.modalRegistry = modalRegistry;
	        _this12.prodConf = $prodConf;
	        _this12.company = $company;
	        _this12.fieldConf = null;
	        _this12.tRecalc = null;
	        _this12.state = {};
	        _this12.Modal = Modal;
	        _this12.onEdit = function () {
	            return _this12.requestOpenEditModal();
	        };
	        _this12.setFieldConf();
	        _this12.setHotKeys();
	        _this12.customEvents();
	        return _this12;
	    }
	
	    _createClass(TicketDetailsCtrl, [{
	        key: 'customEvents',
	        value: function customEvents() {
	            if (this.$stateParams.created) {
	                this.openEditModal();
	            }
	        }
	    }, {
	        key: 'setHotKeys',
	        value: function setHotKeys() {
	            var self = this;
	            self.hotkeys.add({
	                combo: 'e',
	                description: 'Edit Modal',
	                callback: function callback(event, hotkey) {
	                    if (self.modalRegistry.isOpen('ticket-edit')) {
	                        return;
	                    }
	                    ;
	                    self.modalRegistry.push('ticket-edit');
	                    self.requestOpenEditModal();
	                }
	            });
	        }
	    }, {
	        key: 'setFieldConf',
	        value: function setFieldConf() {
	            this.fieldConf = new FieldConf(this.ticket, this.prodConf);
	            this.tRecalc = new TicketRecalc(this.ticket, this.fieldConf);
	        }
	    }, {
	        key: 'openEditModal',
	        value: function openEditModal() {
	            var _this13 = this;
	
	            var self = this;
	            var modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: TicketEditModalCtrl,
	                size: 'ticket-edit',
	                resolve: {
	                    ticket: function ticket() {
	                        return _this13.ticket;
	                    },
	                    prodConf: function prodConf() {
	                        return _this13.prodConf;
	                    },
	                    company: function company() {
	                        return _this13.company;
	                    },
	                    state: function state() {
	                        return _this13.state;
	                    }
	                }
	            });
	
	            modal.result.then(function (r) {
	                if (r && r.companyChanged) {
	                    self.$growl.success('You\'ve changed company! New ticket number generated!');
	                    self.$state.go('r.in.top.tickets.detail', { ticketId: r.newId, created: false }, { absolute: true });
	                }
	                if (self.$stateParams.created) {
	                    // reload page if crated
	                    window.location.reload();
	                } else {
	                    // Update components
	                    self.setFieldConf();
	                    self.getStaticLocations();
	                    self.updateMarkers();
	                }
	            }).finally(function () {
	                self.modalRegistry.pop('ticket-edit');
	            });
	        }
	    }, {
	        key: 'requestOpenEditModal',
	        value: function requestOpenEditModal() {
	            var self = this;
	            if (this.ticket.status === _constants.ticketStatus.completed) {
	                var modal = self.Modal.open({
	                    template: _confirmEditModal2.default,
	                    controller: ConfirmEditModalCtrl
	                });
	                modal.result.then(function () {
	                    return self.openEditModal();
	                });
	            } else {
	                this.openEditModal();
	            }
	        }
	    }]);
	
	    return TicketDetailsCtrl;
	}(_helpers.DetailViewMap);
	
	var TicketEditModalCtrl = exports.TicketEditModalCtrl = function (_EditViewMap) {
	    TicketEditModalCtrl.$inject = ["R", "$growl", "$location", "$timeout", "$uibModalInstance", "ticket", "prodConf", "company", "state"];
	    _inherits(TicketEditModalCtrl, _EditViewMap);
	
	    function TicketEditModalCtrl(R, $growl, $location, $timeout, $uibModalInstance, ticket, prodConf, company, state) {
	        "ngInject";
	
	        _classCallCheck(this, TicketEditModalCtrl);
	
	        var _this14 = _possibleConstructorReturn(this, (TicketEditModalCtrl.__proto__ || Object.getPrototypeOf(TicketEditModalCtrl)).call(this, ticket));
	
	        _this14.$growl = $growl;
	        _this14.$modal = $uibModalInstance;
	        _this14.$timeout = $timeout;
	        _this14.company = company;
	        _this14.ticket = ticket;
	        delete _this14.ticket.delivery_start;
	        delete _this14.ticket.delivery_stop;
	        delete _this14.ticket.application_start;
	        delete _this14.ticket.application_stop;
	
	        _this14.R = R;
	        _this14.data = R.copy(_this14.ticket);
	        _this14.fieldConf = new FieldConf(_this14.data, prodConf);
	        _this14.tRecalc = new TicketRecalc(_this14.data, _this14.fieldConf);
	        _this14.loading = {};
	        _this14.state = state;
	        _this14.acresStatus = '';
	        _this14.saveDisabled = false;
	        _this14.companyChanged = false;
	
	        if (_this14.company.custom_delay !== null && _this14.data.delay === null) {
	            _this14.data.delay = _this14.company.custom_delay;
	        }
	
	        $location.hash(''); // clear
	        return _this14;
	    }
	
	    _createClass(TicketEditModalCtrl, [{
	        key: 'onCompanyChange',
	        value: function onCompanyChange() {}
	    }, {
	        key: 'onCustomerChange',
	        value: function onCustomerChange() {
	            this.data.freight_zone = this.data.customer.freight_zone;
	        }
	    }, {
	        key: 'onAcresModelChange',
	        value: function onAcresModelChange() {
	            this.tRecalc.acres();
	            this.data.is_acres_touched = true;
	        }
	    }, {
	        key: 'onQuantityChange',
	        value: function onQuantityChange() {
	            this.tRecalc.quantity();
	            this.data.is_acres_touched = true;
	        }
	    }, {
	        key: 'handleFormulationErrors',
	        value: function handleFormulationErrors(errors) {
	            this.saveDisabled = true;
	            this.calc('calc', false);
	        }
	    }, {
	        key: 'handleErrors',
	        value: function handleErrors(errors) {
	            if (errors.formulation) {
	                this.handleFormulationErrors(errors);
	            }
	            this.errors = this.fieldConf.handleErrors(errors);
	        }
	    }, {
	        key: 'acresStatusCallback',
	        value: function acresStatusCallback() {
	            this.acresStatus = '';
	        }
	    }, {
	        key: 'reCalculateAcres',
	        value: function reCalculateAcres(canReCalc) {
	            if (canReCalc) {
	                return;
	            }
	            this.data.acres = _lodash2.default.round(_lodash2.default.sum(_lodash2.default.map(this.data.fields, 'field.acres')), 2);
	            this.tRecalc.acres();
	        }
	    }, {
	        key: 'onAcresTouchChange',
	        value: function onAcresTouchChange(isChanged) {
	            this.reCalculateAcres(isChanged);
	        }
	    }, {
	        key: 'onAcresChange',
	        value: function onAcresChange(action) {
	            if (this.data.is_acres_touched) {
	                this.acresStatus = 'not-updated';
	            } else {
	                this.acresStatus = 'updated';
	            }
	
	            this.reCalculateAcres(this.data.is_acres_touched);
	            this.getDynamicLocations(this.data.fields);
	            this.updateMarkers();
	        }
	    }, {
	        key: 'getData',
	        value: function getData() {
	            var data = _angular2.default.copy(this.data);
	
	            delete data.delivery_start;
	            delete data.delivery_stop;
	            delete data.application_start;
	            delete data.application_stop;
	            delete this.data.delivery_start;
	            delete this.data.delivery_stop;
	            delete this.data.application_start;
	            delete this.data.application_stop;
	            data.products = _lodash2.default.filter(data.products, function (o) {
	                return o.product;
	            }); // to avoid glitches
	            return data;
	        }
	    }, {
	        key: 'beforeSend',
	        value: function beforeSend() {
	            var self = this;
	            self.data.gals = self.data.gals === '' ? null : self.data.gals;
	            self.data.lbs_gal = self.data.lbs_gal === '' ? null : self.data.lbs_gal;
	            self.data.custom_fields_destinations = self.ticket.custom_fields_destinations;
	
	            if (self.data.applicators == null) {
	                self.data.applicators = [];
	            } else if (!Array.isArray(self.data.applicators)) {
	                self.data.applicators = Array(self.data.applicators);
	            }
	            if (self.data.haulers == null) {
	                self.data.haulers = [];
	            } else if (!Array.isArray(self.data.haulers)) {
	                self.data.haulers = Array(self.data.haulers);
	            }
	        }
	    }, {
	        key: 'calc',
	        value: function calc(btn) {
	            var raise_exception = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            var self = this;
	            var params = {};
	            btn = btn || 'calc';
	            self.loading[btn] = true;
	            self.errors = {};
	            self.fieldConf.syncNutrientsToTicket();
	
	            if (btn === 'calc_clay') {
	                params.calc_clay = 1;
	            }
	            params.raise = raise_exception;
	            self.beforeSend();
	            var data = self.getData();
	            self.data.one('calc').customPUT(data, null, params).then(function (response) {
	                if (btn === 'calc_clay') {
	                    self.fieldConf.setClay(response.formulation.clay || 0);
	                } else {
	                    var newData = response.plain();
	                    delete newData.products; // Do not remove last line if cals
	                    _angular2.default.extend(self.data, newData);
	                }
	                if (raise_exception) {
	                    self.saveDisabled = false;
	                }
	            }, function (response) {
	                if (response.status === 500) {
	                    self.$growl.error("Server Error. We could not calculate formula!");
	                    return;
	                }
	                self.handleErrors(response.data);
	            }).finally(function () {
	                return self.loading = {};
	            });
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	            var self = this;
	            if (self._submitting) {
	                return;
	            }
	            self._submitting = true;
	            var params = {};
	
	            self.loading[close ? 'submit' : 'submitc'] = true;
	            self.fieldConf.syncNutrientsToTicket();
	            self.errors = {};
	            var data = self.getData();
	            delete data.delivery_start;
	            delete data.delivery_stop;
	
	            data.products = 'a';
	            self.beforeSend();
	            data.put(params).then(function (response) {
	                _angular2.default.extend(self.ticket, response);
	                if (close) {
	                    var changed = !_angular2.default.equals(self.ticket.company, self.data.company);
	                    _angular2.default.extend(self.ticket, response);
	                    self.$growl.updated();
	                    self.$modal.close({ companyChanged: changed, newId: response.id });
	                }
	            }, function (resp) {
	                if (resp.status === 500) {
	                    self.$growl.error("Server Error. We could not calculate formula!");
	                    return;
	                } else if (resp.status === 400) {
	                    Object.entries(resp.data).forEach(function (entry) {
	                        var _entry = _slicedToArray(entry, 2),
	                            field = _entry[0],
	                            error = _entry[1];
	
	                        error.forEach(function (err_msg) {
	                            if ((typeof err_msg === 'undefined' ? 'undefined' : _typeof(err_msg)) === 'object' && err_msg !== null) {
	                                Object.entries(err_msg).forEach(function (list_entry) {
	                                    self.$growl.error(field + ': ' + list_entry);
	                                });
	                            } else {
	                                self.$growl.error(field + ': ' + err_msg);
	                            }
	                        });
	                    });
	                }
	                self.handleErrors(resp.data);
	            }).finally(function () {
	                self.loading = {};
	                self._submitting = false;
	            });
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.$modal.close();
	        }
	    }, {
	        key: 'isZoneEditable',
	        get: function get() {
	            return this.data.company.id === _constants2.MARION_ID;
	        }
	    }]);
	
	    return TicketEditModalCtrl;
	}(_helpers.EditViewMap);
	
	var TicketLogCtrl = exports.TicketLogCtrl = ["$ticket", function TicketLogCtrl($ticket) {
	    "ngInject";
	
	    _classCallCheck(this, TicketLogCtrl);
	
	    this.ticket = $ticket;
	}];
	
	var AddTicketCtrl = function (_BaseAddModal) {
	    AddTicketCtrl.$inject = ["$uibModalInstance", "store", "UserService"];
	    _inherits(AddTicketCtrl, _BaseAddModal);
	
	    function AddTicketCtrl($uibModalInstance, store, UserService) {
	        "ngInject";
	
	        _classCallCheck(this, AddTicketCtrl);
	
	        return _possibleConstructorReturn(this, (AddTicketCtrl.__proto__ || Object.getPrototypeOf(AddTicketCtrl)).call(this, $uibModalInstance, store, UserService));
	    }
	
	    _createClass(AddTicketCtrl, [{
	        key: 'title',
	        get: function get() {
	            return 'Add Ticket';
	        }
	    }]);
	
	    return AddTicketCtrl;
	}(_create2.default);
	
	var SendPresetsCtrl = function () {
	    SendPresetsCtrl.$inject = ["BB", "$uibModalInstance", "company", "ticket", "$growl", "Modal"];
	    function SendPresetsCtrl(BB, $uibModalInstance, company, ticket, $growl, Modal) {
	        "ngInject";
	
	        _classCallCheck(this, SendPresetsCtrl);
	
	        var self = this;
	
	        self.$modal = $uibModalInstance;
	        self.$growl = $growl;
	        self.ticket = ticket;
	        self.company = company;
	        self.BB = BB;
	        self.loading = false;
	        self.checking = false;
	        self.ctrl = BB.ctrl;
	        self.presets = {};
	        self.Modal = Modal;
	        self.registerTags = _lodash2.default.uniq([self.company.murray_settings.chem_write_tag, self.company.murray_settings.fert_write_tag]);
	
	        self.checkStatus();
	        self.getPresets();
	
	        self.checkingIfBusyPromise = null;
	    }
	
	    _createClass(SendPresetsCtrl, [{
	        key: 'checkStatus',
	        value: function checkStatus() {
	            var self = this;
	            self.checking = true;
	            return self.BB.status(self.registerTags).finally(function () {
	                self.checking = false;
	            });
	        }
	    }, {
	        key: 'getPresets',
	        value: function getPresets() {
	            var self = this;
	            self.ticket.one('murray').get().then(function (response) {
	                _angular2.default.extend(self.presets, response);
	            });
	        }
	    }, {
	        key: 'beforeSubmit',
	        value: function beforeSubmit() {
	            var self = this;
	            if (this.ticket.status === _constants.ticketStatus.completed) {
	                var modal = this.Modal.open({
	                    template: _confirmSendModal2.default,
	                    controller: ConfirmSendModalCtrl
	                });
	                modal.result.then(function () {
	                    return self.submit();
	                });
	            } else {
	                self.submit();
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            var presets = [].concat.apply([], _lodash2.default.values(self.presets.plain()));
	            presets = presets.map(function (x) {
	                return _lodash2.default.pick(x, ['write_tag', 'preset_code', 'preset']);
	            });
	
	            self.loading = true;
	            self.BB.sendPresets(self.registerTags, presets).then(function () {
	                self.presets.put().finally(function () {
	                    self.$growl.growl.success("Presets sent");
	                    self.$modal.close();
	                });
	            }).finally(function () {
	                self.loading = false;
	            });
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }]);
	
	    return SendPresetsCtrl;
	}();
	
	var FilesCtrl = exports.FilesCtrl = ["$ticket", function FilesCtrl($ticket) {
	    "ngInject";
	
	    _classCallCheck(this, FilesCtrl);
	
	    this.ticket = $ticket;
	}];
	
	var TicketShippingCtrl = exports.TicketShippingCtrl = function () {
	    TicketShippingCtrl.$inject = ["R", "$growl", "$timeout", "$ticket"];
	    function TicketShippingCtrl(R, $growl, $timeout, $ticket) {
	        "ngInject";
	
	        _classCallCheck(this, TicketShippingCtrl);
	
	        this.$growl = $growl;
	        this.$timeout = $timeout;
	        this.ticket = $ticket;
	        delete this.ticket.delivery_start;
	        delete this.ticket.delivery_stop;
	        delete this.ticket.application_start;
	        delete this.ticket.application_stop;
	        this.R = R;
	        this.data = R.copy(this.ticket);
	        this.loading = {};
	        this.acresStatus = '';
	        this.saveDisabled = false;
	        this.companyChanged = false;
	        this.nozzle_sizes = Array.from({ length: 21 }, function (x, i) {
	            return i * 5 + 25;
	        }); // [25, 30, ... ,125]
	        this.speeds = Array.from({ length: 21 }, function (x, i) {
	            return i;
	        }); // [0, 1, 2, ... , 19, 29]
	        this.temps = Array.from({ length: 86 }, function (x, i) {
	            return i + 20;
	        }); // [20, 21, ... , 104, 105]
	        this.directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
	        var wind = this.data.applicators_notes.wind;
	        this.data.applicators_notes.wind = wind ? "Yes" : "No";
	    }
	
	    _createClass(TicketShippingCtrl, [{
	        key: 'getData',
	        value: function getData() {
	            var data = _angular2.default.copy(this.data);
	            var wind = data.applicators_notes.wind;
	            data.applicators_notes.wind = wind === "Yes";
	            return data;
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.errors = {};
	            var data = self.getData();
	            self.ticket.customPATCH({ applicators_notes: data.applicators_notes }).then(function (response) {
	                _angular2.default.extend(self.ticket, response);
	            }, function (resp) {
	                self.errors = resp.data;
	            });
	        }
	    }]);
	
	    return TicketShippingCtrl;
	}();
	
	var TicketNotesCtrl = exports.TicketNotesCtrl = function () {
	    TicketNotesCtrl.$inject = ["R", "$growl", "$timeout", "$ticket"];
	    function TicketNotesCtrl(R, $growl, $timeout, $ticket) {
	        "ngInject";
	
	        _classCallCheck(this, TicketNotesCtrl);
	
	        this.$growl = $growl;
	        this.$timeout = $timeout;
	        this.ticket = $ticket;
	        delete this.ticket.delivery_start;
	        delete this.ticket.delivery_stop;
	        delete this.ticket.application_start;
	        delete this.ticket.application_stop;
	        this.R = R;
	        this.data = R.copy(this.ticket);
	    }
	
	    _createClass(TicketNotesCtrl, [{
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.errors = {};
	            self.ticket.customPATCH({ notes: self.data.notes }).then(function (response) {
	                _angular2.default.extend(self.ticket, response);
	            }, function (resp) {
	                self.errors = resp.data;
	            });
	        }
	    }]);
	
	    return TicketNotesCtrl;
	}();

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\">\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row top-space\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Customer</label>\n                    <div>\n                        <blnd-customer-picker ng-model=\"vm.data.customer\" company=\"vm.data.company.id\" form-error>\n                        </blnd-customer-picker>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <br />\n                <label ng-if=\"vm.ticket.notes\" class=\"control-label\"><input id=\"copy-notes\" type=\"checkbox\" checked />\n                    Copy notes</label>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\" ng-disabled=\"vm.loading\">\n            Copy\n        </button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">\n            Cancel\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.beforeSubmit()\" novalidate>\n    <div class=\"modal-header\">\n        <button\n                type=\"button\"\n                class=\"close\"\n                data-dismiss=\"modal\"\n                aria-label=\"Close\"\n                ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\">Send Presets</h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <blnd-presets presets=\"vm.presets\"></blnd-presets>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <span ng-show=\"vm.ctrl.state === 'connecting'\">Connecting to controller</span>\n                <span class=\"text-danger\" ng-show=\"vm.ctrl.state === 'controller_busy'\">System is busy, presets can't be sent now.</span>\n                <span class=\"text-danger\" ng-show=\"vm.ctrl.state === 'no_connection_with_bb'\">Connection error - could not connect to Blend Bridge.</span>\n                <span class=\"text-danger\" ng-show=\"vm.ctrl.state === 'no_connection_with_ctrl'\">Connection error - Blend Bridge could not connect to the controller.</span>\n                <span class=\"text-success\" ng-show=\"vm.ctrl.state === 'connected'\">Connected to controller</span>\n                <span ng-show=\"vm.checking\"><i class=\"fa fa-spin fa-spinner\"></i></span>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <span class=\"text-info\" ng-show=\"vm.ctrl.action === 'reset_registers'\">Resetting registers</span>\n                <span ng-show=\"vm.ctrl.action !== ''\"><i class=\"fa fa-spin fa-spinner\"></i></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-success\" type=\"submit\" ladda=\"vm.loading\">Send</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Close</button>\n    </div>\n</form>\n"

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <button type=\"button\"\n                class=\"close\"\n                data-dismiss=\"modal\"\n                aria-label=\"Close\"\n                ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\">Copy Mix</h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <p>Do you want to copy mix configuration to the following tickets:</p>\n                <ul>\n                    <li ng-repeat=\"t in vm.ticketList\">{{ t.title }} (<a ui-sref=\"r.in.top.tickets.detail({ticketId: t.id})\">open</a>)</li>\n                </ul>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"submit\" ladda=\"vm.loading\">Copy</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Close</button>\n    </div>\n</form>\n"

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <button\n                type=\"button\"\n                class=\"close\"\n                data-dismiss=\"modal\"\n                aria-label=\"Close\"\n                ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\">Ticket #{{vm.data.ticketnumber}}</h3>\n        <div class=\"tabs\">\n            <ul class=\"nav nav-pills\">\n                <li role=\"presentation\" class=\"active\" is-active=\"info\" default><a ng-href=\"#info\">Info</a></li>\n                <li role=\"presentation\" is-active=\"mix\"><a ng-href=\"#mix\">Mix</a></li>\n                <li role=\"presentation\" is-active=\"notes\"><a ng-href=\"#notes\">Notes</a></li>\n                <li role=\"presentation\" is-active=\"split\"><a ng-href=\"#split\">Split</a></li>\n            </ul>\n        </div>\n    </div>\n    <div class=\"modal-body\">\n        <section class=\"elements-form\">\n            <h4 id=\"info\">Information</h4>\n            <div class=\"row\">\n                <div class=\"col-sm-3\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"control-label\">Company</label>\n                        <blnd-company-picker ng-model=\"vm.data.company\"\n                                             test-id=\"ticket-add-company-picker\"\n                                             mode=\"edit\"\n                                             user=\"vm.user\"\n                                             ng-change=\"vm.onCompanyChange()\"\n                                             form-error>\n                        </blnd-company-picker>\n                    </div>\n                </div>\n                <div class=\"col-sm-5\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"control-label\">Customer</label>\n                        <blnd-customer-picker ng-model=\"vm.data.customer\"\n                                              data-testid=\"customer-edit\"\n                                              clear-on-change=\"true\"\n                                              company=\"vm.data.company.id\"\n                                              ng-change=\"vm.onCustomerChange()\"\n                                              form-error>\n                        </blnd-customer-picker>\n                    </div>\n                </div>\n                <div class=\"col-sm-3\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label\">Crop</label>\n                        <blnd-crop-picker allow-clear=\"true\" ng-model=\"vm.data.crop\" data-testid=\"crop-edit\" form-error></blnd-crop-picker>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"control-label\">Code</label>\n                        <blnd-sales-code-picker ng-model=\"vm.data.sales_code\"\n                                             data-testid=\"sales-code-edit\"\n                                             mode=\"edit\"\n                                             form-error>\n                        </blnd-sales-code-picker>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-sm-6\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"control-label\">Ship to</label>\n                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.ship_to_text\" data-testid=\"ship-to-edit\" form-error select-on-click/>\n                    </div>\n                </div>\n                <div class=\"col-sm-6\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label\">Ship to Fields</label>\n                        <span class=\"text-primary\" fade-in=\"vm.acresStatus === 'updated'\" callback=\"vm.acresStatusCallback()\">Acres updated!</span>\n                        <span class=\"text-danger\" fade-in=\"vm.acresStatus === 'not-updated'\" callback=\"vm.acresStatusCallback()\">Acres not updated!</span>\n                        <blnd-ship-to ng-model=\"vm.data.fields\" customer=\"vm.data.customer\" data-testid=\"ship-to-fields-edit\" ng-change=\"vm.onAcresChange()\"  mode=\"edit\"></blnd-ship-to>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"row\">\n                <div class=\"col-sm-3\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"control-label\">Delivery</label>\n                        <blnd-delivery-picker ng-model=\"vm.data.delivery\"\n                                              data-testid=\"delivery-edit\"\n                                              data=\"vm.data\"\n                                              mode=\"edit\">\n                        </blnd-delivery-picker>\n                    </div>\n                </div>\n                <div class=\"col-sm-3\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"control-label\">Applicators</label>\n                        <blnd-applicator-picker ng-model=\"vm.data.applicators\" company=\"vm.data.company\" data-testid=\"applicators-edit\" fieldname=\"applicator\" mode=\"edit\" type=\"one\"></blnd-applicator-picker>\n                    </div>\n                </div>\n                <div class=\"col-sm-3\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"control-label\">Haulers</label>\n                        <blnd-applicator-picker ng-model=\"vm.data.haulers\" company=\"vm.data.company\" data-testid=\"haulers-edit\" fieldname=\"hauler\" mode=\"edit\" type=\"one\"></blnd-applicator-picker>\n                    </div>\n                </div>\n                <div class=\"col-md-3\">\n                    <div class=\"row\">\n                        <div class=\"col-sm-4\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Zone</label>\n                                <input type=\"number\"\n                                       ng-model=\"vm.data.freight_zone\"\n                                           data-testid=\"zone-edit\"\n                                       class=\"form-control\"\n                                       ng-show=\"{disabled: !vm.isZoneEditable}\"\n                                       ng-disabled=\"!vm.isZoneEditable\"\n                                       form-error select-on-click>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-4\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Truck #</label>\n                                <input ng-model=\"vm.data.truck_number\" data-testid=\"truck-number-edit\" class=\"form-control\" form-error select-on-click>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-4\">\n                            <div class=\"form-group form-group-sm\">\n                                <label class=\"control-label\">Tank #</label>\n                                <input ng-model=\"vm.data.truck_tank\" data-testid=\"tank-number-edit\" class=\"form-control\" form-error select-on-click>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </section>\n\n        <section class=\"elements-form\">\n            <h4 id=\"mix\">Mix</h4>\n            <div class=\"row\">\n                <div class=\"col-sm-1\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label\">\n                            Acres\n                            <blnd-acres-control ng-model=\"vm.data.is_acres_touched\" ng-change=\"vm.onAcresTouchChange(isChanged)\"></blnd-acres-control>\n                        </label>\n                        <div class=\"input-group transparent\">\n                            <input type=\"number\"\n                                   min=\"0\"\n                                   step=\"0.001\"\n                                   class=\"form-control input-sm\"\n                                   ng-model=\"vm.data.acres\"\n                                   data-testid=\"acres-edit\"\n                                   ng-change=\"vm.onAcresModelChange()\"\n                                   form-error\n                                   blink\n                                   select-on-click>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\">\n                    <div class=\"form-group\">\n                        <label class=\"label-sm control-label\">Rate</label>\n                        <input type=\"number\"\n                               min=\"0\"\n                               step=\"0.001\"\n                               class=\"form-control input-sm\"\n                               ng-model=\"vm.data.rate\"\n                               data-testid=\"rate-edit\"\n                               ng-blur=\"vm.tRecalc.rate()\"\n                               form-error blink select-on-click>\n                    </div>\n                </div>\n                <div class=\"col-sm-2\">\n                    <div class=\"form-group\">\n                        <label class=\"label-sm\">Quantity</label>\n                        <div class=\"input-group blnd-order-group\">\n                            <input type=\"number\"\n                                   min=\"0\"\n                                   step=\"0.001\"\n                                   class=\"form-control input-sm\"\n                                   ng-model=\"vm.data.quantity\"\n                                   data-testid=\"quantity-edit\"\n                                   ng-change=\"vm.onQuantityChange()\"\n                                   form-error blink select-on-click>\n                            <blnd-product-code-picker ng-model=\"vm.data.product_code\" data-testid=\"product-code-edit\" mode=\"edit\"></blnd-product-code-picker>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\">\n                </div>\n                <div class=\"col-sm-1\">\n                    <div class=\"form-group\">\n                        <label class=\"label-sm\">F Batch</label>\n                        <input class=\"form-control input-sm\" ng-model=\"vm.data.fert_batches\" data-testid=\"f-batch-edit\" form-error select-on-click>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\">\n                    <div class=\"form-group\">\n                        <label class=\"label-sm control-label\">C Batch</label>\n                        <input class=\"form-control input-sm\" ng-model=\"vm.data.chem_batches\" data-testid=\"c-batch-edit\" form-error select-on-click>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\">\n                    <div class=\"form-group\">\n                        <label class=\"label-sm control-label\">Loadout</label>\n                        <blnd-tank-picker ng-model=\"vm.data.fert_tank\" data-testid=\"loadout-edit\" mode=\"edit\" company=\"vm.data.company\" type=\"fert_tanks\" form-error></blnd-tank-picker>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\" ng-if=\"vm.company.chem_tanks.length !== 0\">\n                    <div class=\"form-group\">\n                        <label class=\"label-sm control-label\">C Tank</label>\n                        <blnd-tank-picker ng-model=\"vm.data.chem_tank\" data-testid=\"c-tank-edit\" mode=\"edit\" company=\"vm.data.company\" type=\"chem_tanks\" form-error></blnd-tank-picker>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\">\n                </div>\n                <div class=\"col-sm-1\" ng-if=\"vm.data.product_code === 3001\">\n                    <div class=\"form-group\">\n                        <label class=\"label-sm control-label\">LB/G</label>\n                        <input\n                                type=\"number\"\n                                min=\"0\"\n                                step=\"0.001\"\n                                class=\"form-control input-sm\" ng-model=\"vm.data.lbs_gal\" form-error select-on-click>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\" ng-if=\"vm.data.product_code === 3001\">\n                    <div class=\"form-group\">\n                        <label class=\"label-sm control-label\">Load Total</label>\n                        <input\n                                type=\"number\"\n                                min=\"0\"\n                                step=\"0.001\"\n                                class=\"form-control input-sm\" ng-model=\"vm.data.gals\" form-error select-on-click>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-sm-1\" ng-repeat=\"f in vm.fieldConf.fields.top\" ng-show=\"vm.fieldConf.ui.top[f].length > 0\">\n                    <div class=\"form-group\" form-error=\"vm.errors.nutrients.top_{{ f }}\">\n                        <div>\n                            <select ng-model=\"vm.fieldConf.values.top[f].pc\"\n                                    ng-options=\"pc.name for pc in vm.fieldConf.ui.top[f]\"\n                                    ng-show=\"vm.fieldConf.ui.top[f].length > 1\"\n                                    class=\"form-control input-xs input-label\"\n                            >\n                            </select>\n                            <label class=\"label-sm control-label\"\n                                   ng-show=\"vm.fieldConf.ui.top[f].length === 1\"\n                                   ng-bind=\"vm.fieldConf.values.top[f].pc.name\"\n                            >\n                            </label>\n                            <button class=\"btn btn-default btn-auto-clay\" ng-if=\"vm.fieldConf.values.top[f].pc.source_of.id === 'clay'\" type=\"button\"  ng-click=\"vm.calc('calc_clay')\" ladda=\"vm.loading.calc_clay\">\n                                <i class=\"fa fa-refresh\"></i>\n                            </button>\n                        </div>\n                        <div>\n                            <input type=\"number\"\n                                   min=\"0\"\n                                   max=\"100\"\n                                   step=\"0.01\"\n                                   ng-model=\"vm.fieldConf.values.top[f].percent\"\n                                   class=\"form-control input-sm\"\n                                   blink\n                                   select-on-click\n                            >\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-sm-1-and-half\" ng-if=\"vm.company.allow_reduce_water\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"constrol-label label-sm\">Reduce Water</label>\n                        <div class=\"\">\n                            <input type=\"number\"\n                                   min=\"0\"\n                                   class=\"form-control\"\n                                   ng-model=\"vm.data.reduce_water\"\n                                   name=\"reduce_water\"\n                                   form-error select-on-click />\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-sm-1-and-half\" ng-if=\"vm.company.custom_delay\">\n                    <div class=\"form-group form-group-sm\">\n                        <label class=\"constrol-label label-sm\">Delay</label>\n                        <div class=\"\">\n                            <input type=\"number\"\n                                   min=\"0\"\n                                   class=\"form-control\"\n                                   ng-model=\"vm.data.delay\"\n                                   name=\"custom_delay\"\n                                   form-error select-on-click />\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row nutrients-form\">\n                <div class=\"col-sm-1\" ng-repeat=\"f in vm.fieldConf.fields.bottom\" ng-show=\"vm.fieldConf.ui.bottom[f].length > 0\">\n                    <div class=\"form-group\" form-error=\"vm.errors.nutrients.bottom_{{ f }}\">\n                        <div>\n                            <select ng-model=\"vm.fieldConf.values.bottom[f].pc\"\n                                    ng-options=\"pc.name for pc in vm.fieldConf.ui.bottom[f]\"\n                                    ng-show=\"vm.fieldConf.ui.bottom[f].length > 1\"\n                                    class=\"form-control input-xs input-label\"\n                            >\n                            </select>\n                            <label class=\"label-sm control-label\"\n                                   ng-show=\"vm.fieldConf.ui.bottom[f].length === 1\"\n                                   ng-bind=\"vm.fieldConf.values.bottom[f].pc.name\"\n                            >\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row nutrients-form\">\n                <div class=\"col-sm-1\" ng-repeat=\"f in vm.fieldConf.fields.bottom\" ng-show=\"vm.fieldConf.ui.bottom[f].length > 0\">\n                     <div class=\"form-group\" form-error=\"vm.errors.nutrients.bottom_{{ f }}\">\n                        <div>\n                            <input type=\"text\"\n                                   ng-model=\"vm.fieldConf.values.bottom[f].percent\"\n                                   ng-blur=\"vm.fieldConf.onPercentChanged(vm.fieldConf.values.bottom[f])\"\n                                   class=\"form-control input-sm\"\n                                   select-on-click>\n                        </div>\n                     </div>\n                </div>\n            </div>\n            <div class=\"row nutrients-form last\">\n                <div class=\"col-sm-1\" ng-repeat=\"f in vm.fieldConf.fields.bottom\" ng-show=\"vm.fieldConf.ui.bottom[f].length > 0\">\n                     <div class=\"form-group\" form-error=\"vm.errors.nutrients.bottom_{{ f }}\">\n                         <div>\n                            <input type=\"text\"\n                                   ng-model=\"vm.fieldConf.values.bottom[f].lbs\"\n                                   ng-blur=\"vm.fieldConf.onLbsChanged(vm.fieldConf.values.bottom[f])\"\n                                   blink\n                                   class=\"form-control input-sm\"\n                                   select-on-click\n                            >\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-sm-1\">\n                    <blnd-analysis-warning ng-model=\"vm.data.formulation\"></blnd-analysis-warning>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-sm-6\">\n                    <blnd-products ng-model=\"vm.data.products\"\n                                   acres=\"vm.data.acres\"\n                                   crop=\"vm.data.crop\"\n                                   acres-changed=\"vm.tRecalc.acresChanged\"\n                                   errors=\"vm.errors.products\"\n                                   mode=\"edit\"\n                                   customer=\"vs.data.customer\"\n                                   company=\"vm.data.company\"\n                                   has-errors=\"vm.saveDisabled\"\n                    ></blnd-products>\n                </div>\n                <div class=\"col-sm-6 rounded-table table-left\">\n                    <blnd-formula ticket=\"vm.data\"></blnd-formula>\n                    <div class=\"alert alert-danger\" ng-repeat=\"error in vm.data.formulation.errors\" ng-bind=\"error\"></div>\n                </div>\n            </div>\n        </section>\n\n        <section>\n            <h4 >Location </h4>\n            <!-- Google Maps -->\n            <div id=\"map\" style=\"height: 400px;\" class=\"w-100\"></div>\n        </section>\n\n        <section>\n            <h4 id=\"notes\">Notes</h4>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <textarea class=\"form-control notes-control\" ng-model=\"vm.data.notes\"></textarea>\n                </div>\n            </div>\n        </section>\n\n        <section id=\"split\">\n            <h4>Split</h4>\n            <div class=\"row\">\n                <div class=\"col-md-6\">\n                    <blnd-customer-picker ng-model=\"vm.data.split_with.customer\" company=\"vm.data.company.id\" form-error></blnd-customer-picker>\n                </div>\n            </div>\n        </section>\n    </div>\n    <div class=\"modal-footer\">\n        <div class=\"pull-left col-md-5\">\n            <blnd-chemical-program-picker ng-model=\"vm.data.chemical_program\"\n                                          acres=\"vm.data.acres\"\n                                          company=\"vm.data.company\"\n                                          products=\"vm.data.products\">\n            </blnd-chemical-program-picker>\n        </div>\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\" ladda=\"vm.loading.submit\" ng-disabled=\"vm.saveDisabled\">Save</button>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.calc()\" ladda=\"vm.loading.calc\">Calculate</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports = "<form>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">Are you sure that you want to edit completed ticket?</h3>\n    </div>\n    <div class=\"modal-body\">\n        This ticket has already been completed.\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.edit()\">Edit</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = "<form>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">Are you sure that you want to send completed ticket?</h3>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.send()\">Send</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	module.exports = "<form>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">Stop Delivery</h4>\n    </div>\n    <div class=\"modal-body\">\n        You are about to STOP the delivery proccess. This action is irreversible. Do you want to proceed?\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.edit()\">Stop Delivery</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	module.exports = "<form>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">Stop Application</h4>\n    </div>\n    <div class=\"modal-body\">\n        You are about to STOP the application proccess. This action is irreversible. Do you want to proceed?\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.edit()\">Stop Application</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var stateFilters = exports.stateFilters = {
	    all: 'Select Status',
	    open: 'Open',
	    completed: 'Completed',
	    ready_to_bill: 'Ready to Bill',
	    trashed: 'Trashed'
	};
	
	var timerType = exports.timerType = {
	    delivery: 'Delivery',
	    application: 'Application'
	};
	
	var deliveryType = exports.deliveryType = {
	    haul: 'haul',
	    applyHaul: 'apply_haul'
	};
	
	var ticketStatus = exports.ticketStatus = {
	    mixed: 'mixed',
	    completed: 'completed'
	};
	
	var timerFields = exports.timerFields = {
	    deliveryStop: 'delivery_stop',
	    applicationStop: 'application_stop'
	};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _formula = __webpack_require__(664);
	
	var _formula2 = _interopRequireDefault(_formula);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.tickets.component.formulation"
	
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-formula',
	    bindings: {
	        ticket: '='
	    },
	    template: _formula2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$element"];
	    function C($element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$element = $element;
	    }
	
	    _createClass(C, [{
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.$element.remove();
	            this.$element = null;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"formula-component\">\n    <div class=\"row\">\n        <div class=\"col-md-7\">\n            <table class=\"table table-fixed table-striped\">\n                <thead>\n                <tr>\n                    <th class=\"\">Material</th>\n                    <th class=\"\">Preset</th>\n                    <th class=\"\">Weight</th>\n                    <th class=\"\">Scale</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat=\"line in $ctrl.ticket.formulation.lines\">\n                    <td class=\"\" ng-bind=\"line.material\"></td>\n                    <td class=\"\" ng-bind=\"line.preset\"></td>\n                    <td class=\"\" ng-bind=\"line.weight\"></td>\n                    <td class=\"\" ng-bind=\"line.scale\"></td>\n                </tr>\n                </tbody>\n            </table>\n            <div class=\"row material-summary\">\n                <div class=\"col-sm-3\">\n                    <div class=\"blnd-data-field\">\n                        <div>Lb/G</div>\n                        <div ng-bind=\"$ctrl.ticket.formulation.material_summary.lb_g\"></div>\n                    </div>\n                </div>\n                <div class=\"col-sm-3\">\n                    <div class=\"blnd-data-field\">\n                        <div>G/A</div>\n                        <div ng-bind=\"$ctrl.ticket.formulation.material_summary.g_a\"></div>\n                    </div>\n                </div>\n                <div class=\"col-sm-3\">\n                    <div class=\"blnd-data-field\">\n                        <div>Wat/Ton</div>\n                        <div ng-bind=\"$ctrl.ticket.formulation.material_summary.wat_ton\"></div>\n                    </div>\n                </div>\n                <div class=\"col-sm-3\">\n                    <div class=\"blnd-data-field\">\n                        <div>Gals</div>\n                        <div ng-bind=\"$ctrl.ticket.formulation.material_summary.tot_gal\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-5\">\n            <table class=\"table table-fixed\">\n                <thead>\n                <tr>\n                    <th class=\"\">Chemical</th>\n                    <th class=\"\">Preset</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat=\"line in $ctrl.ticket.formulation.chems\">\n                    <td class=\"\" ng-bind=\"line.material\"></td>\n                    <td class=\"\" ng-bind=\"line.preset\"></td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _presets = __webpack_require__(666);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.tickets.component.presets"
	
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-presets',
	    bindings: {
	        presets: '='
	    },
	    template: _presets2.default
	}), _dec(_class = _dec2(_class = function C() {
	    _classCallCheck(this, C);
	}) || _class) || _class);
	exports.default = C;

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"formula-component\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <table class=\"table table-fixed\">\n                <thead>\n                <tr>\n                    <th class=\"col-md-5\">Fertilizer</th>\n                    <th class=\"\">Preset Tag</th>\n                    <th class=\"\">Preset Code</th>\n                    <th class=\"\">Preset Value</th>\n                </tr>\n                </thead>\n                <tbody>\n                    <tr ng-if=\"$ctrl.presets.fertilizer.length > 0\" ng-repeat=\"line in $ctrl.presets.fertilizer\">\n                        <td class=\"\" ng-bind=\"line.material\"></td>\n                        <td class=\"\" ng-bind=\"line.write_tag\"></td>\n                        <td class=\"\" ng-bind=\"line.preset_code\"></td>\n                        <td class=\"\" ng-bind=\"line.preset\"></td>\n                    </tr>\n                    <tr ng-if=\"$ctrl.presets.fertilizer.length === 0\">\n                        <td colspan=\"4\">Nothing to send</td>\n                    </tr>\n                </tbody>\n            </table>\n            <table class=\"table table-fixed\">\n                <thead>\n                <tr>\n                    <th class=\"col-md-5\">Chemicals</th>\n                    <th class=\"\">Preset Tag</th>\n                    <th class=\"\">Preset Code</th>\n                    <th class=\"\">Preset Value</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-if=\"$ctrl.presets.chemicals.length > 0\" ng-repeat=\"line in $ctrl.presets.chemicals\">\n                    <td class=\"\" ng-bind=\"line.material\"></td>\n                    <td class=\"\" ng-bind=\"line.write_tag\"></td>\n                    <td class=\"\" ng-bind=\"line.preset_code\"></td>\n                    <td class=\"\" ng-bind=\"line.preset\"></td>\n                </tr>\n                <tr ng-if=\"$ctrl.presets.chemicals.length === 0\">\n                    <td colspan=\"4\">Nothing to send</td>\n                </tr>\n                </tbody>\n            </table>\n            <table class=\"table table-fixed\">\n                <thead>\n                <tr>\n                    <th class=\"col-md-5\">Additional Information</th>\n                    <th class=\"\">Preset Tag</th>\n                    <th class=\"\">Preset Code</th>\n                    <th class=\"\">Preset Value</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-if=\"$ctrl.presets.fertilizer_batch\">\n                    <td class=\"\">Fertilizer number of batches</td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.fertilizer_batch.write_tag\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.fertilizer_batch.preset_code\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.fertilizer_batch.preset\"></td>\n                </tr>\n                <tr ng-if=\"$ctrl.presets.fertilizer_output_bank\">\n                    <td>Fertilizer output tank</td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.fertilizer_output_bank.write_tag\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.fertilizer_output_bank.preset_code\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.fertilizer_output_bank.preset\"></td>\n                </tr>\n                <tr ng-if=\"$ctrl.presets.chemical_batch\">\n                    <td class=\"\">Chemical number of batches</td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.chemical_batch.write_tag\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.chemical_batch.preset_code\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.chemical_batch.preset\"></td>\n                </tr>\n                <tr ng-if=\"$ctrl.presets.chemical_output_bank\">\n                    <td>Chemical output tank</td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.chemical_output_bank.write_tag\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.chemical_output_bank.preset_code\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.chemical_output_bank.preset\"></td>\n                </tr>\n                <tr ng-repeat=\"line in $ctrl.presets.chemical_output_banks\">\n                    <td>Chemical pod {{$index + 1}}</td>\n                    <td class=\"\" ng-bind=\"line.write_tag\"></td>\n                    <td class=\"\" ng-bind=\"line.preset_code\"></td>\n                    <td class=\"\" ng-bind=\"line.preset\"></td>\n                </tr>\n                <tr ng-if=\"$ctrl.presets.delay\">\n                    <td>Delay</td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.delay.write_tag\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.delay.preset_code\"></td>\n                    <td class=\"\" ng-bind=\"$ctrl.presets.delay.preset\"></td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _ticketStatus = __webpack_require__(668);
	
	var _ticketStatus2 = _interopRequireDefault(_ticketStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.orders.compontents.ticket.status"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-ticket-status',
	    template: _ticketStatus2.default,
	    bindings: {
	        ngModel: '=',
	        mode: '@',
	        inputClass: '@'
	    }
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["Config", "$element"];
	    function C(Config, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var self = this;
	        self.$element = $element;
	        self.statuses = Config.$config.ticket.statuses;
	        self.statusMap = _lodash2.default.fromPairs(self.statuses);
	    }
	
	    _createClass(C, [{
	        key: 'getName',
	        value: function getName() {
	            var self = this;
	            return self.statusMap[self.ngModel];
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            delete this.statuses;
	            delete this.statusMap;
	            this.$element.remove();
	            this.$element = null;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 668 */
591,
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.blink"
	}), _dec2 = (0, _decorators.Directive)('blink', ["$timeout", "$animate", function ($timeout, $animate) {
	    "ngInject";
	
	    return {
	        link: function link(scope, element, attrs) {
	            var model = attrs.ngModel;
	            element.addClass('blink');
	            var watcher = scope.$watch(model, function (newV, oldV) {
	                var x = element;
	                if (_lodash2.default.isUndefined(newV) || newV === oldV) {
	                    return;
	                }
	                if (document.activeElement == element[0]) {
	                    return;
	                }
	                $animate.addClass(element, 'blink-active');
	                $timeout(function () {
	                    $animate.removeClass(element, 'blink-active');
	                }, 500);
	            });
	
	            scope.$on('$destroy', function () {
	                watcher();
	                watcher = null;
	            });
	        }
	    };
	}]), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _companyId = __webpack_require__(594);
	
	var _companyId2 = _interopRequireDefault(_companyId);
	
	var _product = __webpack_require__(596);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _secure = __webpack_require__(633);
	
	var _secure2 = _interopRequireDefault(_secure);
	
	var _ctrls = __webpack_require__(544);
	
	var _component = __webpack_require__(621);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _constants = __webpack_require__(662);
	
	var _modalList = __webpack_require__(545);
	
	var _modalList2 = _interopRequireDefault(_modalList);
	
	var _list = __webpack_require__(671);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.tickets.components.list",
	    modules: [_companyId2.default, _product2.default, _secure2.default, _component2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'ticket-list',
	    bindings: {
	        customer: '=?',
	        extraFields: '<'
	    },
	    template: _list2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope", "$state", "$element", "$growl", "$stateParams", "$timeout", "R", "Modal", "SecureUrlService", "TicketStore", "NgTableParams"];
	    function C($scope, $state, $element, $growl, $stateParams, $timeout, R, Modal, SecureUrlService, TicketStore, NgTableParams) {
	        "ngInject";
	
	        var _this = this;
	
	        _classCallCheck(this, C);
	
	        var self = this;
	        self.stateFilters = _constants.stateFilters;
	
	        self.$scope = $scope;
	        self.$growl = $growl;
	        self.$element = $element;
	        self.$stateParams = $stateParams;
	        self.$state = $state;
	        self.$timeout = $timeout;
	        self.secureUrlService = SecureUrlService;
	        self.Modal = Modal;
	        self.R = R;
	        self.defaultParams = {
	            search: '',
	            status: 'open',
	            created_at__range: '',
	            ordering: ['-created_at'],
	            page_size: 20,
	            contains_product: null
	        };
	        self.selectedObjects = [];
	        if (self.customer) {
	            self.defaultParams.customer = self.customer.id;
	        }
	
	        this.resetParams();
	        this.applyQSParams();
	        this.table = new _table2.default(NgTableParams, TicketStore, {
	            defaultParams: this.defaultParams,
	            params: this.params,
	            onChange: function onChange(params) {
	                return _this.onChange(params);
	            }
	        });
	        this.watcher = null;
	    }
	
	    _createClass(C, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var self = this;
	
	            self.canPrint = true;
	            self.companies = {};
	
	            self.watcher = self.$scope.$watch(function () {
	                return self.table.checked;
	            }, function () {
	                var tickets = self.table.store.list;
	                var checked = self.table.checked;
	
	                self.companies = {};
	                self.selectedObjects = self.table.getSelectedObjects();
	                _lodash2.default.each(_lodash2.default.range(0, _lodash2.default.keys(checked).length), function (index) {
	                    var ticket = tickets[index];
	                    if (ticket && checked[ticket.id]) {
	                        self.companies[ticket.company.id] = true;
	                    }
	                });
	                self.canPrint = _lodash2.default.keys(self.companies).length <= 1; // As we need to select printer for company
	                self.table.updateAllChecked();
	            }, true);
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            if (this.watcher) {
	                this.watcher();
	            }
	            this.table.onDestroy();
	            delete this.table;
	            this.$element.remove();
	            this.$element = null;
	        }
	    }, {
	        key: 'printChemicals',
	        value: function printChemicals() {
	            var preview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	            var self = this;
	            var selectedTicket = self.table.getSelected();
	
	            if (preview) {
	                self.secureUrlService.openInNewWindow(self.R.all('chemicals'), { id: selectedTicket });
	            } else {
	                self.print(selectedTicket);
	            }
	        }
	    }, {
	        key: 'print',
	        value: function print(object) {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _modalList2.default,
	                controller: _ctrls.PrinterListModalCtrl,
	                size: 'large',
	                resolve: {
	                    company: function company() {
	                        return _lodash2.default.first(_lodash2.default.keys(self.companies));
	                    },
	                    request: function request() {
	                        return {
	                            endpoint: self.R.all('chemicals').all('print'),
	                            params: { id: object },
	                            multiple: false
	                        };
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.success('Added file to queue');
	            });
	        }
	    }, {
	        key: 'applyQSParams',
	        value: function applyQSParams() {
	            var params = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Object.keys(this.$stateParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var k = _step.value;
	
	                    var v = this.$stateParams[k];
	                    if (!_lodash2.default.isUndefined(v)) {
	                        params[k] = v;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            params.company = parseInt(params.company) || undefined;
	            params.contains_product = parseInt(params.contains_product) || null;
	            delete params.customerId;
	            _lodash2.default.extend(this.params, params);
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(params_) {
	            // clear current params:
	            var params = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.entries(this.$state.$current.params)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _step2$value = _slicedToArray(_step2.value, 2),
	                        k = _step2$value[0],
	                        v = _step2$value[1];
	
	                    if (v.location === 'search') {
	                        params[k] = undefined;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            params = _lodash2.default.extend(params, params_);
	            params.page = parseInt(params.page) || undefined;
	
	            this.$state.go('.', params, { notify: false });
	        }
	    }, {
	        key: 'resetParams',
	        value: function resetParams() {
	            this.params = _lodash2.default.clone(this.defaultParams);
	            this.selectedContainsProduct = null;
	            this.searchMode = 'ticket';
	            this.searchModeLabel = 'Ticket';
	        }
	    }, {
	        key: 'setSearchMode',
	        value: function setSearchMode(mode) {
	            var _this2 = this;
	
	            var labels = { ticket: 'Ticket', product: 'Product' };
	            this.searchMode = mode;
	            this.searchModeLabel = labels[mode];
	            if (mode === 'ticket') {
	                this.selectedContainsProduct = null;
	                this.params.contains_product = null;
	                this.$timeout(function () {
	                    var input = _this2.$element[0].querySelector('.ticket-search-input-wrapper input[type="text"]');
	                    if (input) input.focus();
	                });
	            } else {
	                this.params.search = '';
	                this.$timeout(function () {
	                    var toggle = _this2.$element[0].querySelector('.ticket-list-page-product-picker .ui-select-toggle');
	                    if (toggle) toggle.click();
	                });
	            }
	            this.refresh();
	        }
	    }, {
	        key: 'onContainsProductChange',
	        value: function onContainsProductChange() {
	            this.params.contains_product = this.selectedContainsProduct ? this.selectedContainsProduct.id : null;
	            this.refresh();
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default ticket-list-page\">\n    <script type=\"text/ng-template\" id=\"headerCheckbox.html\">\n        <input type=\"checkbox\"\n               ng-checked=\"$ctrl.table.allChecked\"\n               ng-click=\"$ctrl.table.allCheckedToggle()\"\n               uib-tooltip=\"{{ $ctrl.table.allChecked ? 'Unselect' : 'Select' }} all rows\">\n    </script>\n    <div class=\"panel-heading\">\n        <div class=\"table-list-filters\" ng-show=\"$ctrl.table.getSelected().length === 0\">\n            <div class=\"search-query\">\n                <div class=\"row\">\n                    <div class=\"col-sm-4\">\n                        <div class=\"input-group\">\n                            <div class=\"ticket-search-input-wrapper\">\n                                <input type=\"text\"\n                                       ng-show=\"$ctrl.searchMode === 'ticket'\"\n                                       class=\"form-control\"\n                                       placeholder=\"Search Tickets\"\n                                       ng-keyup=\"$event.keyCode == 13 && $ctrl.refresh()\"\n                                       ng-model=\"$ctrl.params.search\"\n                                       autofocus>\n                                <blnd-product-picker\n                                    ng-show=\"$ctrl.searchMode === 'product'\"\n                                    mode=\"edit\"\n                                    ng-model=\"$ctrl.selectedContainsProduct\"\n                                    placeholder=\"Search by product\"\n                                    on-change=\"$ctrl.onContainsProductChange()\"\n                                    extended-class-style-name=\"ticket-list-page-product-picker\"\n                                    is-active=\"\"\n                                ></blnd-product-picker>\n                            </div>\n                            <div class=\"input-group-btn\" uib-dropdown>\n                                <button type=\"button\" class=\"btn btn-default dropdown-toggle\" uib-dropdown-toggle>\n                                    <span ng-bind=\"$ctrl.searchModeLabel\"></span> <span class=\"caret\"></span>\n                                </button>\n                                <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\n                                    <li ng-class=\"{active: $ctrl.searchMode === 'ticket'}\">\n                                        <a href ng-click=\"$ctrl.setSearchMode('ticket')\">Ticket</a>\n                                    </li>\n                                    <li ng-class=\"{active: $ctrl.searchMode === 'product'}\">\n                                        <a href ng-click=\"$ctrl.setSearchMode('product')\">Product</a>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-md-2 filter-by-company\">\n                        <blnd-company-id-picker\n                                ng-model=\"$ctrl.params.company\"\n                                test-id=\"ticket-filter-company-picker\"\n                                ng-change=\"$ctrl.refresh()\">\n                        </blnd-company-id-picker>\n                    </div>\n                    <div class=\"col-sm-3\">\n                        <blnd-date-range-picker\n                                ng-model=\"$ctrl.params.created_at__range\"\n                                data-testid=\"ticket-created-at-range-picker\"\n                                ng-change=\"$ctrl.refresh()\"\n                                format=\"string\">\n                        </blnd-date-range-picker>\n                    </div>\n                    <div class=\"col-sm-2\">\n                        <select class=\"form-control\"\n                                ng-options=\"key as value for (key, value) in $ctrl.stateFilters\"\n                                data-testid=\"ticket-status-filter\"\n                                ng-change=\"$ctrl.refresh()\"\n                                ng-model=\"$ctrl.params.status\">\n                        </select>\n                    </div>\n                    <div class=\"col-sm-1\">\n                        <button type=\"button\" class=\"btn btn-default pull-right\"\n                                data-testid=\"ticket-clear-button\"\n                                ng-click=\"$ctrl.resetParams(); $ctrl.refresh()\">\n                            Clear\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"table-list-actions\" ng-show=\"$ctrl.table.getSelected().length !== 0\">\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <div class=\"action pull-right\"\n                         permission\n                         permission-only=\"'main.can_print_chemical_list'\">\n                        <div class=\"btn-group\" uib-dropdown>\n                            <button class=\"btn btn-default\"\n                                    type=\"button\"\n                                    uib-dropdown-toggle\n                                    ng-disabled=\"!$ctrl.canPrint\">\n                                Chemical List <span class=\"caret\"></span>\n                            </button>\n                            <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n                                <li role=\"menuitem\"><a href=\"#\" ng-click=\"$ctrl.printChemicals(true)\">Preview</a></li>\n                                <li role=\"menuitem\"><a href=\"#\" ng-click=\"$ctrl.printChemicals(false)\">Print</a></li>\n                            </ul>\n                        </div>\n                        <span class=\"text-danger\" ng-if=\"!$ctrl.canPrint\">\n                            <i class=\"fa fa-exclamation-triangle print-error\"\n                               tooltip-placement=\"auto\"\n                               uib-tooltip=\"Please select tickets for one company\"\n                               aria-hidden=\"true\"></i>\n                        </span>\n                    </div>\n                    <div class=\"action pull-right\">\n                        <blnd-status-button ng-model=\"$ctrl.selectedObjects\"\n                                            type=\"ticket\"\n                                            multiple=\"true\"\n                                            table=\"$ctrl.table\">\n                        </blnd-status-button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div loading-container=\"$ctrl.table.params.settings().$loading\">\n        <table ng-table=\"$ctrl.table.params\" class=\"table table-fixed table-striped tickets-table\">\n            <tr ng-repeat=\"ticket in $data\">\n                <td header=\"'headerCheckbox.html'\" class=\"col-checkbox\">\n                    <input type=\"checkbox\"\n                           ng-model=\"$ctrl.table.checked[ticket.id]\"\n                           ng-click=\"$ctrl.table.updateAllChecked()\">\n                </td>\n                <td class=\"col-id\" data-title=\"'ID'\" sortable=\"'ticketnumber'\">\n                    <a ui-sref=\"r.in.top.tickets.detail({ticketId: ticket.id})\" ng-bind=\"ticket.ticketnumber\"></a>\n                </td>\n                <td\n                    data-title=\"'Customer'\"\n                    ng-if=\"$ctrl.extraFields.includes('customer')\"\n                    sortable=\"'customer'\">\n                    <span ng-bind=\"ticket.customer.title\"></span>\n                    <i class=\"fa fa-truck\" style=\"color: #149818;\" aria-hidden=\"true\" ng-show=\"$ctrl.table.isInProgressCorrect(ticket.id)\"></i>\n                    <i class=\"fa fa-truck\" style=\"color: #D61E1A\" aria-hidden=\"true\" ng-show=\"$ctrl.table.isInProgressTooLong(ticket.id)\"></i>\n                </td>\n                <td data-title=\"'Ship To'\" ng-if=\"$ctrl.extraFields.includes('fields')\">\n                    <blnd-ship-to ng-model=\"ticket.fields\" mode=\"view\" customer=\"ticket.customer\"></blnd-ship-to>\n                </td>\n                <td class=\"col-company\"\n                    data-title=\"'Company'\"\n                    sortable=\"'company'\">\n                    <blnd-company-picker ng-model=\"ticket.company\"></blnd-company-picker>\n                </td>\n                <td class=\"col-crop\"\n                    ng-bind=\"ticket.crop.name\"\n                    data-title=\"'Crop'\"\n                    sortable=\"'crop'\"></td>\n                <td class=\"\"\n                    ng-bind=\"ticket.acres\"\n                    sortable=\"'acres'\"\n                    data-title=\"'Acres'\"\n                ></td>\n                <td class=\"\"\n                    ng-bind=\"ticket.rate\"\n                    data-title=\"'Rate'\"\n                ></td>\n                <td class=\"col-analysis\"\n                    ng-bind=\"ticket.analysis\"\n                    sortable=\"'analysis'\"\n                    data-title=\"'Analysis'\"\n                ></td>\n                <td class=\"col-date\"\n                    ng-bind=\"ticket.created_at | blndDate\"\n                    sortable=\"'created_at'\"\n                    data-title=\"'Created'\"\n                ></td>\n                <td class=\"\"\n                    ng-bind=\"ticket.applicators[0].applicator.name\"\n                    sortable=\"'applicator'\"\n                    data-title=\"'Applicator'\">\n                </td>\n                <td class=\"col-status\"\n                    data-title=\"'Status'\"\n                    sortable=\"'status'\">\n                    <blnd-ticket-status ng-model=\"ticket.status\" mode=\"view\"></blnd-ticket-status>\n                </td>\n            </tr>\n        </table>\n        <no-data params=\"$ctrl.table.params\">No tickets</no-data>\n    </div>\n</div>\n"

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _company = __webpack_require__(514);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _tankPicker = __webpack_require__(673);
	
	var _tankPicker2 = _interopRequireDefault(_tankPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.compontents.tank",
	    modules: [_resource2.default, _company2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-tank-picker',
	    template: _tankPicker2.default,
	    bindings: {
	        ngModel: '=',
	        mode: '@?',
	        type: '@?',
	        company: '<'
	    }
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["CompanyStore", "$element"];
	    _inherits(C, _BasePicker);
	
	    function C(CompanyStore, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.mode = _this.mode || 'view';
	        _this.type = _this.type || 'fert_tanks';
	
	        _this.list = [];
	        _this.loaded = false;
	        _this.CompanyStore = CompanyStore;
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: 'refresh',
	        value: function refresh() {
	            if (!this.enabled || this.loaded) {
	                return;
	            }
	            this.loaded = true;
	            var self = this;
	            return this.CompanyStore.get(self.company.id).then(function (response) {
	                self.list = _lodash2.default.map(response[self.type], function (o) {
	                    return o.key;
	                });
	                return self;
	            });
	        }
	    }, {
	        key: 'onKeyDown',
	        value: function onKeyDown() {
	            this.enabled = true;
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            delete this.list;
	            _get(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), '$onDestroy', this).call(this);
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode === 'edit'\">\n    <ui-select prevent-animations ng-model=\"$ctrl.ngModel\" allow-remove theme=\"bootstrap\" class=\"form-group-sm\" ng-click=\"$ctrl.onClick()\" ng-keydown=\"$ctrl.onKeyDown()\">\n        <ui-select-match prevent-animations placeholder=\"\">{{ $select.selected.name || $select.selected }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"tank in $ctrl.list | filter: $select.search\"\n                refresh=\"$ctrl.refresh($select.search, $select)\"\n                refresh-delay=\"100\"\n                prevent-animations>\n            <div ng-bind=\"tank\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n<span ng-bind=\"$ctrl.ngModel\" ng-if=\"$ctrl.mode === 'view'\"></span>\n"

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _list = __webpack_require__(675);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _ticket = __webpack_require__(650);
	
	var _ticket2 = _interopRequireDefault(_ticket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.tickets.components.priority-list",
	    modules: [_ticket2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'ticket-priority-list',
	    template: _list2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["TicketStore", "$element"];
	    function C(TicketStore, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$element = $element;
	        this.store = TicketStore;
	        this.store.init();
	        delete this.store.params.date;
	        this.store.params.ordering = ['sort_order'];
	        this.store.params.status = 'pending';
	        this.store.params.field = ['id', 'ticketnumber', 'customer', 'fields', 'crop', 'created_at', 'applicators', 'haulers', 'analysis'];
	        this.store.refresh();
	        this.saving = false;
	    }
	
	    _createClass(C, [{
	        key: 'onMoved',
	        value: function onMoved($index) {
	            var self = this;
	            self.store.list.splice($index, 1);
	        }
	    }, {
	        key: 'onDrop',
	        value: function onDrop(event, index, item, external, type) {
	            var self = this;
	            item = self.store.restangularize(item);
	            var data = {
	                after: this.store.list[index - 1],
	                before: this.store.list[index]
	            };
	            self.saving = true;
	            item.customPUT(data, 'sort_order').then(function (i) {
	                return item.sort_order = i.sort_order;
	            }).finally(function () {
	                return self.saving = false;
	            });
	            return item;
	        }
	    }, {
	        key: 'loadMore',
	        value: function loadMore() {
	            this.store.loadMore();
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.store = null;
	            this.$element.remove();
	            this.$element = null;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default order-sorted-list\">\n    <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Schedule Tickets</h3>\n    </div>\n    <div loading-container=\"$ctrl.store.loading\">\n        <table class=\"table table-fixed table-sortable orders-table\">\n            <thead>\n            <tr>\n                <th></th>\n                <th>ID</th>\n                <th>Customer</th>\n                <th>Ship To</th>\n                <th>Crop</th>\n                <th>Analysis</th>\n                <th>Created</th>\n                <th>Applicators</th>\n            </tr>\n            </thead>\n            <tbody dnd-list=\"$ctrl.store.list\"\n                   dnd-drop=\"$ctrl.onDrop(event, index, item, external, type)\"\n                   infinite-scroll=\"$ctrl.loadMore()\"\n                   infinite-scroll-disabled=\"$ctrl.store.loading || $ctrl.store.isEmpty\"\n                   infinite-scroll-immediate-check=\"true\"\n                   loading-container=\"$ctrl.store.loading\"\n            >\n                <tr ng-repeat=\"order in $ctrl.store.list\"\n                    dnd-draggable=\"order\"\n                    dnd-moved=\"$ctrl.onMoved($index)\"\n                    dnd-effect-allowed=\"move\"\n                >\n                    <td class=\"col-checkbox\" dnd-handle>:::</td>\n                    <td dnd-nodrag\n                        class=\"col-id\"\n                        data-title=\"'ID'\"\n                        sortable=\"'order_id'\" >\n                        <a ui-sref=\"r.in.top.tickets.detail({ticketId: order.id})\" ng-bind=\"order.ticketnumber\"></a>\n                    </td>\n                    <td dnd-nodrag>\n                        <span ng-bind=\"order.customer.title\"></span>\n                    </td>\n                    <td dnd-nodrag=\"\">\n                        <blnd-ship-to ng-model=\"order.fields\" mode=\"view\" customer=\"order.customer\"></blnd-ship-to>\n                    </td>\n                    <td dnd-nodrag\n                        class=\"col-crop\"\n                        ng-bind=\"order.crop.name || '-'\"></td>\n                    <td dnd-nodrag\n                        ng-bind=\"order.analysis || '-'\"></td>\n                    <td dnd-nodrag\n                        class=\"col-date\"\n                        ng-bind=\"order.created_at | blndDate\"></td>\n                    <td dnd-nodrag\n                        ng-bind=\"order.applicators.length > 1 ? order.applicators[0].applicator.name+' ...' : order.applicators[0].applicator.name\"></td>\n                    <!-- dnd-nodrag has to be applied on all td elements :/ -->\n                </tr>\n                <tr class=\"dndPlaceholder\">\n                    <td colspan=\"7\">Drop here ...</td>\n                </tr>\n            </tbody>\n        </table>\n        <no-data =\"$ctrl.store.list.length === 0 && $ctrl.store.isEmpty\">No ready orders</no-data>\n    </div>\n</div>\n<div style=\"text-align: center; padding-bottom: 20px\" ng-show=\"$ctrl.store.loading\">\n    <span class=\"text-muted\">Loading... <i class=\"fa fa-spin fa-spinner\"></i></span>\n</div>\n"

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _salesCodePicker = __webpack_require__(677);
	
	var _salesCodePicker2 = _interopRequireDefault(_salesCodePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.sales.code.picker"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-sales-code-picker',
	    bindings: {
	        ngModel: '=',
	        ngDisabled: '=',
	        mode: '@?'
	    },
	    template: _salesCodePicker2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope", "Config"];
	    function C($scope, Config) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.scope = $scope;
	        this.mode = this.mode || 'view';
	        this.salesCodes = Config.$config.sales_codes;
	    }
	
	    _createClass(C, [{
	        key: 'getName',
	        value: function getName() {
	            return _lodash2.default.toUpper(this.ngModel);
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports = "<span ng-bind=\"$ctrl.getName()\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control\"\n        ng-class=\"$ctrl.inputClass\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-options=\"opt[0] as opt[0]|uppercase for opt in $ctrl.salesCodes\"\n        ng-if=\"$ctrl.mode === 'edit'\">\n   <option value=\"\">Choose code ...</option>\n</select>\n"

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _modals = __webpack_require__(532);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _analysis_warning = __webpack_require__(679);
	
	var _analysis_warning2 = _interopRequireDefault(_analysis_warning);
	
	var _analysisTable = __webpack_require__(680);
	
	var _analysisTable2 = _interopRequireDefault(_analysisTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ActualAnalysisModal = function () {
	    ActualAnalysisModal.$inject = ["$uibModalInstance", "ngModel"];
	    function ActualAnalysisModal($uibModalInstance, ngModel) {
	        "ngInject";
	
	        _classCallCheck(this, ActualAnalysisModal);
	
	        this.modal = $uibModalInstance;
	        this.data = ngModel;
	    }
	
	    _createClass(ActualAnalysisModal, [{
	        key: 'close',
	        value: function close() {
	            this.modal.close();
	        }
	    }]);
	
	    return ActualAnalysisModal;
	}();
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.analysis.warning",
	    modules: [_modals2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-analysis-warning',
	    bindings: {
	        ngModel: '='
	    },
	    template: _analysis_warning2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["Modal"];
	    function C(Modal) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.Modal = Modal;
	    }
	
	    _createClass(C, [{
	        key: 'openModal',
	        value: function openModal() {
	            var _this = this;
	
	            this.Modal.open({
	                template: _analysisTable2.default,
	                controller: ActualAnalysisModal,
	                size: 'small',
	                resolve: {
	                    ngModel: function ngModel() {
	                        return _this.ngModel;
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'hasValue',
	        get: function get() {
	            return _lodash2.default.has(this.ngModel, 'is_analysis_valid');
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	module.exports = "<button class=\"btn btn-link warning-button\"\n        type=\"button\"\n        ng-if=\"$ctrl.hasValue && !$ctrl.ngModel.is_analysis_valid\"\n        ng-click=\"$ctrl.openModal()\">\n    <span class=\"analysis-warning-icon\" aria-hidden=\"true\"></span>\n</button>\n"

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <h3 class=\"modal-title\">Actual Analysis</h3>\n</div>\n<div class=\"modal-body\">\n    <table class=\"table\">\n        <thead>\n            <th ng-repeat=\"n in vm.data.analysis\" ng-bind=\"n[0]\"></th>\n        </thead>\n        <tbody>\n            <tr>\n                <td ng-repeat=\"n in vm.data.analysis\" ng-bind=\"n[1]\"></td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">OK</button>\n</div>\n"

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _product_codePicker = __webpack_require__(682);
	
	var _product_codePicker2 = _interopRequireDefault(_product_codePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.product_code.picker"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-product-code-picker',
	    bindings: {
	        ngModel: '=',
	        ngDisabled: '=',
	        mode: '@?'
	    },
	    template: _product_codePicker2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope", "Config"];
	    function C($scope, Config) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.scope = $scope;
	        this.mode = this.mode || 'view';
	        this.productCodes = Config.$config.product_codes;
	    }
	
	    _createClass(C, [{
	        key: 'getName',
	        value: function getName() {
	            return _lodash2.default.toUpper(this.ngModel);
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = "<span ng-bind=\"$ctrl.getName()\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control input-sm\"\n        ng-class=\"$ctrl.inputClass\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-options=\"opt[0] as opt[0] for opt in $ctrl.productCodes\"\n        ng-if=\"$ctrl.mode === 'edit'\">\n</select>\n"

/***/ }),
/* 683 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ticket-list-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"flip-container\">\n                <div class=\"page flip\" ui-view></div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"create-button\" class=\"bottom-right-icon-button\" permission permission-only=\"'main.add_ticket'\" ng-if=\"vm.showAngularCreateButton\">\n    <div class=\"btn btn-primary btn-fab\"\n        role=\"button\"\n        title=\"Create new ticket\"\n        aria-label=\"Create new ticket\"\n        data-testid=\"ticket-create-button\"\n        ng-click=\"vm.openAddModal()\">\n            <i class=\"btn-icon fa fa-plus\" aria-hidden=\"true\"></i>\n    </div>\n</div>\n"

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ticket-details\">\n    <ul class=\"nav nav-tabs\">\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.tickets.detail.ticket\">Ticket</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.tickets.detail.files\">Files</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.tickets.detail.shipping\">Shipping</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.tickets.detail.notes\">Notes</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.tickets.detail.log\">Log</a></li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.can_send_presets'\">\n            <button type=\"button\" data-testid=\"ticket-send-to-bb-button\" class=\"btn btn-primary\" uib-dropdown-toggle ng-click=\"vmo.sendToBB()\">\n                Send\n            </button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.change_ticket'\">\n            <button type=\"button\" data-testid=\"ticket-preview-button\" class=\"btn btn-primary\" ng-click=\"vmo.shippingTicketUrl()\">\n                Preview\n            </button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.add_ticket'\">\n            <button type=\"button\" data-testid=\"ticket-print-button\" class=\"btn btn-primary\" ng-click=\"vmo.print()\">\n                Print\n            </button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.add_ticket'\">\n            <button type=\"button\" data-testid=\"ticket-copy-button\" class=\"btn btn-primary\" uib-dropdown-toggle ng-click=\"vmo.cloneTicket()\">\n                Copy\n            </button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.change_ticket'\">\n            <button type=\"button\" data-testid=\"ticket-copy-mix-button\" class=\"btn btn-primary\"\n                    ng-click=\"vmo.copyMix()\"\n                    ng-disabled=\"!vmo.canCopyMix\">\n                Copy Mix\n            </button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.change_ticket'\">\n            <blnd-status-button ng-model=\"vmo.ticket\" type=\"ticket\"></blnd-status-button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.change_ticket'\">\n            <button type=\"button\" ng-show=\"vmo.showStopDelivery()\" class=\"btn btn-danger\"\n                    ng-click=\"vmo.confirmStopDeliveryModal()\">\n                Stop Delivery\n            </button>\n        </li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.change_ticket'\">\n            <button type=\"button\" ng-show=\"vmo.showStopApplication()\" class=\"btn btn-danger\"\n                    ng-click=\"vmo.confirmStopApplicationModal()\">\n                Stop Application\n            </button>\n        </li>\n    </ul>\n    <div class=\"blnd-tab-content\" ui-view>\n    </div>\n</div>\n"

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ticket-info-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"top-right-corner\">\n                        <button class=\"btn btn-warning float-left\" style=\"pointer-events: none;\" ng-show=\"vmo.showInDelivery()\">In delivery: {{ vmo.displayDeliveryTime }}</button>\n                        <button class=\"btn btn-warning float-left\" style=\"pointer-events: none;\" ng-show=\"vmo.showInApplication()\">In application: {{ vmo.displayApplicationTime }}</button>\n                        <span class=\"label label-info\" ng-if=\"vm.ticket.is_printed\">Printed</span>\n                        <button class=\"btn btn-edit\" data-testid=\"ticket-edit-button\" ng-click=\"vm.requestOpenEditModal()\" permission permission-only=\"'main.change_ticket'\">Edit</button>\n                    </div>\n                    <section class=\"information\">\n                        <h4>Information</h4>\n                        <div class=\"row\">\n                            <div class=\"col-sm-2\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Ticket #</div>\n                                    <div ng-bind=\"vm.ticket.ticketnumber\" data-testid=\"ticket-number-read\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-5\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Customer</div>\n                                    <div><a ui-sref=\"r.in.top.customers.detail({customerId: vm.ticket.customer.id})\" ng-bind=\"vm.ticket.customer.title\" data-testid=\"customer-read\"></a></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-2\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Order #</div>\n                                    <div ng-show=\"vm.ticket.order.id\">\n                                        <a ui-sref=\"r.in.top.orders.detail({orderId: vm.ticket.order.id})\" ng-bind=\"vm.ticket.order.order_id\" data-testid=\"order-number-read\"></a>\n                                    </div>\n                                    <div ng-show=\"!vm.ticket.order.id\">No Order</div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-2\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Status</div>\n                                    <div><blnd-ticket-status ng-model=\"vm.ticket.status\" mode=\"view\" data-testid=\"ticket-status-read\"></blnd-ticket-status></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Code</div>\n                                    <div>\n                                        <blnd-sales-code-picker ng-model=\"vm.ticket.sales_code\" mode=\"view\" data-testid=\"sales-code-read\"></blnd-sales-code-picker>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-sm-6\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Ship To</div>\n                                    <div ng-bind=\"vm.ticket.ship_to_text || '-'\" data-testid=\"ship-to-read\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-6\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Ship To Fields</div>\n                                    <div>\n                                        <blnd-ship-to ng-model=\"vm.ticket.fields\" customer=\"vm.ticket.customer\" mode=\"view\" data-testid=\"ship-to-fields-read\"></blnd-ship-to>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-sm-3\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Created</div>\n                                    <div>\n                                        <blnd-datepicker ng-model=\"vm.ticket.created_at\" data-testid=\"created-read\"></blnd-datepicker>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-3\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Delivery</div>\n                                    <blnd-delivery-picker ng-model=\"vm.ticket.delivery\" data-testid=\"delivery-read\"></blnd-delivery-picker>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-2\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Crop</div>\n                                    <div ng-bind=\"vm.ticket.crop.title\" data-testid=\"crop-read\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-2\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Company</div>\n                                    <div><blnd-company-picker ng-model=\"vm.ticket.company\" test-id=\"company-read\"></blnd-company-picker></div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-sm-3\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Applicators</div>\n                                        <blnd-applicator-picker ng-model=\"vm.ticket.applicators\" company=\"vm.ticket.company\" fieldname=\"applicator\" mode=\"view\" data-testid=\"applicators-read\"></blnd-applicator-picker>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-3\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Haulers</div>\n                                        <blnd-applicator-picker ng-model=\"vm.ticket.haulers\" company=\"vm.ticket.company\" fieldname=\"hauler\" mode=\"view\" data-testid=\"haulers-read\"></blnd-applicator-picker>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Zone</div>\n                                    <div data-testid=\"zone-read\">{{ vm.ticket.freight_zone }}</div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Truck #</div>\n                                    <div ng-bind=\"vm.ticket.truck_number\" data-testid=\"truck-number-read\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Tank #</div>\n                                    <div ng-bind=\"vm.ticket.truck_tank\" data-testid=\"tank-number-read\"></div>\n                                </div>\n                            </div>\n                        </div>\n                    </section>\n\n                    <section class=\"mix\">\n                        <h4>Mix</h4>\n                        <div class=\"row\">\n                            <div class=\"col-sm-1-mix\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Acres</div>\n                                    <div ng-bind=\"vm.ticket.acres\" data-testid=\"acres-read\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Rate</div>\n                                    <div ng-bind=\"vm.ticket.rate\" data-testid=\"rate-read\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Quantity</div>\n                                    <div>\n                                        <span ng-bind=\"vm.ticket.quantity\" data-testid=\"quantity-read\"></span>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Product Code</div>\n                                    <div>\n                                        <blnd-product-code-picker ng-model=\"vm.ticket.product_code\" model=\"read\" data-testid=\"product-code-read\"></blnd-product-code-picker>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\">\n                                <div class=\"blnd-data-field\">\n                                    <div>F Batch</div>\n                                    <div ng-bind=\"vm.ticket.fert_batches\" data-testid=\"f-batch-read\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\">\n                                <div class=\"blnd-data-field\">\n                                    <div>C Batch</div>\n                                    <div ng-bind=\"vm.ticket.chem_batches\" data-testid=\"c-batch-read\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Loadout</div>\n                                    <div>\n                                        <blnd-tank-picker ng-model=\"vm.ticket.fert_tank\" data-testid=\"loadout-read\"></blnd-tank-picker>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\"  ng-if=\"vm.company.chem_tanks.length !== 0\">\n                                <div class=\"blnd-data-field\">\n                                    <div>C Tank</div>\n                                    <div>\n                                        <blnd-tank-picker ng-model=\"vm.ticket.chem_tank\" data-testid=\"c-tank-read\"></blnd-tank-picker>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\">\n                            </div>\n                            <div class=\"col-sm-1-mix\" ng-if=\"vm.ticket.quantity_units === 'GALS'\">\n                                <div class=\"blnd-data-field\" >\n                                    <div>LB/G</div>\n                                    <div>\n                                        <div ng-bind=\"vm.ticket.lbs_gal\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\" ng-if=\"vm.ticket.quantity_units === 'GALS'\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Load Total</div>\n                                    <div>\n                                        <div ng-bind=\"vm.ticket.gals\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-sm-1-mix\" ng-repeat=\"f in vm.fieldConf.fields.top\" ng-if=\"vm.fieldConf.values.top[f].pc.name\">\n                                <div class=\"blnd-data-field\">\n                                    <div class=\"ellipsis\" ng-bind=\"vm.fieldConf.values.top[f].pc.name\"></div>\n                                    <div ng-bind=\"vm.fieldConf.values.top[f].percent\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\" ng-if=\"vm.company.allow_reduce_water\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Reduce</div>\n                                    <div ng-bind=\"vm.ticket.reduce_water\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\" ng-if=\"vm.company.custom_delay !== null\">\n                                <div class=\"blnd-data-field\">\n                                    <div>Delay</div>\n                                    <div ng-bind=\"vm.ticket.delay || 0\"></div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"row\">\n                            <div class=\"col-sm-1-mix\" ng-repeat=\"f in vm.fieldConf.fields.bottom\" ng-if=\"vm.fieldConf.values.bottom[f].pc.name\">\n                                <div class=\"blnd-data-field\">\n                                    <div ng-bind=\"vm.fieldConf.values.bottom[f].pc.name\"></div>\n                                    <div ng-bind=\"vm.fieldConf.values.bottom[f].percent\"></div>\n                                </div>\n                            </div>\n                            <div class=\"col-sm-1-mix\">\n                                <blnd-analysis-warning ng-model=\"vm.ticket.formulation\"></blnd-analysis-warning>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-md-6 rounded-table table-left\">\n                                <blnd-products ng-model=\"vm.ticket.products\" mode=\"view\"></blnd-products>\n                            </div>\n                            <div class=\"col-md-6 rounded-table table-right\">\n                                <blnd-formula ticket=\"vm.ticket\"></blnd-formula>\n                                <div class=\"alert alert-danger\" ng-repeat=\"error in vm.ticket.formulation.errors\" ng-bind=\"error\"></div>\n                            </div>\n                        </div>\n                    </section>\n\n                    <section>\n                        <h4 >Location </h4>\n                        <h5 ng-repeat=\"location in vm.varLocations\">{{ location.full_string }}</h5>\n                        <!-- Google Maps -->\n                        <div id=\"map\" style=\"height: 400px;\" class=\"w-100\"></div>\n                    </section>\n\n                    <section ng-if=\"vm.ticket.notes\">\n                        <h4>Notes</h4>\n                        <div class=\"notes-container\">\n                            <pre ng-bind=\"vm.ticket.notes\"></pre>\n                        </div>\n                    </section>\n\n                    <section ng-if=\"vm.ticket.split_with\">\n                        <h4>Split</h4>\n                            <div class=\"row\">\n                                <div class=\"blnd-data-field\">\n                                    <blnd-customer-card ng-model=\"vm.ticket.split_with\"></blnd-customer-card>\n                                </div>\n                            </div>\n                        </div>\n                    </section>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 686 */
/***/ (function(module, exports) {

	module.exports = " <blnd-activity object=\"vmo.ticket\"></blnd-activity>\n"

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"actions\">\n    <a class=\"btn btn-default\"\n       ng-if=\"$state.includes('r.in.top.tickets.list.priority') || $state.includes('r.in.top.tickets.map')\"\n       ui-sref=\"r.in.top.tickets.list.main\">Open Tickets</a>\n   <a class=\"btn btn-default\"\n      ng-if=\"$state.includes('r.in.top.tickets.list.main')\"\n      ui-sref=\"r.in.top.tickets.map\"\n      data-testid=\"ticket-map-button\">Ticket Map</a>\n    <a class=\"btn btn-default\"\n       ng-if=\"$state.includes('r.in.top.tickets.list.main')\"\n       ui-sref=\"r.in.top.tickets.list.priority\"\n       permission permission-sref=\"'r.in.top.tickets.list.priority'\">Schedule Tickets</a></li>\n</div>\n"

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ticket-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-upload-section ng-model=\"vm.ticket\" type=\"ticket\"></blnd-upload-section>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ticket-info-page\">\n    <form ng-submit=\"vm.submit()\" novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"panel panel-default blnd-panel\">\n                    <div class=\"panel-body\">\n                        <section class=\"information\">\n                            <h4>Information (entered via the IOS application)</h4>\n                            <div class=\"row\">\n                                <div class=\"col-md-5\">\n                                    <div class=\"row\">\n                                        <div class=\"col-sm-4\">\n                                            <div class=\"form-group form-group-sm\">\n                                                <label class=\"control-label\">Gal/Acre</label>\n                                                <input disabled type=\"text\" class=\"form-control\" ng-model=\"vm.data.applicators_notes.gal_acre\" form-error select-on-click/>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-sm-4\">\n                                            <div class=\"form-group form-group-sm\">\n                                                <label class=\"control-label\">Dial Valve/Gear</label>\n                                                <input disabled type=\"text\" class=\"form-control\" ng-model=\"vm.data.applicators_notes.dial_valve_gear\" form-error select-on-click/>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-sm-4\">\n                                            <div class=\"form-group form-group-sm\">\n                                                <label class=\"control-label\">Speed/Pressure</label>\n                                                <input disabled type=\"text\" class=\"form-control\" ng-model=\"vm.data.applicators_notes.speed_pressure\" form-error select-on-click/>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"row\">\n                                        <div class=\"col-sm-3\">\n                                            <div class=\"form-group form-group-sm\">\n                                                <label class=\"control-label\">Nozzle Size</label>\n                                                <ui-select ng-disabled=\"true\" ng-model=\"vm.data.applicators_notes.nozzle_size\" prevent-animations allow-remove theme=\"bootstrap\">\n                                                    <ui-select-match prevent-animations>{{ $select.selected }}</ui-select-match>\n                                                    <ui-select-choices\n                                                            repeat=\"size in vm.nozzle_sizes\"\n                                                            prevent-animations>\n                                                        <div ng-bind=\"size\"></div>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-sm-3\">\n                                            <div class=\"form-group form-group-sm\">\n                                                <label class=\"control-label\">Direction</label>\n                                                <ui-select ng-disabled=\"true\" ng-model=\"vm.data.applicators_notes.direction\" prevent-animations allow-remove theme=\"bootstrap\">\n                                                    <ui-select-match prevent-animations >{{ $select.selected }}</ui-select-match>\n                                                    <ui-select-choices\n                                                            repeat=\"direction in vm.directions\"\n                                                            prevent-animations>\n                                                        <div ng-bind=\"direction\"></div>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-sm-2\">\n                                            <div class=\"form-group form-group-sm\">\n                                                <label class=\"control-label\">Speed</label>\n                                                <ui-select ng-disabled=\"true\" ng-model=\"vm.data.applicators_notes.speed\" prevent-animations allow-remove theme=\"bootstrap\">\n                                                    <ui-select-match prevent-animations >{{ $select.selected }}</ui-select-match>\n                                                    <ui-select-choices\n                                                            repeat=\"speed in vm.speeds\"\n                                                            prevent-animations>\n                                                        <div ng-bind=\"speed\"></div>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-sm-2\">\n                                            <div class=\"form-group form-group-sm\">\n                                                <label class=\"control-label\">Temp</label>\n                                                <ui-select ng-disabled=\"true\" ng-model=\"vm.data.applicators_notes.temp\" prevent-animations allow-remove theme=\"bootstrap\">\n                                                    <ui-select-match prevent-animations >{{ $select.selected }}</ui-select-match>\n                                                    <ui-select-choices\n                                                            repeat=\"temp in vm.temps\"\n                                                            prevent-animations>\n                                                        <div ng-bind=\"temp\"></div>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-sm-2\">\n                                            <div class=\"form-group form-group-sm\">\n                                                <label class=\"control-label\">Wind</label>\n                                                <ui-select ng-disabled=\"true\" ng-model=\"vm.data.applicators_notes.wind\" prevent-animations allow-remove theme=\"bootstrap\">\n                                                    <ui-select-match prevent-animations >{{ $select.selected }}</ui-select-match>\n                                                    <ui-select-choices\n                                                            repeat=\"wind in ['Yes', 'No']\"\n                                                            prevent-animations>\n                                                        <div ng-bind=\"wind\"></div>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-sm-7\">\n                                    <div class=\"form-group form-group-sm\">\n                                        <label class=\"control-label\">Notes</label>\n                                        <textarea disabled rows=\"5\" class=\"form-control\" ng-model=\"vm.data.applicators_notes.notes\" form-error select-on-click/>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\" ng-show=\"vm.data.applicators_signature\">\n                                <div class=\"col-md-6\">\n                                    <div class=\"form-group form-group-sm\">\n                                        <label class=\"control-label\">Applicator's Signature</label>\n                                        <div>\n                                            <img ng-src=\"{{ vm.data.applicators_signature }}\" alt=\"Applicators Signature\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </section>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n"

/***/ }),
/* 690 */
639,
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.fake-scroll"
	}), _dec2 = (0, _decorators.Directive)('html', ["$document", "$uibPosition", function ($document, $uibPosition) {
	    "ngInject";
	
	    return {
	        restrict: 'E',
	        link: function link($scope, $element) {
	            var watcher = $scope.$watch(function () {
	                return $element.find('body')[0].className;
	            }, function (classes) {
	                var elems = [].concat(_toConsumableArray($element.querySelectorAll('[fake-scroll]')));
	                var width = '0';
	                if (classes.includes('modal-open')) {
	                    width = $uibPosition.scrollbarWidth(true) + 'px';
	                }
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = elems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var el = _step.value;
	
	                        el.style.paddingRight = width;
	                        el.style.paddingRight = width;
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            });
	
	            $scope.$on('$destroy', function () {
	                watcher();
	                watcher = null;
	            });
	        }
	    };
	}]), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _modals = __webpack_require__(532);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _config = __webpack_require__(504);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _form = __webpack_require__(693);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _customer = __webpack_require__(551);
	
	var _customer2 = _interopRequireDefault(_customer);
	
	var _list = __webpack_require__(670);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _list3 = __webpack_require__(592);
	
	var _list4 = _interopRequireDefault(_list3);
	
	var _sales_person = __webpack_require__(694);
	
	var _sales_person2 = _interopRequireDefault(_sales_person);
	
	var _sales = __webpack_require__(697);
	
	var _sales2 = _interopRequireDefault(_sales);
	
	var _activity = __webpack_require__(618);
	
	var _activity2 = _interopRequireDefault(_activity);
	
	var _upload = __webpack_require__(613);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	var _blndCustomerDelivery = __webpack_require__(699);
	
	var _blndCustomerDelivery2 = _interopRequireDefault(_blndCustomerDelivery);
	
	var _component = __webpack_require__(700);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _routing3 = __webpack_require__(702);
	
	var _routing4 = _interopRequireDefault(_routing3);
	
	var _ctrls = __webpack_require__(706);
	
	var _list5 = __webpack_require__(709);
	
	var _list6 = _interopRequireDefault(_list5);
	
	var _detail = __webpack_require__(710);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _info = __webpack_require__(711);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _orderList = __webpack_require__(712);
	
	var _orderList2 = _interopRequireDefault(_orderList);
	
	var _ticketList = __webpack_require__(713);
	
	var _ticketList2 = _interopRequireDefault(_ticketList);
	
	var _files = __webpack_require__(714);
	
	var _files2 = _interopRequireDefault(_files);
	
	var _log = __webpack_require__(715);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _notifications = __webpack_require__(716);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function detailController(legacyController) {
	    return ['Config', function (Config) {
	        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL') ? function () {} : legacyController;
	    }];
	}
	
	function detailTemplate(legacyTemplate) {
	    return ['Config', function (Config) {
	        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL') ? '<div style="display:none"></div>' : legacyTemplate;
	    }];
	}
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.customers',
	    modules: [_routing2.default, _customer2.default, _modals2.default, _config2.default, _form2.default, _routing4.default, _list2.default, _list4.default, _sales_person2.default, _sales2.default, _blndCustomerDelivery2.default, _component2.default, _upload2.default, _activity2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.customers',
	    url: '/customers',
	    template: '<div ui-view></div>',
	    abstract: '.list',
	    ncyBreadcrumb: {
	        skip: true
	    },
	    data: {
	        permissions: {
	            only: ['main.view_customer']
	        }
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.customers.list',
	    url: '?search&companies&sales&page&ordering',
	    // The React page owns these query params (it writes them directly and
	    // refetches itself); the legacy fallback also drives them via UI + an
	    // explicit `$state.go('.', ..., {notify: false})`. Neither relies on the
	    // state reloading when they change, so disable it - otherwise Angular
	    // remounts the React island (and reconciles a stale `$location`) on every
	    // paginate/filter, causing flicker and the "click navbar twice" bug.
	    reloadOnSearch: false,
	    // Feature flag managed by the backend controls the React list rollout.
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_CUSTOMERS_LIST');
	        return useReact ? function () {} : _ctrls.ListCtrl;
	    }],
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        var useReact = Config.isFeatureFlagActive('REACT_CUSTOMERS_LIST');
	        return useReact ? '<div react-view="customers-list"></div>' : _list6.default;
	    }],
	    ncyBreadcrumb: {
	        label: 'Customers'
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.customers.detail',
	    url: '/:customerId',
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL') ? ["$customer", "$scope", function ($customer, $scope) {
	            "ngInject";
	
	            var _this = this;
	
	            this.customer = $customer;
	            this.onCustomerUpdated = function (customer) {
	                return $scope.$applyAsync(function () {
	                    _this.customer = customer;
	                });
	            };
	        }] : _ctrls.DetailCtrl;
	    }],
	    as: 'pvm',
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL') ? '<div react-view="customer-detail" props="{customer: pvm.customer, onCustomerUpdated: pvm.onCustomerUpdated}"></div><div ui-view style="display:none"></div>' : _detail2.default;
	    }],
	    resolve: {
	        $customer: function $customer($stateParams, CustomerStore) {
	            return CustomerStore.get($stateParams.customerId);
	        }
	    },
	    ncyBreadcrumb: {
	        label: '{{pvm.customer.title}}',
	        parent: 'r.in.top.customers.list'
	    },
	    abstract: '.info'
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.customers.detail.info',
	    url: '',
	    controllerProvider: detailController(_ctrls.InfoCtrl),
	    templateProvider: detailTemplate(_info2.default),
	    resolve: {},
	    ncyBreadcrumb: {
	        label: 'Info'
	    }
	}), _dec6 = (0, _decorators.State)({
	    name: 'r.in.top.customers.detail.orders',
	    url: '/orders?company&search&created_at__range&status&page',
	    reloadOnSearch: false,
	    controllerProvider: detailController(_ctrls.OrderListCtrl),
	    templateProvider: detailTemplate(_orderList2.default),
	    resolve: {},
	    ncyBreadcrumb: {
	        label: 'Orders'
	    }
	}), _dec7 = (0, _decorators.State)({
	    name: 'r.in.top.customers.detail.tickets',
	    url: '/tickets?company&search&created_at__range&status&page',
	    reloadOnSearch: false,
	    controllerProvider: detailController(_ctrls.TicketListCtrl),
	    templateProvider: detailTemplate(_ticketList2.default),
	    resolve: {},
	    ncyBreadcrumb: {
	        label: 'Tickets'
	    }
	}), _dec8 = (0, _decorators.State)({
	    name: 'r.in.top.customers.detail.files',
	    url: '/files',
	    controllerProvider: detailController(_ctrls.FilesCtrl),
	    templateProvider: detailTemplate(_files2.default),
	    resolve: {},
	    ncyBreadcrumb: {
	        label: 'Files'
	    }
	}), _dec9 = (0, _decorators.State)({
	    name: 'r.in.top.customers.detail.log',
	    url: '/log',
	    controllerProvider: detailController(_ctrls.LogCtrl),
	    templateProvider: detailTemplate(_log2.default),
	    ncyBreadcrumb: {
	        label: 'Log'
	    }
	}), _dec10 = (0, _decorators.State)({
	    name: 'r.in.top.customers.detail.notifications',
	    url: '/notifications',
	    controllerProvider: detailController(_ctrls.CustomerNotificationsCtrl),
	    templateProvider: detailTemplate(_notifications2.default),
	    ncyBreadcrumb: {
	        label: 'Notifications'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = _dec8(_class = _dec9(_class = _dec10(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.formvalidate"
	}), _dec2 = (0, _decorators.Directive)('form-error', ["$uibTooltip", "$timeout", "$compile", function ($uibTooltip, $timeout, $compile) {
	    "ngInject";
	    /*
	    3 ways of specifying where seek for errors:
	    1. corresponding ng-model attr
	    2. corresponding ng-model attr + prefix
	    3. form-errors="vm.errors.field"
	     */
	
	    return {
	        link: function link(scope, element, attrs) {
	            var $el = element[0];
	            var prefix = attrs.prefix || 'errors';
	            var name = attrs.formError;
	            if (!name) {
	                name = attrs.ngModel;
	                if (name) {
	                    name = name.split('.');
	                    name[1] = prefix;
	                    name = name.join('.');
	                }
	            }
	            if (!name) {
	                return;
	            }
	            $el.removeAttribute('form-error');
	            $el.setAttribute('uib-popover', '{{ ' + name + '[0] }}');
	            $el.setAttribute('popover-trigger', "'mouseenter'");
	
	            var watcher = scope.$watch(name, function (value) {
	                var $parent = element[0].parentElement;
	                if (!value || value.length < 0) {
	                    $parent.classList.remove('has-error');
	                } else {
	                    $parent.classList.add('has-error');
	                }
	            });
	
	            $compile(element)(scope);
	
	            scope.$on('$destroy', function () {
	                watcher();
	                watcher = null;
	                element.remove();
	            });
	        }
	    };
	}]), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _sales_person = __webpack_require__(695);
	
	var _sales_person2 = _interopRequireDefault(_sales_person);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _sales_personPicker = __webpack_require__(696);
	
	var _sales_personPicker2 = _interopRequireDefault(_sales_personPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.salesPerson",
	    modules: [_sales_person2.default]
	
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-salesperson-picker',
	    bindings: {
	        ngModel: '=',
	        ngChange: '&',
	        mode: '@?',
	        placeholder: '@?'
	    },
	    template: _sales_personPicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["$scope", "$element", "SalesPersonStore"];
	    _inherits(C, _BasePicker);
	
	    function C($scope, $element, SalesPersonStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.scope = $scope;
	        _this.store = SalesPersonStore;
	        _this.store.init();
	
	        if (_this.mode === 'search') {
	            _this.store.refresh();
	        }
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;
	
	            var self = this;
	            this.scope.$watch(function () {
	                return _this2.ngModel;
	            }, function () {
	                self.onChange();
	            });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            if (this.ngChange) {
	                this.ngChange();
	            }
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.salesPerson',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('SalesPersonStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('users');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode != 'search'\"><!-- Returns object -->\n    <ui-select prevent-animations ng-model=\"$ctrl.ngModel\" theme=\"bootstrap\" ng-click=\"$ctrl.onClick()\" on-select=\"$ctrl.onSelect($item, $model)\">\n        <ui-select-match prevent-animations placeholder=\"{{$ctrl.placeholder}}\">{{ $select.selected.title }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"person in $ctrl.store.list | filter: $select.search\"\n                refresh=\"$ctrl.refresh($select.search, $select)\"\n                refresh-delay=\"100\"\n                prevent-animations>\n            <div ng-bind=\"person.title\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode == 'search'\"><!-- Returns ID -->\n    <ui-select prevent-animations ng-model=\"$ctrl.ngModel\" theme=\"bootstrap\" ng-click=\"$ctrl.onClick()\" on-select=\"$ctrl.onSelect($item, $model)\">\n        <ui-select-match prevent-animations placeholder=\"{{$ctrl.placeholder}}\">{{ $select.selected.title }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"person.id as person in $ctrl.store.list | filter: $select.search\"\n                refresh=\"$ctrl.refresh($select.search, $select)\"\n                refresh-delay=\"100\"\n                prevent-animations>\n            <div ng-bind=\"person.title\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n"

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _salesPicker = __webpack_require__(698);
	
	var _salesPicker2 = _interopRequireDefault(_salesPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.sales.picker",
	    modules: []
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-salespeople',
	    bindings: {
	        ngModel: '=',
	        mode: '@?',
	        multiple: '=?'
	    },
	    template: _salesPicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["UserStore", "$element"];
	    _inherits(C, _BasePicker);
	
	    function C(UserStore, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.mode = _this.mode || 'view';
	        if (_lodash2.default.isUndefined(_this.multiple)) {
	            _this.multiple = true;
	        }
	        _this.store = UserStore;
	        _this.store.init();
	        _this.items = [];
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: 'refresh',
	        value: function refresh(search) {
	            var self = this;
	
	            if (!this.enabled) {
	                return;
	            }
	            this.store.params.search = search;
	            this.store.refresh().then(function (obj) {
	                self.items = _lodash2.default.map(obj.list, function (o) {
	                    return {
	                        id: o.id,
	                        title: o.title
	                    };
	                });
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            delete this.items;
	            _get(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), '$onDestroy', this).call(this);
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode === 'edit' && $ctrl.multiple\">\n    <ui-select multiple\n               ng-model=\"$ctrl.ngModel\"\n               theme=\"bootstrap\"\n               title=\"Choose salesperson\"\n               close-on-select=\"false\"\n               ng-click=\"$ctrl.onClick()\">\n        <ui-select-match placeholder=\"{{ $ctrl.placeholder }}\">{{ $item.title }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"user in $ctrl.items | filter: $select.search\"\n                refresh=\"$ctrl.refresh($select.search)\"\n                refresh-delay=\"100\">\n            <div ng-bind=\"user.title\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n<div class=\"ui-select-wrapper\"  ng-if=\"$ctrl.mode === 'edit' && !$ctrl.multiple\">\n    <ui-select ng-model=\"$ctrl.ngModel\"\n               theme=\"bootstrap\"\n               title=\"Choose salesperson\"\n               ng-click=\"$ctrl.onClick()\">\n        <ui-select-match placeholder=\"{{$ctrl.placeholder}}\">{{ $select.selected.title || $select.selected }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"user in $ctrl.items | filter: $select.search\"\n                refresh=\"$ctrl.refresh($select.search)\"\n                refresh-delay=\"100\">\n            <div ng-bind=\"user.title\"></div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n<div class=\"sales-list\" ng-if=\"$ctrl.mode === 'view' && $ctrl.multiple\">\n    <span ng-repeat=\"user in $ctrl.ngModel\">{{user.title}}{{{true: '', false: ', '}[$last]}}</span>\n</div>\n<div ng-if=\"$ctrl.mode === 'view' && !$ctrl.multiple\">\n    <span>{{$ctrl.ngModel.title || '-' }}</span>\n</div>\n"

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _product = __webpack_require__(597);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _deliveryPicker = __webpack_require__(610);
	
	var _deliveryPicker2 = _interopRequireDefault(_deliveryPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var pl5_customer = ['apply_haul_itemized', 'haul_itemized'];
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.customerDelivery.picker",
	    modules: []
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-customer-delivery-picker',
	    bindings: {
	        ngModel: '=',
	        mode: '@?',
	        priceLevel: '<?'
	    },
	    template: _deliveryPicker2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope", "$element", "Config"];
	    function C($scope, $element, Config) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.scope = $scope;
	        this.$element = $element;
	        this.config = Config;
	        this.mode = this.mode || 'view';
	
	        // Initial values
	        this.delivery = this.getDeliveryOptions(this.priceLevel);
	        this.deliveryMap = _lodash2.default.fromPairs(this.delivery);
	    }
	
	    _createClass(C, [{
	        key: 'getDeliveryOptions',
	        value: function getDeliveryOptions(priceLevel) {
	            if (_lodash2.default.isUndefined(priceLevel)) {
	                return this.config.$config.delivery;
	            }
	            var is5PL = priceLevel && priceLevel === 5;
	
	            return _lodash2.default.filter(this.config.$config.delivery, function (obj) {
	                var exists = pl5_customer.indexOf(obj[0]);
	                return obj[0] == 'pickup' || is5PL && exists >= 0 || !is5PL && exists === -1;
	            });
	        }
	    }, {
	        key: 'getName',
	        value: function getName() {
	            var self = this;
	            return self.deliveryMap[self.ngModel];
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            if (this.mode === 'view') {
	                return;
	            }
	            var isFirstChange = changes.priceLevel && changes.priceLevel.isFirstChange && changes.priceLevel.isFirstChange();
	            if (isFirstChange || !changes.priceLevel) {
	                return;
	            }
	
	            var currentValue = _lodash2.default.toInteger(changes.priceLevel.currentValue);
	            var previousValue = _lodash2.default.toInteger(changes.priceLevel.previousValue);
	            if (currentValue != previousValue) {
	                this.ngModel = null;
	                this.delivery = this.getDeliveryOptions(currentValue);
	                this.deliveryMap = _lodash2.default.fromPairs(this.delivery);
	            }
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.$element.remove();
	            this.$element = null;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _hideCustomerButton = __webpack_require__(701);
	
	var _hideCustomerButton2 = _interopRequireDefault(_hideCustomerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	  name: "app.directives.hide-customer.button.component"
	}), _dec2 = (0, _decorators.Component)({
	  selector: "blnd-hide-customer-button",
	  template: _hideCustomerButton2.default,
	  bindings: {
	    ngModel: "=",
	    ngDisabled: "=?",
	    type: "@",
	    multiple: "=?",
	    table: "<"
	  }
	}), _dec(_class = _dec2(_class = function () {
	  C.$inject = ["$growl", "UserService", "$stateParams", "$element", "R", "Modal"];
	  function C($growl, UserService, $stateParams, $element, R, Modal) {
	    "ngInject";
	
	    _classCallCheck(this, C);
	
	    this.$growl = $growl;
	    this.$element = $element;
	    this.customerId = $stateParams.customerId;
	    this.$user = UserService.$user;
	    this.R = R;
	    this.Modal = Modal;
	    this.multiple = this.multiple || false;
	    this.ngDisabled = this.ngDisabled || false;
	    this.loading = false;
	    this.isHidden = this.$user.hidden_customers.includes(parseInt(this.customerId));
	  }
	
	  _createClass(C, [{
	    key: "$onDestroy",
	    value: function $onDestroy() {
	      this.$element.remove();
	      this.$element = null;
	    }
	  }, {
	    key: "hideCustomer",
	    value: function hideCustomer() {
	      var _this = this;
	
	      this.loading = true;
	      this.$user.patch({ hidden_customers: this.customerId }).then(function (response) {
	        _angular2.default.extend(_this.$user, response);
	        _this.$growl.success("Status Changed!");
	      }, function (response) {
	        if (response.status === 500) {
	          _this.$growl.error(response.data.detail);
	        }
	      }).finally(function () {
	        return window.location.replace("customers"), _this.loading = false;
	      });
	    }
	  }]);
	
	  return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"btn-group\" uib-dropdown>\n    <button type=\"button\" class=\"btn\" ng-click=\"$ctrl.hideCustomer()\"\n        ng-class=\"{'btn-primary': !$ctrl.multiple, 'btn-default': $ctrl.multiple}\" ladda=\"$ctrl.loading\">\n        <span ng-if=\"$ctrl.isHidden\">Show this customer</span>\n        <span ng-if=\"!$ctrl.isHidden\">Hide this customer</span>\n    </button>\n</div>\n"

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _dec2, _class2, _dec3, _dec4, _class3;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _jsApiLoader = __webpack_require__(548);
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _modals = __webpack_require__(532);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _config = __webpack_require__(504);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _form = __webpack_require__(693);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _field = __webpack_require__(703);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _fields = __webpack_require__(704);
	
	var _fields2 = _interopRequireDefault(_fields);
	
	var _fieldModal = __webpack_require__(705);
	
	var _fieldModal2 = _interopRequireDefault(_fieldModal);
	
	var _constants = __webpack_require__(538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FieldModalCtrl = (_dec = (0, _decorators.Inject)('$scope', 'FieldStore', '$uibModalInstance', 'R', 'customer'), _dec(_class = function () {
	    function FieldModalCtrl($scope, FieldStore, $uibModalInstance, R, customer) {
	        _classCallCheck(this, FieldModalCtrl);
	
	        var self = this;
	        this.R = R;
	        this.$modal = $uibModalInstance;
	        this.customer = customer;
	        this.store = FieldStore;
	        this.data = {
	            customer: customer.id,
	            geo: {}
	        };
	    }
	
	    _createClass(FieldModalCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'onSubmit',
	        value: function onSubmit(data) {
	            // get data from map and set to data object
	            var lat = document.getElementById("geo_latitude").value;
	            var lng = document.getElementById("geo_longitude").value;
	            data.geo.latitude = lat ? lat : 0.0;
	            data.geo.longitude = lng ? lng : 0.0;
	            data.location = document.getElementById("location").value;
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.onSubmit(self.data).then(function (field) {
	                self.$modal.close(field);
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'prepareMap',
	        value: function prepareMap() {
	            var self = this;
	            var loader = new _jsApiLoader.Loader({
	                apiKey: _constants.GOOGLE_API_KEY,
	                libraries: ["places"],
	                version: "weekly"
	            });
	            loader.load().then(function () {
	                var position = {
	                    lat: self.data.geo.latitude != 0 ? self.data.geo.latitude : 39.411136,
	                    lng: self.data.geo.longitude != 0 ? self.data.geo.longitude : -77.402671
	                };
	                var lat = document.getElementById("geo_latitude");
	                var lng = document.getElementById("geo_longitude");
	                var location = document.getElementById("location");
	
	                var map = new google.maps.Map(document.getElementById("map"), {
	                    zoom: 8,
	                    center: position
	                });
	
	                var marker = new google.maps.Marker({
	                    position: position,
	                    map: map,
	                    label: self.location,
	                    draggable: true
	                });
	                marker.addListener("dragend", function () {
	                    lat.value = marker.getPosition().lat().toFixed(6);
	                    lng.value = marker.getPosition().lng().toFixed(6);
	                    location.value = '(' + lat.value + ', ' + lng.value + ')';
	                });
	
	                var autocomplete = new google.maps.places.Autocomplete(location, {
	                    componentRestrictions: {
	                        country: ["us"]
	                    }
	                });
	
	                // update map and geo fields on place select
	                autocomplete.addListener("place_changed", function () {
	                    var place = autocomplete.getPlace();
	                    if (!place.geometry) {
	                        input.placeholder = "Enter a place";
	                    } else {
	                        var new_lat = place.geometry.location.lat().toFixed(6);
	                        var new_lng = place.geometry.location.lng().toFixed(6);
	                        var latLng = new google.maps.LatLng(new_lat, new_lng);
	
	                        map.setCenter(latLng);
	                        marker.setPosition(latLng);
	                        lat.value = latLng.lat();
	                        lng.value = latLng.lng();
	                    }
	                });
	                // workaround for google submitting form on enter
	                location.addEventListener("keydown", function (e) {
	                    if (e.key == "Enter") {
	                        e.preventDefault();
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return '';
	        }
	    }]);
	
	    return FieldModalCtrl;
	}()) || _class);
	
	var AddFieldCtrl = function (_FieldModalCtrl) {
	    _inherits(AddFieldCtrl, _FieldModalCtrl);
	
	    function AddFieldCtrl() {
	        "ngInject";
	
	        var _ref;
	
	        _classCallCheck(this, AddFieldCtrl);
	
	        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
	            params[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, (_ref = AddFieldCtrl.__proto__ || Object.getPrototypeOf(AddFieldCtrl)).call.apply(_ref, [this].concat(params)));
	
	        _this.prepareMap();
	        _this.data.geo = {
	            latitude: 40.394776,
	            longitude: -78.31599
	        };
	        return _this;
	    }
	
	    _createClass(AddFieldCtrl, [{
	        key: 'onSubmit',
	        value: function onSubmit(data) {
	            _get(AddFieldCtrl.prototype.__proto__ || Object.getPrototypeOf(AddFieldCtrl.prototype), 'onSubmit', this).call(this, data);
	            return this.store.create(data);
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Add new destination';
	        }
	    }]);
	
	    return AddFieldCtrl;
	}(FieldModalCtrl);
	
	var EditFieldCtrl = (_dec2 = (0, _decorators.Inject)('$growl', 'field', 'Modal'), _dec2(_class2 = function (_FieldModalCtrl2) {
	    _inherits(EditFieldCtrl, _FieldModalCtrl2);
	
	    function EditFieldCtrl($growl, field, Modal) {
	        var _ref2;
	
	        _classCallCheck(this, EditFieldCtrl);
	
	        for (var _len2 = arguments.length, params = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	            params[_key2 - 3] = arguments[_key2];
	        }
	
	        var _this2 = _possibleConstructorReturn(this, (_ref2 = EditFieldCtrl.__proto__ || Object.getPrototypeOf(EditFieldCtrl)).call.apply(_ref2, [this].concat(params)));
	
	        _this2.field = field;
	        _this2.$growl = $growl;
	        _this2.Modal = Modal;
	        _this2.data = _this2.R.copy(field);
	        _this2.map = {
	            latitude: _this2.data.geo.latitude,
	            longitude: _this2.data.geo.longitude
	        };
	        _this2.prepareMap();
	        return _this2;
	    }
	
	    _createClass(EditFieldCtrl, [{
	        key: 'onSubmit',
	        value: function onSubmit(data) {
	            _get(EditFieldCtrl.prototype.__proto__ || Object.getPrototypeOf(EditFieldCtrl.prototype), 'onSubmit', this).call(this, data);
	            var self = this;
	            return data.put().then(function () {
	                _angular2.default.extend(self.field, data);
	            });
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            return _get(EditFieldCtrl.prototype.__proto__ || Object.getPrototypeOf(EditFieldCtrl.prototype), 'close', this).call(this);
	        }
	    }, {
	        key: 'openDeleteModal',
	        value: function openDeleteModal() {
	            var self = this;
	            var $Modal = self.Modal.openConfirmDelete({
	                text: 'Are you sure to delete ' + self.field.title + ' ?'
	            });
	            $Modal.wait.then(function (result) {
	                self.store.remove(self.field.id).then(function () {
	                    result.close();
	                    self.close();
	                    self.$growl.deleted();
	                });
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Edit destination ' + this.field.title;
	        }
	    }]);
	
	    return EditFieldCtrl;
	}(FieldModalCtrl)) || _class2);
	
	var FieldsCtrl = function () {
	    FieldsCtrl.$inject = ["$state", "$growl", "Modal", "FieldStore", "NgTableParams", "$customer"];
	    function FieldsCtrl($state, $growl, Modal, FieldStore, NgTableParams, $customer) {
	        "ngInject";
	
	        _classCallCheck(this, FieldsCtrl);
	
	        this.$growl = $growl;
	        this.Modal = Modal;
	        this.customer = $customer;
	        this.store = FieldStore;
	        this.$state = $state;
	        this.params = { customer: this.customer.id };
	
	        this.table = new _table2.default(NgTableParams, this.store, {
	            params: this.params
	        });
	        this.field = null;
	    }
	
	    _createClass(FieldsCtrl, [{
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }, {
	        key: 'pickField',
	        value: function pickField(field) {
	            this.field = field || null;
	        }
	    }, {
	        key: 'openAddModal',
	        value: function openAddModal() {
	            var _this3 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _fieldModal2.default,
	                controller: AddFieldCtrl,
	                resolve: {
	                    customer: function customer() {
	                        return _this3.customer;
	                    }
	                }
	            });
	            $modal.result.then(function (field) {
	                field.new = true;
	                self.store.list.unshift(field);
	                self.pickField(field);
	                self.$growl.added();
	            });
	        }
	    }, {
	        key: 'openEditModal',
	        value: function openEditModal() {
	            var _this4 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _fieldModal2.default,
	                controller: EditFieldCtrl,
	                resolve: {
	                    customer: function customer() {
	                        return _this4.customer;
	                    },
	                    field: function field() {
	                        return _this4.field;
	                    }
	                }
	            });
	            $modal.result.then(function () {
	                self.$growl.updated();
	                self.refresh();
	            });
	        }
	    }]);
	
	    return FieldsCtrl;
	}();
	
	var States = (_dec3 = (0, _decorators.Module)({
	    name: 'app.customers.fields',
	    modules: [_routing2.default, _modals2.default, _config2.default, _form2.default, _field2.default]
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.customers.detail.fields',
	    url: '/destinations',
	    controllerProvider: ["Config", function controllerProvider(Config) {
	        "ngInject";
	
	        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL', true) ? function () {} : FieldsCtrl;
	    }],
	    templateProvider: ["Config", function templateProvider(Config) {
	        "ngInject";
	
	        return Config.isFeatureFlagActive('REACT_CUSTOMER_DETAIL', true) ? '<div style="display:none"></div>' : _fields2.default;
	    }],
	    resolve: {},
	    ncyBreadcrumb: {
	        label: 'Destinations'
	    }
	}), _dec3(_class3 = _dec4(_class3 = function States() {
	    _classCallCheck(this, States);
	}) || _class3) || _class3);
	exports.default = States;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.field',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('FieldStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('fields');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"customer-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default\">\n                <div class=\"panel-heading\">\n                    <div class=\"row\">\n                        <div class=\"col-sm-6\">\n                            <input type=\"text\"\n                                   class=\"form-control\"\n                                   placeholder=\"Search\"\n                                   ng-model=\"vm.params.search\"\n                                   ng-keyup=\"$event.keyCode == 13 && vm.refresh()\"\n                            >\n                        </div>\n                        <div class=\"col-sm-2 pull-right\" permission permission-only=\"'main.add_field'\">\n                            <div class=\"pull-right\">\n                                <button class=\"btn btn-add\" ng-click=\"vm.openAddModal()\">Add</button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div loading-container=\"vm.table.params.settings().$loading\">\n                    <table ng-table=\"vm.table.params\" class=\"table table-fixed customer-fields-table\">\n                        <tr ng-repeat=\"field in $data\"\n                            ng-class=\"{active: field.id === vm.field.id}\">\n                            <td class=\"col-xs-4\"\n                                data-title=\"'Farm'\">\n                                <a ng-click=\"vm.pickField(field); vm.openEditModal()\" ng-bind=\"field.farm_name\"></a>\n                            </td>\n                            <td class=\"col-xs-2\"\n                                ng-bind=\"field.field_name\"\n                                data-title=\"'Field'\">\n                            </td>\n                            <td class=\"col-xs-2\"\n                                ng-bind=\"field.acres\"\n                                data-title=\"'Acres'\">\n                            </td>\n                            <td class=\"col-xs-4\"\n                                ng-bind=\"field.location\"\n                                data-title=\"'Location'\">\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports = "<style>\n/* https://stackoverflow.com/questions/45086703/how-to-create-google-autocomplete-in-bootstrap-modal-in-angular-2 */\n.pac-container {\n    z-index: 1054 !important;\n }\n</style>\n<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n                type=\"button\"\n                class=\"close\"\n                data-dismiss=\"modal\"\n                aria-label=\"Close\"\n                ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-sm-5\">\n                <div class=\"form-group\">\n                    <label>Farm Name</label>\n                    <input type=\"text\" class=\"form-control\" name=\"farm_name\" ng-model=\"vm.data.farm_name\" form-error>\n                </div>\n            </div>\n            <div class=\"col-sm-5\">\n                <div class=\"form-group\">\n                    <label>Field Name</label>\n                    <input type=\"text\" class=\"form-control\" name=\"field_name\" ng-model=\"vm.data.field_name\" form-error>\n                </div>\n            </div>\n            <div class=\"col-sm-2\">\n                <div class=\"form-group\">\n                    <label>Acres</label>\n                    <input type=\"number\" step=\"0.01\" class=\"form-control\" name=\"acres\" ng-model=\"vm.data.acres\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-sm-12\">\n                <div class=\"form-group\">\n                    <label>Location</label>\n                    <input type=\"text\" class=\"form-control\" id=\"location\" ng-model=\"vm.data.location\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                    <label>Latitude</label>\n                    <input class=\"form-control\" id=\"geo_latitude\" ng-model=\"vm.data.geo.latitude\" form-error>\n                </div>\n            </div>\n            <div class=\"col-sm-6\">\n                <div class=\"form-group\">\n                    <label>Longitude</label>\n                    <input class=\"form-control\" id=\"geo_longitude\" ng-model=\"vm.data.geo.longitude\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div id=\"map\" style=\"height: 400px;\" class=\"w-100\"></div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <label>Notes</label>\n                <textarea class=\"form-control\" ng-model=\"vm.data.notes\"></textarea>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"submit\" ladda=\"vm.loading\">Save</button>\n        <button class=\"btn btn-delete\" type=\"button\" ng-click=\"vm.openDeleteModal()\" permission permission-only=\"'main.delete_field'\">Delete</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CustomerNotificationsCtrl = exports.LogCtrl = exports.FilesCtrl = exports.OrderListCtrl = exports.TicketListCtrl = exports.InfoCtrl = exports.EditInfoCtrl = exports.DetailCtrl = exports.ListCtrl = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _editInfo = __webpack_require__(707);
	
	var _editInfo2 = _interopRequireDefault(_editInfo);
	
	var _chooseCompanyModal = __webpack_require__(708);
	
	var _chooseCompanyModal2 = _interopRequireDefault(_chooseCompanyModal);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ListCtrl = exports.ListCtrl = function () {
	    ListCtrl.$inject = ["$stateParams", "$state", "NgTableParams", "CustomerStore", "UserService"];
	    function ListCtrl($stateParams, $state, NgTableParams, CustomerStore, UserService) {
	        "ngInject";
	
	        var _this = this;
	
	        _classCallCheck(this, ListCtrl);
	
	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.$user = UserService.$user;
	        this.defaultParams = {
	            is_active: 'True',
	            ordering: ['title'],
	            page_size: 20
	        };
	        this.showOnlyHidden = false;
	
	        this.resetParams();
	        this.applyQSParams();
	        this.table = new _table2.default(NgTableParams, CustomerStore, {
	            defaultParams: this.defaultParams,
	            params: this.params,
	            onChange: function onChange(params) {
	                return _this.onChange(params);
	            }
	        });
	    }
	
	    _createClass(ListCtrl, [{
	        key: 'applyQSParams',
	        value: function applyQSParams() {
	            var params = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Object.keys(this.$stateParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var k = _step.value;
	
	                    var v = this.$stateParams[k];
	                    if (!_lodash2.default.isUndefined(v)) {
	                        params[k] = v;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            params.companies = _lodash2.default.parseInt(params.companies) || undefined;
	            params.sales = parseInt(params.sales) || undefined;
	            params.page = parseInt(params.page) || undefined;
	
	            _lodash2.default.extend(this.params, params);
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(params_) {
	            // clear current params:
	            var params = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = Object.entries(this.$state.$current.params)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _step2$value = _slicedToArray(_step2.value, 2),
	                        k = _step2$value[0],
	                        v = _step2$value[1];
	
	                    if (v.location === 'search') {
	                        params[k] = undefined;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            params = _lodash2.default.extend(params, params_);
	            this.$state.go('.', params, { notify: false });
	        }
	    }, {
	        key: 'resetParams',
	        value: function resetParams() {
	            this.params = _lodash2.default.clone(this.defaultParams);
	            this.showOnlyHidden = false;
	        }
	    }, {
	        key: 'showHidden',
	        value: function showHidden() {
	            this.showOnlyHidden = !this.showOnlyHidden;
	            this.params = _lodash2.default.extend(this.params, { 'hidden': this.showOnlyHidden });
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }]);
	
	    return ListCtrl;
	}();
	
	var DetailCtrl = exports.DetailCtrl = ["$customer", function DetailCtrl($customer) {
	    "ngInject";
	
	    _classCallCheck(this, DetailCtrl);
	
	    this.customer = $customer;
	}];
	
	var EditInfoCtrl = exports.EditInfoCtrl = function () {
	    EditInfoCtrl.$inject = ["R", "$uibModalInstance", "customer", "CustomerStore"];
	    function EditInfoCtrl(R, $uibModalInstance, customer, CustomerStore) {
	        "ngInject";
	
	        _classCallCheck(this, EditInfoCtrl);
	
	        this.R = R;
	        this.customer = customer;
	        this.CustomerStore = CustomerStore;
	        this.data = this.R.copy(customer);
	        this.$modal = $uibModalInstance;
	        this.loading = false;
	    }
	
	    _createClass(EditInfoCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            // Remove from request readonly fields
	            var readOnlyFields = ['first_name', 'last_name', 'name', 'address', 'price_level', 'freight_zone', 'companies'];
	            // avoid glitch before send
	            var data = this.R.copy(this.data);
	
	            _lodash2.default.each(readOnlyFields, function (field) {
	                delete data[field];
	            });
	
	            // `data.put()` no longer exists: `CustomerStore.get()` now returns a
	            // plain object from the shared REST resource store rather than a
	            // "live" Restangular element. Use `CustomerStore.update(id, data)`.
	            this.CustomerStore.update(this.customer.id, data).then(function (data) {
	                _angular2.default.extend(self.customer, data);
	                self.$modal.close();
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }]);
	
	    return EditInfoCtrl;
	}();
	
	var InfoCtrl = exports.InfoCtrl = function () {
	    InfoCtrl.$inject = ["$growl", "Modal", "$customer"];
	    function InfoCtrl($growl, Modal, $customer) {
	        "ngInject";
	
	        _classCallCheck(this, InfoCtrl);
	
	        this.$growl = $growl;
	        this.Modal = Modal;
	        this.customer = $customer;
	    }
	
	    _createClass(InfoCtrl, [{
	        key: 'openEdit',
	        value: function openEdit() {
	            var _this2 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editInfo2.default,
	                controller: EditInfoCtrl,
	                size: 'lg',
	                resolve: {
	                    customer: function customer() {
	                        return _this2.customer;
	                    }
	                }
	            });
	            $modal.result.then(function () {
	                self.$growl.updated();
	            });
	        }
	    }]);
	
	    return InfoCtrl;
	}();
	
	var ChooseCompanyModalCtrl = function () {
	    ChooseCompanyModalCtrl.$inject = ["$uibModalInstance", "customer"];
	    function ChooseCompanyModalCtrl($uibModalInstance, customer) {
	        "ngInject";
	
	        _classCallCheck(this, ChooseCompanyModalCtrl);
	
	        this.data = {};
	        this.customer = customer;
	        this.$modal = $uibModalInstance;
	        this.data.company = _lodash2.default.first(this.customer.companies);
	    }
	
	    _createClass(ChooseCompanyModalCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            this.$modal.close(this.data.company);
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Select company';
	        }
	    }]);
	
	    return ChooseCompanyModalCtrl;
	}();
	
	var CreateOrderOrTicket = function () {
	    function CreateOrderOrTicket($q, $customer, $growl, Modal, store) {
	        _classCallCheck(this, CreateOrderOrTicket);
	
	        this.customer = $customer;
	        this.$growl = $growl;
	        this.Modal = Modal;
	        this.store = store;
	
	        this.defered = $q.defer();
	    }
	
	    _createClass(CreateOrderOrTicket, [{
	        key: 'redirectTo',
	        value: function redirectTo(data) {
	            throw 'Not implemented';
	        }
	    }, {
	        key: 'create',
	        value: function create() {
	            var self = this;
	            var company = _lodash2.default.first(self.customer.companies);
	
	            if (self.customer.companies.length > 1) {
	                var $modal = this.Modal.open({
	                    template: _chooseCompanyModal2.default,
	                    controller: ChooseCompanyModalCtrl,
	                    size: 'small',
	                    resolve: {
	                        customer: function customer() {
	                            return self.customer;
	                        }
	                    }
	                });
	
	                $modal.result.then(function (data) {
	                    self.defered.resolve(data);
	                });
	            } else {
	                self.defered.resolve(company);
	            }
	
	            self.defered.promise.then(function (company) {
	                self.store.create({
	                    customer: self.customer,
	                    company: company
	                }).then(function (data) {
	                    self.$growl.added();
	                    self.redirectTo(data);
	                });
	            });
	        }
	    }]);
	
	    return CreateOrderOrTicket;
	}();
	
	var TicketListCtrl = exports.TicketListCtrl = function (_CreateOrderOrTicket) {
	    TicketListCtrl.$inject = ["$q", "$customer", "$growl", "$state", "Modal", "TicketStore"];
	    _inherits(TicketListCtrl, _CreateOrderOrTicket);
	
	    function TicketListCtrl($q, $customer, $growl, $state, Modal, TicketStore) {
	        "ngInject";
	
	        _classCallCheck(this, TicketListCtrl);
	
	        var _this3 = _possibleConstructorReturn(this, (TicketListCtrl.__proto__ || Object.getPrototypeOf(TicketListCtrl)).call(this, $q, $customer, $growl, Modal, TicketStore));
	
	        _this3.$state = $state;
	
	        return _this3;
	    }
	
	    _createClass(TicketListCtrl, [{
	        key: 'redirectTo',
	        value: function redirectTo(data) {
	            this.$state.go('r.in.top.tickets.detail', { ticketId: data.id }, { absolute: true });
	        }
	    }]);
	
	    return TicketListCtrl;
	}(CreateOrderOrTicket);
	
	var OrderListCtrl = exports.OrderListCtrl = function (_CreateOrderOrTicket2) {
	    OrderListCtrl.$inject = ["$q", "$customer", "$growl", "$state", "Modal", "OrderStore"];
	    _inherits(OrderListCtrl, _CreateOrderOrTicket2);
	
	    function OrderListCtrl($q, $customer, $growl, $state, Modal, OrderStore) {
	        "ngInject";
	
	        _classCallCheck(this, OrderListCtrl);
	
	        var _this4 = _possibleConstructorReturn(this, (OrderListCtrl.__proto__ || Object.getPrototypeOf(OrderListCtrl)).call(this, $q, $customer, $growl, Modal, OrderStore));
	
	        _this4.$state = $state;
	        return _this4;
	    }
	
	    _createClass(OrderListCtrl, [{
	        key: 'redirectTo',
	        value: function redirectTo(data) {
	            this.$state.go('r.in.top.orders.detail', { orderId: data.id }, { absolute: true });
	        }
	    }]);
	
	    return OrderListCtrl;
	}(CreateOrderOrTicket);
	
	var FilesCtrl = exports.FilesCtrl = ["$customer", function FilesCtrl($customer) {
	    "ngInject";
	
	    _classCallCheck(this, FilesCtrl);
	
	    this.customer = $customer;
	}];
	
	var LogCtrl = exports.LogCtrl = function LogCtrl() {
	    _classCallCheck(this, LogCtrl);
	};
	
	var CustomerNotificationsCtrl = exports.CustomerNotificationsCtrl = function () {
	    CustomerNotificationsCtrl.$inject = ["$customer", "$growl"];
	    function CustomerNotificationsCtrl($customer, $growl) {
	        "ngInject";
	
	        _classCallCheck(this, CustomerNotificationsCtrl);
	
	        this.$growl = $growl;
	        this.customer = $customer;
	        var customerNotifications = this.customer.notifications_settings;
	        this.notifications = {
	            ticket_was_mixed_email_customer: customerNotifications ? customerNotifications.ticket_was_mixed_email_customer : false,
	            ticket_was_mixed_sms_customer: customerNotifications ? customerNotifications.ticket_was_mixed_sms_customer : false,
	            ticket_was_mixed_email_sales_person: customerNotifications ? customerNotifications.ticket_was_mixed_email_sales_person : false,
	            ticket_was_mixed_sms_sales_person: customerNotifications ? customerNotifications.ticket_was_mixed_sms_sales_person : false,
	            ticket_start_delivery_email_customer: customerNotifications ? customerNotifications.ticket_start_delivery_email_customer : false,
	            ticket_start_delivery_sms_customer: customerNotifications ? customerNotifications.ticket_start_delivery_sms_customer : false,
	            ticket_start_delivery_email_sales_person: customerNotifications ? customerNotifications.ticket_start_delivery_email_sales_person : false,
	            ticket_start_delivery_sms_sales_person: customerNotifications ? customerNotifications.ticket_start_delivery_sms_sales_person : false,
	            ticket_finish_delivery_email_customer: customerNotifications ? customerNotifications.ticket_finish_delivery_email_customer : false,
	            ticket_finish_delivery_sms_customer: customerNotifications ? customerNotifications.ticket_finish_delivery_sms_customer : false,
	            ticket_finish_delivery_email_sales_person: customerNotifications ? customerNotifications.ticket_finish_delivery_email_sales_person : false,
	            ticket_finish_delivery_sms_sales_person: customerNotifications ? customerNotifications.ticket_finish_delivery_sms_sales_person : false,
	            ticket_start_application_email_customer: customerNotifications ? customerNotifications.ticket_start_application_email_customer : false,
	            ticket_start_application_sms_customer: customerNotifications ? customerNotifications.ticket_start_application_sms_customer : false,
	            ticket_start_application_email_sales_person: customerNotifications ? customerNotifications.ticket_start_application_email_sales_person : false,
	            ticket_start_application_sms_sales_person: customerNotifications ? customerNotifications.ticket_start_application_sms_sales_person : false,
	            ticket_stop_application_email_customer: customerNotifications ? customerNotifications.ticket_stop_application_email_customer : false,
	            ticket_stop_application_sms_customer: customerNotifications ? customerNotifications.ticket_stop_application_sms_customer : false,
	            ticket_stop_application_email_sales_person: customerNotifications ? customerNotifications.ticket_stop_application_email_sales_person : false,
	            ticket_stop_application_sms_sales_person: customerNotifications ? customerNotifications.ticket_stop_application_sms_sales_person : false,
	            ticket_ready_to_bill_email_customer: customerNotifications ? customerNotifications.ticket_ready_to_bill_email_customer : false,
	            ticket_ready_to_bill_email_sales_person: customerNotifications ? customerNotifications.ticket_ready_to_bill_email_sales_person : false,
	            ticket_ready_to_bill_sms_customer: customerNotifications ? customerNotifications.ticket_ready_to_bill_sms_customer : false,
	            ticket_ready_to_bill_sms_sales_person: customerNotifications ? customerNotifications.ticket_ready_to_bill_sms_sales_person : false
	        };
	    }
	
	    _createClass(CustomerNotificationsCtrl, [{
	        key: 'submitChange',
	        value: function submitChange() {
	            var self = this;
	            this.customer.post('notifications', self.notifications).then(function () {
	                self.$growl.success('Notifications settings updated!');
	                self.errors = {};
	                self.customer.notifications_settings = self.notifications;
	            }, function (response) {
	                self.$growl.error('Something went wrong', response.data);
	            });
	        }
	    }]);
	
	    return CustomerNotificationsCtrl;
	}();

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\" ng-bind=\"vm.customer.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">First Name <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.first_name\" name=\"first_name\" readonly disabled form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Middle Name</label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.middle_name\" name=\"middle_name\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Last Name <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.last_name\" name=\"last_name\" readonly disabled form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Default Delivery</label>\n                    <blnd-customer-delivery-picker ng-model=\"vm.data.delivery\" price-level=\"vm.data.price_level\" mode=\"edit\"></blnd-customer-delivery-picker>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Name <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.name\" name=\"name\" readonly disabled form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Address 1 <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.address.line1\" name=\"address.line1\" readonly disabled form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Address 2 <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.address.line2\" name=\"address.line2\" readonly disabled form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-5\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">City <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.address.city\" name=\"address.city\" readonly disabled form-error>\n                </div>\n            </div>\n            <div class=\"col-md-5\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">State <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.address.state\" name=\"address.state\" readonly disabled form-error>\n                </div>\n            </div>\n            <div class=\"col-md-2\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Zip <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.address.zipcode\" name=\"address.zipcode\" readonly disabled form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">E-mail</label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.email\" name=\"email\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Phone number</label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.phone_number\" name=\"phone_number\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Price Level <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.price_level\" name=\"price_level\" readonly disabled form-error>\n                </div>\n            </div>\n            <div class=\"col-md-2\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Freight Zone <i read-only-as400></i></label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.freight_zone\" name=\"freight_zone\" readonly disabled form-error>\n                </div>\n            </div>\n            <div class=\"col-md-2\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Tax Class</label>\n                    <input type=\"text\" class=\"form-control input-medium\" ng-model=\"vm.data.tax_class\" name=\"tax_class\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Primary Salesperson <i class=\"fa fa-question-circle\" uib-tooltip=\"Only synced if it is in AS400, if there is no salesperson in AS400, you can provide value here.\"></i></label>\n                    <blnd-salespeople ng-model=\"vm.data.primary_salesperson\"\n                                      errors=\"vm.errors.primary_salesperson\"\n                                      mode=\"edit\"\n                                      multiple=\"false\"\n                                      form-error>\n                    </blnd-salespeople>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Salespeople</label>\n                    <div class=\"form-control-static\">\n                        <blnd-salespeople ng-model=\"vm.data.sales\" errors=\"vm.errors.sales\" mode=\"edit\" form-error></blnd-salespeople>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Companies <i read-only-as400></i></label>\n                    <div class=\"form-control-static\">\n                        <blnd-companies ng-model=\"vm.data.companies\" errors=\"vm.errors.companies\" mode=\"view\"  form-error></blnd-companies>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"submit\" ladda=\"vm.loading\">Submit</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label>Company</label>\n                    <blnd-company-picker ng-model=\"vm.data.company\" customer=\"vm.customer\"\n                                         test-id=\"customer-add-company-picker\" form-error mode=\"edit\"></blnd-company-picker>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"customers-list-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default\">\n                <div class=\"panel-heading\">\n                    <div class=\"search-query\">\n                        <form novalidate>\n                            <div class=\"row\">\n                                <div class=\"col-md-4\">\n                                    <input type=\"text\" class=\"form-control\" placeholder=\"Search\"\n                                        ng-model=\"vm.params.search\" ng-keyup=\"$event.keyCode == 13 && vm.refresh()\"\n                                        autofocus>\n                                </div>\n                                <div class=\"col-md-2 filter-by-company\">\n                                    <blnd-company-id-picker ng-model=\"vm.params.companies\"\n                                        test-id=\"customer-filter-company-picker\" ng-change=\"vm.refresh()\">\n                                    </blnd-company-id-picker>\n                                </div>\n                                <div class=\"col-md-3 filter-by-sales-person\">\n                                    <blnd-salesperson-picker ng-model=\"vm.params.sales\" mode=\"search\"\n                                        placeholder=\"Select Salesperson\" ng-change=\"vm.refresh()\">\n                                    </blnd-salesperson-picker>\n                                </div>\n                                <div class=\"col-sm-1\">\n                                    <button type=\"button\" class=\"btn btn-default pull-right\"\n                                        ng-click=\"vm.resetParams(); vm.refresh()\">\n                                        Clear\n                                    </button>\n                                </div>\n                                <div class=\"col-sm-2\">\n                                    <button type=\"button\" class=\"btn btn-default pull-right\"\n                                        ng-click=\"vm.showHidden(); vm.refresh()\">\n                                        <span ng-if=\"vm.showOnlyHidden\">All customers</span>\n                                        <span ng-if=\"!vm.showOnlyHidden\">Hidden customers</span>\n                                    </button>\n                                </div>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n                <div loading-container=\"vm.table.params.settings().$loading\">\n                    <table ng-table=\"vm.table.params\" class=\"table table-fixed table-striped customers-table\">\n                        <tr ng-repeat=\"customer in $data\">\n                            <td header=\"'headerCheckBox'\" class=\"col-checkbox\">\n                                <input type=\"checkbox\" />\n                            </td>\n                            <td class=\"col-id\" data-title=\"'ID'\" sortable=\"'id'\">\n                                <a ui-sref=\"r.in.top.customers.detail({customerId: customer.id})\"\n                                    ng-bind=\"customer.id\"></a>\n                            </td>\n                            <td data-title=\"'Name'\" sortable=\"'title'\" ng-bind=\"customer.title\"></td>\n                            <td data-title=\"'Address'\" ng-bind=\"customer.address.title\"></td>\n                            <td data-title=\"'Company'\">\n                                <blnd-company-picker ng-repeat=\"company in customer.companies\" ng-model=\"company\">\n                                </blnd-company-picker>\n                            </td>\n                            <td data-title=\"'Salesperson'\" sortable=\"'sales'\">\n                                <blnd-salespeople ng-model=\"customer.sales\"></blnd-salespeople>\n                            </td>\n                            <td data-title=\"'Hidden'\">\n                                <input type=\"checkbox\" data-title=\"'Hide'\" ng-checked='vm.$user.hidden_customers.includes(customer.id)' disabled></input>\n                            </td>\n                        </tr>\n                    </table>\n                    <no-data params=\"vm.table.params\">No customers</no-data>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"customer-details\">\n    <ul class=\"nav nav-tabs\">\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.customers.detail.info\">Info</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.customers.detail.fields\">Destinations</a>\n        </li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.customers.detail.orders\">Orders</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.customers.detail.tickets\">Tickets</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.customers.detail.files\">Files</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\"><a ui-sref=\"r.in.top.customers.detail.log\">Log</a></li>\n        <li role=\"presentation\" ui-sref-active=\"active\" permission permission-only=\"'main.view_customer'\"><a ui-sref=\"r.in.top.customers.detail.notifications\">Notifications</a></li>\n        <li role=\"presentation\" class=\"action pull-right\" permission permission-only=\"'main.view_customer'\">\n            <blnd-hide-customer-button ng-model=\"vmo.order\" ng-disabled=\"!canViewEditButton\" type=\"order\" permission\n                permission-only=\"'main.view_customer'\"></blnd-hide-customer-button>\n        </li>\n    </ul>\n    <div class=\"blnd-tab-content\" ui-view>\n    </div>\n</div>\n"

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"customer-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"top-right-corner\" permission permission-only=\"'main.change_customer'\">\n                        <button class=\"btn btn btn-edit\" ng-click=\"vm.openEdit()\">Edit</button>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>ID</div>\n                                <div ng-bind=\"vm.customer.id\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-3\">\n                            <div class=\"blnd-data-field\">\n                                <div>First Name</div>\n                                <div ng-bind=\"vm.customer.first_name\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-3\">\n                            <div class=\"blnd-data-field\">\n                                <div>Middle Name</div>\n                                <div ng-bind=\"vm.customer.middle_name\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-3\">\n                            <div class=\"blnd-data-field\">\n                                <div>Last Name</div>\n                                <div ng-bind=\"vm.customer.last_name\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-6\">\n                            <div class=\"blnd-data-field\">\n                                <div>Name</div>\n                                <div ng-bind=\"vm.customer.name\"></div>\n                            </div>\n\n                        </div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-sm-6\">\n                            <div class=\"blnd-data-field\">\n                                <div>Address</div>\n                                <div ng-bind=\"vm.customer.address.line1\"></div>\n                                <div ng-bind=\"vm.customer.address.line2\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-3\">\n                            <div class=\"blnd-data-field\">\n                                <div>City</div>\n                                <div ng-bind=\"vm.customer.address.city\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>State</div>\n                                <div ng-bind=\"vm.customer.address.state\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-1\">\n                            <div class=\"blnd-data-field\">\n                                <div>Zip</div>\n                                <div ng-bind=\"vm.customer.address.zipcode\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-2\">\n                        </div>\n                        <div class=\"col-md-2\">\n                        </div>\n                        <div class=\"col-md-2\">\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-3\">\n                             <div class=\"blnd-data-field\">\n                                 <div>Phone number</div>\n                                 <div ng-bind=\"vm.customer.phone_number\"></div>\n                             </div>\n                        </div>\n                        <div class=\"col-sm-3\">\n                             <div class=\"blnd-data-field\">\n                                 <div>E-mail</div>\n                                 <div ng-bind=\"vm.customer.email\"></div>\n                             </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-6\">\n                            <div class=\"blnd-data-field\">\n                                <div>Default Delivery</div>\n                                <blnd-customer-delivery-picker ng-model=\"vm.customer.delivery\" price-level=\"vm.customer.price_level\" mode=\"view\"></blnd-customer-delivery-picker>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-sm-1\">\n                            <div class=\"blnd-data-field\">\n                                <div>PL</div>\n                                <div ng-bind=\"vm.customer.price_level\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-1\">\n                            <div class=\"blnd-data-field\">\n                                <div>NS PL</div>\n                                <div ng-bind=\"vm.customer.non_standard_price_level\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>Freight Zone</div>\n                                <div ng-bind=\"vm.customer.freight_zone\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>Tax Class</div>\n                                <div ng-bind=\"vm.customer.tax_class\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-sm-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>Primary Salesperson</div>\n                                <div><blnd-salespeople ng-model=\"vm.customer.primary_salesperson\" multiple=\"false\"></blnd-salespeople></div>\n                            </div>\n                        </div>\n                        <div class=\"col-sm-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Salespeople</div>\n                                <div><blnd-salespeople ng-model=\"vm.customer.sales\"></blnd-salespeople></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Companies</div>\n                                <div>\n                                    <blnd-companies ng-model=\"vm.customer.companies\"></blnd-companies>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = "<order-list customer=\"pvm.customer\" extra-fields=\"['fields']\"></order-list>\n<div id=\"create-button\" class=\"bottom-right-icon-button\" permission permission-only=\"'main.add_order'\">\n    <div class=\"btn btn-primary btn-fab\"\n        role=\"button\"\n        title=\"Create new order\"\n        aria-label=\"Create new order\"\n        ng-click=\"vm.create()\">\n            <i class=\"btn-icon fa fa-plus\" aria-hidden=\"true\"></i>\n    </div>\n</div>\n"

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	module.exports = "<ticket-list customer=\"pvm.customer\" extra-fields=\"['fields']\"></ticket-list>\n<div id=\"create-button\"\n    data-testid=\"ticket-create-button\"\n    class=\"bottom-right-icon-button\"\n    permission permission-only=\"'main.add_ticket'\">\n    <div class=\"btn btn-primary btn-fab\"\n        role=\"button\"\n        title=\"Create new ticket\"\n        aria-label=\"Create new ticket\"\n        ng-click=\"vm.create()\">\n            <i class=\"btn-icon fa fa-plus\" aria-hidden=\"true\"></i>\n    </div>\n</div>\n"

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"order-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-upload-section ng-model=\"vm.customer\" type=\"customer\"></blnd-upload-section>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports = "<blnd-activity object=\"pvm.customer\"></blnd-activity>\n"

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"jumbotron\">\n    <form ng-submit=\"vm.submitChange\" novalidate>\n        <table class=\"notifications_table\">\n            <thead>\n                <tr>\n                    <th>Notification</th>\n                    <th colspan=\"2\" style=\"text-align:center\">Customer</th>\n                    <th colspan=\"2\" style=\"text-align:center\">Salesperson</th>\n                </tr>\n            </thead>\n            <thead>\n                <tr>\n                    <th></th>\n                    <th style=\"text-align:center\">Email</th>\n                    <th style=\"text-align:center\">SMS</th>\n                    <th style=\"text-align:center\">Email</th>\n                    <th style=\"text-align:center\">SMS</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>Ticket was mixed</td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_was_mixed_email_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_was_mixed_sms_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_was_mixed_email_sales_person\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_was_mixed_sms_sales_person\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Ticket is in delivery</td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_delivery_email_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_delivery_sms_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_delivery_email_sales_person\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_delivery_sms_sales_person\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Ticket was delivered</td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_finish_delivery_email_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_finish_delivery_sms_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_finish_delivery_email_sales_person\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_finish_delivery_sms_sales_person\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Application has started</td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_application_email_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_application_sms_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_application_email_sales_person\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_start_application_sms_sales_person\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Ticket ready to bill</td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_ready_to_bill_email_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_ready_to_bill_sms_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_ready_to_bill_email_sales_person\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_ready_to_bill_sms_sales_person\">\n                    </td>\n                </tr>\n                <tr>\n                    <td>Application is completed</td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_stop_application_email_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_stop_application_sms_customer\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_stop_application_email_sales_person\">\n                    </td>\n                    <td style=\"text-align:center\">\n                        <input type=\"checkbox\" ng-model=\"vm.notifications.ticket_stop_application_sms_sales_person\">\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n\n        <div class=\"row modal-footer\">\n            <button class=\"btn btn-submit pull-right\" type=\"button\" ng-click=\"vm.submitChange()\" permission permission-only=\"'main.can_change_customer_notifications'\">Save</button>\n        </div>\n    </form>\n</div>\n"

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _main = __webpack_require__(718);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _plant = __webpack_require__(719);
	
	var _plant2 = _interopRequireDefault(_plant);
	
	var _ctrls = __webpack_require__(720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.inventoryDashboard.routing',
	    modules: [_routing2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.inventoryDashboard',
	    url: '/inventory',
	    template: _main2.default,
	    controller: _ctrls.InventoryDashboardMainCtrl,
	    ncyBreadcrumb: {
	        label: 'Inventory',
	        parent: 'r.in.top'
	    },
	    data: {
	        permissions: {
	            only: ['main.view_productinventory']
	        }
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.inventoryDashboard.plant',
	    url: '/{companyId:int}',
	    controller: _ctrls.InventoryDashboardPlantCtrl,
	    template: _plant2.default,
	    ncyBreadcrumb: {
	        skip: true
	    },
	    data: {
	        permissions: {
	            only: ['main.view_productinventory']
	        }
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <ul class=\"nav nav-tabs\">\n        <li ui-sref=\"r.in.top.inventoryDashboard.plant({\n            companyId: company.id\n        })\" ng-repeat=\"company in vm.store.list\" ui-sref-active=\"active\">\n            <a>{{company.name}}</a>\n        </li>\n    </ul>\n    <div class=\"flip-container\">\n        <div class=\"text-center panel panel-default blnd-panel\">\n            <div class=\"panel-body\">\n                <div ui-view class=\"plant-view\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div>\n        <a href=\"#\" ng-click=\"vm.export()\" class=\"pull-right\">Export to CSV</a>\n        <div class='clearfix'>\n        <h2 ng-show=\"vm.displayNutrients\" style=\"\">Nutrients</h2>\n        </div>\n    </div>\n        <div class=\"card card-default dashboard-card\" ng-repeat=\"group in vm.nutrientSetsList\" ng-class=\"group.class\">\n        <div class=\"card-body text-center\">\n                <h4>{{group.title}}</h4>\n        </div>\n        <div class=\"card-body text-center chart-body\">\n            <div ng-show=\"group.charts[0]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                    <canvas\n                        tc-chartjs\n                        chart-type=\"bar\"\n                        chart-data=\"group.charts[0]\"\n                        chart-options=\"group.charts[0].options\"\n                    ></canvas>\n                </div>\n                <div ng-show=\"group.charts[1]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                        <canvas\n                            tc-chartjs\n                            chart-type=\"bar\"\n                            chart-data=\"group.charts[1]\"\n                            chart-options=\"group.charts[1].options\"\n                        ></canvas>\n                </div>\n                <div ng-show=\"group.charts[2]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                        <canvas\n                            tc-chartjs\n                            chart-type=\"bar\"\n                            chart-data=\"group.charts[2]\"\n                            chart-options=\"group.charts[2].options\"\n                        ></canvas>\n                </div>\n                <div ng-show=\"group.charts[3]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                        <canvas\n                            tc-chartjs\n                            chart-type=\"bar\"\n                            chart-data=\"group.charts[3]\"\n                            chart-options=\"group.charts[3].options\"\n                        ></canvas>\n                </div>\n        </div>\n    </div>\n</div>\n<div class=\"row\">\n    <h2 ng-show=\"vm.displayChemicals\">Chemicals</h1>\n        <div class=\"card card-default dashboard-card\" ng-repeat=\"group in vm.chemicalSets\" ng-class=\"group.class\">\n        <div class=\"card-body text-center\">\n                <h4>{{group.title}}</h4>\n        </div>\n        <div class=\"card-body text-center chart-body\">\n            <div ng-show=\"group.charts[0]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                <canvas\n                    tc-chartjs\n                    chart-type=\"bar\"\n                    chart-data=\"group.charts[0]\"\n                    chart-options=\"group.charts[0].options\"\n                ></canvas>\n            </div>\n            <div ng-show=\"group.charts[1]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                    <canvas\n                        tc-chartjs\n                        chart-type=\"bar\"\n                        chart-data=\"group.charts[1]\"\n                        chart-options=\"group.charts[1].options\"\n                    ></canvas>\n            </div>\n            <div ng-show=\"group.charts[2]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                    <canvas\n                        tc-chartjs\n                        chart-type=\"bar\"\n                        chart-data=\"group.charts[2]\"\n                        chart-options=\"group.charts[2].options\"\n                    ></canvas>\n            </div>\n            <div ng-show=\"group.charts[3]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                    <canvas\n                        tc-chartjs\n                        chart-type=\"bar\"\n                        chart-data=\"group.charts[3]\"\n                        chart-options=\"group.charts[3].options\"\n                    ></canvas>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"row\">\n    <h2 ng-show=\"vm.displayOthers\">Others</h1>\n        <div class=\"card card-default dashboard-card\" ng-repeat=\"group in vm.otherSets\" ng-class=\"group.class\">\n        <div class=\"card-body text-center\">\n                <h4>{{group.title}}</h4>\n        </div>\n        <div class=\"card-body text-center chart-body\">\n            <div ng-show=\"group.charts[0]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                <canvas\n                    tc-chartjs\n                    chart-type=\"bar\"\n                    chart-data=\"group.charts[0]\"\n                    chart-options=\"group.charts[0].options\"\n                ></canvas>\n            </div>\n            <div ng-show=\"group.charts[1]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                    <canvas\n                        tc-chartjs\n                        chart-type=\"bar\"\n                        chart-data=\"group.charts[1]\"\n                        chart-options=\"group.charts[1].options\"\n                    ></canvas>\n            </div>\n            <div ng-show=\"group.charts[2]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                    <canvas\n                        tc-chartjs\n                        chart-type=\"bar\"\n                        chart-data=\"group.charts[2]\"\n                        chart-options=\"group.charts[2].options\"\n                    ></canvas>\n            </div>\n            <div ng-show=\"group.charts[3]\" class=\"chart-wrapper\" ng-class=\"group.chartClass\">\n                    <canvas\n                        tc-chartjs\n                        chart-type=\"bar\"\n                        chart-data=\"group.charts[3]\"\n                        chart-options=\"group.charts[3].options\"\n                    ></canvas>\n            </div>\n        </div>\n    </div>\n</div>\n    <h3 ng-show=\"!vm.displayChemicals && !vm.displayNutrients && !vm.displayOthers && !vm.loading\">Please configure capacities in order to see inventory charts!</h3>\n    <h2 ng-show=\"vm.loading\">Loading...</h3>\n</div>\n"

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InventoryDashboardMainCtrl = exports.InventoryDashboardMainCtrl = ["CompanyStore", "$state", function InventoryDashboardMainCtrl(CompanyStore, $state) {
	    "ngInject";
	
	    var _this = this;
	
	    _classCallCheck(this, InventoryDashboardMainCtrl);
	
	    this.store = CompanyStore;
	    this.store.init();
	    this.store.refresh().then(function () {
	        if ($state.current.name === 'r.in.top.inventoryDashboard') {
	            $state.go('r.in.top.inventoryDashboard.plant', {
	                companyId: _this.store.list[0].id
	            });
	        }
	    });
	}];
	
	var InventoryDashboardPlantCtrl = exports.InventoryDashboardPlantCtrl = function () {
	    InventoryDashboardPlantCtrl.$inject = ["R", "$stateParams", "SecureUrlService"];
	    function InventoryDashboardPlantCtrl(R, $stateParams, SecureUrlService) {
	        "ngInject";
	
	        _classCallCheck(this, InventoryDashboardPlantCtrl);
	
	        this.companyId = $stateParams.companyId;
	        this.R = R;
	        this.nutrientSets = {};
	        this.nutrientSetsList = [];
	        this.chemicalSets = [];
	        this.otherSets = [];
	        this.loading = true;
	        this.displayNutrients = false;
	        this.displayChemicals = false;
	        this.displayOthers = false;
	        this.type = $stateParams.type;
	        this.secureUrlService = SecureUrlService;
	        this.fetchInventory();
	    }
	
	    _createClass(InventoryDashboardPlantCtrl, [{
	        key: 'export',
	        value: function _export() {
	            var self = this;
	            self.secureUrlService.openInNewWindow(self.R.one('export-inventory'), { company: this.companyId });
	        }
	    }, {
	        key: 'processInventory',
	        value: function processInventory(inventory) {
	            var _this2 = this;
	
	            this.loading = false;
	            inventory.results.forEach(function (value) {
	                var configuration = value.product.configurations[0] || {};
	                var group = configuration ? configuration.source_of : value.product.id;
	                while (_this2.nutrientSets[group] && _this2.nutrientSets[group].length > 4) {
	                    group = group + '-';
	                }
	                var available = value.available > 0 ? value.available : 0;
	                var chartData = {
	                    options: {
	                        animation: false,
	                        scales: {
	                            xAxes: [{
	                                stacked: true
	                            }],
	
	                            yAxes: [{
	                                stacked: false,
	                                scaleLabel: {
	                                    display: true,
	                                    labelString: value.product.units.name
	                                }
	                            }]
	                        },
	                        responsive: true,
	                        maintainAspectRatio: false
	                    },
	                    labels: [value.product.description],
	                    datasets: [{
	                        stack: '1',
	                        label: 'Available',
	                        data: [available],
	                        backgroundColor: '#337ab7'
	                    }, {
	                        label: 'Capacity',
	                        stack: '1',
	                        data: [value.capacity, 0]
	                    }]
	                };
	                if (['chemical', 'micronutrient'].indexOf(configuration.type) !== -1) {
	                    _this2.displayChemicals = true;
	                    _this2.chemicalSets.push({
	                        class: 'col-sm-3',
	                        charts: [chartData],
	                        title: value.product.configurations[0].name ? value.product.configurations[0].name : value.product.description,
	                        count: 1
	                    });
	                } else if (['econ', 'nutrient'].indexOf(configuration.type) !== -1) {
	                    _this2.displayNutrients = true;
	                    if (!_this2.nutrientSets[group]) {
	                        _this2.nutrientSets[group] = {
	                            charts: [chartData],
	                            class: 'col-sm-3',
	                            title: value.product.configurations[0].name ? value.product.configurations[0].name : value.product.description,
	                            count: 1
	                        };
	                    } else {
	                        _this2.nutrientSets[group].count = _this2.nutrientSets[group].count + 1;
	                        if (_this2.nutrientSets[group].count === 1) {
	                            _this2.nutrientSets[group].class = 'col-sm-3';
	                            _this2.nutrientSets[group].chartClass = 'col-sm-12';
	                        } else if (_this2.nutrientSets[group].count === 2) {
	                            _this2.nutrientSets[group].class = 'col-sm-6';
	                            _this2.nutrientSets[group].chartClass = 'col-sm-6';
	                        } else if (_this2.nutrientSets[group].count === 3) {
	                            _this2.nutrientSets[group].class = 'col-sm-9';
	                            _this2.nutrientSets[group].chartClass = 'col-sm-4';
	                        } else {
	                            _this2.nutrientSets[group].class = 'col-sm-12';
	                            _this2.nutrientSets[group].chartClass = 'col-sm-3';
	                        }
	                        _this2.nutrientSets[group].charts.push(chartData);
	                    }
	                } else {
	                    _this2.displayOthers = true;
	                    _this2.otherSets.push({
	                        class: 'col-sm-3',
	                        charts: [chartData],
	                        title: value.product.description,
	                        count: 1
	                    });
	                }
	            });
	            var tempList = [];
	            for (var key in this.nutrientSets) {
	                tempList.push(Object.assign({}, this.nutrientSets[key]));
	            }
	            tempList.sort(function (a, b) {
	                return b.count - a.count;
	            });
	            var i = 0;
	            while (tempList.length > 0) {
	                var item = {};
	                if (!(i % 4)) {
	                    item = tempList.shift();
	                } else {
	                    item = tempList.pop();
	                }
	                i += item.count;
	                this.nutrientSetsList.push(item);
	            }
	        }
	    }, {
	        key: 'fetchInventory',
	        value: function fetchInventory() {
	            var _this3 = this;
	
	            var params = {
	                company: this.companyId,
	                dashboard: true
	            };
	            var inventory = this.R.all('product_inventory').customGET('', params);
	            inventory.then(function (value) {
	                return _this3.processInventory(value);
	            });
	        }
	    }]);
	
	    return InventoryDashboardPlantCtrl;
	}();

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _main = __webpack_require__(722);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _plant = __webpack_require__(723);
	
	var _plant2 = _interopRequireDefault(_plant);
	
	var _ctrls = __webpack_require__(724);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.tonsDashboard.routing',
	    modules: [_routing2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.tonsDashboard',
	    url: '/tonnage',
	    template: _main2.default,
	    controller: _ctrls.TonsDashboardMainCtrl,
	    ncyBreadcrumb: {
	        label: 'Tonnage',
	        parent: 'r.in.top'
	    },
	    data: {
	        permissions: {
	            only: ['main.view_ticket']
	        }
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.tonsDashboard.plant',
	    url: '/{companyId:int}',
	    controller: _ctrls.TonsDashboardPlantCtrl,
	    template: _plant2.default,
	    ncyBreadcrumb: {
	        skip: true
	    },
	    data: {
	        permissions: {
	            only: ['main.view_ticket']
	        }
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <ul class=\"nav nav-tabs\">\n        <li ui-sref=\"r.in.top.tonsDashboard.plant({\n            companyId: company.id\n        })\" ng-repeat=\"company in vm.store.list\" ui-sref-active=\"active\">\n            <a>{{company.name}}</a>\n        </li>\n    </ul>\n    <div class=\"flip-container\">\n        <div class=\"panel panel-default blnd-panel\">\n            <div class=\"panel-body\">\n                <div ui-view class=\"plant-view\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <h3 class=\"text-center\">Years and months</h3>\n    <table class=\"table table-striped\">\n        <thead>\n            <th></th>\n            <th ng-repeat=\"year in vm.years\">{{year}}</th>\n        </thead>\n        <tbody>\n            <tr ng-repeat=\"item in vm.tonsData\">\n                <th class=\"tons-header\">{{item.monthName}}</th>\n                <td ng-repeat=\"entry in item.displayData track by $index\">\n                    {{entry}}\n                </td>\n            </tr>\n            <tr>\n                <th>Year Totals</th>\n                <td ng-repeat=\"entry in vm.totals track by $index\">\n                    {{entry}}\n                </td>\n            </tr>\n        </tbody>\n    </table>\n    <h3 class=\"text-center\">Progress</h3>\n    <table class=\"table table-fixed table-striped tickets-table ng-table\">\n        <thead>\n            <tr>\n                    <th>{{vm.currentYear}} Progress</th>\n                    <td>{{vm.currentScore}}</td>\n                    <td style=\"width: 55%\">\n                            <div class=\"progress\">\n                                <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"vm.barStyle\">\n                                    <span class=\"bar-text\">{{vm.currentScore}}</span>\n                                </div>\n                            </div>\n                    </td>\n                    <td class=\"text-center\"><b>{{vm.highScore}}</b></td>\n                    <th>7 years high <span class=\"glyphicon glyphicon-star\" ng-show=\"vm.scoreBeaten\"></span></th>\n            </tr>\n        </thead>\n        <tbody>\n                <tr ng-repeat=\"item in vm.tonsMonthlyProgressData\">\n                    <th class=\"tons-header\">{{item.currentDate}}</th>\n                    <td>{{item.currentScore}}</td>\n                    <td style=\"width: 55%\">\n                            <div class=\"progress\">\n                                <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"item.barStyle\">\n                                    <span class=\"bar-text\">{{item.currentScore}}</span>\n                                </div>\n                            </div>\n                    </td>\n                    <td class=\"text-center\">{{item.highScore}}</td>\n                    <td>{{item.date}} <span class=\"glyphicon glyphicon-star\" ng-show=\"item.scoreBeaten\"></span></td>\n                </tr>\n        </tbody>\n    </table>\n    <h3 class=\"text-center\">Chart</h3>\n    <canvas tc-chartjs chart-type=\"bar\" chart-data=\"vm.chartData\"></canvas>\n</div>\n    <h2 ng-show=\"vm.loading\">Loading...</h3>\n</div>\n"

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TonsDashboardMainCtrl = exports.TonsDashboardMainCtrl = ["CompanyStore", "$state", function TonsDashboardMainCtrl(CompanyStore, $state) {
	    "ngInject";
	
	    var _this = this;
	
	    _classCallCheck(this, TonsDashboardMainCtrl);
	
	    this.store = CompanyStore;
	    this.store.init();
	    this.store.refresh().then(function () {
	        if ($state.current.name === 'r.in.top.tonsDashboard') {
	            $state.go('r.in.top.tonsDashboard.plant', {
	                companyId: _this.store.list[0].id
	            });
	        }
	    });
	}];
	
	var TonsDashboardPlantCtrl = exports.TonsDashboardPlantCtrl = function () {
	    TonsDashboardPlantCtrl.$inject = ["R", "$stateParams"];
	    function TonsDashboardPlantCtrl(R, $stateParams) {
	        "ngInject";
	
	        _classCallCheck(this, TonsDashboardPlantCtrl);
	
	        this.companyId = $stateParams.companyId;
	        this.R = R;
	        this.years = [];
	        for (var i = 0; i < 7; i++) {
	            this.years.push(String(new Date().getFullYear() - 6 + i));
	        }
	        this.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	        this.tonsData = [];
	        this.tonsMonthlyProgressData = [];
	        this.totals = new Array(7);
	        this.currentYear = new Date().getFullYear();
	        this.currentScore = null;
	        this.highScore = null;
	        this.scoreBeaten = false;
	        this.chartData = {};
	        this.fetchTons();
	    }
	
	    _createClass(TonsDashboardPlantCtrl, [{
	        key: 'processTons',
	        value: function processTons(value) {
	            var yearDict = {};
	            var yearTotalsDict = {};
	            var monthlyRecordsDict = {};
	            var bestYearScore = 0;
	
	            for (var year in this.years) {
	                yearTotalsDict[this.years[year]] = 0;
	            }
	            for (var key in value) {
	                if (!value[key] || !value[key].year) {
	                    continue;
	                }
	                var _year = value[key].year;
	                var month = value[key].month - 1;
	                if (!yearDict[_year]) {
	                    yearDict[_year] = new Array(12);
	                }
	                yearDict[_year][month] = value[key].quantity;
	                yearTotalsDict[_year] += value[key].quantity;
	                if (!monthlyRecordsDict[month] || value[key].quantity > monthlyRecordsDict[month].value) {
	                    monthlyRecordsDict[month] = {
	                        value: value[key].quantity,
	                        year: _year
	                    };
	                }
	                if (!monthlyRecordsDict[month].all) {
	                    monthlyRecordsDict[month].all = new Array(7);
	                    monthlyRecordsDict[month].all.fill(0);
	                }
	                var yearId = _year - (new Date().getFullYear() - 6);
	                monthlyRecordsDict[month].all[yearId] = value[key].quantity;
	                if (yearTotalsDict[_year] > bestYearScore) {
	                    bestYearScore = yearTotalsDict[_year];
	                }
	            }
	
	            for (var i = 0; i < 12; i++) {
	                if (!monthlyRecordsDict[i]) {
	                    var placeholder = {
	                        value: 0,
	                        year: this.currentYear,
	                        all: new Array(7).fill(0)
	                    };
	                    Object.assign(monthlyRecordsDict, _defineProperty({}, i, placeholder));
	                }
	            }
	
	            var averages = [];
	
	            for (var _month in monthlyRecordsDict) {
	                var values = monthlyRecordsDict[_month].all.slice(0, 6);
	                var averageFunc = function averageFunc(array) {
	                    return array.reduce(function (a, b) {
	                        return a + b;
	                    }) / array.length;
	                };
	                averages.push(Math.floor(averageFunc(values)));
	            }
	
	            var tonsData = [];
	
	            for (var _i = 0; _i < 12; _i++) {
	                for (var _year2 in yearDict) {
	                    if (!tonsData[_i]) {
	                        tonsData[_i] = {
	                            data: new Array(7).fill(0),
	                            displayData: new Array(7).fill(0),
	                            monthName: this.months[_i]
	                        };
	                    }
	                    var _yearId = _year2 - (new Date().getFullYear() - 6);
	                    tonsData[_i].data[_yearId] = yearDict[_year2][_i] || 0;
	                    tonsData[_i].displayData[_yearId] = Math.floor(yearDict[_year2][_i] || 0);
	                }
	            }
	
	            var tonsMonthlyProgressData = [];
	            for (var _i2 = 0; _i2 < 12; _i2++) {
	                var currentScore = tonsData[_i2].data[6];
	                var highScore = monthlyRecordsDict[_i2].value;
	                tonsMonthlyProgressData[_i2] = {
	                    currentScore: Math.floor(currentScore),
	                    highScore: Math.floor(highScore),
	                    date: this.months[_i2] + ' ' + monthlyRecordsDict[_i2].year,
	                    currentDate: this.months[_i2] + ' ' + new Date().getFullYear(),
	                    scoreBeaten: currentScore >= highScore
	                };
	                tonsMonthlyProgressData[_i2].barStyle = {
	                    width: Math.floor(Math.min(currentScore * 100 / highScore, 100)) + '%'
	                };
	            }
	            var thisYear = [];
	            for (var _month2 in tonsData) {
	                thisYear.push(Math.floor(tonsData[_month2].data[6]));
	            }
	            this.tonsMonthlyProgressData = tonsMonthlyProgressData;
	            this.tonsData = tonsData;
	            this.totals = Object.keys(yearTotalsDict).map(function (key) {
	                return Math.floor(yearTotalsDict[key]);
	            });
	            this.currentScore = Math.floor(yearTotalsDict[new Date().getFullYear()]);
	            this.highScore = Math.floor(bestYearScore);
	            if (this.currentScore >= this.highScore) {
	                this.scoreBeaten = true;
	            }
	            this.barStyle = {
	                width: Math.floor(Math.min(this.currentScore * 100 / this.highScore, 100)) + '%'
	            };
	            this.chartData = {
	                // Chart.js data structure goes here
	                // e.g. Pie Chart Data Structure http://www.chartjs.org/docs/#doughnut-pie-chart-data-structure
	                labels: this.months,
	                datasets: [{
	                    data: averages,
	                    backgroundColor: ["#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3", "#6FB6F3"],
	                    label: 'Past 6 years average'
	                }, {
	                    data: thisYear,
	                    backgroundColor: ["#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F", "#F2AC6F"],
	                    label: this.currentYear
	                }]
	            };
	        }
	    }, {
	        key: 'fetchTons',
	        value: function fetchTons() {
	            var _this2 = this;
	
	            var params = {
	                company: this.companyId
	            };
	            var tons = this.R.all('tons').customGET('', params);
	            tons.then(function (value) {
	                return _this2.processTons(value);
	            });
	        }
	    }]);
	
	    return TonsDashboardPlantCtrl;
	}();

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = "<ol class=\"breadcrumb\">\n    <li ng-repeat=\"step in steps\" ng-class=\"{active: $last}\" ng-switch=\"$last\">\n        <a ng-switch-when=\"false\" href=\"{{step.ncyBreadcrumbLink}}\">{{step.ncyBreadcrumbLabel}}</a>\n        <span ng-switch-when=\"true\">{{step.ncyBreadcrumbLabel}}</span>\n    </li>\n</ol>\n"

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	// Admin Control Apps
	
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(727);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _routing3 = __webpack_require__(741);
	
	var _routing4 = _interopRequireDefault(_routing3);
	
	var _routing5 = __webpack_require__(756);
	
	var _routing6 = _interopRequireDefault(_routing5);
	
	var _routing7 = __webpack_require__(770);
	
	var _routing8 = _interopRequireDefault(_routing7);
	
	var _routing9 = __webpack_require__(786);
	
	var _routing10 = _interopRequireDefault(_routing9);
	
	var _routing11 = __webpack_require__(788);
	
	var _routing12 = _interopRequireDefault(_routing11);
	
	var _routing13 = __webpack_require__(792);
	
	var _routing14 = _interopRequireDefault(_routing13);
	
	var _routing15 = __webpack_require__(801);
	
	var _routing16 = _interopRequireDefault(_routing15);
	
	var _routing17 = __webpack_require__(812);
	
	var _routing18 = _interopRequireDefault(_routing17);
	
	var _routing19 = __webpack_require__(822);
	
	var _routing20 = _interopRequireDefault(_routing19);
	
	var _company = __webpack_require__(583);
	
	var _company2 = _interopRequireDefault(_company);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	  name: "app.admin.routing",
	  modules: [_routing2.default, _routing4.default, _routing6.default, _routing8.default, _company2.default, _routing12.default, _routing14.default, _routing16.default, _routing18.default, _routing20.default]
	}), _dec2 = (0, _decorators.State)({
	  name: "r.in.top.admin",
	  url: "/admin",
	  template: "<div ui-view></div>",
	  abstract: ".home",
	  data: {
	    permissions: {
	      only: ["main.can_view_admin_panel"]
	    }
	  },
	  ncyBreadcrumb: {
	    label: "Admin",
	    parent: "r.in.top"
	  }
	}), _dec(_class = _dec2(_class = function States() {
	  _classCallCheck(this, States);
	}) || _class) || _class);
	exports.default = States;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _state = __webpack_require__(728);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _tanks = __webpack_require__(730);
	
	var _tanks2 = _interopRequireDefault(_tanks);
	
	var _mapping = __webpack_require__(732);
	
	var _mapping2 = _interopRequireDefault(_mapping);
	
	var _ctrls = __webpack_require__(734);
	
	var _main = __webpack_require__(739);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _mainPlants = __webpack_require__(740);
	
	var _mainPlants2 = _interopRequireDefault(_mainPlants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.admin.home',
	    modules: [_routing2.default, _state2.default, _tanks2.default, _mapping2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.admin.home',
	    url: '',
	    controller: _ctrls.HomeCtrl,
	    template: _main2.default,
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company',
	    url: '/{companyId:int}',
	    template: '<div ui-view></div>',
	    resolve: {
	        $company: function $company($stateParams, CompanyStore) {
	            return CompanyStore.get($stateParams.companyId);
	        }
	    },
	    controller: ["$company", function controller($company) {
	        "ngInject";
	
	        this.company = $company;
	    }],
	    ncyBreadcrumb: {
	        label: '{{ vm.company.name }}',
	        parent: 'r.in.top.admin'
	    },
	    data: {
	        permissions: {
	            only: ['main.view_company']
	        }
	    },
	    abstract: '.detail'
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.detail',
	    url: '',
	    controller: _ctrls.CompanyHomeCtrl,
	    template: _mainPlants2.default,
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _statePicker = __webpack_require__(729);
	
	var _statePicker2 = _interopRequireDefault(_statePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.state.component"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-state-picker',
	    template: _statePicker2.default,
	    bindings: {
	        ngModel: '=',
	        mode: '@',
	        inputClass: '@'
	    }
	}), _dec(_class = _dec2(_class = ["Config", function C(Config) {
	    "ngInject";
	
	    _classCallCheck(this, C);
	
	    this.states = Config.$config.states;
	}]) || _class) || _class);
	exports.default = C;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = "<span ng-bind=\"$ctrl.ngModel\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control\" ng-class=\"$ctrl.inputClass\" ng-model=\"$ctrl.ngModel\" ng-options=\"opt for opt in $ctrl.states\" ng-if=\"$ctrl.mode === 'edit'\"></select>\n"

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _tanksPicker = __webpack_require__(731);
	
	var _tanksPicker2 = _interopRequireDefault(_tanksPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.tanks.picker"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-tanks',
	    bindings: {
	        ngModel: '=',
	        mode: '@?'
	    },
	    template: _tanksPicker2.default
	}), _dec(_class = _dec2(_class = function C() {
	    _classCallCheck(this, C);
	
	    this.mode = this.mode || 'view';
	}) || _class) || _class);
	exports.default = C;

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\" ng-if=\"$ctrl.mode === 'edit'\">\n    <ui-select multiple tagging tagging-label=\"false\" ng-model=\"$ctrl.ngModel\" theme=\"bootstrap\" sortable=\"true\">\n        <ui-select-match placeholder=\"Type to add more tanks\">{{$item}}</ui-select-match>\n        <ui-select-choices repeat=\"dummy in []\">{{dummy}}</ui-select-choices>\n    </ui-select>\n</div>\n<div>\n\n<div ng-if=\"$ctrl.mode === 'view'\">\n    <span ng-repeat=\"t in $ctrl.ngModel\">{{t}}{{{true: '', false: ', '}[$last]}}</span>\n</div>\n"

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mappingComponent = __webpack_require__(733);
	
	var _mappingComponent2 = _interopRequireDefault(_mappingComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.mapping.component"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-mapping-component',
	    bindings: {
	        ngModel: '=',
	        mode: '@?'
	    },
	    template: _mappingComponent2.default
	}), _dec(_class = _dec2(_class = function () {
	    function C() {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var self = this;
	
	        self.mode = self.mode || 'view';
	    }
	
	    _createClass(C, [{
	        key: 'add',
	        value: function add() {
	            this.ngModel.push({});
	        }
	    }, {
	        key: 'remove',
	        value: function remove(item) {
	            var index = this.ngModel.indexOf(item);
	            this.ngModel.splice(index, 1);
	        }
	    }, {
	        key: 'onPress',
	        value: function onPress(event, isLast) {
	            if (event.which === 9 && isLast) {
	                this.add();
	            }
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-striped\" ng-if=\"$ctrl.mode === 'view'\">\n    <thead>\n        <th>Label</th>\n        <th>Value</th>\n    </thead>\n    <tbody>\n        <tr ng-if=\"$ctrl.ngModel.length >= 1\"\n            ng-repeat=\"row in $ctrl.ngModel track by $index\">\n            <td ng-bind=\"row.key\"></td>\n            <td ng-bind=\"row.value\"></td>\n        </tr>\n        <tr ng-if=\"$ctrl.ngModel.length === 0\">\n            <td colspan=\"2\">No entries.</td>\n        </tr>\n    </tbody>\n</table>\n<table class=\"table table-striped product-max-rate-table\" ng-if=\"$ctrl.mode === 'edit'\">\n    <thead>\n        <tr>\n            <th></th>\n            <th>Label</th>\n            <th>Value</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat=\"item in $ctrl.ngModel track by $index\">\n            <td>\n                <i class=\"fa fa-times clickable\" ng-click=\"$ctrl.remove(item)\"></i>\n            </td>\n            <td class=\"\">\n                <input type=\"text\"\n                       class=\"form-control input-sm\"\n                       ng-model=\"item.key\"\n                       form-error=\"$ctrl.errors[{{$index}}].key\">\n            </td>\n            <td class=\"max-rate-input\">\n                <input type=\"number\"\n                       class=\"form-control input-sm\"\n                       ng-model=\"item.value\"\n                       step=\"0.01\"\n                       ng-keypress=\"$ctrl.onPress($event, $last)\"\n                       ng-keydown=\"$ctrl.onPress($event, $last)\"\n                       form-error=\"$ctrl.errors[{{$index}}].value\">\n            </td>\n        </tr>\n        <tr>\n            <td><i class=\"fa fa-plus clickable\" ng-click=\"$ctrl.add()\"></i></td>\n            <td></td>\n            <td></td>\n        </tr>\n    </tbody>\n</table>\n"

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompanyHomeCtrl = exports.HomeCtrl = exports.DefaultCompanyCtrl = exports.DefaultDeliveryCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ctrls = __webpack_require__(735);
	
	var _ctrls2 = _interopRequireDefault(_ctrls);
	
	var _modal = __webpack_require__(736);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _default_delivery = __webpack_require__(737);
	
	var _default_delivery2 = _interopRequireDefault(_default_delivery);
	
	var _default_company = __webpack_require__(738);
	
	var _default_company2 = _interopRequireDefault(_default_company);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DefaultDeliveryCtrl = exports.DefaultDeliveryCtrl = function () {
	  DefaultDeliveryCtrl.$inject = ["$growl", "R", "$uibModalInstance", "deliveryOptions", "$user"];
	  function DefaultDeliveryCtrl($growl, R, $uibModalInstance, deliveryOptions, $user) {
	    "ngInject";
	
	    var _this = this;
	
	    _classCallCheck(this, DefaultDeliveryCtrl);
	
	    this.R = R;
	    this.$growl = $growl;
	    this.$modal = $uibModalInstance;
	    this.deliveryOptions = deliveryOptions;
	    this.user = _angular2.default.copy($user);
	    this.currentDefaultDelivery = this.deliveryOptions.find(function (x) {
	      return x.value === _this.user.default_delivery;
	    });
	    if (this.currentDefaultDelivery) {
	      this.currentDefaultDeliveryLabel = this.currentDefaultDelivery.label;
	    }
	  }
	
	  _createClass(DefaultDeliveryCtrl, [{
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var _this2 = this;
	
	      this.loading = true;
	      this.user.patch({ default_delivery: this.user.default_delivery.value }).then(function (response) {
	        _angular2.default.extend(_this2.user, response);
	        _this2.$growl.success("Status Changed!");
	        _this2.$modal.close();
	        window.location.reload();
	      }, function (response) {
	        if (response.status === 500) {
	          _this2.$growl.error(response.data.detail);
	        }
	      }).finally(function () {
	        return _this2.loading = false;
	      });
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Choose default delivery option";
	    }
	  }]);
	
	  return DefaultDeliveryCtrl;
	}();
	
	var DefaultCompanyCtrl = exports.DefaultCompanyCtrl = function () {
	  DefaultCompanyCtrl.$inject = ["$growl", "R", "$uibModalInstance", "companyOptions", "$user"];
	  function DefaultCompanyCtrl($growl, R, $uibModalInstance, companyOptions, $user) {
	    "ngInject";
	
	    var _this3 = this;
	
	    _classCallCheck(this, DefaultCompanyCtrl);
	
	    this.R = R;
	    this.$growl = $growl;
	    this.$modal = $uibModalInstance;
	    this.companyOptions = companyOptions;
	    this.user = _angular2.default.copy($user);
	    this.currentDefaultCompany = this.companyOptions.find(function (x) {
	      return x.value === _this3.user.default_company;
	    });
	    if (this.currentDefaultCompany) {
	      this.currentDefaultCompanyLabel = this.currentDefaultCompany.label;
	    }
	  }
	
	  _createClass(DefaultCompanyCtrl, [{
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var _this4 = this;
	
	      this.loading = true;
	      this.user.patch({ default_company: this.user.default_company.value }).then(function (response) {
	        _angular2.default.extend(_this4.user, response);
	        _this4.$growl.success("Status Changed!");
	        _this4.$modal.close();
	        window.location.reload();
	      }, function (response) {
	        if (response.status === 500) {
	          _this4.$growl.error(response.data.detail);
	        }
	      }).finally(function () {
	        return _this4.loading = false;
	      });
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Choose default company option";
	    }
	  }]);
	
	  return DefaultCompanyCtrl;
	}();
	
	var HomeCtrl = exports.HomeCtrl = function () {
	  HomeCtrl.$inject = ["CompanyStore", "Modal", "R", "$growl", "UserService"];
	  function HomeCtrl(CompanyStore, Modal, R, $growl, UserService) {
	    "ngInject";
	
	    _classCallCheck(this, HomeCtrl);
	
	    this.$user = UserService.$user;
	    this.store = CompanyStore;
	    this.store.init();
	    this.store.refresh();
	    this.Modal = Modal;
	    this.R = R;
	    this.$growl = $growl;
	  }
	
	  _createClass(HomeCtrl, [{
	    key: "syncAS400",
	    value: function syncAS400() {
	      var self = this;
	      var $modal = self.Modal.openConfirm({
	        confirmName: "Yes",
	        text: "Are you sure ?"
	      });
	      $modal.wait.then(function (result) {
	        self.R.all("sync_as400").customPOST({}).then(function () {
	          self.$growl.success("Syncing started.");
	          result.close();
	        }, function () {
	          self.$growl.error("Syncing already in progress.");
	          result.close();
	        });
	      });
	    }
	  }, {
	    key: "chooseDefaultDelivery",
	    value: function chooseDefaultDelivery() {
	      var _this5 = this;
	
	      this.deliveryOptions = [{ value: null, label: "No default delivery option" }, { value: "haul", label: "Haul" }, { value: "apply_haul", label: "Apply & Haul" }, { value: "pickup", label: "Pick-Up" }];
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _default_delivery2.default,
	        controller: DefaultDeliveryCtrl,
	        size: "small",
	        resolve: {
	          deliveryOptions: function deliveryOptions() {
	            return _this5.deliveryOptions;
	          },
	          $user: function $user() {
	            return _this5.$user;
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        self.$growl.updated();
	      });
	    }
	  }, {
	    key: "chooseDefaultCompany",
	    value: function chooseDefaultCompany() {
	      var _this6 = this;
	
	      this.companyOptions = [{ value: null, label: "No default company" }];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.$user.companies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var company = _step.value;
	
	          this.companyOptions.push({ value: company.id, label: company.name });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _default_company2.default,
	        controller: DefaultCompanyCtrl,
	        size: "small",
	        resolve: {
	          companyOptions: function companyOptions() {
	            return _this6.companyOptions;
	          },
	          $user: function $user() {
	            return _this6.$user;
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        self.$growl.updated();
	      });
	    }
	  }]);
	
	  return HomeCtrl;
	}();
	
	var CompanyHomeCtrl = exports.CompanyHomeCtrl = function () {
	  CompanyHomeCtrl.$inject = ["$growl", "Modal", "$company"];
	  function CompanyHomeCtrl($growl, Modal, $company) {
	    "ngInject";
	
	    _classCallCheck(this, CompanyHomeCtrl);
	
	    this.$growl = $growl;
	    this.Modal = Modal;
	    this.company = $company;
	  }
	
	  _createClass(CompanyHomeCtrl, [{
	    key: "openModal",
	    value: function openModal() {
	      var _this7 = this;
	
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _modal2.default,
	        controller: _ctrls2.default,
	        size: "small",
	        resolve: {
	          company: function company() {
	            return _this7.company;
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        self.$growl.updated();
	      });
	    }
	  }]);
	
	  return CompanyHomeCtrl;
	}();

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _files = __webpack_require__(522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlantFileUpload = function (_BaseFileUpload) {
	    _inherits(PlantFileUpload, _BaseFileUpload);
	
	    function PlantFileUpload($cookies, TokenService, Upload, Company) {
	        _classCallCheck(this, PlantFileUpload);
	
	        var _this = _possibleConstructorReturn(this, (PlantFileUpload.__proto__ || Object.getPrototypeOf(PlantFileUpload)).call(this, $cookies, TokenService, Upload));
	
	        _this.company = Company;
	        return _this;
	    }
	
	    _createClass(PlantFileUpload, [{
	        key: 'uploadFile',
	        value: function uploadFile(file) {
	            if (!file) {
	                return;
	            }
	            var uri = this.company.getRequestedUrl();
	            var data = {
	                signature: file
	            };
	            return _get(PlantFileUpload.prototype.__proto__ || Object.getPrototypeOf(PlantFileUpload.prototype), 'uploadFile', this).call(this, uri, data, file.type, 'patch');
	        }
	    }]);
	
	    return PlantFileUpload;
	}(_files.BaseFileUpload);
	
	var EditPlantCtrl = function () {
	    EditPlantCtrl.$inject = ["$uibModalInstance", "$cookies", "TokenService", "R", "company", "Upload"];
	    function EditPlantCtrl($uibModalInstance, $cookies, TokenService, R, company, Upload) {
	        "ngInject";
	
	        _classCallCheck(this, EditPlantCtrl);
	
	        this.R = R;
	        this.data = this.R.copy(company);
	        this.company = company;
	        this.$modal = $uibModalInstance;
	        this.data.mapping = [];
	        this.fileUpload = new PlantFileUpload($cookies, TokenService, Upload, company);
	    }
	
	    _createClass(EditPlantCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'upload',
	        value: function upload(file) {
	            var self = this;
	            this.fileUpload.uploadFile(file, { signature: file }).then(function (response) {
	                _angular2.default.extend(self.company, response.data);
	            });
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            // Always delete signature form PUT request
	            delete this.data.signature;
	            this.data.put().then(function (data) {
	                _angular2.default.extend(self.company, data);
	                self.$modal.close(data);
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Edit plant';
	        }
	    }]);
	
	    return EditPlantCtrl;
	}();
	
	exports.default = EditPlantCtrl;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-sm-12\">\n                <div class=\"form-group\">\n                    <label>Company Name</label>\n                    <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.data.name\" form-error>\n                </div>\n                <div class=\"form-group\">\n                    <label>Company Legal Name</label>\n                    <input type=\"text\" class=\"form-control\" name=\"legal_name\" ng-model=\"vm.data.legal_name\" form-error>\n                </div>\n                <div class=\"form-group\">\n                    <label>E-mail Address</label>\n                    <input type=\"text\" class=\"form-control\" name=\"email\" ng-model=\"vm.data.email\" form-error>\n                </div>\n                <div class=\"form-group company-address\">\n                    <label>Company Address</label>\n                    <input type=\"text\" class=\"form-control\" name=\"legal_name\" ng-model=\"vm.data.address.line1\" placeholder=\"Line1\" form-error>\n                    <input type=\"text\" class=\"form-control\" name=\"legal_name\" ng-model=\"vm.data.address.line2\" placeholder=\"Line2\" form-error>\n                    <input type=\"text\" class=\"form-control\" name=\"legal_name\" ng-model=\"vm.data.address.city\" placeholder=\"City\" form-error>\n                    <div class=\"row\">\n                        <div class=\"col-md-6\">\n                            <blnd-state-picker ng-model=\"vm.data.address.state\" mode=\"edit\"></blnd-state-picker>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <input type=\"text\" class=\"form-control\" name=\"legal_name\" ng-model=\"vm.data.address.zipcode\" placeholder=\"ZipCode\" form-error>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label>Phone Number</label>\n                    <input type=\"text\" class=\"form-control\" name=\"phone_number\" ng-model=\"vm.data.address.phone_number\" form-error>\n                </div>\n                <div class=\"form-group signature\">\n                    <label>Signature</label>\n                    <div>\n                        <img ng-show=\"vm.company.signature\" ng-src=\"{{ vm.company.signature }}\" alt=\"Plant Operator Signature\">\n                        <input type=\"file\" ngf-select=\"vm.upload($file)\" ng-model=\"vm.data.signature\" name=\"file\" ngf-accept=\"'image/*'\">\n                        <p class=\"help-block\">Uploading a new signature overwrite old one!</p>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <label>Max Blender Size</label>\n                        <input type=\"number\" class=\"form-control\" name=\"max_blender_size\" ng-model=\"vm.data.max_blender_size\" form-error>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>Water Flush</label>\n                        <input type=\"number\" class=\"form-control\" name=\"water_flush\" ng-model=\"vm.data.water_flush\" form-error>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>Custom delay</label>\n                        <input type=\"number\" class=\"form-control\" name=\"water_flush\" ng-model=\"vm.data.custom_delay\" form-error>\n                        <p class=\"help-block\">Leave empty field to disable</p>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <label class=\"control-label\">Allow Reduce Water</label>\n                        <input class=\"form-control\" type=\"checkbox\" name=\"allow_reduce_water\" ng-model=\"vm.data.allow_reduce_water\" form-error>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label>Load out tanks</label>\n                    <blnd-mapping-component ng-model=\"vm.data.fert_tanks\" mode=\"edit\"></blnd-mapping-component>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Chem Banks & tanks</label>\n                    <blnd-mapping-component ng-model=\"vm.data.chem_tanks\" mode=\"edit\"></blnd-mapping-component>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <label>Fert Preset Tag</label>\n                        <input type=\"text\" class=\"form-control\" name=\"fert_write_tag\" ng-model=\"vm.data.murray_settings.fert_write_tag\">\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>Fert Batch Preset</label>\n                        <input type=\"text\" class=\"form-control\" name=\"fert_batch_code\" ng-model=\"vm.data.murray_settings.fert_batch_code\">\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>Fert Tank Preset</label>\n                        <input type=\"text\" class=\"form-control\" name=\"fert_output_tank_code\" ng-model=\"vm.data.murray_settings.fert_output_tank_code\">\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <label>Chem Preset Tag</label>\n                        <input type=\"text\" class=\"form-control\" name=\"chem_write_tag\" ng-model=\"vm.data.murray_settings.chem_write_tag\">\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>Chem Batch Preset</label>\n                        <input type=\"text\" class=\"form-control\" name=\"chem_batch_code\" ng-model=\"vm.data.murray_settings.chem_batch_code\">\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>Chem Output Preset</label>\n                        <input type=\"text\" class=\"form-control\" name=\"chem_output_tank_code\" ng-model=\"vm.data.murray_settings.chem_output_tank_code\">\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-4\">\n                        <label>Delay Preset</label>\n                        <input type=\"text\" class=\"form-control\" name=\"chem_write_tag\" ng-model=\"vm.data.murray_settings.delay_code\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label>Current default delivery option:</label>\n                    <h4 class=\"modal-title\" ng-bind=\"vm.currentDefaultDeliveryLabel\"></h4><br>\n                    <span class=\"modal-title\">Change default delivery option to:</span>\n                    <select ng-model=\"vm.user.default_delivery\" class=\"form-control\"\n                        ng-options=\"opt as opt.label for opt in vm.deliveryOptions\">\n                        <option style=\"display:none\" value=\"\">Select a default delivery option</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label>Current default company option:</label>\n                    <h4 class=\"modal-title\" ng-bind=\"vm.currentDefaultCompanyLabel\"></h4><br>\n                    <span class=\"modal-title\">Change default company option to:</span>\n                    <select ng-model=\"vm.user.default_company\" class=\"form-control\"\n                        ng-options=\"opt as opt.label for opt in vm.companyOptions\">\n                        <option style=\"display:none\" value=\"\">Select a default company</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"admin-homepage\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div class=\"panel panel-default\">\n                <div class=\"panel-heading\">\n                    <h3 class=\"panel-title\">Global Configuration</h3>\n                </div>\n                <div class=\"panel-body\">\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"list-group\">\n                                <a ui-sref=\"r.in.top.admin.users\" permission permission-sref=\"'r.in.top.admin.users'\"\n                                    class=\"list-group-item\">Users</a>\n                                <a ui-sref=\"r.in.top.admin.products\" permission\n                                    permission-sref=\"'r.in.top.admin.products'\" class=\"list-group-item\">Products</a>\n                                <a ui-sref=\"r.in.top.admin.printers\" permission\n                                    permission-sref=\"'r.in.top.admin.printers'\" class=\"list-group-item\">Printers</a>\n                                <a ng-click=\"vm.chooseDefaultDelivery()\" class=\"list-group-item default-delivery-picker\">Default delivery</a>\n                                <a ng-click=\"vm.chooseDefaultCompany()\" class=\"list-group-item default-delivery-picker\">Default company</a>\n                                <a ui-sref=\"r.in.top.admin.mix_calculator\" permission\n                                    permission-sref=\"'r.in.top.admin.mix_calculator'\" class=\"list-group-item\">Mix Calculator</a>\n                                    <!-- Feature hit-percentage hidden, uncomment to enable -->\n                                <!-- <a ui-sref=\"r.in.top.admin.hit_percentages\" permission\n                                    permission-sref=\"'r.in.top.admin.printers'\" class=\"list-group-item\">Hit percentages\n                                    for Forecasting</a> -->\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <button class=\"btn btn-danger\" ng-click=\"vm.syncAS400()\" permission\n                                permission-only=\"'main.can_trigger_as400_sync'\">Sync from AS400</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-6\" permission permission-sref=\"'r.in.top.admin.company'\">\n            <div class=\"panel panel-default\">\n                <div class=\"panel-heading\">\n                    <h3 class=\"panel-title\">Plants</h3>\n                </div>\n                <div class=\"panel-body\">\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"list-group plant-list\">\n                                <a ui-sref=\"r.in.top.admin.company({companyId: company.id})\" class=\"list-group-item\"\n                                    ng-repeat=\"company in vm.store.list\">\n                                    <blnd-company-picker ng-model=\"company\"></blnd-company-picker>\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"admin-homepage\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div class=\"panel panel-default\">\n                <div class=\"panel-body\">\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"top-right-corner\" permission permission-only=\"'main.change_company'\">\n                                <button class=\"btn btn btn-edit\" ng-click=\"vm.openModal()\">Edit</button>\n                            </div>\n                            <h3>Plant Configuration</h3>\n                            <div class=\"plant-configuration\">\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Company name\n                                    </div>\n                                    <div class=\"display-value form-control-static col-md-6\" ng-bind=\"vm.company.name\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        E-mail Address\n                                    </div>\n                                    <div class=\"display-value form-control-static col-md-6\" ng-bind=\"vm.company.email\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Company Address\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\">\n                                        <span class=\"address-line\" ng-bind=\"vm.company.address.line1\"></span>\n                                        <span class=\"address-line\" ng-bind=\"vm.company.address.line2\"></span>\n                                        <span class=\"address-line\" ng-bind=\"vm.company.address.city\"></span>\n                                        <span>\n                                            <span ng-bind=\"vm.company.address.state\"></span>\n                                            <span ng-bind=\"vm.company.address.zipcode\"></span>\n                                        </span>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Company Phone\n                                    </div>\n                                    <div class=\"display-value form-control-static col-md-6\" ng-bind=\"vm.company.address.phone_number\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Legal Name\n                                    </div>\n                                    <div class=\"display-value form-control-static col-md-6\" ng-bind=\"vm.company.legal_name\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Signature\n                                    </div>\n                                    <div class=\"display-value form-control-static col-md-6 signature\">\n                                        <img ng-if=\"vm.company.signature\" ng-src=\"{{ vm.company.signature }}\" alt=\"Plant Operator Signature\">\n                                        <span ng-if=\"!vm.company.signature\">Please upload signature</span>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-12\">\n                                        <h4>Load Out Tanks</h4>\n                                        <blnd-mapping-component ng-model=\"vm.company.fert_tanks\" mode=\"view\"></blnd-mapping-component>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Max Blender Size\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\" ng-bind=\"vm.company.max_blender_size\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Water Flush\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\">{{ vm.company.water_flush }}</div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Custom Delay\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\">{{ vm.company.custom_delay || '-' }}</div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-12\">\n                                        <h4>Chem Tanks / Load out</h4>\n                                        <blnd-mapping-component ng-model=\"vm.company.chem_tanks\" mode=\"view\"></blnd-mapping-component>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-md-12\">\n                                        <h4>Murray</h4>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Fertilizer Presets Write Tag\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\" ng-bind=\"vm.company.murray_settings.fert_write_tag\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Fertilizer Batch Preset Code\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\" ng-bind=\"vm.company.murray_settings.fert_batch_code\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Fertilizer Output Tank Code\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\" ng-bind=\"vm.company.murray_settings.fert_output_tank_code\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Chemical Write Tag\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\" ng-bind=\"vm.company.murray_settings.chem_write_tag\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Chemical Batch Preset Code\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\" ng-bind=\"vm.company.murray_settings.chem_batch_code\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Chemical Output Bank Code\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\" ng-bind=\"vm.company.murray_settings.chem_output_tank_code\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Delay Preset Code\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\" ng-bind=\"vm.company.murray_settings.delay_code || '-'\"></div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"display-label col-md-6\">\n                                        Allow Reduce Water\n                                    </div>\n                                    <div class=\"display-value col-md-6 form-control-static\">{{ vm.company.allow_reduce_water && 'Yes' || 'No' }}</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-6\">\n            <div class=\"row\" permission permission-sref=\"'r.in.top.admin.company.productconf.list'\">\n                <div class=\"col-md-12\">\n                    <div class=\"panel panel-default\">\n                        <div class=\"panel-body\">\n                            <div class=\"description\">\n                                <div class=\"pull-left\"><a ui-sref=\"r.in.top.admin.company.productconf.list\">Product Configurations</a></div>\n                                <div class=\"description-stats pull-right\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" permission permission-sref=\"'r.in.top.admin.company.chemicals'\">\n                <div class=\"col-md-12\">\n                    <div class=\"panel panel-default\">\n                        <div class=\"panel-body\">\n                            <div class=\"description\">\n                                <div class=\"pull-left\"><a ui-sref=\"r.in.top.admin.company.chemicals.list\">Chemical Programs</a></div>\n                                <div class=\"description-stats pull-right\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\" permission permission-sref=\"'r.in.top.admin.company.inventory.list'\">\n                <div class=\"col-md-12\">\n                    <div class=\"panel panel-default\">\n                        <div class=\"panel-body\">\n                            <div class=\"description\">\n                                <div class=\"pull-left\"><a ui-sref=\"r.in.top.admin.company.inventory.list\">Inventory</a></div>\n                                <div class=\"description-stats pull-right\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _companies = __webpack_require__(742);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _blndUnits = __webpack_require__(744);
	
	var _blndUnits2 = _interopRequireDefault(_blndUnits);
	
	var _maxRates = __webpack_require__(746);
	
	var _maxRates2 = _interopRequireDefault(_maxRates);
	
	var _active = __webpack_require__(748);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _activity = __webpack_require__(618);
	
	var _activity2 = _interopRequireDefault(_activity);
	
	var _ctrls = __webpack_require__(749);
	
	var _main = __webpack_require__(751);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _details = __webpack_require__(752);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _logs = __webpack_require__(753);
	
	var _logs2 = _interopRequireDefault(_logs);
	
	var _tableSection = __webpack_require__(754);
	
	var _tableSection2 = _interopRequireDefault(_tableSection);
	
	var _detailSection = __webpack_require__(755);
	
	var _detailSection2 = _interopRequireDefault(_detailSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.admin.products',
	    modules: [_routing2.default, _blndUnits2.default, _companies2.default, _maxRates2.default, _active2.default, _activity2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.admin.products',
	    url: '/products',
	    template: _main2.default,
	    abstract: '.list',
	    ncyBreadcrumb: {
	        skip: true
	    },
	    data: {
	        permissions: {
	            only: ['main.view_product']
	        }
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.admin.products.list',
	    url: '?search',
	    views: {
	        tableView: {
	            template: _tableSection2.default,
	            controller: _ctrls.ProductsCtrl
	        },
	        detailsView: {
	            template: _detailSection2.default,
	            controller: _ctrls.ProductCtrl
	        }
	    },
	    resolve: {
	        $object: function $object() {
	            return null;
	        },
	        $productRate: function $productRate() {
	            return null;
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Products'
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.admin.products.list.product',
	    url: '/{objectId:int}',
	    ncyBreadcrumb: {
	        skip: true
	    },
	    template: '<ui-view/>',
	    resolve: {
	        $object: function $object($stateParams, ProductStore) {
	            return ProductStore.get($stateParams.objectId);
	        },
	        $productRate: function $productRate($object) {
	            return $object.one('rate').getList();
	        }
	    },
	    abstract: '.detail'
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.admin.products.list.product.detail',
	    url: '/details',
	    controller: _ctrls.ProductCtrl,
	    template: _details2.default,
	    as: 'vmc',
	    ncyBreadcrumb: {
	        label: '{{ vmc.object.title }}', LogCtrl: _ctrls.LogCtrl
	    }
	}), _dec6 = (0, _decorators.State)({
	    name: 'r.in.top.admin.products.list.product.logs',
	    url: '/log',
	    controller: _ctrls.LogCtrl,
	    template: _logs2.default,
	    ncyBreadcrumb: {
	        label: 'Logs'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _company = __webpack_require__(583);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _companiesComponentTpl = __webpack_require__(743);
	
	var _companiesComponentTpl2 = _interopRequireDefault(_companiesComponentTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.companies.component",
	    modules: [_company2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-companies',
	    bindings: {
	        ngModel: '=',
	        mode: '@?'
	    },
	    template: _companiesComponentTpl2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["CompanyStore", "$element"];
	    _inherits(C, _BasePicker);
	
	    function C(CompanyStore, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.mode = _this.mode || 'view';
	        _this.store = CompanyStore;
	        _this.store.init();
	        _this.items = [];
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: 'refresh',
	        value: function refresh(search) {
	            var self = this;
	
	            if (!this.enabled) {
	                return;
	            }
	            this.store.params.search = search;
	            this.store.refresh().then(function (obj) {
	                self.items = _lodash2.default.map(obj.list, function (o) {
	                    return {
	                        id: o.id,
	                        name: o.name
	                    };
	                });
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.items = [];
	            _get(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), '$onDestroy', this).call(this);
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-container\" ng-if=\"$ctrl.mode === 'edit'\">\n    <ui-select multiple\n           ng-model=\"$ctrl.ngModel\"\n           theme=\"bootstrap\"\n           title=\"Choose field\"\n           close-on-select=\"false\"\n           ng-click=\"$ctrl.onClick()\"\n           prevent-animations>\n    <ui-select-match prevent-animations placeholder=\"{{ $ctrl.placeholder }}\">{{ $item.name }}</ui-select-match>\n    <ui-select-choices\n            repeat=\"company in $ctrl.items | filter: $select.search\"\n            refresh=\"$ctrl.refresh($select.search)\"\n            refresh-delay=\"100\"\n            prevent-animations>\n        <div ng-bind=\"company.name\"></div>\n    </ui-select-choices>\n</ui-select>\n</div>\n<blnd-company-picker ng-if=\"$ctrl.mode === 'view'\"  ng-repeat=\"company in $ctrl.ngModel\" ng-model=\"company\"></blnd-company-picker>\n"

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _blndUnitsPickerTpl = __webpack_require__(745);
	
	var _blndUnitsPickerTpl2 = _interopRequireDefault(_blndUnitsPickerTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.units.picker"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-units-picker',
	    bindings: {
	        ngModel: '=',
	        mode: '@?'
	    },
	    template: _blndUnitsPickerTpl2.default
	}), _dec(_class = _dec2(_class = ["Config", function C(Config) {
	    "ngInject";
	
	    _classCallCheck(this, C);
	
	    this.units = Config.$config.units;
	    this.mode = this.mode || 'view';
	}]) || _class) || _class);
	exports.default = C;

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	module.exports = "<select class=\"form-control\"\n        ng-options=\"obj.id as obj.name for obj in $ctrl.units\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-disabled=\"$ctrl.mode == 'view'\">\n</select>\n"

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _crop = __webpack_require__(581);
	
	var _crop2 = _interopRequireDefault(_crop);
	
	var _maxRatesTable = __webpack_require__(747);
	
	var _maxRatesTable2 = _interopRequireDefault(_maxRatesTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.max.rates.component",
	    modules: [_crop2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-max-rates',
	    bindings: {
	        ngModel: '=',
	        mode: '@?',
	        errors: '=?'
	    },
	    template: _maxRatesTable2.default
	}), _dec(_class = _dec2(_class = function () {
	    function C() {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var self = this;
	
	        self.mode = self.mode || 'view';
	    }
	
	    _createClass(C, [{
	        key: 'add',
	        value: function add() {
	            this.ngModel.push({});
	        }
	    }, {
	        key: 'remove',
	        value: function remove(item) {
	            var index = this.ngModel.indexOf(item);
	            this.ngModel.splice(index, 1);
	        }
	    }, {
	        key: 'onPress',
	        value: function onPress(event, isLast) {
	            if (event.which === 9 && isLast) {
	                this.add();
	            }
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-striped\" ng-if=\"$ctrl.mode === 'view'\">\n    <thead>\n        <th>Crop</th>\n        <th>Max rates</th>\n    </thead>\n    <tbody>\n        <tr ng-if=\"$ctrl.ngModel.length >= 1\"\n            ng-repeat=\"row in $ctrl.ngModel track by $index\">\n            <td ng-bind=\"row.crop.name\"></td>\n            <td ng-bind=\"row.max_rate\"></td>\n        </tr>\n        <tr ng-if=\"$ctrl.ngModel.length === 0\">\n            <td colspan=\"2\">No entries.</td>\n        </tr>\n    </tbody>\n</table>\n<table class=\"table table-striped product-max-rate-table\" ng-if=\"$ctrl.mode === 'edit'\">\n    <thead>\n        <tr>\n            <th></th>\n            <th>Crop</th>\n            <th>Max rates</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat=\"item in $ctrl.ngModel track by $index\">\n            <td>\n                <i class=\"fa fa-times clickable\" ng-click=\"$ctrl.remove(item)\"></i>\n            </td>\n            <td class=\"crop-selector\">\n                <blnd-crop-picker ng-model=\"item.crop\" form-error=\"$ctrl.errors[{{$index}}].crop\"></blnd-crop-picker>\n            </td>\n            <td class=\"max-rate-input\">\n                <input type=\"number\"\n                       class=\"form-control input-sm\"\n                       ng-model=\"item.max_rate\"\n                       step=\"0.01\"\n                       ng-keypress=\"$ctrl.onPress($event, $last)\"\n                       ng-keydown=\"$ctrl.onPress($event, $last)\"\n                       form-error=\"$ctrl.errors[{{$index}}].max_rate\">\n            </td>\n        </tr>\n        <tr>\n            <td><i class=\"fa fa-plus clickable\" ng-click=\"$ctrl.add()\"></i></td>\n            <td></td>\n            <td></td>\n        </tr>\n    </tbody>\n</table>\n"

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _product = __webpack_require__(588);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.fiters.active"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-active-filter',
	    bindings: {
	        ngModel: '=',
	        ngChange: '&?'
	    },
	    template: '<select class="form-control" ng-model="$ctrl.ngModel" ng-options="key for (key, value) in $ctrl.options"><option value="">Show all</option></select>'
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["$scope"];
	    function C($scope) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.$scope = $scope;
	        this.options = {
	            'Active': 'yes',
	            'Inactive': 'no'
	        };
	    }
	
	    _createClass(C, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var self = this;
	            self.$scope.$watch(function () {
	                return self.ngModel;
	            }, function () {
	                self.onChange();
	            });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange() {
	            if (this.ngChange) {
	                this.ngChange();
	            }
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LogCtrl = exports.ProductCtrl = exports.ProductsCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _editModal = __webpack_require__(750);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditProductModal = function () {
	    EditProductModal.$inject = ["R", "BlndHelpers", "$uibModalInstance", "$state", "object", "productRate"];
	    function EditProductModal(R, BlndHelpers, $uibModalInstance, $state, object, productRate) {
	        "ngInject";
	
	        _classCallCheck(this, EditProductModal);
	
	        this.helpers = BlndHelpers;
	        this.$modal = $uibModalInstance;
	        this.$state = $state;
	        this.object = object;
	        this.R = R;
	        this.productRate = productRate;
	        this.data = this.R.copy(this.object);
	        this.rateData = this.R.copy(productRate).plain();
	        this.errors = {};
	        this.state = {};
	    }
	
	    _createClass(EditProductModal, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'disableField',
	        value: function disableField(field) {
	            var idx = this.getFieldIdx(field);
	
	            if (idx === -1) {
	                this.data.disabled_fields.push(field);
	            } else {
	                this.data.disabled_fields.splice(idx, 1);
	            }
	        }
	    }, {
	        key: 'getFieldIdx',
	        value: function getFieldIdx(field) {
	            return _lodash2.default.findIndex(this.data.disabled_fields, function (o) {
	                return o === field;
	            });
	        }
	    }, {
	        key: 'isChecked',
	        value: function isChecked(field) {
	            var idx = this.getFieldIdx(field);
	            var isChecked = idx !== -1;
	            this.state[field] = isChecked ? 'edit' : 'view';
	            return isChecked;
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            var readOnlyFields = ['description', 'units', 'hazardous_material'];
	
	            var data = this.R.copy(self.data);
	            _lodash2.default.each(readOnlyFields, function (field) {
	                delete data[field];
	            });
	
	            var productPromise = data.put();
	            var ratePromise = this.object.customPUT(this.rateData, "rate", {});
	
	            self.errors = {};
	            productPromise.then(function () {}, function (resp) {
	                _angular2.default.extend(self.errors, resp.data);
	            });
	            ratePromise.then(function () {}, function (resp) {
	                self.errors['max_rates'] = resp.data;
	            });
	
	            self.helpers.all({
	                'product': productPromise,
	                'rate': ratePromise
	            }).then(function (response) {
	                var isOk = _lodash2.default.every(_lodash2.default.map(response, function (o) {
	                    return o && o.status ? !(o.status >= 400) : true;
	                }));
	
	                if (!isOk) {
	                    return;
	                }
	
	                _angular2.default.extend(self.object, response.product);
	                _angular2.default.extend(self.productRate, response.rate);
	                self.$state.go('r.in.top.admin.products.list.product', { objectId: response.product.id }, { reload: true });
	                self.$modal.close(response.product.id);
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Edit ' + this.object.title;
	        }
	    }]);
	
	    return EditProductModal;
	}();
	
	var ProductsCtrl = exports.ProductsCtrl = function () {
	    ProductsCtrl.$inject = ["NgTableParams", "$state", "$stateParams", "$growl", "Modal", "ProductStore"];
	    function ProductsCtrl(NgTableParams, $state, $stateParams, $growl, Modal, ProductStore) {
	        "ngInject";
	
	        _classCallCheck(this, ProductsCtrl);
	
	        this.Modal = Modal;
	        this.$state = $state;
	        this.$growl = $growl;
	        this.params = {
	            is_active: 'yes',
	            page_size: 20
	        };
	        this.store = ProductStore;
	
	        this.selectedObject = $stateParams.objectId;
	
	        this.table = new _table2.default(NgTableParams, this.store, {
	            defaultParams: {
	                page_size: 20,
	                ordering: ['id']
	            }
	        });
	        if ($state.params && $state.params.objectId) {
	            this.selectedObject = $state.params.objectId;
	        }
	    }
	
	    _createClass(ProductsCtrl, [{
	        key: 'selectRow',
	        value: function selectRow(objectId) {
	            this.selectedObject = objectId;
	            this.$state.go('r.in.top.admin.products.list.product', { objectId: objectId });
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }]);
	
	    return ProductsCtrl;
	}();
	
	var ProductCtrl = exports.ProductCtrl = function () {
	    ProductCtrl.$inject = ["$rootScope", "Modal", "$growl", "$object", "$productRate"];
	    function ProductCtrl($rootScope, Modal, $growl, $object, $productRate) {
	        "ngInject";
	
	        _classCallCheck(this, ProductCtrl);
	
	        this.object = $object;
	        this.productRate = $productRate;
	        this.$growl = $growl;
	        this.Modal = Modal;
	
	        $rootScope.object = this.object;
	    }
	
	    _createClass(ProductCtrl, [{
	        key: 'isChecked',
	        value: function isChecked(field) {
	            var idx = _lodash2.default.findIndex(this.object.disabled_fields, function (o) {
	                return o == field;
	            });
	
	            return idx !== -1;
	        }
	    }, {
	        key: 'editModal',
	        value: function editModal() {
	            var _this = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: EditProductModal,
	                size: 'lg',
	                resolve: {
	                    object: function object() {
	                        return _this.object;
	                    },
	                    productRate: function productRate() {
	                        return _this.productRate;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.updated();
	            });
	        }
	    }]);
	
	    return ProductCtrl;
	}();
	
	var LogCtrl = exports.LogCtrl = ["$rootScope", "$object", "$productRate", function LogCtrl($rootScope, $object, $productRate) {
	    "ngInject";
	
	    _classCallCheck(this, LogCtrl);
	
	    this.object = $object;
	    this.productRate = $productRate;
	    $rootScope.object = this.object;
	}];

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">ID <i read-only-as400></i></label>\n                    <input class=\"form-control\" disabled ng-model=\"vm.data.id\" readonly disabled>\n                </div>\n            </div>\n            <div class=\"col-md-4\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Name <i read-only-as400></i></label>\n                    <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.description\" readonly disabled form-error>\n                </div>\n            </div>\n            <div class=\"col-md-2\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\"></label>\n                    <div class=\"checkbox\">\n                        <label>\n                            <input type=\"checkbox\" ng-model=\"vm.data.is_active\"> Active\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-2\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Suffix</label>\n                    <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.suffix\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Units <i read-only-as400></i></label>\n                    <blnd-units-picker ng-model=\"vm.data.units.id\" mode=\"view\" form-error></blnd-units-picker>\n                </div>\n            </div>\n            <div class=\"col-md-4\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Max Rate Acre </label>\n                    <input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"vm.data.max_rate_acre\" name=\"max_rate_acre\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-3\">\n                <div class=\"form-group form-group-sm\">\n                    <label>\n                        <input type=\"checkbox\" ng-model=\"vmc.data.hazardous_material\" readonly disabled> Hazardous Material <i read-only-as400></i>\n                    </label>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">EPA Registration Number</label>\n                    <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.epa_registration_number\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">DOT</label>\n                    <textarea class=\"form-control\" rows=\"3\" ng-model=\"vm.data.dot\" form-error></textarea>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-9\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Companies</label>\n                    <div>\n                        <blnd-companies ng-model=\"vm.data.companies\" errors=\"vm.errors.companies\" mode=\"{{ vm.state['companies'] }}\"></blnd-companies>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-3\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\" for=\"disable_companies\">Don't sync from AS400</label>\n                    <input id=\"disable_companies\" type=\"checkbox\" ng-checked=\"vm.isChecked('companies')\" ng-click=\"vm.disableField('companies')\">\n                </div>\n            </div>\n        </div>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Product max rates</label>\n                    <div>\n                        <blnd-max-rates ng-model=\"vm.rateData\" mode=\"edit\" errors=\"vm.errors.max_rates\"></blnd-max-rates>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"product-listing\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div ui-view=\"tableView\"></div>\n        </div>\n        <div class=\"col-md-6\">\n            <div ui-view=\"detailsView\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"top-right-corner\" permission permission-only=\"'main.change_product'\">\n                        <button type=\"button\"\n                                class=\"btn btn-edit\"\n                                ng-click=\"vmc.editModal()\">Edit</button>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>ID</div>\n                                <div ng-bind=\"vmc.object.id\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Name</div>\n                                <div ng-bind=\"vmc.object.description\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <label>\n                                    <input type=\"checkbox\" ng-model=\"vmc.object.is_active\" disabled> Active\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-2\">\n                            <div class=\"blnd-data-field\">\n                                <div>Suffix</div>\n                                <div ng-bind=\"vmc.object.suffix\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Units</div>\n                                <div ng-bind=\"vmc.object.units.name\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Max Rate Acre</div>\n                                <div ng-bind=\"vmc.object.max_rate_acre\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"blnd-data-field\">\n                                <div>DOT</div>\n                                <div ng-bind=\"vmc.object.dot\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"checkbox\">\n                                <label>\n                                    <input type=\"checkbox\" ng-model=\"vmc.object.hazardous_material\" disabled> Hazardous Material\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"blnd-data-field\">\n                                <div>EPA Registration Number</div>\n                                <div ng-bind=\"vmc.object.epa_registration_number || '-'\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"blnd-data-field\">\n                                <div>Product max rates by crop</div>\n                                <div>\n                                    <blnd-max-rates ng-model=\"vmc.productRate\"></blnd-max-rates>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-8\">\n                            <div class=\"blnd-data-field\">\n                                <div>Companies</div>\n                                <div>\n                                    <blnd-companies ng-model=\"vmc.object.companies\" mode=\"view\"></blnd-companies>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Disabled sync from AS400</div>\n                                <div>{{ vmc.isChecked('companies') && 'Yes' || 'No' }}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default products-log blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-activity object=\"vm.object\"></blnd-activity>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"search-query\">\n    <form novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-9\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       placeholder=\"Type to search..\"\n                       ng-model=\"vm.params.search\"\n                       ng-keyup=\"$event.keyCode == 13 && vm.refresh()\" />\n            </div>\n            <div class=\"col-md-3\">\n                <blnd-active-filter ng-model=\"vm.params.is_active\" ng-change=\"vm.refresh()\"></blnd-active-filter>\n            </div>\n        </div>\n    </form>\n</div>\n<div loading-container=\"vm.table.params.settings().$loading\">\n    <table ng-table=\"vm.table.params\" class=\"table table-fixed table-sortable table-clickable\">\n        <tr ng-click=\"vm.selectRow(object.id)\"\n            ng-repeat=\"object in $data\"\n            ng-class=\"{active: object.id === vm.selectedObject}\">\n            <td header=\"'headerCheckBox'\" class=\"col-checkbox\">\n                <input type=\"checkbox\"/>\n            </td>\n            <td class=\"col-id\" data-title=\"'ID'\" sortable=\"'id'\">\n                <a ui-sref=\"r.admin.in.products.list.product({objectId: object.id})\" ng-bind=\"object.id\"></a>\n            </td>\n            <td data-title=\"'Name'\" ng-bind=\"object.title\" sortable=\"'product'\"></td>\n            <td data-title=\"'Suffix'\" ng-bind=\"object.suffix\"></td>\n            <td data-title=\"'Units'\" ng-bind=\"object.units.name\"></td>\n            <td data-title=\"'Class'\" ng-bind=\"object.a_class\"></td>\n            <td data-title=\"'Active'\">\n                <label><input type=\"checkbox\" ng-model=\"object.is_active\" disabled></label>\n            </td>\n        </tr>\n    </table>\n</div>\n"

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\"^.detail\" ng-bind=\"object.title || 'Product'\"></a>\n    </li>\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\"^.logs\">Logs</a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\"><div ui-view></div></div>\n"

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _nutrient = __webpack_require__(757);
	
	var _nutrient2 = _interopRequireDefault(_nutrient);
	
	var _uiLocation = __webpack_require__(760);
	
	var _uiLocation2 = _interopRequireDefault(_uiLocation);
	
	var _ctrls = __webpack_require__(762);
	
	var _main = __webpack_require__(764);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _details = __webpack_require__(765);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _notes = __webpack_require__(766);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	var _logs = __webpack_require__(767);
	
	var _logs2 = _interopRequireDefault(_logs);
	
	var _tableSection = __webpack_require__(768);
	
	var _tableSection2 = _interopRequireDefault(_tableSection);
	
	var _detailSection = __webpack_require__(769);
	
	var _detailSection2 = _interopRequireDefault(_detailSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'admin.company.products.conf',
	    modules: [_routing2.default, _nutrient2.default, _uiLocation2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.productconf',
	    url: '/products-configuration',
	    template: _main2.default,
	    abstract: '.list',
	    data: {
	        permissions: {
	            only: ['main.view_productconfiguration']
	        }
	    },
	    ncyBreadcrumb: {
	        skip: true,
	        parent: 'r.in.top.admin.company'
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.productconf.list',
	    url: '?search',
	    views: {
	        tableView: {
	            template: _tableSection2.default,
	            controller: _ctrls.ProductsCtrl
	        },
	        detailsView: {
	            template: _detailSection2.default
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Products Configuration'
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.productconf.list.product',
	    url: '/{objectId:int}',
	    template: '<ui-view/>',
	    abstract: '.detail',
	    ncyBreadcrumb: {
	        skip: true
	    },
	    controller: ["$rootScope", "$stateParams", function controller($rootScope, $stateParams) {
	        "ngInject";
	
	        $rootScope.selectedObject = $stateParams.objectId;
	    }],
	    resolve: {
	        $object: function $object($stateParams, ProductConfStore) {
	            return ProductConfStore.get($stateParams.objectId);
	        }
	    }
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.productconf.list.product.detail',
	    url: '/configuration',
	    controller: _ctrls.ProductCtrl,
	    template: _details2.default,
	    ncyBreadcrumb: {
	        label: '{{ vm.object.name }}'
	    }
	}), _dec6 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.productconf.list.product.notes',
	    url: '/notes',
	    controller: _ctrls.NotesCtrl,
	    template: _notes2.default,
	    ncyBreadcrumb: {
	        label: 'Notes'
	    }
	}), _dec7 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.productconf.list.product.logs',
	    url: '/logs',
	    controller: _ctrls.LogCtrl,
	    template: _logs2.default,
	    ncyBreadcrumb: {
	        label: 'Logs'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _nutrient = __webpack_require__(758);
	
	var _nutrient2 = _interopRequireDefault(_nutrient);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _nutrientPicker = __webpack_require__(759);
	
	var _nutrientPicker2 = _interopRequireDefault(_nutrientPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.nutrientpicker",
	    modules: [_nutrient2.default]
	
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-nutrient-picker',
	    bindings: {
	        ngModel: '=',
	        mode: '@?'
	    },
	    template: _nutrientPicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["NutrientStore", "$element"];
	    _inherits(C, _BasePicker);
	
	    function C(NutrientStore, $element) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.mode = _this.mode || 'view';
	        _this.store = NutrientStore;
	        return _this;
	    }
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NutrientStore = (_dec = (0, _decorators.Module)({
	    name: 'app.store.nutrient',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('NutrientStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    NutrientStore.$inject = ["$q", "R"];
	    _inherits(NutrientStore, _BaseStore);
	
	    function NutrientStore($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, NutrientStore);
	
	        var _this = _possibleConstructorReturn(this, (NutrientStore.__proto__ || Object.getPrototypeOf(NutrientStore)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('nutrients');
	        return _this;
	    }
	
	    return NutrientStore;
	}(_base2.default)) || _class) || _class);
	exports.default = NutrientStore;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"ui-select-wrapper\">\n    <ui-select ng-if=\"$ctrl.mode === 'edit'\"\n            ng-model=\"$ctrl.ngModel\"\n            theme=\"bootstrap\"\n            class=\"input-sm\"\n            ng-click=\"$ctrl.onClick()\"\n            on-select=\"$ctrl.onSelect($item, $model)\">\n        <ui-select-match placeholder=\"{{$ctrl.placeholder}}\">{{ $select.selected.name }}</ui-select-match>\n        <ui-select-choices\n                repeat=\"nutrient in $ctrl.store.list | filter: $select.search\"\n                refresh=\"$ctrl.refresh($select.search, $select)\"\n                refresh-delay=\"100\">\n            <span>{{ nutrient.short_name }} <strong ng-if=\"nutrient.name\">{{ nutrient.name }}</strong></span>\n        </ui-select-choices>\n    </ui-select>\n</div>\n<span ng-if=\"$ctrl.mode === 'view'\" ng-bind=\"$ctrl.ngModel.name\"></span>\n"

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _uiLocationPicker = __webpack_require__(761);
	
	var _uiLocationPicker2 = _interopRequireDefault(_uiLocationPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.ui.location.picker"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-ui-location-picker',
	    bindings: {
	        ngModel: '=',
	        mode: '@?'
	    },
	    template: _uiLocationPicker2.default
	}), _dec(_class = _dec2(_class = function () {
	    C.$inject = ["Config"];
	    function C(Config) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.mode = this.mode || 'view';
	        this.locations = Config.$config.ticket.ui_location;
	    }
	
	    _createClass(C, [{
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            delete this.locations;
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	module.exports = "<select ng-if=\"$ctrl.mode === 'edit'\"\n        class=\"form-control\"\n        ng-if=\"$ctrl.mode === 'edit'\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-disabled=\"$ctrl.ngDisabled\"\n        ng-options=\"item for item in $ctrl.locations\">\n    <option value=\"\">Not visible</option>\n</select>\n<span ng-if=\"$ctrl.mode === 'view'\" ng-bind=\"$ctrl.ngModel || 'Not visible'\"></span>\n"

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LogCtrl = exports.NotesCtrl = exports.ProductCtrl = exports.ProductsCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _editModal = __webpack_require__(763);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseConfigurationModal = function () {
	    BaseConfigurationModal.$inject = ["Config", "$uibModalInstance"];
	    function BaseConfigurationModal(Config, $uibModalInstance) {
	        "ngInject";
	
	        _classCallCheck(this, BaseConfigurationModal);
	
	        this.$modal = $uibModalInstance;
	        this.Config = Config;
	        this.fieldsForType = Config.$config.product_configuraton.fields;
	        this.data = {
	            type: Config.$config.product_configuraton.types[0][0]
	        };
	    }
	
	    _createClass(BaseConfigurationModal, [{
	        key: 'showField',
	        value: function showField(name) {
	            return this.fieldsForType[this.data.type].includes(name);
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            this.close();
	        }
	    }]);
	
	    return BaseConfigurationModal;
	}();
	
	var AddConfigurationModal = function (_BaseConfigurationMod) {
	    AddConfigurationModal.$inject = ["Config", "$uibModalInstance", "$state", "$stateParams", "$growl", "ProductConfStore"];
	    _inherits(AddConfigurationModal, _BaseConfigurationMod);
	
	    function AddConfigurationModal(Config, $uibModalInstance, $state, $stateParams, $growl, ProductConfStore) {
	        "ngInject";
	
	        _classCallCheck(this, AddConfigurationModal);
	
	        var _this = _possibleConstructorReturn(this, (AddConfigurationModal.__proto__ || Object.getPrototypeOf(AddConfigurationModal)).call(this, Config, $uibModalInstance));
	
	        _this.$state = $state;
	        _this.$growl = $growl;
	        _this.ProductConfStore = ProductConfStore;
	        _this.data = {
	            company: {
	                id: $stateParams.companyId
	            },
	            type: Config.$config.product_configuraton.types[0][0]
	        };
	        return _this;
	    }
	
	    _createClass(AddConfigurationModal, [{
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	
	            self.ProductConfStore.create(this.data).then(function (data) {
	                self.ProductConfStore.get(data.id).then(function (data) {
	                    self.$growl.added();
	                    self.$modal.close(data);
	                });
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Add Product Configuration';
	        }
	    }]);
	
	    return AddConfigurationModal;
	}(BaseConfigurationModal);
	
	var EditConfigurationModal = function (_BaseConfigurationMod2) {
	    EditConfigurationModal.$inject = ["Config", "R", "$uibModalInstance", "object"];
	    _inherits(EditConfigurationModal, _BaseConfigurationMod2);
	
	    function EditConfigurationModal(Config, R, $uibModalInstance, object) {
	        "ngInject";
	
	        _classCallCheck(this, EditConfigurationModal);
	
	        var _this2 = _possibleConstructorReturn(this, (EditConfigurationModal.__proto__ || Object.getPrototypeOf(EditConfigurationModal)).call(this, Config, $uibModalInstance));
	
	        _this2.object = object;
	        _this2.R = R;
	        _this2.data = _this2.R.copy(_this2.object);
	        return _this2;
	    }
	
	    _createClass(EditConfigurationModal, [{
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            this.data.put().then(function (data) {
	                _angular2.default.extend(self.object, data);
	                self.$modal.close();
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Edit ' + this.object.name + ' configuration';
	        }
	    }]);
	
	    return EditConfigurationModal;
	}(BaseConfigurationModal);
	
	var ProductsCtrl = exports.ProductsCtrl = function () {
	    ProductsCtrl.$inject = ["NgTableParams", "$rootScope", "$state", "$growl", "Modal", "$company", "ProductConfStore"];
	    function ProductsCtrl(NgTableParams, $rootScope, $state, $growl, Modal, $company, ProductConfStore) {
	        "ngInject";
	
	        _classCallCheck(this, ProductsCtrl);
	
	        var self = this;
	        this.Modal = Modal;
	        this.company = $company;
	        this.$growl = $growl;
	        this.$state = $state;
	        this.params = {
	            ordering: ['material_sequence']
	        };
	        this.store = ProductConfStore;
	        this.store.init();
	
	        $rootScope.$watch('selectedObject', function (newValue) {
	            self.selectedObject = newValue;
	        });
	
	        // Filter configurations by company ID;
	
	        this.params.company = this.company.id;
	
	        this.table = new _table2.default(NgTableParams, this.store, { defaultParams: this.params });
	    }
	
	    _createClass(ProductsCtrl, [{
	        key: 'selectRow',
	        value: function selectRow(objectId) {
	            this.selectedObject = objectId;
	            this.$state.go('r.in.top.admin.company.productconf.list.product', { objectId: objectId });
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }, {
	        key: 'addModal',
	        value: function addModal() {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: AddConfigurationModal
	            });
	
	            $modal.result.then(function (obj) {
	                self.$growl.added();
	                self.store.list.unshift(obj);
	                self.selectRow(obj.id);
	            });
	        }
	    }]);
	
	    return ProductsCtrl;
	}();
	
	var ProductCtrl = exports.ProductCtrl = function () {
	    ProductCtrl.$inject = ["$rootScope", "$state", "Modal", "$growl", "Config", "$object", "$company"];
	    function ProductCtrl($rootScope, $state, Modal, $growl, Config, $object, $company) {
	        "ngInject";
	
	        _classCallCheck(this, ProductCtrl);
	
	        this.object = $object;
	        this.company = $company;
	        this.$growl = $growl;
	        this.$state = $state;
	        this.Modal = Modal;
	        this.fieldsForType = Config.$config.product_configuraton.fields;
	
	        $rootScope.object = this.object;
	    }
	
	    _createClass(ProductCtrl, [{
	        key: 'showField',
	        value: function showField(name) {
	            return this.fieldsForType[this.object.type].includes(name);
	        }
	    }, {
	        key: 'editModal',
	        value: function editModal() {
	            var _this3 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: EditConfigurationModal,
	                resolve: {
	                    object: function object() {
	                        return _this3.object;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.updated();
	            });
	        }
	    }, {
	        key: 'deleteModal',
	        value: function deleteModal() {
	            var self = this;
	            var $modal = self.Modal.openConfirm({
	                confirmName: 'Yes',
	                text: 'Are you sure you want to delete product configuration?'
	            });
	
	            $modal.wait.then(function () {
	                $modal.close();
	                self.object.remove().then(function () {
	                    self.$state.go('r.in.top.admin.company.productconf.list', {}, { reload: true });
	                    self.$growl.success('Product Configuration deleted');
	                }).finally(function () {
	                    self.loading = false;
	                });
	            });
	        }
	    }]);
	
	    return ProductCtrl;
	}();
	
	var NotesCtrl = exports.NotesCtrl = ["$object", "$company", function NotesCtrl($object, $company) {
	    "ngInject";
	
	    _classCallCheck(this, NotesCtrl);
	
	    this.object = $object;
	    this.company = $company;
	}];
	
	var LogCtrl = exports.LogCtrl = ["$object", "$company", function LogCtrl($object, $company) {
	    "ngInject";
	
	    _classCallCheck(this, LogCtrl);
	
	    this.object = $object;
	    this.company = $company;
	}];

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n           <div class=\"col-sm-6\">\n               <div class=\"form-group form-group-sm\">\n                   <label class=\"control-label\">Name</label>\n                   <input class=\"form-control\" ng-model=\"vm.data.name\" form-error>\n               </div>\n           </div>\n            <div class=\"col-md-3\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Type</label>\n                    <div>\n                        <select ng-model=\"vm.data.type\" ng-options=\"i[0] as i[1] for i in vm.Config.$config.product_configuraton.types\" class=\"form-control\"></select>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Product</label>\n                    <div>\n                        <blnd-product-picker ng-model=\"vm.data.product\" mode=\"edit\" form-error></blnd-product-picker>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group form-group-sm\" ng-if=\"vm.showField('default')\">\n                    <label class=\"control-label\"></label>\n                    <div class=\"checkbox\">\n                        <label>\n                            <input type=\"checkbox\" ng-model=\"vm.data.default\"> Default\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-4\" ng-if=\"vm.showField('preset_name')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Preset Name</label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.preset_name\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('preset_code')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Preset Code</label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.preset_code\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('material_sequence')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Material Sequence</label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.material_sequence\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-4\" ng-if=\"vm.showField('meter_factor')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Meter Factor</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.meter_factor\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('slow_down')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Slow Down</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.slow_down\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('pounds_second')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Pounds Seconds</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.pounds_second\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-4\" ng-if=\"vm.showField('main_ingredient_percent')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Percent Main Ingredient</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.main_ingredient_percent\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('nitrogen_percent')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Percent Nitrogen</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.nitrogen_percent\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('water_equival_percent')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Percent Water Equivalent</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.water_equival_percent\" form-error>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-4\" ng-if=\"vm.showField('shrink_percent')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Shrink Percent</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.shrink_percent\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('convert_ratio')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Volume to Weight</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.convert_ratio\" form-error>\n                    <span class=\"help-block\" ng-show=\"vm.object.product\">({{ vm.object.product.units.name }} to LBS)</span>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('estimate')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Estimate</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.estimate\" form-error>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('source_of')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Source of</label>\n                    <blnd-nutrient-picker ng-model=\"vm.data.source_of\" mode=\"edit\" form-error></blnd-nutrient-picker>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-4\" ng-if=\"vm.showField('ui_location')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Screen Placement</label>\n                    <blnd-ui-location-picker ng-model=\"vm.data.ui_location\" mode=\"edit\"></blnd-ui-location-picker>\n                </div>\n            </div>\n            <div class=\"col-md-4\" ng-if=\"vm.showField('db2_slot')\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">DB2 Slot</label>\n                    <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.db2_slot\" form-error>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 764 */
751,
/* 765 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"objectiguration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"top-right-corner\">\n                        <button type=\"button\"\n                                class=\"btn btn-edit\"\n                                permission permission-only=\"'main.change_productconfiguration'\"\n                                ng-click=\"vm.editModal()\">Edit</button>\n                        <button type=\"button\"\n                                class=\"btn btn-danger\"\n                                permission permission-only=\"'main.change_productconfiguration'\"\n                                ng-click=\"vm.deleteModal()\">Delete</button>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-6\">\n                            <div class=\"blnd-data-field\">\n                                <div>Name</div>\n                                <div ng-bind=\"vm.object.name\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-3\" ng-if=\"vm.showField('default')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Default</div>\n                                <div>\n                                    <label>\n                                        <input type=\"checkbox\" ng-model=\"vm.object.default\" disabled />\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-6\">\n                            <div class=\"blnd-data-field\">\n                                <div class=\"control-label\">Product</div>\n                                <div>\n                                    <blnd-product-picker ng-model=\"vm.object.product\"></blnd-product-picker>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <div class=\"blnd-data-field\">\n                                <div class=\"control-label\">Type</div>\n                                <div>\n                                    <span ng-bind=\"vm.object.type | titlecase\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('preset_name')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Preset Name</div>\n                                <div ng-bind=\"vm.object.preset_name\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('preset_code')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Present Code</div>\n                                <div ng-bind=\"vm.object.preset_code\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('material_sequence')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Material Seq</div>\n                                <div ng-bind=\"vm.object.material_sequence\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('meter_factor')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Meter Factor</div>\n                                <div ng-bind=\"vm.object.meter_factor\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('slow_down')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Slow Down</div>\n                                <div ng-bind=\"vm.object.slow_down\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('pounds_second')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Pounds seconds</div>\n                                <div ng-bind=\"vm.object.pounds_second\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\" ng-if=\"vm.showField('main_ingredient_percent')\">\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>P Main Ingredient</div>\n                                <div ng-bind=\"vm.object.main_ingredient_percent\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('nitrogen_percent')\">\n                            <div class=\"blnd-data-field\">\n                                <div>P Nitrogen</div>\n                                <div ng-bind=\"vm.object.nitrogen_percent\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('water_equival_percent')\">\n                            <div class=\"blnd-data-field\">\n                                <div>P Water Equivalent</div>\n                                <div ng-bind=\"vm.object.water_equival_percent\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('shrink_percent')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Shrink Percent</div>\n                                <div ng-bind=\"vm.object.shrink_percent\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('convert_ratio')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Volume to Weight</div>\n                                <span class=\"small\" ng-show=\"vm.object.product\">({{ vm.object.product.units.name }} to LBS)</span>\n                                <div ng-bind=\"vm.object.convert_ratio\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('estimate')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Estimate</div>\n                                <div ng-bind=\"vm.object.estimate\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('source_of')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Source of</div>\n                                <div>\n                                    <blnd-nutrient-picker ng-model=\"vm.object.source_of\"></blnd-nutrient-picker>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('ui_location')\">\n                            <div class=\"blnd-data-field\">\n                                <div>Screen Placement</div>\n                                <div>\n                                    <blnd-ui-location-picker ng-model=\"vm.object.ui_location\"></blnd-ui-location-picker>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\" ng-if=\"vm.showField('db2_slot')\">\n                            <div class=\"blnd-data-field\">\n                                <div>DB2 Slot</div>\n                                <div>\n                                    <span ng-bind=\"vm.object.db2_slot\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    Notes  for {{ vm.object.name }}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-activity object=\"vm.object\"></blnd-activity>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"search-query\">\n    <form novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-10\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       placeholder=\"Type to search..\"\n                       ng-model=\"vm.params.search\"\n                       ng-keyup=\"$event.keyCode == 13 && vm.refresh()\" />\n            </div>\n            <div class=\"col-md-2\" permission permission-only=\"'main.add_productconfiguration'\">\n                <button type=\"button\"\n                        class=\"btn btn-add btn-block pull-right\"\n                        ng-click=\"vm.addModal()\">Add</button>\n            </div>\n        </div>\n    </form>\n</div>\n<div loading-container=\"vm.table.params.settings().$loading\">\n    <table ng-table=\"vm.table.params\" class=\"table table-fixed table-sortable table-clickable\">\n        <tr ng-click=\"vm.selectRow(object.id)\"\n            ng-repeat=\"object in $data\"\n            ng-class=\"{active: object.id === vm.selectedObject}\">\n            <td header=\"'headerCheckBox'\" class=\"col-checkbox\">\n                <input type=\"checkbox\"/>\n            </td>\n            <td data-title=\"'Name'\" ng-bind=\"object.name\" sortable=\"'name'\"></td>\n            <td data-title=\"'Units'\" ng-bind=\"object.product.units.name\"></td>\n            <td data-title=\"'Preset Code'\" ng-bind=\"object.preset_code\"></td>\n            <td data-title=\"'Material Seq'\" ng-bind=\"object.material_sequence\" sortable=\"'material_sequence'\"></td>\n            <td data-title=\"'Active'\">\n                <label><input type=\"checkbox\" ng-model=\"object.is_active\" disabled></label>\n            </td>\n        </tr>\n    </table>\n</div>\n"

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" class=\"clickable\" ng-class=\"{'disabled': object === null}\" ui-sref-active=\"active\">\n        <a ui-sref=\"^.detail\">{{ object.name || 'Configuration' }}</a>\n    </li>\n    <li role=\"presentation\" class=\"clickable\" ng-class=\"{'disabled': object === null}\" ui-sref-active=\"active\">\n        <a ui-sref=\"^.notes\">Notes</a>\n    </li>\n    <li role=\"presentation\" class=\"clickable\" ng-class=\"{'disabled': object === null}\" ui-sref-active=\"active\">\n        <a ui-sref=\"^.logs\">Logs</a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\" ui-view></div>\n"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _user = __webpack_require__(771);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _ctrls = __webpack_require__(772);
	
	var _companies = __webpack_require__(742);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _role = __webpack_require__(776);
	
	var _role2 = _interopRequireDefault(_role);
	
	var _emailto = __webpack_require__(779);
	
	var _emailto2 = _interopRequireDefault(_emailto);
	
	var _main = __webpack_require__(782);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _details = __webpack_require__(783);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _tableSection = __webpack_require__(784);
	
	var _tableSection2 = _interopRequireDefault(_tableSection);
	
	var _detailSection = __webpack_require__(785);
	
	var _detailSection2 = _interopRequireDefault(_detailSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.admin.users',
	    modules: [_routing2.default, _user2.default, _companies2.default, _role2.default, _emailto2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.admin.users',
	    url: '/users',
	    template: _main2.default,
	    ncyBreadcrumb: {
	        skip: true
	    },
	    abstract: '.list',
	    data: {
	        permissions: {
	            only: ['main.view_user']
	        }
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.admin.users.list',
	    url: '?search',
	    views: {
	        tableView: {
	            template: _tableSection2.default,
	            controller: _ctrls.UserListCtrl
	        },
	        detailsView: {
	            template: _detailSection2.default,
	            controller: _ctrls.UserCtrl
	        }
	    },
	    resolve: {
	        $object: function $object() {
	            return null;
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Users'
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.admin.users.list.user',
	    url: '/{objectId:int}',
	    ncyBreadcrumb: {
	        skip: true
	    },
	    template: '<ui-view/>',
	    resolve: {
	        $object: function $object($stateParams, UserStore) {
	            return UserStore.get($stateParams.objectId, { extra_field: 'account' });
	        }
	    },
	    abstract: '.detail'
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.admin.users.list.user.detail',
	    url: '/details',
	    controller: _ctrls.UserCtrl,
	    template: _details2.default,
	    ncyBreadcrumb: {
	        label: '{{ vm.object.username }}'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserStore = (_dec = (0, _decorators.Module)({
	    name: 'app.store.user',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('UserStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    UserStore.$inject = ["$q", "R"];
	    _inherits(UserStore, _BaseStore);
	
	    function UserStore($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, UserStore);
	
	        var _this = _possibleConstructorReturn(this, (UserStore.__proto__ || Object.getPrototypeOf(UserStore)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('users');
	        return _this;
	    }
	
	    return UserStore;
	}(_base2.default)) || _class) || _class);
	exports.default = UserStore;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UserCtrl = exports.UserListCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _addModal = __webpack_require__(773);
	
	var _addModal2 = _interopRequireDefault(_addModal);
	
	var _editModal = __webpack_require__(774);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	var _changePasswordModal = __webpack_require__(775);
	
	var _changePasswordModal2 = _interopRequireDefault(_changePasswordModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditUserModalCtrl = function () {
	    EditUserModalCtrl.$inject = ["R", "$uibModalInstance", "$state", "object"];
	    function EditUserModalCtrl(R, $uibModalInstance, $state, object) {
	        "ngInject";
	
	        _classCallCheck(this, EditUserModalCtrl);
	
	        this.object = object;
	        this.R = R;
	        this.data = this.R.copy(object);
	        this.$state = $state;
	        this.$modal = $uibModalInstance;
	    }
	
	    _createClass(EditUserModalCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            this.data.put().then(function (data) {
	                _angular2.default.extend(self.object, data);
	                self.$state.go('r.in.top.admin.users.list.user', { objectId: data.id }, { reload: true });
	                self.$modal.close(data.id);
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Edit ' + this.object.username;
	        }
	    }]);
	
	    return EditUserModalCtrl;
	}();
	
	var UserListCtrl = exports.UserListCtrl = function () {
	    UserListCtrl.$inject = ["NgTableParams", "Modal", "$growl", "$state", "$stateParams", "UserStore"];
	    function UserListCtrl(NgTableParams, Modal, $growl, $state, $stateParams, UserStore) {
	        "ngInject";
	
	        _classCallCheck(this, UserListCtrl);
	
	        this.Modal = Modal;
	        this.$growl = $growl;
	        this.$state = $state;
	        this.selectedObject = $stateParams.objectId;
	
	        this.defaultParams = {
	            role: 3,
	            page_size: 20
	        };
	
	        this.resetParams();
	
	        this.table = new _table2.default(NgTableParams, UserStore, {
	            defaultParams: this.defaultParams,
	            params: this.params
	        });
	
	        if ($state.params && $state.params.objectId) {
	            this.selectedObject = $state.params.objectId;
	        }
	    }
	
	    _createClass(UserListCtrl, [{
	        key: 'addUser',
	        value: function addUser() {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _addModal2.default,
	                controller: CreateUserCtrl
	            });
	
	            $modal.result.then(function (objectId) {
	                self.$growl.added();
	                self.$state.go('r.in.top.admin.users.list.user', { objectId: objectId });
	            });
	        }
	    }, {
	        key: 'selectRow',
	        value: function selectRow(objectId) {
	            this.selectedObject = objectId;
	            this.$state.go('r.in.top.admin.users.list.user', { objectId: objectId });
	        }
	    }, {
	        key: 'resetParams',
	        value: function resetParams() {
	            this.params = _.clone(this.defaultParams);
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }]);
	
	    return UserListCtrl;
	}();
	
	var CreateUserCtrl = function () {
	    CreateUserCtrl.$inject = ["$uibModalInstance", "UserStore"];
	    function CreateUserCtrl($uibModalInstance, UserStore) {
	        "ngInject";
	
	        _classCallCheck(this, CreateUserCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.store = UserStore;
	        this.data = {
	            'is_active': false
	        };
	    }
	
	    _createClass(CreateUserCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.loading = true;
	            this.store.create(this.data).then(function (data) {
	                self.$modal.close(data.id);
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Create new user';
	        }
	    }]);
	
	    return CreateUserCtrl;
	}();
	
	var ChangePasswordCtrl = function () {
	    ChangePasswordCtrl.$inject = ["$uibModalInstance", "object"];
	    function ChangePasswordCtrl($uibModalInstance, object) {
	        "ngInject";
	
	        _classCallCheck(this, ChangePasswordCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.object = object;
	        this.data = {};
	    }
	
	    _createClass(ChangePasswordCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.loading = true;
	            self.object.one('password').post('change', self.data).then(function () {
	                self.$modal.close();
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Change password for ' + this.object.username;
	        }
	    }]);
	
	    return ChangePasswordCtrl;
	}();
	
	var UserCtrl = exports.UserCtrl = function () {
	    UserCtrl.$inject = ["$rootScope", "Modal", "$growl", "$object"];
	    function UserCtrl($rootScope, Modal, $growl, $object) {
	        "ngInject";
	
	        _classCallCheck(this, UserCtrl);
	
	        this.object = $object;
	        this.$growl = $growl;
	        this.Modal = Modal;
	        $rootScope.object = this.object;
	    }
	
	    _createClass(UserCtrl, [{
	        key: 'editModal',
	        value: function editModal() {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: EditUserModalCtrl,
	                resolve: {
	                    object: function object() {
	                        return self.object;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.updated();
	            });
	        }
	    }, {
	        key: 'editPasswordModal',
	        value: function editPasswordModal() {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _changePasswordModal2.default,
	                controller: ChangePasswordCtrl,
	                resolve: {
	                    object: function object() {
	                        return self.object;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.updated();
	            });
	        }
	    }]);
	
	    return UserCtrl;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)))

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Username</label>\n                    <input type=\"text\" class=\"form-control\" name=\"username\" ng-model=\"vm.data.username\" form-error />\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Email</label>\n                    <input type=\"text\" class=\"form-control\" name=\"email\" ng-model=\"vm.data.email\" form-error />\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Name</label>\n                    <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.data.name\" form-error />\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Initials</label>\n                    <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.data.initials\" form-error />\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Companies</label>\n                    <blnd-companies ng-model=\"vm.data.companies\" mode=\"edit\"></blnd-companies>\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Role</label>\n                    <blnd-role ng-model=\"vm.data.role.id\" mode=\"edit\" exclude=\"['applicator']\"></blnd-role>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Email To</label>\n                    <blnd-email-to ng-model=\"vm.data.email_to\" mode=\"edit\"></blnd-email-to>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\" ng-if=\"vm.data.role.id === 4\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Account for applicators</label>\n                    <div>\n                        <ul>\n                            <li ng-repeat=\"applicator in vm.object.account\" ng-bind=\"applicator\"></li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"checkbox-inline\">\n                        <input type=\"checkbox\" ng-model=\"vm.data.is_active\"> Active\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Username</label>\n                    <input type=\"text\" class=\"form-control\" name=\"username\" ng-model=\"vm.data.username\" form-error />\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Email</label>\n                    <input type=\"text\" class=\"form-control\" name=\"email\" ng-model=\"vm.data.email\" form-error />\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Name</label>\n                    <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.data.name\" form-error />\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Initials</label>\n                    <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.data.initials\" form-error />\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Companies</label>\n                    <blnd-companies ng-model=\"vm.data.companies\" mode=\"edit\"></blnd-companies>\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Role</label>\n                    <blnd-role ng-model=\"vm.data.role.id\" mode=\"edit\"></blnd-role>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n             <div class=\"col-md-6\">\n                 <label class=\"control-label\">Phone number</label>\n                 <div class=\"form-group\">\n                     <input type=\"tel\" class=\"form-control\" name=\"phone_number\" ng-model=\"vm.data.phone_number\" form-error>\n                 </div>\n             </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Email To</label>\n                    <blnd-email-to ng-model=\"vm.data.email_to\" mode=\"edit\"></blnd-email-to>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\" ng-if=\"vm.data.role.id === 4\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Account for applicators</label>\n                    <div>\n                        <ul>\n                            <li ng-repeat=\"applicator in vm.object.account\" ng-bind=\"applicator\"></li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"checkbox-inline\">\n                        <input type=\"checkbox\" ng-model=\"vm.data.is_active\"> Active\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Password</label>\n                    <input type=\"password\" class=\"form-control\" name=\"new_password\" ng-model=\"vm.data.new_password\" form-error />\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Password (again):</label>\n                    <input type=\"password\" class=\"form-control\" name=\"re_new_password\" ng-model=\"vm.data.re_new_password\" form-error />\n                    <span class=\"help-block\">Enter the same password as before, for verification.</span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _group = __webpack_require__(777);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _rolePicker = __webpack_require__(778);
	
	var _rolePicker2 = _interopRequireDefault(_rolePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.group.picker",
	    modules: [_group2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-role',
	    bindings: {
	        ngModel: '=',
	        ngDisabled: '=',
	        ngChange: '&',
	        mode: '@?',
	        exclude: '<?'
	    },
	    template: _rolePicker2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["$timeout", "$element", "GroupStore"];
	    _inherits(C, _BasePicker);
	
	    function C($timeout, $element, GroupStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this, $element));
	
	        _this.$timeout = $timeout;
	
	        _this.mode = _this.mode || 'view';
	        _this.exclude = _this.exclude || [];
	
	        if (_this.mode == 'edit') {
	            _this.store = GroupStore;
	            _this.store.init();
	            _this.store.params.exclude = _this.exclude;
	            _this.store.refresh();
	        }
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: '_ngChange',
	        value: function _ngChange(newV, oldV) {
	            var _this2 = this;
	
	            this.$timeout(function () {
	                return _this2.ngChange(newV, oldV);
	            });
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.group',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('GroupStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('groups');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	module.exports = "<select class=\"form-control\"\n        ng-if=\"$ctrl.mode === 'edit'\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-disabled=\"$ctrl.ngDisabled\"\n        ng-change=\"$ctrl._ngChange()\"\n        ng-options=\"item.id as item.name for item in $ctrl.store.list\">\n    <option value=\"\">Show all</option>\n</select>\n<span ng-if=\"$ctrl.mode === 'view'\" class=\"label label-default\" style=\"background-color: #999\" ng-bind=\"$ctrl.ngModel.name\"></span>\n"

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _emailto = __webpack_require__(780);
	
	var _emailto2 = _interopRequireDefault(_emailto);
	
	var _emailtoComponent = __webpack_require__(781);
	
	var _emailtoComponent2 = _interopRequireDefault(_emailtoComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.admin.components.emailto",
	    modules: [_emailto2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-email-to',
	    bindings: {
	        ngModel: '=',
	        mode: '@'
	    },
	    template: _emailtoComponent2.default
	}), _dec(_class = _dec2(_class = function (_BasePicker) {
	    C.$inject = ["EmailToStore"];
	    _inherits(C, _BasePicker);
	
	    function C(EmailToStore) {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        var _this = _possibleConstructorReturn(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this));
	
	        _this.mode = _this.mode || 'view';
	        _this.store = EmailToStore;
	        _this.store.init();
	        _this.items = [];
	        return _this;
	    }
	
	    _createClass(C, [{
	        key: 'tagTransform',
	        value: function tagTransform(newTag) {
	            return {
	                email: newTag
	            };
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh(search) {
	            var self = this;
	
	            if (!this.enabled) {
	                return;
	            }
	            this.store.params.search = search;
	            this.store.refresh().then(function (obj) {
	                self.items = _lodash2.default.map(obj.list, function (o) {
	                    return {
	                        email: o.email
	                    };
	                });
	            });
	        }
	    }]);
	
	    return C;
	}(_base2.default)) || _class) || _class);
	exports.default = C;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.emailTo',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('EmailToStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('email-to');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	module.exports = "<ui-select multiple\n           tagging=\"$ctrl.tagTransform\"\n           ng-model=\"$ctrl.ngModel\"\n           theme=\"bootstrap\"\n           title=\"Choose field\"\n           close-on-select=\"false\"\n           ng-click=\"$ctrl.onClick()\"\n           ng-if=\"$ctrl.mode === 'edit'\">\n    <ui-select-match placeholder=\"{{ $ctrl.placeholder }}\">{{ $item.email }}</ui-select-match>\n    <ui-select-choices\n            repeat=\"e in $ctrl.items | filter: $select.search\"\n            refresh=\"$ctrl.refresh($select.search)\"\n            refresh-delay=\"200\">\n        <div ng-bind=\"e.email\"></div>\n    </ui-select-choices>\n</ui-select>\n<div class=\"row emails-list\" ng-if=\"$ctrl.mode === 'view'\">\n    <div class=\"col-md-12\">\n        <span ng-repeat=\"e in $ctrl.ngModel\" class=\"label label-default\">{{ e.email }}</span>\n    </div>\n</div>\n"

/***/ }),
/* 782 */
751,
/* 783 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel blnd-panel-admin\">\n                <div class=\"panel-body\">\n                    <div class=\"top-right-corner\" permission permission-only=\"'main.change_user'\">\n                        <button type=\"button\"\n                                class=\"btn btn-edit\"\n                                ng-click=\"vm.editPasswordModal()\">Change password</button>\n                        <button type=\"button\"\n                                class=\"btn btn-edit\"\n                                ng-click=\"vm.editModal()\">Edit</button>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Username</div>\n                                <div ng-bind=\"vm.object.username\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Email</div>\n                                <div ng-bind=\"vm.object.email\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                             <div class=\"blnd-data-field\">\n                                 <div>Phone number</div>\n                                 <div ng-bind=\"vm.object.phone_number\"></div>\n                             </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Name</div>\n                                <div ng-bind=\"vm.object.name\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Initials</div>\n                                <div ng-bind=\"vm.object.initials\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-8\">\n                            <div class=\"blnd-data-field\">\n                                <div>Companies</div>\n                                <div>\n                                    <blnd-companies ng-model=\"vm.object.companies\" mode=\"view\"></blnd-companies>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Role</div>\n                                <div><blnd-role ng-model=\"vm.object.role\" mode=\"view\"></blnd-role></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"blnd-data-field\">\n                                <div>Email To</div>\n                                <div>\n                                    <blnd-email-to ng-model=\"vm.object.email_to\" mode=\"view\"></blnd-email-to>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\" ng-if=\"vm.object.role.id === 4\">\n                        <div class=\"col-md-12\">\n                            <div class=\"form-group\">\n                                <label class=\"control-label\">Account for applicators</label>\n                                <div>\n                                    <ul>\n                                        <li ng-repeat=\"applicator in vm.object.account\" ng-bind=\"applicator\"></li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div class=\"checkbox\">\n                                    <label>\n                                        <input type=\"checkbox\" ng-model=\"vm.object.is_active\" disabled> Active\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"search-query\">\n    <form novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       placeholder=\"Type to search..\"\n                       ng-model=\"vm.params.search\"\n                       ng-keyup=\"$event.keyCode == 13 && vm.refresh()\" />\n            </div>\n            <div class=\"col-md-4\">\n                <blnd-role ng-model=\"vm.params.role\"\n                           ng-change=\"vm.refresh()\"\n                           mode=\"edit\">\n                </blnd-role>\n            </div>\n            <div class=\"col-md-2\">\n                <button type=\"button\" ng-click=\"vm.addUser()\" class=\"btn btn-block btn-add\">Add</button>\n            </div>\n        </div>\n    </form>\n</div>\n<div loading-container=\"vm.table.params.settings().$loading\">\n    <table ng-table=\"vm.table.params\" class=\"table table-fixed table-sortable table-clickable\">\n        <tr ng-click=\"vm.selectRow(object.id)\"\n            ng-repeat=\"object in $data\"\n            ng-class=\"{active: object.id === vm.selectedObject}\">\n            <td header=\"'headerCheckBox'\" class=\"col-checkbox\">\n                <input type=\"checkbox\"/>\n            </td>\n            <td data-title=\"'Name'\" ng-bind=\"object.name\"></td>\n            <td data-title=\"'Username'\" ng-bind=\"object.username\"></td>\n            <td data-title=\"'Role'\">\n                <blnd-role ng-model=\"object.role\"></blnd-role>\n            </td>\n        </tr>\n    </table>\n</div>\n"

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\".user\" ng-bind=\"object.title || 'User'\"></a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\"><div ui-view></div>\n"

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _main = __webpack_require__(787);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.admin.company.hauler',
	    modules: [_routing2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.hauler',
	    url: '/hauler',
	    template: _main2.default,
	    ncyBreadcrumb: {
	        label: 'Hauler & Applicator'
	    }
	}), _dec(_class = _dec2(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class);
	exports.default = States;

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	module.exports = "Haulser/Applicator\n"

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _modals = __webpack_require__(532);
	
	var _modals2 = _interopRequireDefault(_modals);
	
	var _printer = __webpack_require__(557);
	
	var _printer2 = _interopRequireDefault(_printer);
	
	var _companies = __webpack_require__(742);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _ctrls = __webpack_require__(789);
	
	var _listMain = __webpack_require__(791);
	
	var _listMain2 = _interopRequireDefault(_listMain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.admin.printers',
	    modules: [_routing2.default, _modals2.default, _printer2.default, _companies2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.admin.printers',
	    url: '/printers',
	    template: '<div ui-view></div>',
	    abstract: '.list',
	    data: {
	        permissions: {
	            only: ['main.view_companyprinter']
	        }
	    },
	    ncyBreadcrumb: {
	        skip: true
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.admin.printers.list',
	    url: '?search',
	    template: _listMain2.default,
	    controller: _ctrls.PrinterListCtrl,
	    ncyBreadcrumb: {
	        label: 'Printers'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PrinterListCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _editModal = __webpack_require__(790);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AVAILABLE_PRINTER_STATUSES = ['online', 'offline', 'unknown', 'dormant'];
	
	var PrinterListCtrl = exports.PrinterListCtrl = function () {
	    PrinterListCtrl.$inject = ["NgTableParams", "$sce", "$growl", "$location", "PrinterStore", "Modal"];
	    function PrinterListCtrl(NgTableParams, $sce, $growl, $location, PrinterStore, Modal) {
	        "ngInject";
	
	        _classCallCheck(this, PrinterListCtrl);
	
	        var self = this;
	        self.Modal = Modal;
	        self.$growl = $growl;
	        self.$location = $location;
	        self.connected = true;
	        self.store = PrinterStore;
	        self.store.init();
	
	        self.params = {
	            status: AVAILABLE_PRINTER_STATUSES
	        };
	
	        this.table = new _table2.default(NgTableParams, this.store, {
	            defaultParams: {
	                status: AVAILABLE_PRINTER_STATUSES
	            },
	            params: self.params
	        });
	
	        this.store.$promise.then(function () {}, function () {
	            return self.connected = false;
	        });
	    }
	
	    _createClass(PrinterListCtrl, [{
	        key: 'getRedirect',
	        value: function getRedirect() {
	            if (baseConfig.backendUrl === '') {
	                return '/admin/printers';
	            }
	            return this.$location.protocol() + '://' + this.$location.host() + ':8080/admin/printers';
	        }
	    }, {
	        key: 'refreshConfirmationModal',
	        value: function refreshConfirmationModal() {
	            var self = this;
	            var $modal = self.Modal.openConfirm({
	                confirmName: 'Yes',
	                text: 'Are you sure you want to refresh all printers?'
	            });
	            $modal.wait.then(function () {
	                self.loading = true;
	                $modal.close();
	                self.store.create().then(function () {
	                    self.$growl.success('Printers have been updated');
	                }, function (response) {
	                    if (response.status === 403) {
	                        self.connected = false;
	                        self.$growl.error('Could not refresh printers.');
	                    }
	                }).finally(function () {
	                    self.table.refresh(self.params);
	                    self.loading = false;
	                });
	            });
	        }
	    }, {
	        key: 'editModal',
	        value: function editModal(id) {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: EditPrinterCtrl,
	                size: 'sm',
	                resolve: {
	                    object: function object() {
	                        return self.store.get(id);
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.updated();
	                self.table.refresh(self.params);
	            });
	        }
	    }]);
	
	    return PrinterListCtrl;
	}();
	
	var EditPrinterCtrl = function () {
	    EditPrinterCtrl.$inject = ["R", "$uibModalInstance", "object"];
	    function EditPrinterCtrl(R, $uibModalInstance, object) {
	        "ngInject";
	
	        _classCallCheck(this, EditPrinterCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.object = object;
	        this.R = R;
	        this.data = this.R.copy(this.object);
	    }
	
	    _createClass(EditPrinterCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            this.data.put().then(function (data) {
	                angular.extend(self.object, data);
	                self.$modal.close();
	            }, function (resp) {
	                self.errors = resp.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Edit ' + this.data.display_name;
	        }
	    }]);
	
	    return EditPrinterCtrl;
	}();

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Display Name</label>\n                    <div>\n                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.data.display_name\" name=\"display_name\" form-error>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Company</label>\n                    <div>\n                        <blnd-company-picker ng-model=\"vm.data.company\" mode=\"edit\"\n                                             test-id=\"admin-printer-company-picker\"></blnd-company-picker>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <h4>Settings</h4>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Default number of copies</label>\n                    <div>\n                        <input type=\"number\" class=\"form-control\" ng-model=\"vm.data.default_copies\" name=\"default_copies\" min=\"0\" form-error>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Use for Send and Print Form</label>\n                    <div>\n                        <input type=\"checkbox\" ng-model=\"vm.data.form\" name=\"form\" form-error>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row printer-admin-container\">\n    <div class=\"col-md-12\">\n        <div class=\"panel panel-default blnd-panel\">\n            <div class=\"panel-body\">\n                <div class=\"row\" ng-if=\"!vm.loading && !vm.connected\">\n                    <div class=\"col-md-12\">\n                        <a class=\"btn btn-default center-block fit-content\"\n                           href=\"https://www.printnode.com/en/status\"\n                           rel=\"noopener noreferrer\"\n                           target=\"_blank\">\n                            <span class=\"fa-stack fa-lg\">\n                                <i class=\"fa fa-square fa-background-google fa-stack-2x\"></i>\n                                <i class=\"fa fa-print fa-stack-1x fa-inverse\"></i>\n                            </span>\n                            <span>Check PrintNode system status</span>\n                        </a>\n                    </div>\n                </div>\n                <div ng-if=\"vm.connected\">\n                    <div class=\"row\">\n                        <div class=\"col-md-12\">\n                            <div class=\"top-right-corner\">\n                                <button class=\"btn btn-primary pull-right\"\n                                        ladda=\"vm.loading\"\n                                        ng-click=\"vm.refreshConfirmationModal()\"><span>Refresh</span>\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row printers-table\">\n                        <div class=\"col-md-12\">\n                            <div loading-container=\"vm.table.params.settings().$loading\">\n                                <table ng-table=\"vm.table.params\" class=\"table table-fixed table-sortable table-clickable\">\n                                    <tr ng-repeat=\"printer in $data\">\n                                        <td data-title=\"'Original Name'\">\n                                            <span ng-bind=\"printer.name\"></span>\n                                        </td>\n                                        <td data-title=\"'Display Name'\">\n                                            <span ng-bind=\"printer.display_name\"></span>\n                                        </td>\n                                        <td data-title=\"'Status'\" ng-bind=\"printer.status\"></td>\n                                        <td data-title=\"'Company'\">\n                                            <blnd-company-picker ng-model=\"printer.company\" mode=\"view\"></blnd-company-picker>\n                                        </td>\n                                        <td><button ng-click=\"vm.editModal(printer.id)\" class=\"btn btn-default\">Edit</button></td>\n                                    </tr>\n                                </table>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _chemical = __webpack_require__(629);
	
	var _chemical2 = _interopRequireDefault(_chemical);
	
	var _chemical3 = __webpack_require__(793);
	
	var _chemical4 = _interopRequireDefault(_chemical3);
	
	var _ctrls = __webpack_require__(795);
	
	var _main = __webpack_require__(797);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _details = __webpack_require__(798);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _tableSection = __webpack_require__(799);
	
	var _tableSection2 = _interopRequireDefault(_tableSection);
	
	var _detailSection = __webpack_require__(800);
	
	var _detailSection2 = _interopRequireDefault(_detailSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.admin.chemical.products',
	    modules: [_routing2.default, _chemical2.default, _chemical4.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.chemicals',
	    url: '/chemicals',
	    template: _main2.default,
	    abstract: '.list',
	    data: {
	        permissions: {
	            only: ['main.view_chemicalprogram']
	        }
	    },
	    ncyBreadcrumb: {
	        skip: true,
	        parent: 'r.in.top.admin.company'
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.chemicals.list',
	    url: '?search',
	    views: {
	        tableView: {
	            template: _tableSection2.default,
	            controller: _ctrls.ListCtrl
	        },
	        detailsView: {
	            template: _detailSection2.default,
	            controller: _ctrls.DetailCtrl
	        }
	    },
	    resolve: {
	        $object: function $object() {
	            return null;
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Chemical Programs'
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.chemicals.list.program',
	    url: '/{objectId:int}',
	    ncyBreadcrumb: {
	        skip: true
	    },
	    template: '<ui-view/>',
	    resolve: {
	        $object: function $object($stateParams, ChemicalProgramStore) {
	            return ChemicalProgramStore.get($stateParams.objectId);
	        }
	    },
	    abstract: '.detail'
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.chemicals.list.program.detail',
	    url: '/details',
	    controller: _ctrls.DetailCtrl,
	    template: _details2.default,
	    as: 'vmc',
	    ncyBreadcrumb: {
	        label: '{{ vmc.object.name }}'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _product = __webpack_require__(596);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _chemicalProducts = __webpack_require__(794);
	
	var _chemicalProducts2 = _interopRequireDefault(_chemicalProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.admin.components.chemica.program",
	    modules: [_product2.default]
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'blnd-chemical-products',
	    bindings: {
	        ngModel: '=',
	        mode: '@',
	        company: '<'
	    },
	    template: _chemicalProducts2.default
	}), _dec(_class = _dec2(_class = function () {
	    function C() {
	        "ngInject";
	
	        _classCallCheck(this, C);
	
	        this.ngModel = this.ngModel || [];
	        this.mode = this.mode || 'view';
	    }
	
	    _createClass(C, [{
	        key: 'addProduct',
	        value: function addProduct() {
	            this.ngModel.push({});
	        }
	    }, {
	        key: 'removeProduct',
	        value: function removeProduct(product) {
	            var index = this.ngModel.indexOf(product);
	            this.ngModel.splice(index, 1);
	        }
	    }]);
	
	    return C;
	}()) || _class) || _class);
	exports.default = C;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table products-edit-table\" ng-if=\"$ctrl.mode == 'edit'\">\n    <thead>\n        <tr>\n            <th></th>\n            <th>Product</th>\n            <th>Units</th>\n            <th>Rate</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat=\"product in $ctrl.ngModel track by $index\">\n            <td>\n                <i class=\"fa fa-times clickable\" ng-click=\"$ctrl.removeProduct(product)\"></i>\n            </td>\n            <td class=\"col-grow\">\n                <blnd-product-picker\n                        mode=\"edit\"\n                        ng-model=\"product.product\"\n                        company=\"$ctrl.company\"\n                        on-change=\"$ctrl.onProductChange(product)\"\n                        form-error=\"$ctrl.errors[{{$index}}].product\">\n                </blnd-product-picker>\n            </td>\n            <td class=\"col-sm-1 units\" ng-bind=\"product.product.units.name || '-'\"></td>\n            <td>\n                <input ng-model=\"product.rate\"\n                       type=\"number\"\n                       step=\"0.01\"\n                       class=\"form-control input-sm rate-acre-input\">\n            </td>\n        </tr>\n        <tr>\n            <td><i class=\"fa fa-plus clickable\" ng-click=\"$ctrl.addProduct()\"></i></td>\n            <td></td>\n            <td></td>\n            <td></td>\n        </tr>\n    </tbody>\n</table>\n<table class=\"table table-fixed\" ng-if=\"$ctrl.mode == 'view'\">\n    <thead>\n        <tr>\n            <th></th>\n            <th>Product</th>\n            <th>Unit</th>\n            <th>Rate</th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-if=\"$ctrl.ngModel.length === 0\">\n            <td colspan=\"5\" class=\"no-items\">No product selected</td>\n        </tr>\n        <tr ng-if=\"$ctrl.ngModel.length > 0\" ng-repeat=\"product in $ctrl.ngModel\">\n            <td ng-bind=\"product.product.id\"></td>\n            <td class=\"col-grow\" ng-bind=\"product.product.description || product.product.dot\"></td>\n            <td ng-bind=\"product.product.units.name\"></td>\n            <td ng-bind=\"product.rate\"></td>\n        </tr>\n    </tbody>\n</table>\n"

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DetailCtrl = exports.ListCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _editModal = __webpack_require__(796);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditModalCtrl = function () {
	    EditModalCtrl.$inject = ["$uibModalInstance", "R", "company", "object"];
	    function EditModalCtrl($uibModalInstance, R, company, object) {
	        "ngInject";
	
	        _classCallCheck(this, EditModalCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.object = object;
	        this.company = company;
	        this.data = R.copy(this.object);
	    }
	
	    _createClass(EditModalCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	
	            self.loading = true;
	            self.data.put().then(function (response) {
	                _angular2.default.extend(self.object, response);
	                self.$modal.close();
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Edit';
	        }
	    }]);
	
	    return EditModalCtrl;
	}();
	
	var AddModalCtrl = function () {
	    AddModalCtrl.$inject = ["$uibModalInstance", "$stateParams", "ChemicalProgramStore", "company", "isAdding"];
	    function AddModalCtrl($uibModalInstance, $stateParams, ChemicalProgramStore, company, isAdding) {
	        "ngInject";
	
	        _classCallCheck(this, AddModalCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.store = ChemicalProgramStore;
	        this.company = company;
	        this.isAdding = isAdding;
	        this.data = {
	            companies: [{ id: $stateParams.companyId }]
	        };
	    }
	
	    _createClass(AddModalCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var _this = this;
	
	            var self = this;
	            self.loading = true;
	            self.store.create(self.data).then(function (response) {
	                self.$modal.close(response.id);
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return _this.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Add new chemical program';
	        }
	    }]);
	
	    return AddModalCtrl;
	}();
	
	var ListCtrl = exports.ListCtrl = function () {
	    ListCtrl.$inject = ["NgTableParams", "$company", "$state", "$stateParams", "$growl", "Modal", "ChemicalProgramStore"];
	    function ListCtrl(NgTableParams, $company, $state, $stateParams, $growl, Modal, ChemicalProgramStore) {
	        "ngInject";
	
	        _classCallCheck(this, ListCtrl);
	
	        this.Modal = Modal;
	        this.$state = $state;
	        this.$growl = $growl;
	        this.store = ChemicalProgramStore;
	        this.company = $company;
	        this.params = {
	            is_active: 'yes',
	            company: this.company.id
	        };
	
	        this.selectedObject = $stateParams.objectId;
	
	        this.table = new _table2.default(NgTableParams, this.store, {
	            defaultParams: {
	                page_size: 20
	            }
	        });
	    }
	
	    _createClass(ListCtrl, [{
	        key: 'openModal',
	        value: function openModal() {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: AddModalCtrl,
	                resolve: {
	                    isAdding: true,
	                    company: self.company
	                }
	            });
	
	            $modal.result.then(function (objectId) {
	                self.refresh();
	                self.table.store.$promise.then(function () {
	                    self.selectRow(objectId);
	                });
	            });
	        }
	    }, {
	        key: 'selectRow',
	        value: function selectRow(objectId) {
	            this.selectedObject = objectId;
	            this.$state.go('r.in.top.admin.company.chemicals.list.program', { objectId: objectId });
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }]);
	
	    return ListCtrl;
	}();
	
	var DetailCtrl = exports.DetailCtrl = function () {
	    DetailCtrl.$inject = ["$rootScope", "Modal", "$company", "$growl", "$state", "$object"];
	    function DetailCtrl($rootScope, Modal, $company, $growl, $state, $object) {
	        "ngInject";
	
	        _classCallCheck(this, DetailCtrl);
	
	        this.Modal = Modal;
	        this.object = $object;
	        this.$state = $state;
	        this.$growl = $growl;
	        this.company = $company;
	
	        $rootScope.object = this.object;
	    }
	
	    _createClass(DetailCtrl, [{
	        key: 'openModal',
	        value: function openModal() {
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: EditModalCtrl,
	                resolve: {
	                    object: function object() {
	                        return self.object;
	                    },
	                    company: function company() {
	                        return self.company;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.updated();
	                self.$state.go(self.$state.current, {}, { reload: true });
	            });
	        }
	    }]);
	
	    return DetailCtrl;
	}();

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"field-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n            type=\"button\"\n            class=\"close\"\n            data-dismiss=\"modal\"\n            aria-label=\"Close\"\n            ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-9\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Program ID</label>\n                    <div>\n                        <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.program_id\" name=\"program_id\" form-error>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-3\" ng-if=\"!vm.isAdding\">\n                <div class=\"form-group form-group-sm\" >\n                    <label class=\"control-label\"></label>\n                    <div class=\"checkbox\">\n                        <label>\n                            <input type=\"checkbox\" ng-model=\"vm.data.is_active\" name=\"is_active\"> Is Active\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-9\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Name</label>\n                    <div>\n                        <input class=\"form-control\" type=\"text\" ng-model=\"vm.data.name\" name=\"name\" form-error>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row top-space\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Products</label>\n                    <div>\n                        <blnd-chemical-products ng-model=\"vm.data.products\" company=\"vm.company\" errors=\"vm.errors.products\" mode=\"edit\"></blnd-chemical-products>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ladda=\"vm.loading\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 797 */
751,
/* 798 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"top-right-corner\">\n                        <button type=\"button\"\n                                class=\"btn btn-edit\"\n                                ng-click=\"vmc.openModal()\">Edit</button>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-md-10\">\n                            <div class=\"blnd-data-field\">\n                                <div>Program ID</div>\n                                <div ng-bind=\"vmc.object.program_id || 'Please set ID'\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-10\">\n                            <div class=\"blnd-data-field\">\n                                <div>Name</div>\n                                <div ng-bind=\"vmc.object.name\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row top-space\">\n                        <div class=\"col-md-12\">\n                            <div class=\"blnd-data-field\">\n                                <div>Products</div>\n                                <div>\n                                    <blnd-chemical-products ng-model=\"vmc.object.products\" mode=\"view\"></blnd-chemical-products>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"search-query\">\n    <form novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-7\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       placeholder=\"Type to search..\"\n                       ng-model=\"vm.params.search\"\n                       ng-keyup=\"$event.keyCode == 13 && vm.refresh()\" />\n            </div>\n            <div class=\"col-md-3\">\n                <blnd-active-filter ng-model=\"vm.params.is_active\" ng-change=\"vm.refresh()\"></blnd-active-filter>\n            </div>\n            <div class=\"col-md-2\">\n                <button type=\"button\" class=\"btn btn-add btn-block\" ng-click=\"vm.openModal()\">Add</button>\n            </div>\n        </div>\n    </form>\n</div>\n<div loading-container=\"vm.table.params.settings().$loading\">\n    <table ng-table=\"vm.table.params\" class=\"table table-fixed table-sortable table-clickable\">\n        <tr ng-click=\"vm.selectRow(object.id)\"\n            ng-repeat=\"object in $data\"\n            ng-class=\"{active: object.id === vm.selectedObject}\">\n            <td header=\"'headerCheckBox'\" class=\"col-checkbox\">\n                <input type=\"checkbox\"/>\n            </td>\n            <td class=\"col-id\" data-title=\"'ID'\">\n                <a ui-sref=\"r.admin.in.products.list.product({objectId: object.id})\" ng-bind=\"object.program_id\"></a>\n            </td>\n            <td data-title=\"'Name'\" ng-bind=\"object.name\"></td>\n            <td data-title=\"'Active'\">\n                <label><input type=\"checkbox\" ng-model=\"object.is_active\" disabled></label>\n            </td>\n        </tr>\n    </table>\n</div>\n"

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\".product\" ng-bind=\"object.title || 'Chemical Program'\"></a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\"><div ui-view></div>\n"

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _productInventory = __webpack_require__(802);
	
	var _productInventory2 = _interopRequireDefault(_productInventory);
	
	var _inventoryTransaction = __webpack_require__(803);
	
	var _inventoryTransaction2 = _interopRequireDefault(_inventoryTransaction);
	
	var _nutrient = __webpack_require__(757);
	
	var _nutrient2 = _interopRequireDefault(_nutrient);
	
	var _uiLocation = __webpack_require__(760);
	
	var _uiLocation2 = _interopRequireDefault(_uiLocation);
	
	var _ctrls = __webpack_require__(804);
	
	var _main = __webpack_require__(807);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _details = __webpack_require__(808);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _transactions = __webpack_require__(809);
	
	var _transactions2 = _interopRequireDefault(_transactions);
	
	var _tableSection = __webpack_require__(810);
	
	var _tableSection2 = _interopRequireDefault(_tableSection);
	
	var _detailSection = __webpack_require__(811);
	
	var _detailSection2 = _interopRequireDefault(_detailSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'admin.company.inventory',
	    modules: [_routing2.default, _nutrient2.default, _uiLocation2.default, _productInventory2.default, _inventoryTransaction2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.inventory',
	    url: '/inventory',
	    template: _main2.default,
	    abstract: '.list',
	    data: {
	        permissions: {
	            only: ['main.view_productinventory']
	        }
	    },
	    ncyBreadcrumb: {
	        skip: true,
	        parent: 'r.in.top.admin.company'
	    }
	}), _dec3 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.inventory.list',
	    url: '?search',
	    views: {
	        tableView: {
	            template: _tableSection2.default,
	            controller: _ctrls.ProductsCtrl
	        },
	        detailsView: {
	            template: _detailSection2.default
	        }
	    },
	    ncyBreadcrumb: {
	        label: 'Inventory'
	    }
	}), _dec4 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.inventory.list.product',
	    url: '/{objectId:int}',
	    template: '<ui-view/>',
	    abstract: '.detail',
	    ncyBreadcrumb: {
	        skip: true
	    },
	    controller: ["$rootScope", "$scope", "$stateParams", function controller($rootScope, $scope, $stateParams) {
	        "ngInject";
	
	        $rootScope.selectedObject = $stateParams.objectId;
	        $scope.$on('$destroy', function () {
	            delete $rootScope.selectedObject;
	        });
	    }],
	    resolve: {
	        $object: function $object($stateParams, ProductInventoryStore) {
	            return ProductInventoryStore.get($stateParams.objectId);
	        }
	    }
	}), _dec5 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.inventory.list.product.detail',
	    url: '',
	    controller: _ctrls.ProductCtrl,
	    template: _details2.default,
	    ncyBreadcrumb: {
	        label: '{{ vm.object.product.description }}'
	    }
	}), _dec6 = (0, _decorators.State)({
	    name: 'r.in.top.admin.company.inventory.list.product.transactions',
	    url: '/transactions',
	    controller: _ctrls.TransactionsCtrl,
	    template: _transactions2.default,
	    ncyBreadcrumb: {
	        label: '{{ vm.object.product.description }}'
	    }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.productInventory',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('ProductInventoryStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('product_inventory');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Store = (_dec = (0, _decorators.Module)({
	    name: 'app.store.inventoryTransaction',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('InventoryTransactionStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    Store.$inject = ["$q", "R"];
	    _inherits(Store, _BaseStore);
	
	    function Store($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, Store);
	
	        var _this = _possibleConstructorReturn(this, (Store.__proto__ || Object.getPrototypeOf(Store)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('inventory_transactions');
	        return _this;
	    }
	
	    return Store;
	}(_base2.default)) || _class) || _class);
	exports.default = Store;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TransactionsCtrl = exports.ProductCtrl = exports.ProductsCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(366);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _editModal = __webpack_require__(805);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	var _addTransModal = __webpack_require__(806);
	
	var _addTransModal2 = _interopRequireDefault(_addTransModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductsCtrl = exports.ProductsCtrl = function () {
	    ProductsCtrl.$inject = ["NgTableParams", "$rootScope", "$state", "$growl", "Modal", "$company", "ProductInventoryStore"];
	    function ProductsCtrl(NgTableParams, $rootScope, $state, $growl, Modal, $company, ProductInventoryStore) {
	        "ngInject";
	
	        _classCallCheck(this, ProductsCtrl);
	
	        var self = this;
	        this.Modal = Modal;
	        this.company = $company;
	        this.$growl = $growl;
	        this.$state = $state;
	        this.params = {
	            page_size: 20,
	            ordering: 'diff'
	        };
	        this.store = ProductInventoryStore;
	        this.store.init();
	
	        $rootScope.$watch('selectedObject', function (newValue) {
	            self.selectedObject = newValue;
	        });
	
	        // Filter configurations by company ID;
	
	        this.params.company = this.company.id;
	
	        this.table = new _table2.default(NgTableParams, this.store, { defaultParams: this.params });
	    }
	
	    _createClass(ProductsCtrl, [{
	        key: 'selectRow',
	        value: function selectRow(objectId) {
	            this.selectedObject = objectId;
	            this.$state.go('r.in.top.admin.company.inventory.list.product', { objectId: objectId });
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            return this.table.refresh(this.params);
	        }
	    }]);
	
	    return ProductsCtrl;
	}();
	
	var EditInventoryCtrl = function () {
	    EditInventoryCtrl.$inject = ["R", "$uibModalInstance", "$state", "object"];
	    function EditInventoryCtrl(R, $uibModalInstance, $state, object) {
	        "ngInject";
	
	        _classCallCheck(this, EditInventoryCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.$state = $state;
	        this.object = object;
	        this.R = R;
	        this.data = this.R.copy(this.object);
	        this.errors = {};
	    }
	
	    _createClass(EditInventoryCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	
	            self.loading = true;
	            self.data.put().then(function (response) {
	                _angular2.default.extend(self.object, response);
	                self.$modal.close();
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Edit ' + this.object.product.description;
	        }
	    }]);
	
	    return EditInventoryCtrl;
	}();
	
	var AddTransCtrl = function () {
	    AddTransCtrl.$inject = ["R", "$uibModalInstance", "productInventory", "InventoryTransactionStore"];
	    function AddTransCtrl(R, $uibModalInstance, productInventory, InventoryTransactionStore) {
	        "ngInject";
	
	        _classCallCheck(this, AddTransCtrl);
	
	        this.$modal = $uibModalInstance;
	        this.store = InventoryTransactionStore;
	        this.object = productInventory;
	        this.R = R;
	        this.data = {
	            amount: 0,
	            product: productInventory.product.id,
	            company: productInventory.company.id
	        };
	        this.errors = {};
	    }
	
	    _createClass(AddTransCtrl, [{
	        key: 'close',
	        value: function close() {
	            this.$modal.dismiss();
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            var self = this;
	            self.loading = true;
	            self.store.create(self.data).then(function (response) {
	                self.$modal.close();
	            }, function (response) {
	                self.errors = response.data;
	            }).finally(function () {
	                return self.loading = false;
	            });
	        }
	    }, {
	        key: 'title',
	        get: function get() {
	            return 'Add ' + this.object.product.title + ' transaction';
	        }
	    }]);
	
	    return AddTransCtrl;
	}();
	
	var ProductCtrl = exports.ProductCtrl = function () {
	    ProductCtrl.$inject = ["$rootScope", "$state", "Modal", "$growl", "$object", "$company"];
	    function ProductCtrl($rootScope, $state, Modal, $growl, $object, $company) {
	        "ngInject";
	
	        _classCallCheck(this, ProductCtrl);
	
	        this.object = $object;
	        this.company = $company;
	        this.$growl = $growl;
	        this.$state = $state;
	        this.Modal = Modal;
	
	        $rootScope.object = this.object;
	    }
	
	    _createClass(ProductCtrl, [{
	        key: 'editModal',
	        value: function editModal() {
	            var _this = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _editModal2.default,
	                controller: EditInventoryCtrl,
	                resolve: {
	                    object: function object() {
	                        return _this.object;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.$growl.updated();
	            });
	        }
	    }]);
	
	    return ProductCtrl;
	}();
	
	var TransactionsCtrl = exports.TransactionsCtrl = function () {
	    TransactionsCtrl.$inject = ["$rootScope", "$object", "$company", "R", "$growl", "Modal", "InventoryTransactionStore", "NgTableParams"];
	    function TransactionsCtrl($rootScope, $object, $company, R, $growl, Modal, InventoryTransactionStore, NgTableParams) {
	        "ngInject";
	
	        _classCallCheck(this, TransactionsCtrl);
	
	        this.object = $object;
	        this.company = $company;
	        this.Modal = Modal;
	        this.$growl = $growl;
	        this.R = R;
	        $rootScope.object = this.object;
	        var start = (0, _moment2.default)().startOf('week');
	        var end = (0, _moment2.default)().endOf('week');
	
	        this.params = {
	            page_size: 30,
	            company: $company.id,
	            product: $object.product.id,
	            created_at__range: start.format('YYYY-MM-DD') + ',' + end.format('YYYY-MM-DD')
	        };
	        this.table = new _table2.default(NgTableParams, InventoryTransactionStore, { defaultParams: this.params });
	        this.refreshUsage();
	        this.usage = '0.0';
	    }
	
	    _createClass(TransactionsCtrl, [{
	        key: 'openAddTransaction',
	        value: function openAddTransaction() {
	            var _this2 = this;
	
	            var self = this;
	            var $modal = this.Modal.open({
	                template: _addTransModal2.default,
	                controller: AddTransCtrl,
	                resolve: {
	                    productInventory: function productInventory() {
	                        return _this2.object;
	                    }
	                }
	            });
	
	            $modal.result.then(function () {
	                self.object.get().then(function (obj) {
	                    return _angular2.default.extend(self.object, obj);
	                });
	                self.table.refresh(self.params);
	                self.$growl.added();
	            });
	        }
	    }, {
	        key: 'refreshUsage',
	        value: function refreshUsage() {
	            var self = this;
	            var params = {
	                company: this.company.id,
	                created_at__range: this.params.created_at__range
	            };
	            var q = this.R.one('product_inventory', this.object.id).customGET('usage', params);
	            q.then(function (data) {
	                self.usage = data.sum;
	            });
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            this.refreshUsage();
	            return this.table.refresh(this.params);
	        }
	    }]);
	
	    return TransactionsCtrl;
	}();

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"inventory-product-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n                type=\"button\"\n                class=\"close\"\n                data-dismiss=\"modal\"\n                aria-label=\"Close\"\n                ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Available</label>\n                    <div>\n                        <input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"vm.data.available\" form-error>\n                        <span ng-bind=\"vm.object.product.units.id\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Low Threshold</label>\n                    <div>\n                        <input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"vm.data.low_threshold\" form-error>\n                        <span ng-bind=\"vm.object.product.units.id\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Capacity</label>\n                    <div>\n                        <input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"vm.data.capacity\" form-error>\n                        <span ng-bind=\"vm.object.product.units.id\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" class=\"product-transaction-modal\" novalidate>\n    <div class=\"modal-header\">\n        <button\n                type=\"button\"\n                class=\"close\"\n                data-dismiss=\"modal\"\n                aria-label=\"Close\"\n                ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-4\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Amount</label>\n                    <div>\n                        <input class=\"form-control\" type=\"number\" step=\"0.01\" ng-model=\"vm.data.amount\" form-error>\n                        <span ng-bind=\"vm.object.product.units.id\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"form-group form-group-sm\">\n                    <label class=\"control-label\">Notes</label>\n                    <textarea class=\"form-control\" ng-model=\"vm.data.notes\" form-error>\n                    </textarea>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Add</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"inventory-page\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div ui-view=\"tableView\"></div>\n        </div>\n        <div class=\"col-md-6\">\n            <div ui-view=\"detailsView\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"objectiguration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <div class=\"top-right-corner\">\n                        <button type=\"button\"\n                                class=\"btn btn-edit\"\n                                permission permission-only=\"'main.change_productinventory'\"\n                                ng-click=\"vm.editModal()\">Edit</button>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>ID</div>\n                                <div ng-bind=\"vm.object.product.id\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <div class=\"blnd-data-field\">\n                                <div>Name</div>\n                                <div ng-bind=\"vm.object.product.description\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Available</div>\n                                <div>\n                                    <span ng-bind=\"vm.object.available\"></span>\n                                    <span ng-bind=\"vm.object.product.units.id\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <div class=\"blnd-data-field\">\n                                <div>Low Threshold</div>\n                                <div>\n                                    <span ng-bind=\"vm.object.low_threshold || '-'\"></span>\n                                    <span ng-show=\"vm.object.low_threshold\" ng-bind=\"vm.object.product.units.id\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-md-4\">\n                            <div class=\"blnd-data-field\">\n                                <div>Capacity</div>\n                                <div>\n                                    <span ng-bind=\"vm.object.capacity || '-'\"></span>\n                                    <span ng-show=\"vm.object.capacity\" ng-bind=\"vm.object.product.units.id\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"panel panel-default blnd-panel\">\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"objectiguration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <h4>\n                        <span>Transactions</span>\n                        <button class=\"btn btn-xs btn-default pull-right\" ng-click=\"vm.openAddTransaction()\">Add</button>\n                    </h4>\n                    <blnd-date-range-picker\n                            ng-model=\"vm.params.created_at__range\"\n                            ng-change=\"vm.refresh()\"\n                            format=\"string\"\n                    ></blnd-date-range-picker>\n                </div>\n                <div class=\"panel-body\">\n                    <div class=\"form-inline\">\n                        <strong>Usage:</strong> <input class=\"form-control input-inline\" type=\"text\" readonly ng-model=\"vm.usage\"> <strong ng-bind=\"vm.object.product.units.id\"></strong>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <table ng-table=\"vm.table.params\" class=\"table table-condensed table-transactions\">\n                        <tr ng-repeat=\"object in $data\">\n                            <td class=\"col-date\" data-title=\"'Date'\" ng-bind=\"object.created_at | blndDate\"></td>\n                            <td class=\"col-amount\" data-title=\"'Amount'\" ng-bind=\"object.amount\"></td>\n                            <td class=\"col-ticket-slug\" data-title=\"'Ticket ID'\" >\n                                <a ui-sref=\"r.in.top.tickets.detail({ticketId: object.ticket.id})\"\n                                   ng-bind=\"object.ticket.id\">\n                                </a>\n                            </td>\n                            <td data-title=\"'Notes'\" ng-bind=\"object.notes\"></td>\n                        </tr>\n                    </table>\n                    <no-data params=\"vm.table.params\">No transactions</no-data>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"search-query\">\n    <form novalidate>\n        <div class=\"row\">\n            <div class=\"col-md-12\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       placeholder=\"Type to search..\"\n                       ng-model=\"vm.params.search\"\n                       ng-keyup=\"$event.keyCode == 13 && vm.refresh()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div loading-container=\"vm.table.params.settings().$loading\">\n    <table ng-table=\"vm.table.params\" class=\"table table-fixed table-sortable table-clickable\">\n        <tr ng-click=\"vm.selectRow(object.id)\"\n            ng-repeat=\"object in $data\"\n            ng-class=\"{active: object.id === vm.selectedObject}\">\n\n            <td data-title=\"'ID'\" ng-bind=\"object.product.id\" sortable=\"'id'\"></td>\n            <td data-title=\"'Name'\" ng-bind=\"object.product.description\" sortable=\"'product'\"></td>\n            <td data-title=\"'Units'\" ng-bind=\"object.product.units.name\"></td>\n            <td data-title=\"'Available'\" ng-bind=\"object.available\" sortable=\"'available'\"></td>\n            <td data-title=\"'Threshold'\" ng-bind=\"object.low_threshold || '-'\" sortable=\"'low_threshold'\"></td>\n            <td data-title=\"'Diff'\" ng-bind=\"object.diff || '-'\" sortable=\"'diff'\"></td>\n            <td data-title=\"'Capacity'\" ng-bind=\"object.capacity || '-'\" sortable=\"'capacity'\"></td>\n        </tr>\n    </table>\n</div>\n"

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav nav-tabs\" ng-if=\"selectedObject\">\n    <li role=\"presentation\" class=\"clickable\" ng-class=\"{'disabled': object === null}\" ui-sref-active=\"active\">\n        <a ui-sref=\"^.detail\">Inventory</a>\n    </li>\n    <li role=\"presentation\" class=\"clickable\" ng-class=\"{'disabled': object === null}\" ui-sref-active=\"active\">\n        <a ui-sref=\"^.transactions\">Transactions</a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\" ui-view></div>\n"

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _hit_percentage = __webpack_require__(813);
	
	var _hit_percentage2 = _interopRequireDefault(_hit_percentage);
	
	var _ctrls = __webpack_require__(814);
	
	var _main = __webpack_require__(818);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _details = __webpack_require__(819);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _tableSection = __webpack_require__(820);
	
	var _tableSection2 = _interopRequireDefault(_tableSection);
	
	var _detailSection = __webpack_require__(821);
	
	var _detailSection2 = _interopRequireDefault(_detailSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	  name: "app.admin.hit_percentages",
	  modules: [_routing2.default, _hit_percentage2.default]
	}), _dec2 = (0, _decorators.State)({
	  name: "r.in.top.admin.hit_percentages",
	  url: "/hit-percentages",
	  template: _main2.default,
	  ncyBreadcrumb: {
	    skip: true
	  },
	  abstract: ".list",
	  data: {
	    permissions: {
	      only: ["main.view_user"]
	    }
	  }
	}), _dec3 = (0, _decorators.State)({
	  name: "r.in.top.admin.hit_percentages.list",
	  url: "?search",
	  views: {
	    tableView: {
	      template: _tableSection2.default,
	      controller: _ctrls.HitPercentageListCtrl
	    },
	    detailsView: {
	      template: _detailSection2.default,
	      controller: _ctrls.HitPercentageCtrl
	    }
	  },
	  resolve: {
	    $object: function $object() {
	      return null;
	    }
	  },
	  ncyBreadcrumb: {
	    label: "Hit Percentages for Forecasting"
	  }
	}), _dec4 = (0, _decorators.State)({
	  name: "r.in.top.admin.hit_percentages.list.hit_percentage",
	  url: "/{objectId:int}",
	  ncyBreadcrumb: {
	    skip: true
	  },
	  template: "<ui-view/>",
	  resolve: {
	    $object: function $object($stateParams, HitPercentageStore) {
	      return HitPercentageStore.get($stateParams.objectId);
	    }
	  },
	  abstract: ".detail"
	}), _dec5 = (0, _decorators.State)({
	  name: "r.in.top.admin.hit_percentages.list.hit_percentage.detail",
	  url: "/details",
	  controller: _ctrls.HitPercentageCtrl,
	  template: _details2.default,
	  ncyBreadcrumb: {
	    label: "{{ vm.object.hit_percentage }}"
	  }
	}), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = function States() {
	  _classCallCheck(this, States);
	}) || _class) || _class) || _class) || _class) || _class);
	exports.default = States;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _resource = __webpack_require__(498);
	
	var _resource2 = _interopRequireDefault(_resource);
	
	var _base = __webpack_require__(500);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HitPercentageStore = (_dec = (0, _decorators.Module)({
	    name: 'app.store.hit_percentage',
	    modules: [_resource2.default]
	}), _dec2 = (0, _decorators.Service)('HitPercentageStore'), _dec(_class = _dec2(_class = function (_BaseStore) {
	    HitPercentageStore.$inject = ["$q", "R"];
	    _inherits(HitPercentageStore, _BaseStore);
	
	    function HitPercentageStore($q, R) {
	        "ngInject";
	
	        _classCallCheck(this, HitPercentageStore);
	
	        var _this = _possibleConstructorReturn(this, (HitPercentageStore.__proto__ || Object.getPrototypeOf(HitPercentageStore)).call(this, $q, R));
	
	        _this.endpoint = _this.R.all('hit-percentages');
	        return _this;
	    }
	
	    return HitPercentageStore;
	}(_base2.default)) || _class) || _class);
	exports.default = HitPercentageStore;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HitPercentageCtrl = exports.HitPercentageListCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _table = __webpack_require__(593);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _addModal = __webpack_require__(815);
	
	var _addModal2 = _interopRequireDefault(_addModal);
	
	var _editModal = __webpack_require__(816);
	
	var _editModal2 = _interopRequireDefault(_editModal);
	
	var _deleteModal2 = __webpack_require__(817);
	
	var _deleteModal3 = _interopRequireDefault(_deleteModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditHitPercentageModalCtrl = function () {
	  EditHitPercentageModalCtrl.$inject = ["R", "$uibModalInstance", "$state", "object"];
	  function EditHitPercentageModalCtrl(R, $uibModalInstance, $state, object) {
	    "ngInject";
	
	    _classCallCheck(this, EditHitPercentageModalCtrl);
	
	    this.object = object;
	    this.R = R;
	    this.data = this.R.copy(object);
	    this.$state = $state;
	    this.$modal = $uibModalInstance;
	  }
	
	  _createClass(EditHitPercentageModalCtrl, [{
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var self = this;
	      this.data.put().then(function (data) {
	        _angular2.default.extend(self.object, data);
	        self.$state.go("r.in.top.admin.hit_percentages.list", {
	          reload: true
	        });
	        self.$modal.close(data.id);
	      }, function (resp) {
	        self.errors = resp.data;
	      }, self.$state.reload()).finally(function () {
	        return self.loading = false;
	      });
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Hit percentage: " + this.object.name;
	    }
	  }]);
	
	  return EditHitPercentageModalCtrl;
	}();
	
	var HitPercentageListCtrl = exports.HitPercentageListCtrl = function () {
	  HitPercentageListCtrl.$inject = ["NgTableParams", "Modal", "$growl", "$state", "$stateParams", "HitPercentageStore"];
	  function HitPercentageListCtrl(NgTableParams, Modal, $growl, $state, $stateParams, HitPercentageStore) {
	    "ngInject";
	
	    _classCallCheck(this, HitPercentageListCtrl);
	
	    this.Modal = Modal;
	    this.$growl = $growl;
	    this.$state = $state;
	    this.selectedObject = $stateParams.objectId;
	
	    this.defaultParams = {
	      page_size: 20
	    };
	
	    this.resetParams();
	
	    this.table = new _table2.default(NgTableParams, HitPercentageStore, {
	      defaultParams: this.defaultParams,
	      params: this.params
	    });
	
	    if ($state.params && $state.params.objectId) {
	      this.selectedObject = $state.params.objectId;
	    }
	  }
	
	  _createClass(HitPercentageListCtrl, [{
	    key: "addHitPercentage",
	    value: function addHitPercentage() {
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _addModal2.default,
	        controller: CreateHitPercentageCtrl
	      });
	
	      $modal.result.then(function (objectId) {
	        self.$growl.added();
	        self.$state.go("r.in.top.admin.hit_percentages.list.hit_percentage", {
	          objectId: objectId
	        });
	        self.$state.reload();
	      });
	    }
	  }, {
	    key: "selectRow",
	    value: function selectRow(objectId) {
	      this.selectedObject = objectId;
	      this.$state.go("r.in.top.admin.hit_percentages.list.hit_percentage", {
	        objectId: objectId
	      });
	    }
	  }, {
	    key: "resetParams",
	    value: function resetParams() {
	      this.params = _.clone(this.defaultParams);
	    }
	  }, {
	    key: "refresh",
	    value: function refresh() {
	      return this.table.refresh(this.params);
	    }
	  }]);
	
	  return HitPercentageListCtrl;
	}();
	
	var CreateHitPercentageCtrl = function () {
	  CreateHitPercentageCtrl.$inject = ["$uibModalInstance", "HitPercentageStore"];
	  function CreateHitPercentageCtrl($uibModalInstance, HitPercentageStore) {
	    "ngInject";
	
	    _classCallCheck(this, CreateHitPercentageCtrl);
	
	    this.$modal = $uibModalInstance;
	    this.store = HitPercentageStore;
	    this.data = {
	      is_active: false
	    };
	  }
	
	  _createClass(CreateHitPercentageCtrl, [{
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var self = this;
	      self.loading = true;
	      this.store.create(this.data).then(function (data) {
	        self.$modal.close(data.id);
	      }, function (resp) {
	        self.errors = resp.data;
	      }).finally(function () {
	        return self.loading = false;
	      });
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Create new hit percentage";
	    }
	  }]);
	
	  return CreateHitPercentageCtrl;
	}();
	
	var DeleteHitPercentageCtrl = function () {
	  DeleteHitPercentageCtrl.$inject = ["R", "$uibModalInstance", "$state", "object"];
	  function DeleteHitPercentageCtrl(R, $uibModalInstance, $state, object) {
	    "ngInject";
	
	    _classCallCheck(this, DeleteHitPercentageCtrl);
	
	    this.object = object;
	    this.R = R;
	    this.data = this.R.copy(object);
	    this.$state = $state;
	    this.$modal = $uibModalInstance;
	  }
	
	  _createClass(DeleteHitPercentageCtrl, [{
	    key: "close",
	    value: function close() {
	      this.$modal.dismiss();
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var self = this;
	      var old_data = this.R.copy(this.data);
	      this.data.remove().then(function (data) {
	        _angular2.default.extend(self.object, data);
	        self.$state.go("r.in.top.admin.hit_percentages.list", {
	          reload: true
	        });
	        self.$modal.close(old_data.id);
	      }, function (resp) {
	        self.errors = resp.data;
	      }, self.$state.reload()).finally(function () {
	        return self.loading = false;
	      });
	    }
	  }, {
	    key: "title",
	    get: function get() {
	      return "Delete hit percentage " + this.object.rate_pct + "%?";
	    }
	  }]);
	
	  return DeleteHitPercentageCtrl;
	}();
	
	var HitPercentageCtrl = exports.HitPercentageCtrl = function () {
	  HitPercentageCtrl.$inject = ["$rootScope", "Modal", "$growl", "$object"];
	  function HitPercentageCtrl($rootScope, Modal, $growl, $object) {
	    "ngInject";
	
	    _classCallCheck(this, HitPercentageCtrl);
	
	    this.object = $object;
	    this.$growl = $growl;
	    this.Modal = Modal;
	    $rootScope.object = this.object;
	  }
	
	  _createClass(HitPercentageCtrl, [{
	    key: "editModal",
	    value: function editModal() {
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _editModal2.default,
	        controller: EditHitPercentageModalCtrl,
	        resolve: {
	          object: function object() {
	            return self.object;
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        self.$growl.updated();
	      });
	    }
	  }, {
	    key: "deleteModal",
	    value: function deleteModal() {
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _deleteModal3.default,
	        controller: DeleteHitPercentageCtrl,
	        resolve: {
	          object: function object() {
	            return self.object;
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        self.$growl.updated();
	      });
	    }
	  }]);
	
	  return HitPercentageCtrl;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)))

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Rate %</label>\n                    <input type=\"text\" class=\"form-control\" name=\"rate_pct\" ng-model=\"vm.data.rate_pct\" form-error />\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Name</label>\n                    <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.data.name\" form-error />\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">Save</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Cancel</button>\n    </div>\n</form>\n"

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3>Edit</h3>\n        <h4 class=\"modal-title\" ng-bind=\"vm.title\"></h4>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <div class=\"col-md-8\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Rate %</label>\n                    <input type=\"text\" class=\"form-control\" name=\"rate_pct\" ng-model=\"vm.data.rate_pct\" form-error />\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-8\">\n                <div class=\"form-group\">\n                    <label class=\"control-label\">Name</label>\n                    <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.data.name\" form-error />\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-submit\" type=\"button\" ng-click=\"vm.submit()\">\n            Save\n        </button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">\n            Cancel\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" ng-bind=\"vm.title\"></h3>\n    </div>\n    <div class=\"modal-body\">\n        <div class=\"row\">\n            <h4 class=\"modal-body\">\n                Are you sure you want to delete this hit percentage?\n            </h4>\n        </div>\n        <div class=\"modal-body\">\n            <div class=\"row\">\n                <div class=\"blnd-data-field col-md-10\">\n                    <div>Rate %</div>\n                    <div ng-bind=\"vm.object.rate_pct\"></div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"blnd-data-field col-md-10\">\n                    <div>Name</div>\n                    <div ng-bind=\"vm.object.name\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-delete\" type=\"button\" ng-click=\"vm.submit()\">\n            Delete hit percentage\n        </button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">\n            Cancel\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 818 */
751,
/* 819 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-6\">\n            <div class=\"panel panel-default blnd-panel blnd-panel-admin\">\n                <div class=\"panel-body\">\n                    <div class=\"top-left-corner\" permission permission-only=\"'main.change_user'\">\n                        <button type=\"button\" class=\"btn btn-edit\" ng-click=\"vm.editModal()\">\n                            Edit\n                        </button>\n                    </div>\n                    <div class=\"top-right-corner\" permission permission-only=\"'main.change_user'\">\n                        <button type=\"button\" class=\"btn btn-delete\" ng-click=\"vm.deleteModal()\">\n                            Delete\n                        </button>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"blnd-data-field\">\n                            <div>Rate %</div>\n                            <div ng-bind=\"vm.object.rate_pct\"></div>\n                        </div>\n                        <div class=\"blnd-data-field\">\n                            <div>Name</div>\n                            <div ng-bind=\"vm.object.name\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"search-query\">\n  <form novalidate>\n    <div class=\"row\">\n      <div class=\"col-md-6\">\n        <input type=\"text\" class=\"form-control\" placeholder=\"Type to search..\" ng-model=\"vm.params.search\"\n          ng-keyup=\"$event.keyCode == 13 && vm.refresh()\" />\n      </div>\n      <div class=\"col-md-2\">\n        <button type=\"button\" ng-click=\"vm.addHitPercentage()\" class=\"btn btn-block btn-add\">\n          Add\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n<div loading-container=\"vm.table.params.settings().$loading\">\n  <table ng-table=\"vm.table.params\" class=\"table table-fixed table-sortable table-clickable\">\n    <tr ng-click=\"vm.selectRow(object.id)\" ng-repeat=\"object in $data\"\n      ng-class=\"{active: object.id === vm.selectedObject}\">\n      <td data-title=\"'Rate %'\" ng-bind=\"object.rate_pct\"></td>\n      <td data-title=\"'Name'\" ng-bind=\"object.name\"></td>\n    </tr>\n  </table>\n</div>\n"

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\".hit_percentage\" ng-bind=\"'Hit percentage'\"></a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\">\n    <div ui-view></div>\n"

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _hit_percentage = __webpack_require__(813);
	
	var _hit_percentage2 = _interopRequireDefault(_hit_percentage);
	
	var _react = __webpack_require__(552);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ctrls = __webpack_require__(823);
	
	var _ticket = __webpack_require__(650);
	
	var _ticket2 = _interopRequireDefault(_ticket);
	
	var _company = __webpack_require__(514);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _product = __webpack_require__(651);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _mixCalculator = __webpack_require__(824);
	
	var _mixCalculator2 = _interopRequireDefault(_mixCalculator);
	
	var _secure = __webpack_require__(633);
	
	var _secure2 = _interopRequireDefault(_secure);
	
	var _user = __webpack_require__(503);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var States = (_dec = (0, _decorators.Module)({
	  name: "app.admin.mix_calculator",
	  modules: [_routing2.default, _hit_percentage2.default, _react2.default, _ticket2.default, _product2.default, _company2.default, _secure2.default, _user2.default]
	}), _dec2 = (0, _decorators.State)({
	  name: "r.in.top.admin.mix_calculator",
	  url: "/mix-calculator",
	  controllerProvider: ["Config", function controllerProvider(Config) {
	    "ngInject";
	
	    var useReact = Config.isFeatureFlagActive('REACT_MIX_CALCULATOR');
	    return useReact ? function () {} : _ctrls.MixCalculatorCtrl;
	  }],
	  templateProvider: ["Config", function templateProvider(Config) {
	    "ngInject";
	
	    var useReact = Config.isFeatureFlagActive('REACT_MIX_CALCULATOR');
	    return useReact ? "<div react-view=\"mix-calculator\"></div>" : _mixCalculator2.default;
	  }],
	  ncyBreadcrumb: {
	    label: "Mix Calculator"
	  },
	  data: {
	    permissions: {
	      only: ["main.change_order"]
	    }
	  },
	  resolve: {
	    $ticket: function $ticket(Config, TicketStore) {
	      if (Config.isFeatureFlagActive('REACT_MIX_CALCULATOR')) {
	        return null;
	      }
	      return TicketStore.get('mix-calculator');
	    },
	    $prodConf: function $prodConf(Config, ProductConfStore, $ticket) {
	      if (Config.isFeatureFlagActive('REACT_MIX_CALCULATOR')) {
	        return null;
	      }
	      ProductConfStore.params.company = $ticket.company.id;
	      return ProductConfStore.refresh();
	    },
	    $company: function $company(Config, CompanyStore, $ticket, UserService) {
	      if (Config.isFeatureFlagActive('REACT_MIX_CALCULATOR')) {
	        return null;
	      }
	      if (UserService.$user.default_company) {
	        return CompanyStore.get(UserService.$user.default_company);
	      } else {
	        return CompanyStore.get($ticket.company.id);
	      }
	    },
	    $secureUrlService: function $secureUrlService(Config, SecureUrlService) {
	      if (Config.isFeatureFlagActive('REACT_MIX_CALCULATOR')) {
	        return null;
	      }
	      return SecureUrlService;
	    }
	  }
	}), _dec(_class = _dec2(_class = function States() {
	  _classCallCheck(this, States);
	}) || _class) || _class);
	exports.default = States;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MixCalculatorCtrl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ctrls = __webpack_require__(653);
	
	var _ctrls2 = __webpack_require__(544);
	
	var _modalList = __webpack_require__(545);
	
	var _modalList2 = _interopRequireDefault(_modalList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MixCalculatorCtrl = exports.MixCalculatorCtrl = function () {
	  MixCalculatorCtrl.$inject = ["R", "$growl", "$location", "$timeout", "$ticket", "$prodConf", "$company", "$state", "UserService", "Modal", "$secureUrlService"];
	  function MixCalculatorCtrl(R, $growl, $location, $timeout, $ticket, $prodConf, $company, $state, UserService, Modal, $secureUrlService) {
	    "ngInject";
	
	    var _this = this;
	
	    _classCallCheck(this, MixCalculatorCtrl);
	
	    this.$growl = $growl;
	    this.$timeout = $timeout;
	    this.company = $company;
	    this.ticket = $ticket;
	    this.R = R;
	    this.$state = $state;
	    this.userDefaultCompany = UserService.$user.default_company;
	    this.data = R.copy(this.ticket);
	    this.prodConf = $prodConf;
	    this.data.company = this.company;
	    this.prodConf.params.company = this.userDefaultCompany;
	    this.isLoading = true;
	    this.prodConf.refresh().then(function () {
	      _this.fieldConf = new _ctrls.FieldConf(_this.data, _this.prodConf);
	      _this.isLoading = false;
	    });
	    this.tRecalc = new _ctrls.TicketRecalc(this.data, this.fieldConf);
	    this.loading = {};
	    this.acresStatus = "";
	    this.saveDisabled = true;
	    this.companyChanged = false;
	    this.Modal = Modal;
	    this.secureUrlService = $secureUrlService;
	    this.calculateClicked = false;
	
	    if (this.company.custom_delay !== null && this.data.delay === null) {
	      this.data.delay = this.company.custom_delay;
	    }
	
	    $location.hash(""); // clear
	  }
	
	  _createClass(MixCalculatorCtrl, [{
	    key: "onCompanyChange",
	    value: function onCompanyChange() {
	      var _this2 = this;
	
	      this.prodConf.params.company = this.data.company.id;
	      this.data = this.R.copy(this.ticket);
	      this.isLoading = true;
	      this.prodConf.refresh().then(function () {
	        _this2.fieldConf = new _ctrls.FieldConf(_this2.data, _this2.prodConf);
	        _this2.isLoading = false;
	      });
	      this.tRecalc = new _ctrls.TicketRecalc(this.data, this.fieldConf);
	      this.calculateClicked = false;
	    }
	  }, {
	    key: "onCustomerChange",
	    value: function onCustomerChange() {
	      this.data.freight_zone = this.data.customer.freight_zone;
	    }
	  }, {
	    key: "onAcresModelChange",
	    value: function onAcresModelChange() {
	      this.tRecalc.acres();
	      this.data.is_acres_touched = true;
	    }
	  }, {
	    key: "onQuantityChange",
	    value: function onQuantityChange() {
	      this.tRecalc.quantity();
	      this.data.is_acres_touched = true;
	    }
	  }, {
	    key: "handleFormulationErrors",
	    value: function handleFormulationErrors(errors) {
	      this.saveDisabled = true;
	      this.calc("calc", false);
	    }
	  }, {
	    key: "handleErrors",
	    value: function handleErrors(errors) {
	      if (errors.formulation) {
	        this.handleFormulationErrors(errors);
	      }
	      this.errors = this.fieldConf.handleErrors(errors);
	    }
	  }, {
	    key: "acresStatusCallback",
	    value: function acresStatusCallback() {
	      this.acresStatus = "";
	    }
	  }, {
	    key: "reCalculateAcres",
	    value: function reCalculateAcres(canReCalc) {
	      if (canReCalc) {
	        return;
	      }
	      this.data.acres = _.round(_.sum(_.map(this.data.fields, "field.acres")), 2);
	      this.tRecalc.acres();
	    }
	  }, {
	    key: "onAcresTouchChange",
	    value: function onAcresTouchChange(isChanged) {
	      this.reCalculateAcres(isChanged);
	    }
	  }, {
	    key: "onAcresChange",
	    value: function onAcresChange(action) {
	      if (this.data.is_acres_touched) {
	        this.acresStatus = "not-updated";
	      } else {
	        this.acresStatus = "updated";
	      }
	
	      this.reCalculateAcres(this.data.is_acres_touched);
	    }
	  }, {
	    key: "getData",
	    value: function getData() {
	      var data = _angular2.default.copy(this.data);
	      data.products = _.filter(data.products, function (o) {
	        return o.product;
	      }); // to avoid glitches
	      return data;
	    }
	  }, {
	    key: "beforeSend",
	    value: function beforeSend() {
	      var self = this;
	      self.data.gals = self.data.gals === "" ? null : self.data.gals;
	      self.data.lbs_gal = self.data.lbs_gal === "" ? null : self.data.lbs_gal;
	      self.data.id = "mix-calculator";
	    }
	  }, {
	    key: "calc",
	    value: function calc(btn) {
	      var _this3 = this;
	
	      var raise_exception = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var self = this;
	      var params = {};
	      btn = btn || "calc";
	      self.loading[btn] = true;
	      self.errors = {};
	      self.fieldConf.syncNutrientsToTicket();
	
	      if (btn === "calc_clay") {
	        params.calc_clay = 1;
	      }
	      var data = self.getData();
	      params.raise = raise_exception;
	      self.beforeSend();
	      self.data.one("calc").customPUT(data, null, params).then(function (response) {
	        if (btn === "calc_clay") {
	          self.fieldConf.setClay(response.formulation.clay || 0);
	        } else {
	          var newData = response.plain();
	          delete newData.products; // Do not remove last line if cals
	          _angular2.default.extend(self.data, newData);
	        }
	        if (raise_exception) {
	          self.saveDisabled = false;
	        }
	      }, function (response) {
	        if (response.status === 500) {
	          self.$growl.error("Server Error. We could not calculate formula!");
	          return;
	        }
	        self.handleErrors(response.data);
	      }).finally(function () {
	        return self.loading = {}, _this3.calculateClicked = true;
	      });
	    }
	  }, {
	    key: "submit",
	    value: function submit() {
	      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var self = this;
	      var params = {};
	
	      self.loading[close ? "submit" : "submitc"] = true;
	      self.fieldConf.syncNutrientsToTicket();
	      self.errors = {};
	      var data = self.getData();
	
	      data.products = "a";
	      self.beforeSend();
	      data.put(params).then(function (response) {
	        _angular2.default.extend(self.ticket, response);
	        if (close) {
	          var changed = !_angular2.default.equals(self.ticket.company, self.data.company);
	          _angular2.default.extend(self.ticket, response);
	          self.$growl.updated();
	          self.$modal.close({ companyChanged: changed, newId: response.id });
	        }
	      }, function (resp) {
	        if (resp.status === 500) {
	          self.$growl.error("Server Error. We could not calculate formula!");
	          return;
	        }
	        self.handleErrors(resp.data);
	      }).finally(function () {
	        return self.loading = {};
	      });
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.$state.go("r.in.top.admin");
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      var _this4 = this;
	
	      this.data = this.R.copy(this.ticket);
	      this.isLoading = true;
	      this.prodConf.refresh().then(function () {
	        _this4.fieldConf = new _ctrls.FieldConf(_this4.data, _this4.prodConf);
	        _this4.isLoading = false;
	      });
	      this.tRecalc = new _ctrls.TicketRecalc(this.data, this.fieldConf);
	      this.calculateClicked = false;
	    }
	  }, {
	    key: "print",
	    value: function print() {
	      var self = this;
	      var $modal = this.Modal.open({
	        template: _modalList2.default,
	        controller: _ctrls2.PrinterListModalCtrl,
	        size: 'large',
	        resolve: {
	          company: function company() {
	            return self.ticket.company.id;
	          },
	          request: function request() {
	            return {
	              endpoint: self.ticket.all('shipping-ticket').all('print'),
	              multiple: false
	            };
	          }
	        }
	      });
	
	      $modal.result.then(function () {
	        self.$state.go(self.$state.current, { created: false }, { reload: true });
	        self.$growl.success('Added file to queue');
	      });
	    }
	  }, {
	    key: "preview",
	    value: function preview() {
	      var self = this;
	      this.secureUrlService.openInNewWindow(self.ticket.one('shipping_ticket'), self.data);
	    }
	  }]);
	
	  return MixCalculatorCtrl;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)))

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"vm.submit()\" novalidate>\n  <div class=\"modal-header\">\n    <h3 class=\"modal-title action pull-left\">Mix Calculator</h3>\n    <ul class=\"nav\">\n      <li\n        role=\"presentation\"\n        class=\"action pull-right\"\n        permission\n      >\n        <button\n          type=\"button\"\n          class=\"btn btn-primary\"\n          ng-click=\"vm.preview()\"\n          ng-disabled=\"!vm.calculateClicked\"\n        >\n          Preview\n        </button>\n      </li>\n      <li\n        role=\"presentation\"\n        class=\"action pull-right\"\n        permission\n      >\n        <button\n          type=\"button\"\n          class=\"btn btn-primary\"\n          ng-click=\"vm.print()\"\n          ng-disabled=\"!vm.calculateClicked\"\n        >\n          Print\n        </button>\n      </li>\n    </ul>\n  </div>\n  <div class=\"modal-body\" loading-container=\"vm.isLoading\">\n    <ul class=\"nav nav-tabs top-space action pull-right\">\n      <li\n        role=\"presentation\"\n        permission\n      >\n        <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.reset()\">\n          Reset\n        </button>\n      </li>\n    </ul>\n    <section class=\"elements-form\">\n      <h4 id=\"info\">Information</h4>\n      <div class=\"row\">\n        <div class=\"col-sm-3\">\n          <div class=\"form-group form-group-sm\">\n            <label class=\"control-label\">Company</label>\n            <blnd-company-picker\n              ng-model=\"vm.data.company\"\n              mode=\"edit\"\n              test-id=\"admin-mix-calculator-company-picker\"\n              user=\"vm.user\"\n              ng-change=\"vm.onCompanyChange()\"\n              form-error\n            >\n            </blnd-company-picker>\n          </div>\n        </div>\n        <div class=\"col-sm-3\">\n          <div class=\"form-group\">\n            <label class=\"control-label\">Crop</label>\n            <blnd-crop-picker\n              allow-clear=\"true\"\n              ng-model=\"vm.data.crop\"\n              form-error\n            ></blnd-crop-picker>\n          </div>\n        </div>\n      </div>\n    </section>\n    <section class=\"elements-form\">\n      <h4 id=\"mix\">Mix</h4>\n      <div class=\"row\">\n        <div class=\"col-sm-1\">\n          <div class=\"form-group\">\n            <label class=\"control-label\">\n              Acres\n              <blnd-acres-control\n                ng-model=\"vm.data.is_acres_touched\"\n                ng-change=\"vm.onAcresTouchChange(isChanged)\"\n              ></blnd-acres-control>\n            </label>\n            <div class=\"input-group transparent\">\n              <input\n                type=\"number\"\n                min=\"0\"\n                step=\"0.001\"\n                class=\"form-control input-sm\"\n                ng-model=\"vm.data.acres\"\n                ng-change=\"vm.onAcresModelChange()\"\n                form-error\n                blink\n                select-on-click\n              />\n            </div>\n          </div>\n        </div>\n        <div class=\"col-sm-1\">\n          <div class=\"form-group\">\n            <label class=\"label-sm control-label\">Rate</label>\n            <input\n              type=\"number\"\n              min=\"0\"\n              step=\"0.001\"\n              class=\"form-control input-sm\"\n              ng-model=\"vm.data.rate\"\n              ng-blur=\"vm.tRecalc.rate()\"\n              form-error\n              blink\n              select-on-click\n            />\n          </div>\n        </div>\n        <div class=\"col-sm-2\">\n          <div class=\"form-group\">\n            <label class=\"label-sm\">Quantity</label>\n            <div class=\"input-group blnd-order-group\">\n              <input\n                type=\"number\"\n                min=\"0\"\n                step=\"0.001\"\n                class=\"form-control input-sm\"\n                ng-model=\"vm.data.quantity\"\n                ng-change=\"vm.onQuantityChange()\"\n                form-error\n                blink\n                select-on-click\n              />\n              <blnd-product-code-picker\n                ng-model=\"vm.data.product_code\"\n                mode=\"edit\"\n              ></blnd-product-code-picker>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-sm-1\"></div>\n        <div class=\"col-sm-1\">\n          <div class=\"form-group\">\n            <label class=\"label-sm\">F Batch</label>\n            <input\n              class=\"form-control input-sm\"\n              ng-model=\"vm.data.fert_batches\"\n              form-error\n              select-on-click\n            />\n          </div>\n        </div>\n        <div class=\"col-sm-1\">\n          <div class=\"form-group\">\n            <label class=\"label-sm control-label\">C Batch</label>\n            <input\n              class=\"form-control input-sm\"\n              ng-model=\"vm.data.chem_batches\"\n              form-error\n              select-on-click\n            />\n          </div>\n        </div>\n        <div class=\"col-sm-1\">\n          <div class=\"form-group\">\n            <label class=\"label-sm control-label\">Loadout</label>\n            <blnd-tank-picker\n              ng-model=\"vm.data.fert_tank\"\n              mode=\"edit\"\n              company=\"vm.data.company\"\n              type=\"fert_tanks\"\n              form-error\n            ></blnd-tank-picker>\n          </div>\n        </div>\n        <div class=\"col-sm-1\" ng-if=\"vm.company.chem_tanks.length !== 0\">\n          <div class=\"form-group\">\n            <label class=\"label-sm control-label\">C Tank</label>\n            <blnd-tank-picker\n              ng-model=\"vm.data.chem_tank\"\n              mode=\"edit\"\n              company=\"vm.data.company\"\n              type=\"chem_tanks\"\n              form-error\n            ></blnd-tank-picker>\n          </div>\n        </div>\n        <div class=\"col-sm-1\"></div>\n        <div class=\"col-sm-1\" ng-if=\"vm.data.product_code === 3001\">\n          <div class=\"form-group\">\n            <label class=\"label-sm control-label\">LB/G</label>\n            <input\n              type=\"number\"\n              min=\"0\"\n              step=\"0.001\"\n              class=\"form-control input-sm\"\n              ng-model=\"vm.data.lbs_gal\"\n              form-error\n              select-on-click\n            />\n          </div>\n        </div>\n        <div class=\"col-sm-1\" ng-if=\"vm.data.product_code === 3001\">\n          <div class=\"form-group\">\n            <label class=\"label-sm control-label\">Load Total</label>\n            <input\n              type=\"number\"\n              min=\"0\"\n              step=\"0.001\"\n              class=\"form-control input-sm\"\n              ng-model=\"vm.data.gals\"\n              form-error\n              select-on-click\n            />\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div\n          class=\"col-sm-1\"\n          ng-repeat=\"f in vm.fieldConf.fields.top\"\n          ng-show=\"vm.fieldConf.ui.top[f].length > 0\"\n        >\n          <div class=\"form-group\" form-error=\"vm.errors.nutrients.top_{{ f }}\">\n            <div>\n              <select\n                ng-model=\"vm.fieldConf.values.top[f].pc\"\n                ng-options=\"pc.name for pc in vm.fieldConf.ui.top[f]\"\n                ng-show=\"vm.fieldConf.ui.top[f].length > 1\"\n                class=\"form-control input-xs input-label\"\n              ></select>\n              <label\n                class=\"label-sm control-label\"\n                ng-show=\"vm.fieldConf.ui.top[f].length === 1\"\n                ng-bind=\"vm.fieldConf.values.top[f].pc.name\"\n              >\n              </label>\n              <button\n                class=\"btn btn-default btn-auto-clay\"\n                ng-if=\"vm.fieldConf.values.top[f].pc.source_of.id === 'clay'\"\n                type=\"button\"\n                ng-click=\"vm.calc('calc_clay')\"\n                ladda=\"vm.loading.calc_clay\"\n              >\n                <i class=\"fa fa-refresh\"></i>\n              </button>\n            </div>\n            <div>\n              <input\n                type=\"number\"\n                min=\"0\"\n                max=\"100\"\n                step=\"0.01\"\n                ng-model=\"vm.fieldConf.values.top[f].percent\"\n                class=\"form-control input-sm\"\n                blink\n                select-on-click\n              />\n            </div>\n          </div>\n        </div>\n        <div class=\"col-sm-1-and-half\" ng-if=\"vm.company.allow_reduce_water\">\n          <div class=\"form-group form-group-sm\">\n            <label class=\"constrol-label label-sm\">Reduce Water</label>\n            <div class=\"\">\n              <input\n                type=\"number\"\n                min=\"0\"\n                class=\"form-control\"\n                ng-model=\"vm.data.reduce_water\"\n                name=\"reduce_water\"\n                form-error\n                select-on-click\n              />\n            </div>\n          </div>\n        </div>\n        <div class=\"col-sm-1-and-half\" ng-if=\"vm.company.custom_delay\">\n          <div class=\"form-group form-group-sm\">\n            <label class=\"constrol-label label-sm\">Delay</label>\n            <div class=\"\">\n              <input\n                type=\"number\"\n                min=\"0\"\n                class=\"form-control\"\n                ng-model=\"vm.data.delay\"\n                name=\"custom_delay\"\n                form-error\n                select-on-click\n              />\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row nutrients-form\">\n        <div\n          class=\"col-sm-1\"\n          ng-repeat=\"f in vm.fieldConf.fields.bottom\"\n          ng-show=\"vm.fieldConf.ui.bottom[f].length > 0\"\n        >\n          <div\n            class=\"form-group\"\n            form-error=\"vm.errors.nutrients.bottom_{{ f }}\"\n          >\n            <div>\n              <select\n                ng-model=\"vm.fieldConf.values.bottom[f].pc\"\n                ng-options=\"pc.name for pc in vm.fieldConf.ui.bottom[f]\"\n                ng-show=\"vm.fieldConf.ui.bottom[f].length > 1\"\n                class=\"form-control input-xs input-label\"\n              ></select>\n              <label\n                class=\"label-sm control-label\"\n                ng-show=\"vm.fieldConf.ui.bottom[f].length === 1\"\n                ng-bind=\"vm.fieldConf.values.bottom[f].pc.name\"\n              >\n              </label>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row nutrients-form\">\n        <div\n          class=\"col-sm-1\"\n          ng-repeat=\"f in vm.fieldConf.fields.bottom\"\n          ng-show=\"vm.fieldConf.ui.bottom[f].length > 0\"\n        >\n          <div\n            class=\"form-group\"\n            form-error=\"vm.errors.nutrients.bottom_{{ f }}\"\n          >\n            <div>\n              <input\n                type=\"text\"\n                ng-model=\"vm.fieldConf.values.bottom[f].percent\"\n                ng-blur=\"vm.fieldConf.onPercentChanged(vm.fieldConf.values.bottom[f])\"\n                class=\"form-control input-sm\"\n                select-on-click\n              />\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row nutrients-form last\">\n        <div\n          class=\"col-sm-1\"\n          ng-repeat=\"f in vm.fieldConf.fields.bottom\"\n          ng-show=\"vm.fieldConf.ui.bottom[f].length > 0\"\n        >\n          <div\n            class=\"form-group\"\n            form-error=\"vm.errors.nutrients.bottom_{{ f }}\"\n          >\n            <div>\n              <input\n                type=\"text\"\n                ng-model=\"vm.fieldConf.values.bottom[f].lbs\"\n                ng-blur=\"vm.fieldConf.onLbsChanged(vm.fieldConf.values.bottom[f])\"\n                blink\n                class=\"form-control input-sm\"\n                select-on-click\n              />\n            </div>\n          </div>\n        </div>\n        <div class=\"col-sm-1\">\n          <blnd-analysis-warning\n            ng-model=\"vm.data.formulation\"\n          ></blnd-analysis-warning>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n          <blnd-products\n            ng-model=\"vm.data.products\"\n            acres=\"vm.data.acres\"\n            crop=\"vm.data.crop\"\n            acres-changed=\"vm.tRecalc.acresChanged\"\n            errors=\"vm.errors.products\"\n            mode=\"edit\"\n            customer=\"vs.data.customer\"\n            company=\"vm.data.company\"\n            has-errors=\"vm.saveDisabled\"\n          ></blnd-products>\n        </div>\n        <div class=\"col-sm-6 rounded-table table-left\">\n          <blnd-formula ticket=\"vm.data\"></blnd-formula>\n          <div\n            class=\"alert alert-danger\"\n            ng-repeat=\"error in vm.data.formulation.errors\"\n            ng-bind=\"error\"\n          ></div>\n        </div>\n      </div>\n    </section>\n  </div>\n  <div class=\"modal-footer mix-calc-footer\">\n    <div class=\"pull-left col-md-5\">\n      <blnd-chemical-program-picker\n        ng-model=\"vm.data.chemical_program\"\n        acres=\"vm.data.acres\"\n        company=\"vm.data.company\"\n        products=\"vm.data.products\"\n      >\n      </blnd-chemical-program-picker>\n    </div>\n    <button\n      class=\"btn btn-primary\"\n      type=\"button\"\n      ng-click=\"vm.calc()\"\n      ladda=\"vm.loading.calc\"\n    >\n      Calculate\n    </button>\n    <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">\n      Back\n    </button>\n  </div>\n</form>\n"

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _user = __webpack_require__(503);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _config = __webpack_require__(504);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _auth = __webpack_require__(502);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var F = (_dec = (0, _decorators.Module)({
	    name: 'app.services.init',
	    modules: [_user2.default, _config2.default, _auth2.default]
	}), _dec2 = (0, _decorators.Factory)('InitService', ["$q", "$rootScope", "AuthService", "UserService", "Config", "PermPermissionStore", function ($q, $rootScope, AuthService, UserService, Config, PermPermissionStore) {
	    "ngInject";
	
	    return function () {
	        if (!AuthService.isLoggedIn) {
	            return $q.resolve();
	        }
	        // Global, route-independent: keeps the offline cache warm no matter
	        // which page the user is on, and re-checks every 24h without a reload.
	        if (window.ReactBridge) {
	            window.ReactBridge.startOfflinePrefetchScheduler();
	        }
	        PermPermissionStore.clearStore();
	        return $q.all([UserService.refresh(), Config.refresh()]).then(function () {
	            $rootScope.$state.test = Config.$config.env === "test" ? true : false;
	            $rootScope.$state.staging = Config.$config.env === "staging" ? true : false;
	
	            // Expose the real logged-in user to the shared React/Angular store,
	            // so React components can read it via `useStore(appStore, s => s.currentUser)`.
	            if (window.ReactBridge) {
	                window.ReactBridge.store.getState().setCurrentUser(UserService.$user);
	            }
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = UserService.$user.perms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var perm = _step.value;
	
	                    PermPermissionStore.definePermission(perm, function () {
	                        return true;
	                    });
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        });
	    };
	}]), _dec(_class = _dec2(_class = function F() {
	    _classCallCheck(this, F);
	}) || _class) || _class);
	exports.default = F;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _decorators = __webpack_require__(331);
	
	var _routing = __webpack_require__(501);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _react = __webpack_require__(552);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Demo route proving the React island renders inside the AngularJS shell,
	 * AND that state flows both ways:
	 *   - Angular -> React via the `props` binding on the `react-view` directive.
	 *   - The shared store (synced with the real logged-in user by InitService, on both initial page load and login) is read by BOTH React (`useStore`) and Angular
	 */
	var Ctrl = function () {
	    Ctrl.$inject = ["ReactBridge"];
	    function Ctrl(ReactBridge) {
	        "ngInject";
	
	        _classCallCheck(this, Ctrl);
	
	        this.ReactBridge = ReactBridge;
	        // Pass data from Angular into the React component as props.
	        this.reactProps = { title: 'Hello from React' };
	    }
	
	    // Read directly from the shared vanilla Zustand store on the Angular side.
	    // The `app.react` module's `.run()` connector calls `$rootScope.$applyAsync()`
	    // whenever the store changes, which re-triggers Angular's digest and
	    // re-evaluates this getter in the template — no manual subscription needed.
	
	
	    _createClass(Ctrl, [{
	        key: 'storeUser',
	        value: function storeUser() {
	            return this.ReactBridge().store.getState().currentUser;
	        }
	    }]);
	
	    return Ctrl;
	}();
	
	var States = (_dec = (0, _decorators.Module)({
	    name: 'app.react_demo',
	    modules: [_routing2.default, _react2.default]
	}), _dec2 = (0, _decorators.State)({
	    name: 'r.in.top.react_demo',
	    url: '/react-demo',
	    controller: Ctrl,
	    template: '\n        <div class="container" style="padding-top: 20px;">\n            <div react-view="hello" props="vm.reactProps"></div>\n        </div>\n    ',
	    ncyBreadcrumb: {
	        label: 'React Demo'
	    }
	}), _dec(_class = _dec2(_class = function States() {
	    _classCallCheck(this, States);
	}) || _class) || _class);
	exports.default = States;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	__webpack_require__(828);
	
	__webpack_require__(829);
	
	__webpack_require__(830);
	
	__webpack_require__(831);
	
	__webpack_require__(832);
	
	__webpack_require__(835);
	
	__webpack_require__(836);
	
	__webpack_require__(837);
	
	__webpack_require__(547);
	
	__webpack_require__(838);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } // here we put all modules
	// that should be injected to all other angular modules
	// beside puting your file here, you need to add module name to @Module decorator
	
	
	var C = function C() {
	  _classCallCheck(this, C);
	};
	
	exports.default = C;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.autofocus"
	}), _dec2 = (0, _decorators.Directive)('autofocus', ["$timeout", function ($timeout) {
	    "ngInject";
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element) {
	            $timeout(function () {
	                $element[0].focus();
	            });
	        }
	    };
	}]), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _angular = __webpack_require__(328);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _decorators = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.loading"
	}), _dec2 = (0, _decorators.Directive)('loading-container', function () {
	    "ngInject";
	
	    return {
	        restrict: "A",
	        scope: false,
	        link: function link(scope, element, attrs) {
	            var loadingLayer = _angular2.default.element("<div class='loading'></div>");
	            element.append(loadingLayer);
	            element.addClass("loading-container");
	            scope.$watch(attrs.loadingContainer, function (value) {
	                loadingLayer.toggleClass("ng-hide", !value);
	            });
	        }
	    };
	}), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.nodata"
	}), _dec2 = (0, _decorators.Component)({
	    selector: 'no-data',
	    transclude: true,
	    bindings: {
	        params: '=', // ngTable params
	        condition: '<'
	    },
	    template: '<div class="no-data" ng-show="$ctrl.condition || (!$ctrl.params.settings().$loading && $ctrl.params.total() === 0)" ng-transclude>No data</div>'
	}), _dec(_class = _dec2(_class = function C() {
	    _classCallCheck(this, C);
	}) || _class) || _class);
	exports.default = C;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: 'app.directives.appLoading'
	}), _dec2 = (0, _decorators.Directive)('app-loading', ["$animate", function ($animate) {
	    "ngInject";
	
	    return {
	        restrict: "A",
	        link: function link(scope, element, attributes) {
	            $animate.leave(element.children().eq(1)).then(function cleanupAfterAnimation() {
	                // Remove the root directive element.
	                element.remove();
	
	                // Clear the closed-over variable references.
	                scope = element = attributes = null;
	            });
	        }
	    };
	}]), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	__webpack_require__(833);
	
	var _checkBrowser = __webpack_require__(834);
	
	var _checkBrowser2 = _interopRequireDefault(_checkBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: 'app.directives.check.browser',
	    modules: ['jlareau.bowser']
	}), _dec2 = (0, _decorators.Directive)('check-browser', ["$compile", "$state", "$window", "$cookies", "bowser", function ($compile, $state, $window, $cookies, bowser) {
	    "ngInject";
	
	    return {
	        restrict: 'EA',
	        priority: 1,
	        link: function link(scope, element) {
	            scope.confirmContinue = confirmContinue;
	
	            if ($cookies.get('browsernotify')) {
	                return;
	            }
	
	            if (bowser.msie && bowser.version <= 11) {
	                element.contents().remove();
	                element.replaceWith($compile(_checkBrowser2.default)(scope));
	            }
	
	            function confirmContinue() {
	                setCookie();
	                $window.location.reload();
	            }
	
	            function setCookie() {
	                $cookies.put('browsernotify', true, {
	                    expires: new Date(new Date().getTime() + 3600000 * 24).toGMTString()
	                });
	            }
	        }
	    };
	}]), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 833 */,
/* 834 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container check-browser-container\">\n    <div class=\"row\">\n        <div class=\"col-lg-8 col-lg-offset-2\">\n            <p><div class=\"logo center-block\"></div></p>\n            <p>Internet Explorer is not recommended, please download <a type=\"\" href=\"https://www.google.com/chrome/browser\" target=\"_blank\">Chrome</a></p>\n            <p>If you want to continue, click <a class=\"btn btn-link\" href=\"#\" ng-click=\"confirmContinue()\">here</a></p>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.selectOnClick"
	}), _dec2 = (0, _decorators.Directive)('select-on-click', function () {
	    "ngInject";
	
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            element.on('focus', function () {
	                this.select();
	            });
	
	            scope.$on('$destroy', function () {
	                element.off('focus');
	            });
	        }
	    };
	}), _dec(_class = _dec2(_class = function D() {
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.C = undefined;
	
	var _dec, _dec2, _dec3, _dec4, _class;
	
	var _decorators = __webpack_require__(331);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var C = exports.C = (_dec = (0, _decorators.Module)({
	    name: "app.directives.uiSelectHelpers"
	}), _dec2 = (0, _decorators.Directive)('set-focus', ["$parse", "$timeout", function ($parse, $timeout) {
	    "ngInject";
	
	    // This is widget designed specifically for ui-select
	
	    return {
	        link: {
	            post: function post(scope, element, attrs) {
	                attrs.$observe('setFocus', function (value) {
	                    value = $parse(value)(scope);
	                    if (value) {
	                        $timeout(function () {
	                            var controller = element.controller('uiSelect');
	                            if (controller) {
	                                controller.focusser[0].focus();
	                            }
	                        });
	                    }
	                });
	            }
	        }
	    };
	}]), _dec3 = (0, _decorators.Directive)('allow-remove', ["$timeout", function ($timeout) {
	    "ngInject";
	
	    return {
	        restrict: 'A',
	        require: '^uiSelect',
	        link: function link(scope, element, attrs, $select) {
	            element.on('keydown', removeHandler);
	            $select.focusser.bind("keyup input", removeHandler);
	
	            function removeValue($event) {
	                if ($select.search) {
	                    return;
	                }
	                if ($event.which == 8 || $event.which == 46) {
	                    $event.preventDefault();
	                    $event.stopPropagation();
	
	                    clear($event);
	                }
	            }
	
	            function clear() {
	                $select.select(null);
	                $select.close();
	
	                scope.$apply(function () {
	
	                    if ($select.onRemoveCallback) {
	                        $select.onRemoveCallback(scope, {});
	                    }
	                });
	            };
	
	            function removeHandler($event) {
	                removeValue($event);
	            }
	
	            scope.$on('$onDestroy', function () {
	                element.off('keydown', removeHandler);
	                $select.focusser.off('keyup input', removeHandler);
	            });
	        }
	    };
	}]), _dec4 = (0, _decorators.Directive)('prevent-animations', ["$animate", function ($animate) {
	    "ngInject";
	
	    return {
	        restrict: 'A',
	        replace: true,
	        link: function link($scope, $element, $attrs, vm) {
	            // Disable $animate for this element
	            $animate.enabled($element, false);
	        }
	    };
	}]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = function C() {
	    _classCallCheck(this, C);
	}) || _class) || _class) || _class) || _class);

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _decorators = __webpack_require__(331);
	
	var _product = __webpack_require__(597);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _base = __webpack_require__(568);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var D = (_dec = (0, _decorators.Module)({
	    name: "app.directives.read_only_icon"
	}), _dec2 = (0, _decorators.Directive)('read-only-as400', function () {
	    "ngInject";
	
	    return {
	        restrict: 'A',
	        template: '\n        <i class="fa fa-question-circle" aria-hidden="true" uib-tooltip="Field synced from AS400"></i>\n        '
	    };
	}), _dec(_class = _dec2(_class = function D() {
	    "ngInject";
	
	    _classCallCheck(this, D);
	}) || _class) || _class);
	exports.default = D;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _dec, _dec2, _class;
	
	var _lodash = __webpack_require__(337);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _decorators = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var F = (_dec = (0, _decorators.Module)({
	    name: 'app.services.models.registry'
	}), _dec2 = (0, _decorators.Factory)('modalRegistry', function () {
	    "ngInject";
	
	    var currentOpenedModals = {};
	
	    return {
	        isOpen: function isOpen(id) {
	            return _lodash2.default.has(currentOpenedModals, id) && currentOpenedModals[id];
	        },
	        push: function push(id) {
	            currentOpenedModals[id] = true;
	        },
	        pop: function pop(id) {
	            if (this.isOpen(id)) {
	                delete currentOpenedModals[id];
	            }
	        }
	    };
	}), _dec(_class = _dec2(_class = function F() {
	    _classCallCheck(this, F);
	}) || _class) || _class);
	exports.default = F;

/***/ }),
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(850);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(848)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./main.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(841)();
	// imports
	exports.i(__webpack_require__(851), "");
	exports.i(__webpack_require__(852), "");
	exports.i(__webpack_require__(853), "");
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}.blnd-data-field>:first-child,b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(854) + ");src:url(" + __webpack_require__(854) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(855) + ") format(\"woff2\"),url(" + __webpack_require__(856) + ") format(\"woff\"),url(" + __webpack_require__(857) + ") format(\"truetype\"),url(" + __webpack_require__(858) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid,.container-fluid-blnd{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid-blnd:after,.container-fluid-blnd:before,.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid-blnd:after,.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-1-and-half,.col-sm-1-mix,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.33333%}.col-xs-2{width:16.66667%}.col-xs-3{width:25%}.col-xs-4{width:33.33333%}.col-xs-5{width:41.66667%}.col-xs-6{width:50%}.col-xs-7{width:58.33333%}.col-xs-8{width:66.66667%}.col-xs-9{width:75%}.col-xs-10{width:83.33333%}.col-xs-11{width:91.66667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.33333%}.col-xs-pull-2{right:16.66667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.33333%}.col-xs-pull-5{right:41.66667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.33333%}.col-xs-pull-8{right:66.66667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.33333%}.col-xs-pull-11{right:91.66667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.33333%}.col-xs-push-2{left:16.66667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.33333%}.col-xs-push-5{left:41.66667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.33333%}.col-xs-push-8{left:66.66667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.33333%}.col-xs-push-11{left:91.66667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.33333%}.col-xs-offset-2{margin-left:16.66667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.33333%}.col-xs-offset-5{margin-left:41.66667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.33333%}.col-xs-offset-8{margin-left:66.66667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.33333%}.col-xs-offset-11{margin-left:91.66667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-1-and-half,.col-sm-1-mix,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1,.col-sm-1-and-half,.col-sm-1-mix{width:8.33333%}.col-sm-2{width:16.66667%}.col-sm-3{width:25%}.col-sm-4{width:33.33333%}.col-sm-5{width:41.66667%}.col-sm-6{width:50%}.col-sm-7{width:58.33333%}.col-sm-8{width:66.66667%}.col-sm-9{width:75%}.col-sm-10{width:83.33333%}.col-sm-11{width:91.66667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.33333%}.col-sm-pull-2{right:16.66667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.33333%}.col-sm-pull-5{right:41.66667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.33333%}.col-sm-pull-8{right:66.66667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.33333%}.col-sm-pull-11{right:91.66667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.33333%}.col-sm-push-2{left:16.66667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.33333%}.col-sm-push-5{left:41.66667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.33333%}.col-sm-push-8{left:66.66667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.33333%}.col-sm-push-11{left:91.66667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.33333%}.col-sm-offset-2{margin-left:16.66667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.33333%}.col-sm-offset-5{margin-left:41.66667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.33333%}.col-sm-offset-8{margin-left:66.66667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.33333%}.col-sm-offset-11{margin-left:91.66667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.33333%}.col-md-2{width:16.66667%}.col-md-3{width:25%}.col-md-4{width:33.33333%}.col-md-5{width:41.66667%}.col-md-6{width:50%}.col-md-7{width:58.33333%}.col-md-8{width:66.66667%}.col-md-9{width:75%}.col-md-10{width:83.33333%}.col-md-11{width:91.66667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.33333%}.col-md-pull-2{right:16.66667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.33333%}.col-md-pull-5{right:41.66667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.33333%}.col-md-pull-8{right:66.66667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.33333%}.col-md-pull-11{right:91.66667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.33333%}.col-md-push-2{left:16.66667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.33333%}.col-md-push-5{left:41.66667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.33333%}.col-md-push-8{left:66.66667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.33333%}.col-md-push-11{left:91.66667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.33333%}.col-md-offset-2{margin-left:16.66667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.33333%}.col-md-offset-5{margin-left:41.66667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.33333%}.col-md-offset-8{margin-left:66.66667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.33333%}.col-md-offset-11{margin-left:91.66667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.33333%}.col-lg-2{width:16.66667%}.col-lg-3{width:25%}.col-lg-4{width:33.33333%}.col-lg-5{width:41.66667%}.col-lg-6{width:50%}.col-lg-7{width:58.33333%}.col-lg-8{width:66.66667%}.col-lg-9{width:75%}.col-lg-10{width:83.33333%}.col-lg-11{width:91.66667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.33333%}.col-lg-pull-2{right:16.66667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.33333%}.col-lg-pull-5{right:41.66667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.33333%}.col-lg-pull-8{right:66.66667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.33333%}.col-lg-pull-11{right:91.66667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.33333%}.col-lg-push-2{left:16.66667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.33333%}.col-lg-push-5{left:41.66667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.33333%}.col-lg-push-8{left:66.66667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.33333%}.col-lg-push-11{left:91.66667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.33333%}.col-lg-offset-2{margin-left:16.66667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.33333%}.col-lg-offset-5{margin-left:41.66667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.33333%}.col-lg-offset-8{margin-left:66.66667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.33333%}.col-lg-offset-11{margin-left:91.66667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.customer-fields-page table.customer-fields-table>tbody>tr:hover,.order-fields-page table.customer-fields-table>tbody>tr:hover,.table-clickable>tbody>tr:hover,.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.customer-fields-page table.customer-fields-table>tbody>tr.active:hover>td,.customer-fields-page table.customer-fields-table>tbody>tr.active:hover>th,.customer-fields-page table.customer-fields-table>tbody>tr:hover>.active,.customer-fields-page table.customer-fields-table>tbody>tr>td.active:hover,.customer-fields-page table.customer-fields-table>tbody>tr>th.active:hover,.order-fields-page table.customer-fields-table>tbody>tr.active:hover>td,.order-fields-page table.customer-fields-table>tbody>tr.active:hover>th,.order-fields-page table.customer-fields-table>tbody>tr:hover>.active,.order-fields-page table.customer-fields-table>tbody>tr>td.active:hover,.order-fields-page table.customer-fields-table>tbody>tr>th.active:hover,.table-clickable>tbody>tr.active:hover>td,.table-clickable>tbody>tr.active:hover>th,.table-clickable>tbody>tr:hover>.active,.table-clickable>tbody>tr>td.active:hover,.table-clickable>tbody>tr>th.active:hover,.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.customer-fields-page table.customer-fields-table>tbody>tr.success:hover>td,.customer-fields-page table.customer-fields-table>tbody>tr.success:hover>th,.customer-fields-page table.customer-fields-table>tbody>tr:hover>.success,.customer-fields-page table.customer-fields-table>tbody>tr>td.success:hover,.customer-fields-page table.customer-fields-table>tbody>tr>th.success:hover,.order-fields-page table.customer-fields-table>tbody>tr.success:hover>td,.order-fields-page table.customer-fields-table>tbody>tr.success:hover>th,.order-fields-page table.customer-fields-table>tbody>tr:hover>.success,.order-fields-page table.customer-fields-table>tbody>tr>td.success:hover,.order-fields-page table.customer-fields-table>tbody>tr>th.success:hover,.table-clickable>tbody>tr.success:hover>td,.table-clickable>tbody>tr.success:hover>th,.table-clickable>tbody>tr:hover>.success,.table-clickable>tbody>tr>td.success:hover,.table-clickable>tbody>tr>th.success:hover,.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.customer-fields-page table.customer-fields-table>tbody>tr.info:hover>td,.customer-fields-page table.customer-fields-table>tbody>tr.info:hover>th,.customer-fields-page table.customer-fields-table>tbody>tr:hover>.info,.customer-fields-page table.customer-fields-table>tbody>tr>td.info:hover,.customer-fields-page table.customer-fields-table>tbody>tr>th.info:hover,.order-fields-page table.customer-fields-table>tbody>tr.info:hover>td,.order-fields-page table.customer-fields-table>tbody>tr.info:hover>th,.order-fields-page table.customer-fields-table>tbody>tr:hover>.info,.order-fields-page table.customer-fields-table>tbody>tr>td.info:hover,.order-fields-page table.customer-fields-table>tbody>tr>th.info:hover,.table-clickable>tbody>tr.info:hover>td,.table-clickable>tbody>tr.info:hover>th,.table-clickable>tbody>tr:hover>.info,.table-clickable>tbody>tr>td.info:hover,.table-clickable>tbody>tr>th.info:hover,.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.customer-fields-page table.customer-fields-table>tbody>tr.warning:hover>td,.customer-fields-page table.customer-fields-table>tbody>tr.warning:hover>th,.customer-fields-page table.customer-fields-table>tbody>tr:hover>.warning,.customer-fields-page table.customer-fields-table>tbody>tr>td.warning:hover,.customer-fields-page table.customer-fields-table>tbody>tr>th.warning:hover,.order-fields-page table.customer-fields-table>tbody>tr.warning:hover>td,.order-fields-page table.customer-fields-table>tbody>tr.warning:hover>th,.order-fields-page table.customer-fields-table>tbody>tr:hover>.warning,.order-fields-page table.customer-fields-table>tbody>tr>td.warning:hover,.order-fields-page table.customer-fields-table>tbody>tr>th.warning:hover,.table-clickable>tbody>tr.warning:hover>td,.table-clickable>tbody>tr.warning:hover>th,.table-clickable>tbody>tr:hover>.warning,.table-clickable>tbody>tr>td.warning:hover,.table-clickable>tbody>tr>th.warning:hover,.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.customer-fields-page table.customer-fields-table>tbody>tr.danger:hover>td,.customer-fields-page table.customer-fields-table>tbody>tr.danger:hover>th,.customer-fields-page table.customer-fields-table>tbody>tr:hover>.danger,.customer-fields-page table.customer-fields-table>tbody>tr>td.danger:hover,.customer-fields-page table.customer-fields-table>tbody>tr>th.danger:hover,.order-fields-page table.customer-fields-table>tbody>tr.danger:hover>td,.order-fields-page table.customer-fields-table>tbody>tr.danger:hover>th,.order-fields-page table.customer-fields-table>tbody>tr:hover>.danger,.order-fields-page table.customer-fields-table>tbody>tr>td.danger:hover,.order-fields-page table.customer-fields-table>tbody>tr>th.danger:hover,.table-clickable>tbody>tr.danger:hover>td,.table-clickable>tbody>tr.danger:hover>th,.table-clickable>tbody>tr:hover>.danger,.table-clickable>tbody>tr>td.danger:hover,.table-clickable>tbody>tr>th.danger:hover,.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.form-group-sm .input-group>.input-group-btn>input[type=date].btn,.form-group-sm .input-group>.input-group-btn>input[type=datetime-local].btn,.form-group-sm .input-group>.input-group-btn>input[type=month].btn,.form-group-sm .input-group>.input-group-btn>input[type=time].btn,.form-group-sm .input-group>input[type=date].form-control,.form-group-sm .input-group>input[type=date].input-group-addon,.form-group-sm .input-group>input[type=datetime-local].form-control,.form-group-sm .input-group>input[type=datetime-local].input-group-addon,.form-group-sm .input-group>input[type=month].form-control,.form-group-sm .input-group>input[type=month].input-group-addon,.form-group-sm .input-group>input[type=time].form-control,.form-group-sm .input-group>input[type=time].input-group-addon,.form-group-sm .input-group input[type=date],.form-group-sm .input-group input[type=datetime-local],.form-group-sm .input-group input[type=month],.form-group-sm .input-group input[type=time],.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],.ui-select-container.input-sm input[type=date].ui-select-choices-row,.ui-select-container.input-sm input[type=date].ui-select-toggle,.ui-select-container.input-sm input[type=datetime-local].ui-select-choices-row,.ui-select-container.input-sm input[type=datetime-local].ui-select-toggle,.ui-select-container.input-sm input[type=month].ui-select-choices-row,.ui-select-container.input-sm input[type=month].ui-select-toggle,.ui-select-container.input-sm input[type=time].ui-select-choices-row,.ui-select-container.input-sm input[type=time].ui-select-toggle,input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group,.plant-configuration .display-value{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.form-group-sm .input-group>.form-control-static.form-control,.form-group-sm .input-group>.form-control-static.input-group-addon,.form-group-sm .input-group>.input-group-btn>.form-control-static.btn,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn,.ui-select-container.input-sm .form-control-static.ui-select-choices-row,.ui-select-container.input-sm .form-control-static.ui-select-toggle{padding-left:0;padding-right:0}.form-group-sm .input-group>.form-control,.form-group-sm .input-group>.input-group-addon,.form-group-sm .input-group>.input-group-btn>.btn,.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm,.ui-select-container.input-sm .ui-select-choices-row,.ui-select-container.input-sm .ui-select-toggle{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm .input-group>.input-group-btn>select.btn,.form-group-sm .input-group>select.form-control,.form-group-sm .input-group>select.input-group-addon,.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,.ui-select-container.input-sm select.ui-select-choices-row,.ui-select-container.input-sm select.ui-select-toggle,select.input-sm{height:30px;line-height:30px}.form-group-sm .input-group>.input-group-btn>select[multiple].btn,.form-group-sm .input-group>.input-group-btn>textarea.btn,.form-group-sm .input-group>select[multiple].form-control,.form-group-sm .input-group>select[multiple].input-group-addon,.form-group-sm .input-group>textarea.form-control,.form-group-sm .input-group>textarea.input-group-addon,.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,.ui-select-container.input-sm select[multiple].ui-select-choices-row,.ui-select-container.input-sm select[multiple].ui-select-toggle,.ui-select-container.input-sm textarea.ui-select-choices-row,.ui-select-container.input-sm textarea.ui-select-toggle,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.33333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.form-group-sm .input-group+.form-control-feedback,.form-group-sm .input-group>.form-control+.form-control-feedback,.form-group-sm .input-group>.input-group-addon+.form-control-feedback,.form-group-sm .input-group>.input-group-btn>.btn+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback,.ui-select-container.input-sm .ui-select-choices-row+.form-control-feedback,.ui-select-container.input-sm .ui-select-toggle+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group,.form-inline .plant-configuration .display-value,.plant-configuration .form-inline .display-value{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group,.form-horizontal .plant-configuration .display-value,.plant-configuration .form-horizontal .display-value{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before,.form-horizontal .plant-configuration .display-value:after,.form-horizontal .plant-configuration .display-value:before,.plant-configuration .form-horizontal .display-value:after,.plant-configuration .form-horizontal .display-value:before{content:\" \";display:table}.form-horizontal .form-group:after,.form-horizontal .plant-configuration .display-value:after,.plant-configuration .form-horizontal .display-value:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-add,.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-add:focus,.btn-primary.focus,.btn-primary:focus,.focus.btn-add{color:#fff;background-color:#286090;border-color:#122b40}.active.btn-add,.btn-add:active,.btn-add:hover,.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle,.open>.dropdown-toggle.btn-add{color:#fff;background-color:#286090;border-color:#204d74}.active.btn-add:focus,.active.btn-add:hover,.active.focus.btn-add,.btn-add:active.focus,.btn-add:active:focus,.btn-add:active:hover,.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover,.open>.dropdown-toggle.btn-add:focus,.open>.dropdown-toggle.btn-add:hover,.open>.dropdown-toggle.focus.btn-add{color:#fff;background-color:#204d74;border-color:#122b40}.active.btn-add,.btn-add:active,.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle,.open>.dropdown-toggle.btn-add{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,.disabled.btn-add:focus,.disabled.btn-add:hover,.disabled.focus.btn-add,[disabled].btn-add:focus,[disabled].btn-add:hover,[disabled].focus.btn-add,fieldset[disabled] .btn-add:focus,fieldset[disabled] .btn-add:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover,fieldset[disabled] .focus.btn-add{background-color:#337ab7;border-color:#2e6da4}.btn-add .badge,.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-edit,.btn-submit,.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-edit:focus,.btn-submit:focus,.btn-warning.focus,.btn-warning:focus,.focus.btn-edit,.focus.btn-submit{color:#fff;background-color:#ec971f;border-color:#985f0d}.active.btn-edit,.active.btn-submit,.btn-edit:active,.btn-edit:hover,.btn-submit:active,.btn-submit:hover,.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle,.open>.dropdown-toggle.btn-edit,.open>.dropdown-toggle.btn-submit{color:#fff;background-color:#ec971f;border-color:#d58512}.active.btn-edit:focus,.active.btn-edit:hover,.active.btn-submit:focus,.active.btn-submit:hover,.active.focus.btn-edit,.active.focus.btn-submit,.btn-edit:active.focus,.btn-edit:active:focus,.btn-edit:active:hover,.btn-submit:active.focus,.btn-submit:active:focus,.btn-submit:active:hover,.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover,.open>.dropdown-toggle.btn-edit:focus,.open>.dropdown-toggle.btn-edit:hover,.open>.dropdown-toggle.btn-submit:focus,.open>.dropdown-toggle.btn-submit:hover,.open>.dropdown-toggle.focus.btn-edit,.open>.dropdown-toggle.focus.btn-submit{color:#fff;background-color:#d58512;border-color:#985f0d}.active.btn-edit,.active.btn-submit,.btn-edit:active,.btn-submit:active,.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle,.open>.dropdown-toggle.btn-edit,.open>.dropdown-toggle.btn-submit{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,.disabled.btn-edit:focus,.disabled.btn-edit:hover,.disabled.btn-submit:focus,.disabled.btn-submit:hover,.disabled.focus.btn-edit,.disabled.focus.btn-submit,[disabled].btn-edit:focus,[disabled].btn-edit:hover,[disabled].btn-submit:focus,[disabled].btn-submit:hover,[disabled].focus.btn-edit,[disabled].focus.btn-submit,fieldset[disabled] .btn-edit:focus,fieldset[disabled] .btn-edit:hover,fieldset[disabled] .btn-submit:focus,fieldset[disabled] .btn-submit:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover,fieldset[disabled] .focus.btn-edit,fieldset[disabled] .focus.btn-submit{background-color:#f0ad4e;border-color:#eea236}.btn-edit .badge,.btn-submit .badge,.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger,.btn-delete{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus,.btn-delete:focus,.focus.btn-delete{color:#fff;background-color:#c9302c;border-color:#761c19}.active.btn-delete,.btn-danger.active,.btn-danger:active,.btn-danger:hover,.btn-delete:active,.btn-delete:hover,.open>.btn-danger.dropdown-toggle,.open>.dropdown-toggle.btn-delete{color:#fff;background-color:#c9302c;border-color:#ac2925}.active.btn-delete:focus,.active.btn-delete:hover,.active.focus.btn-delete,.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.btn-delete:active.focus,.btn-delete:active:focus,.btn-delete:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover,.open>.dropdown-toggle.btn-delete:focus,.open>.dropdown-toggle.btn-delete:hover,.open>.dropdown-toggle.focus.btn-delete{color:#fff;background-color:#ac2925;border-color:#761c19}.active.btn-delete,.btn-danger.active,.btn-danger:active,.btn-delete:active,.open>.btn-danger.dropdown-toggle,.open>.dropdown-toggle.btn-delete{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,.disabled.btn-delete:focus,.disabled.btn-delete:hover,.disabled.focus.btn-delete,[disabled].btn-delete:focus,[disabled].btn-delete:hover,[disabled].focus.btn-delete,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover,fieldset[disabled] .btn-delete:focus,fieldset[disabled] .btn-delete:hover,fieldset[disabled] .focus.btn-delete{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge,.btn-delete .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.33333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.form-group-sm .input-group>.input-group-addon,.form-group-sm .input-group>.input-group-btn>.input-group-addon.btn,.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn,.ui-select-container.input-sm .input-group-addon.ui-select-choices-row,.ui-select-container.input-sm .input-group-addon.ui-select-toggle{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.blnd-tab-content>.tab-pane,.tab-content>.tab-pane{display:none}.blnd-tab-content>.active,.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid-blnd>.navbar-collapse,.container-fluid-blnd>.navbar-header,.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid-blnd>.navbar-collapse,.container-fluid-blnd>.navbar-header,.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid-blnd .navbar-brand,.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group,.navbar-form .plant-configuration .display-value,.plant-configuration .navbar-form .display-value{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group,.navbar-form .plant-configuration .display-value,.plant-configuration .navbar-form .display-value{margin-bottom:5px}.navbar-form .form-group:last-child,.navbar-form .plant-configuration .display-value:last-child,.plant-configuration .navbar-form .display-value:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.42857;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.33333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid-blnd .jumbotron,.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid-blnd .jumbotron,.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert,.no-data{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4,.no-data h4{margin-top:0;color:inherit}.alert .alert-link,.no-data .alert-link{font-weight:700}.alert>p,.alert>ul,.no-data>p,.no-data>ul{margin-bottom:0}.alert>p+p,.no-data>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\r\n * Ladda\r\n * http://lab.hakim.se/ladda\r\n * MIT licensed\r\n *\r\n * Copyright (C) 2016 Hakim El Hattab, http://hakim.se\r\n */.ladda-button{position:relative}.ladda-button .ladda-spinner{position:absolute;z-index:2;display:inline-block;width:32px;top:50%;margin-top:0;opacity:0;pointer-events:none}.ladda-button .ladda-label{position:relative;z-index:3}.ladda-button .ladda-progress{position:absolute;width:0;height:100%;left:0;top:0;background:rgba(0,0,0,.2);visibility:hidden;opacity:0;transition:all .1s linear!important}.ladda-button[data-loading] .ladda-progress{opacity:1;visibility:visible}.ladda-button,.ladda-button .ladda-label,.ladda-button .ladda-spinner{transition:all .3s cubic-bezier(.175,.885,.32,1.275)!important}.ladda-button[data-style=zoom-in],.ladda-button[data-style=zoom-in] .ladda-label,.ladda-button[data-style=zoom-in] .ladda-spinner,.ladda-button[data-style=zoom-out],.ladda-button[data-style=zoom-out] .ladda-label,.ladda-button[data-style=zoom-out] .ladda-spinner{transition:all .3s ease!important}.ladda-button[data-style=expand-right] .ladda-spinner{right:-6px}.ladda-button[data-style=expand-right][data-size=s] .ladda-spinner,.ladda-button[data-style=expand-right][data-size=xs] .ladda-spinner{right:-12px}.ladda-button[data-style=expand-right][data-loading]{padding-right:56px}.ladda-button[data-style=expand-right][data-loading] .ladda-spinner{opacity:1}.ladda-button[data-style=expand-right][data-loading][data-size=s],.ladda-button[data-style=expand-right][data-loading][data-size=xs]{padding-right:40px}.ladda-button[data-style=expand-left] .ladda-spinner{left:26px}.ladda-button[data-style=expand-left][data-size=s] .ladda-spinner,.ladda-button[data-style=expand-left][data-size=xs] .ladda-spinner{left:4px}.ladda-button[data-style=expand-left][data-loading]{padding-left:56px}.ladda-button[data-style=expand-left][data-loading] .ladda-spinner{opacity:1}.ladda-button[data-style=expand-left][data-loading][data-size=s],.ladda-button[data-style=expand-left][data-loading][data-size=xs]{padding-left:40px}.ladda-button[data-style=expand-up]{overflow:hidden}.ladda-button[data-style=expand-up] .ladda-spinner{top:-32px;left:50%;margin-left:0}.ladda-button[data-style=expand-up][data-loading]{padding-top:54px}.ladda-button[data-style=expand-up][data-loading] .ladda-spinner{opacity:1;top:26px;margin-top:0}.ladda-button[data-style=expand-up][data-loading][data-size=s],.ladda-button[data-style=expand-up][data-loading][data-size=xs]{padding-top:32px}.ladda-button[data-style=expand-up][data-loading][data-size=s] .ladda-spinner,.ladda-button[data-style=expand-up][data-loading][data-size=xs] .ladda-spinner{top:4px}.ladda-button[data-style=expand-down]{overflow:hidden}.ladda-button[data-style=expand-down] .ladda-spinner{top:62px;left:50%;margin-left:0}.ladda-button[data-style=expand-down][data-size=s] .ladda-spinner,.ladda-button[data-style=expand-down][data-size=xs] .ladda-spinner{top:40px}.ladda-button[data-style=expand-down][data-loading]{padding-bottom:54px}.ladda-button[data-style=expand-down][data-loading] .ladda-spinner{opacity:1}.ladda-button[data-style=expand-down][data-loading][data-size=s],.ladda-button[data-style=expand-down][data-loading][data-size=xs]{padding-bottom:32px}.ladda-button[data-style=slide-left]{overflow:hidden}.ladda-button[data-style=slide-left] .ladda-label{position:relative}.ladda-button[data-style=slide-left] .ladda-spinner{left:100%;margin-left:0}.ladda-button[data-style=slide-left][data-loading] .ladda-label{opacity:0;left:-100%}.ladda-button[data-style=slide-left][data-loading] .ladda-spinner{opacity:1;left:50%}.ladda-button[data-style=slide-right]{overflow:hidden}.ladda-button[data-style=slide-right] .ladda-label{position:relative}.ladda-button[data-style=slide-right] .ladda-spinner{right:100%;margin-left:0;left:16px}[dir=rtl] .ladda-button[data-style=slide-right] .ladda-spinner{right:auto}.ladda-button[data-style=slide-right][data-loading] .ladda-label{opacity:0;left:100%}.ladda-button[data-style=slide-right][data-loading] .ladda-spinner{opacity:1;left:50%}.ladda-button[data-style=slide-up]{overflow:hidden}.ladda-button[data-style=slide-up] .ladda-label{position:relative}.ladda-button[data-style=slide-up] .ladda-spinner{left:50%;margin-left:0;margin-top:1em}.ladda-button[data-style=slide-up][data-loading] .ladda-label{opacity:0;top:-1em}.ladda-button[data-style=slide-up][data-loading] .ladda-spinner{opacity:1;margin-top:0}.ladda-button[data-style=slide-down]{overflow:hidden}.ladda-button[data-style=slide-down] .ladda-label{position:relative}.ladda-button[data-style=slide-down] .ladda-spinner{left:50%;margin-left:0;margin-top:-2em}.ladda-button[data-style=slide-down][data-loading] .ladda-label{opacity:0;top:1em}.ladda-button[data-style=slide-down][data-loading] .ladda-spinner{opacity:1;margin-top:0}.ladda-button[data-style=zoom-out]{overflow:hidden}.ladda-button[data-style=zoom-out] .ladda-spinner{left:50%;margin-left:32px;transform:scale(2.5)}.ladda-button[data-style=zoom-out] .ladda-label{position:relative;display:inline-block}.ladda-button[data-style=zoom-out][data-loading] .ladda-label{opacity:0;transform:scale(.5)}.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner{opacity:1;margin-left:0;transform:none}.ladda-button[data-style=zoom-in]{overflow:hidden}.ladda-button[data-style=zoom-in] .ladda-spinner{left:50%;margin-left:-16px;transform:scale(.2)}.ladda-button[data-style=zoom-in] .ladda-label{position:relative;display:inline-block}.ladda-button[data-style=zoom-in][data-loading] .ladda-label{opacity:0;transform:scale(2.2)}.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner{opacity:1;margin-left:0;transform:none}.ladda-button[data-style=contract]{overflow:hidden;width:100px}.ladda-button[data-style=contract] .ladda-spinner{left:50%;margin-left:0}.ladda-button[data-style=contract][data-loading]{border-radius:50%;width:52px}.ladda-button[data-style=contract][data-loading] .ladda-label{opacity:0}.ladda-button[data-style=contract][data-loading] .ladda-spinner{opacity:1}.ladda-button[data-style=contract-overlay]{overflow:hidden;width:100px;box-shadow:0 0 0 2000px transparent}.ladda-button[data-style=contract-overlay] .ladda-spinner{left:50%;margin-left:0}.ladda-button[data-style=contract-overlay][data-loading]{border-radius:50%;width:52px;box-shadow:0 0 0 2000px rgba(0,0,0,.8)}.ladda-button[data-style=contract-overlay][data-loading] .ladda-label{opacity:0}.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner{opacity:1}[dir=rtl] .ladda-spinner>div{left:25%!important}.select2-container--bootstrap{display:block}.select2-container--bootstrap .select2-selection{box-shadow:inset 0 1px 1px rgba(0,0,0,.075);background-color:#fff;border:1px solid #ccc;border-radius:4px;color:#555;font-size:14px;outline:0}.select2-container--bootstrap .select2-selection.form-control{border-radius:4px}.select2-container--bootstrap .select2-search--dropdown .select2-search__field{box-shadow:inset 0 1px 1px rgba(0,0,0,.075);background-color:#fff;border:1px solid #ccc;border-radius:4px;color:#555;font-size:14px}.select2-container--bootstrap .select2-search__field{outline:0}.select2-container--bootstrap .select2-search__field::-webkit-input-placeholder{color:#999}.select2-container--bootstrap .select2-search__field:-moz-placeholder{color:#999}.select2-container--bootstrap .select2-search__field::-moz-placeholder{color:#999;opacity:1}.select2-container--bootstrap .select2-search__field:-ms-input-placeholder{color:#999}.select2-container--bootstrap .select2-results__option{padding:6px 12px}.select2-container--bootstrap .select2-results__option[role=group]{padding:0}.select2-container--bootstrap .select2-results__option[aria-disabled=true]{color:#777;cursor:not-allowed}.select2-container--bootstrap .select2-results__option[aria-selected=true]{background-color:#f5f5f5;color:#262626}.select2-container--bootstrap .select2-results__option--highlighted[aria-selected]{background-color:#337ab7;color:#fff}.select2-container--bootstrap .select2-results__option .select2-results__option{padding:6px 12px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__group{padding-left:0}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option{margin-left:-12px;padding-left:24px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-24px;padding-left:36px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-36px;padding-left:48px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-48px;padding-left:60px}.select2-container--bootstrap .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option .select2-results__option{margin-left:-60px;padding-left:72px}.select2-container--bootstrap .select2-results__group{color:#777;display:block;padding:6px 12px;font-size:12px;line-height:1.42857;white-space:nowrap}.select2-container--bootstrap.select2-container--focus .select2-selection,.select2-container--bootstrap.select2-container--open .select2-selection{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out!important;border-color:#66afe9}.select2-container--bootstrap.select2-container--open .select2-selection .select2-selection__arrow b{border-color:transparent transparent #999;border-width:0 4px 4px}.select2-container--bootstrap.select2-container--open.select2-container--below .select2-selection{border-bottom-right-radius:0;border-bottom-left-radius:0;border-bottom-color:transparent}.select2-container--bootstrap.select2-container--open.select2-container--above .select2-selection{border-top-right-radius:0;border-top-left-radius:0;border-top-color:transparent}.select2-container--bootstrap .select2-selection__clear{color:#999;cursor:pointer;float:right;font-weight:700;margin-right:10px}.select2-container--bootstrap .select2-selection__clear:hover{color:#333}.select2-container--bootstrap.select2-container--disabled .select2-selection{border-color:#ccc;box-shadow:none}.select2-container--bootstrap.select2-container--disabled .select2-search__field,.select2-container--bootstrap.select2-container--disabled .select2-selection{cursor:not-allowed}.select2-container--bootstrap.select2-container--disabled .select2-selection,.select2-container--bootstrap.select2-container--disabled .select2-selection--multiple .select2-selection__choice{background-color:#eee}.select2-container--bootstrap.select2-container--disabled .select2-selection--multiple .select2-selection__choice__remove,.select2-container--bootstrap.select2-container--disabled .select2-selection__clear{display:none}.select2-container--bootstrap .select2-dropdown{box-shadow:0 6px 12px rgba(0,0,0,.175);border-color:#66afe9;overflow-x:hidden;margin-top:-1px}.select2-container--bootstrap .select2-dropdown--above{box-shadow:0 -6px 12px rgba(0,0,0,.175);margin-top:1px}.select2-container--bootstrap .select2-results>.select2-results__options{max-height:200px;overflow-y:auto}.select2-container--bootstrap .select2-selection--single{height:34px;line-height:1.42857;padding:6px 24px 6px 12px}.select2-container--bootstrap .select2-selection--single .select2-selection__arrow{position:absolute;bottom:0;right:12px;top:0;width:4px}.select2-container--bootstrap .select2-selection--single .select2-selection__arrow b{border-color:#999 transparent transparent;border-style:solid;border-width:4px 4px 0;height:0;left:0;margin-left:-4px;margin-top:-2px;position:absolute;top:50%;width:0}.select2-container--bootstrap .select2-selection--single .select2-selection__rendered{color:#555;padding:0}.select2-container--bootstrap .select2-selection--single .select2-selection__placeholder{color:#999}.select2-container--bootstrap .select2-selection--multiple{min-height:34px;padding:0;height:auto}.select2-container--bootstrap .select2-selection--multiple .select2-selection__rendered{box-sizing:border-box;display:block;line-height:1.42857;list-style:none;margin:0;overflow:hidden;padding:0;width:100%;text-overflow:ellipsis;white-space:nowrap}.select2-container--bootstrap .select2-selection--multiple .select2-selection__placeholder{color:#999;float:left;margin-top:5px}.select2-container--bootstrap .select2-selection--multiple .select2-selection__choice{color:#555;background:#fff;border:1px solid #ccc;border-radius:4px;cursor:default;float:left;margin:5px 0 0 6px;padding:0 6px}.select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field{background:transparent;padding:0 12px;height:32px;line-height:1.42857;margin-top:0;min-width:5em}.select2-container--bootstrap .select2-selection--multiple .select2-selection__choice__remove{color:#999;cursor:pointer;display:inline-block;font-weight:700;margin-right:3px}.select2-container--bootstrap .select2-selection--multiple .select2-selection__choice__remove:hover{color:#333}.select2-container--bootstrap .select2-selection--multiple .select2-selection__clear{margin-top:6px}.form-group-sm .input-group .select2-container--bootstrap .select2-selection--single,.form-group-sm .select2-container--bootstrap .input-group>.input-group-btn>.select2-selection--single.btn,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--single.form-control,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--single.input-group-addon,.form-group-sm .select2-container--bootstrap .select2-selection--single,.input-group-sm .select2-container--bootstrap .select2-selection--single,.select2-container--bootstrap .form-group-sm .input-group>.input-group-btn>.select2-selection--single.btn,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--single.form-control,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--single.input-group-addon,.select2-container--bootstrap .input-group-sm>.input-group-btn>.select2-selection--single.btn,.select2-container--bootstrap .input-group-sm>.select2-selection--single.form-control,.select2-container--bootstrap .input-group-sm>.select2-selection--single.input-group-addon,.select2-container--bootstrap .select2-selection--single.input-sm,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--single.ui-select-choices-row,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--single.ui-select-toggle,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--single.ui-select-choices-row,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--single.ui-select-toggle{border-radius:3px;font-size:12px;height:30px;line-height:1.5;padding:5px 22px 5px 10px}.form-group-sm .input-group .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.form-group-sm .select2-container--bootstrap .input-group>.input-group-btn>.select2-selection--single.btn .select2-selection__arrow b,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--single.form-control .select2-selection__arrow b,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--single.input-group-addon .select2-selection__arrow b,.form-group-sm .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.input-group-sm .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .form-group-sm .input-group>.input-group-btn>.select2-selection--single.btn .select2-selection__arrow b,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--single.form-control .select2-selection__arrow b,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--single.input-group-addon .select2-selection__arrow b,.select2-container--bootstrap .input-group-sm>.input-group-btn>.select2-selection--single.btn .select2-selection__arrow b,.select2-container--bootstrap .input-group-sm>.select2-selection--single.form-control .select2-selection__arrow b,.select2-container--bootstrap .input-group-sm>.select2-selection--single.input-group-addon .select2-selection__arrow b,.select2-container--bootstrap .select2-selection--single.input-sm .select2-selection__arrow b,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--single.ui-select-choices-row .select2-selection__arrow b,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--single.ui-select-toggle .select2-selection__arrow b,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--single.ui-select-choices-row .select2-selection__arrow b,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--single.ui-select-toggle .select2-selection__arrow b{margin-left:-5px}.form-group-sm .input-group .select2-container--bootstrap .select2-selection--multiple,.form-group-sm .select2-container--bootstrap .input-group>.input-group-btn>.select2-selection--multiple.btn,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--multiple.form-control,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--multiple.input-group-addon,.form-group-sm .select2-container--bootstrap .select2-selection--multiple,.input-group-sm .select2-container--bootstrap .select2-selection--multiple,.select2-container--bootstrap .form-group-sm .input-group>.input-group-btn>.select2-selection--multiple.btn,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--multiple.form-control,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--multiple.input-group-addon,.select2-container--bootstrap .input-group-sm>.input-group-btn>.select2-selection--multiple.btn,.select2-container--bootstrap .input-group-sm>.select2-selection--multiple.form-control,.select2-container--bootstrap .input-group-sm>.select2-selection--multiple.input-group-addon,.select2-container--bootstrap .select2-selection--multiple.input-sm,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--multiple.ui-select-choices-row,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--multiple.ui-select-toggle,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--multiple.ui-select-choices-row,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--multiple.ui-select-toggle{min-height:30px;border-radius:3px}.form-group-sm .input-group .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.form-group-sm .select2-container--bootstrap .input-group>.input-group-btn>.select2-selection--multiple.btn .select2-selection__choice,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--multiple.form-control .select2-selection__choice,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--multiple.input-group-addon .select2-selection__choice,.form-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.input-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.select2-container--bootstrap .form-group-sm .input-group>.input-group-btn>.select2-selection--multiple.btn .select2-selection__choice,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--multiple.form-control .select2-selection__choice,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--multiple.input-group-addon .select2-selection__choice,.select2-container--bootstrap .input-group-sm>.input-group-btn>.select2-selection--multiple.btn .select2-selection__choice,.select2-container--bootstrap .input-group-sm>.select2-selection--multiple.form-control .select2-selection__choice,.select2-container--bootstrap .input-group-sm>.select2-selection--multiple.input-group-addon .select2-selection__choice,.select2-container--bootstrap .select2-selection--multiple.input-sm .select2-selection__choice,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--multiple.ui-select-choices-row .select2-selection__choice,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--multiple.ui-select-toggle .select2-selection__choice,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--multiple.ui-select-choices-row .select2-selection__choice,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--multiple.ui-select-toggle .select2-selection__choice{font-size:12px;line-height:1.5;margin:4px 0 0 5px;padding:0 5px}.form-group-sm .input-group .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.form-group-sm .select2-container--bootstrap .input-group>.input-group-btn>.select2-selection--multiple.btn .select2-search--inline .select2-search__field,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--multiple.form-control .select2-search--inline .select2-search__field,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--multiple.input-group-addon .select2-search--inline .select2-search__field,.form-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.input-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.select2-container--bootstrap .form-group-sm .input-group>.input-group-btn>.select2-selection--multiple.btn .select2-search--inline .select2-search__field,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--multiple.form-control .select2-search--inline .select2-search__field,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--multiple.input-group-addon .select2-search--inline .select2-search__field,.select2-container--bootstrap .input-group-sm>.input-group-btn>.select2-selection--multiple.btn .select2-search--inline .select2-search__field,.select2-container--bootstrap .input-group-sm>.select2-selection--multiple.form-control .select2-search--inline .select2-search__field,.select2-container--bootstrap .input-group-sm>.select2-selection--multiple.input-group-addon .select2-search--inline .select2-search__field,.select2-container--bootstrap .select2-selection--multiple.input-sm .select2-search--inline .select2-search__field,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--multiple.ui-select-choices-row .select2-search--inline .select2-search__field,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--multiple.ui-select-toggle .select2-search--inline .select2-search__field,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--multiple.ui-select-choices-row .select2-search--inline .select2-search__field,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--multiple.ui-select-toggle .select2-search--inline .select2-search__field{padding:0 10px;font-size:12px;height:28px;line-height:1.5}.form-group-sm .input-group .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.form-group-sm .select2-container--bootstrap .input-group>.input-group-btn>.select2-selection--multiple.btn .select2-selection__clear,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--multiple.form-control .select2-selection__clear,.form-group-sm .select2-container--bootstrap .input-group>.select2-selection--multiple.input-group-addon .select2-selection__clear,.form-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.input-group-sm .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.select2-container--bootstrap .form-group-sm .input-group>.input-group-btn>.select2-selection--multiple.btn .select2-selection__clear,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--multiple.form-control .select2-selection__clear,.select2-container--bootstrap .form-group-sm .input-group>.select2-selection--multiple.input-group-addon .select2-selection__clear,.select2-container--bootstrap .input-group-sm>.input-group-btn>.select2-selection--multiple.btn .select2-selection__clear,.select2-container--bootstrap .input-group-sm>.select2-selection--multiple.form-control .select2-selection__clear,.select2-container--bootstrap .input-group-sm>.select2-selection--multiple.input-group-addon .select2-selection__clear,.select2-container--bootstrap .select2-selection--multiple.input-sm .select2-selection__clear,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--multiple.ui-select-choices-row .select2-selection__clear,.select2-container--bootstrap .ui-select-container.input-sm .select2-selection--multiple.ui-select-toggle .select2-selection__clear,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--multiple.ui-select-choices-row .select2-selection__clear,.ui-select-container.input-sm .select2-container--bootstrap .select2-selection--multiple.ui-select-toggle .select2-selection__clear{margin-top:5px}.form-group-lg .select2-container--bootstrap .select2-selection--single,.input-group-lg .select2-container--bootstrap .select2-selection--single,.select2-container--bootstrap .input-group-lg>.input-group-btn>.select2-selection--single.btn,.select2-container--bootstrap .input-group-lg>.select2-selection--single.form-control,.select2-container--bootstrap .input-group-lg>.select2-selection--single.input-group-addon,.select2-container--bootstrap .select2-selection--single.input-lg{border-radius:6px;font-size:18px;height:46px;line-height:1.33333;padding:10px 31px 10px 16px}.form-group-lg .select2-container--bootstrap .select2-selection--single .select2-selection__arrow,.input-group-lg .select2-container--bootstrap .select2-selection--single .select2-selection__arrow,.select2-container--bootstrap .input-group-lg>.input-group-btn>.select2-selection--single.btn .select2-selection__arrow,.select2-container--bootstrap .input-group-lg>.select2-selection--single.form-control .select2-selection__arrow,.select2-container--bootstrap .input-group-lg>.select2-selection--single.input-group-addon .select2-selection__arrow,.select2-container--bootstrap .select2-selection--single.input-lg .select2-selection__arrow{width:5px}.form-group-lg .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.input-group-lg .select2-container--bootstrap .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .input-group-lg>.input-group-btn>.select2-selection--single.btn .select2-selection__arrow b,.select2-container--bootstrap .input-group-lg>.select2-selection--single.form-control .select2-selection__arrow b,.select2-container--bootstrap .input-group-lg>.select2-selection--single.input-group-addon .select2-selection__arrow b,.select2-container--bootstrap .select2-selection--single.input-lg .select2-selection__arrow b{border-width:5px 5px 0;margin-left:-5px;margin-left:-10px;margin-top:-2.5px}.form-group-lg .select2-container--bootstrap .select2-selection--multiple,.input-group-lg .select2-container--bootstrap .select2-selection--multiple,.select2-container--bootstrap .input-group-lg>.input-group-btn>.select2-selection--multiple.btn,.select2-container--bootstrap .input-group-lg>.select2-selection--multiple.form-control,.select2-container--bootstrap .input-group-lg>.select2-selection--multiple.input-group-addon,.select2-container--bootstrap .select2-selection--multiple.input-lg{min-height:46px;border-radius:6px}.form-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.input-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-selection__choice,.select2-container--bootstrap .input-group-lg>.input-group-btn>.select2-selection--multiple.btn .select2-selection__choice,.select2-container--bootstrap .input-group-lg>.select2-selection--multiple.form-control .select2-selection__choice,.select2-container--bootstrap .input-group-lg>.select2-selection--multiple.input-group-addon .select2-selection__choice,.select2-container--bootstrap .select2-selection--multiple.input-lg .select2-selection__choice{font-size:18px;line-height:1.33333;border-radius:4px;margin:9px 0 0 8px;padding:0 10px}.form-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.input-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field,.select2-container--bootstrap .input-group-lg>.input-group-btn>.select2-selection--multiple.btn .select2-search--inline .select2-search__field,.select2-container--bootstrap .input-group-lg>.select2-selection--multiple.form-control .select2-search--inline .select2-search__field,.select2-container--bootstrap .input-group-lg>.select2-selection--multiple.input-group-addon .select2-search--inline .select2-search__field,.select2-container--bootstrap .select2-selection--multiple.input-lg .select2-search--inline .select2-search__field{padding:0 16px;font-size:18px;height:44px;line-height:1.33333}.form-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.input-group-lg .select2-container--bootstrap .select2-selection--multiple .select2-selection__clear,.select2-container--bootstrap .input-group-lg>.input-group-btn>.select2-selection--multiple.btn .select2-selection__clear,.select2-container--bootstrap .input-group-lg>.select2-selection--multiple.form-control .select2-selection__clear,.select2-container--bootstrap .input-group-lg>.select2-selection--multiple.input-group-addon .select2-selection__clear,.select2-container--bootstrap .select2-selection--multiple.input-lg .select2-selection__clear{margin-top:10px}.input-group-lg .select2-container--bootstrap .select2-selection.select2-container--open .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .input-group-lg>.input-group-btn>.select2-selection.select2-container--open.btn .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .input-group-lg>.select2-selection.select2-container--open.form-control .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .input-group-lg>.select2-selection.select2-container--open.input-group-addon .select2-selection--single .select2-selection__arrow b,.select2-container--bootstrap .select2-selection.input-lg.select2-container--open .select2-selection--single .select2-selection__arrow b{border-color:transparent transparent #999;border-width:0 5px 5px}.select2-container--bootstrap[dir=rtl] .select2-selection--single{padding-left:24px;padding-right:12px}.select2-container--bootstrap[dir=rtl] .select2-selection--single .select2-selection__rendered{padding-right:0;padding-left:0;text-align:right}.select2-container--bootstrap[dir=rtl] .select2-selection--single .select2-selection__clear{float:left}.select2-container--bootstrap[dir=rtl] .select2-selection--single .select2-selection__arrow{left:12px;right:auto}.select2-container--bootstrap[dir=rtl] .select2-selection--single .select2-selection__arrow b{margin-left:0}.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-search--inline,.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-selection__choice,.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-selection__placeholder{float:right}.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-selection__choice{margin-left:0;margin-right:6px}.select2-container--bootstrap[dir=rtl] .select2-selection--multiple .select2-selection__choice__remove{margin-left:2px;margin-right:auto}.has-warning .select2-dropdown,.has-warning .select2-selection{border-color:#8a6d3b}.has-warning .select2-container--focus .select2-selection,.has-warning .select2-container--open .select2-selection{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;border-color:#66512c}.has-warning.select2-drop-active{border-color:#66512c}.has-warning.select2-drop-active.select2-drop.select2-drop-above{border-top-color:#66512c}.has-error .select2-dropdown,.has-error .select2-selection{border-color:#a94442}.has-error .select2-container--focus .select2-selection,.has-error .select2-container--open .select2-selection{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;border-color:#843534}.has-error.select2-drop-active{border-color:#843534}.has-error.select2-drop-active.select2-drop.select2-drop-above{border-top-color:#843534}.has-success .select2-dropdown,.has-success .select2-selection{border-color:#3c763d}.has-success .select2-container--focus .select2-selection,.has-success .select2-container--open .select2-selection{box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;border-color:#2b542c}.has-success.select2-drop-active{border-color:#2b542c}.has-success.select2-drop-active.select2-drop.select2-drop-above{border-top-color:#2b542c}.input-group>.select2-hidden-accessible:first-child+.select2-container--bootstrap>.selection>.select2-selection,.input-group>.select2-hidden-accessible:first-child+.select2-container--bootstrap>.selection>.select2-selection.form-control{border-bottom-right-radius:0;border-top-right-radius:0}.input-group>.select2-hidden-accessible:not(:first-child)+.select2-container--bootstrap:not(:last-child)>.selection>.select2-selection,.input-group>.select2-hidden-accessible:not(:first-child)+.select2-container--bootstrap:not(:last-child)>.selection>.select2-selection.form-control{border-radius:0}.input-group>.select2-hidden-accessible:not(:first-child):not(:last-child)+.select2-container--bootstrap:last-child>.selection>.select2-selection,.input-group>.select2-hidden-accessible:not(:first-child):not(:last-child)+.select2-container--bootstrap:last-child>.selection>.select2-selection.form-control{border-bottom-left-radius:0;border-top-left-radius:0}.input-group>.select2-container--bootstrap{display:table;table-layout:fixed;position:relative;z-index:2;width:100%;margin-bottom:0}.input-group>.select2-container--bootstrap>.selection>.select2-selection.form-control{float:none}.input-group>.select2-container--bootstrap.select2-container--focus,.input-group>.select2-container--bootstrap.select2-container--open{z-index:3}.input-group>.select2-container--bootstrap,.input-group>.select2-container--bootstrap .input-group-btn,.input-group>.select2-container--bootstrap .input-group-btn .btn{vertical-align:top}.form-control.select2-hidden-accessible{position:absolute!important;width:1px!important}@media (min-width:768px){.form-inline .select2-container--bootstrap{display:inline-block}}.daterangepicker{position:absolute;color:inherit;background-color:#fff;border-radius:4px;width:278px;padding:4px;margin-top:1px;top:100px;left:20px}.daterangepicker:after,.daterangepicker:before{position:absolute;display:inline-block;border-bottom-color:rgba(0,0,0,.2);content:\"\"}.daterangepicker:before{top:-7px;border-right:7px solid transparent;border-left:7px solid transparent;border-bottom:7px solid #ccc}.daterangepicker:after{top:-6px;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.daterangepicker.opensleft:before{right:9px}.daterangepicker.opensleft:after{right:10px}.daterangepicker.openscenter:after,.daterangepicker.openscenter:before{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.daterangepicker.opensright:before{left:9px}.daterangepicker.opensright:after{left:10px}.daterangepicker.dropup{margin-top:-5px}.daterangepicker.dropup:before{top:auto;bottom:-7px;border-bottom:initial;border-top:7px solid #ccc}.daterangepicker.dropup:after{top:auto;bottom:-6px;border-bottom:initial;border-top:6px solid #fff}.daterangepicker.dropdown-menu{max-width:none;z-index:3001}.daterangepicker.single .calendar,.daterangepicker.single .ranges{float:none}.daterangepicker.show-calendar .calendar{display:block}.daterangepicker .calendar{display:none;max-width:270px;margin:4px}.daterangepicker .calendar.single .calendar-table{border:none}.daterangepicker .calendar td,.daterangepicker .calendar th{white-space:nowrap;text-align:center;min-width:32px}.daterangepicker .calendar-table{border:1px solid #fff;padding:4px;border-radius:4px;background-color:#fff}.daterangepicker table{width:100%;margin:0}.daterangepicker td,.daterangepicker th{text-align:center;width:20px;height:20px;border-radius:4px;border:1px solid transparent;white-space:nowrap;cursor:pointer}.daterangepicker td.available:hover,.daterangepicker th.available:hover{background-color:#eee;border-color:transparent;color:inherit}.daterangepicker td.week,.daterangepicker th.week{font-size:80%;color:#ccc}.daterangepicker td.off,.daterangepicker td.off.end-date,.daterangepicker td.off.in-range,.daterangepicker td.off.start-date{background-color:#fff;border-color:transparent;color:#999}.daterangepicker td.in-range{background-color:#ebf4f8;border-color:transparent;color:#000;border-radius:0}.daterangepicker td.start-date{border-radius:4px 0 0 4px}.daterangepicker td.end-date{border-radius:0 4px 4px 0}.daterangepicker td.start-date.end-date{border-radius:4px}.daterangepicker td.active,.daterangepicker td.active:hover{background-color:#357ebd;border-color:transparent;color:#fff}.daterangepicker th.month{width:auto}.daterangepicker option.disabled,.daterangepicker td.disabled{color:#999;cursor:not-allowed;text-decoration:line-through}.daterangepicker select.monthselect,.daterangepicker select.yearselect{font-size:12px;padding:1px;height:auto;margin:0;cursor:default}.daterangepicker select.monthselect{margin-right:2%;width:56%}.daterangepicker select.yearselect{width:40%}.daterangepicker select.ampmselect,.daterangepicker select.hourselect,.daterangepicker select.minuteselect,.daterangepicker select.secondselect{width:50px;margin-bottom:0}.daterangepicker .input-mini{border:1px solid #ccc;border-radius:4px;color:#555;height:30px;line-height:30px;display:block;vertical-align:middle;margin:0 0 5px;padding:0 6px 0 28px;width:100%}.daterangepicker .input-mini.active{border:1px solid #08c;border-radius:4px}.daterangepicker .daterangepicker_input{position:relative}.daterangepicker .daterangepicker_input i{position:absolute;left:8px;top:8px}.daterangepicker.rtl .input-mini{padding-right:28px;padding-left:6px}.daterangepicker.rtl .daterangepicker_input i{left:auto;right:8px}.daterangepicker .calendar-time{text-align:center;margin:5px auto;line-height:30px;position:relative;padding-left:28px}.daterangepicker .calendar-time select.disabled{color:#ccc;cursor:not-allowed}.ranges{font-size:11px;float:none;margin:4px;text-align:left}.ranges ul{list-style:none;margin:0 auto;padding:0;width:100%}.ranges li{font-size:13px;background-color:#f5f5f5;border:1px solid #f5f5f5;border-radius:4px;color:#08c;padding:3px 12px;margin-bottom:8px;cursor:pointer}.ranges li.active,.ranges li:hover{background-color:#08c;border:1px solid #08c;color:#fff}@media (min-width:564px){.daterangepicker{width:auto}.daterangepicker .ranges ul{width:160px}.daterangepicker.single .ranges ul{width:100%}.daterangepicker.single .calendar.left{clear:none}.daterangepicker.single.ltr .calendar,.daterangepicker.single.ltr .ranges{float:left}.daterangepicker.single.rtl .calendar,.daterangepicker.single.rtl .ranges{float:right}.daterangepicker.ltr{direction:ltr;text-align:left}.daterangepicker.ltr .calendar.left{clear:left;margin-right:0}.daterangepicker.ltr .calendar.left .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.daterangepicker.ltr .calendar.right{margin-left:0}.daterangepicker.ltr .calendar.right .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.daterangepicker.ltr .calendar.left .calendar-table,.daterangepicker.ltr .left .daterangepicker_input{padding-right:12px}.daterangepicker.ltr .calendar,.daterangepicker.ltr .ranges{float:left}.daterangepicker.rtl{direction:rtl;text-align:right}.daterangepicker.rtl .calendar.left{clear:right;margin-left:0}.daterangepicker.rtl .calendar.left .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.daterangepicker.rtl .calendar.right{margin-right:0}.daterangepicker.rtl .calendar.right .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.daterangepicker.rtl .calendar.left .calendar-table,.daterangepicker.rtl .left .daterangepicker_input{padding-left:12px}.daterangepicker.rtl .calendar,.daterangepicker.rtl .ranges{text-align:right;float:right}}@media (min-width:730px){.daterangepicker .ranges{width:auto}.daterangepicker.ltr .ranges{float:left}.daterangepicker.rtl .ranges{float:right}.daterangepicker .calendar.left{clear:none!important}}/*!\n * ui-select\n * http://github.com/angular-ui/ui-select\n * Version: 0.19.8 - 2017-04-18T05:43:43.881Z\n * License: MIT\n */.ui-select-highlight{font-weight:700}.ui-select-offscreen{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.ui-select-choices-row:hover{background-color:#f5f5f5}.ng-dirty.ng-invalid>a.select2-choice{border-color:#d44950}.select2-result-single{padding-left:0}.select2-locked>.select2-search-choice-close,.select-locked>.ui-select-match-close{display:none}body>.select2-container.open{z-index:9999}.ui-select-container.select2.direction-up .ui-select-match,.ui-select-container[theme=select2].direction-up .ui-select-match{border-radius:4px;border-top-left-radius:0;border-top-right-radius:0}.ui-select-container.select2.direction-up .ui-select-dropdown,.ui-select-container[theme=select2].direction-up .ui-select-dropdown{border-radius:4px;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-width:1px;border-top-style:solid;box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-4px}.ui-select-container.select2.direction-up .ui-select-dropdown .select2-search,.ui-select-container[theme=select2].direction-up .ui-select-dropdown .select2-search{margin-top:4px}.ui-select-container.select2.direction-up.select2-dropdown-open .ui-select-match,.ui-select-container[theme=select2].direction-up.select2-dropdown-open .ui-select-match{border-bottom-color:#5897fb}.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden,.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden input{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.selectize-input.selectize-focus{border-color:#007fbb!important}.selectize-control.single>.selectize-input>input{width:100%}.selectize-control.multi>.selectize-input>input{margin:0!important}.selectize-control>.selectize-dropdown{width:100%}.ng-dirty.ng-invalid>div.selectize-input{border-color:#d44950}.ui-select-container[theme=selectize].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-2px}.ui-select-container[theme=selectize] input.ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0;width:0}.btn-default-focus{color:#333;background-color:#ebebeb;border-color:#adadad;text-decoration:none;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-select-bootstrap .ui-select-toggle{position:relative}.ui-select-bootstrap .ui-select-toggle>.caret{position:absolute;height:10px;top:50%;right:10px;margin-top:-2px}.input-group>.ui-select-bootstrap.dropdown{position:static}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control{border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control.direction-up{border-radius:4px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important}.ui-select-bootstrap .ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.ui-select-bootstrap>.ui-select-match>.btn{text-align:left!important}.ui-select-bootstrap>.ui-select-match>.caret{position:absolute;top:45%;right:15px}.ui-select-bootstrap>.ui-select-choices,.ui-select-bootstrap>.ui-select-no-choice{width:100%;height:auto;max-height:200px;overflow-x:hidden;margin-top:-1px}body>.ui-select-bootstrap.open{z-index:1000}.ui-select-multiple.ui-select-bootstrap{height:auto;padding:3px 3px 0}.ui-select-multiple.ui-select-bootstrap input.ui-select-search{background-color:transparent!important;border:none;outline:none;height:1.666666em;margin-bottom:3px}.ui-select-multiple.ui-select-bootstrap .ui-select-match .close{font-size:1.6em;line-height:.75}.ui-select-multiple.ui-select-bootstrap .ui-select-match-item{outline:0;margin:0 3px 3px 0}.ui-select-multiple .ui-select-match-item{position:relative}.ui-select-multiple .ui-select-match-item.dropping .ui-select-match-close{pointer-events:none}.ui-select-multiple:hover .ui-select-match-item.dropping-before:before{content:\"\";position:absolute;top:0;right:100%;height:100%;margin-right:2px;border-left:1px solid #428bca}.ui-select-multiple:hover .ui-select-match-item.dropping-after:after{content:\"\";position:absolute;top:0;left:100%;height:100%;margin-left:2px;border-right:1px solid #428bca}.ui-select-bootstrap .ui-select-choices-row>span{cursor:pointer;display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.ui-select-bootstrap .ui-select-choices-row>span:focus,.ui-select-bootstrap .ui-select-choices-row>span:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.ui-select-bootstrap .ui-select-choices-row.active>span{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.ui-select-bootstrap .ui-select-choices-row.active.disabled>span,.ui-select-bootstrap .ui-select-choices-row.disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.ui-select-match.ng-hide-add,.ui-select-search.ng-hide-add{display:none!important}.ui-select-bootstrap.ng-dirty.ng-invalid>button.btn.ui-select-match{border-color:#d44950}.ui-select-container[theme=bootstrap].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25)}.ui-select-bootstrap .ui-select-match-text{width:100%;padding-right:1em}.ui-select-bootstrap .ui-select-match-text span{display:inline-block;width:100%;overflow:hidden}.ui-select-bootstrap .ui-select-toggle>a.btn{position:absolute;height:10px;right:10px;margin-top:-2px}.ui-select-refreshing.glyphicon{position:absolute;right:0;padding:8px 27px}@keyframes ui-select-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.ui-select-spin{animation:ui-select-spin 2s infinite linear}.ui-select-refreshing.ng-animate{-webkit-animation:none 0s}.ng-table th{text-align:center;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-table th.sortable{cursor:pointer}.ng-table th.sortable .sort-indicator{padding-right:18px;position:relative}.ng-table th.sortable .sort-indicator:after,.ng-table th.sortable .sort-indicator:before{content:\"\";border-width:0 4px 4px;border-style:solid;border-color:#000 transparent;visibility:visible;right:5px;top:50%;position:absolute;opacity:.3;margin-top:-4px}.ng-table th.sortable .sort-indicator:before{margin-top:2px;border-bottom:none;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid #000}.ng-table th.sortable .sort-indicator:hover:after,.ng-table th.sortable .sort-indicator:hover:before{opacity:1;visibility:visible}.ng-table th.sortable.sort-asc,.ng-table th.sortable.sort-desc{background-color:rgba(141,192,219,.25);text-shadow:0 1px 1px hsla(0,0%,100%,.75)}.ng-table th.sortable.sort-asc .sort-indicator:after,.ng-table th.sortable.sort-desc .sort-indicator:after{margin-top:-2px}.ng-table th.sortable.sort-asc .sort-indicator:before,.ng-table th.sortable.sort-desc .sort-indicator:before{visibility:hidden}.ng-table th.sortable.sort-asc .sort-indicator:after,.ng-table th.sortable.sort-asc .sort-indicator:hover:after,.ng-table th.sortable.sort-desc .sort-indicator:after{visibility:visible;filter:alpha(opacity=60);-khtml-opacity:.6;-moz-opacity:.6;opacity:.6}.ng-table th.sortable.sort-desc .sort-indicator:after{border-bottom:none;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid #000;box-shadow:none}.ng-table th.filter .input-filter{margin:0;display:block;width:100%;min-height:30px;box-sizing:border-box}.ng-table .ng-table-group-header th{text-align:left}.ng-table .ng-table-group-selector{display:block}.ng-table .ng-table-group-close,.ng-table .ng-table-group-toggle{float:right}.ng-table .ng-table-group-toggle{margin-right:5px}@media only screen and (max-width:800px){.ng-table-responsive{border-bottom:1px solid #999}.ng-table-responsive tr{border-top:1px solid #999;border-left:1px solid #999;border-right:1px solid #999}.ng-table-responsive td:before{position:absolute;padding:8px;left:0;top:0;width:50%;white-space:nowrap;text-align:left;font-weight:700}.ng-table-responsive thead tr th{text-align:left}.ng-table-responsive thead tr.ng-table-filters th{padding:0}.ng-table-responsive thead tr.ng-table-filters th form>div{padding:8px}.ng-table-responsive td{border:none;border-bottom:1px solid #eee;position:relative;padding-left:50%;white-space:normal;text-align:left}.ng-table-responsive td:before{content:attr(data-title-text)}.ng-table-responsive,.ng-table-responsive tbody,.ng-table-responsive td,.ng-table-responsive th,.ng-table-responsive thead,.ng-table-responsive tr{display:block}}.ng-table-pagination{margin-top:0}.filter:after,.filter:before,.ng-table-group-selector:after,.ng-table-group-selector:before{display:table;content:\" \"}.filter:after,.ng-table-group-selector:after{clear:both}.filter>.filter-cell{float:left;box-sizing:border-box}.filter-horizontal>.filter-cell{padding:0 2px}.filter-horizontal>.filter-cell:first-child{padding-left:0}.filter-horizontal>.filter-cell.last,.filter-horizontal>.filter-cell:last-child{padding-right:0}.s12{width:100%}.s11{width:91.66666666666666%}.s10{width:83.33333333333334%}.s9{width:75%}.s8{width:66.66666666666666%}.s7{width:58.333333333333336%}.s6{width:50%}.s5{width:41.66666666666667%}.s4{width:33.33333333333333%}.s3{width:25%}.s2{width:16.666666666666664%}.s1{width:8.333333333333332%}@media (max-width:468px){.s1,.s2,.s3,.s4,.s5,.s6,.s7,.s8,.s9,.s10,.s11,.s12{width:100%}.filter>.filter-cell{padding:0}}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:1500px){.container{width:1530px}}.test-bar{height:30px;padding-top:2px}.test-bar p.testenv{text-align:center;margin:3px 0 5px}@media (min-width:1500px){.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12{float:left}.col-xl-1{width:8.33333%}.col-xl-2{width:16.66667%}.col-xl-3{width:25%}.col-xl-4{width:33.33333%}.col-xl-5{width:41.66667%}.col-xl-6{width:50%}.col-xl-7{width:58.33333%}.col-xl-8{width:66.66667%}.col-xl-9{width:75%}.col-xl-10{width:83.33333%}.col-xl-11{width:91.66667%}.col-xl-12{width:100%}.col-xl-pull-0{right:auto}.col-xl-pull-1{right:8.33333%}.col-xl-pull-2{right:16.66667%}.col-xl-pull-3{right:25%}.col-xl-pull-4{right:33.33333%}.col-xl-pull-5{right:41.66667%}.col-xl-pull-6{right:50%}.col-xl-pull-7{right:58.33333%}.col-xl-pull-8{right:66.66667%}.col-xl-pull-9{right:75%}.col-xl-pull-10{right:83.33333%}.col-xl-pull-11{right:91.66667%}.col-xl-pull-12{right:100%}.col-xl-push-0{left:auto}.col-xl-push-1{left:8.33333%}.col-xl-push-2{left:16.66667%}.col-xl-push-3{left:25%}.col-xl-push-4{left:33.33333%}.col-xl-push-5{left:41.66667%}.col-xl-push-6{left:50%}.col-xl-push-7{left:58.33333%}.col-xl-push-8{left:66.66667%}.col-xl-push-9{left:75%}.col-xl-push-10{left:83.33333%}.col-xl-push-11{left:91.66667%}.col-xl-push-12{left:100%}.col-xl-offset-0{margin-left:0}.col-xl-offset-1{margin-left:8.33333%}.col-xl-offset-2{margin-left:16.66667%}.col-xl-offset-3{margin-left:25%}.col-xl-offset-4{margin-left:33.33333%}.col-xl-offset-5{margin-left:41.66667%}.col-xl-offset-6{margin-left:50%}.col-xl-offset-7{margin-left:58.33333%}.col-xl-offset-8{margin-left:66.66667%}.col-xl-offset-9{margin-left:75%}.col-xl-offset-10{margin-left:83.33333%}.col-xl-offset-11{margin-left:91.66667%}.col-xl-offset-12{margin-left:100%}}.activity-item-container{margin-bottom:20px}.activity-item-container .activity-item .top{display:flex;justify-content:space-between}.activity-item-container .activity-item .updates{border-top:1px solid #ddd;margin-top:10px}.activity-item-container .activity-item .updates .field_value{white-space:pre}.activity-item-container .activity-item .updates table th{width:33.33%}.products-log .field_value{white-space:pre-wrap!important}.clickable:hover,.customer-fields-page table.customer-fields-table tbody>tr>td:hover,.order-fields-page table.customer-fields-table tbody>tr>td:hover,.table-clickable tbody>tr>td:hover{cursor:pointer}table>tbody>tr.selected>td{background-color:#eee}.top-space{margin-top:20px}.reset-filters{width:6.3333%}.blnd-tab-content{position:relative}.nav-tabs{border-bottom:1px solid #e7e7e7}.nav-tabs .disabled,.nav-tabs .disabled a{pointer-events:none}.nav-tabs li.active a,.nav-tabs li.active a:focus,.nav-tabs li.active a:hover{background-color:#e7e7e7;border-bottom:0;color:#333}.blnd-data-field{padding-left:5px;margin-bottom:5px;background:#fff;border-radius:4px;min-height:38px}.ellipsis{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.notes-container,.table-field td{background:#fff;border-radius:4px}.top-right-corner{top:0;right:0}.top-left-corner,.top-right-corner{position:absolute;padding:inherit;z-index:10}.top-left-corner{top:-11px;left:0}.formula-component .material-summary{text-align:center}.formula-component .col-sm-3{padding-left:0;padding-right:5px}.no-data{text-align:center}.angular-google-map{height:200px;width:100%}.angular-google-map .angular-google-map-container{height:100%;width:100%}.blnd-panel{border-top-left-radius:0;border-top-right-radius:0;border:0}.blnd-panel .panel-body{position:relative;background:#e7e7e7;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.blnd-panel .panel-body .fit-content{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.blnd-panel h4{margin-top:0}.blnd-panel .row{padding-left:15px;padding-right:10px}.blnd-panel .col-sm-1,.blnd-panel .col-sm-1-and-half,.blnd-panel .col-sm-1-mix,.blnd-panel .col-sm-2,.blnd-panel .col-sm-3,.blnd-panel .col-sm-4,.blnd-panel .col-sm-5,.blnd-panel .col-sm-6,.blnd-panel .col-sm-7,.blnd-panel .col-sm-8,.blnd-panel .col-sm-9,.blnd-panel .col-sm-10,.blnd-panel .col-sm-11,.blnd-panel .col-sm-12{padding-left:0;padding-right:5px}.blnd-panel .top-right-corner{padding-top:5px;padding-right:15px}.modal-body{background:#e7e7e7}.table-scrollable tbody{overflow-y:scroll}.ng-table .sort-asc,.ng-table .sort-desc{background-color:#fff!important}.ng-table th{text-align:left!important}.rounded-table{background:#fff;border-radius:4px;overflow:hidden;padding:0;position:relative;margin-bottom:5px;margin-right:5px}.table-left{width:49%}.table-right{width:49%;margin-left:5px}.table-fixed{margin-bottom:0}table .header{text-align:left}table .col-id{width:60px}table .col-crop{width:90px}table .col-company{width:100px}table .col-analysis,table .col-date{width:90px}table .col-status{width:110px}table .col-checkbox{width:30px}table .col-min{widht:1px}table .col-grow{width:100%}table .no-items{text-align:center}table .col-ticket-slug{width:90px}table.borderless{margin-bottom:0}table.borderless tbody>tr>td,table.borderless thead>tr>th{border:none}.nav .action{padding:0 5px}.modal-extra-lg{width:95%;max-width:1170px}.modal-open .modal{overflow-y:scroll}.modal-medium{width:450px}.modal-ticket-edit{height:100%;max-height:calc(100vh - 200px);width:95%;max-width:1170px}.modal-ticket-edit .modal-header .modal-title,.modal-ticket-edit .modal-header .tabs{float:left}.modal-ticket-edit .modal-header .tabs{position:absolute;left:50%;margin-left:-100px}.modal-ticket-edit .modal-body{max-height:calc(100vh - 200px);overflow-y:scroll}.modal-ticket-edit .form-group,.modal-ticket-edit .plant-configuration .display-value,.plant-configuration .modal-ticket-edit .display-value{margin-bottom:5px}.modal-ticket-edit h4{border-bottom:1px solid #cdcdcd;font-size:19px;margin-top:5px;margin-bottom:5px}.modal-ticket-edit section{padding-bottom:10px}.modal-ticket-edit .notes-control{height:100px}.modal-order-edit{height:100%;max-height:calc(100vh - 200px);width:95%;max-width:1170px}.modal-order-edit .modal-body{max-height:calc(100vh - 200px);overflow-y:auto}.input-xs{height:20px;line-height:20px;font-size:12px}.blnd-order-group .form-control{width:50%}.input-group{width:100%}.input-group .customer-id{width:15%;min-width:15%}label.label-sm{font-size:12px}.errors-list{color:#a94442;padding:15px;margin-bottom:20px;border:1px solid #ebccd1;border-radius:4px;background-color:#f2dede}.errors-list .errors{margin-bottom:0}.input-group.transparent .input-group-addon{background-color:transparent;border-color:transparent}.input-group.transparent .form-control:first-child{border-radius:2px}.form-group-sm .input-group>.input-group-btn>.ui-select-container.btn,.form-group-sm .input-group>.ui-select-container.form-control,.form-group-sm .input-group>.ui-select-container.input-group-addon,.input-group-sm>.input-group-btn>.ui-select-container.btn,.input-group-sm>.ui-select-container.form-control,.input-group-sm>.ui-select-container.input-group-addon,.ui-select-container.input-sm,.ui-select-container.input-sm .ui-select-container.ui-select-choices-row,.ui-select-container.input-sm .ui-select-container.ui-select-toggle{padding:0}.product-inactive-indicator{color:#999;font-size:90%}.ui-select-choices-row.active .product-inactive-indicator{color:#fff}table.products-edit-table tbody>tr>td{padding:3px 3px 2px;vertical-align:middle}table.products-edit-table .quantity-input,table.products-edit-table .rate-acre-input{width:80px}table.products-edit-table .warning-icon{padding:0}.loading-container{position:relative}.loading-container .loading:after,.loading-container .loading:before{content:\" \";position:absolute;top:0;left:0;right:0;bottom:0;min-height:50px;min-width:50px}.loading-container .loading:before{background-color:#fff;opacity:.5}.ng-table-pager{text-align:center}.col-sm-1half,.col-sm-2half,.col-sm-3half,.col-sm-4half,.col-sm-5half,.col-sm-6half,.col-sm-7half,.col-sm-8half,.col-sm-9half,.col-sm-10half,.col-sm-11half,.col-sm-12half{position:relative;min-height:1px;padding-right:15px;padding-left:15px}@media (min-width:768px){.col-sm-1half,.col-sm-2half,.col-sm-3half,.col-sm-4half,.col-sm-5half,.col-sm-6half,.col-sm-7half,.col-sm-8half,.col-sm-9half,.col-sm-10half,.col-sm-11half,.col-sm-12half{float:left}.col-sm-1half{width:12.5%;padding-right:0}.col-sm-2half{width:20.83333333%}.col-sm-3half{width:29.16666667%}.col-sm-4half{width:37.5%}.col-sm-5half{width:45.83333333%}.col-sm-6half{width:54.16666667%}.col-sm-7half{width:62.5%}.col-sm-8half{width:70.83333333%}}.blink{transition:all .5s linear}.blink.blink-active{background-color:#dbe9f5;border-color:#78acd9}.ui-select-match-text,.ui-select-placeholder{width:80%!important;overflow:hidden;text-overflow:ellipsis;padding-right:40px}.ui-select-match-text>span{width:80%!important;overflow:hidden;text-overflow:ellipsis;position:absolute}.prices{text-align:center;font-size:13px}.drag-and-drop{width:100%;height:100%;border:2px dashed #fff;border-radius:5px;padding:30px 0}.drag-and-drop.dragover{border-color:rgba(0,0,0,.15);background:rgba(0,0,0,.03)}.drag-and-drop.dragover *{opacity:.5}.drag-and-drop p{text-align:center}.drag-and-drop span{display:block;padding:5px 0;font-weight:700;text-transform:uppercase}.browse-files-container{margin-top:20px}.browse-files .browse-file-row{display:flex;flex-wrap:wrap;position:relative;padding:7px 2px;margin-bottom:-1px;box-sizing:border-box;list-style:none;border-top:1px solid #e8e8e8;border-bottom:1px solid #e8e8e8;border-left:1px solid transparent;border-right:1px solid transparent}.browse-files .browse-file-row .file-actions,.browse-files .browse-file-row .file-icon,.browse-files .browse-file-row .file-name{position:relative;min-height:1px;width:100%}.browse-files .browse-file-row .file-actions{flex:0 0 2%}.browse-files .browse-file-row .file-actions .delete{color:#c9302c}.browse-files .browse-file-row .file-icon{flex:0 0 2%}.browse-files .browse-file-row .file-name{flex:0 0 91.666667%}.browse-files .browse-file-row:first-child{border-top:0}@keyframes selector-rotate{0%{transform:rotate(-359deg)}to{transform:rotate(0deg)}}.selector,[selector]{display:none}.selector-container{display:block;position:relative}.selector-container,.selector-container input{font-size:1em;line-height:normal;color:#495c68;text-shadow:0 1px 0 hsla(0,0%,100%,.5)}.selector-input{display:block;margin:0;position:relative;width:100%;padding:.8em 2.6em .7em .7em;overflow:hidden;cursor:pointer;border:1px solid #bbb;box-shadow:0 1px 0 rgba(0,0,0,.05),inset 0 1px 0 hsla(0,0%,100%,.8);box-sizing:border-box;border-radius:4px;font-weight:inherit;background-color:#f9f9f9;background-image:linear-gradient(#fafafa,#eee)}.selector-container.rtl .selector-input{padding-right:.7em;padding-left:2.6em}.selector-container .selector-values{list-style:none}.selector-container input{outline:none;background:none!important;border-color:transparent!important;width:102px;display:inline-block;cursor:pointer}.selector-container.has-value input,.selector-container.open input{cursor:text}.selector-container.disabled{opacity:.6}.selector-container.remove-button.has-value .selector-input{padding-right:3.5em}.selector-container.remove-button.has-value.rtl .selector-input{padding-right:.7em;padding-left:3.5em}.selector-container.open .selector-input{background:none;border-bottom-color:#f0f0f0;padding-right:2.6em;border-radius:4px 4px 0 0}.selector-container.open.rtl .selector-input{padding-right:.7em;padding-left:2.6em}.selector-container.open.empty .selector-input{border-radius:4px;border-bottom-color:#bbb}.selector-container.multiple .selector-values,.selector-container.multiple input{float:left}.selector-container.multiple.rtl .selector-values,.selector-container.multiple.rtl input{float:right}.selector-container .selector-values,.selector-container .selector-values>li,.selector-container .selector-values>li>div,.selector-container input{padding:0;margin:0;border:0;display:inline}.selector-container.multiple .selector-input{padding:.5em .55em .2em!important;cursor:text;background:#fff;box-shadow:inset 0 1px 1px rgba(0,0,0,.1)}.selector-container.multiple.has-value .selector-input{padding-left:.35em!important;padding-right:.35em!important}.selector-container.multiple .selector-values{float:none}.selector-container.multiple .selector-values>li,.selector-container.multiple input{padding:.2em .6em;margin:0 .15em .25em;border-width:2px;border-style:solid;float:left;line-height:normal}.selector-container.multiple .selector-values>li{border-color:#0987d6;color:#fff;text-shadow:0 1px 1px rgba(0,0,0,.2);font-weight:300;box-shadow:inset 0 1px 1px hsla(0,0%,100%,.5),0 1px 1px rgba(0,0,0,.2);background-color:#2dadef}.selector-container.multiple.remove-button .selector-values>li{padding-right:1.9em}.selector-container.multiple.rtl .selector-values>li,.selector-container.multiple.rtl input{float:right}.selector-container.multiple.rtl.remove-button .selector-values>li{padding-right:.6em;padding-left:1.9em}.selector-helper{position:absolute;display:block;width:2.6em;top:0;right:0;bottom:0}.selector-container.rtl .selector-helper{right:inherit;left:0}.selector-helper .selector-icon{display:block;position:relative;height:100%}.selector-helper .selector-icon:after{content:\"\";display:block;position:absolute;top:50%;left:50%;margin-top:-.1em;margin-left:-.4em;width:0;height:0;border:.4em solid #888;border-left-color:transparent;border-right-color:transparent;border-bottom:none}.selector-container.has-value.remove-button .selector-helper{border-left:1px solid #bbb}.selector-container.has-value.remove-button.rtl .selector-helper{border-left:none;border-right:1px solid #bbb}.selector-container.has-value.remove-button .selector-icon{display:table;width:100%}.selector-container.has-value.remove-button .selector-icon:after{content:\"\\D7\";display:table-cell;position:relative;top:0;left:0;margin:0;border:none;height:100%;text-align:center;vertical-align:middle}.selector-container.loading .selector-helper.selector-global-helper{width:1.3em;height:1.3em;margin:.65em .7em}.selector-container.loading .selector-global-helper .selector-icon{display:table;width:100%}.selector-container.loading .selector-global-helper .selector-icon:after{content:\"\";width:100%;height:100%;margin:0;top:0;left:0;opacity:.5;border-top:1px solid #545a6a;border-bottom:1px solid #d4d4db;border-left:1px solid #545a6a;border-right:1px solid #d4d4db;animation:selector-rotate .5s linear infinite;border-radius:100%}.selector-container.loading .selector-global-helper,.selector-container.open .selector-global-helper{border-left:none!important;border-right:none!important}.selector-container.multiple .selector-helper{display:none}.selector-container.multiple.remove-button .selector-helper{display:block;width:1.3em;border-left:1px solid #0987d6;cursor:pointer}.selector-container.multiple.remove-button .selector-helper:hover{background:rgba(0,0,0,.1)}.selector-container.multiple.remove-button.rtl .selector-helper{border-left:none;border-right:1px solid #0987d6}.selector-container.multiple.loading .selector-input{padding-right:3em!important}.selector-container.multiple.loading .selector-global-helper{margin:.75em .8em;border-left:none;border-right:none}.selector-container.multiple.loading.rtl .selector-input{padding-right:.55em!important;padding-left:3em!important}.selector-container.multiple.loading.rtl.has-value .selector-input{padding-right:.25em!important}.selector-input input,.selector-shadow{padding-left:0!important;padding-right:0!important;border-left:0!important;border-right:0!important;max-width:100%!important}.selector-shadow{position:absolute;top:0;left:0;opacity:0;visibility:hidden;white-space:pre;margin:0}.selector-dropdown{display:none;list-style:none;padding:0!important;margin:0!important;position:absolute;background:#fff;border:1px solid #ccc;border-top:0;max-height:15.5em;overflow-x:hidden;overflow-y:auto;z-index:1000;border-radius:0 0 3px 3px;box-shadow:0 1px 3px rgba(0,0,0,.1);box-sizing:border-box}.selector-dropdown>li{padding:.65em .8em;overflow:hidden;cursor:pointer}.selector-dropdown>.selector-optgroup{background:#fefefe;border-top:1px solid #f0f0f0;border-bottom:1px solid #f0f0f0}.selector-dropdown>.selector-option.grouped{padding-left:1.6em}.selector-dropdown>.selector-option.active{background:#f5fafd}.selector-dropdown>.selector-option.create{color:rgba(73,92,104,.6)}.selector-dropdown>.selector-option.create.active{color:#495c68}.selector-container.open .selector-dropdown{display:block}.selector-container.multiple.loading .selector-global-helper{margin:.45em .8em}.selector-container.multiple input{font-size:12px;margin-bottom:0}.selector-container.multiple .create input{z-index:1020!important;background-color:#fff!important;background-image:none!important;border:1px solid #ccc!important}.selector-container.multiple .create input,.selector-container.multiple .selector-input{box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.selector-container.multiple .selector-input{border:1px solid #ccc;padding:.2em .15em 0!important}.selector-container.multiple .selector-values>li{display:inline-block;position:relative;box-shadow:none;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;text-shadow:none;border:1px solid #ccc;border-radius:3px;padding:1px 5px;font-size:12px;line-height:1.5;color:#333;background-color:#fff}.selector-container.multiple .selector-values>li:hover{color:#333;background-color:#ebebeb;border-color:#adadad}.selector-container input{color:#555;text-shadow:none}.selector-container.has-value.remove-button .selector-helper{border:0}.selector-dropdown>.selector-option{cursor:pointer;display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#555;white-space:nowrap}.selector-dropdown>.selector-option.active{background-color:#f5f5f5}.plant-configuration .selector-dropdown .display-value,.selector-dropdown .form-group,.selector-dropdown .plant-configuration .display-value{width:22%}.plant-configuration .selector-dropdown .display-value input,.selector-dropdown .form-group input,.selector-dropdown .plant-configuration .display-value input{width:100%}.notes{min-height:500px}.printers li{border-bottom:1px solid #ccc;clear:left;cursor:pointer;min-height:40px;line-height:30px}.printers li.selected,.printers li:hover{background-color:#eee}.printers li:last-child{border-bottom:none}.printers li .icon-container,.printers li .printer-container{float:left}.printers li .fa{font-size:30px;margin-top:4px;margin-left:6px}.printers li .printer-info{margin-left:10px;margin-top:5px}.printer-admin-container .information{margin-top:10px}.printer-admin-container .top-right-corner .btn+.btn{margin-right:10px}.printers-table{margin-top:40px}.product-max-rate-table .crop-selector,.product-max-rate-table .max-rate-input{width:48%}.check-browser-container{padding:100px 0 180px}.check-browser-container p{text-align:center}.check-browser-container .logo{margin-bottom:40px}.warning-button{padding:0;margin:0}.warning-button .analysis-warning-icon{background:url(" + __webpack_require__(859) + ") no-repeat;background-size:40px;width:40px;height:40px;display:block}.nutrients-form .warning-button{position:absolute;top:-20px;left:10px}[fade-in]{display:none}.animated{transition:all 5s linear}.animated.fade-in{opacity:1;display:inline-block!important}.card{background-color:#fff;border:1px solid transparent;border-radius:6px}.card>.card-link{color:#333}.card>.card-link:hover{text-decoration:none}.card>.card-link .card-img img{border-radius:6px 6px 0 0}.card .card-img{position:relative;padding:0;display:table}.card .card-img .card-caption{position:absolute;right:0;bottom:16px;left:0}.card .card-body{width:100%;padding:12px}.card .card-header{border-radius:6px 6px 0 0;padding:8px}.card .card-footer{border-radius:0 0 6px 6px;padding:8px}.card .card-body .h1,.card .card-body .h2,.card .card-body .h3,.card .card-body .h4,.card .card-body h1:first-child,.card .card-body h2:first-child,.card .card-body h3:first-child,.card .card-body h4:first-child{margin-top:0}.card .card-body .heading{display:block}.card .card-body .heading:last-child{margin-bottom:0}.card .card-body .lead{text-align:center}@media (min-width:768px){.card .card-left{float:left;padding:0 8px 0 0}.card .card-right{float:left;padding:0 0 0 8px}.card .card-4-8 .card-left{width:33.33333333%}.card .card-4-8 .card-right{width:66.66666667%}.card .card-5-7 .card-left{width:41.66666667%}.card .card-5-7 .card-right{width:58.33333333%}.card .card-6-6 .card-left,.card .card-6-6 .card-right{width:50%}.card .card-7-5 .card-left{width:58.33333333%}.card .card-7-5 .card-right{width:41.66666667%}.card .card-8-4 .card-left{width:66.66666667%}.card .card-8-4 .card-right{width:33.33333333%}}.card-default{border-color:#ddd;background-color:#fff;margin-bottom:24px}.card-default>.card-footer,.card-default>.card-header{color:#333;background-color:#ddd}.card-default>.card-header{border-bottom:1px solid #ddd;padding:8px}.card-default>.card-footer{border-top:1px solid #ddd;padding:8px}.card-default>.card-img:first-child img{border-radius:6px 6px 0 0}.card-default>.card-left{padding-right:4px}.card-default>.card-right{padding-left:4px}.card-default p:last-child{margin-bottom:0}.card-default .card-caption{color:#fff;text-align:center;text-transform:uppercase}.card-price{border-color:#999;background-color:#ededed;margin-bottom:24px}.card-price>.card-footer,.card-price>.card-heading{color:#333;background-color:#fdfdfd}.card-price>.card-heading{border-bottom:1px solid #ddd;padding:8px}.card-price>.card-footer{border-top:1px solid #ddd;padding:8px}.card-price>.card-img:first-child img{border-radius:6px 6px 0 0}.card-price>.card-left{padding-right:4px}.card-price>.card-right{padding-left:4px}.card-price .card-caption{color:#fff;text-align:center;text-transform:uppercase}.card-price p:last-child{margin-bottom:0}.card-price .price{text-align:center;color:#337ab7;font-size:3em;text-transform:uppercase;line-height:.7em;margin:24px 0 16px}.card-price .price small{font-size:.4em;color:#66a5da}.card-price .details{list-style:none;margin-bottom:24px;padding:0 18px}.card-price .details li{text-align:center;margin-bottom:8px}.card-price .buy-now{text-transform:uppercase}.card-price table .price{font-size:1.2em;font-weight:700;text-align:left}.card-price table .note{color:#666;font-size:.8em}.notifications_table{width:100%}.notifications_table thead{border-bottom:1px solid #d3d3d3}.notifications_table thead tr th{text-transform:uppercase;padding:10px}.notifications_table tbody tr{border-bottom:1px solid #d3d3d3}.notifications_table tbody tr td{padding:10px}.plant-configuration{padding-top:20px}.plant-configuration .display-label{display:inline-block;max-width:100%;margin-bottom:0;font-weight:700;padding-top:7px}.plant-configuration .display-value{margin-right:-15px;margin-left:-15px}.plant-configuration .address-line{display:block;padding-bottom:1px}.company-address input{margin-bottom:5px}.admin-homepage .plant-list,blnd-chemical-products .units{text-align:center}.blnd-panel-admin .top-right-corner+.row{padding-top:40px}.emails-list .label{margin:2px;float:left}.signature img{max-width:100%;max-height:100%}.inventory-page .table-transactions{background-color:#fff;border-radius:4px}.inventory-page .table-transactions .col-amount{width:100px}.inventory-product-modal input,.product-transaction-modal input{width:100px;display:inline}.default-delivery-picker{cursor:pointer}#read-orders-scroll{overflow-y:auto;max-height:78vh}#available-applicators-scroll{overflow-y:auto;max-height:calc(78vh - 59px)}.ready-orders-col{width:30%}@media (min-width:1600px){.ready-orders-col{width:22%}}.order-card{margin:10px 5px;padding:10px;width:90%;cursor:pointer;border:2px solid #d3d3d3}.order-card-no-events{pointer-events:none}.infinite-scroll-orders{display:flex;flex-flow:row wrap;justify-content:center}.available-applicators-col{width:70%}@media (min-width:1600px){.available-applicators-col{width:78%}}.search-buttons-div{display:flex}.search-window{width:50%;margin:10px 0 15px 4%}@media (min-width:1600px){.search-window{margin:10px 0 15px 3.7%}}.search-window input{font-size:medium;height:3.5rem}#selected-orders-action{display:none;margin:10px 0 15px 5px}.dispatch-button{font-size:medium;height:3.5rem}.applicator-card{margin:7px;width:45%;min-height:15rem;border:3px solid #d3d3d3;background-color:#f5f5f5}@media (min-width:1600px){.applicator-card{width:30%}}.applicator-header{border-bottom:3px solid #d3d3d3;margin-bottom:7px}.applicator-order-list{margin-bottom:0;overflow-y:auto;max-height:50rem}.applicator-order-card{padding:10px;margin:0 5px 10px;border:2px solid #d3d3d3;background-color:#fff;width:90%}.applicator-order-card .close{visibility:hidden;font-size:large}.applicator-order-card:hover .close{visibility:visible}.applicator-order-card-body{padding:10px 10px 0}.applicator-ticket{background-color:#f6f6f6;display:flex;justify-content:space-between;border-top-color:#d3d3d3;font-weight:700;border-radius:2px}.dndPlaceholder+.applicator-card{border:3px solid #90ee90}.left-correct{float:left;color:green}.right-correct{float:right;color:green}.left-error{float:left}.right-error{float:right}.checkbox-div{margin-left:5px}.bigger-checkbox{height:15px;width:15px}.order-div{display:flex;flex-direction:row;align-items:center;align-content:center}.linked-order{display:table;margin:auto;font-size:xx-large;margin-bottom:-32px;position:relative}.full-content-center{max-width:380px;margin:80px auto}body.auth-page{background:#eee!important}.box{padding:15px 35px 45px;margin:0 auto;background-color:#fff;border:1px solid rgba(0,0,0,.1)}.box .logo{display:inline-block}.box .header{text-align:center;padding-bottom:20px}.box .form-signin .checkbox,.box .form-signin .form-signin-heading{margin-bottom:30px}.box .form-signin .checkbox{font-weight:400}.box .form-signin .form-control{position:relative;font-size:16px;height:auto;padding:10px}.box .form-signin .form-control:focus{z-index:2}.box .form-signin input[type=text]{margin-bottom:-1px;border-bottom-left-radius:0;border-bottom-right-radius:0}.box .form-signin input[type=password]{margin-bottom:20px;border-top-left-radius:0;border-top-right-radius:0}body{overflow-y:scroll;background-color:#f8f8f8}.pt-100{padding-top:150px}@media (min-width:992px){.pt-100{padding-top:100px}}.pt-140{padding-top:190px}@media (min-width:992px){.pt-140{padding-top:140px}}.navbar-default{border:0}[disabled]{cursor:default!important}textarea{resize:vertical}.w-50{width:50%}.w-100{width:100%}.order-button-container{display:flex;flex-wrap:wrap;margin:0 10%}.order-button{text-align:center;margin:2% 0}.rounded{background:#fff;overflow:hidden;border-radius:4px;margin-right:5px;margin-bottom:5px;padding-left:5px;padding-right:5px}.rounded table{margin-bottom:0}.blnd-page-header{background-color:#e7e7e7;display:flex;justify-content:space-between;border:0;border-top-left-radius:4px;border-top-right-radius:4px;overflow:hidden;padding:5px 35px}.blnd-page-header .breadcrumb,.blnd-page-header ol{background-color:#f8f8f8;padding:7px 15px;margin:0}.table-list-actions{min-height:34px}.col-sm-1-and-half{width:10.33333%}.col-sm-1-mix{padding-left:5px;padding-right:0;width:85px}.logo{width:144px;height:68px;background:url(" + __webpack_require__(860) + ") no-repeat}.a-unstyled,.a-unstyled:focus,.a-unstyled:hover,.main-box,.main-box:focus,.main-box:hover{text-decoration:none;color:inherit}.main-box{display:block;text-align:center}.main-box>.count{border:1px solid #eee}.main-box:hover{background-color:#f7f7f7;color:inherit}.card-box{width:100%;padding:10px 15px;min-width:90px;background:#fff;border:1px solid #dbe0e4;margin-bottom:20px;border-radius:3px;text-align:center}.card-box .box-num{font-size:46px;line-height:1.6em;font-weight:300;color:#686868}.card-box a{font-size:25px}.recent-box span{font-weight:900}.recent-box span,.recent-box ul{display:inline-block}.customer-fields-page .angular-google-map-container,.customer-fields-page .field-map{height:300px}.field-modal .angular-google-map{height:300px;width:100%}.customer-card{border-bottom:1px solid #ddd;padding-bottom:15px;margin-bottom:15px}.order-list-page .actions{margin-top:-10px;margin-bottom:8px;text-align:right}.order-list-page .order-search-input-wrapper{display:table-cell;width:100%}.order-list-page .order-search-input-wrapper>input[type=text].form-control{display:block;transition:none;animation:none}.order-list-page .order-search-input-wrapper>blnd-product-picker{display:block;width:100%;transition:none;animation:none}.order-list-page .order-list-page-product-picker,.order-list-page .order-list-page-product-picker .ui-select-container{width:100%}.order-list-page .order-list-page-product-picker .ui-select-container .ui-select-toggle{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;font-weight:400;border-top-right-radius:0;border-bottom-right-radius:0;white-space:normal}.order-list-page .order-list-page-product-picker .ui-select-container .ui-select-toggle>.caret{display:none}.order-list-page .order-list-page-product-picker .ui-select-container .ui-select-toggle .ui-select-placeholder{color:#999}.order-list-page .order-list-page-product-picker .ui-select-container input.ui-select-search.form-control{border-top-right-radius:0;border-bottom-right-radius:0}.order-details .actions li{display:inline-block}.order-details h4{border-bottom:1px solid #333;font-size:19px;margin-bottom:14px}.ship-to{padding-bottom:10px}.price-table tbody>tr>td,.price-table tbody>tr>th,.price-table thead>tr>th{border:none}.price-table tbody>tr>td{border:none;padding:1px 20px}.price-table tbody>tr>td:last-child{text-align:right;font-weight:800}.table-elements-edit td,table.table-elements-edit tbody>tr>td{padding:1px}table.table-elements-edit thead>tr>th{text-align:center}.modal-open #order-add-button{right:29px}.create-ticket-modal .form-control-static{text-align:right}.create-ticket-modal .control-label{text-align:left;display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}.create-ticket-modal .ship-to-container{margin:0 15px}.create-ticket-modal .ship-to-container .form-group,.create-ticket-modal .ship-to-container .plant-configuration .display-value,.plant-configuration .create-ticket-modal .ship-to-container .display-value{margin-left:-4px;margin-right:0}.create-ticket-modal .tickets-created{margin-left:0}.price-level .form-control-static{padding:6px 6px 6px 0}.price-level .form-control-static span{font-size:90%}.order-sorted-list .panel-heading{text-align:center;color:#777}.order-sorted-list [dnd-handle]{text-align:center;cursor:pointer}.order-sorted-list .dndDraggingSource{display:none}.order-sorted-list .dndPlaceholder{background-color:#eee}.linked-cell{border:2.5px solid #2774df}.linked-td{text-align:center}.lined_order_span{font-size:x-large;position:relative;bottom:-24px}.custom-marker{height:25px;background-color:#188ff1;border-radius:5px;padding:5px}.ticket-list-page .ticket-search-input-wrapper{display:table-cell;width:100%}.ticket-list-page .ticket-search-input-wrapper>input[type=text].form-control{display:block;transition:none;animation:none}.ticket-list-page .ticket-search-input-wrapper>blnd-product-picker{display:block;width:100%;transition:none;animation:none}.ticket-list-page .ticket-list-page-product-picker,.ticket-list-page .ticket-list-page-product-picker .ui-select-container{width:100%}.ticket-list-page .ticket-list-page-product-picker .ui-select-container .ui-select-toggle{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;font-weight:400;border-top-right-radius:0;border-bottom-right-radius:0;white-space:normal}.ticket-list-page .ticket-list-page-product-picker .ui-select-container .ui-select-toggle>.caret{display:none}.ticket-list-page .ticket-list-page-product-picker .ui-select-container .ui-select-toggle .ui-select-placeholder{color:#999}.ticket-list-page .ticket-list-page-product-picker .ui-select-container input.ui-select-search.form-control{border-top-right-radius:0;border-bottom-right-radius:0}.elements-form .input-label{margin-bottom:5px;height:auto;padding:2px 6px}.elements-form .btn-auto-clay{padding:0 3px}.elements-form .col-sm-1,.elements-form .col-sm-1-and-half,.elements-form .col-sm-1-mix,.elements-form .col-sm-2,.elements-form .col-sm-3,.elements-form .col-sm-4,.elements-form .col-sm-5,.elements-form .col-sm-6,.elements-form .col-sm-7,.elements-form .col-sm-8,.elements-form .col-sm-9,.elements-form .col-sm-10,.elements-form .col-sm-11,.elements-form .col-sm-12{padding-left:0;padding-right:5px}.elements-form .row{padding-left:15px;padding-right:10px}.print-error{padding:0 0 0 10px}.ticket-details h4{border-bottom:1px solid #333;font-size:19px;margin-bottom:14px}.ticket-details section{padding-bottom:10px}.ticket-details section.information{padding-top:10px}.ticket-details .notes-container{min-height:80px}.ticket-details .notes-container pre{background:none;border:none}.ticket-details .customer-card{border:none;padding-bottom:0;margin-bottom:0}.mix-calc-footer{background-color:#e7e7e7;margin-bottom:50px}#create-button{bottom:14px;right:14px}.bottom-right-icon-button{height:56px;width:56px;position:fixed;z-index:2}.bottom-right-icon-button .btn-fab{border-radius:50%;height:56px;margin:auto;min-width:56px;width:56px;padding:0;box-shadow:0 1px 1.5px 0 rgba(0,0,0,.12),0 1px 1px 0 rgba(0,0,0,.24);position:relative;color:#fff;text-align:center}.bottom-right-icon-button .btn-fab:before{content:\"\";display:inline-block;height:100%;vertical-align:middle;margin-right:-.25em}.bottom-right-icon-button .btn-fab .btn-icon{text-align:center;vertical-align:middle;font-weight:400;font-size:20px}.clickable,.customer-fields-page table.customer-fields-table tbody>tr>td,.order-fields-page table.customer-fields-table tbody>tr>td,.table-clickable tbody>tr>td{cursor:pointer}.flip-container{perspective:10000px;position:relative}.flip-container .flip{position:absolute;left:0;width:100%;transform-style:preserve-3d;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:all 1s linear}.flip-container .flip.ng-leave{transform:rotateY(0deg)}.flip-container .flip.ng-leave-active{transform:rotateY(-180deg)}.flip-container .flip.ng-enter{transform:rotateY(180deg)}.flip-container .flip.ng-enter-active{transform:rotateY(0deg)}.table-list-actions .action+.action{margin-right:10px}.form-group label+input[type=checkbox],.plant-configuration .display-value label+input[type=checkbox]{display:block}.nutrients-form .form-group,.nutrients-form .plant-configuration .display-value,.plant-configuration .nutrients-form .display-value{margin-bottom:0}.nutrients-form.last{margin-bottom:15px}.nav.nav-tabs>li a{cursor:pointer}#content-error-page{padding:100px 0 180px;text-align:center;background-position:bottom;background-repeat:no-repeat;min-height:493px}#content-error-page .logo{width:144px;height:68px;background:url(" + __webpack_require__(860) + ") no-repeat;display:inline-block}.dashboard-card{background-clip:padding-box;border:10px solid transparent}.chart-body{height:500px}.chart-wrapper{min-height:100%}.box{text-align:right}th.tons-header{font-weight:400}td>.progress{margin-bottom:0!important;line-height:40px!important}.progress{position:relative}.bar-text{position:absolute;display:block;width:100%;color:#000}", ""]);
	
	// exports


/***/ }),
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "icon.warning.bd401cd.png";

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "logo.b96cf9c.png";

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 906,
		"./af.js": 906,
		"./ar": 907,
		"./ar-dz": 908,
		"./ar-dz.js": 908,
		"./ar-kw": 909,
		"./ar-kw.js": 909,
		"./ar-ly": 910,
		"./ar-ly.js": 910,
		"./ar-ma": 911,
		"./ar-ma.js": 911,
		"./ar-sa": 912,
		"./ar-sa.js": 912,
		"./ar-tn": 913,
		"./ar-tn.js": 913,
		"./ar.js": 907,
		"./az": 914,
		"./az.js": 914,
		"./be": 915,
		"./be.js": 915,
		"./bg": 916,
		"./bg.js": 916,
		"./bm": 917,
		"./bm.js": 917,
		"./bn": 918,
		"./bn.js": 918,
		"./bo": 919,
		"./bo.js": 919,
		"./br": 920,
		"./br.js": 920,
		"./bs": 921,
		"./bs.js": 921,
		"./ca": 922,
		"./ca.js": 922,
		"./cs": 923,
		"./cs.js": 923,
		"./cv": 924,
		"./cv.js": 924,
		"./cy": 925,
		"./cy.js": 925,
		"./da": 926,
		"./da.js": 926,
		"./de": 927,
		"./de-at": 928,
		"./de-at.js": 928,
		"./de-ch": 929,
		"./de-ch.js": 929,
		"./de.js": 927,
		"./dv": 930,
		"./dv.js": 930,
		"./el": 931,
		"./el.js": 931,
		"./en-SG": 932,
		"./en-SG.js": 932,
		"./en-au": 933,
		"./en-au.js": 933,
		"./en-ca": 934,
		"./en-ca.js": 934,
		"./en-gb": 935,
		"./en-gb.js": 935,
		"./en-ie": 936,
		"./en-ie.js": 936,
		"./en-il": 937,
		"./en-il.js": 937,
		"./en-nz": 938,
		"./en-nz.js": 938,
		"./eo": 939,
		"./eo.js": 939,
		"./es": 940,
		"./es-do": 941,
		"./es-do.js": 941,
		"./es-us": 942,
		"./es-us.js": 942,
		"./es.js": 940,
		"./et": 943,
		"./et.js": 943,
		"./eu": 944,
		"./eu.js": 944,
		"./fa": 945,
		"./fa.js": 945,
		"./fi": 946,
		"./fi.js": 946,
		"./fo": 947,
		"./fo.js": 947,
		"./fr": 948,
		"./fr-ca": 949,
		"./fr-ca.js": 949,
		"./fr-ch": 950,
		"./fr-ch.js": 950,
		"./fr.js": 948,
		"./fy": 951,
		"./fy.js": 951,
		"./ga": 952,
		"./ga.js": 952,
		"./gd": 953,
		"./gd.js": 953,
		"./gl": 954,
		"./gl.js": 954,
		"./gom-latn": 955,
		"./gom-latn.js": 955,
		"./gu": 956,
		"./gu.js": 956,
		"./he": 957,
		"./he.js": 957,
		"./hi": 958,
		"./hi.js": 958,
		"./hr": 959,
		"./hr.js": 959,
		"./hu": 960,
		"./hu.js": 960,
		"./hy-am": 961,
		"./hy-am.js": 961,
		"./id": 962,
		"./id.js": 962,
		"./is": 963,
		"./is.js": 963,
		"./it": 964,
		"./it-ch": 965,
		"./it-ch.js": 965,
		"./it.js": 964,
		"./ja": 966,
		"./ja.js": 966,
		"./jv": 967,
		"./jv.js": 967,
		"./ka": 968,
		"./ka.js": 968,
		"./kk": 969,
		"./kk.js": 969,
		"./km": 970,
		"./km.js": 970,
		"./kn": 971,
		"./kn.js": 971,
		"./ko": 972,
		"./ko.js": 972,
		"./ku": 973,
		"./ku.js": 973,
		"./ky": 974,
		"./ky.js": 974,
		"./lb": 975,
		"./lb.js": 975,
		"./lo": 976,
		"./lo.js": 976,
		"./lt": 977,
		"./lt.js": 977,
		"./lv": 978,
		"./lv.js": 978,
		"./me": 979,
		"./me.js": 979,
		"./mi": 980,
		"./mi.js": 980,
		"./mk": 981,
		"./mk.js": 981,
		"./ml": 982,
		"./ml.js": 982,
		"./mn": 983,
		"./mn.js": 983,
		"./mr": 984,
		"./mr.js": 984,
		"./ms": 985,
		"./ms-my": 986,
		"./ms-my.js": 986,
		"./ms.js": 985,
		"./mt": 987,
		"./mt.js": 987,
		"./my": 988,
		"./my.js": 988,
		"./nb": 989,
		"./nb.js": 989,
		"./ne": 990,
		"./ne.js": 990,
		"./nl": 991,
		"./nl-be": 992,
		"./nl-be.js": 992,
		"./nl.js": 991,
		"./nn": 993,
		"./nn.js": 993,
		"./pa-in": 994,
		"./pa-in.js": 994,
		"./pl": 995,
		"./pl.js": 995,
		"./pt": 996,
		"./pt-br": 997,
		"./pt-br.js": 997,
		"./pt.js": 996,
		"./ro": 998,
		"./ro.js": 998,
		"./ru": 999,
		"./ru.js": 999,
		"./sd": 1000,
		"./sd.js": 1000,
		"./se": 1001,
		"./se.js": 1001,
		"./si": 1002,
		"./si.js": 1002,
		"./sk": 1003,
		"./sk.js": 1003,
		"./sl": 1004,
		"./sl.js": 1004,
		"./sq": 1005,
		"./sq.js": 1005,
		"./sr": 1006,
		"./sr-cyrl": 1007,
		"./sr-cyrl.js": 1007,
		"./sr.js": 1006,
		"./ss": 1008,
		"./ss.js": 1008,
		"./sv": 1009,
		"./sv.js": 1009,
		"./sw": 1010,
		"./sw.js": 1010,
		"./ta": 1011,
		"./ta.js": 1011,
		"./te": 1012,
		"./te.js": 1012,
		"./tet": 1013,
		"./tet.js": 1013,
		"./tg": 1014,
		"./tg.js": 1014,
		"./th": 1015,
		"./th.js": 1015,
		"./tl-ph": 1016,
		"./tl-ph.js": 1016,
		"./tlh": 1017,
		"./tlh.js": 1017,
		"./tr": 1018,
		"./tr.js": 1018,
		"./tzl": 1019,
		"./tzl.js": 1019,
		"./tzm": 1020,
		"./tzm-latn": 1021,
		"./tzm-latn.js": 1021,
		"./tzm.js": 1020,
		"./ug-cn": 1022,
		"./ug-cn.js": 1022,
		"./uk": 1023,
		"./uk.js": 1023,
		"./ur": 1024,
		"./ur.js": 1024,
		"./uz": 1025,
		"./uz-latn": 1026,
		"./uz-latn.js": 1026,
		"./uz.js": 1025,
		"./vi": 1027,
		"./vi.js": 1027,
		"./x-pseudo": 1028,
		"./x-pseudo.js": 1028,
		"./yo": 1029,
		"./yo.js": 1029,
		"./zh-cn": 1030,
		"./zh-cn.js": 1030,
		"./zh-hk": 1031,
		"./zh-hk.js": 1031,
		"./zh-tw": 1032,
		"./zh-tw.js": 1032
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 905;


/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js